/* eslint-disable */
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: number;
  /** A country code as defined by ISO 3166-1 alpha-2 */
  CountryCode: string;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: string;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: string;
  /** A Date encoded as a String in ISO format.  e.g., \`2017-03-02\` */
  DateType: string;
  /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
  EmailAddress: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: string;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: Record<string, unknown>;
  /** A field whose value is a valid decimal degrees latitude number (53.471): https://en.wikipedia.org/wiki/Latitude */
  Latitude: number;
  LocalTime: string;
  /** A field whose value is a valid decimal degrees longitude number (53.471): https://en.wikipedia.org/wiki/Longitude */
  Longitude: number;
  /** Mime Type. Example: 'image/png' or 'application/pdf' */
  MimeType: string;
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: string;
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: number;
  /** A Timestamp encoded as a String in ISO8601 format, e.g., \`2010-03-17T13:33:02.123Z\` */
  TimestampType: string;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: string;
};

export type ActiveMetricStats = {
  __typename?: 'ActiveMetricStats';
  metricCalculationCount: Scalars['Int'];
  metricCount: Scalars['Int'];
  metricDataWaterlyConnectCount: Scalars['Int'];
};

export type ActiveMetricStatsInput = {
  fromDate: Scalars['DateTime'];
  organizationId: Scalars['Int'];
  toDate: Scalars['DateTime'];
};

export type ActiveUserDetailsInput = {
  fromDate: Scalars['DateTime'];
  organizationId: Scalars['Int'];
  toDate: Scalars['DateTime'];
};

export type ActiveUserStats = {
  __typename?: 'ActiveUserStats';
  activeUserCount: Scalars['Int'];
  userCount: Scalars['Int'];
  users: Array<UserStats>;
};

export type ActivitySchedule = {
  __typename?: 'ActivitySchedule';
  activityScheduleTypeId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['Int'];
  defaultAssignee?: Maybe<UserNest>;
  defaultAssigneeId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  exDates?: Maybe<Array<Scalars['DateTime']>>;
  id: Scalars['UUID'];
  isStackable: Scalars['Boolean'];
  notBeforeUnit?: Maybe<DurationUnit>;
  notBeforeValue?: Maybe<Scalars['Int']>;
  photoRequired: Scalars['Boolean'];
  rDates?: Maybe<Array<Scalars['DateTime']>>;
  recurrenceType: RecurrenceType;
  rrule: Scalars['String'];
  siteId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  system: SystemNest;
  systemId: Scalars['Int'];
  targetBeforeUnit?: Maybe<DurationUnit>;
  targetBeforeValue?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ActivityScheduleAddInput = {
  activityScheduleTypeId?: InputMaybe<Scalars['UUID']>;
  defaultAssigneeId?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  isStackable?: InputMaybe<Scalars['Boolean']>;
  notBeforeUnit?: InputMaybe<DurationUnit>;
  notBeforeValue?: InputMaybe<Scalars['Int']>;
  photoRequired: Scalars['Boolean'];
  recurrenceType: RecurrenceType;
  rrule: Scalars['String'];
  siteId?: InputMaybe<Scalars['Int']>;
  systemId: Scalars['Int'];
  targetBeforeUnit?: InputMaybe<DurationUnit>;
  targetBeforeValue?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type ActivityScheduleCancelInput = {
  endDate: Scalars['DateTime'];
  id: Scalars['UUID'];
};

export type ActivityScheduleUpdateInput = {
  activityScheduleTypeId?: InputMaybe<Scalars['String']>;
  defaultAssigneeId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isStackable?: InputMaybe<Scalars['Boolean']>;
  notBeforeUnit?: InputMaybe<DurationUnit>;
  notBeforeValue?: InputMaybe<Scalars['Int']>;
  photoRequired?: InputMaybe<Scalars['Boolean']>;
  recurrenceType?: InputMaybe<RecurrenceType>;
  rrule?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
  targetBeforeUnit?: InputMaybe<DurationUnit>;
  targetBeforeValue?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ActivityScheduleWithCount = {
  __typename?: 'ActivityScheduleWithCount';
  count: Scalars['Int'];
  items: Array<ActivitySchedule>;
};

export type ActivitySchedulesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActivitySchedulesWhere>;
};

export type ActivitySchedulesWhere = {
  activityScheduleTypeId?: InputMaybe<Scalars['String']>;
  defaultAssigneeId?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['UUID']>;
  recurrenceType?: InputMaybe<RecurrenceType>;
  siteId?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  systemIds: Array<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type AddEdgeDeviceNestInput = {
  deviceName: Scalars['String'];
  deviceType: EdgeDeviceTypeNest;
  organizationId: Scalars['Int'];
};

export type AddLicenseInput = {
  authority: Scalars['String'];
  licenseLabel: Scalars['String'];
  licenseNumber: Scalars['String'];
  userId: Scalars['Int'];
};

export type AddPhoneNumberInput = {
  country: Scalars['CountryCode'];
  phoneNumber: Scalars['String'];
  userId: Scalars['Int'];
};

export type AddSsoUserToSystemGroupInput = {
  role: SystemGroupRoleEnum;
  ssoUserId: Scalars['String'];
  systemGroupId: Scalars['Int'];
};

export type AddSampleSiteUploadInput = {
  sampleSiteId: Scalars['UUID'];
  uploadId: Scalars['UUID'];
};

export type AddScheduledItemUploadInput = {
  scheduledItemId: Scalars['UUID'];
  uploadId: Scalars['UUID'];
};

export type AddSiteFlexMetricsToFolderInput = {
  folderId?: InputMaybe<Scalars['UUID']>;
  metricIds: Array<Scalars['Int']>;
  siteId: Scalars['Int'];
};

export type AddSiteInput = {
  emoji?: InputMaybe<Scalars['String']>;
  flex?: InputMaybe<Scalars['Boolean']>;
  isEntry?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Latitude']>;
  longitude?: InputMaybe<Scalars['Longitude']>;
  name: Scalars['String'];
  /** NPDES Permit Number - National permists searchable at https://www.epa.gov/npdes-permits */
  npdesPermitNumber?: InputMaybe<Scalars['String']>;
  siteType?: InputMaybe<SiteTypeEnum>;
  systemId: Scalars['Int'];
};

export type AddSsoUserToSystemTypeInput = {
  role: SystemRoleType;
  ssoUserId: Scalars['String'];
  systemId: Scalars['Int'];
};

export type AddSystemFavoriteInput = {
  id: Scalars['Int'];
};

export type AddSystemGroupInput = {
  name: Scalars['String'];
  parentSystemGroupId: Scalars['Int'];
};

export type AddTagMappingInput = {
  edgeDeviceId: Scalars['Int'];
  metricId: Scalars['Int'];
  tagName: Scalars['String'];
};

export type AddTrendInput = {
  isGlobal?: Scalars['Boolean'];
  keynameFilters?: InputMaybe<Array<Scalars['String']>>;
  metricIds?: InputMaybe<Array<Scalars['Int']>>;
  name: Scalars['String'];
  systemId?: InputMaybe<Scalars['Int']>;
  systemType?: InputMaybe<SystemTypeEnum>;
};

export type AddUserToSystemGroupInput = {
  email: Scalars['String'];
  role: SystemGroupRoleEnum;
  systemGroupId: Scalars['Int'];
};

export type AddUserToSystemInput = {
  role: SystemRoleType;
  systemId: Scalars['Int'];
  userEmail: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  label?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  purpose: AddressPurpose;
  recipientName?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['Int']>;
  systemId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export enum AddressPurpose {
  Billing = 'BILLING',
  Both = 'BOTH',
  Shipping = 'SHIPPING'
}

export type AdjacentEntryIntervalInput = {
  date: Scalars['Date'];
  direction: NavigationDirection;
  siteId: Scalars['Int'];
  time: Scalars['String'];
};

export type AdminStats = {
  __typename?: 'AdminStats';
  numberOfMetrics: Scalars['Int'];
  numberOfSites: Scalars['Int'];
  numberOfStates: Scalars['Int'];
  numberOfSystems: Scalars['Int'];
  numberOfUsers: Scalars['Int'];
};

export type Analyte = {
  __typename?: 'Analyte';
  analyteType: AnalyteType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  unitId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type AnalyteGroup = {
  __typename?: 'AnalyteGroup';
  analytes: Array<Analyte>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type AnalyteGroupCreateInput = {
  analyteIds?: InputMaybe<Array<Scalars['UUID']>>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AnalyteGroupUpdateInput = {
  analyteIds?: InputMaybe<Array<Scalars['UUID']>>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type AnalyteGroupsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AnalyteGroupsWhere>;
};

export type AnalyteGroupsWhere = {
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AnalyteGroupsWithCount = {
  __typename?: 'AnalyteGroupsWithCount';
  count: Scalars['Int'];
  items: Array<AnalyteGroup>;
};

export enum AnalyteType {
  Field = 'FIELD',
  Lab = 'LAB'
}

export type AnalytesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AnalytesWhere>;
};

export type AnalytesWhere = {
  analyteType?: InputMaybe<AnalyteType>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Array<Scalars['UUID']>>;
  name?: InputMaybe<Scalars['String']>;
};

export type AnalytesWithCount = {
  __typename?: 'AnalytesWithCount';
  count: Scalars['Int'];
  items: Array<Analyte>;
};

export enum AnalyticsReportRunMode {
  DbConfig = 'DbConfig',
  RepoConfig = 'RepoConfig'
}

export enum ApiTokenCapabilityPreset {
  Export = 'EXPORT',
  Ingestion = 'INGESTION',
  ReadOnly = 'READ_ONLY',
  Superadmin = 'SUPERADMIN'
}

export type ApiTokenNest = {
  __typename?: 'ApiTokenNest';
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['Int'];
  expiresAt: Scalars['DateTime'];
  id: Scalars['Int'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  realm: Scalars['String'];
  revokedAt?: Maybe<Scalars['DateTime']>;
  scopes: Array<ApiTokenScope>;
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
};

export enum ApiTokenScope {
  AdminAll = 'AdminAll',
  DataModelRead = 'DataModelRead',
  DataPointsRead = 'DataPointsRead',
  DataPointsWrite = 'DataPointsWrite',
  ExportsRead = 'ExportsRead',
  ExportsWrite = 'ExportsWrite',
  OrganizationRead = 'OrganizationRead',
  ReportsRead = 'ReportsRead'
}

export type ApiTokensByOrganizationInput = {
  organizationId: Scalars['Int'];
};

export type ArchiveConstantDefinitionInput = {
  id: Scalars['Int'];
};

export type ArchiveConstantValueInput = {
  id: Scalars['Int'];
};

export type ArchiveReportDistributionListInput = {
  id: Scalars['UUID'];
};

export type ArchiveReportingReportGroupInput = {
  id: Scalars['Int'];
};

export type ArchiveSampleScheduleInput = {
  id: Scalars['UUID'];
};

export type ArchiveSampleSiteUploadInput = {
  sampleSiteId: Scalars['UUID'];
};

export type ArchiveScheduledItemCommentInput = {
  id: Scalars['UUID'];
};

export type ArchiveScheduledItemUploadInput = {
  scheduledItemId: Scalars['UUID'];
};

export type ArchiveScheduledItemsInput = {
  ids: Array<Scalars['UUID']>;
};

export type ArchiveUploadInput = {
  id: Scalars['UUID'];
};

export enum AssetsEntityType {
  Asset = 'Asset',
  Facility = 'Facility',
  System = 'System'
}

export type AuditEventFindOneInput = {
  where?: InputMaybe<AuditEventsWhere>;
};

export type AuditEventNest = {
  __typename?: 'AuditEventNest';
  activitySchedule?: Maybe<ActivitySchedule>;
  appliedAtWithTimeZone?: Maybe<Scalars['DateTime']>;
  component?: Maybe<ComponentNest>;
  componentId?: Maybe<Scalars['Int']>;
  event: Scalars['JSON'];
  id: Scalars['ID'];
  itemId?: Maybe<Scalars['String']>;
  itemType?: Maybe<AuditItemType>;
  metric?: Maybe<MetricNest>;
  metricId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  process?: Maybe<ProcessNest>;
  processId?: Maybe<Scalars['Int']>;
  rolledBackAt?: Maybe<Scalars['DateTime']>;
  scheduledItem?: Maybe<ScheduledItem>;
  site?: Maybe<SiteNest>;
  siteId?: Maybe<Scalars['Int']>;
  system?: Maybe<SystemNest>;
  systemId?: Maybe<Scalars['Int']>;
  timestamp: Scalars['Timestamp'];
  type: AuditEventType;
  user: UserNest;
  userId: Scalars['Int'];
  version: AuditEventVersion;
};

export type AuditEventSubscriptionInput = {
  organizationId: Scalars['Int'];
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
  types?: InputMaybe<Array<AuditEventType>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

export enum AuditEventType {
  ActivityScheduleArchivedEvent = 'ActivityScheduleArchivedEvent',
  ActivityScheduleChangedEvent = 'ActivityScheduleChangedEvent',
  ActivityScheduleCreatedEvent = 'ActivityScheduleCreatedEvent',
  AddressArchivedEvent = 'AddressArchivedEvent',
  AddressChangedEvent = 'AddressChangedEvent',
  AddressCreatedEvent = 'AddressCreatedEvent',
  ComponentArchivedEvent = 'ComponentArchivedEvent',
  ComponentChangedEvent = 'ComponentChangedEvent',
  ComponentCreatedEvent = 'ComponentCreatedEvent',
  ConstantDefinitionArchivedEvent = 'ConstantDefinitionArchivedEvent',
  ConstantDefinitionChangedEvent = 'ConstantDefinitionChangedEvent',
  ConstantDefinitionCreatedEvent = 'ConstantDefinitionCreatedEvent',
  ConstantRecalculationSubmittedEvent = 'ConstantRecalculationSubmittedEvent',
  ConstantValueArchivedEvent = 'ConstantValueArchivedEvent',
  ConstantValueChangedEvent = 'ConstantValueChangedEvent',
  ConstantValueCreatedEvent = 'ConstantValueCreatedEvent',
  DataEntryCompletionArchivedEvent = 'DataEntryCompletionArchivedEvent',
  DataEntryCompletionChangedEvent = 'DataEntryCompletionChangedEvent',
  DataEntryCompletionCreatedEvent = 'DataEntryCompletionCreatedEvent',
  DataPointChangedEvent = 'DataPointChangedEvent',
  DataPointChangedOnKeyMetricEvent = 'DataPointChangedOnKeyMetricEvent',
  EnterpriseReportArchivedEvent = 'EnterpriseReportArchivedEvent',
  EnterpriseReportChangedEvent = 'EnterpriseReportChangedEvent',
  EnterpriseReportCreatedEvent = 'EnterpriseReportCreatedEvent',
  EnterpriseReportShareLinkArchivedEvent = 'EnterpriseReportShareLinkArchivedEvent',
  EnterpriseReportShareLinkChangedEvent = 'EnterpriseReportShareLinkChangedEvent',
  EnterpriseReportShareLinkCreatedEvent = 'EnterpriseReportShareLinkCreatedEvent',
  FolderArchivedEvent = 'FolderArchivedEvent',
  FolderChangedEvent = 'FolderChangedEvent',
  FolderCreatedEvent = 'FolderCreatedEvent',
  IntervalArchivedEvent = 'IntervalArchivedEvent',
  IntervalChangedEvent = 'IntervalChangedEvent',
  IntervalCreatedEvent = 'IntervalCreatedEvent',
  LabImportBatchArchivedEvent = 'LabImportBatchArchivedEvent',
  LabImportBatchChangedEvent = 'LabImportBatchChangedEvent',
  LabImportBatchCreatedEvent = 'LabImportBatchCreatedEvent',
  LabImportProfileArchivedEvent = 'LabImportProfileArchivedEvent',
  LabImportProfileChangedEvent = 'LabImportProfileChangedEvent',
  LabImportProfileCreatedEvent = 'LabImportProfileCreatedEvent',
  LogBookEntryArchivedEvent = 'LogBookEntryArchivedEvent',
  LogBookEntryChangedEvent = 'LogBookEntryChangedEvent',
  LogBookEntryCreatedEvent = 'LogBookEntryCreatedEvent',
  MetricArchivedEvent = 'MetricArchivedEvent',
  MetricChangedEvent = 'MetricChangedEvent',
  MetricCreatedEvent = 'MetricCreatedEvent',
  OrganizationChangedEvent = 'OrganizationChangedEvent',
  OrganizationCreatedEvent = 'OrganizationCreatedEvent',
  PermitArchivedEvent = 'PermitArchivedEvent',
  PermitChangedEvent = 'PermitChangedEvent',
  PermitCreatedEvent = 'PermitCreatedEvent',
  PhraseArchivedEvent = 'PhraseArchivedEvent',
  PhraseChangedEvent = 'PhraseChangedEvent',
  PhraseCreatedEvent = 'PhraseCreatedEvent',
  ProcessArchivedEvent = 'ProcessArchivedEvent',
  ProcessChangedEvent = 'ProcessChangedEvent',
  ProcessCreatedEvent = 'ProcessCreatedEvent',
  ReportChangedEvent = 'ReportChangedEvent',
  ReportDefinitionArchivedEvent = 'ReportDefinitionArchivedEvent',
  ReportDefinitionChangedEvent = 'ReportDefinitionChangedEvent',
  ReportDefinitionCreatedEvent = 'ReportDefinitionCreatedEvent',
  ReportSnapshotArchivedEvent = 'ReportSnapshotArchivedEvent',
  ReportSnapshotChangedEvent = 'ReportSnapshotChangedEvent',
  ReportSnapshotCreatedEvent = 'ReportSnapshotCreatedEvent',
  ReportTemplateChangedEvent = 'ReportTemplateChangedEvent',
  ReportTemplateCreatedEvent = 'ReportTemplateCreatedEvent',
  RollbackEvent = 'RollbackEvent',
  SampleScheduleArchivedEvent = 'SampleScheduleArchivedEvent',
  SampleScheduleChangedEvent = 'SampleScheduleChangedEvent',
  SampleScheduleCreatedEvent = 'SampleScheduleCreatedEvent',
  ScheduledItemArchivedEvent = 'ScheduledItemArchivedEvent',
  ScheduledItemChangedEvent = 'ScheduledItemChangedEvent',
  ScheduledItemCommentArchivedEvent = 'ScheduledItemCommentArchivedEvent',
  ScheduledItemCommentChangedEvent = 'ScheduledItemCommentChangedEvent',
  ScheduledItemCommentCreatedEvent = 'ScheduledItemCommentCreatedEvent',
  ScheduledItemCreatedEvent = 'ScheduledItemCreatedEvent',
  SiteArchivedEvent = 'SiteArchivedEvent',
  SiteChangedEvent = 'SiteChangedEvent',
  SiteCreatedEvent = 'SiteCreatedEvent',
  SiteFlexMetricArchivedEvent = 'SiteFlexMetricArchivedEvent',
  SiteFlexMetricChangedEvent = 'SiteFlexMetricChangedEvent',
  SiteFlexMetricCreatedEvent = 'SiteFlexMetricCreatedEvent',
  SystemArchivedEvent = 'SystemArchivedEvent',
  SystemChangedEvent = 'SystemChangedEvent',
  SystemCreatedEvent = 'SystemCreatedEvent',
  TagMappingArchivedEvent = 'TagMappingArchivedEvent',
  TagMappingCreatedEvent = 'TagMappingCreatedEvent',
  TrendArchivedEvent = 'TrendArchivedEvent',
  TrendChangedEvent = 'TrendChangedEvent',
  TrendCreatedEvent = 'TrendCreatedEvent',
  UserAddedToSystemEvent = 'UserAddedToSystemEvent',
  UserAddedToSystemGroupEvent = 'UserAddedToSystemGroupEvent',
  UserChangedEvent = 'UserChangedEvent',
  UserCreatedEvent = 'UserCreatedEvent',
  UserLicenseArchivedEvent = 'UserLicenseArchivedEvent',
  UserLicenseChangedEvent = 'UserLicenseChangedEvent',
  UserLicenseCreatedEvent = 'UserLicenseCreatedEvent',
  UserPermissionToSystemChangedEvent = 'UserPermissionToSystemChangedEvent',
  UserPermissionToSystemGroupChangedEvent = 'UserPermissionToSystemGroupChangedEvent',
  UserPhoneNumberArchivedEvent = 'UserPhoneNumberArchivedEvent',
  UserPhoneNumberChangedEvent = 'UserPhoneNumberChangedEvent',
  UserPhoneNumberCreatedEvent = 'UserPhoneNumberCreatedEvent',
  UserRemovedFromSystemEvent = 'UserRemovedFromSystemEvent',
  UserRemovedFromSystemGroupEvent = 'UserRemovedFromSystemGroupEvent'
}

export enum AuditEventVersion {
  V1 = 'v1',
  V2 = 'v2'
}

export type AuditEventWithCount = {
  __typename?: 'AuditEventWithCount';
  count: Scalars['Int'];
  items: Array<AuditEventNest>;
};

export type AuditEventsByItemTypeAndItemId = {
  itemId: Scalars['String'];
  itemType: AuditItemType;
  orgId: Scalars['Int'];
};

export type AuditEventsByMetricIdInput = {
  endDate: Scalars['DateTime'];
  hideNonValueUpdates?: InputMaybe<Scalars['Boolean']>;
  metricId: Scalars['Int'];
  skip: Scalars['Int'];
  startDate: Scalars['DateTime'];
  systemId: Scalars['Int'];
  take: Scalars['Int'];
};

export type AuditEventsByScheduledItemIdInput = {
  id: Scalars['UUID'];
  systemId: Scalars['Int'];
};

export type AuditEventsInput = {
  componentIds?: InputMaybe<Array<Scalars['Int']>>;
  direction?: InputMaybe<OrderDirectionsNest>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  hideNonValueUpdates?: InputMaybe<Scalars['Boolean']>;
  includeWaterlyConnectEvents?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<Scalars['String']>>;
  itemTypes?: InputMaybe<Array<AuditItemType>>;
  lastAuditEventId?: InputMaybe<Scalars['String']>;
  metricIds?: InputMaybe<Array<Scalars['Int']>>;
  organizationId: Scalars['Int'];
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  skip: Scalars['Int'];
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
  take?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  types?: InputMaybe<Array<AuditEventType>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type AuditEventsWhere = {
  componentId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  itemId?: InputMaybe<Scalars['String']>;
  itemType?: InputMaybe<AuditItemType>;
  metricId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<AuditEventType>;
  userId?: InputMaybe<Scalars['Int']>;
};

export enum AuditItemType {
  ActivitySchedule = 'ACTIVITY_SCHEDULE',
  Address = 'ADDRESS',
  Component = 'COMPONENT',
  ConstantDefinition = 'CONSTANT_DEFINITION',
  ConstantValue = 'CONSTANT_VALUE',
  DataEntryCompletion = 'DATA_ENTRY_COMPLETION',
  DataPoint = 'DATA_POINT',
  EnterpriseReport = 'ENTERPRISE_REPORT',
  EnterpriseReportShareLink = 'ENTERPRISE_REPORT_SHARE_LINK',
  Folder = 'FOLDER',
  Interval = 'INTERVAL',
  LabImportBatch = 'LAB_IMPORT_BATCH',
  LabImportProfile = 'LAB_IMPORT_PROFILE',
  LogBookEntry = 'LOG_BOOK_ENTRY',
  Metric = 'METRIC',
  Organization = 'ORGANIZATION',
  Permit = 'PERMIT',
  Phrase = 'PHRASE',
  Process = 'PROCESS',
  ReportDefinition = 'REPORT_DEFINITION',
  ReportSnapshot = 'REPORT_SNAPSHOT',
  ReportTemplate = 'REPORT_TEMPLATE',
  Rollback = 'ROLLBACK',
  SampleSchedule = 'SAMPLE_SCHEDULE',
  ScheduledItem = 'SCHEDULED_ITEM',
  ScheduledItemComment = 'SCHEDULED_ITEM_COMMENT',
  Site = 'SITE',
  SiteFlexMetric = 'SITE_FLEX_METRIC',
  System = 'SYSTEM',
  TagMapping = 'TAG_MAPPING',
  Trend = 'TREND',
  User = 'USER',
  UserLicense = 'USER_LICENSE',
  UserPermission = 'USER_PERMISSION',
  UserPhoneNumber = 'USER_PHONE_NUMBER'
}

export type BaseFolder = {
  __typename?: 'BaseFolder';
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  default: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  depth: Scalars['Int'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  parentId?: Maybe<Scalars['UUID']>;
  siteId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type BaseSchedule = {
  __typename?: 'BaseSchedule';
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['Int'];
  defaultAssignee?: Maybe<UserNest>;
  defaultAssigneeId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  exDates?: Maybe<Array<Scalars['DateTime']>>;
  id: Scalars['UUID'];
  isStackable: Scalars['Boolean'];
  notBeforeUnit?: Maybe<DurationUnit>;
  notBeforeValue?: Maybe<Scalars['Int']>;
  photoRequired: Scalars['Boolean'];
  rDates?: Maybe<Array<Scalars['DateTime']>>;
  recurrenceType: RecurrenceType;
  rrule: Scalars['String'];
  siteId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  system: SystemNest;
  systemId: Scalars['Int'];
  targetBeforeUnit?: Maybe<DurationUnit>;
  targetBeforeValue?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  key: Scalars['String'];
  value: Scalars['String'];
};

export enum BulkMetricEditorBooleanFilter {
  False = 'False',
  True = 'True'
}

export enum BulkMetricEditorColumn {
  CalculationName = 'CalculationName',
  ComponentKeyname = 'ComponentKeyname',
  ComponentName = 'ComponentName',
  CopyPreviousValueEnabled = 'CopyPreviousValueEnabled',
  DataPointCommentPolicy = 'DataPointCommentPolicy',
  DataType = 'DataType',
  Expression = 'Expression',
  HasIntervals = 'HasIntervals',
  HideFromDataEntry = 'HideFromDataEntry',
  Interpolated = 'Interpolated',
  IsLockedByWaterly = 'IsLockedByWaterly',
  IsReportComments = 'IsReportComments',
  Keyname = 'Keyname',
  Limits = 'Limits',
  MetricId = 'MetricId',
  MetricRangeType = 'MetricRangeType',
  Name = 'Name',
  NotificationEnabled = 'NotificationEnabled',
  Order = 'Order',
  OrganizationName = 'OrganizationName',
  Precision = 'Precision',
  ProcessKeyname = 'ProcessKeyname',
  ProcessName = 'ProcessName',
  RangeMax = 'RangeMax',
  RangeMin = 'RangeMin',
  ReportAggregations = 'ReportAggregations',
  Required = 'Required',
  SiteName = 'SiteName',
  SiteType = 'SiteType',
  SystemName = 'SystemName',
  SystemType = 'SystemType',
  Units = 'Units'
}

export type BulkMetricEditorCompositeFilterInput = {
  presence?: InputMaybe<BulkMetricEditorCompositePresenceFilter>;
};

export enum BulkMetricEditorCompositePresenceFilter {
  Configured = 'Configured',
  NotConfigured = 'NotConfigured'
}

export enum BulkMetricEditorCsvExportStatus {
  Ready = 'Ready',
  TooLarge = 'TooLarge'
}

export type BulkMetricEditorEntityFilterOption = {
  __typename?: 'BulkMetricEditorEntityFilterOption';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type BulkMetricEditorEntityMultiselectFilterInput = {
  ids: Array<Scalars['Int']>;
  includeNullValues?: InputMaybe<Scalars['Boolean']>;
};

export type BulkMetricEditorFilterOptions = {
  __typename?: 'BulkMetricEditorFilterOptions';
  calculationNames: Array<Scalars['String']>;
  componentKeynames: Array<Scalars['String']>;
  components: Array<BulkMetricEditorEntityFilterOption>;
  copyPreviousValueEnabled: Array<Scalars['Boolean']>;
  dataPointCommentPolicies: Array<DataPointCommentPolicy>;
  dataTypes: Array<MetricDataTypeEnum>;
  expressions: Array<Scalars['String']>;
  hasIntervals: Array<Scalars['Boolean']>;
  hideFromDataEntry: Array<Scalars['Boolean']>;
  interpolated: Array<Scalars['Boolean']>;
  isLockedByWaterly: Array<Scalars['Boolean']>;
  isReportComments: Array<Scalars['Boolean']>;
  keynames: Array<Scalars['String']>;
  limits: Array<BulkMetricEditorCompositePresenceFilter>;
  metricRangeTypes: Array<MetricRangeType>;
  notificationEnabled: Array<Scalars['Boolean']>;
  organizations: Array<BulkMetricEditorEntityFilterOption>;
  processKeynames: Array<Scalars['String']>;
  processes: Array<BulkMetricEditorEntityFilterOption>;
  reportAggregations: Array<BulkMetricEditorCompositePresenceFilter>;
  required: Array<Scalars['Boolean']>;
  siteTypes: Array<Scalars['String']>;
  sites: Array<BulkMetricEditorEntityFilterOption>;
  systemTypes: Array<Scalars['String']>;
  systems: Array<BulkMetricEditorEntityFilterOption>;
  units: Array<Scalars['String']>;
};

export type BulkMetricEditorLimitsSummary = {
  __typename?: 'BulkMetricEditorLimitsSummary';
  belowReportingLimitValue?: Maybe<Scalars['Float']>;
  configured: Scalars['Boolean'];
  detectionLimit?: Maybe<Scalars['Float']>;
  reportingLimit?: Maybe<Scalars['Float']>;
  treatBelowReportingLimitAsPercent: Scalars['Boolean'];
};

export type BulkMetricEditorMetricRangeTypeFilterInput = {
  includeNullValues?: InputMaybe<Scalars['Boolean']>;
  values: Array<MetricRangeType>;
};

export type BulkMetricEditorMetrics = {
  __typename?: 'BulkMetricEditorMetrics';
  filteredCount: Scalars['Int'];
  items: Array<BulkMetricEditorRow>;
  totalCount: Scalars['Int'];
};

export type BulkMetricEditorMetricsCsvExport = {
  __typename?: 'BulkMetricEditorMetricsCsvExport';
  contentType: Scalars['String'];
  csv?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  rowCount: Scalars['Int'];
  status: BulkMetricEditorCsvExportStatus;
};

export type BulkMetricEditorMetricsCsvExportInput = {
  columnsToInclude: Array<BulkMetricEditorColumn>;
  filter?: InputMaybe<BulkMetricEditorMetricsFilterInput>;
  orderBy?: InputMaybe<Array<BulkMetricEditorOrderByInput>>;
};

export type BulkMetricEditorMetricsFilterInput = {
  calculationName?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
  componentKeynames?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
  components?: InputMaybe<BulkMetricEditorEntityMultiselectFilterInput>;
  copyPreviousValueEnabled?: InputMaybe<BulkMetricEditorBooleanFilter>;
  dataPointCommentPolicies?: InputMaybe<Array<DataPointCommentPolicy>>;
  dataTypes?: InputMaybe<Array<MetricDataTypeEnum>>;
  decimalPlaces?: InputMaybe<BulkMetricEditorNumberRangeFilterInput>;
  expression?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
  globalSearch?: InputMaybe<Scalars['String']>;
  hasIntervals?: InputMaybe<BulkMetricEditorBooleanFilter>;
  hideFromDataEntry?: InputMaybe<BulkMetricEditorBooleanFilter>;
  interpolated?: InputMaybe<BulkMetricEditorBooleanFilter>;
  isLockedByWaterly?: InputMaybe<BulkMetricEditorBooleanFilter>;
  isReportComments?: InputMaybe<BulkMetricEditorBooleanFilter>;
  keyname?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
  limits?: InputMaybe<BulkMetricEditorCompositeFilterInput>;
  metricIds?: InputMaybe<Array<Scalars['Int']>>;
  metricName?: InputMaybe<BulkMetricEditorStringFuzzySearchInput>;
  metricRangeTypes?: InputMaybe<BulkMetricEditorMetricRangeTypeFilterInput>;
  notificationEnabled?: InputMaybe<BulkMetricEditorBooleanFilter>;
  order?: InputMaybe<BulkMetricEditorNumberRangeFilterInput>;
  organizations?: InputMaybe<BulkMetricEditorEntityMultiselectFilterInput>;
  processKeynames?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
  processes?: InputMaybe<BulkMetricEditorEntityMultiselectFilterInput>;
  rangeMax?: InputMaybe<BulkMetricEditorNumberRangeFilterInput>;
  rangeMin?: InputMaybe<BulkMetricEditorNumberRangeFilterInput>;
  reportAggregations?: InputMaybe<BulkMetricEditorCompositeFilterInput>;
  required?: InputMaybe<BulkMetricEditorBooleanFilter>;
  siteTypes?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
  sites?: InputMaybe<BulkMetricEditorEntityMultiselectFilterInput>;
  systemTypes?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
  systems?: InputMaybe<BulkMetricEditorEntityMultiselectFilterInput>;
  units?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
};

export type BulkMetricEditorMetricsInput = {
  filter?: InputMaybe<BulkMetricEditorMetricsFilterInput>;
  orderBy?: InputMaybe<Array<BulkMetricEditorOrderByInput>>;
  page: BulkMetricEditorPageInput;
};

export type BulkMetricEditorMultiselectFilterInput = {
  includeNullValues?: InputMaybe<Scalars['Boolean']>;
  values: Array<Scalars['String']>;
};

export type BulkMetricEditorNumberRangeFilterInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type BulkMetricEditorOrderByInput = {
  direction: OrderDirectionsNest;
  field: BulkMetricEditorColumn;
};

export type BulkMetricEditorPageInput = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type BulkMetricEditorReportAggregationSummary = {
  __typename?: 'BulkMetricEditorReportAggregationSummary';
  canBeAveraged: CanBeAveraged;
  canBeCounted: Scalars['Boolean'];
  canBeMaximized: Scalars['Boolean'];
  canBeMinimized: Scalars['Boolean'];
  canBeTotaled: Scalars['Boolean'];
  configured: Scalars['Boolean'];
};

export type BulkMetricEditorRow = {
  __typename?: 'BulkMetricEditorRow';
  calculationName?: Maybe<Scalars['String']>;
  componentKeyname?: Maybe<Scalars['String']>;
  componentName?: Maybe<Scalars['String']>;
  copyPreviousValueEnabled: Scalars['Boolean'];
  dataPointCommentPolicy: DataPointCommentPolicy;
  dataType: MetricDataTypeEnum;
  expression?: Maybe<Scalars['String']>;
  hasIntervals: Scalars['Boolean'];
  hideFromDataEntry: Scalars['Boolean'];
  interpolated: Scalars['Boolean'];
  isLockedByWaterly: Scalars['Boolean'];
  isReportComments: Scalars['Boolean'];
  keyname?: Maybe<Scalars['String']>;
  limits: BulkMetricEditorLimitsSummary;
  metricId: Scalars['Int'];
  metricRangeType?: Maybe<MetricRangeType>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  order: Scalars['Int'];
  organizationName: Scalars['String'];
  precision?: Maybe<Scalars['Int']>;
  processKeyname?: Maybe<Scalars['String']>;
  processName: Scalars['String'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMin?: Maybe<Scalars['Float']>;
  reportAggregations: BulkMetricEditorReportAggregationSummary;
  required: Scalars['Boolean'];
  siteId: Scalars['Int'];
  siteName: Scalars['String'];
  siteType: Scalars['String'];
  systemId: Scalars['Int'];
  systemName: Scalars['String'];
  systemType: Scalars['String'];
  units?: Maybe<Scalars['String']>;
};

export type BulkMetricEditorStringFuzzySearchInput = {
  searchValue: Scalars['String'];
};

export type CalcClusterDebug = {
  __typename?: 'CalcClusterDebug';
  clusterId: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['UUID'];
  logStats: CalcClusterDebugLogStats;
  metricId: Scalars['Int'];
  metrics: Array<MetricWithSpcIntervalsUnit>;
  systems: Array<SystemNest>;
  updatedAt: Scalars['DateTime'];
};


export type CalcClusterDebugMetricsArgs = {
  input: CalcClusterDebugInputs;
};

export type CalcClusterDebugInputs = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: CalcClusterDebugWhere;
};

export type CalcClusterDebugLog = {
  __typename?: 'CalcClusterDebugLog';
  appliedAt: Scalars['DateTime'];
  calcClusterDebugId: Scalars['UUID'];
  clusterId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  measuredAt: Scalars['DateTime'];
  metricId: Scalars['Int'];
  oldValue?: Maybe<Scalars['String']>;
  site: SiteNest;
  transactionId: Scalars['UUID'];
  updatedAt: Scalars['DateTime'];
  value?: Maybe<Scalars['String']>;
};

export type CalcClusterDebugLogStats = {
  __typename?: 'CalcClusterDebugLogStats';
  avgLogsPerTransaction: Scalars['Float'];
  lastLoggedAt?: Maybe<Scalars['DateTime']>;
  logCount: Scalars['Int'];
  maxLogsPerTransaction: Scalars['Int'];
  transactionCount: Scalars['Int'];
};

export type CalcClusterDebugLogsInput = {
  includeIntervalMetrics?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: CalcClusterDebugLogsWhere;
};

export type CalcClusterDebugLogsWhere = {
  clusterId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  metricId?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  transactionId?: InputMaybe<Scalars['UUID']>;
};

export type CalcClusterDebugUpdateInput = {
  clusterId: Scalars['String'];
  enabled: Scalars['Boolean'];
  metricId: Scalars['Int'];
};

export type CalcClusterDebugWhere = {
  clusterId?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
};

export type CalcClusterDebugsWithCount = {
  __typename?: 'CalcClusterDebugsWithCount';
  count: Scalars['Int'];
  items: Array<CalcClusterDebug>;
};

export type CalcTree = {
  __typename?: 'CalcTree';
  dot: Scalars['String'];
  /** Uses the metric id as the unique key */
  id: Scalars['String'];
};

export type CalculatedMetric = {
  __typename?: 'CalculatedMetric';
  calculatedMetricId: Scalars['Int'];
  sourceMetricId: Scalars['Int'];
};

export enum CanBeAveraged {
  Arithmetic = 'Arithmetic',
  Geometric = 'Geometric',
  No = 'No'
}

export type CancelSampleScheduleInput = {
  endDate: Scalars['DateTime'];
  id: Scalars['UUID'];
};

export type CloneComponentsInput = {
  cloneQuantity: Scalars['Int'];
  sourceComponentIds: Array<Scalars['Int']>;
  targetProcessId: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
  withIntervals: Scalars['Boolean'];
};

export type CloneMetricsInput = {
  cloneQuantity: Scalars['Int'];
  sourceMetricIds: Array<Scalars['Int']>;
  targetComponentId?: InputMaybe<Scalars['Int']>;
  targetProcessId: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
  withIntervals: Scalars['Boolean'];
};

export type CloneProcessesInput = {
  cloneQuantity: Scalars['Int'];
  sourceProcessIds: Array<Scalars['Int']>;
  targetSiteId: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
  withIntervals: Scalars['Boolean'];
};

export type CloneSitesInput = {
  cloneQuantity: Scalars['Int'];
  flexSiteCloningMethod?: InputMaybe<FlexSiteCloningMethod>;
  sourceSiteIds: Array<Scalars['Int']>;
  targetSystemId: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
  withIntervals: Scalars['Boolean'];
};

export type CloneSystemInput = {
  cloneDescendants?: InputMaybe<Scalars['Boolean']>;
  cloneIntervals: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  sourceSystemId: Scalars['Int'];
  targetSystemGroupId: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
};

export type CloneSystemWithSelectedDescendantsInput = {
  cloneIntervals: Scalars['Boolean'];
  cloneQuantity: Scalars['Int'];
  restoreDeleted: Scalars['Boolean'];
  sourceComponentIds: Array<Scalars['Int']>;
  sourceMetricIds: Array<Scalars['Int']>;
  sourceProcessIds: Array<Scalars['Int']>;
  sourceSiteIds: Array<Scalars['Int']>;
  sourceSystemId: Scalars['Int'];
  targetSystemGroupId: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
};

export type CloneToTargetInput = {
  cloneIntervals: Scalars['Boolean'];
  cloneQuantity: Scalars['Int'];
  restoreDeleted: Scalars['Boolean'];
  sourceComponentIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceMetricIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceSiteIds?: InputMaybe<Array<Scalars['Int']>>;
  targetIds: Array<Scalars['Int']>;
  targetLevel: SspcmLevel;
  withDeleted: Scalars['Boolean'];
};

export type ClonedComponentPayload = {
  __typename?: 'ClonedComponentPayload';
  component: ComponentNest;
  metrics: Array<MetricNest>;
};

export type ClonedProcessPayload = {
  __typename?: 'ClonedProcessPayload';
  components: Array<ComponentNest>;
  metrics: Array<MetricNest>;
  process: ProcessNest;
};

export enum ColumnAggregation {
  ArithmeticMean = 'ARITHMETIC_MEAN',
  Count = 'COUNT',
  GeometricMean = 'GEOMETRIC_MEAN',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export enum ColumnCalculation {
  ArithmeticMean = 'ARITHMETIC_MEAN',
  Count = 'COUNT',
  GeometricMean = 'GEOMETRIC_MEAN',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export type ColumnGroup = {
  __typename?: 'ColumnGroup';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  reportDefinitionId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ColumnGroupItem = {
  __typename?: 'ColumnGroupItem';
  aggregation?: Maybe<ColumnAggregation>;
  calculationType?: Maybe<ColumnCalculation>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  intervalId?: Maybe<Scalars['Int']>;
  metricId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sourceMetrics: Array<MetricNest>;
  type: ColumnGroupItemType;
  updatedAt: Scalars['DateTime'];
};

export enum ColumnGroupItemType {
  Calculated = 'CALCULATED',
  Metric = 'METRIC',
  PageBreak = 'PAGE_BREAK'
}

export type ColumnGroupItemWithMetric = {
  __typename?: 'ColumnGroupItemWithMetric';
  aggregation?: Maybe<ColumnAggregation>;
  calculationType?: Maybe<ColumnCalculation>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  intervalId?: Maybe<Scalars['Int']>;
  metric?: Maybe<MetricNest>;
  metricId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sourceMetrics: Array<MetricNest>;
  type: ColumnGroupItemType;
  updatedAt: Scalars['DateTime'];
};

export type ColumnGroupWithItems = {
  __typename?: 'ColumnGroupWithItems';
  columnGroupItems?: Maybe<Array<ColumnGroupItemWithMetric>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  reportDefinitionId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ColumnGroupsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: ColumnGroupsWhere;
};

export type ColumnGroupsWhere = {
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['UUID']>;
  reportDefinitionId: Scalars['Int'];
};

export type ColumnGroupsWithItemsInput = {
  reportDefinitionId: Scalars['Int'];
};

export type CommitDirtyDataPointsInput = {
  dirtyDataPoints: Array<MetricDataPointInput>;
  siteId: Scalars['Int'];
  subscriptionClientId: Scalars['String'];
};

export type CommitLabImportBatchInput = {
  batchId: Scalars['UUID'];
  expectedValidatedAt: Scalars['DateTime'];
};

export type ComponentCreateInput = {
  internalKeyname?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  processId: Scalars['Int'];
};

export type ComponentNest = {
  __typename?: 'ComponentNest';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  processId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ComponentType = {
  __typename?: 'ComponentType';
  deletedAt?: Maybe<Scalars['TimestampType']>;
  displayName: Scalars['String'];
  enabledForReport?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  metrics: Array<MetricType>;
  name: Scalars['String'];
  order: Scalars['Int'];
  process: ProcessType;
  site: SiteType;
  system: SystemType;
};


export type ComponentTypeEnabledForReportArgs = {
  reportDefinitionId?: InputMaybe<Scalars['Int']>;
};


export type ComponentTypeMetricsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ComponentUpdateInput = {
  id: Scalars['Int'];
  internalKeyname?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type ComponentWithMetrics = {
  __typename?: 'ComponentWithMetrics';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  metrics: Array<MetricWithRelatedMetrics>;
  name: Scalars['String'];
  order: Scalars['Int'];
  processId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ComponentsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ComponentsWhere>;
};

export type ComponentsWhere = {
  id?: InputMaybe<Scalars['Int']>;
  internalKeyname?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  processId?: InputMaybe<Scalars['Int']>;
};

export enum ConstantDataType {
  Numeric = 'Numeric',
  Text = 'Text'
}

export type ConstantDefinition = {
  __typename?: 'ConstantDefinition';
  createdAt: Scalars['DateTime'];
  dataType: ConstantDataType;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  keyname: Scalars['String'];
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['Int']>;
  precision?: Maybe<Scalars['Int']>;
  scope: ConstantScope;
  systemId?: Maybe<Scalars['Int']>;
  unitId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  usedByMetricCount: Scalars['Int'];
  values: Array<ConstantValue>;
};

export type ConstantDefinitionsInput = {
  organizationId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
};

export type ConstantImpactedMetric = {
  __typename?: 'ConstantImpactedMetric';
  metricId: Scalars['Int'];
  metricName: Scalars['String'];
  recalculationCount: Scalars['Int'];
  siteName?: Maybe<Scalars['String']>;
};

export type ConstantRecalculationEstimate = {
  __typename?: 'ConstantRecalculationEstimate';
  capped: Scalars['Boolean'];
  dayCount: Scalars['Int'];
  effectiveFromDate: Scalars['Date'];
  metrics: Array<ConstantImpactedMetric>;
  recalcFromDate: Scalars['Date'];
  toDate: Scalars['Date'];
  totalRecalculationCount: Scalars['Int'];
};

export type ConstantRecalculationInput = {
  constantDefinitionId: Scalars['Int'];
  fromDate: Scalars['Date'];
  spanToToday?: InputMaybe<Scalars['Boolean']>;
};

export enum ConstantScope {
  Organization = 'Organization',
  System = 'System'
}

export type ConstantValue = {
  __typename?: 'ConstantValue';
  constantDefinitionId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  effectiveDate: Scalars['Date'];
  id: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  numericValue?: Maybe<Scalars['Float']>;
  textValue?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ConstantsForOrganizationInput = {
  asOfDate: Scalars['Date'];
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['Int'];
};

export type ConstantsForSystemInput = {
  asOfDate?: InputMaybe<Scalars['Date']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  systemId: Scalars['Int'];
};

export type CreateAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  purpose: AddressPurpose;
  recipientName?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
};

export type CreateApiTokenInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  preset?: InputMaybe<ApiTokenCapabilityPreset>;
};

export type CreateApiTokenPayloadNest = {
  __typename?: 'CreateApiTokenPayloadNest';
  credentials: MintedApiTokenCredentialsNest;
  token: ApiTokenNest;
};

export type CreateCalcClusterDebugInput = {
  clusterId: Scalars['String'];
  enabled: Scalars['Boolean'];
};

export type CreateColumnGroupInput = {
  name: Scalars['String'];
  parentId: Scalars['UUID'];
  reportDefinitionId: Scalars['Int'];
};

export type CreateColumnGroupItemViaTreeViewInput = {
  columnGroupItemId: Scalars['UUID'];
  isTopLevel: Scalars['Boolean'];
  metricId: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Int'];
  parentId: Scalars['UUID'];
  reportNodeId: Scalars['UUID'];
};

export type CreateColumnGroupItemsInput = {
  calculationType?: InputMaybe<ColumnCalculation>;
  metricIds: Array<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  parentId: Scalars['UUID'];
  reportDefinitionId: Scalars['Int'];
  sourceMetricIds?: InputMaybe<Array<Scalars['Int']>>;
  type?: ColumnGroupItemType;
};

export type CreateColumnGroupViaTreeViewInput = {
  columnGroupId: Scalars['UUID'];
  isTopLevel: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  parentId: Scalars['UUID'];
  reportNodeId: Scalars['UUID'];
};

export type CreateColumnGroupsAndItemsInput = {
  columnGroupInputs: Array<CreateColumnGroupViaTreeViewInput>;
  columnGroupItemInputs: Array<CreateColumnGroupItemViaTreeViewInput>;
  reportDefinitionId: Scalars['Int'];
};

export type CreateConstantDefinitionInput = {
  dataType: ConstantDataType;
  description?: InputMaybe<Scalars['String']>;
  keyname: Scalars['String'];
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['Int']>;
  precision?: InputMaybe<Scalars['Int']>;
  scope: ConstantScope;
  systemId?: InputMaybe<Scalars['Int']>;
  unitId?: InputMaybe<Scalars['Int']>;
};

export type CreateEnterpriseReportShareLinkInput = {
  expiresAt: Scalars['DateTime'];
  reportSnapshotId: Scalars['UUID'];
};

export type CreateEnterpriseReportShareLinkPayload = {
  __typename?: 'CreateEnterpriseReportShareLinkPayload';
  publicUrl: Scalars['String'];
  shareLink: EnterpriseReportShareLink;
};

export type CreateFlexFormFromSystemInput = {
  emoji?: InputMaybe<Scalars['String']>;
  includeArchived: Scalars['Boolean'];
  isEntry: Scalars['Boolean'];
  matchRequired: Scalars['Boolean'];
  name: Scalars['String'];
  sourceComponentIds: Array<Scalars['Int']>;
  sourceMetricIds: Array<Scalars['Int']>;
  sourceProcessIds: Array<Scalars['Int']>;
  targetSystemId: Scalars['Int'];
};

export type CreateFolderInput = {
  color?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  parentFolderId?: InputMaybe<Scalars['UUID']>;
  siteId: Scalars['Int'];
};

export type CreateIntervalInput = {
  siteId: Scalars['Int'];
  time?: InputMaybe<Scalars['String']>;
};

export type CreateIntervalsInput = {
  createIntervalInputs: Array<CreateIntervalInput>;
};

export type CreateLabImportBatchInput = {
  parserConfig?: InputMaybe<LabImportParserConfigInput>;
  profileVersionId?: InputMaybe<Scalars['UUID']>;
  systemId: Scalars['Int'];
  uploadId: Scalars['UUID'];
};

export type CreateLogBookEntryAttachmentsInput = {
  componentIds?: InputMaybe<Array<Scalars['Int']>>;
  metricIds?: InputMaybe<Array<Scalars['Int']>>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  siteIds?: InputMaybe<Array<Scalars['Int']>>;
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
  uploadIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type CreateLogBookEntryDashboardViewInput = {
  message?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['Int']>;
  siteIds?: InputMaybe<Array<Scalars['Int']>>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type CreateLogBookEntryInput = {
  attachments: CreateLogBookEntryAttachmentsInput;
  message: Scalars['String'];
  organizationId: Scalars['Int'];
};

export type CreateNotificationInput = {
  appearance: NotificationAppearance;
  dismissable: Scalars['Boolean'];
  displayPosition: NotificationDisplayPosition;
  endDate?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<SelectableIcons>;
  message: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  startDate: Scalars['DateTime'];
  systemGroupId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateOrganizationIntegrationInput = {
  integrationType: OrganizationIntegrationType;
  organizationId: Scalars['Int'];
  token: Scalars['String'];
};

export type CreatePhraseInput = {
  bodyText: Scalars['String'];
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type CreateReportDistributionListInput = {
  description?: InputMaybe<Scalars['String']>;
  members: Array<ReportDistributionListMemberInput>;
  name: Scalars['String'];
  scope: ReportDistributionListScopeInput;
};

export type CreateReportingReportGroupInput = {
  name: Scalars['String'];
  reportDefinitionIds: Array<Scalars['Int']>;
  systemId: Scalars['Int'];
};

export type CreateRoundsShiftNoteInput = {
  actionTaken: Scalars['Boolean'];
  componentId?: InputMaybe<Scalars['Int']>;
  date: Scalars['String'];
  emailStaff: Scalars['Boolean'];
  needsAttention: Scalars['Boolean'];
  note: Scalars['String'];
  noteAction?: InputMaybe<Scalars['String']>;
  notifyEvery?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  requestId: Scalars['UUID'];
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceRoundsEntityId: Scalars['Int'];
  sourceType: RoundsShiftNoteSourceType;
  systemId: Scalars['Int'];
  time: Scalars['String'];
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type CreateSampleScheduleInput = {
  analyteGroupId?: InputMaybe<Scalars['UUID']>;
  analyteIds: Array<Scalars['UUID']>;
  defaultAssigneeId?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  isStackable?: InputMaybe<Scalars['Boolean']>;
  notBeforeUnit?: InputMaybe<DurationUnit>;
  notBeforeValue?: InputMaybe<Scalars['Int']>;
  photoRequired: Scalars['Boolean'];
  recurrenceType: RecurrenceType;
  rrule: Scalars['String'];
  sampleSiteId: Scalars['UUID'];
  sampleType: SampleType;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId: Scalars['Int'];
  targetBeforeUnit?: InputMaybe<DurationUnit>;
  targetBeforeValue?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CreateScheduleParentInput = {
  defaultAssigneeId?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  isStackable?: InputMaybe<Scalars['Boolean']>;
  notBeforeUnit?: InputMaybe<DurationUnit>;
  notBeforeValue?: InputMaybe<Scalars['Int']>;
  photoRequired: Scalars['Boolean'];
  recurrenceType: RecurrenceType;
  rrule: Scalars['String'];
  siteId?: InputMaybe<Scalars['Int']>;
  systemId: Scalars['Int'];
  targetBeforeUnit?: InputMaybe<DurationUnit>;
  targetBeforeValue?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CreateScheduledItemCommentInput = {
  comment: Scalars['String'];
  commentType: ScheduledItemCommentType;
  scheduledItemId: Scalars['UUID'];
};

export type CreateSystemInput = {
  address?: InputMaybe<CreateAddressInput>;
  existingOrganizationId?: InputMaybe<Scalars['Int']>;
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  newOrganizationName?: InputMaybe<Scalars['String']>;
  operatorId?: InputMaybe<Scalars['Int']>;
  parentSystemGroupId?: InputMaybe<Scalars['Int']>;
  publicWaterSystemId?: InputMaybe<Scalars['String']>;
  regulatoryId?: InputMaybe<Scalars['String']>;
  timeZone: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type CreateTagInput = {
  color?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nameEs?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  type: TagType;
};

export type CreateUploadInput = {
  blobId: Scalars['String'];
  fileLength: Scalars['Float'];
  fileName: Scalars['String'];
  mimeType: Scalars['MimeType'];
  organizationId?: InputMaybe<Scalars['Int']>;
  uploadToken: Scalars['String'];
};

export type CreateWeatherDataStationInput = {
  latitude: Scalars['Float'];
  locationName: Scalars['String'];
  longitude: Scalars['Float'];
  stateCode?: InputMaybe<Scalars['String']>;
  usgsStationId?: InputMaybe<Scalars['String']>;
};

export type DataEntryCompletion = {
  __typename?: 'DataEntryCompletion';
  appliedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  intervalTime?: Maybe<Scalars['String']>;
  isComplete: Scalars['Boolean'];
  latestServiceReportSnapshot?: Maybe<ReportSnapshot>;
  siteId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<UserNest>;
  userId?: Maybe<Scalars['Int']>;
};

export enum DataEntryCompletionEmailOption {
  Always = 'Always',
  Never = 'Never',
  Prompt = 'Prompt'
}

export type DataEntryCompletionsByAppliedAt = {
  __typename?: 'DataEntryCompletionsByAppliedAt';
  daily?: Maybe<DataEntryCompletion>;
  intervals?: Maybe<Array<DataEntryCompletion>>;
};

export type DataEntryCompletionsByReportDateInput = {
  reportDate: Scalars['DateTime'];
  siteId: Scalars['Int'];
};

export enum DataPointCommentPolicy {
  None = 'None',
  Optional = 'Optional',
  Required = 'Required'
}

export type DataPointType = {
  id?: Maybe<Scalars['Int']>;
  reportDate: Scalars['String'];
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type DataPointValueAndInterval = {
  __typename?: 'DataPointValueAndInterval';
  id: Scalars['ID'];
  intervalId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  waterlyConnect: Scalars['Boolean'];
};

export type DataPointsForDay = {
  __typename?: 'DataPointsForDay';
  dataPoints: Array<DataPointValueAndInterval>;
  id: Scalars['ID'];
  metricId: Scalars['Int'];
};

export type DeleteColumnGroupItemInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteComponentInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeleteFolderInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteIntervalInput = {
  id: Scalars['Int'];
  siteId?: InputMaybe<Scalars['Int']>;
};

export type DeleteLicenseInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeleteLogBookEntryDashboardViewInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteLogBookEntryInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteMetricInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeleteMetricRangeInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteNotificationInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteOrganizationIntegrationInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeletePermitInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeletePhoneNumberInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeletePhraseInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteProcessInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeleteReportDefinitionByIdInput = {
  id: Scalars['Int'];
};

export type DeleteReportNodesInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  ids: Array<Scalars['UUID']>;
};

export type DeleteSiteInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeleteSystemFavoriteInput = {
  id: Scalars['Int'];
};

export type DeleteSystemGroupInput = {
  id: Scalars['Int'];
};

export type DeleteSystemInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeleteTagInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteTagMappingInput = {
  id: Scalars['Int'];
};

export type DeleteTrendInput = {
  id: Scalars['Int'];
};

export type DeleteUnitInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeleteUserFromSystemInput = {
  systemId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type DiagnosticsResult = {
  __typename?: 'DiagnosticsResult';
  id: Scalars['Int'];
  lastUpdated: Scalars['DateTime'];
  success: Scalars['Boolean'];
};

export type DisableEnterpriseReportShareLinkInput = {
  id: Scalars['UUID'];
};

export enum DurationUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type EdgeDeviceNest = {
  __typename?: 'EdgeDeviceNest';
  createdAt: Scalars['DateTime'];
  deviceName: Scalars['String'];
  deviceType: EdgeDeviceTypeNest;
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  integrationMetadata?: Maybe<Scalars['JSONObject']>;
  lastReceivedAt?: Maybe<Scalars['DateTime']>;
  organizationId: Scalars['Int'];
  organizationName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type EdgeDeviceSubmission = {
  __typename?: 'EdgeDeviceSubmission';
  createdAt: Scalars['TimestampType'];
  dataExcerpt: Scalars['String'];
  edgeDevice: EdgeDeviceType;
  edgeDeviceId: Scalars['Int'];
  id: Scalars['Int'];
  remoteIp?: Maybe<Scalars['String']>;
  status: EdgeDeviceSubmissionStatus;
  success: Scalars['Boolean'];
  updatedAt: Scalars['TimestampType'];
};

export type EdgeDeviceSubmissionFindRecentForDeviceIdInput = {
  edgeDeviceId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EdgeDeviceSubmissionOrderByInput>>;
};

export type EdgeDeviceSubmissionOrderByInput = {
  direction: EdgeDeviceSubmissionOrderDirection;
  field: EdgeDeviceSubmissionOrderField;
};

export enum EdgeDeviceSubmissionOrderDirection {
  Asc = 'Asc',
  Desc = 'Desc'
}

export enum EdgeDeviceSubmissionOrderField {
  CreatedAt = 'CreatedAt',
  Id = 'Id',
  RemoteIp = 'RemoteIp',
  Success = 'Success',
  UpdatedAt = 'UpdatedAt'
}

export type EdgeDeviceSubmissionSearchOptions = {
  filterEdgeDeviceId?: InputMaybe<Scalars['Int']>;
  filterStatus?: InputMaybe<EdgeDeviceSubmissionStatusFilter>;
  offset?: InputMaybe<Scalars['Int']>;
  submissionDateUTC: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
};

export enum EdgeDeviceSubmissionStatus {
  Fail = 'fail',
  Success = 'success'
}

export enum EdgeDeviceSubmissionStatusFilter {
  Both = 'both',
  Fail = 'fail',
  Success = 'success'
}

export type EdgeDeviceSubmissionSummariesWithCount = {
  __typename?: 'EdgeDeviceSubmissionSummariesWithCount';
  count: Scalars['Int'];
  items: Array<EdgeDeviceSubmissionSummary>;
};

export type EdgeDeviceSubmissionSummary = {
  __typename?: 'EdgeDeviceSubmissionSummary';
  createdAt: Scalars['DateTime'];
  edgeDeviceId: Scalars['Int'];
  id: Scalars['Int'];
  remoteIp: Scalars['String'];
  success: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type EdgeDeviceType = {
  __typename?: 'EdgeDeviceType';
  deviceName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  organizationId?: Maybe<Scalars['Int']>;
};

export enum EdgeDeviceTypeNest {
  ApiOrOther = 'APIOrOther',
  Flexy205 = 'Flexy205',
  Ignition = 'Ignition',
  NightOwl = 'NightOwl',
  SimpliScada = 'SimpliSCADA',
  VtScada = 'VTScada',
  Walchem = 'Walchem',
  XiO = 'XiO'
}

export type EligibleManualReportEmailRecipientsInput = {
  reportSnapshotId: Scalars['UUID'];
  search?: InputMaybe<Scalars['String']>;
};

export type EnterpriseReport = {
  __typename?: 'EnterpriseReport';
  createdAt: Scalars['DateTime'];
  frequency?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  inputConfig: Scalars['String'];
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['Int']>;
  reportId: Scalars['UUID'];
  reportSnapshots?: Maybe<Array<ReportSnapshot>>;
  reportTemplate: Scalars['String'];
  siteId?: Maybe<Scalars['Int']>;
  systemId?: Maybe<Scalars['Int']>;
  timeZone: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type EnterpriseReportShareLink = {
  __typename?: 'EnterpriseReportShareLink';
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  disabledAt?: Maybe<Scalars['DateTime']>;
  disabledByUserId?: Maybe<Scalars['Int']>;
  expiresAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  reportSnapshotId: Scalars['UUID'];
  updatedAt: Scalars['DateTime'];
};

export type EnterpriseReportShareLinkAccessRequestPayload = {
  __typename?: 'EnterpriseReportShareLinkAccessRequestPayload';
  emailRecipient?: Maybe<Scalars['String']>;
  submitted: Scalars['Boolean'];
};

export type EnterpriseReportShareLinkResolution = {
  __typename?: 'EnterpriseReportShareLinkResolution';
  disabledAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  redirectPath?: Maybe<Scalars['String']>;
  reportSnapshotId?: Maybe<Scalars['UUID']>;
  shareLinkId?: Maybe<Scalars['UUID']>;
  state: EnterpriseReportShareLinkResolutionState;
};

export enum EnterpriseReportShareLinkResolutionState {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Expired = 'EXPIRED',
  NotFound = 'NOT_FOUND',
  Redirect = 'REDIRECT'
}

export type EnterpriseReportsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: EnterpriseReportsWhere;
};

export type EnterpriseReportsWhere = {
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  reportTemplate?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
};

export type EntryIntervalCreateInput = {
  date: Scalars['Date'];
  siteId: Scalars['Int'];
  time: Scalars['String'];
};

export type EntryIntervalDateRangeInput = {
  endDate: Scalars['Date'];
  siteId: Scalars['Int'];
  startDate: Scalars['Date'];
};

export type EntrySparklineDataInput = {
  intervalId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  reportDate: Scalars['String'];
  siteId: Scalars['Int'];
};

export type EntrySparklineDataPointType = {
  __typename?: 'EntrySparklineDataPointType';
  appliedAt: Scalars['DateTime'];
  dataPoint?: Maybe<EntryTsDataPoint>;
  id: Scalars['ID'];
  intervalId?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['String']>;
};

export type EntrySparklineType = {
  __typename?: 'EntrySparklineType';
  dataPoints: Array<EntrySparklineDataPointType>;
  id: Scalars['ID'];
  metricId: Scalars['Int'];
  metricType: MetricDataTypeEnum;
};

export type EntryTsDataPoint = {
  __typename?: 'EntryTSDataPoint';
  appliedAt: Scalars['DateTime'];
  booleanValue?: Maybe<Scalars['Boolean']>;
  calculatedNondetectValue?: Maybe<Scalars['Boolean']>;
  calculatedValue?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  connectValue?: Maybe<Scalars['String']>;
  dateTimeValue?: Maybe<Scalars['String']>;
  dateValue?: Maybe<Scalars['String']>;
  edgeDeviceSubmissionId?: Maybe<Scalars['Int']>;
  effectiveNumericValue?: Maybe<Scalars['Float']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intervalId?: Maybe<Scalars['Int']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isCalculatedResult?: Maybe<Scalars['Boolean']>;
  isInterpolated: Scalars['Boolean'];
  isNondetect: Scalars['Boolean'];
  journalEntryRecordId: Scalars['ID'];
  jsonValue?: Maybe<Scalars['String']>;
  locatorEntityId: Scalars['String'];
  locatorEntityType: Scalars['String'];
  locatorNamespace: Scalars['String'];
  measuredAt: Scalars['DateTime'];
  metaData: EntryTsDataPointMetadata;
  metricId: Scalars['Int'];
  numericValue?: Maybe<Scalars['Float']>;
  reportDate: Scalars['String'];
  storedAt: Scalars['DateTime'];
  textValue?: Maybe<Scalars['String']>;
  timeValue?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  valueType: Scalars['String'];
};

export type EntryTsDataPointMetadata = {
  __typename?: 'EntryTSDataPointMetadata';
  connectValue?: Maybe<Scalars['String']>;
  edgeDeviceSubmissionId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  intervalId?: Maybe<Scalars['Int']>;
  reportDate: Scalars['String'];
};

export type ExternalFacilitiesInput = {
  maxResults?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['Int'];
  searchInput?: InputMaybe<Scalars['String']>;
};

export type ExternalFacility = {
  __typename?: 'ExternalFacility';
  externalId: Scalars['String'];
  externalMetadata: Scalars['JSONObject'];
  name: Scalars['String'];
};

export type ExternalSystem = {
  __typename?: 'ExternalSystem';
  externalId: Scalars['String'];
  externalMetadata: Scalars['JSONObject'];
  externalOwner: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  state: Scalars['String'];
};

export type ExternalSystemsInput = {
  externalId?: InputMaybe<Scalars['String']>;
  externalOwner?: InputMaybe<Scalars['String']>;
  maxResults?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['Int'];
  searchInput?: InputMaybe<Scalars['String']>;
};

export type FindUploadsWhere = {
  id?: InputMaybe<Scalars['UUID']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

export enum FlexSiteCloningMethod {
  LinkToClonedRefMetrics = 'LINK_TO_CLONED_REF_METRICS',
  LinkToOriginalRefMetrics = 'LINK_TO_ORIGINAL_REF_METRICS'
}

export type FlexSitesAssociatedWithMetricId = {
  id?: InputMaybe<Scalars['Int']>;
};

export type FolderWithMetricIdsAndOrder = {
  __typename?: 'FolderWithMetricIdsAndOrder';
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  default: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  depth: Scalars['Int'];
  id: Scalars['UUID'];
  metricIdsWithOrder: Array<MetricOrderWithMetricId>;
  name: Scalars['String'];
  order: Scalars['Int'];
  parentId?: Maybe<Scalars['UUID']>;
  siteId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type GetCalcTreeInput = {
  metricId: Scalars['Int'];
};

export type GroupCount = {
  __typename?: 'GroupCount';
  count: Scalars['Int'];
  id: Scalars['String'];
  status: Scalars['String'];
  userJobCounts: Array<UserJobCount>;
};

export type GroupQueueCounts = {
  __typename?: 'GroupQueueCounts';
  limited: Scalars['Int'];
  maxed: Scalars['Int'];
  paused: Scalars['Int'];
  waiting: Scalars['Int'];
};

/** A Country Abbreviation */
export enum IsoCountryCodesEnum {
  Ca = 'CA',
  Mx = 'MX',
  Us = 'US'
}

export type Interval = {
  __typename?: 'Interval';
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  time: Scalars['LocalTime'];
};

export type IntervalNest = {
  __typename?: 'IntervalNest';
  createdAt: Scalars['DateTime'];
  createdByUser?: Maybe<UserNest>;
  createdByUserId?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  displayName: Scalars['String'];
  id: Scalars['Int'];
  recentEntryCompletion?: Maybe<DataEntryCompletion>;
  siteFullName?: Maybe<Scalars['String']>;
  siteId: Scalars['Int'];
  time: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type IntervalsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IntervalsWhere>;
};

export type IntervalsWhere = {
  id?: InputMaybe<Scalars['Int']>;
  siteId?: InputMaybe<Scalars['Int']>;
  time?: InputMaybe<Scalars['String']>;
};

export type IntervalsWithCount = {
  __typename?: 'IntervalsWithCount';
  count: Scalars['Int'];
  items: Array<IntervalNest>;
};

export type JobEvent = {
  __typename?: 'JobEvent';
  data: QueuedRecalculation;
  job: JobLite;
  queue: Scalars['String'];
  type: JobEventType;
};

export enum JobEventType {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Progress = 'PROGRESS',
  Removed = 'REMOVED',
  Waiting = 'WAITING'
}

export type JobLite = {
  __typename?: 'JobLite';
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  progress?: Maybe<Scalars['Float']>;
  returnValue?: Maybe<Scalars['String']>;
  state: JobState;
};

export enum JobState {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Delayed = 'DELAYED',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Prioritized = 'PRIORITIZED',
  Wait = 'WAIT',
  WaitingChildren = 'WAITING_CHILDREN'
}

export type JobsFilterInput = {
  groups?: InputMaybe<Array<Scalars['String']>>;
  names?: InputMaybe<Array<Scalars['String']>>;
  states?: InputMaybe<Array<JobState>>;
};

export type LabImportBatch = {
  __typename?: 'LabImportBatch';
  checksumSha256: Scalars['String'];
  committedAt?: Maybe<Scalars['DateTime']>;
  committedRowCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  errorDetails?: Maybe<Scalars['JSONObject']>;
  id: Scalars['UUID'];
  invalidRowCount: Scalars['Int'];
  organizationId: Scalars['Int'];
  originalFileName: Scalars['String'];
  parserMetadata: LabImportParserConfig;
  profileName?: Maybe<Scalars['String']>;
  profileVersion?: Maybe<LabImportProfileVersion>;
  profileVersionId?: Maybe<Scalars['UUID']>;
  readyMetricCount: Scalars['Int'];
  readySiteCount: Scalars['Int'];
  reconciliationRequiredRowCount: Scalars['Int'];
  skippedRowCount: Scalars['Int'];
  sourceFileSizeBytes: Scalars['Int'];
  sourceMimeType: Scalars['String'];
  sourceUploadId: Scalars['UUID'];
  status: LabImportBatchStatus;
  systemId: Scalars['Int'];
  totalRowCount: Scalars['Int'];
  uploadedByUserId: Scalars['Int'];
  validRowCount: Scalars['Int'];
  validatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabImportBatchResume = {
  __typename?: 'LabImportBatchResume';
  batch: LabImportBatch;
  pendingProfile?: Maybe<LabImportPendingProfile>;
};

export enum LabImportBatchStatus {
  Committed = 'Committed',
  Committing = 'Committing',
  Failed = 'Failed',
  Parsed = 'Parsed',
  Parsing = 'Parsing',
  PartiallyCommitted = 'PartiallyCommitted',
  Ready = 'Ready',
  Uploaded = 'Uploaded',
  Validating = 'Validating'
}

export type LabImportBatchSummary = {
  __typename?: 'LabImportBatchSummary';
  committedAt?: Maybe<Scalars['DateTime']>;
  committedRowCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  fileLength?: Maybe<Scalars['Int']>;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  invalidRowCount: Scalars['Int'];
  profileName?: Maybe<Scalars['String']>;
  reconciliationRequiredRowCount: Scalars['Int'];
  skippedRowCount: Scalars['Int'];
  status: LabImportBatchStatus;
  totalRowCount: Scalars['Int'];
  validRowCount: Scalars['Int'];
};

export type LabImportBatchesInput = {
  skip?: InputMaybe<Scalars['Int']>;
  systemId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
};

export type LabImportBatchesPage = {
  __typename?: 'LabImportBatchesPage';
  count: Scalars['Int'];
  items: Array<LabImportBatchSummary>;
};

export type LabImportColumnMapping = {
  __typename?: 'LabImportColumnMapping';
  column: Scalars['String'];
  field: Scalars['String'];
};

export type LabImportColumnMappingInput = {
  column: Scalars['String'];
  field: Scalars['String'];
};

export type LabImportCommitResult = {
  __typename?: 'LabImportCommitResult';
  batch: LabImportBatch;
  committedCount: Scalars['Int'];
  failedCount: Scalars['Int'];
  reconciliationRequiredCount: Scalars['Int'];
};

export enum LabImportDataPointWriteStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Reconciled = 'Reconciled',
  Succeeded = 'Succeeded',
  WorkflowFailed = 'WorkflowFailed'
}

export type LabImportFileDownload = {
  __typename?: 'LabImportFileDownload';
  downloadUrl: Scalars['String'];
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
};

export type LabImportParserConfig = {
  __typename?: 'LabImportParserConfig';
  columns: Array<Scalars['String']>;
  delimiter: Scalars['String'];
  hasHeader: Scalars['Boolean'];
  quote: Scalars['String'];
};

export type LabImportParserConfigInput = {
  columns: Array<Scalars['String']>;
  delimiter: Scalars['String'];
  hasHeader: Scalars['Boolean'];
  quote: Scalars['String'];
};

export type LabImportPendingProfile = {
  __typename?: 'LabImportPendingProfile';
  baseProfileVersionId?: Maybe<Scalars['UUID']>;
  definition: LabImportProfileDefinition;
  name: Scalars['String'];
  profileId?: Maybe<Scalars['UUID']>;
};

export type LabImportProfile = {
  __typename?: 'LabImportProfile';
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['Int'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  systemId: Scalars['Int'];
  versions: Array<LabImportProfileVersion>;
};

export type LabImportProfileDefinition = {
  __typename?: 'LabImportProfileDefinition';
  columnMappings: Array<LabImportColumnMapping>;
  parserConfig: LabImportParserConfig;
  targetMappings: Array<LabImportTargetMapping>;
};

export type LabImportProfileDefinitionInput = {
  baseProfileVersionId?: InputMaybe<Scalars['UUID']>;
  columnMappings: Array<LabImportColumnMappingInput>;
  name: Scalars['String'];
  parserConfig: LabImportParserConfigInput;
  profileId?: InputMaybe<Scalars['UUID']>;
  systemId: Scalars['Int'];
  targetMappings: Array<LabImportTargetMappingInput>;
};

export type LabImportProfileValidation = {
  __typename?: 'LabImportProfileValidation';
  issues: Array<LabImportProfileValidationIssue>;
  valid: Scalars['Boolean'];
};

export type LabImportProfileValidationIssue = {
  __typename?: 'LabImportProfileValidationIssue';
  code: Scalars['String'];
  field: Scalars['String'];
  message: Scalars['String'];
};

export type LabImportProfileVersion = {
  __typename?: 'LabImportProfileVersion';
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['Int'];
  definition: LabImportProfileDefinition;
  id: Scalars['UUID'];
  profileId: Scalars['UUID'];
  version: Scalars['Int'];
};

export type LabImportRow = {
  __typename?: 'LabImportRow';
  batchId: Scalars['UUID'];
  canonicalValues: Scalars['JSONObject'];
  comments?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  importedUnitLabel?: Maybe<Scalars['String']>;
  intervalId?: Maybe<Scalars['Int']>;
  isNondetect?: Maybe<Scalars['Boolean']>;
  metricId?: Maybe<Scalars['Int']>;
  rawValues: Scalars['JSONObject'];
  reportDate?: Maybe<Scalars['String']>;
  requestId?: Maybe<Scalars['String']>;
  resultName?: Maybe<Scalars['String']>;
  resultValue?: Maybe<Scalars['String']>;
  rowNumber: Scalars['Int'];
  sampleDate?: Maybe<Scalars['String']>;
  sampleIdentifier?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['Int']>;
  status: LabImportRowStatus;
  systemId?: Maybe<Scalars['Int']>;
  validationResults: Array<LabImportValidationResult>;
  writeErrorDetails?: Maybe<Scalars['JSONObject']>;
  writeStatus?: Maybe<LabImportDataPointWriteStatus>;
  writtenAt?: Maybe<Scalars['DateTime']>;
};

export enum LabImportRowStatus {
  Committed = 'Committed',
  Committing = 'Committing',
  Failed = 'Failed',
  Invalid = 'Invalid',
  Parsed = 'Parsed',
  ReconciliationRequired = 'ReconciliationRequired',
  Skipped = 'Skipped',
  Valid = 'Valid'
}

export type LabImportRowsInput = {
  batchId: Scalars['UUID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<LabImportRowStatus>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type LabImportRowsPage = {
  __typename?: 'LabImportRowsPage';
  count: Scalars['Int'];
  items: Array<LabImportRow>;
};

export type LabImportSourceColumnsInput = {
  analyte: Scalars['String'];
  project: Scalars['String'];
  sampleSite: Scalars['String'];
  unit: Scalars['String'];
};

export type LabImportSourceGroup = {
  __typename?: 'LabImportSourceGroup';
  analyte: Scalars['String'];
  project: Scalars['String'];
  rowCount: Scalars['Int'];
  sampleSite: Scalars['String'];
  unit: Scalars['String'];
};

export type LabImportSourceGroupsInput = {
  batchId: Scalars['UUID'];
  columns: LabImportSourceColumnsInput;
};

export type LabImportTarget = {
  __typename?: 'LabImportTarget';
  metricId: Scalars['Int'];
  metricName: Scalars['String'];
  metricUnitLabel: Scalars['String'];
  siteId: Scalars['Int'];
  siteName: Scalars['String'];
};

export enum LabImportTargetDecision {
  Map = 'Map',
  Skip = 'Skip'
}

export type LabImportTargetMapping = {
  __typename?: 'LabImportTargetMapping';
  decision: LabImportTargetDecision;
  id: Scalars['String'];
  importedUnitLabel?: Maybe<Scalars['String']>;
  metricId?: Maybe<Scalars['Int']>;
  metricUnitLabel?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['Int']>;
  sourceAnalyte: Scalars['String'];
  sourceProject: Scalars['String'];
  sourceSampleSite: Scalars['String'];
  unitDecision?: Maybe<LabImportUnitDecision>;
};

export type LabImportTargetMappingInput = {
  decision: LabImportTargetDecision;
  id: Scalars['String'];
  importedUnitLabel?: InputMaybe<Scalars['String']>;
  metricId?: InputMaybe<Scalars['Int']>;
  metricUnitLabel?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  sourceAnalyte: Scalars['String'];
  sourceProject: Scalars['String'];
  sourceSampleSite: Scalars['String'];
  unitDecision?: InputMaybe<LabImportUnitDecision>;
};

export enum LabImportUnitDecision {
  Accepted = 'Accepted',
  Exact = 'Exact',
  Rejected = 'Rejected'
}

export type LabImportValidationResult = {
  __typename?: 'LabImportValidationResult';
  attempt: Scalars['Int'];
  code: Scalars['String'];
  details?: Maybe<Scalars['JSONObject']>;
  field?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  message: Scalars['String'];
  status: LabImportValidationStatus;
};

export enum LabImportValidationStatus {
  Error = 'Error',
  Passed = 'Passed',
  Warning = 'Warning'
}

export type LatestServiceReportSnapshotBySiteAndReportDateInput = {
  dataEntryCompletionId?: InputMaybe<Scalars['UUID']>;
  reportDateTime: Scalars['DateTime'];
  siteId: Scalars['Int'];
};

/** Current mostly US states, but can be extended to include other regions as needed. */
export enum LicenseAuthoritiesEnum {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  /** Non Us State */
  Itca = 'ITCA',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type LicenseNest = {
  __typename?: 'LicenseNest';
  authority: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  id: Scalars['Int'];
  licenseLabel: Scalars['String'];
  licenseNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
};

export type LogBookEntriesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<OrderDirectionsNest>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: LogBookEntriesWhere;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type LogBookEntriesWhere = {
  createdAtEndDate?: InputMaybe<Scalars['DateTime']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  siteIds?: InputMaybe<Array<Scalars['Int']>>;
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type LogBookEntriesWithCount = {
  __typename?: 'LogBookEntriesWithCount';
  count: Scalars['Int'];
  items: Array<LogBookEntryNest>;
};

export type LogBookEntryAttachmentsNest = {
  __typename?: 'LogBookEntryAttachmentsNest';
  components: Array<ComponentNest>;
  metrics: Array<MetricNest>;
  processes: Array<ProcessNest>;
  sites: Array<SiteNest>;
  systems: Array<SystemNest>;
  tags: Array<Tag>;
  uploads: Array<Upload>;
};

export type LogBookEntryDashboardViewByUserIdInput = {
  userId: Scalars['Int'];
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type LogBookEntryDashboardViewNest = {
  __typename?: 'LogBookEntryDashboardViewNest';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['Int']>;
  siteIds?: Maybe<Array<Scalars['Int']>>;
  sortDirection: Scalars['String'];
  sortField: Scalars['String'];
  systemIds?: Maybe<Array<Scalars['Int']>>;
  tagIds?: Maybe<Array<Scalars['UUID']>>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
  userIds?: Maybe<Array<Scalars['Int']>>;
};

export type LogBookEntryNest = {
  __typename?: 'LogBookEntryNest';
  attachments: LogBookEntryAttachmentsNest;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  message: Scalars['String'];
  organizationId: Scalars['Int'];
  pinned: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  user: UserNest;
  userId: Scalars['Int'];
};

export type ManualReportEmailAddressInput = {
  email: Scalars['EmailAddress'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type ManualReportEmailDistributionListInput = {
  distributionListId: Scalars['UUID'];
  recipientKind: ManualReportEmailRecipientKind;
};

export type ManualReportEmailEligibleRecipient = {
  __typename?: 'ManualReportEmailEligibleRecipient';
  displayName: Scalars['String'];
  email: Scalars['String'];
  primaryOrganizationName?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type ManualReportEmailEvent = {
  __typename?: 'ManualReportEmailEvent';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  providerMessageId?: Maybe<Scalars['String']>;
  recipients: Array<ManualReportEmailRecipient>;
  reportSnapshotId: Scalars['UUID'];
  senderEmail: Scalars['String'];
  senderUserId: Scalars['Int'];
  sentAt?: Maybe<Scalars['DateTime']>;
  shareLinkId: Scalars['UUID'];
  status: ManualReportEmailEventStatus;
  subject: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum ManualReportEmailEventStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Sent = 'Sent'
}

export type ManualReportEmailRecipient = {
  __typename?: 'ManualReportEmailRecipient';
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  normalizedEmail: Scalars['String'];
  recipientKind: ManualReportEmailRecipientKind;
  recipientSource: ManualReportEmailRecipientSource;
  sourceDistributionListId?: Maybe<Scalars['UUID']>;
  sourceDistributionListName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['Int']>;
};

export enum ManualReportEmailRecipientKind {
  Bcc = 'Bcc',
  Cc = 'Cc',
  To = 'To'
}

export enum ManualReportEmailRecipientSource {
  ManualEmail = 'ManualEmail',
  RegisteredUser = 'RegisteredUser'
}

export type ManualReportEmailSharingScope = {
  __typename?: 'ManualReportEmailSharingScope';
  organizationId?: Maybe<Scalars['Int']>;
  organizationName?: Maybe<Scalars['String']>;
  scope: ReportDistributionListScope;
  siteId?: Maybe<Scalars['Int']>;
  systemId?: Maybe<Scalars['Int']>;
};

export type MetricChartDataContainerType = {
  __typename?: 'MetricChartDataContainerType';
  data?: Maybe<Array<Maybe<MetricChartDataType>>>;
  endDate: Scalars['DateType'];
  startDate: Scalars['DateType'];
};

export type MetricChartDataPointType = {
  __typename?: 'MetricChartDataPointType';
  effectiveValue?: Maybe<Scalars['Float']>;
  reportDate: Scalars['DateTime'];
  value?: Maybe<Scalars['Float']>;
};

export type MetricChartDataType = {
  __typename?: 'MetricChartDataType';
  dataPoints: Array<Maybe<MetricChartDataPointType>>;
  metricId: Scalars['Int'];
};

export type MetricCreateInput = {
  belowRlValue?: InputMaybe<Scalars['Float']>;
  calculated?: InputMaybe<Scalars['Boolean']>;
  calculationName?: InputMaybe<Scalars['String']>;
  canBeAveraged?: InputMaybe<CanBeAveraged>;
  canBeMaximized?: InputMaybe<Scalars['Boolean']>;
  canBeMinimized?: InputMaybe<Scalars['Boolean']>;
  canBeTotaled?: InputMaybe<Scalars['Boolean']>;
  componentId?: InputMaybe<Scalars['Int']>;
  dataPointCommentPolicy?: InputMaybe<DataPointCommentPolicy>;
  dataType: MetricDataTypeEnum;
  detectionLimit?: InputMaybe<Scalars['Float']>;
  expression?: InputMaybe<Scalars['String']>;
  internalKeyname?: InputMaybe<Scalars['String']>;
  isDecreasing?: InputMaybe<Scalars['Boolean']>;
  isIncreasing?: InputMaybe<Scalars['Boolean']>;
  isLockedByWaterly?: InputMaybe<Scalars['Boolean']>;
  maxValue?: InputMaybe<Scalars['BigInt']>;
  minValue?: InputMaybe<Scalars['BigInt']>;
  name: Scalars['String'];
  notificationEnabled?: InputMaybe<Scalars['Boolean']>;
  precision?: InputMaybe<Scalars['Int']>;
  processId: Scalars['Int'];
  rangeMax?: InputMaybe<Scalars['Float']>;
  rangeMin?: InputMaybe<Scalars['Float']>;
  reportingLimit?: InputMaybe<Scalars['Float']>;
  required?: InputMaybe<Scalars['Boolean']>;
  treatBelowRlAsPercent?: InputMaybe<Scalars['Boolean']>;
  unitId?: InputMaybe<Scalars['Int']>;
};

export type MetricDataPointInput = {
  comment?: InputMaybe<Scalars['String']>;
  effectiveValue?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  intervalId?: InputMaybe<Scalars['Int']>;
  isCalculatedResult?: InputMaybe<Scalars['Boolean']>;
  isInterpolated?: InputMaybe<Scalars['Boolean']>;
  isNondetect?: InputMaybe<Scalars['Boolean']>;
  metricId: Scalars['Int'];
  reportDate: Scalars['String'];
  value: Scalars['String'];
  version: Scalars['Int'];
};

export type MetricDataPointType = DataPointType & {
  __typename?: 'MetricDataPointType';
  appliedAt: Scalars['DateType'];
  calculatedNondetectValue?: Maybe<Scalars['Boolean']>;
  calculatedValue?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  connectValue?: Maybe<Scalars['String']>;
  edgeDeviceSubmissionId?: Maybe<Scalars['Int']>;
  effectiveValue?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  intervalId?: Maybe<Scalars['Int']>;
  isInterpolated?: Maybe<Scalars['Boolean']>;
  isNondetect?: Maybe<Scalars['Boolean']>;
  measuredAt: Scalars['DateType'];
  metricId: Scalars['Int'];
  reportDate: Scalars['String'];
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export enum MetricDataTypeEnum {
  Date = 'Date',
  Image = 'Image',
  Json = 'Json',
  Number = 'Number',
  SmartText = 'SmartText',
  String = 'String',
  Time = 'Time',
  Timestamp = 'Timestamp',
  Userselect = 'Userselect',
  Yesno = 'Yesno'
}

export type MetricKeyname = {
  __typename?: 'MetricKeyname';
  compliance: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  systemTypes?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['DateTime'];
};

export type MetricKeynameCreateInput = {
  compliance?: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  systemTypes?: InputMaybe<Array<Scalars['String']>>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
  unitIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type MetricKeynameDeleteInput = {
  hardDelete?: Scalars['Boolean'];
  id: Scalars['String'];
};

export type MetricKeynameInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MetricKeynameWhere>;
};

export type MetricKeynameJoinedWithCount = {
  __typename?: 'MetricKeynameJoinedWithCount';
  count: Scalars['Int'];
  items: Array<MetricKeynameWithUnitsAndTags>;
};

export type MetricKeynameUpdateInput = {
  compliance?: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  systemTypes?: InputMaybe<Array<Scalars['String']>>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
  unitIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type MetricKeynameWhere = {
  compliance?: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  systemTypes?: InputMaybe<Array<Scalars['String']>>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
  unitIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type MetricKeynameWithUnitsAndTags = {
  __typename?: 'MetricKeynameWithUnitsAndTags';
  compliance: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  metricsCount: Scalars['Int'];
  name: Scalars['String'];
  systemTypes?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Tag>>;
  units?: Maybe<Array<UnitNest>>;
  updatedAt: Scalars['DateTime'];
};

export type MetricNest = {
  __typename?: 'MetricNest';
  belowRlValue?: Maybe<Scalars['Float']>;
  calcClusterId?: Maybe<Scalars['String']>;
  calculated: Scalars['Boolean'];
  calculationName?: Maybe<Scalars['String']>;
  canBeAveraged: CanBeAveraged;
  canBeCounted: Scalars['Boolean'];
  canBeMaximized: Scalars['Boolean'];
  canBeMinimized: Scalars['Boolean'];
  canBeTotaled: Scalars['Boolean'];
  component?: Maybe<ComponentNest>;
  componentId?: Maybe<Scalars['Int']>;
  copyPreviousValueEnabled: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  dataPointCommentPolicy: DataPointCommentPolicy;
  dataType: MetricDataTypeEnum;
  debug: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  detectionLimit?: Maybe<Scalars['Float']>;
  displayNameBreadcrumbs?: Maybe<Array<Breadcrumb>>;
  expression?: Maybe<Scalars['String']>;
  hideFromDataEntry: Scalars['Boolean'];
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  interpolated: Scalars['Boolean'];
  intervals?: Maybe<Array<IntervalNest>>;
  isDecreasing: Scalars['Boolean'];
  isIncreasing: Scalars['Boolean'];
  isLockedByWaterly: Scalars['Boolean'];
  isReportComments: Scalars['Boolean'];
  isWaterlyConnected: Scalars['Boolean'];
  keynameId?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['BigInt']>;
  metricKeyname?: Maybe<MetricKeyname>;
  metricRangeType?: Maybe<MetricRangeType>;
  metricRanges: Array<MetricRange>;
  minValue?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  order: Scalars['Int'];
  precision?: Maybe<Scalars['Int']>;
  process?: Maybe<ProcessNest>;
  processId: Scalars['Int'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMin?: Maybe<Scalars['Float']>;
  reportingLimit?: Maybe<Scalars['Float']>;
  required: Scalars['Boolean'];
  treatBelowRlAsPercent: Scalars['Boolean'];
  unit?: Maybe<UnitNest>;
  unitId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatesPriorDay: Scalars['Boolean'];
};


export type MetricNestCalcClusterIdArgs = {
  includeCalcClusterId?: InputMaybe<Scalars['Boolean']>;
};

export type MetricOrderWithMetricId = {
  __typename?: 'MetricOrderWithMetricId';
  id: Scalars['UUID'];
  metricId: Scalars['Int'];
  order: Scalars['Int'];
};

export type MetricRange = {
  __typename?: 'MetricRange';
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  ideal: Scalars['Boolean'];
  maxTag?: Maybe<Tag>;
  maxTagId?: Maybe<Scalars['UUID']>;
  metricId: Scalars['Int'];
  minTag?: Maybe<Tag>;
  minTagId?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMaxInclusive: Scalars['Boolean'];
  rangeMin?: Maybe<Scalars['Float']>;
  rangeMinInclusive: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export enum MetricRangeType {
  Both = 'BOTH',
  Lower = 'LOWER',
  Upper = 'UPPER'
}

export type MetricType = {
  __typename?: 'MetricType';
  belowRlValue?: Maybe<Scalars['Float']>;
  calculated: Scalars['Boolean'];
  calculatedMetrics: Array<MetricType>;
  calculationName?: Maybe<Scalars['String']>;
  canBeAveraged: CanBeAveraged;
  canBeCounted: Scalars['Boolean'];
  canBeMaximized: Scalars['Boolean'];
  canBeMinimized: Scalars['Boolean'];
  canBeTotaled: Scalars['Boolean'];
  component?: Maybe<ComponentType>;
  componentId?: Maybe<Scalars['Int']>;
  copyPreviousValueEnabled: Scalars['Boolean'];
  dataPointCommentPolicy?: Maybe<DataPointCommentPolicy>;
  dataType: MetricDataTypeEnum;
  deletedAt?: Maybe<Scalars['TimestampType']>;
  detectionLimit?: Maybe<Scalars['Float']>;
  displayName: Scalars['String'];
  displayNameSiteLocal: Scalars['String'];
  enabledForReport: Scalars['Boolean'];
  enabledIntervalForMonthlyReport?: Maybe<Interval>;
  expression?: Maybe<Scalars['String']>;
  hasIntervals: Scalars['String'];
  hideFromDataEntry: Scalars['Boolean'];
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  interpolated: Scalars['Boolean'];
  intervals: Array<Interval>;
  isDecreasing: Scalars['Boolean'];
  isIncreasing: Scalars['Boolean'];
  isLockedByWaterly: Scalars['Boolean'];
  isReportComments: Scalars['Boolean'];
  isWaterlyConnected: Scalars['Boolean'];
  keynameId?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['BigInt']>;
  metricRanges: Array<MetricRange>;
  minValue?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  order: Scalars['Int'];
  precision?: Maybe<Scalars['Int']>;
  process?: Maybe<ProcessType>;
  processId: Scalars['Int'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMin?: Maybe<Scalars['Float']>;
  reportingLimit?: Maybe<Scalars['Float']>;
  required: Scalars['Boolean'];
  site?: Maybe<SiteType>;
  sourceMetrics: Array<MetricType>;
  system?: Maybe<SystemType>;
  tagMapping?: Maybe<TagMappingType>;
  treatBelowRlAsPercent: Scalars['Boolean'];
  unit?: Maybe<UnitType>;
  unitId?: Maybe<Scalars['Int']>;
};


export type MetricTypeEnabledForReportArgs = {
  reportDefinitionId: Scalars['Int'];
};


export type MetricTypeEnabledIntervalForMonthlyReportArgs = {
  reportDefinitionId: Scalars['Int'];
};

export type MetricUpdateInput = {
  belowRlValue?: InputMaybe<Scalars['Float']>;
  calculated?: InputMaybe<Scalars['Boolean']>;
  calculationName?: InputMaybe<Scalars['String']>;
  canBeAveraged?: InputMaybe<CanBeAveraged>;
  canBeCounted?: InputMaybe<Scalars['Boolean']>;
  canBeMaximized?: InputMaybe<Scalars['Boolean']>;
  canBeMinimized?: InputMaybe<Scalars['Boolean']>;
  canBeTotaled?: InputMaybe<Scalars['Boolean']>;
  componentId?: InputMaybe<Scalars['Int']>;
  copyPreviousValueEnabled?: InputMaybe<Scalars['Boolean']>;
  dataPointCommentPolicy?: InputMaybe<DataPointCommentPolicy>;
  dataType?: InputMaybe<MetricDataTypeEnum>;
  detectionLimit?: InputMaybe<Scalars['Float']>;
  expression?: InputMaybe<Scalars['String']>;
  hideFromDataEntry?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  internalKeyname?: InputMaybe<Scalars['String']>;
  interpolated?: InputMaybe<Scalars['Boolean']>;
  intervalIds?: InputMaybe<Array<Scalars['Int']>>;
  isDecreasing?: InputMaybe<Scalars['Boolean']>;
  isIncreasing?: InputMaybe<Scalars['Boolean']>;
  isLockedByWaterly?: InputMaybe<Scalars['Boolean']>;
  isReportComments?: InputMaybe<Scalars['Boolean']>;
  keynameId?: InputMaybe<Scalars['String']>;
  maxValue?: InputMaybe<Scalars['BigInt']>;
  metricRangeType?: InputMaybe<MetricRangeType>;
  metricRanges?: InputMaybe<Array<UpsertMetricRangeInput>>;
  minValue?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEnabled?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  precision?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  rangeMax?: InputMaybe<Scalars['Float']>;
  rangeMin?: InputMaybe<Scalars['Float']>;
  reportingLimit?: InputMaybe<Scalars['Float']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sourceMetricIds?: InputMaybe<Array<Scalars['Int']>>;
  treatBelowRlAsPercent?: InputMaybe<Scalars['Boolean']>;
  unitId?: InputMaybe<Scalars['Int']>;
};

export type MetricWithCalculatedMetric = {
  __typename?: 'MetricWithCalculatedMetric';
  belowRlValue?: Maybe<Scalars['Float']>;
  calcClusterId?: Maybe<Scalars['String']>;
  calculated: Scalars['Boolean'];
  calculatedMetric: CalculatedMetric;
  calculationName?: Maybe<Scalars['String']>;
  canBeAveraged: CanBeAveraged;
  canBeCounted: Scalars['Boolean'];
  canBeMaximized: Scalars['Boolean'];
  canBeMinimized: Scalars['Boolean'];
  canBeTotaled: Scalars['Boolean'];
  component?: Maybe<ComponentNest>;
  componentId?: Maybe<Scalars['Int']>;
  copyPreviousValueEnabled: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  dataPointCommentPolicy: DataPointCommentPolicy;
  dataType: MetricDataTypeEnum;
  debug: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  detectionLimit?: Maybe<Scalars['Float']>;
  displayNameBreadcrumbs?: Maybe<Array<Breadcrumb>>;
  expression?: Maybe<Scalars['String']>;
  hideFromDataEntry: Scalars['Boolean'];
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  interpolated: Scalars['Boolean'];
  intervals?: Maybe<Array<IntervalNest>>;
  isDecreasing: Scalars['Boolean'];
  isIncreasing: Scalars['Boolean'];
  isLockedByWaterly: Scalars['Boolean'];
  isReportComments: Scalars['Boolean'];
  isWaterlyConnected: Scalars['Boolean'];
  keynameId?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['BigInt']>;
  metricKeyname?: Maybe<MetricKeyname>;
  metricRangeType?: Maybe<MetricRangeType>;
  metricRanges: Array<MetricRange>;
  minValue?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  order: Scalars['Int'];
  precision?: Maybe<Scalars['Int']>;
  process?: Maybe<ProcessNest>;
  processId: Scalars['Int'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMin?: Maybe<Scalars['Float']>;
  reportingLimit?: Maybe<Scalars['Float']>;
  required: Scalars['Boolean'];
  treatBelowRlAsPercent: Scalars['Boolean'];
  unit?: Maybe<UnitNest>;
  unitId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatesPriorDay: Scalars['Boolean'];
};


export type MetricWithCalculatedMetricCalcClusterIdArgs = {
  includeCalcClusterId?: InputMaybe<Scalars['Boolean']>;
};

export type MetricWithCalculatedMetrics = {
  __typename?: 'MetricWithCalculatedMetrics';
  belowRlValue?: Maybe<Scalars['Float']>;
  calcClusterId?: Maybe<Scalars['String']>;
  calculated: Scalars['Boolean'];
  calculationName?: Maybe<Scalars['String']>;
  canBeAveraged: CanBeAveraged;
  canBeCounted: Scalars['Boolean'];
  canBeMaximized: Scalars['Boolean'];
  canBeMinimized: Scalars['Boolean'];
  canBeTotaled: Scalars['Boolean'];
  component?: Maybe<ComponentNest>;
  componentId?: Maybe<Scalars['Int']>;
  copyPreviousValueEnabled: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  dataPointCommentPolicy: DataPointCommentPolicy;
  dataType: MetricDataTypeEnum;
  debug: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  detectionLimit?: Maybe<Scalars['Float']>;
  displayNameBreadcrumbs?: Maybe<Array<Breadcrumb>>;
  downstreamCalcCount: Scalars['Int'];
  expression?: Maybe<Scalars['String']>;
  hideFromDataEntry: Scalars['Boolean'];
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  interpolated: Scalars['Boolean'];
  intervals?: Maybe<Array<IntervalNest>>;
  isDecreasing: Scalars['Boolean'];
  isIncreasing: Scalars['Boolean'];
  isLockedByWaterly: Scalars['Boolean'];
  isReportComments: Scalars['Boolean'];
  isWaterlyConnected: Scalars['Boolean'];
  keynameId?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['BigInt']>;
  metricKeyname?: Maybe<MetricKeyname>;
  metricRangeType?: Maybe<MetricRangeType>;
  metricRanges: Array<MetricRange>;
  minValue?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  order: Scalars['Int'];
  precision?: Maybe<Scalars['Int']>;
  process?: Maybe<ProcessNest>;
  processId: Scalars['Int'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMin?: Maybe<Scalars['Float']>;
  reportingLimit?: Maybe<Scalars['Float']>;
  required: Scalars['Boolean'];
  treatBelowRlAsPercent: Scalars['Boolean'];
  unit?: Maybe<UnitNest>;
  unitId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatesPriorDay: Scalars['Boolean'];
};


export type MetricWithCalculatedMetricsCalcClusterIdArgs = {
  includeCalcClusterId?: InputMaybe<Scalars['Boolean']>;
};

export type MetricWithRelatedMetrics = {
  __typename?: 'MetricWithRelatedMetrics';
  belowRlValue?: Maybe<Scalars['Float']>;
  calcClusterId?: Maybe<Scalars['String']>;
  calculated: Scalars['Boolean'];
  calculatedMetrics: Array<CalculatedMetric>;
  calculationName?: Maybe<Scalars['String']>;
  canBeAveraged: CanBeAveraged;
  canBeCounted: Scalars['Boolean'];
  canBeMaximized: Scalars['Boolean'];
  canBeMinimized: Scalars['Boolean'];
  canBeTotaled: Scalars['Boolean'];
  component?: Maybe<ComponentNest>;
  componentId?: Maybe<Scalars['Int']>;
  copyPreviousValueEnabled: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  dataPointCommentPolicy: DataPointCommentPolicy;
  dataType: MetricDataTypeEnum;
  debug: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  detectionLimit?: Maybe<Scalars['Float']>;
  displayNameBreadcrumbs?: Maybe<Array<Breadcrumb>>;
  expression?: Maybe<Scalars['String']>;
  hideFromDataEntry: Scalars['Boolean'];
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  interpolated: Scalars['Boolean'];
  intervals?: Maybe<Array<IntervalNest>>;
  isDecreasing: Scalars['Boolean'];
  isIncreasing: Scalars['Boolean'];
  isLockedByWaterly: Scalars['Boolean'];
  isReportComments: Scalars['Boolean'];
  isWaterlyConnected: Scalars['Boolean'];
  keynameId?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['BigInt']>;
  metricKeyname?: Maybe<MetricKeyname>;
  metricRangeType?: Maybe<MetricRangeType>;
  metricRanges: Array<MetricRange>;
  minValue?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  order: Scalars['Int'];
  precision?: Maybe<Scalars['Int']>;
  process?: Maybe<ProcessNest>;
  processId: Scalars['Int'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMin?: Maybe<Scalars['Float']>;
  reportingLimit?: Maybe<Scalars['Float']>;
  required: Scalars['Boolean'];
  sourceMetrics: Array<CalculatedMetric>;
  treatBelowRlAsPercent: Scalars['Boolean'];
  unit?: Maybe<UnitNest>;
  unitId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatesPriorDay: Scalars['Boolean'];
};


export type MetricWithRelatedMetricsCalcClusterIdArgs = {
  includeCalcClusterId?: InputMaybe<Scalars['Boolean']>;
};

export type MetricWithReportData = {
  __typename?: 'MetricWithReportData';
  enabledForReport: Scalars['Boolean'];
  enabledIntervalId?: Maybe<Scalars['Int']>;
  metricId: Scalars['Int'];
};

export type MetricWithSpcIntervalsUnit = {
  __typename?: 'MetricWithSPCIntervalsUnit';
  belowRlValue?: Maybe<Scalars['Float']>;
  calcClusterId?: Maybe<Scalars['String']>;
  calculated: Scalars['Boolean'];
  calculationName?: Maybe<Scalars['String']>;
  canBeAveraged: CanBeAveraged;
  canBeCounted: Scalars['Boolean'];
  canBeMaximized: Scalars['Boolean'];
  canBeMinimized: Scalars['Boolean'];
  canBeTotaled: Scalars['Boolean'];
  component?: Maybe<ComponentNest>;
  componentId?: Maybe<Scalars['Int']>;
  copyPreviousValueEnabled: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  dataPointCommentPolicy: DataPointCommentPolicy;
  dataType: MetricDataTypeEnum;
  debug: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  detectionLimit?: Maybe<Scalars['Float']>;
  displayName: Scalars['String'];
  displayNameBreadcrumbs?: Maybe<Array<Breadcrumb>>;
  expression?: Maybe<Scalars['String']>;
  hideFromDataEntry: Scalars['Boolean'];
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  interpolated: Scalars['Boolean'];
  intervals?: Maybe<Array<IntervalNest>>;
  isDecreasing: Scalars['Boolean'];
  isIncreasing: Scalars['Boolean'];
  isLockedByWaterly: Scalars['Boolean'];
  isReportComments: Scalars['Boolean'];
  isWaterlyConnected: Scalars['Boolean'];
  keynameId?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['BigInt']>;
  metricKeyname?: Maybe<MetricKeyname>;
  metricRangeType?: Maybe<MetricRangeType>;
  metricRanges: Array<MetricRange>;
  minValue?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  order: Scalars['Int'];
  precision?: Maybe<Scalars['Int']>;
  process: ProcessNest;
  processId: Scalars['Int'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMin?: Maybe<Scalars['Float']>;
  reportingLimit?: Maybe<Scalars['Float']>;
  required: Scalars['Boolean'];
  site: SiteNest;
  treatBelowRlAsPercent: Scalars['Boolean'];
  unit?: Maybe<UnitNest>;
  unitId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatesPriorDay: Scalars['Boolean'];
};


export type MetricWithSpcIntervalsUnitCalcClusterIdArgs = {
  includeCalcClusterId?: InputMaybe<Scalars['Boolean']>;
};

export type MetricsBySystemIdsInput = {
  componentId?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  nameOrId?: InputMaybe<Scalars['String']>;
  processId?: InputMaybe<Scalars['Int']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemIds: Array<Scalars['Int']>;
};

export type MetricsInput = {
  includeIntervalMetrics?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: MetricsWhere;
};

export type MetricsUpdateInput = {
  inputs: Array<MetricUpdateInput>;
};

export type MetricsWhere = {
  componentId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  internalKeyname?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  processId?: InputMaybe<Scalars['Int']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId: Scalars['Int'];
};

export type MetricsWithDownstreamCalcCountsInput = {
  componentId?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
};

export type MigrateSiteDataToTimeSeriesInput = {
  siteId: Scalars['Int'];
};

export type MigrateSiteDataToTimeSeriesResult = {
  __typename?: 'MigrateSiteDataToTimeSeriesResult';
  id: Scalars['Int'];
  success: Scalars['Boolean'];
};

export type MintedApiTokenCredentialsNest = {
  __typename?: 'MintedApiTokenCredentialsNest';
  realm: Scalars['String'];
  secret: Scalars['String'];
  username: Scalars['String'];
};

export enum MoveDirectionEnum {
  Down = 'DOWN',
  Up = 'UP'
}

export type Mutation = {
  __typename?: 'Mutation';
  addActivitySchedule: ActivitySchedule;
  addEdgeDevice: EdgeDeviceNest;
  addLicense: LicenseNest;
  addNewReportDefinition: ReportDefinitionNest;
  addPhoneNumber: PhoneNumberNest;
  addSSOUserToSystemGroup: UserInfoType;
  addSampleSiteUpload: SampleSiteUpload;
  addScheduledItemUpload: ScheduledItemUpload;
  addSite: SiteType;
  addSiteFlexMetricsToFolder: Array<SiteFlexMetric>;
  addSsoUserToSystem: UserInfoType;
  addSystemFavorite: SystemType;
  addSystemGroup: SystemGroupType;
  addTagMapping: TagMappingType;
  addTrend: TrendNest;
  addUserToSystem?: Maybe<UserInfoType>;
  addUserToSystemGroup: UserInfoType;
  archiveBySampleSiteId?: Maybe<SampleSiteUpload>;
  archiveByScheduledItemId?: Maybe<ScheduledItemUpload>;
  archiveConstantDefinition: ConstantDefinition;
  archiveConstantValue: ConstantValue;
  archiveLabImportBatch: Scalars['Boolean'];
  archiveLabImportProfile: Scalars['Boolean'];
  archiveReportDistributionList: ReportDistributionList;
  archiveReportingReportGroup: ReportingReportGroupNest;
  archiveSampleCollectionComment: SuccessResponse;
  archiveSampleSchedule?: Maybe<SampleSchedule>;
  archiveScheduledItemComment: SuccessResponse;
  archiveScheduledItems: Array<ScheduledItem>;
  archiveUpload: Upload;
  archiveWeatherDataStation: WeatherDataStationNest;
  cancelActivitySchedule: ActivitySchedule;
  cancelSampleSchedule: SampleSchedule;
  clearRuntimeLoggerOverride: SuccessResponse;
  clearSSOCache: Scalars['Boolean'];
  cloneComponents: Array<ClonedComponentPayload>;
  cloneMetrics: Array<MetricNest>;
  cloneProcesses: Array<ClonedProcessPayload>;
  cloneSites: Array<SiteNest>;
  cloneSystem: Array<SystemNest>;
  cloneSystemWithSelectedDescendants: Array<SystemNest>;
  cloneToTarget: SuccessResponse;
  commitDirtyDataPoints: Array<Maybe<MetricDataPointType>>;
  commitLabImportBatch: LabImportCommitResult;
  convertToFlexReport: ReportDefinitionNest;
  createAddress: Address;
  createAnalyteGroup: AnalyteGroup;
  createApiToken: CreateApiTokenPayloadNest;
  createCalcClusterDebugByClusterId: CalcClusterDebug;
  createColumnGroup: ColumnGroup;
  createColumnGroupItems: Array<ColumnGroupItem>;
  createColumnGroupsAndItems: SuccessResponse;
  createComponent: ComponentNest;
  createConstantDefinition: ConstantDefinition;
  createEnterpriseReportShareLink: CreateEnterpriseReportShareLinkPayload;
  createEntryIntervals: Array<IntervalNest>;
  createFlexFormFromSystem: SiteNest;
  createFolder: BaseFolder;
  createInterval: IntervalNest;
  createIntervals: Array<IntervalNest>;
  createLabImportBatch: LabImportBatch;
  createLogBookEntry: LogBookEntryNest;
  createLogBookEntryDashboardView: LogBookEntryDashboardViewNest;
  createMetric: MetricNest;
  createMetricKeyname: MetricKeyname;
  createNotification: Notification;
  createOrganizationIntegration: OrganizationIntegrationNest;
  createPermit: Permit;
  createPhrase: Phrase;
  createProcess: ProcessNest;
  createReportDistributionList: ReportDistributionList;
  createReportingReportGroup: ReportingReportGroupNest;
  createRoundsShiftNote: RoundsShiftNoteCreateResult;
  createSampleCollection: SampleCollection;
  createSampleCollectionComment: SampleCollectionComment;
  createSampleCollectionCustody: Array<SampleCollectionCustody>;
  createSampleSchedule: SampleSchedule;
  createSampleSite: SampleSite;
  createScheduledItemComment: ScheduledItemComment;
  createSystem: SystemNest;
  createTag: Tag;
  createUnit: UnitNest;
  createUpload: Upload;
  createWeatherDataStation: WeatherDataStationNest;
  deleteActivitySchedule?: Maybe<ActivitySchedule>;
  deleteColumnGroupItem: SuccessResponse;
  deleteComponent: SuccessResponse;
  deleteFolder: SuccessResponse;
  deleteInterval?: Maybe<Interval>;
  deleteLicense?: Maybe<LicenseNest>;
  deleteLogBookEntry: SuccessResponse;
  deleteLogBookEntryDashboardView: SuccessResponse;
  deleteMetric: SuccessResponse;
  deleteMetricKeyname: SuccessResponse;
  deleteMetricRange: SuccessResponse;
  deleteNotification: SuccessResponse;
  deleteOrganizationIntegration: SuccessResponse;
  deletePermit: SuccessResponse;
  deletePhoneNumber: PhoneNumberNest;
  deletePhrase: SuccessResponse;
  deleteProcess: SuccessResponse;
  deleteReportDefinitionById: Scalars['Boolean'];
  deleteReportNodes: SuccessResponse;
  deleteSite: SuccessResponse;
  deleteSiteFlexMetric: SuccessResponse;
  deleteSystem: SuccessResponse;
  deleteSystemFavorite: SystemType;
  deleteSystemGroup?: Maybe<SystemGroupType>;
  deleteTag: SuccessResponse;
  deleteTagMapping?: Maybe<TagMappingType>;
  deleteTrend: TrendNest;
  deleteUnit: SuccessResponse;
  deleteUserFromSystem: Array<Maybe<UserInfoType>>;
  disableEnterpriseReportShareLink: EnterpriseReportShareLink;
  initSSOUser: UserInfoType;
  migrateSiteDataToTimeSeries: MigrateSiteDataToTimeSeriesResult;
  recalculateMetric: MetricType;
  reconcileLabImportBatch: LabImportCommitResult;
  removeUserFromSystemGroup: UserInfoType;
  replayWaterlyConnectSubmission: EdgeDeviceSubmission;
  requestEnterpriseReportShareLinkAccess: EnterpriseReportShareLinkAccessRequestPayload;
  requestId?: Maybe<Scalars['String']>;
  resolveLabImportReconciliation: LabImportBatch;
  restoreComponent: SuccessResponse;
  restoreConstantDefinition: ConstantDefinition;
  restoreConstantValue: ConstantValue;
  restoreFolder: SuccessResponse;
  restoreMetric: SuccessResponse;
  restoreProcess: SuccessResponse;
  restoreSite: SuccessResponse;
  restoreSiteFlexMetric: SuccessResponse;
  restoreWeatherDataStation: WeatherDataStationNest;
  revokeApiToken: ApiTokenNest;
  sendEmailVerification: UserInfoType;
  sendManualReportEmail: SendManualReportEmailPayload;
  setRuntimeLoggerOverride: RuntimeLoggerOverride;
  snoozeAllOrgRetentionRisks: Array<RetentionRiskNest>;
  snoozeRetentionRisk?: Maybe<RetentionRiskNest>;
  startMirroring: SiteNest;
  stopMirroring: SiteNest;
  submitConstantRecalculation: ConstantRecalculationEstimate;
  submitSiteRecalculation: RecalculatedMetricsResult;
  transferComponent: SuccessResponse;
  transferMetric: SuccessResponse;
  transferMetricToFolder: SuccessResponse;
  transferSystem: SystemNest;
  triggerAnalyticsReportSnapshot: ReportSnapshot;
  triggerMetricRangeEmails: SuccessResponse;
  updateActivitySchedule: ActivitySchedule;
  updateAddress?: Maybe<Address>;
  updateAnalyteGroup: AnalyteGroup;
  updateCalcClusterDebug: CalcClusterDebug;
  updateColumnGroup: ColumnGroup;
  updateColumnGroupItem: ColumnGroupItem;
  updateComponents: Array<ComponentNest>;
  updateConstantDefinition: ConstantDefinition;
  updateEdgeDevice: EdgeDeviceNest;
  updateEnterpriseReportShareLink: UpdateEnterpriseReportShareLinkPayload;
  updateFolder: BaseFolder;
  updateFolders: Array<BaseFolder>;
  updateLicense: LicenseNest;
  updateLogBookEntry: LogBookEntryNest;
  updateLogBookEntryDashboardView: LogBookEntryDashboardViewNest;
  updateMetric: MetricNest;
  updateMetricForReport: ReportDefinition;
  updateMetricKeyname: MetricKeyname;
  updateMetrics: Array<MetricNest>;
  updateNotification: Notification;
  updateOrganization?: Maybe<OrganizationNest>;
  updateOrganizationIntegration: OrganizationIntegrationNest;
  updatePermit: Permit;
  updatePhoneNumber: PhoneNumberNest;
  updatePhrase: Phrase;
  updateProcessForReport: ReportDefinition;
  updateProcesses: Array<ProcessNest>;
  updateReportDefinition: ReportDefinition;
  updateReportDistributionList: ReportDistributionList;
  updateReportNodes: Array<ReportNode>;
  updateReportingReportDefinitionGroups: Scalars['Boolean'];
  updateReportingReportGroup: ReportingReportGroupNest;
  updateSampleCollection: SampleCollection;
  updateSampleCollectionComment: SampleCollectionComment;
  updateSampleSchedule: SampleSchedule;
  updateSampleSite: SampleSite;
  updateScheduleItemsBySourceScheduleId: Array<ScheduledItem>;
  updateScheduledItem: ScheduledItem;
  updateScheduledItemComment: ScheduledItemComment;
  updateSite: SiteNest;
  updateSiteFlexMetric: SiteFlexMetric;
  updateSiteFlexMetrics: Array<SiteFlexMetric>;
  updateSiteStructure: SiteType;
  updateSites: Array<SiteNest>;
  updateSystem: SystemNest;
  updateSystemGroup: SystemGroupType;
  updateTag: Tag;
  updateTrend: TrendNest;
  updateUnit: UnitNest;
  updateUpload: Upload;
  updateUser: UserInfoType;
  updateUserByToken: UserInfoType;
  updateUserRoleForSystem: Array<Maybe<UserInfoType>>;
  updateUserRoleForSystemGroup: UserInfoType;
  updateWeatherDataStation: WeatherDataStationNest;
  updatedRetentionRiskForOrgs: SuccessResponse;
  upsertConstantValue: ConstantValue;
  upsertDataEntryCompletion: DataEntryCompletion;
  upsertMetricRanges: Array<MetricRange>;
  validateLabImportBatch: LabImportBatch;
  validateLabImportProfile: LabImportProfileValidation;
};


export type MutationAddActivityScheduleArgs = {
  input: ActivityScheduleAddInput;
};


export type MutationAddEdgeDeviceArgs = {
  input: AddEdgeDeviceNestInput;
};


export type MutationAddLicenseArgs = {
  input: AddLicenseInput;
};


export type MutationAddNewReportDefinitionArgs = {
  input: ReportDefinitionCreateInput;
};


export type MutationAddPhoneNumberArgs = {
  input: AddPhoneNumberInput;
};


export type MutationAddSsoUserToSystemGroupArgs = {
  input: AddSsoUserToSystemGroupInput;
};


export type MutationAddSampleSiteUploadArgs = {
  input: AddSampleSiteUploadInput;
};


export type MutationAddScheduledItemUploadArgs = {
  input: AddScheduledItemUploadInput;
};


export type MutationAddSiteArgs = {
  input: AddSiteInput;
};


export type MutationAddSiteFlexMetricsToFolderArgs = {
  input: AddSiteFlexMetricsToFolderInput;
};


export type MutationAddSsoUserToSystemArgs = {
  input: AddSsoUserToSystemTypeInput;
};


export type MutationAddSystemFavoriteArgs = {
  input: AddSystemFavoriteInput;
};


export type MutationAddSystemGroupArgs = {
  input: AddSystemGroupInput;
};


export type MutationAddTagMappingArgs = {
  input: AddTagMappingInput;
};


export type MutationAddTrendArgs = {
  input: AddTrendInput;
};


export type MutationAddUserToSystemArgs = {
  input: AddUserToSystemInput;
};


export type MutationAddUserToSystemGroupArgs = {
  input: AddUserToSystemGroupInput;
};


export type MutationArchiveBySampleSiteIdArgs = {
  input: ArchiveSampleSiteUploadInput;
};


export type MutationArchiveByScheduledItemIdArgs = {
  input: ArchiveScheduledItemUploadInput;
};


export type MutationArchiveConstantDefinitionArgs = {
  input: ArchiveConstantDefinitionInput;
};


export type MutationArchiveConstantValueArgs = {
  input: ArchiveConstantValueInput;
};


export type MutationArchiveLabImportBatchArgs = {
  id: Scalars['UUID'];
};


export type MutationArchiveLabImportProfileArgs = {
  id: Scalars['UUID'];
};


export type MutationArchiveReportDistributionListArgs = {
  input: ArchiveReportDistributionListInput;
};


export type MutationArchiveReportingReportGroupArgs = {
  input: ArchiveReportingReportGroupInput;
};


export type MutationArchiveSampleCollectionCommentArgs = {
  input: SampleCollectionCommentArchiveInput;
};


export type MutationArchiveSampleScheduleArgs = {
  input: ArchiveSampleScheduleInput;
};


export type MutationArchiveScheduledItemCommentArgs = {
  input: ArchiveScheduledItemCommentInput;
};


export type MutationArchiveScheduledItemsArgs = {
  input: ArchiveScheduledItemsInput;
};


export type MutationArchiveUploadArgs = {
  input: ArchiveUploadInput;
};


export type MutationArchiveWeatherDataStationArgs = {
  input: WeatherDataStationIdInput;
};


export type MutationCancelActivityScheduleArgs = {
  input: ActivityScheduleCancelInput;
};


export type MutationCancelSampleScheduleArgs = {
  input: CancelSampleScheduleInput;
};


export type MutationClearRuntimeLoggerOverrideArgs = {
  name: Scalars['String'];
};


export type MutationCloneComponentsArgs = {
  input: CloneComponentsInput;
};


export type MutationCloneMetricsArgs = {
  input: CloneMetricsInput;
};


export type MutationCloneProcessesArgs = {
  input: CloneProcessesInput;
};


export type MutationCloneSitesArgs = {
  input: CloneSitesInput;
};


export type MutationCloneSystemArgs = {
  input: CloneSystemInput;
};


export type MutationCloneSystemWithSelectedDescendantsArgs = {
  input: CloneSystemWithSelectedDescendantsInput;
};


export type MutationCloneToTargetArgs = {
  input: CloneToTargetInput;
};


export type MutationCommitDirtyDataPointsArgs = {
  input: CommitDirtyDataPointsInput;
};


export type MutationCommitLabImportBatchArgs = {
  input: CommitLabImportBatchInput;
};


export type MutationConvertToFlexReportArgs = {
  reportDefinitionId: Scalars['Int'];
};


export type MutationCreateAddressArgs = {
  input: CreateAddressInput;
};


export type MutationCreateAnalyteGroupArgs = {
  input: AnalyteGroupCreateInput;
};


export type MutationCreateApiTokenArgs = {
  input: CreateApiTokenInput;
};


export type MutationCreateCalcClusterDebugByClusterIdArgs = {
  input: CreateCalcClusterDebugInput;
};


export type MutationCreateColumnGroupArgs = {
  input: CreateColumnGroupInput;
};


export type MutationCreateColumnGroupItemsArgs = {
  input: CreateColumnGroupItemsInput;
};


export type MutationCreateColumnGroupsAndItemsArgs = {
  input: CreateColumnGroupsAndItemsInput;
};


export type MutationCreateComponentArgs = {
  input: ComponentCreateInput;
};


export type MutationCreateConstantDefinitionArgs = {
  input: CreateConstantDefinitionInput;
};


export type MutationCreateEnterpriseReportShareLinkArgs = {
  input: CreateEnterpriseReportShareLinkInput;
};


export type MutationCreateEntryIntervalsArgs = {
  input: Array<EntryIntervalCreateInput>;
};


export type MutationCreateFlexFormFromSystemArgs = {
  input: CreateFlexFormFromSystemInput;
};


export type MutationCreateFolderArgs = {
  input: CreateFolderInput;
};


export type MutationCreateIntervalArgs = {
  input: CreateIntervalInput;
};


export type MutationCreateIntervalsArgs = {
  input: CreateIntervalsInput;
};


export type MutationCreateLabImportBatchArgs = {
  input: CreateLabImportBatchInput;
};


export type MutationCreateLogBookEntryArgs = {
  input: CreateLogBookEntryInput;
};


export type MutationCreateLogBookEntryDashboardViewArgs = {
  input: CreateLogBookEntryDashboardViewInput;
};


export type MutationCreateMetricArgs = {
  input: MetricCreateInput;
};


export type MutationCreateMetricKeynameArgs = {
  input: MetricKeynameCreateInput;
};


export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


export type MutationCreateOrganizationIntegrationArgs = {
  input: CreateOrganizationIntegrationInput;
};


export type MutationCreatePermitArgs = {
  input: PermitCreateInput;
};


export type MutationCreatePhraseArgs = {
  input: CreatePhraseInput;
};


export type MutationCreateProcessArgs = {
  input: ProcessCreateInput;
};


export type MutationCreateReportDistributionListArgs = {
  input: CreateReportDistributionListInput;
};


export type MutationCreateReportingReportGroupArgs = {
  input: CreateReportingReportGroupInput;
};


export type MutationCreateRoundsShiftNoteArgs = {
  input: CreateRoundsShiftNoteInput;
};


export type MutationCreateSampleCollectionArgs = {
  input: SampleCollectionCreateInput;
};


export type MutationCreateSampleCollectionCommentArgs = {
  input: SampleCollectionCommentCreateInput;
};


export type MutationCreateSampleCollectionCustodyArgs = {
  input: SampleCollectionCustodyCreateInput;
};


export type MutationCreateSampleScheduleArgs = {
  input: CreateSampleScheduleInput;
};


export type MutationCreateSampleSiteArgs = {
  input: SampleSiteCreateInput;
};


export type MutationCreateScheduledItemCommentArgs = {
  input: CreateScheduledItemCommentInput;
};


export type MutationCreateSystemArgs = {
  input: CreateSystemInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateUnitArgs = {
  input: UnitCreateInput;
};


export type MutationCreateUploadArgs = {
  input: CreateUploadInput;
};


export type MutationCreateWeatherDataStationArgs = {
  input: CreateWeatherDataStationInput;
};


export type MutationDeleteActivityScheduleArgs = {
  id: Scalars['String'];
};


export type MutationDeleteColumnGroupItemArgs = {
  input: DeleteColumnGroupItemInput;
};


export type MutationDeleteComponentArgs = {
  input: DeleteComponentInput;
};


export type MutationDeleteFolderArgs = {
  input: DeleteFolderInput;
};


export type MutationDeleteIntervalArgs = {
  input: DeleteIntervalInput;
};


export type MutationDeleteLicenseArgs = {
  input: DeleteLicenseInput;
};


export type MutationDeleteLogBookEntryArgs = {
  input: DeleteLogBookEntryInput;
};


export type MutationDeleteLogBookEntryDashboardViewArgs = {
  input: DeleteLogBookEntryDashboardViewInput;
};


export type MutationDeleteMetricArgs = {
  input: DeleteMetricInput;
};


export type MutationDeleteMetricKeynameArgs = {
  input: MetricKeynameDeleteInput;
};


export type MutationDeleteMetricRangeArgs = {
  input: DeleteMetricRangeInput;
};


export type MutationDeleteNotificationArgs = {
  input: DeleteNotificationInput;
};


export type MutationDeleteOrganizationIntegrationArgs = {
  input: DeleteOrganizationIntegrationInput;
};


export type MutationDeletePermitArgs = {
  input: DeletePermitInput;
};


export type MutationDeletePhoneNumberArgs = {
  input: DeletePhoneNumberInput;
};


export type MutationDeletePhraseArgs = {
  input: DeletePhraseInput;
};


export type MutationDeleteProcessArgs = {
  input: DeleteProcessInput;
};


export type MutationDeleteReportDefinitionByIdArgs = {
  input: DeleteReportDefinitionByIdInput;
};


export type MutationDeleteReportNodesArgs = {
  input: DeleteReportNodesInput;
};


export type MutationDeleteSiteArgs = {
  input: DeleteSiteInput;
};


export type MutationDeleteSiteFlexMetricArgs = {
  input: SiteFlexMetricDeleteInput;
};


export type MutationDeleteSystemArgs = {
  input: DeleteSystemInput;
};


export type MutationDeleteSystemFavoriteArgs = {
  input: DeleteSystemFavoriteInput;
};


export type MutationDeleteSystemGroupArgs = {
  input: DeleteSystemGroupInput;
};


export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};


export type MutationDeleteTagMappingArgs = {
  input: DeleteTagMappingInput;
};


export type MutationDeleteTrendArgs = {
  input: DeleteTrendInput;
};


export type MutationDeleteUnitArgs = {
  input: DeleteUnitInput;
};


export type MutationDeleteUserFromSystemArgs = {
  input: DeleteUserFromSystemInput;
};


export type MutationDisableEnterpriseReportShareLinkArgs = {
  input: DisableEnterpriseReportShareLinkInput;
};


export type MutationMigrateSiteDataToTimeSeriesArgs = {
  input: MigrateSiteDataToTimeSeriesInput;
};


export type MutationRecalculateMetricArgs = {
  input: RecalculateMetricInput;
};


export type MutationReconcileLabImportBatchArgs = {
  input: ReconcileLabImportBatchInput;
};


export type MutationRemoveUserFromSystemGroupArgs = {
  input: RemoveUserFromSystemGroupInput;
};


export type MutationReplayWaterlyConnectSubmissionArgs = {
  submissionId: Scalars['Int'];
};


export type MutationRequestEnterpriseReportShareLinkAccessArgs = {
  input: RequestEnterpriseReportShareLinkAccessInput;
};


export type MutationResolveLabImportReconciliationArgs = {
  input: ResolveLabImportReconciliationInput;
};


export type MutationRestoreComponentArgs = {
  input: RestoreComponentInput;
};


export type MutationRestoreConstantDefinitionArgs = {
  input: RestoreConstantDefinitionInput;
};


export type MutationRestoreConstantValueArgs = {
  input: RestoreConstantValueInput;
};


export type MutationRestoreFolderArgs = {
  input: RestoreFolderInput;
};


export type MutationRestoreMetricArgs = {
  input: RestoreMetricInput;
};


export type MutationRestoreProcessArgs = {
  input: RestoreProcessInput;
};


export type MutationRestoreSiteArgs = {
  input: RestoreSiteInput;
};


export type MutationRestoreSiteFlexMetricArgs = {
  input: SiteFlexMetricRestoreInput;
};


export type MutationRestoreWeatherDataStationArgs = {
  input: WeatherDataStationIdInput;
};


export type MutationRevokeApiTokenArgs = {
  input: RevokeApiTokenInput;
};


export type MutationSendEmailVerificationArgs = {
  userId: Scalars['Int'];
};


export type MutationSendManualReportEmailArgs = {
  input: SendManualReportEmailInput;
};


export type MutationSetRuntimeLoggerOverrideArgs = {
  input: SetRuntimeLoggerOverrideInput;
};


export type MutationSnoozeAllOrgRetentionRisksArgs = {
  input: SnoozeAllOrgRetentionRisksInput;
};


export type MutationSnoozeRetentionRiskArgs = {
  input: SnoozeRetentionRiskInput;
};


export type MutationStartMirroringArgs = {
  input: StartMirroringInput;
};


export type MutationStopMirroringArgs = {
  input: StopMirroringInput;
};


export type MutationSubmitConstantRecalculationArgs = {
  input: ConstantRecalculationInput;
};


export type MutationSubmitSiteRecalculationArgs = {
  input: SubmitSiteRecalculationInput;
};


export type MutationTransferComponentArgs = {
  input: TransferComponentInput;
};


export type MutationTransferMetricArgs = {
  input: TransferMetricInput;
};


export type MutationTransferMetricToFolderArgs = {
  input: TransferMetricToFolderInput;
};


export type MutationTransferSystemArgs = {
  input: TransferSystemInput;
};


export type MutationTriggerAnalyticsReportSnapshotArgs = {
  input: TriggerAnalyticsReportSnapshotInput;
};


export type MutationUpdateActivityScheduleArgs = {
  input: ActivityScheduleUpdateInput;
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateAnalyteGroupArgs = {
  input: AnalyteGroupUpdateInput;
};


export type MutationUpdateCalcClusterDebugArgs = {
  input: CalcClusterDebugUpdateInput;
};


export type MutationUpdateColumnGroupArgs = {
  input: UpdateColumnGroupInput;
};


export type MutationUpdateColumnGroupItemArgs = {
  input: UpdateColumnGroupItemInput;
};


export type MutationUpdateComponentsArgs = {
  input: UpdateComponentsInput;
};


export type MutationUpdateConstantDefinitionArgs = {
  input: UpdateConstantDefinitionInput;
};


export type MutationUpdateEdgeDeviceArgs = {
  input: UpdateEdgeDeviceNestInput;
};


export type MutationUpdateEnterpriseReportShareLinkArgs = {
  input: UpdateEnterpriseReportShareLinkInput;
};


export type MutationUpdateFolderArgs = {
  input: UpdateFolderInput;
};


export type MutationUpdateFoldersArgs = {
  input: UpdateFoldersInput;
};


export type MutationUpdateLicenseArgs = {
  input: UpdateLicenseInput;
};


export type MutationUpdateLogBookEntryArgs = {
  input: UpdateLogBookEntryInput;
};


export type MutationUpdateLogBookEntryDashboardViewArgs = {
  input: UpdateLogBookEntryDashboardViewInput;
};


export type MutationUpdateMetricArgs = {
  input: MetricUpdateInput;
};


export type MutationUpdateMetricForReportArgs = {
  input: UpdateMetricForReportInput;
};


export type MutationUpdateMetricKeynameArgs = {
  input: MetricKeynameUpdateInput;
};


export type MutationUpdateMetricsArgs = {
  input: MetricsUpdateInput;
};


export type MutationUpdateNotificationArgs = {
  input: UpdateNotificationInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationIntegrationArgs = {
  input: UpdateOrganizationIntegrationInput;
};


export type MutationUpdatePermitArgs = {
  input: PermitUpdateInput;
};


export type MutationUpdatePhoneNumberArgs = {
  input: UpdatePhoneNumberInput;
};


export type MutationUpdatePhraseArgs = {
  input: UpdatePhraseInput;
};


export type MutationUpdateProcessForReportArgs = {
  input: UpdateProcessForReportInput;
  reportDefinitionId: Scalars['Int'];
};


export type MutationUpdateProcessesArgs = {
  input: UpdateProcessesInput;
};


export type MutationUpdateReportDefinitionArgs = {
  input: UpdateReportDefinitionInput;
};


export type MutationUpdateReportDistributionListArgs = {
  input: UpdateReportDistributionListInput;
};


export type MutationUpdateReportNodesArgs = {
  input: UpdateReportNodesInput;
};


export type MutationUpdateReportingReportDefinitionGroupsArgs = {
  input: UpdateReportingReportDefinitionGroupsInput;
};


export type MutationUpdateReportingReportGroupArgs = {
  input: UpdateReportingReportGroupInput;
};


export type MutationUpdateSampleCollectionArgs = {
  input: SampleCollectionUpdateInput;
};


export type MutationUpdateSampleCollectionCommentArgs = {
  input: SampleCollectionCommentUpdateInput;
};


export type MutationUpdateSampleScheduleArgs = {
  input: UpdateSampleScheduleInput;
};


export type MutationUpdateSampleSiteArgs = {
  input: SampleSiteUpdateInput;
};


export type MutationUpdateScheduleItemsBySourceScheduleIdArgs = {
  input: ActivityScheduleUpdateInput;
};


export type MutationUpdateScheduledItemArgs = {
  input: UpdateScheduledItemInput;
};


export type MutationUpdateScheduledItemCommentArgs = {
  input: UpdateScheduledItemCommentInput;
};


export type MutationUpdateSiteArgs = {
  input: SiteUpdateInput;
};


export type MutationUpdateSiteFlexMetricArgs = {
  input: SiteFlexMetricUpdateInput;
};


export type MutationUpdateSiteFlexMetricsArgs = {
  input: SiteFlexMetricsUpdateInput;
};


export type MutationUpdateSiteStructureArgs = {
  input: UpdateSiteStructureInput;
};


export type MutationUpdateSitesArgs = {
  input: UpdateSitesInput;
};


export type MutationUpdateSystemArgs = {
  input: UpdateSystemInput;
};


export type MutationUpdateSystemGroupArgs = {
  input: UpdateSystemGroupInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateTrendArgs = {
  input: UpdateTrendInput;
};


export type MutationUpdateUnitArgs = {
  input: UnitUpdateInput;
};


export type MutationUpdateUploadArgs = {
  input: UpdateUploadInput;
};


export type MutationUpdateUserArgs = {
  enableIphoneMetricNumberInput?: InputMaybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationUpdateUserByTokenArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  userToken: Scalars['String'];
  verifyPassword: Scalars['String'];
};


export type MutationUpdateUserRoleForSystemArgs = {
  input: UpdateUserRoleForSystemInput;
};


export type MutationUpdateUserRoleForSystemGroupArgs = {
  input: UpdateUserRoleForSystemGroupInput;
};


export type MutationUpdateWeatherDataStationArgs = {
  input: UpdateWeatherDataStationInput;
};


export type MutationUpsertConstantValueArgs = {
  input: UpsertConstantValueInput;
};


export type MutationUpsertDataEntryCompletionArgs = {
  input: UpsertDataEntryCompletionInput;
};


export type MutationUpsertMetricRangesArgs = {
  input: UpsertMetricRangesInput;
};


export type MutationValidateLabImportBatchArgs = {
  input: ValidateLabImportBatchInput;
};


export type MutationValidateLabImportProfileArgs = {
  input: LabImportProfileDefinitionInput;
};

export enum NavigationDirection {
  Next = 'NEXT',
  Previous = 'PREVIOUS'
}

export type Notification = {
  __typename?: 'Notification';
  active: Scalars['Boolean'];
  appearance: NotificationAppearance;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  dismissable: Scalars['Boolean'];
  displayPosition: NotificationDisplayPosition;
  endDate?: Maybe<Scalars['DateTime']>;
  icon?: Maybe<SelectableIcons>;
  id: Scalars['UUID'];
  message: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  startDate: Scalars['DateTime'];
  systemGroupId?: Maybe<Scalars['Int']>;
  systemId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export enum NotificationAppearance {
  Critical = 'Critical',
  Info = 'Info',
  Neutral = 'Neutral',
  Success = 'Success',
  Warning = 'Warning'
}

export enum NotificationDisplayPosition {
  BottomLeft = 'BottomLeft',
  BottomRight = 'BottomRight',
  Center = 'Center',
  FullBottom = 'FullBottom',
  FullTop = 'FullTop',
  TopLeft = 'TopLeft',
  TopRight = 'TopRight'
}

export type NotificationsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: NotificationsWhere;
};

export type NotificationsWhere = {
  active?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  systemGroupId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
};

export type NotificationsWithCount = {
  __typename?: 'NotificationsWithCount';
  count: Scalars['Int'];
  items: Array<Notification>;
};

export enum OrderDirections {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrderDirectionsNest {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrganizationDateFormat {
  DdMmYyyy = 'DD_MM_YYYY',
  MmDdYyyy = 'MM_DD_YYYY',
  YyyyMmDd = 'YYYY_MM_DD'
}

export type OrganizationIntegrationNest = {
  __typename?: 'OrganizationIntegrationNest';
  createdAt: Scalars['DateTime'];
  credentialsSecretReference: Scalars['String'];
  id: Scalars['Int'];
  integrationType: OrganizationIntegrationType;
  organizationId: Scalars['Int'];
  tokenExpiresAt?: Maybe<Scalars['DateTime']>;
  tokenId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export enum OrganizationIntegrationType {
  Walchem = 'WALCHEM'
}

export type OrganizationNest = {
  __typename?: 'OrganizationNest';
  addresses: Array<Address>;
  dateFormat: OrganizationDateFormat;
  fiscalYearStartDate: Scalars['Date'];
  id: Scalars['Int'];
  idpKey?: Maybe<Scalars['String']>;
  isExternalSystemSearchEnabled: Scalars['Boolean'];
  name: Scalars['String'];
  selfServiceEnabled: Scalars['Boolean'];
};

export type OrganizationType = {
  __typename?: 'OrganizationType';
  addresses: Array<Address>;
  dateFormat: OrganizationDateFormat;
  fiscalYearStartDate: Scalars['Date'];
  id: Scalars['Int'];
  idpKey?: Maybe<Scalars['String']>;
  isExternalSystemSearchEnabled: Scalars['Boolean'];
  isUserDirectoryEnabled: Scalars['Boolean'];
  name: Scalars['String'];
  selfServiceEnabled: Scalars['Boolean'];
  systemGroups: Array<SystemGroupType>;
  systems: Array<SystemType>;
  users: Array<UserInfoType>;
};

export enum PaperOrientationEnum {
  Landscape = 'landscape',
  Portrait = 'portrait'
}

export enum PaperSizeEnum {
  Legal = 'LEGAL',
  Letter = 'LETTER',
  Tabloid = 'TABLOID'
}

export type Permit = {
  __typename?: 'Permit';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isPublicWaterSystemId: Scalars['Boolean'];
  name: Scalars['String'];
  permitCode: Scalars['String'];
  systemId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type PermitCreateInput = {
  isPublicWaterSystemId?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  permitCode: Scalars['String'];
  systemId: Scalars['Int'];
};

export type PermitUpdateInput = {
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  permitCode?: InputMaybe<Scalars['String']>;
};

export type PermitsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: PermitsWhere;
};

export type PermitsWhere = {
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  permitCode?: InputMaybe<Scalars['String']>;
  systemId: Scalars['Int'];
};

export type PhoneNumberNest = {
  __typename?: 'PhoneNumberNest';
  country: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  phoneNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
};

export type Phrase = {
  __typename?: 'Phrase';
  bodyText: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['Int']>;
};

export type PhrasesInput = {
  organizationId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ProcessCreateInput = {
  internalKeyname?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  siteId: Scalars['Int'];
};

export type ProcessNest = {
  __typename?: 'ProcessNest';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  siteId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ProcessType = {
  __typename?: 'ProcessType';
  components: Array<ComponentType>;
  deletedAt?: Maybe<Scalars['TimestampType']>;
  displayName: Scalars['String'];
  enabledForReport?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  metrics: Array<MetricType>;
  name: Scalars['String'];
  order: Scalars['Int'];
  site: SiteType;
  siteId: Scalars['Int'];
  system: SystemType;
};


export type ProcessTypeComponentsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type ProcessTypeEnabledForReportArgs = {
  reportDefinitionId?: InputMaybe<Scalars['Int']>;
};


export type ProcessTypeMetricsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ProcessUpdateInput = {
  id: Scalars['Int'];
  internalKeyname?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type ProcessWithComponentsAndMetrics = {
  __typename?: 'ProcessWithComponentsAndMetrics';
  components: Array<ComponentWithMetrics>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  metrics: Array<MetricWithRelatedMetrics>;
  name: Scalars['String'];
  order: Scalars['Int'];
  siteId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ProcessWithReportData = {
  __typename?: 'ProcessWithReportData';
  enabledForReport: Scalars['Boolean'];
  processId: Scalars['Int'];
};

export type ProcessesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProcessesWhere>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ProcessesWhere = {
  id?: InputMaybe<Scalars['Int']>;
  internalKeyname?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
};

export type PublicWaterSystemIdPermitInput = {
  id?: InputMaybe<Scalars['UUID']>;
  permitCode: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  SampleScheduleAnalytes: SampleScheduleAnalytesWithCount;
  _usersByOrganizationId?: Maybe<UserNest>;
  activeMetricStats: ActiveMetricStats;
  activeUserStats: ActiveUserStats;
  address?: Maybe<Address>;
  adjacentEntryInterval?: Maybe<IntervalNest>;
  adminStats: AdminStats;
  allEdgeDevices: Array<EdgeDeviceType>;
  allSites: Array<SiteNest>;
  analyteGroupById: AnalyteGroup;
  analyteGroups: AnalyteGroupsWithCount;
  analytes: AnalytesWithCount;
  apiTokens: Array<ApiTokenNest>;
  apiTokensByOrganization: Array<ApiTokenNest>;
  auditEventSiteCreated: AuditEventNest;
  auditEvents: Array<AuditEventNest>;
  auditEventsByItemTypeAndItemId: Array<AuditEventNest>;
  auditEventsByMetricId: AuditEventWithCount;
  auditEventsByScheduledItemId: Array<AuditEventNest>;
  bulkMetricEditorFilterOptions: BulkMetricEditorFilterOptions;
  bulkMetricEditorMetrics: BulkMetricEditorMetrics;
  calcClusterDebugByClusterId?: Maybe<CalcClusterDebug>;
  calcClusterDebugLogs: Array<CalcClusterDebugLog>;
  calcClusterDebugs: CalcClusterDebugsWithCount;
  columnGroupById: ColumnGroup;
  columnGroupItemById?: Maybe<ColumnGroupItem>;
  columnGroups: Array<ColumnGroup>;
  columnGroupsWithItems: Array<ColumnGroupWithItems>;
  component: ComponentType;
  componentById: ComponentNest;
  components: Array<ComponentNest>;
  constantDefinitions: Array<ConstantDefinition>;
  constantRecalculationEstimate: ConstantRecalculationEstimate;
  constantsForOrganization: Array<ResolvedConstant>;
  constantsForSystem: Array<ResolvedConstant>;
  dataEntryCompletionsByReportDate: DataEntryCompletionsByAppliedAt;
  diagnostics: DiagnosticsResult;
  edgeDeviceToken: Scalars['String'];
  edgeDevicesByOrganizationId: Array<EdgeDeviceType>;
  edgeDevicesV2: Array<EdgeDeviceNest>;
  eligibleManualReportEmailRecipients: Array<ManualReportEmailEligibleRecipient>;
  enterpriseReportById?: Maybe<EnterpriseReport>;
  enterpriseReportShareLink: EnterpriseReportShareLinkResolution;
  enterpriseReports: Array<EnterpriseReport>;
  entryIntervalsByDateRange: Array<IntervalNest>;
  entryIntervalsBySiteId: Array<IntervalNest>;
  entrySparklineData: Array<EntrySparklineType>;
  estimateSiteRecalculation: RecalculatedMetricsEstimate;
  exportBulkMetricEditorMetricsCsv: BulkMetricEditorMetricsCsvExport;
  exportLogBookEntriesCsv: Scalars['String'];
  exportUserManagerUsersCsv: Scalars['String'];
  externalFacilities: Array<ExternalFacility>;
  externalSystems: Array<ExternalSystem>;
  findAllUploads: UploadsWithCount;
  findEdgeDeviceSubmissions: EdgeDeviceSubmissionSummariesWithCount;
  findRecentEdgeDeviceSubmissions: Array<EdgeDeviceSubmissionSummary>;
  findUploadById: Upload;
  findUserByToken: UserInfoType;
  flexSitesAssociatedWithMetricId: Array<SiteNest>;
  /**
   * After providing a `fileName` and `mimeType`, this endpoint will generate an object with the details
   *        needed to upload a file to storage. The returned object contains an uploadUrl and a set of headers. The client should
   *        use HTTP `PUT` to upload the file to the given URL. The client must include the headers returned as well. **NOTE:** The
   *        returned upload and download URLs expire after 5 minutes (default, but can override via environment variables supplied to
   *        the API server)
   */
  generateUploadParameters: UploadBlobInfo;
  getActivityScheduleById: ActivitySchedule;
  getActivitySchedules: ActivityScheduleWithCount;
  getCalcTree: CalcTree;
  getCalcTreesWithCycles: Array<Scalars['String']>;
  getDataPointsForDay: Array<DataPointsForDay>;
  getEdgeDeviceSubmissionData: Scalars['JSON'];
  getEdgeDeviceV2: EdgeDeviceNest;
  getEmptyBaseSchedule: BaseSchedule;
  getNextNewUnitId: Scalars['Int'];
  getSSOConfigurationByIDP?: Maybe<SsoConfigurationType>;
  getScheduledItemById: ScheduledItem;
  getScheduledItems: ScheduledItemsWithCount;
  hasLinkedServiceReportEnterpriseReport: Scalars['Boolean'];
  intervalById: IntervalNest;
  intervals: Array<IntervalNest>;
  labImportBatch: LabImportBatch;
  labImportBatchResume: LabImportBatchResume;
  labImportBatches: LabImportBatchesPage;
  labImportFileDownload: LabImportFileDownload;
  labImportProfiles: Array<LabImportProfile>;
  labImportRows: LabImportRowsPage;
  labImportSourceGroups: Array<LabImportSourceGroup>;
  labImportTargets: Array<LabImportTarget>;
  latestServiceReportSnapshotBySiteAndReportDate?: Maybe<ReportSnapshot>;
  license?: Maybe<LicenseNest>;
  licenses: Array<LicenseNest>;
  logBookEntries: Array<LogBookEntryNest>;
  logBookEntriesWithCount: LogBookEntriesWithCount;
  logBookEntryById?: Maybe<LogBookEntryNest>;
  logBookEntryDashboardViewByUserId: Array<LogBookEntryDashboardViewNest>;
  manualReportEmailSharingScope: ManualReportEmailSharingScope;
  me: UserInfoType;
  metric: MetricType;
  metricById: MetricNest;
  metricChartData: MetricChartDataContainerType;
  metricKeynamesWithCount: MetricKeynameJoinedWithCount;
  metricRangesByMetricId: Array<MetricRange>;
  metricsBySiteProcessComponent: Array<MetricNest>;
  metricsBySystemIds: Array<MetricWithSpcIntervalsUnit>;
  metricsWithDownstreamCalcCounts: Array<MetricWithCalculatedMetrics>;
  notifications: NotificationsWithCount;
  organization: OrganizationType;
  organizationIntegrations: Array<OrganizationIntegrationNest>;
  organizations: Array<OrganizationType>;
  organizationsWithSystemGroupsAndSystems: Array<OrganizationType>;
  permitById?: Maybe<Permit>;
  permits: Array<Permit>;
  phoneNumbers: Array<PhoneNumberNest>;
  phrases: Array<Phrase>;
  ping: Scalars['Boolean'];
  process: ProcessType;
  processById: ProcessNest;
  processes: Array<ProcessNest>;
  recentEntryIntervalsBySiteId: IntervalsWithCount;
  regulatoryReportDefinitionsForGrouping: Array<RegulatoryReportDefinitionForGroupingNest>;
  reportData: ReportDataFlatTree;
  reportDataForSite: ReportData;
  reportDefinition: ReportDefinition;
  reportDefinitionDiscoveryFilterCounts: ReportDefinitionDiscoveryFilterCounts;
  reportDefinitionsForDiscovery: ReportDefinitionsForDiscoveryWithCount;
  reportDistributionList: ReportDistributionList;
  reportDistributionLists: Array<ReportDistributionList>;
  reportNodesTree: Array<ReportNodeWithRelations>;
  reportSnapshotById: ReportSnapshot;
  reportSnapshotsWithCount: ReportSnapshotItemsWithCount;
  reportTemplates: Array<ReportTemplate>;
  requestId?: Maybe<Scalars['String']>;
  retentionRisks?: Maybe<Array<RetentionRiskResultNest>>;
  retentionRisksByOrganizationId?: Maybe<Array<RetentionRiskNest>>;
  roundsAssetsMappingsByEntities: Array<RoundsAssetsMappingNest>;
  roundsShiftNoteFormContext: RoundsShiftNoteFormContext;
  runtimeLoggers: RuntimeLoggerSnapshot;
  sampleCollectionById: SampleCollection;
  sampleCollectionComments: SampleCollectionComment;
  sampleCollectionCustodies: SampleCollectionCustodiesWithCount;
  sampleCollections: SampleCollectionsWithCount;
  sampleScheduleById: SampleSchedule;
  sampleSchedules: SampleSchedulesWithCount;
  sampleSiteById: SampleSite;
  sampleSites: Array<SampleSite>;
  scheduledItemComments: ScheduledItemComment;
  scheduledItemCount: ScheduledItemCount;
  site: SiteType;
  siteDataEntryCompletionByDate: Array<SiteDataEntryCompletionByDate>;
  siteFlexMetricById: SiteFlexMetric;
  siteFlexMetrics: Array<SiteFlexMetric>;
  siteV2: SiteNest;
  sitesV2: Array<SiteNest>;
  sourceMetricsBySystemId: Array<MetricWithCalculatedMetric>;
  ssoOrgUsersForSystem: Array<SsoDirectoryUser>;
  ssoUsersForOrganization: Array<SsoDirectoryUser>;
  system?: Maybe<SystemType>;
  systemGroup: SystemGroupType;
  systemGroups: Array<SystemGroupType>;
  systemV2: SystemNest;
  systemWithDeepSites: SystemWithSites;
  systems: Array<SystemType>;
  systemsV2: Array<SystemNest>;
  tagMappings: TagMappingsResult;
  tags: TagsWithCount;
  templateSystems: Array<SystemNest>;
  transactionInfoWithCalcClusterDebugLogs: Array<TransactionInfoWithCalcClusterDebugLogs>;
  trends: Array<TrendNest>;
  unitById: UnitNest;
  unitNests: Array<UnitNest>;
  units: Array<UnitType>;
  user?: Maybe<UserNest>;
  userManagerUser?: Maybe<UserManagerUser>;
  userManagerUsers: UserManagerUsersPage;
  users: Array<UserInfoType>;
  waterlyConnectErrorStats: WaterlyConnectErrorStatsByMonth;
  waterlyConnectStats: WaterlyConnectStats;
  waterlyConnectSubmissionHistory: Array<EdgeDeviceSubmission>;
  weatherDataStations: Array<WeatherDataStationNest>;
};


export type QuerySampleScheduleAnalytesArgs = {
  input: SampleScheduleAnalytesInput;
};


export type Query_UsersByOrganizationIdArgs = {
  organizationId: Scalars['Int'];
};


export type QueryActiveMetricStatsArgs = {
  input: ActiveMetricStatsInput;
};


export type QueryActiveUserStatsArgs = {
  input: ActiveUserDetailsInput;
};


export type QueryAddressArgs = {
  id: Scalars['UUID'];
};


export type QueryAdjacentEntryIntervalArgs = {
  input: AdjacentEntryIntervalInput;
};


export type QueryAllSitesArgs = {
  input?: InputMaybe<SitesInput>;
};


export type QueryAnalyteGroupByIdArgs = {
  id: Scalars['String'];
};


export type QueryAnalyteGroupsArgs = {
  input: AnalyteGroupsInput;
};


export type QueryAnalytesArgs = {
  input: AnalytesInput;
};


export type QueryApiTokensByOrganizationArgs = {
  input: ApiTokensByOrganizationInput;
};


export type QueryAuditEventSiteCreatedArgs = {
  input: AuditEventFindOneInput;
};


export type QueryAuditEventsArgs = {
  input: AuditEventsInput;
};


export type QueryAuditEventsByItemTypeAndItemIdArgs = {
  input: AuditEventsByItemTypeAndItemId;
};


export type QueryAuditEventsByMetricIdArgs = {
  input: AuditEventsByMetricIdInput;
};


export type QueryAuditEventsByScheduledItemIdArgs = {
  input: AuditEventsByScheduledItemIdInput;
};


export type QueryBulkMetricEditorFilterOptionsArgs = {
  input: BulkMetricEditorMetricsFilterInput;
};


export type QueryBulkMetricEditorMetricsArgs = {
  input: BulkMetricEditorMetricsInput;
};


export type QueryCalcClusterDebugByClusterIdArgs = {
  clusterId: Scalars['String'];
};


export type QueryCalcClusterDebugLogsArgs = {
  input: CalcClusterDebugLogsInput;
};


export type QueryCalcClusterDebugsArgs = {
  input: CalcClusterDebugInputs;
};


export type QueryColumnGroupByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryColumnGroupItemByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryColumnGroupsArgs = {
  input: ColumnGroupsInput;
};


export type QueryColumnGroupsWithItemsArgs = {
  input: ColumnGroupsWithItemsInput;
};


export type QueryComponentArgs = {
  componentId: Scalars['Int'];
};


export type QueryComponentByIdArgs = {
  componentId: Scalars['Int'];
};


export type QueryComponentsArgs = {
  input: ComponentsInput;
};


export type QueryConstantDefinitionsArgs = {
  input: ConstantDefinitionsInput;
};


export type QueryConstantRecalculationEstimateArgs = {
  input: ConstantRecalculationInput;
};


export type QueryConstantsForOrganizationArgs = {
  input: ConstantsForOrganizationInput;
};


export type QueryConstantsForSystemArgs = {
  input: ConstantsForSystemInput;
};


export type QueryDataEntryCompletionsByReportDateArgs = {
  input: DataEntryCompletionsByReportDateInput;
};


export type QueryEdgeDeviceTokenArgs = {
  edgeDeviceId: Scalars['Int'];
};


export type QueryEdgeDevicesByOrganizationIdArgs = {
  organizationId: Scalars['Int'];
};


export type QueryEligibleManualReportEmailRecipientsArgs = {
  input: EligibleManualReportEmailRecipientsInput;
};


export type QueryEnterpriseReportByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryEnterpriseReportShareLinkArgs = {
  id: Scalars['UUID'];
};


export type QueryEnterpriseReportsArgs = {
  input: EnterpriseReportsInput;
};


export type QueryEntryIntervalsByDateRangeArgs = {
  input: EntryIntervalDateRangeInput;
};


export type QueryEntryIntervalsBySiteIdArgs = {
  siteId: Scalars['Int'];
};


export type QueryEntrySparklineDataArgs = {
  input: EntrySparklineDataInput;
};


export type QueryEstimateSiteRecalculationArgs = {
  input: SubmitSiteRecalculationInput;
};


export type QueryExportBulkMetricEditorMetricsCsvArgs = {
  input: BulkMetricEditorMetricsCsvExportInput;
};


export type QueryExportLogBookEntriesCsvArgs = {
  input: LogBookEntriesInput;
};


export type QueryExportUserManagerUsersCsvArgs = {
  input?: InputMaybe<UserManagerUsersCsvExportInput>;
};


export type QueryExternalFacilitiesArgs = {
  input: ExternalFacilitiesInput;
};


export type QueryExternalSystemsArgs = {
  input: ExternalSystemsInput;
};


export type QueryFindAllUploadsArgs = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FindUploadsWhere>;
};


export type QueryFindEdgeDeviceSubmissionsArgs = {
  input: EdgeDeviceSubmissionFindRecentForDeviceIdInput;
};


export type QueryFindRecentEdgeDeviceSubmissionsArgs = {
  input: EdgeDeviceSubmissionFindRecentForDeviceIdInput;
};


export type QueryFindUploadByIdArgs = {
  id: Scalars['String'];
};


export type QueryFindUserByTokenArgs = {
  userToken: Scalars['String'];
};


export type QueryFlexSitesAssociatedWithMetricIdArgs = {
  input: FlexSitesAssociatedWithMetricId;
};


export type QueryGenerateUploadParametersArgs = {
  fileName: Scalars['String'];
  mimeType: Scalars['MimeType'];
  organizationId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetActivityScheduleByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetActivitySchedulesArgs = {
  input: ActivitySchedulesInput;
};


export type QueryGetCalcTreeArgs = {
  input: GetCalcTreeInput;
};


export type QueryGetDataPointsForDayArgs = {
  metricIds: Array<Scalars['Int']>;
  reportDate: Scalars['Date'];
  systemId: Scalars['Int'];
};


export type QueryGetEdgeDeviceSubmissionDataArgs = {
  submissionId: Scalars['Int'];
};


export type QueryGetEdgeDeviceV2Args = {
  edgeDeviceId: Scalars['Int'];
};


export type QueryGetEmptyBaseScheduleArgs = {
  input: CreateScheduleParentInput;
};


export type QueryGetSsoConfigurationByIdpArgs = {
  idpKey: Scalars['String'];
};


export type QueryGetScheduledItemByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetScheduledItemsArgs = {
  input: ScheduledItemsInput;
};


export type QueryHasLinkedServiceReportEnterpriseReportArgs = {
  siteId: Scalars['Int'];
};


export type QueryIntervalByIdArgs = {
  intervalId: Scalars['Int'];
};


export type QueryIntervalsArgs = {
  input: IntervalsInput;
};


export type QueryLabImportBatchArgs = {
  id: Scalars['UUID'];
};


export type QueryLabImportBatchResumeArgs = {
  id: Scalars['UUID'];
};


export type QueryLabImportBatchesArgs = {
  input: LabImportBatchesInput;
};


export type QueryLabImportFileDownloadArgs = {
  batchId: Scalars['UUID'];
};


export type QueryLabImportProfilesArgs = {
  systemId: Scalars['Int'];
};


export type QueryLabImportRowsArgs = {
  input: LabImportRowsInput;
};


export type QueryLabImportSourceGroupsArgs = {
  input: LabImportSourceGroupsInput;
};


export type QueryLabImportTargetsArgs = {
  systemId: Scalars['Int'];
};


export type QueryLatestServiceReportSnapshotBySiteAndReportDateArgs = {
  input: LatestServiceReportSnapshotBySiteAndReportDateInput;
};


export type QueryLicenseArgs = {
  licenseId: Scalars['Int'];
};


export type QueryLicensesArgs = {
  userId: Scalars['Int'];
};


export type QueryLogBookEntriesArgs = {
  input: LogBookEntriesInput;
};


export type QueryLogBookEntriesWithCountArgs = {
  input: LogBookEntriesInput;
};


export type QueryLogBookEntryByIdArgs = {
  id: Scalars['UUID'];
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLogBookEntryDashboardViewByUserIdArgs = {
  input: LogBookEntryDashboardViewByUserIdInput;
};


export type QueryManualReportEmailSharingScopeArgs = {
  reportSnapshotId: Scalars['UUID'];
};


export type QueryMetricArgs = {
  metricId: Scalars['Int'];
};


export type QueryMetricByIdArgs = {
  metricId: Scalars['Int'];
};


export type QueryMetricChartDataArgs = {
  endDate: Scalars['DateType'];
  metricIds: Array<Scalars['Int']>;
  startDate: Scalars['DateType'];
  systemId: Scalars['Int'];
};


export type QueryMetricKeynamesWithCountArgs = {
  input: MetricKeynameInput;
};


export type QueryMetricRangesByMetricIdArgs = {
  metricId: Scalars['Int'];
};


export type QueryMetricsBySiteProcessComponentArgs = {
  input: MetricsInput;
};


export type QueryMetricsBySystemIdsArgs = {
  input: MetricsBySystemIdsInput;
};


export type QueryMetricsWithDownstreamCalcCountsArgs = {
  input: MetricsWithDownstreamCalcCountsInput;
};


export type QueryNotificationsArgs = {
  input: NotificationsInput;
};


export type QueryOrganizationArgs = {
  organizationId: Scalars['Int'];
};


export type QueryPermitByIdArgs = {
  permitId: Scalars['UUID'];
};


export type QueryPermitsArgs = {
  input: PermitsInput;
};


export type QueryPhoneNumbersArgs = {
  userId: Scalars['Int'];
};


export type QueryPhrasesArgs = {
  input: PhrasesInput;
};


export type QueryProcessArgs = {
  processId: Scalars['Int'];
};


export type QueryProcessByIdArgs = {
  processId: Scalars['Int'];
};


export type QueryProcessesArgs = {
  input: ProcessesInput;
};


export type QueryRecentEntryIntervalsBySiteIdArgs = {
  beforeDate?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  siteId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRegulatoryReportDefinitionsForGroupingArgs = {
  input: ReportDefinitionsForDiscoveryInput;
};


export type QueryReportDataArgs = {
  reportDefinitionId: Scalars['Int'];
};


export type QueryReportDataForSiteArgs = {
  reportDefinitionId: Scalars['Int'];
};


export type QueryReportDefinitionArgs = {
  input: ReportDefinitionInput;
};


export type QueryReportDefinitionDiscoveryFilterCountsArgs = {
  input: ReportDefinitionsForDiscoveryInput;
};


export type QueryReportDefinitionsForDiscoveryArgs = {
  input: ReportDefinitionsForDiscoveryInput;
};


export type QueryReportDistributionListArgs = {
  id: Scalars['UUID'];
};


export type QueryReportDistributionListsArgs = {
  input: ReportDistributionListsInput;
};


export type QueryReportNodesTreeArgs = {
  input: ReportNodesTreeInput;
};


export type QueryReportSnapshotByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryReportSnapshotsWithCountArgs = {
  input: ReportSnapshotInput;
};


export type QueryReportTemplatesArgs = {
  input: ReportTemplatesWhere;
};


export type QueryRetentionRisksArgs = {
  input: RetentionRisksInput;
};


export type QueryRetentionRisksByOrganizationIdArgs = {
  id: Scalars['Float'];
};


export type QueryRoundsAssetsMappingsByEntitiesArgs = {
  input: RoundsAssetsMappingsByEntitiesInput;
};


export type QueryRoundsShiftNoteFormContextArgs = {
  input: RoundsShiftNoteFormContextInput;
};


export type QuerySampleCollectionByIdArgs = {
  id: Scalars['String'];
};


export type QuerySampleCollectionCommentsArgs = {
  input: SampleCollectionCommentsInput;
};


export type QuerySampleCollectionCustodiesArgs = {
  input: SampleCollectionCustodiesInput;
};


export type QuerySampleCollectionsArgs = {
  input: SampleCollectionsInput;
};


export type QuerySampleScheduleByIdArgs = {
  id: Scalars['String'];
};


export type QuerySampleSchedulesArgs = {
  input: SampleSchedulesInput;
};


export type QuerySampleSiteByIdArgs = {
  id: Scalars['String'];
};


export type QuerySampleSitesArgs = {
  input: SampleSitesInput;
};


export type QueryScheduledItemCommentsArgs = {
  input: ScheduledItemCommentsInput;
};


export type QueryScheduledItemCountArgs = {
  input: ScheduledItemsInput;
};


export type QuerySiteArgs = {
  siteId: Scalars['Int'];
};


export type QuerySiteDataEntryCompletionByDateArgs = {
  input: SiteDataEntryCompletionByDateInput;
};


export type QuerySiteFlexMetricByIdArgs = {
  id: Scalars['String'];
};


export type QuerySiteFlexMetricsArgs = {
  input: SiteFlexMetricsInput;
};


export type QuerySiteV2Args = {
  entryDate?: InputMaybe<Scalars['Date']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  siteId: Scalars['Int'];
};


export type QuerySitesV2Args = {
  input: SitesInput;
};


export type QuerySourceMetricsBySystemIdArgs = {
  systemId: Scalars['Int'];
};


export type QuerySsoOrgUsersForSystemArgs = {
  searchInput: Scalars['String'];
  systemId: Scalars['Int'];
};


export type QuerySsoUsersForOrganizationArgs = {
  input: SsoUsersForOrganizationInput;
};


export type QuerySystemArgs = {
  systemId: Scalars['Int'];
};


export type QuerySystemGroupArgs = {
  input: SystemGroupInput;
};


export type QuerySystemGroupsArgs = {
  input: SystemGroupsInput;
};


export type QuerySystemV2Args = {
  id: Scalars['Int'];
};


export type QuerySystemWithDeepSitesArgs = {
  id: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
};


export type QuerySystemsArgs = {
  input?: InputMaybe<SystemsInput>;
};


export type QueryTagMappingsArgs = {
  input: TagMappingsInput;
};


export type QueryTagsArgs = {
  input: TagsInput;
};


export type QueryTemplateSystemsArgs = {
  organizationId: Scalars['Int'];
};


export type QueryTransactionInfoWithCalcClusterDebugLogsArgs = {
  input: CalcClusterDebugLogsInput;
};


export type QueryTrendsArgs = {
  input: TrendsQueryInput;
};


export type QueryUnitByIdArgs = {
  unitId: Scalars['Int'];
};


export type QueryUnitNestsArgs = {
  input: UnitsInput;
};


export type QueryUserArgs = {
  userId: Scalars['Int'];
};


export type QueryUserManagerUserArgs = {
  input: UserManagerUserDetailsInput;
};


export type QueryUserManagerUsersArgs = {
  input?: InputMaybe<UserManagerUsersInput>;
};


export type QueryUsersArgs = {
  input: UsersInput;
};


export type QueryWaterlyConnectErrorStatsArgs = {
  edgeDeviceId?: InputMaybe<Scalars['Int']>;
  forMonthStartingUTC: Scalars['String'];
};


export type QueryWaterlyConnectSubmissionHistoryArgs = {
  options: EdgeDeviceSubmissionSearchOptions;
};


export type QueryWeatherDataStationsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};

export type QueueStats = {
  __typename?: 'QueueStats';
  completedInLastHour: Scalars['Int'];
  completedPerMinute: Array<Scalars['Int']>;
  failedInLastHour: Scalars['Int'];
  failedPerMinute: Array<Scalars['Int']>;
  generatedAt: Scalars['DateTime'];
  groupsCount: Array<Maybe<GroupCount>>;
  groupsCountByStatus: GroupQueueCounts;
  queue: Scalars['String'];
  workersCount: Scalars['Int'];
};

export type QueuedRecalculation = {
  __typename?: 'QueuedRecalculation';
  canRunForwardCalculations: Scalars['Boolean'];
  edgeDeviceSubmissionId?: Maybe<Scalars['Int']>;
  intervalId?: Maybe<Scalars['Int']>;
  metricId: Scalars['Int'];
  queuedAt: Scalars['DateTime'];
  reportDate: Scalars['DateTime'];
  senderEmail: Scalars['String'];
  stackDepth: Scalars['Int'];
  subscriptionClientId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type RecalculateMetricInput = {
  intervalId?: InputMaybe<Scalars['Int']>;
  metricId: Scalars['Int'];
  reportDate: Scalars['DateType'];
  siteId?: InputMaybe<Scalars['Int']>;
  subscriptionClientId: Scalars['String'];
};

export type RecalculatedMetricData = {
  __typename?: 'RecalculatedMetricData';
  metricId: Scalars['Int'];
  metricName: Scalars['String'];
  recalculationCount: Scalars['Int'];
};

export type RecalculatedMetricsEstimate = {
  __typename?: 'RecalculatedMetricsEstimate';
  metrics: Array<RecalculatedMetricData>;
  totalRecalculationCount: Scalars['Int'];
};

export type RecalculatedMetricsResult = {
  __typename?: 'RecalculatedMetricsResult';
  recalculationCount: Scalars['Int'];
};

export type ReconcileLabImportBatchInput = {
  batchId: Scalars['UUID'];
  confirmNoActiveWriter: Scalars['Boolean'];
  confirmedNotWrittenRowIds: Array<Scalars['UUID']>;
  confirmedWrittenRowIds: Array<Scalars['UUID']>;
};

export enum RecurrenceType {
  Adhoc = 'ADHOC',
  Recurring = 'RECURRING'
}

export type RegulatoryReportDefinitionForGroupingNest = {
  __typename?: 'RegulatoryReportDefinitionForGroupingNest';
  id: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Int'];
  outputTypes: Array<ReportOutputType>;
  reportGroup?: Maybe<ReportingReportGroupNest>;
  reportGroupId?: Maybe<Scalars['Int']>;
  reportType: ReportDiscoveryReportType;
  site?: Maybe<ReportDiscoverySiteNest>;
  siteId?: Maybe<Scalars['Int']>;
  system?: Maybe<ReportDiscoverySystemNest>;
  systemId: Scalars['Int'];
};

export type RemoveUserFromSystemGroupInput = {
  systemGroupId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ReportData = {
  __typename?: 'ReportData';
  metricsWithReportData: Array<MetricWithReportData>;
  processesWithReportData: Array<ProcessWithReportData>;
};

export type ReportDataFlatTree = {
  __typename?: 'ReportDataFlatTree';
  reportNodes: Array<ReportNodeWithRelations>;
};

export type ReportDefinition = {
  __typename?: 'ReportDefinition';
  annualPeriod?: Maybe<Scalars['String']>;
  configSchemaId?: Maybe<Scalars['String']>;
  customFooter?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isFlex: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSONObject']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  paperOrientation: PaperOrientationEnum;
  paperSize: PaperSizeEnum;
  reportGroup?: Maybe<ReportGroup>;
  reportGroupId?: Maybe<Scalars['Int']>;
  reportTemplateId: Scalars['Int'];
  reportType: ReportTypeEnum;
  showDayOfWeek: Scalars['Boolean'];
  site?: Maybe<SiteType>;
  siteId?: Maybe<Scalars['Int']>;
  supplementaryEnabled: Scalars['Boolean'];
  system: SystemType;
  systemId: Scalars['Int'];
  timeFormat: TimeFormatEnum;
};

export type ReportDefinitionCreateInput = {
  isFlex?: InputMaybe<Scalars['Boolean']>;
  reportType?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId: Scalars['Int'];
};

export type ReportDefinitionDiscoveryFilterCounts = {
  __typename?: 'ReportDefinitionDiscoveryFilterCounts';
  frequencies: ReportDefinitionDiscoveryFrequencyCounts;
  scopes: ReportDefinitionDiscoveryScopeCounts;
};

export type ReportDefinitionDiscoveryFrequencyCounts = {
  __typename?: 'ReportDefinitionDiscoveryFrequencyCounts';
  annual: Scalars['Int'];
  daily: Scalars['Int'];
  monthly: Scalars['Int'];
  other: Scalars['Int'];
  quarterly: Scalars['Int'];
};

export type ReportDefinitionDiscoveryScopeCounts = {
  __typename?: 'ReportDefinitionDiscoveryScopeCounts';
  component: Scalars['Int'];
  organization: Scalars['Int'];
  process: Scalars['Int'];
  site: Scalars['Int'];
  system: Scalars['Int'];
};

export type ReportDefinitionFieldChange = {
  metricId: Scalars['Int'];
  reportTemplateFieldId: Scalars['Int'];
};

export type ReportDefinitionInput = {
  reportDefinitionId: Scalars['Int'];
};

export type ReportDefinitionNest = {
  __typename?: 'ReportDefinitionNest';
  annualPeriod?: Maybe<Scalars['String']>;
  bacterialsEnabled: Scalars['Boolean'];
  configSchemaId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customFooter?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isFlex: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  paperOrientation: Scalars['String'];
  paperSize: Scalars['String'];
  reportGroup?: Maybe<ReportingReportGroupNest>;
  reportGroupId?: Maybe<Scalars['Int']>;
  reportId: Scalars['UUID'];
  reportNodes?: Maybe<ReportNode>;
  reportTemplate: ReportTemplate;
  reportTemplateId?: Maybe<Scalars['Int']>;
  reportType: Scalars['String'];
  showDayOfWeek: Scalars['Boolean'];
  site?: Maybe<SiteNest>;
  siteId?: Maybe<Scalars['Int']>;
  supplementaryEnabled: Scalars['Boolean'];
  system?: Maybe<SystemNest>;
  systemId: Scalars['Int'];
  timeFormat: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ReportDefinitionsForDiscoveryFilterInput = {
  field: ReportDiscoveryFilterField;
  operator: ReportDiscoveryFilterOperator;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type ReportDefinitionsForDiscoveryInput = {
  filters?: InputMaybe<Array<ReportDefinitionsForDiscoveryFilterInput>>;
  includeFlexReports?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<ReportDiscoveryOrderBy>;
  orderDirection?: InputMaybe<ReportDiscoveryOrderDirection>;
  organizationId?: InputMaybe<Scalars['Int']>;
  recentSnapshotsTake?: InputMaybe<Scalars['Int']>;
  scopes?: InputMaybe<Array<ReportScope>>;
  skip?: InputMaybe<Scalars['Int']>;
  sourceType?: InputMaybe<ReportDiscoverySourceType>;
  systemIds: Array<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  timePeriods?: InputMaybe<Array<ReportDiscoveryReportType>>;
};

export type ReportDefinitionsForDiscoveryWithCount = {
  __typename?: 'ReportDefinitionsForDiscoveryWithCount';
  count: Scalars['Int'];
  items: Array<ReportDiscoveryItem>;
};

export enum ReportDiscoveryFilterField {
  Name = 'Name',
  ReportType = 'ReportType',
  Site = 'Site',
  System = 'System'
}

export enum ReportDiscoveryFilterOperator {
  Contains = 'Contains',
  EndsWith = 'EndsWith',
  Equals = 'Equals',
  Is = 'Is',
  IsAnyOf = 'IsAnyOf',
  IsEmpty = 'IsEmpty',
  IsNotEmpty = 'IsNotEmpty',
  StartsWith = 'StartsWith'
}

export type ReportDiscoveryItem = {
  __typename?: 'ReportDiscoveryItem';
  createdAt: Scalars['DateTime'];
  enterpriseReportId?: Maybe<Scalars['UUID']>;
  id: Scalars['String'];
  isFlex: Scalars['Boolean'];
  latestSnapshotReportDateTime?: Maybe<Scalars['DateTime']>;
  latestSnapshotStatus?: Maybe<ReportStatus>;
  latestSnapshotUpdatedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  outputTypes: Array<ReportOutputType>;
  recentSnapshots: Array<ReportDiscoverySnapshot>;
  reportDefinitionId?: Maybe<Scalars['Int']>;
  reportGroup?: Maybe<ReportingReportGroupNest>;
  reportGroupId?: Maybe<Scalars['Int']>;
  reportSnapshotId?: Maybe<Scalars['UUID']>;
  reportType: ReportDiscoveryReportType;
  site?: Maybe<ReportDiscoverySiteNest>;
  siteId?: Maybe<Scalars['Int']>;
  snapshotCount?: Maybe<Scalars['Int']>;
  sourceType: ReportDiscoverySourceType;
  system?: Maybe<ReportDiscoverySystemNest>;
  systemId?: Maybe<Scalars['Int']>;
};

export enum ReportDiscoveryOrderBy {
  CreatedAt = 'CreatedAt',
  Name = 'Name',
  ReportType = 'ReportType',
  Site = 'Site',
  System = 'System'
}

export enum ReportDiscoveryOrderDirection {
  Asc = 'Asc',
  Desc = 'Desc'
}

export enum ReportDiscoveryReportType {
  Annual = 'Annual',
  Daily = 'Daily',
  Monthly = 'Monthly',
  Other = 'Other',
  Quarterly = 'Quarterly'
}

export type ReportDiscoverySiteNest = {
  __typename?: 'ReportDiscoverySiteNest';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type ReportDiscoverySnapshot = {
  __typename?: 'ReportDiscoverySnapshot';
  enterpriseReportId: Scalars['UUID'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  reportDateTime: Scalars['DateTime'];
  status: ReportStatus;
  updatedAt: Scalars['DateTime'];
};

export enum ReportDiscoverySourceType {
  Enterprise = 'Enterprise',
  Regulatory = 'Regulatory'
}

export type ReportDiscoverySystemNest = {
  __typename?: 'ReportDiscoverySystemNest';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  timeZone: Scalars['String'];
};

export type ReportDistributionList = {
  __typename?: 'ReportDistributionList';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displaySummary: Scalars['String'];
  id: Scalars['UUID'];
  isArchived: Scalars['Boolean'];
  memberCount: Scalars['Int'];
  members: Array<ReportDistributionListMember>;
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  organizationId?: Maybe<Scalars['Int']>;
  scope: ReportDistributionListScope;
  siteId?: Maybe<Scalars['Int']>;
  systemId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type ReportDistributionListMember = {
  __typename?: 'ReportDistributionListMember';
  createdAt: Scalars['DateTime'];
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  memberType: ReportDistributionListMemberType;
  normalizedEmail: Scalars['String'];
  sortOrder: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['Int']>;
};

export type ReportDistributionListMemberInput = {
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['EmailAddress'];
  memberType: ReportDistributionListMemberType;
  userId?: InputMaybe<Scalars['Int']>;
};

export enum ReportDistributionListMemberType {
  ManualEmail = 'ManualEmail',
  RegisteredUser = 'RegisteredUser'
}

export enum ReportDistributionListScope {
  Organization = 'ORGANIZATION',
  Site = 'SITE',
  System = 'SYSTEM'
}

export type ReportDistributionListScopeInput = {
  organizationId?: InputMaybe<Scalars['Int']>;
  scope: ReportDistributionListScope;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
};

export type ReportDistributionListsInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  scope: ReportDistributionListScopeInput;
  search?: InputMaybe<Scalars['String']>;
};

export enum ReportFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY'
}

export type ReportGroup = {
  __typename?: 'ReportGroup';
  createdAt: Scalars['DateType'];
  id: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Int'];
  systemId: Scalars['Int'];
  updatedAt: Scalars['DateType'];
};

export type ReportNest = {
  __typename?: 'ReportNest';
  description: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  organization?: Maybe<OrganizationNest>;
  organizationId?: Maybe<Scalars['Int']>;
  reportTemplate?: Maybe<Scalars['JSON']>;
  reportType: ReportType;
  site?: Maybe<SiteNest>;
  siteId?: Maybe<Scalars['Int']>;
  system?: Maybe<SystemNest>;
  systemId?: Maybe<Scalars['Int']>;
};

export type ReportNode = {
  __typename?: 'ReportNode';
  columnGroupId?: Maybe<Scalars['UUID']>;
  columnGroupItemId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  metricId?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  parentId?: Maybe<Scalars['UUID']>;
  reportDefinitionId: Scalars['Int'];
  type: ReportNodeType;
  updatedAt: Scalars['DateTime'];
};

export enum ReportNodeType {
  Calculated = 'Calculated',
  Folder = 'Folder',
  Metric = 'Metric',
  PageBreak = 'PageBreak',
  ReportDefinition = 'ReportDefinition'
}

export type ReportNodeWithRelations = {
  __typename?: 'ReportNodeWithRelations';
  columnGroup?: Maybe<ColumnGroup>;
  columnGroupId?: Maybe<Scalars['UUID']>;
  columnGroupItem?: Maybe<ColumnGroupItem>;
  columnGroupItemId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  metric?: Maybe<MetricNest>;
  metricId?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  parentId?: Maybe<Scalars['UUID']>;
  reportDefinition?: Maybe<ReportDefinitionNest>;
  reportDefinitionId: Scalars['Int'];
  type: ReportNodeType;
  updatedAt: Scalars['DateTime'];
};

export type ReportNodesTreeInput = {
  nodeId: Scalars['UUID'];
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

/** Report Output Types */
export enum ReportOutputType {
  Pdf = 'PDF',
  Xml = 'XML'
}

export enum ReportScope {
  Component = 'COMPONENT',
  Organization = 'ORGANIZATION',
  Process = 'PROCESS',
  Site = 'SITE',
  System = 'SYSTEM'
}

export type ReportSnapshot = {
  __typename?: 'ReportSnapshot';
  config?: Maybe<Scalars['JSONObject']>;
  configSchemaVersion: ReportSnapshotConfigSchemaVersion;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['JSONObject']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  enterpriseReportId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  report: ReportNest;
  reportDateTime: Scalars['DateTime'];
  reportDefinition?: Maybe<ReportDefinitionNest>;
  reportDefinitionId?: Maybe<Scalars['Int']>;
  status: ReportStatus;
  system?: Maybe<SystemNest>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};

export enum ReportSnapshotConfigSchemaVersion {
  EnterpriseReportV1 = 'ENTERPRISE_REPORT_V1',
  ReportDefinitionV1 = 'REPORT_DEFINITION_V1'
}

export type ReportSnapshotInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReportSnapshotsWhereInput>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ReportSnapshotItemsWithCount = {
  __typename?: 'ReportSnapshotItemsWithCount';
  count: Scalars['Int'];
  items: Array<ReportSnapshot>;
};

export type ReportSnapshotsWhereInput = {
  endDate: Scalars['DateTime'];
  enterpriseReportId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  reportDefinitionId?: InputMaybe<Scalars['Int']>;
  reportTypes?: InputMaybe<Array<ReportType>>;
  scopes?: InputMaybe<Array<ReportScope>>;
  siteIds?: InputMaybe<Array<Scalars['Int']>>;
  standardReportTypes?: InputMaybe<Array<ReportFrequency>>;
  startDate: Scalars['DateTime'];
  status?: InputMaybe<ReportStatus>;
  systemIds: Array<Scalars['Int']>;
};

export enum ReportStatus {
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Final = 'FINAL',
  Pending = 'PENDING'
}

export type ReportTemplate = {
  __typename?: 'ReportTemplate';
  agencyName?: Maybe<Scalars['String']>;
  configSchemaId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isEditable: Scalars['Boolean'];
  legalStatement?: Maybe<Scalars['String']>;
  outputTypes: Array<ReportOutputType>;
  stateOrProvince: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  variant: Scalars['String'];
};

export type ReportTemplatesWhere = {
  systemId: Scalars['Int'];
};

export enum ReportType {
  Enterprise = 'ENTERPRISE',
  Inspection = 'INSPECTION',
  Regulatory = 'REGULATORY'
}

/**
 * Report Types
 * *** Be sure to keep these synchronized with the Postgres enums ***
 */
export enum ReportTypeEnum {
  /** An `annual` report contains sub-year (month/quarter) data */
  Annual = 'ANNUAL',
  /** A `daily` report contains sub-day (hourly/interval) data. */
  Daily = 'DAILY',
  /** A `monthly` report contains sub-month (day) data */
  Monthly = 'MONTHLY'
}

export type ReportingReportGroupNest = {
  __typename?: 'ReportingReportGroupNest';
  id: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Int'];
  systemId: Scalars['Int'];
};

export type RequestEnterpriseReportShareLinkAccessInput = {
  id: Scalars['UUID'];
  requesterEmail: Scalars['EmailAddress'];
};

export type ResolveLabImportReconciliationInput = {
  batchId: Scalars['UUID'];
  confirmDownstreamRepaired: Scalars['Boolean'];
  resolutionNote: Scalars['String'];
  rowId: Scalars['UUID'];
};

export type ResolvedConstant = {
  __typename?: 'ResolvedConstant';
  constantDefinition: ConstantDefinition;
  constantValue?: Maybe<ConstantValue>;
  source: ConstantScope;
};

export type RestoreComponentInput = {
  componentId: Scalars['Int'];
};

export type RestoreConstantDefinitionInput = {
  id: Scalars['Int'];
};

export type RestoreConstantValueInput = {
  id: Scalars['Int'];
};

export type RestoreFolderInput = {
  id: Scalars['UUID'];
};

export type RestoreMetricInput = {
  metricId: Scalars['Int'];
};

export type RestoreProcessInput = {
  processId: Scalars['Int'];
};

export type RestoreSiteInput = {
  siteId: Scalars['Int'];
};

export enum RetentionRiskFlagType {
  OrgLastLogin = 'ORG_LAST_LOGIN',
  SystemLastLogin = 'SYSTEM_LAST_LOGIN',
  SystemLastReportDownload = 'SYSTEM_LAST_REPORT_DOWNLOAD',
  SystemLastSavedDatapoint = 'SYSTEM_LAST_SAVED_DATAPOINT'
}

export enum RetentionRiskItemType {
  Organization = 'ORGANIZATION',
  System = 'SYSTEM'
}

export type RetentionRiskNest = {
  __typename?: 'RetentionRiskNest';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  displayName: Scalars['String'];
  flag: Scalars['Boolean'];
  flagType: RetentionRiskFlagType;
  id: Scalars['UUID'];
  itemId: Scalars['String'];
  itemType: RetentionRiskItemType;
  organization: OrganizationNest;
  organizationId: Scalars['Int'];
  score: Scalars['Float'];
  snooze?: Maybe<Scalars['Date']>;
  updatedAt: Scalars['DateTime'];
};

export type RetentionRiskResultNest = {
  __typename?: 'RetentionRiskResultNest';
  organizationId: Scalars['Int'];
  organizationRetentionRisks: Array<RetentionRiskNest>;
  score: Scalars['Float'];
  systemRetentionRisks: Array<RetentionRiskNest>;
};

export type RetentionRisksInput = {
  snooze?: InputMaybe<Scalars['Boolean']>;
};

export type RevokeApiTokenInput = {
  id: Scalars['Int'];
};

export type RoundsAssetsMappingNest = {
  __typename?: 'RoundsAssetsMappingNest';
  assetsEntityId: Scalars['Int'];
  assetsEntityType: AssetsEntityType;
  assetsInstanceId: Scalars['Int'];
  id: Scalars['ID'];
  roundsEntityId: Scalars['Int'];
  roundsEntityType: RoundsEntityType;
  systemId: Scalars['Int'];
};

export type RoundsAssetsMappingsByEntitiesInput = {
  entities: Array<RoundsAssetsMappingsEntityRefInput>;
  systemId: Scalars['Int'];
};

export type RoundsAssetsMappingsEntityRefInput = {
  roundsEntityId: Scalars['Int'];
  roundsEntityType: RoundsEntityType;
};

export enum RoundsEntityType {
  Component = 'Component',
  Process = 'Process',
  Site = 'Site'
}

export type RoundsShiftNoteAssetChoice = {
  __typename?: 'RoundsShiftNoteAssetChoice';
  componentId: Scalars['Int'];
  name: Scalars['String'];
};

export type RoundsShiftNoteAssigneeRole = {
  __typename?: 'RoundsShiftNoteAssigneeRole';
  isUnassignedBucket: Scalars['Boolean'];
  roleId: Scalars['Int'];
  roleName: Scalars['String'];
  users: Array<RoundsShiftNoteAssigneeUser>;
};

export type RoundsShiftNoteAssigneeUser = {
  __typename?: 'RoundsShiftNoteAssigneeUser';
  label: Scalars['String'];
  userId: Scalars['Int'];
};

export type RoundsShiftNoteCreateResult = {
  __typename?: 'RoundsShiftNoteCreateResult';
  noteId: Scalars['String'];
  viewUrl: Scalars['String'];
};

export type RoundsShiftNoteFormContext = {
  __typename?: 'RoundsShiftNoteFormContext';
  asset?: Maybe<RoundsShiftNoteLocationTier>;
  assetChoices: Array<RoundsShiftNoteAssetChoice>;
  assigneeRoles: Array<RoundsShiftNoteAssigneeRole>;
  defaultDate: Scalars['String'];
  defaultTime: Scalars['String'];
  facility: RoundsShiftNoteLocationTier;
  notifyAssignedByDefault: Scalars['Boolean'];
  sourceType: RoundsShiftNoteSourceType;
  system?: Maybe<RoundsShiftNoteLocationTier>;
  systemChoices: Array<RoundsShiftNoteSystemChoice>;
};

export type RoundsShiftNoteFormContextInput = {
  sourceRoundsEntityId: Scalars['Int'];
  sourceType: RoundsShiftNoteSourceType;
  systemId: Scalars['Int'];
};

export type RoundsShiftNoteLocationTier = {
  __typename?: 'RoundsShiftNoteLocationTier';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum RoundsShiftNoteSourceType {
  Component = 'Component',
  Process = 'Process',
  Site = 'Site'
}

export type RoundsShiftNoteSystemChoice = {
  __typename?: 'RoundsShiftNoteSystemChoice';
  assets: Array<RoundsShiftNoteAssetChoice>;
  name: Scalars['String'];
  processId: Scalars['Int'];
};

export enum RuntimeLogLevel {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Fatal = 'FATAL',
  Info = 'INFO',
  Trace = 'TRACE',
  Warn = 'WARN'
}

export type RuntimeLogger = {
  __typename?: 'RuntimeLogger';
  defaults: Array<RuntimeLoggerDefault>;
  name: Scalars['String'];
  override?: Maybe<RuntimeLoggerOverride>;
  overrideStatus: Scalars['String'];
  recent: Scalars['Boolean'];
};

export type RuntimeLoggerDefault = {
  __typename?: 'RuntimeLoggerDefault';
  instanceId: Scalars['String'];
  lastSeenAt: Scalars['DateTime'];
  level: RuntimeLogLevel;
  role: Scalars['String'];
};

export type RuntimeLoggerOverride = {
  __typename?: 'RuntimeLoggerOverride';
  expiresAt: Scalars['DateTime'];
  level: RuntimeLogLevel;
  updatedAt: Scalars['DateTime'];
};

export type RuntimeLoggerSnapshot = {
  __typename?: 'RuntimeLoggerSnapshot';
  available: Scalars['Boolean'];
  complete: Scalars['Boolean'];
  loggers: Array<RuntimeLogger>;
  observedAt?: Maybe<Scalars['DateTime']>;
};

export type SsoConfigurationType = {
  __typename?: 'SSOConfigurationType';
  audience?: Maybe<Scalars['String']>;
  authority: Scalars['String'];
  clientId: Scalars['String'];
  id: Scalars['Int'];
  idpKey: Scalars['String'];
  isNameEditable: Scalars['Boolean'];
  logoSvg?: Maybe<Scalars['String']>;
  scope: Scalars['String'];
  signoutRedirectUrl: Scalars['String'];
  userDirectoryEnabled: Scalars['Boolean'];
};

export type SsoDirectoryUser = {
  __typename?: 'SSODirectoryUser';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  metadataJSON?: Maybe<Scalars['String']>;
};

export type SsoUsersForOrganizationInput = {
  organizationId: Scalars['Int'];
  searchInput: Scalars['String'];
};

export enum SspcmLevel {
  Component = 'COMPONENT',
  Metric = 'METRIC',
  Process = 'PROCESS',
  Site = 'SITE',
  System = 'SYSTEM'
}

export type SampleCollection = {
  __typename?: 'SampleCollection';
  createdAt: Scalars['DateTime'];
  currentCustody?: Maybe<SampleCollectionCustody>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  sampleCollectionResults?: Maybe<Array<SampleCollectionResult>>;
  sampleSite?: Maybe<SampleSite>;
  sampleSiteId: Scalars['UUID'];
  scheduledItemId?: Maybe<Scalars['UUID']>;
  systemId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type SampleCollectionComment = {
  __typename?: 'SampleCollectionComment';
  comment: Scalars['String'];
  commentType: SampleCollectionCommentType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  sampleCollectionId: Scalars['UUID'];
  updatedAt: Scalars['DateTime'];
  user: UserNest;
  userId: Scalars['Int'];
};

export type SampleCollectionCommentArchiveInput = {
  id: Scalars['UUID'];
};

export type SampleCollectionCommentCreateInput = {
  comment: Scalars['String'];
  commentType: SampleCollectionCommentType;
  sampleCollectionId: Scalars['UUID'];
};

export enum SampleCollectionCommentType {
  General = 'GENERAL'
}

export type SampleCollectionCommentUpdateInput = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type SampleCollectionCommentsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SampleCollectionCommentsWhere>;
};

export type SampleCollectionCommentsWhere = {
  commentType?: InputMaybe<SampleCollectionCommentType>;
  id?: InputMaybe<Scalars['UUID']>;
  sampleCollectionId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type SampleCollectionCreateInput = {
  analyteIds?: InputMaybe<Array<Scalars['UUID']>>;
  sampleSiteId: Scalars['UUID'];
  scheduledItemId?: InputMaybe<Scalars['UUID']>;
  systemId: Scalars['Int'];
};

export type SampleCollectionCustodiesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: SampleCollectionCustodiesWhere;
};

export type SampleCollectionCustodiesWhere = {
  createdBy?: InputMaybe<Scalars['Int']>;
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['DateTime'];
  systemIds: Array<Scalars['Int']>;
};

export type SampleCollectionCustodiesWithCount = {
  __typename?: 'SampleCollectionCustodiesWithCount';
  count: Scalars['Int'];
  items: Array<SampleCollectionCustody>;
};

export type SampleCollectionCustody = {
  __typename?: 'SampleCollectionCustody';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  previousCustodyId?: Maybe<Scalars['UUID']>;
  relinquishedBy?: Maybe<Scalars['Int']>;
  relinquishedByUser?: Maybe<UserNest>;
  relinquishedTo: Scalars['Int'];
  relinquishedToUser: UserNest;
  sampleCollectionId: Scalars['UUID'];
  systemId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type SampleCollectionCustodyCreateInput = {
  comment?: InputMaybe<Scalars['String']>;
  relinquishToUserId: Scalars['Int'];
  sampleCollectionIds: Array<Scalars['UUID']>;
  systemId: Scalars['Int'];
};

export type SampleCollectionResult = {
  __typename?: 'SampleCollectionResult';
  analyte?: Maybe<Analyte>;
  analyteId: Scalars['UUID'];
  booleanValue?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  measuredAt?: Maybe<Scalars['DateTime']>;
  numericValue?: Maybe<Scalars['Float']>;
  sampleCollectionId: Scalars['UUID'];
  textValue?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  valueType: ValueType;
};

export type SampleCollectionUpdateInput = {
  analyteIds?: InputMaybe<Array<Scalars['UUID']>>;
  id: Scalars['UUID'];
  sampleSiteId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
};

export type SampleCollectionsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: SampleCollectionsWhere;
};

export type SampleCollectionsWhere = {
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['UUID']>;
  sampleSiteId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['DateTime'];
  systemIds: Array<Scalars['Int']>;
};

export type SampleCollectionsWithCount = {
  __typename?: 'SampleCollectionsWithCount';
  count: Scalars['Int'];
  items: Array<SampleCollection>;
};

export type SampleSchedule = {
  __typename?: 'SampleSchedule';
  analyteGroupId?: Maybe<Scalars['UUID']>;
  analytes: Array<Analyte>;
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['Int'];
  defaultAssignee?: Maybe<UserNest>;
  defaultAssigneeId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  exDates?: Maybe<Array<Scalars['DateTime']>>;
  id: Scalars['UUID'];
  isStackable: Scalars['Boolean'];
  notBeforeUnit?: Maybe<DurationUnit>;
  notBeforeValue?: Maybe<Scalars['Int']>;
  photoRequired: Scalars['Boolean'];
  rDates?: Maybe<Array<Scalars['DateTime']>>;
  recurrenceType: RecurrenceType;
  rrule: Scalars['String'];
  sampleSite?: Maybe<SampleSite>;
  sampleSiteId: Scalars['UUID'];
  sampleType: SampleType;
  siteId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  system: SystemNest;
  systemId: Scalars['Int'];
  targetBeforeUnit?: Maybe<DurationUnit>;
  targetBeforeValue?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SampleScheduleAnalyte = {
  __typename?: 'SampleScheduleAnalyte';
  analyteId: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  sampleScheduleId: Scalars['UUID'];
  updatedAt: Scalars['DateTime'];
};

export type SampleScheduleAnalytesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SampleScheduleAnalytesWhere>;
};

export type SampleScheduleAnalytesWhere = {
  analyteId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  sampleScheduleId?: InputMaybe<Scalars['UUID']>;
};

export type SampleScheduleAnalytesWithCount = {
  __typename?: 'SampleScheduleAnalytesWithCount';
  count: Scalars['Int'];
  items: Array<SampleScheduleAnalyte>;
};

export type SampleSchedulesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SampleSchedulesWhere>;
};

export type SampleSchedulesWhere = {
  activityScheduleTypeId?: InputMaybe<Scalars['String']>;
  analyteGroupIds?: InputMaybe<Array<Scalars['UUID']>>;
  defaultAssigneeId?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['UUID']>;
  recurrenceType?: InputMaybe<RecurrenceType>;
  sampleSiteId?: InputMaybe<Scalars['UUID']>;
  sampleTypes?: InputMaybe<Array<SampleType>>;
  siteId?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  systemIds: Array<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type SampleSchedulesWithCount = {
  __typename?: 'SampleSchedulesWithCount';
  count: Scalars['Int'];
  items: Array<SampleSchedule>;
};

export type SampleSite = {
  __typename?: 'SampleSite';
  address?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  lastInspectionDate?: Maybe<Scalars['DateTime']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  photoUpload?: Maybe<Upload>;
  samplePointType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};

export type SampleSiteCreateInput = {
  address?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  lastInspectionDate?: InputMaybe<Scalars['DateTime']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  photoId?: InputMaybe<Scalars['UUID']>;
  samplePointType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type SampleSiteUpdateInput = {
  address?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  lastInspectionDate?: InputMaybe<Scalars['DateTime']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  photoId?: InputMaybe<Scalars['UUID']>;
  samplePointType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type SampleSiteUpload = {
  __typename?: 'SampleSiteUpload';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  sampleSiteId: Scalars['UUID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadId: Scalars['UUID'];
};

export type SampleSitesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SampleSitesWhere>;
};

export type SampleSitesWhere = {
  createdByUserId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export enum SampleType {
  Compliance = 'COMPLIANCE',
  Process = 'PROCESS',
  Research = 'RESEARCH'
}

export type ScheduledItem = {
  __typename?: 'ScheduledItem';
  assignee?: Maybe<UserNest>;
  assigneeId?: Maybe<Scalars['Int']>;
  comments: Array<ScheduledItemComment>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isStackable: Scalars['Boolean'];
  notBefore?: Maybe<Scalars['DateTime']>;
  photoRequired: Scalars['Boolean'];
  photoUpload?: Maybe<Upload>;
  recurrenceType: RecurrenceType;
  scheduledAt: Scalars['DateTime'];
  sourceScheduleId: Scalars['String'];
  sourceScheduleType: SourceScheduleType;
  status: ScheduledItemStatus;
  system: SystemNest;
  systemId: Scalars['Int'];
  targetDate?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ScheduledItemComment = {
  __typename?: 'ScheduledItemComment';
  comment: Scalars['String'];
  commentType: ScheduledItemCommentType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  scheduledItemId: Scalars['UUID'];
  updatedAt: Scalars['DateTime'];
  user: UserNest;
  userId: Scalars['Int'];
};

export enum ScheduledItemCommentType {
  Complete = 'COMPLETE',
  Defer = 'DEFER',
  General = 'GENERAL',
  Reschedule = 'RESCHEDULE'
}

export type ScheduledItemCommentsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledItemCommentsWhere>;
};

export type ScheduledItemCommentsWhere = {
  commentType?: InputMaybe<ScheduledItemCommentType>;
  id?: InputMaybe<Scalars['UUID']>;
  scheduledItemId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ScheduledItemCount = {
  __typename?: 'ScheduledItemCount';
  count: Scalars['Int'];
};

export enum ScheduledItemStatus {
  Completed = 'COMPLETED',
  Missed = 'MISSED',
  Pending = 'PENDING'
}

export type ScheduledItemUpload = {
  __typename?: 'ScheduledItemUpload';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  scheduledItemId: Scalars['UUID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadId: Scalars['UUID'];
};

export type ScheduledItemsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledItemsWhere>;
};

export type ScheduledItemsWhere = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['DateTime'];
  statuses?: InputMaybe<Array<ScheduledItemStatus>>;
  systemIds: Array<Scalars['Int']>;
  type?: InputMaybe<Array<SourceScheduleType>>;
};

export type ScheduledItemsWithCount = {
  __typename?: 'ScheduledItemsWithCount';
  count: Scalars['Int'];
  items: Array<ScheduledItem>;
};

export enum SelectableIcons {
  Audio = 'Audio',
  AutoAwesome = 'Auto_Awesome',
  Calendar = 'Calendar',
  Chat = 'Chat',
  CleanHands = 'CleanHands',
  Computer = 'Computer',
  Construction = 'Construction',
  Critical = 'Critical',
  Document = 'Document',
  Folder = 'Folder',
  Image = 'Image',
  Info = 'Info',
  Link = 'Link',
  Mail = 'Mail',
  Neutral = 'Neutral',
  None = 'None',
  Notification = 'Notification',
  Phone = 'Phone',
  Restart = 'Restart',
  Success = 'Success',
  SystemUpdate = 'System_Update',
  Video = 'Video',
  Warning = 'Warning'
}

export type SendManualReportEmailInput = {
  attachPdf?: InputMaybe<Scalars['Boolean']>;
  bcc?: InputMaybe<Array<ManualReportEmailAddressInput>>;
  cc?: InputMaybe<Array<ManualReportEmailAddressInput>>;
  comment?: InputMaybe<Scalars['String']>;
  distributionLists?: InputMaybe<Array<ManualReportEmailDistributionListInput>>;
  expiresAt: Scalars['DateTime'];
  reportSnapshotId: Scalars['UUID'];
  subject: Scalars['String'];
  to?: InputMaybe<Array<ManualReportEmailAddressInput>>;
};

export type SendManualReportEmailPayload = {
  __typename?: 'SendManualReportEmailPayload';
  emailEvent: ManualReportEmailEvent;
  publicUrl: Scalars['String'];
  reportSnapshot: ReportSnapshot;
  shareLinkId: Scalars['UUID'];
};

export type SetRuntimeLoggerOverrideInput = {
  durationMinutes: Scalars['Int'];
  level: RuntimeLogLevel;
  name: Scalars['String'];
};

export type SiteDataEntriesCollectionType = {
  __typename?: 'SiteDataEntriesCollectionType';
  current: MetricDataPointType;
  id: Scalars['ID'];
  metricId: Scalars['Int'];
};

export type SiteDataEntriesDayDataPointType = {
  __typename?: 'SiteDataEntriesDayDataPointType';
  appliedAt: Scalars['DateTime'];
  dataPoint?: Maybe<TsDataPoint>;
  id: Scalars['ID'];
  intervalId?: Maybe<Scalars['Int']>;
  reportDate: Scalars['String'];
  time?: Maybe<Scalars['String']>;
};

export type SiteDataEntriesDayType = {
  __typename?: 'SiteDataEntriesDayType';
  dataPoints: Array<SiteDataEntriesDayDataPointType>;
  id: Scalars['ID'];
  metricId: Scalars['Int'];
  metricType: MetricDataTypeEnum;
};

export type SiteDataEntriesHistoryCollectionType = {
  __typename?: 'SiteDataEntriesHistoryCollectionType';
  history: Array<MetricDataPointType>;
  id: Scalars['ID'];
  metricId: Scalars['Int'];
};

export type SiteDataEntryChangeType = {
  __typename?: 'SiteDataEntryChangeType';
  dataPoint: MetricDataPointType;
  entryIntervalDate?: Maybe<Scalars['String']>;
  entryIntervalTime?: Maybe<Scalars['String']>;
};

export type SiteDataEntryCompletionByDate = {
  __typename?: 'SiteDataEntryCompletionByDate';
  dailyCompletion: SiteIntervalCompletionStatus;
  intervalCompletions: Array<SiteIntervalCompletionStatus>;
  site: SiteNest;
};

export type SiteDataEntryCompletionByDateInput = {
  reportDate: Scalars['DateTime'];
  siteIds: Array<Scalars['Int']>;
};

export type SiteFlexMetric = {
  __typename?: 'SiteFlexMetric';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  folderViewOrder: Scalars['Int'];
  id: Scalars['UUID'];
  metric?: Maybe<MetricNest>;
  metricId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  siteId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type SiteFlexMetricDeleteInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type SiteFlexMetricRestoreInput = {
  id: Scalars['UUID'];
};

export type SiteFlexMetricUpdateInput = {
  folderViewOrder?: InputMaybe<Scalars['Int']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
};

export type SiteFlexMetricWithParentSite = {
  __typename?: 'SiteFlexMetricWithParentSite';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  folderViewOrder: Scalars['Int'];
  id: Scalars['UUID'];
  metric?: Maybe<MetricNest>;
  metricId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  parentSite: SiteNest;
  required: Scalars['Boolean'];
  siteId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type SiteFlexMetricsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: SiteFlexMetricsWhere;
};

export type SiteFlexMetricsUpdateInput = {
  inputs: Array<SiteFlexMetricUpdateInput>;
};

export type SiteFlexMetricsWhere = {
  id?: InputMaybe<Scalars['UUID']>;
  metricId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  siteId: Scalars['Int'];
};

export type SiteIntervalCompletionStatus = {
  __typename?: 'SiteIntervalCompletionStatus';
  dataEntryCompletion?: Maybe<DataEntryCompletion>;
  hasRequiredMetrics: Scalars['Boolean'];
  interval?: Maybe<IntervalNest>;
};

export type SiteNest = {
  __typename?: 'SiteNest';
  addresses: Array<Address>;
  components: Array<ComponentNest>;
  createdAt: Scalars['DateTime'];
  dataEntryCompletionEmail: DataEntryCompletionEmailOption;
  dataEntryCompletionEnabled: Scalars['Boolean'];
  dataModelSite?: Maybe<SiteNest>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  displayNameBreadcrumbs: Array<Breadcrumb>;
  emoji?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalMetadata?: Maybe<Scalars['JSON']>;
  externalOwner?: Maybe<Scalars['String']>;
  flex: Scalars['Boolean'];
  foldersWithMetricIdsAndOrder: Array<FolderWithMetricIdsAndOrder>;
  fullName: Scalars['String'];
  id: Scalars['Int'];
  intervals: Array<IntervalNest>;
  isEntry: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  licenseId?: Maybe<Scalars['Int']>;
  longitude?: Maybe<Scalars['Float']>;
  metrics: Array<MetricNest>;
  mirrorSiteId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  npdesPermitNumber?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  phoneNumber?: Maybe<PhoneNumberNest>;
  phoneNumberId?: Maybe<Scalars['Int']>;
  processes: Array<ProcessNest>;
  siteFlexMetricsWithParentSite?: Maybe<Array<SiteFlexMetricWithParentSite>>;
  siteType: Scalars['String'];
  sourceMetrics: Array<MetricWithCalculatedMetric>;
  systemId: Scalars['Int'];
  /** @deprecated No longer in use */
  timeSeriesEnabled: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};


export type SiteNestComponentsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type SiteNestFoldersWithMetricIdsAndOrderArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type SiteNestIntervalsArgs = {
  entryDate?: InputMaybe<Scalars['Date']>;
};


export type SiteNestMetricsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};


export type SiteNestProcessesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type SiteNestSiteFlexMetricsWithParentSiteArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type SiteOutOfIdealRangeMetricType = {
  __typename?: 'SiteOutOfIdealRangeMetricType';
  metric: MetricType;
  outOfIdealRange: Array<TsDataPoint>;
};

export type SiteOutOfRangeMetricType = {
  __typename?: 'SiteOutOfRangeMetricType';
  metric: MetricType;
  outOfRange: Array<TsDataPoint>;
};

export type SiteType = {
  __typename?: 'SiteType';
  addresses: Array<Address>;
  dataEntries: Array<SiteDataEntriesCollectionType>;
  dataEntriesDay: Array<SiteDataEntriesDayType>;
  dataEntriesHistory: Array<SiteDataEntriesHistoryCollectionType>;
  dataEntryCompletionEmail?: Maybe<DataEntryCompletionEmailOption>;
  dataEntryCompletionEnabled?: Maybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  emoji?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalMetadataJSON?: Maybe<Scalars['String']>;
  externalOwner?: Maybe<Scalars['String']>;
  flex?: Maybe<Scalars['Boolean']>;
  fullName: Scalars['String'];
  hasIntervals?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  intervals: Array<Interval>;
  isEntry?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['Latitude']>;
  licenseId?: Maybe<Scalars['Int']>;
  longitude?: Maybe<Scalars['Longitude']>;
  metrics: Array<MetricType>;
  name?: Maybe<Scalars['String']>;
  /** NPDES Permit Number - National permists searchable at https://www.epa.gov/npdes-permits */
  npdesPermitNumber?: Maybe<Scalars['String']>;
  operator?: Maybe<UserInfoType>;
  operatorId?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  outOfIdealRangeMetrics: Array<SiteOutOfIdealRangeMetricType>;
  outOfRangeMetrics: Array<SiteOutOfRangeMetricType>;
  phoneNumber?: Maybe<PhoneNumberNest>;
  phoneNumberId?: Maybe<Scalars['Int']>;
  processes: Array<ProcessType>;
  siteType?: Maybe<SiteTypeEnum>;
  system: SystemType;
  systemId: Scalars['Int'];
};


export type SiteTypeDataEntriesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  intervalIds?: InputMaybe<Array<Scalars['Int']>>;
  reportDate: Scalars['Date'];
};


export type SiteTypeDataEntriesDayArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  intervalIds: Array<Scalars['Int']>;
  reportDate: Scalars['Date'];
};


export type SiteTypeDataEntriesHistoryArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  intervalIds?: InputMaybe<Array<Scalars['Int']>>;
  reportDate: Scalars['Date'];
};


export type SiteTypeOutOfIdealRangeMetricsArgs = {
  endDateTime: Scalars['Timestamp'];
  startDateTime: Scalars['Timestamp'];
};


export type SiteTypeOutOfRangeMetricsArgs = {
  endDateTime: Scalars['Timestamp'];
  startDateTime: Scalars['Timestamp'];
};


export type SiteTypeProcessesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

/** Site Types */
export enum SiteTypeEnum {
  BoosterPumpStation = 'BOOSTER_PUMP_STATION',
  ElevatedStorage = 'ELEVATED_STORAGE',
  Generic = 'GENERIC',
  GraywaterStation = 'GRAYWATER_STATION',
  GroundWaterPlant = 'GROUND_WATER_PLANT',
  Industrial = 'INDUSTRIAL',
  LiftStation = 'LIFT_STATION',
  PressureReducingStation = 'PRESSURE_REDUCING_STATION',
  StormwaterStation = 'STORMWATER_STATION',
  Summary = 'SUMMARY',
  SurfaceWaterPlant = 'SURFACE_WATER_PLANT',
  SystemInterconnect = 'SYSTEM_INTERCONNECT',
  WastewaterMeteringStation = 'WASTEWATER_METERING_STATION',
  WastewaterMultipleTypes = 'WASTEWATER_MULTIPLE_TYPES',
  WastewaterTreatmentPlant = 'WASTEWATER_TREATMENT_PLANT',
  WaterMonitoringStation = 'WATER_MONITORING_STATION',
  WaterMultipleTypes = 'WATER_MULTIPLE_TYPES',
  Well = 'WELL'
}

export type SiteUpdateInput = {
  dataEntryCompletionEmail?: InputMaybe<DataEntryCompletionEmailOption>;
  dataEntryCompletionEnabled?: InputMaybe<Scalars['Boolean']>;
  emoji?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isEntry?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Latitude']>;
  licenseId?: InputMaybe<Scalars['Int']>;
  longitude?: InputMaybe<Scalars['Longitude']>;
  name?: InputMaybe<Scalars['String']>;
  npdesPermitNumber?: InputMaybe<Scalars['String']>;
  operatorId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  phoneNumberId?: InputMaybe<Scalars['Int']>;
  siteType?: InputMaybe<Scalars['String']>;
};

export type SiteWithProcesses = {
  __typename?: 'SiteWithProcesses';
  addresses: Array<Address>;
  components: Array<ComponentNest>;
  createdAt: Scalars['DateTime'];
  dataEntryCompletionEmail: DataEntryCompletionEmailOption;
  dataEntryCompletionEnabled: Scalars['Boolean'];
  dataModelSite?: Maybe<SiteNest>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  displayNameBreadcrumbs: Array<Breadcrumb>;
  emoji?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalMetadata?: Maybe<Scalars['JSON']>;
  externalOwner?: Maybe<Scalars['String']>;
  flex: Scalars['Boolean'];
  foldersWithMetricIdsAndOrder: Array<FolderWithMetricIdsAndOrder>;
  fullName: Scalars['String'];
  id: Scalars['Int'];
  intervals: Array<IntervalNest>;
  isEntry: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  licenseId?: Maybe<Scalars['Int']>;
  longitude?: Maybe<Scalars['Float']>;
  metrics: Array<MetricNest>;
  mirrorSiteId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  npdesPermitNumber?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  phoneNumber?: Maybe<PhoneNumberNest>;
  phoneNumberId?: Maybe<Scalars['Int']>;
  processes: Array<ProcessWithComponentsAndMetrics>;
  siteFlexMetricsWithParentSite?: Maybe<Array<SiteFlexMetricWithParentSite>>;
  siteType: Scalars['String'];
  sourceMetrics: Array<MetricWithCalculatedMetric>;
  systemId: Scalars['Int'];
  /** @deprecated No longer in use */
  timeSeriesEnabled: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};


export type SiteWithProcessesComponentsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type SiteWithProcessesFoldersWithMetricIdsAndOrderArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type SiteWithProcessesIntervalsArgs = {
  entryDate?: InputMaybe<Scalars['Date']>;
};


export type SiteWithProcessesMetricsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};


export type SiteWithProcessesSiteFlexMetricsWithParentSiteArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type SitesInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SitesWhere>;
};

export type SitesWhere = {
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type SnoozeAllOrgRetentionRisksInput = {
  date: Scalars['DateTime'];
  orgId: Scalars['Int'];
};

export type SnoozeRetentionRiskInput = {
  date: Scalars['DateTime'];
  id: Scalars['UUID'];
};

export enum SourceScheduleType {
  Activity = 'ACTIVITY',
  ChemicalReceiving = 'CHEMICAL_RECEIVING',
  Samples = 'SAMPLES'
}

export type SsoConfigurationNest = {
  __typename?: 'SsoConfigurationNest';
  audience?: Maybe<Scalars['String']>;
  authority: Scalars['String'];
  clientId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  facilitySearchUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  idpKey: Scalars['String'];
  isNameEditable: Scalars['Boolean'];
  issuer?: Maybe<Scalars['String']>;
  logoSvg?: Maybe<Scalars['String']>;
  provisioner?: Maybe<Scalars['String']>;
  scope: Scalars['String'];
  signoutRedirectUrl: Scalars['String'];
  systemSearchUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userDirectoryAuthVaultEntry?: Maybe<Scalars['String']>;
  userDirectoryEnabled: Scalars['Boolean'];
  userDirectorySearchUrl?: Maybe<Scalars['String']>;
};

export type StartMirroringInput = {
  siteId: Scalars['Int'];
  sourceSiteId: Scalars['Int'];
};

export type StopMirroringInput = {
  siteId: Scalars['Int'];
};

export type SubmitSiteRecalculationInput = {
  allMetrics?: InputMaybe<Scalars['Boolean']>;
  componentId?: InputMaybe<Scalars['Int']>;
  endDate: Scalars['Date'];
  includeInterpolatedMetrics?: InputMaybe<Scalars['Boolean']>;
  processId?: InputMaybe<Scalars['Int']>;
  siteId: Scalars['Int'];
  startDate: Scalars['Date'];
};

export type Subscription = {
  __typename?: 'Subscription';
  onAuditEventPublished: AuditEventNest;
  onCalcQueueJobsPublished: JobEvent;
  onCalcQueueStatsPublished: QueueStats;
  onDataEntryCompletionPublished: DataEntryCompletion;
  onLogBookEntryPublished: LogBookEntryNest;
  onNotificationPublished?: Maybe<Notification>;
  onScheduledItemPublished: ScheduledItem;
  onSiteDataEntryChanged: SiteDataEntryChangeType;
};


export type SubscriptionOnAuditEventPublishedArgs = {
  accessToken: Scalars['String'];
  input: AuditEventSubscriptionInput;
};


export type SubscriptionOnCalcQueueJobsPublishedArgs = {
  filter?: InputMaybe<JobsFilterInput>;
};


export type SubscriptionOnCalcQueueStatsPublishedArgs = {
  accessToken: Scalars['String'];
};


export type SubscriptionOnDataEntryCompletionPublishedArgs = {
  accessToken: Scalars['String'];
  siteId: Scalars['Float'];
};


export type SubscriptionOnLogBookEntryPublishedArgs = {
  accessToken: Scalars['String'];
  siteId: Scalars['Float'];
};


export type SubscriptionOnScheduledItemPublishedArgs = {
  accessToken: Scalars['String'];
};


export type SubscriptionOnSiteDataEntryChangedArgs = {
  accessToken: Scalars['String'];
  intervalIds?: InputMaybe<Array<Scalars['Int']>>;
  reportDate: Scalars['DateType'];
  siteId: Scalars['Int'];
  subscriptionClientId: Scalars['String'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  id: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SystemGroupInput = {
  systemGroupId: Scalars['Int'];
};

export enum SystemGroupRoleEnum {
  Admin = 'Admin',
  Editor = 'Editor',
  NoAccess = 'NoAccess',
  ReadOnly = 'ReadOnly',
  Supervisor = 'Supervisor'
}

export type SystemGroupType = {
  __typename?: 'SystemGroupType';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  isTopLevel: Scalars['Boolean'];
  name: Scalars['String'];
  organization: OrganizationType;
  organizationId: Scalars['Int'];
  parentSystemGroup?: Maybe<SystemGroupType>;
  parentSystemGroupId?: Maybe<Scalars['Int']>;
  systemGroups: Array<SystemGroupType>;
  systems: Array<SystemType>;
  users: Array<UserInfoType>;
};

export type SystemGroupsInput = {
  where: SystemGroupsWhere;
};

export type SystemGroupsWhere = {
  organizationId: Scalars['Int'];
};

export type SystemNest = {
  __typename?: 'SystemNest';
  addresses: Array<Address>;
  displayName: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  externalMetadata?: Maybe<Scalars['JSON']>;
  externalOwner?: Maybe<Scalars['String']>;
  hideDataSites: Scalars['Boolean'];
  id: Scalars['Int'];
  isFavorite?: Maybe<Scalars['Boolean']>;
  isTemplate: Scalars['Boolean'];
  licenseId?: Maybe<Scalars['Int']>;
  myRole: SystemGroupRoleEnum;
  name: Scalars['String'];
  operator?: Maybe<UserNest>;
  operatorId?: Maybe<Scalars['Int']>;
  organization: OrganizationNest;
  organizationId: Scalars['Int'];
  parentSystemGroupId: Scalars['Int'];
  permits: Array<Permit>;
  phoneNumber?: Maybe<PhoneNumberNest>;
  phoneNumberId?: Maybe<Scalars['Int']>;
  regulatoryId?: Maybe<Scalars['String']>;
  timeZone: Scalars['String'];
  type: Scalars['String'];
  userDirectoryEnabled: Scalars['Boolean'];
  users: Array<UserNest>;
};


export type SystemNestUsersArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The Role of a User
 * TODO: When we move from schema-first sdl to the code-first nestJS method,
 * we can register the `SystemRole` enum from waterly/utils and remove this one to prevent duplication.
 */
export enum SystemRoleType {
  /** Never should be set, NoAccess is a default response when no role is set in the db. */
  NoAccess = 'NoAccess',
  Operator = 'Operator',
  ReadOnly = 'ReadOnly',
  Supervisor = 'Supervisor',
  Unknown = 'Unknown'
}

export type SystemType = {
  __typename?: 'SystemType';
  addresses: Array<Address>;
  components: Array<ComponentType>;
  displayName: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  externalMetadataJSON?: Maybe<Scalars['String']>;
  externalOwner?: Maybe<Scalars['String']>;
  hasSitesWithIntervals: Scalars['Boolean'];
  hideDataSites: Scalars['Boolean'];
  id: Scalars['Int'];
  isFavorite: Scalars['Boolean'];
  isTemplate: Scalars['Boolean'];
  licenseId?: Maybe<Scalars['Int']>;
  metrics: Array<MetricType>;
  /**
   * Role for the current user, as it applies to this system.
   * Users with the `superadmin` flag always return as Supervisor
   */
  myRole: SystemGroupRoleEnum;
  name: Scalars['String'];
  operator?: Maybe<UserInfoType>;
  operatorId?: Maybe<Scalars['Int']>;
  organization: OrganizationType;
  organizationId: Scalars['Int'];
  parentSystemGroup?: Maybe<SystemGroupType>;
  parentSystemGroupId?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<PhoneNumberNest>;
  phoneNumberId?: Maybe<Scalars['Int']>;
  processes: Array<ProcessType>;
  regulatoryId?: Maybe<Scalars['String']>;
  sites: Array<SiteType>;
  timeZone: Scalars['TimeZone'];
  type?: Maybe<SystemTypeEnum>;
  userDirectoryEnabled: Scalars['Boolean'];
  users: Array<UserInfoType>;
};


export type SystemTypeUsersArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export enum SystemTypeEnum {
  Administrative = 'ADMINISTRATIVE',
  Greywater = 'GREYWATER',
  Industrial = 'INDUSTRIAL',
  Stormwater = 'STORMWATER',
  Unknown = 'UNKNOWN',
  Wastewater = 'WASTEWATER',
  Water = 'WATER'
}

export type SystemWithSites = {
  __typename?: 'SystemWithSites';
  addresses: Array<Address>;
  externalId?: Maybe<Scalars['String']>;
  externalMetadata?: Maybe<Scalars['JSON']>;
  externalOwner?: Maybe<Scalars['String']>;
  hideDataSites: Scalars['Boolean'];
  id: Scalars['Int'];
  isFavorite?: Maybe<Scalars['Boolean']>;
  isTemplate: Scalars['Boolean'];
  licenseId?: Maybe<Scalars['Int']>;
  myRole: SystemGroupRoleEnum;
  name: Scalars['String'];
  operator?: Maybe<UserNest>;
  operatorId?: Maybe<Scalars['Int']>;
  organization: OrganizationNest;
  organizationId: Scalars['Int'];
  parentSystemGroupId: Scalars['Int'];
  permits: Array<Permit>;
  phoneNumber?: Maybe<PhoneNumberNest>;
  phoneNumberId?: Maybe<Scalars['Int']>;
  regulatoryId?: Maybe<Scalars['String']>;
  sites: Array<SiteWithProcesses>;
  timeZone: Scalars['String'];
  type: Scalars['String'];
  userDirectoryEnabled: Scalars['Boolean'];
  users: Array<UserNest>;
};


export type SystemWithSitesUsersArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type SystemsInput = {
  where?: InputMaybe<SystemsWhere>;
};

export type SystemsWhere = {
  minRoleRequired?: InputMaybe<SystemRoleType>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type TsDataPoint = {
  __typename?: 'TSDataPoint';
  appliedAt: Scalars['DateTime'];
  booleanValue?: Maybe<Scalars['Boolean']>;
  calculatedNondetectValue?: Maybe<Scalars['Boolean']>;
  calculatedValue?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  connectValue?: Maybe<Scalars['String']>;
  dateTimeValue?: Maybe<Scalars['String']>;
  dateValue?: Maybe<Scalars['String']>;
  edgeDeviceSubmissionId?: Maybe<Scalars['Int']>;
  effectiveNumericValue?: Maybe<Scalars['Float']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intervalId?: Maybe<Scalars['Int']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isCalculatedResult?: Maybe<Scalars['Boolean']>;
  isInterpolated: Scalars['Boolean'];
  isNondetect: Scalars['Boolean'];
  journalEntryRecordId: Scalars['ID'];
  jsonValue?: Maybe<Scalars['String']>;
  locatorEntityId: Scalars['String'];
  locatorEntityType: Scalars['String'];
  locatorNamespace: Scalars['String'];
  measuredAt: Scalars['DateTime'];
  metaData: TsDataPointMetadata;
  metricId: Scalars['Int'];
  numericValue?: Maybe<Scalars['Float']>;
  reportDate: Scalars['String'];
  storedAt: Scalars['DateTime'];
  textValue?: Maybe<Scalars['String']>;
  timeValue?: Maybe<Scalars['String']>;
  type: MetricDataTypeEnum;
  value?: Maybe<Scalars['String']>;
  valueType: TsDataPointValueType;
};

export type TsDataPointMetadata = {
  __typename?: 'TSDataPointMetadata';
  connectValue?: Maybe<Scalars['String']>;
  edgeDeviceSubmissionId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  intervalId?: Maybe<Scalars['Int']>;
  reportDate: Scalars['String'];
};

export enum TsDataPointValueType {
  Boolean = 'boolean',
  Date = 'date',
  DateTime = 'date_time',
  Image = 'image',
  Json = 'json',
  Numeric = 'numeric',
  Text = 'text',
  Time = 'time',
  UserSelect = 'user_select'
}

export type Tag = {
  __typename?: 'Tag';
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  displayName: Scalars['String'];
  id: Scalars['UUID'];
  keynameTagCount: Scalars['Int'];
  logBookEntryTagCount: Scalars['Int'];
  name: Scalars['String'];
  nameEs?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationNest>;
  organizationId?: Maybe<Scalars['Int']>;
  reportTagCount: Scalars['Int'];
  type: TagType;
  updatedAt: Scalars['DateTime'];
};

export type TagMappingType = {
  __typename?: 'TagMappingType';
  edgeDevice?: Maybe<EdgeDeviceNest>;
  edgeDeviceId: Scalars['Int'];
  id: Scalars['Int'];
  metric: MetricNest;
  metricId: Scalars['Int'];
  site: SiteNest;
  system: SystemNest;
  tagName: Scalars['String'];
};

export type TagMappingsInput = {
  order: TagMappingsOrder;
  where: TagMappingsWhere;
};

export type TagMappingsOrder = {
  direction?: InputMaybe<Scalars['String']>;
  skip: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
};

export type TagMappingsResult = {
  __typename?: 'TagMappingsResult';
  data: Array<TagMappingType>;
  id: Scalars['ID'];
  total: Scalars['Int'];
};

export type TagMappingsWhere = {
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
};

export enum TagType {
  All = 'ALL',
  Keyname = 'KEYNAME',
  LogBook = 'LOG_BOOK',
  MetricRange = 'METRIC_RANGE',
  Report = 'REPORT'
}

export type TagsInput = {
  includeGlobal?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: TagsWhere;
};

export type TagsWhere = {
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  organizationIds: Array<Scalars['Int']>;
  types?: InputMaybe<Array<TagType>>;
};

export type TagsWithCount = {
  __typename?: 'TagsWithCount';
  count: Scalars['Int'];
  items: Array<Tag>;
};

export enum TimeFormatEnum {
  Military = 'MILITARY',
  Standard = 'STANDARD',
  TrueMilitary = 'TRUE_MILITARY'
}

export type TransactionInfoWithCalcClusterDebugLogs = {
  __typename?: 'TransactionInfoWithCalcClusterDebugLogs';
  id: Scalars['UUID'];
  logs: Array<CalcClusterDebugLog>;
  originTimestamp: Scalars['DateTime'];
  transactionId: Scalars['UUID'];
};

export type TransferComponentInput = {
  componentId: Scalars['Int'];
  processId: Scalars['Int'];
};

export type TransferMetricInput = {
  metricId: Scalars['Int'];
  targetComponentId?: InputMaybe<Scalars['Int']>;
  targetProcessId: Scalars['Int'];
  targetSiteId: Scalars['Int'];
};

export type TransferMetricToFolderInput = {
  destinationFolderId: Scalars['UUID'];
  metricId: Scalars['Int'];
  oldFolderId: Scalars['UUID'];
  siteId: Scalars['Int'];
};

export type TransferSystemInput = {
  systemId: Scalars['Int'];
  targetOrganizationId: Scalars['Int'];
  targetSystemGroupId?: InputMaybe<Scalars['Int']>;
};

export type TrendNest = {
  __typename?: 'TrendNest';
  id: Scalars['Int'];
  isGlobal: Scalars['Boolean'];
  keynameFilters: Array<Scalars['String']>;
  name: Scalars['String'];
  owner: UserNest;
  ownerId: Scalars['Int'];
  resolvedMetricIds: Array<Scalars['Int']>;
  system?: Maybe<SystemNest>;
  systemId?: Maybe<Scalars['Int']>;
  systemType: SystemTypeEnum;
};


export type TrendNestResolvedMetricIdsArgs = {
  systemId: Scalars['Int'];
};

export type TrendsQueryInput = {
  systemId: Scalars['Int'];
};

export type TriggerAnalyticsReportSnapshotInput = {
  bindings?: InputMaybe<Scalars['JSONObject']>;
  configFileName?: InputMaybe<Scalars['String']>;
  enterpriseReportId: Scalars['UUID'];
  mode?: AnalyticsReportRunMode;
  reportDateTime?: InputMaybe<Scalars['DateTime']>;
  snapshotConfig?: InputMaybe<Scalars['JSONObject']>;
  snapshotId?: InputMaybe<Scalars['UUID']>;
  successStatus?: InputMaybe<ReportStatus>;
};

/** A US State */
export enum UsStateEnum {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type UnitCreateInput = {
  isInterpolatable?: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UnitNest = {
  __typename?: 'UnitNest';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isInterpolatable: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type UnitType = {
  __typename?: 'UnitType';
  id: Scalars['Int'];
  isInterpolatable: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UnitTypeInput = {
  id?: InputMaybe<Scalars['Int']>;
  isInterpolatable: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UnitUpdateInput = {
  id: Scalars['Int'];
  isInterpolatable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UnitsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UnitsWhere>;
};

export type UnitsWhere = {
  id?: InputMaybe<Scalars['Int']>;
  isInterpolatable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  label?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<AddressPurpose>;
  recipientName?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

export type UpdateColumnGroupInput = {
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateColumnGroupItemInput = {
  aggregation?: InputMaybe<ColumnAggregation>;
  calculationType?: InputMaybe<ColumnCalculation>;
  id: Scalars['UUID'];
  intervalId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sourceMetricIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type UpdateComponentsInput = {
  components: Array<ComponentUpdateInput>;
};

export type UpdateConstantDefinitionInput = {
  dataType?: InputMaybe<ConstantDataType>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  keyname?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  precision?: InputMaybe<Scalars['Int']>;
  unitId?: InputMaybe<Scalars['Int']>;
};

export type UpdateEdgeDeviceNestInput = {
  deviceName?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<EdgeDeviceTypeNest>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  organizationId?: InputMaybe<Scalars['Int']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type UpdateEnterpriseReportShareLinkInput = {
  expiresAt: Scalars['DateTime'];
  id: Scalars['UUID'];
};

export type UpdateEnterpriseReportShareLinkPayload = {
  __typename?: 'UpdateEnterpriseReportShareLinkPayload';
  publicUrl: Scalars['String'];
  shareLink: EnterpriseReportShareLink;
};

export type UpdateFolderInput = {
  color?: InputMaybe<Scalars['String']>;
  folderId: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type UpdateFoldersInput = {
  folders: Array<UpdateFolderInput>;
};

export type UpdateLicenseInput = {
  authority?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  licenseLabel?: InputMaybe<Scalars['String']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateLogBookEntryDashboardViewInput = {
  id: Scalars['UUID'];
  message?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['Int']>;
  siteIds?: InputMaybe<Array<Scalars['Int']>>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type UpdateLogBookEntryInput = {
  id: Scalars['UUID'];
  message?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateMetricForReportInput = {
  enabled: Scalars['Boolean'];
  intervalId?: InputMaybe<Scalars['Int']>;
  metricId: Scalars['Int'];
  reportDefinitionId: Scalars['Int'];
};

export type UpdateMetricInput = {
  belowRlValue?: InputMaybe<Scalars['Float']>;
  calculated?: InputMaybe<Scalars['Boolean']>;
  calculationName?: InputMaybe<Scalars['String']>;
  canBeAveraged?: InputMaybe<CanBeAveraged>;
  canBeCounted?: InputMaybe<Scalars['Boolean']>;
  canBeMaximized?: InputMaybe<Scalars['Boolean']>;
  canBeMinimized?: InputMaybe<Scalars['Boolean']>;
  canBeTotaled?: InputMaybe<Scalars['Boolean']>;
  componentId?: InputMaybe<Scalars['Int']>;
  copyPreviousValueEnabled?: InputMaybe<Scalars['Boolean']>;
  dataPointCommentPolicy?: InputMaybe<DataPointCommentPolicy>;
  dataType?: InputMaybe<MetricDataTypeEnum>;
  detectionLimit?: InputMaybe<Scalars['Float']>;
  expression?: InputMaybe<Scalars['String']>;
  hideFromDataEntry?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  internalKeyname?: InputMaybe<Scalars['String']>;
  interpolated?: InputMaybe<Scalars['Boolean']>;
  intervalIds?: InputMaybe<Array<Scalars['Int']>>;
  isDecreasing?: InputMaybe<Scalars['Boolean']>;
  isIncreasing?: InputMaybe<Scalars['Boolean']>;
  isLockedByWaterly?: InputMaybe<Scalars['Boolean']>;
  isReportComments?: InputMaybe<Scalars['Boolean']>;
  keynameId?: InputMaybe<Scalars['String']>;
  maxValue?: InputMaybe<Scalars['BigInt']>;
  minValue?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEnabled?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  precision?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  rangeMax?: InputMaybe<Scalars['Float']>;
  rangeMin?: InputMaybe<Scalars['Float']>;
  reportingLimit?: InputMaybe<Scalars['Float']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sourceMetricIds?: InputMaybe<Array<Scalars['Int']>>;
  treatBelowRlAsPercent?: InputMaybe<Scalars['Boolean']>;
  unitId?: InputMaybe<Scalars['Int']>;
};

export type UpdateMetricsInput = {
  inputs: Array<UpdateMetricInput>;
};

export type UpdateNotificationInput = {
  appearance: NotificationAppearance;
  dismissable?: InputMaybe<Scalars['Boolean']>;
  displayPosition: NotificationDisplayPosition;
  endDate?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<SelectableIcons>;
  message: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  notificationId: Scalars['UUID'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  systemGroupId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganizationInput = {
  dateFormat?: InputMaybe<OrganizationDateFormat>;
  fiscalYearStartDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  selfServiceEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOrganizationIntegrationInput = {
  id: Scalars['Int'];
  token?: InputMaybe<Scalars['String']>;
};

export type UpdatePhoneNumberInput = {
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UpdatePhraseInput = {
  bodyText?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateProcessForReportInput = {
  enabled: Scalars['Boolean'];
  processId: Scalars['Int'];
};

export type UpdateProcessesInput = {
  processes: Array<ProcessUpdateInput>;
};

export type UpdateReportDefinitionInput = {
  annualPeriod?: InputMaybe<Scalars['String']>;
  configSchemaId?: InputMaybe<Scalars['String']>;
  customFooter?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<ReportDefinitionFieldChange>>;
  id: Scalars['Int'];
  metadata?: InputMaybe<Scalars['JSONObject']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  paperOrientation?: InputMaybe<PaperOrientationEnum>;
  paperSize?: InputMaybe<PaperSizeEnum>;
  reportGroupId?: InputMaybe<Scalars['Int']>;
  reportTemplateId?: InputMaybe<Scalars['Int']>;
  showDayOfWeek?: InputMaybe<Scalars['Boolean']>;
  supplementaryEnabled?: InputMaybe<Scalars['Boolean']>;
  timeFormat?: InputMaybe<TimeFormatEnum>;
};

export type UpdateReportDistributionListInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  members?: InputMaybe<Array<ReportDistributionListMemberInput>>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateReportNodeInput = {
  id: Scalars['UUID'];
  order?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateReportNodesInput = {
  updateReportNodeInputs: Array<UpdateReportNodeInput>;
};

export type UpdateReportingReportDefinitionGroupAssignmentInput = {
  id: Scalars['Int'];
  order: Scalars['Int'];
  reportGroupId?: InputMaybe<Scalars['Int']>;
};

export type UpdateReportingReportDefinitionGroupsInput = {
  inputs: Array<UpdateReportingReportDefinitionGroupAssignmentInput>;
};

export type UpdateReportingReportGroupInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type UpdateSampleScheduleInput = {
  analyteGroupId?: InputMaybe<Scalars['UUID']>;
  analyteIds?: InputMaybe<Array<Scalars['UUID']>>;
  defaultAssigneeId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isStackable?: InputMaybe<Scalars['Boolean']>;
  notBeforeUnit?: InputMaybe<DurationUnit>;
  notBeforeValue?: InputMaybe<Scalars['Int']>;
  photoRequired?: InputMaybe<Scalars['Boolean']>;
  recurrenceType?: InputMaybe<RecurrenceType>;
  rrule?: InputMaybe<Scalars['String']>;
  sampleSiteId?: InputMaybe<Scalars['UUID']>;
  sampleType?: InputMaybe<SampleType>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
  targetBeforeUnit?: InputMaybe<DurationUnit>;
  targetBeforeValue?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateScheduledItemCommentInput = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type UpdateScheduledItemInput = {
  assigneeId?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  commentType?: InputMaybe<ScheduledItemCommentType>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  notBefore?: InputMaybe<Scalars['DateTime']>;
  photoId?: InputMaybe<Scalars['UUID']>;
  photoRequired?: InputMaybe<Scalars['Boolean']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<ScheduledItemStatus>;
  systemId?: InputMaybe<Scalars['Int']>;
  targetDate?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateSiteComponentInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  metrics?: InputMaybe<Array<UpdateSiteMetricInput>>;
  name: Scalars['String'];
  order: Scalars['Int'];
};

export type UpdateSiteMetricInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  order: Scalars['Int'];
};

export type UpdateSiteProcessInput = {
  components?: InputMaybe<Array<UpdateSiteComponentInput>>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  metrics?: InputMaybe<Array<UpdateSiteMetricInput>>;
  name: Scalars['String'];
  order: Scalars['Int'];
};

export type UpdateSiteStructureInput = {
  id: Scalars['Int'];
  processes: Array<UpdateSiteProcessInput>;
};

export type UpdateSitesInput = {
  sites: Array<SiteUpdateInput>;
};

export type UpdateSystemGroupInput = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  parentSystemGroupId?: InputMaybe<Scalars['Int']>;
};

export type UpdateSystemInput = {
  address?: InputMaybe<UpsertAddressInput>;
  externalId?: InputMaybe<Scalars['String']>;
  externalOwner?: InputMaybe<Scalars['String']>;
  hideDataSites?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  licenseId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  operatorId?: InputMaybe<Scalars['Int']>;
  parentSystemGroupId?: InputMaybe<Scalars['Int']>;
  phoneNumberId?: InputMaybe<Scalars['Int']>;
  publicWaterSystemIdPermit?: InputMaybe<PublicWaterSystemIdPermitInput>;
  regulatoryId?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['TimeZone']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateTagInput = {
  color?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameEs?: InputMaybe<Scalars['String']>;
  tagId: Scalars['UUID'];
  type?: InputMaybe<TagType>;
};

export type UpdateTrendInput = {
  id: Scalars['Int'];
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  keynameFilters?: InputMaybe<Array<Scalars['String']>>;
  metricIds?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  systemType?: InputMaybe<SystemTypeEnum>;
};

export type UpdateUploadInput = {
  description?: InputMaybe<Scalars['String']>;
  fileLength?: InputMaybe<Scalars['Float']>;
  fileName?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  mimeType?: InputMaybe<Scalars['MimeType']>;
};

export type UpdateUserRoleForSystemGroupInput = {
  role: SystemGroupRoleEnum;
  systemGroupId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UpdateUserRoleForSystemInput = {
  role: SystemRoleType;
  systemId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UpdateWeatherDataStationInput = {
  id: Scalars['UUID'];
  latitude: Scalars['Float'];
  locationName: Scalars['String'];
  longitude: Scalars['Float'];
  stateCode?: InputMaybe<Scalars['String']>;
  usgsStationId?: InputMaybe<Scalars['String']>;
};

export type Upload = {
  __typename?: 'Upload';
  blobId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  fileLength: Scalars['Int'];
  fileName: Scalars['String'];
  id: Scalars['UUID'];
  mimeType: Scalars['MimeType'];
  organizationId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

/** Information used by a client to upload a file to storage */
export type UploadBlobInfo = {
  __typename?: 'UploadBlobInfo';
  blobId: Scalars['String'];
  downloadUrl: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['MimeType']>;
  uploadHeadersJSON: Scalars['String'];
  uploadToken: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type UploadsWithCount = {
  __typename?: 'UploadsWithCount';
  count: Scalars['Int'];
  items: Array<Upload>;
};

export type UpsertAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  label?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<AddressPurpose>;
  recipientName?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

export type UpsertConstantValueInput = {
  constantDefinitionId: Scalars['Int'];
  effectiveDate: Scalars['Date'];
  note?: InputMaybe<Scalars['String']>;
  numericValue?: InputMaybe<Scalars['Float']>;
  textValue?: InputMaybe<Scalars['String']>;
};

export type UpsertDataEntryCompletionInput = {
  intervalTime?: InputMaybe<Scalars['String']>;
  isComplete: Scalars['Boolean'];
  reportDate: Scalars['DateTime'];
  sendEmail?: InputMaybe<Scalars['Boolean']>;
  siteId: Scalars['Int'];
};

export type UpsertMetricRangeInput = {
  color: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['UUID']>;
  ideal: Scalars['Boolean'];
  maxTagId?: InputMaybe<Scalars['UUID']>;
  minTagId?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  rangeMax?: InputMaybe<Scalars['Float']>;
  rangeMaxInclusive: Scalars['Boolean'];
  rangeMin?: InputMaybe<Scalars['Float']>;
  rangeMinInclusive: Scalars['Boolean'];
};

export type UpsertMetricRangesInput = {
  metricId: Scalars['Int'];
  ranges: Array<UpsertMetricRangeInput>;
};

export type UserInfoType = {
  __typename?: 'UserInfoType';
  displayName: Scalars['String'];
  email: Scalars['String'];
  enableIphoneMetricNumberInput: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  externalMetadataJSON?: Maybe<Scalars['String']>;
  externalOwner?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  fullNameOrEmail: Scalars['String'];
  id: Scalars['Int'];
  idpKey: Scalars['String'];
  lastLoginAt?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  licenses: Array<LicenseNest>;
  pending: Scalars['Boolean'];
  permissions: Array<UserOrganizationPermission>;
  phoneNumbers: Array<PhoneNumberNest>;
  primaryOrganization: OrganizationType;
  primaryOrganizationDateFormat: OrganizationDateFormat;
  primaryOrganizationId: Scalars['Int'];
  readonlySuperadmin: Scalars['Boolean'];
  roleForSystem: SystemRoleType;
  roleForSystemGroup: SystemGroupRoleEnum;
  ssoConfig: SsoConfigurationType;
  subject: Scalars['String'];
  superadmin: Scalars['Boolean'];
};


export type UserInfoTypeRoleForSystemArgs = {
  systemId: Scalars['Int'];
};


export type UserInfoTypeRoleForSystemGroupArgs = {
  systemGroupId: Scalars['Int'];
};

export type UserJobCount = {
  __typename?: 'UserJobCount';
  count: Scalars['Int'];
  senderEmail: Scalars['String'];
};

export enum UserManagerOrderDirection {
  Asc = 'Asc',
  Desc = 'Desc'
}

export enum UserManagerOrderField {
  CreatedAt = 'CreatedAt',
  DeletedAt = 'DeletedAt',
  Email = 'Email',
  FirstName = 'FirstName',
  Id = 'Id',
  IdpKey = 'IdpKey',
  LastLoginAt = 'LastLoginAt',
  LastName = 'LastName',
  Pending = 'Pending',
  PrimaryOrganizationName = 'PrimaryOrganizationName',
  ReadonlySuperadmin = 'ReadonlySuperadmin',
  Superadmin = 'Superadmin'
}

export type UserManagerUser = {
  __typename?: 'UserManagerUser';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  idpKey: Scalars['String'];
  lastLoginAt?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  pending: Scalars['Boolean'];
  primaryOrganizationName?: Maybe<Scalars['String']>;
  readonlySuperadmin: Scalars['Boolean'];
  superadmin: Scalars['Boolean'];
};

export type UserManagerUserDetailsInput = {
  showArchived?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['Int'];
};

export type UserManagerUsersCsvExportInput = {
  filter?: InputMaybe<UserManagerUsersFilterInput>;
  orderBy?: InputMaybe<Array<UserManagerUsersOrderByInput>>;
};

export type UserManagerUsersFilterInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  idpKeys?: InputMaybe<Array<Scalars['String']>>;
  organizationIds?: InputMaybe<Array<Scalars['Int']>>;
  pending?: InputMaybe<Scalars['Boolean']>;
  readonlySuperadmin?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  showArchived?: InputMaybe<Scalars['Boolean']>;
  showDisabled?: InputMaybe<Scalars['Boolean']>;
  superadmin?: InputMaybe<Scalars['Boolean']>;
};

export type UserManagerUsersInput = {
  filter?: InputMaybe<UserManagerUsersFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserManagerUsersOrderByInput>>;
};

export type UserManagerUsersOrderByInput = {
  direction: UserManagerOrderDirection;
  field: UserManagerOrderField;
};

export type UserManagerUsersPage = {
  __typename?: 'UserManagerUsersPage';
  count: Scalars['Int'];
  items: Array<UserManagerUser>;
};

export type UserNest = {
  __typename?: 'UserNest';
  displayName: Scalars['String'];
  email: Scalars['EmailAddress'];
  enableIphoneMetricNumberInput: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  externalOwner?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  fullNameOrEmail: Scalars['String'];
  id: Scalars['Int'];
  idpKey?: Maybe<Scalars['String']>;
  lastLoginAt?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  licenses: Array<LicenseNest>;
  pending?: Maybe<Scalars['Boolean']>;
  permissions?: Maybe<Array<UserOrganizationPermissionNest>>;
  phoneNumbers?: Maybe<Array<PhoneNumberNest>>;
  primaryOrganizationId: Scalars['Int'];
  readonlySuperadmin?: Maybe<Scalars['Boolean']>;
  roleForSystem: Scalars['String'];
  ssoConfig?: Maybe<SsoConfigurationNest>;
  subject: Scalars['String'];
  superadmin: Scalars['Boolean'];
};


export type UserNestRoleForSystemArgs = {
  systemId: Scalars['Int'];
};

export type UserOrganizationPermission = {
  __typename?: 'UserOrganizationPermission';
  /** The organization id */
  id: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  organizationRole: SystemGroupRoleEnum;
  selfServiceEnabled: Scalars['Boolean'];
  systemGroupPermissions: Array<UserSystemGroupPermission>;
  systemPermissions: Array<UserSystemPermission>;
};

export type UserOrganizationPermissionNest = {
  __typename?: 'UserOrganizationPermissionNest';
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  organizationRole: SystemGroupRoleEnum;
  selfServiceEnabled: Scalars['Boolean'];
  systemGroupPermissions: Array<UserSystemGroupPermissionNest>;
  systemPermissions: Array<UserSystemPermissionNest>;
};

export type UserStats = {
  __typename?: 'UserStats';
  activityCount: Scalars['Int'];
  user: UserNest;
};

export type UserSystemGroupPermission = {
  __typename?: 'UserSystemGroupPermission';
  id: Scalars['ID'];
  name: Scalars['String'];
  role: SystemGroupRoleEnum;
  systemGroupId: Scalars['Int'];
};

export type UserSystemGroupPermissionNest = {
  __typename?: 'UserSystemGroupPermissionNest';
  id: Scalars['String'];
  name: Scalars['String'];
  role: SystemGroupRoleEnum;
  systemGroupId: Scalars['Int'];
};

export type UserSystemPermission = {
  __typename?: 'UserSystemPermission';
  id: Scalars['ID'];
  inheritedFromSystemGroupId?: Maybe<Scalars['Int']>;
  isTemplate: Scalars['Boolean'];
  name: Scalars['String'];
  role: SystemGroupRoleEnum;
  systemId: Scalars['Int'];
};

export type UserSystemPermissionNest = {
  __typename?: 'UserSystemPermissionNest';
  id: Scalars['String'];
  inheritedFromSystemGroupId?: Maybe<Scalars['Int']>;
  isTemplate: Scalars['Boolean'];
  name: Scalars['String'];
  role: SystemGroupRoleEnum;
  systemId: Scalars['Int'];
};

export type UsersInput = {
  organizationId: Scalars['Int'];
  where?: InputMaybe<UsersWhere>;
};

export type UsersWhere = {
  systemGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type ValidateLabImportBatchInput = {
  batchId: Scalars['UUID'];
  profileDefinition?: InputMaybe<LabImportProfileDefinitionInput>;
  profileVersionId?: InputMaybe<Scalars['UUID']>;
};

export enum ValueType {
  Boolean = 'BOOLEAN',
  Numeric = 'NUMERIC',
  Text = 'TEXT'
}

/** Version Types */
export enum VersionEnum {
  V1 = 'v1',
  V2 = 'v2'
}

export type WaterlyConnectErrorStatsByMonth = {
  __typename?: 'WaterlyConnectErrorStatsByMonth';
  /** This is a zero-based view of the month described in the id.  The first day of the month will be the 0th element of the list */
  errorCountByDay: Array<Scalars['Int']>;
  /** This ID is the ISO-formatted, UTC representation fo the first day of a month. For instance, 2022-08-01T00:00:00.000Z */
  id: Scalars['ID'];
};

export type WaterlyConnectQueueJobCountByEdgeDevice = {
  __typename?: 'WaterlyConnectQueueJobCountByEdgeDevice';
  activeCount: Scalars['Int'];
  edgeDeviceId: Scalars['Int'];
  edgeDeviceName: Scalars['String'];
  waitingCount: Scalars['Int'];
};

export type WaterlyConnectStats = {
  __typename?: 'WaterlyConnectStats';
  activeQueueJobCount: Scalars['Int'];
  countLast24HourSubmissions: Scalars['Int'];
  countLast24HourSubmissionsFailed: Scalars['Int'];
  countLast24HourSubmissionsSuccessful: Scalars['Int'];
  id: Scalars['Int'];
  queueJobCountsByEdgeDevice: Array<WaterlyConnectQueueJobCountByEdgeDevice>;
  waitingQueueJobCount: Scalars['Int'];
};

export type WeatherDataStationIdInput = {
  id: Scalars['UUID'];
};

export type WeatherDataStationNest = {
  __typename?: 'WeatherDataStationNest';
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  latitude: Scalars['Float'];
  locationName: Scalars['String'];
  longitude: Scalars['Float'];
  stateCode?: Maybe<Scalars['String']>;
  usgsStationId?: Maybe<Scalars['String']>;
};

export type CalcClusterDebugLogFragment = { __typename?: 'CalcClusterDebugLog', appliedAt: string, calcClusterDebugId: string, clusterId: string, createdAt: string, deletedAt?: string | null, id: string, measuredAt: string, metricId: number, oldValue?: string | null, transactionId: string, updatedAt: string, value?: string | null };

export type DataEntryCompletionFragment = { __typename?: 'DataEntryCompletion', appliedAt: string, createdAt: string, id: string, intervalTime?: string | null, isComplete: boolean, siteId: number, updatedAt: string, userId?: number | null };

export type FolderWithMetricIdsAndOrderFragment = { __typename?: 'FolderWithMetricIdsAndOrder', color?: string | null, createdAt: string, default: boolean, deletedAt?: string | null, depth: number, id: string, name: string, order: number, parentId?: string | null, siteId: number, updatedAt: string };

export type SiteFlexMetricWithParentSiteFragment = { __typename?: 'SiteFlexMetricWithParentSite', createdAt: string, deletedAt?: string | null, folderViewOrder: number, id: string, metricId: number, name?: string | null, required: boolean, siteId: number, updatedAt: string, parentSite: { __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, id: number, isEntry: boolean, latitude?: number | null, longitude?: number | null, name: string, npdesPermitNumber?: string | null, order: number, siteType: string, systemId: number, updatedAt: string } };

export type ActivityScheduleFragment = { __typename?: 'ActivitySchedule', activityScheduleTypeId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, deletedAt?: string | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string };

export type AddressFragment = { __typename?: 'Address', city?: string | null, countryCode: string, createdAt: string, id: string, label?: string | null, line1?: string | null, line2?: string | null, organizationId?: number | null, phone?: string | null, postalCode?: string | null, purpose: AddressPurpose, recipientName?: string | null, region?: string | null, siteId?: number | null, systemId?: number | null, updatedAt: string };

export type AnalyteFragment = { __typename?: 'Analyte', analyteType: AnalyteType, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, unitId?: number | null, updatedAt: string };

export type AnalyteGroupFragment = { __typename?: 'AnalyteGroup', createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, organizationId: number, updatedAt: string };

export type ApiTokenFragment = { __typename?: 'ApiTokenNest', createdAt: string, createdByUserId: number, expiresAt: string, id: number, lastUsedAt?: string | null, name: string, organizationId: number, realm: string, revokedAt?: string | null, scopes: Array<ApiTokenScope>, updatedAt: string, username: string };

export type AuditEventFragment = { __typename?: 'AuditEventNest', event: string, id: string, rolledBackAt?: string | null, timestamp: number, type: AuditEventType, userId: number, version: AuditEventVersion };

export type AuditEventNestFragment = { __typename?: 'AuditEventNest', appliedAtWithTimeZone?: string | null, event: string, id: string, rolledBackAt?: string | null, timestamp: number, type: AuditEventType, userId: number, version: AuditEventVersion };

export type BaseFolderFragment = { __typename?: 'BaseFolder', color?: string | null, createdAt: string, default: boolean, deletedAt?: string | null, depth: number, id: string, name: string, order: number, parentId?: string | null, siteId: number, updatedAt: string };

export type BulkMetricEditorRowFragment = { __typename?: 'BulkMetricEditorRow', calculationName?: string | null, componentKeyname?: string | null, componentName?: string | null, copyPreviousValueEnabled: boolean, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, expression?: string | null, hasIntervals: boolean, hideFromDataEntry: boolean, interpolated: boolean, isLockedByWaterly: boolean, isReportComments: boolean, keyname?: string | null, metricId: number, metricRangeType?: MetricRangeType | null, name: string, notificationEnabled: boolean, order: number, organizationName: string, precision?: number | null, processKeyname?: string | null, processName: string, rangeMax?: number | null, rangeMin?: number | null, required: boolean, siteId: number, siteName: string, siteType: string, systemId: number, systemName: string, systemType: string, units?: string | null, limits: { __typename?: 'BulkMetricEditorLimitsSummary', belowReportingLimitValue?: number | null, configured: boolean, detectionLimit?: number | null, reportingLimit?: number | null, treatBelowReportingLimitAsPercent: boolean }, reportAggregations: { __typename?: 'BulkMetricEditorReportAggregationSummary', canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, configured: boolean } };

export type CalcClusterDebugFragment = { __typename?: 'CalcClusterDebug', clusterId: string, enabled: boolean, id: string, metricId: number, updatedAt: string };

export type ColumnGroupFragment = { __typename?: 'ColumnGroup', createdAt: string, deletedAt?: string | null, id: string, name: string, reportDefinitionId: number, updatedAt: string };

export type ColumnGroupItemFragment = { __typename?: 'ColumnGroupItem', aggregation?: ColumnAggregation | null, calculationType?: ColumnCalculation | null, createdAt: string, deletedAt?: string | null, id: string, intervalId?: number | null, metricId?: number | null, name?: string | null, type: ColumnGroupItemType, updatedAt: string };

export type ComponentFragment = { __typename?: 'ComponentType', deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number };

export type ComponentNestFragment = { __typename?: 'ComponentNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, processId: number, updatedAt: string };

export type ConstantDefinitionFragment = { __typename?: 'ConstantDefinition', createdAt: string, dataType: ConstantDataType, deletedAt?: string | null, description?: string | null, id: number, keyname: string, name: string, organizationId?: number | null, precision?: number | null, scope: ConstantScope, systemId?: number | null, unitId?: number | null, updatedAt: string };

export type ConstantValueFragment = { __typename?: 'ConstantValue', constantDefinitionId: number, createdAt: string, deletedAt?: string | null, effectiveDate: string, id: number, note?: string | null, numericValue?: number | null, textValue?: string | null, updatedAt: string };

export type EdgeDeviceFragment = { __typename?: 'EdgeDeviceType', deviceName?: string | null, id: number };

export type EdgeDeviceSubmissionFragment = { __typename?: 'EdgeDeviceSubmission', createdAt: string, dataExcerpt: string, edgeDeviceId: number, id: number, remoteIp?: string | null, status: EdgeDeviceSubmissionStatus, updatedAt: string };

export type EdgeDeviceSubmissionSummaryFragment = { __typename?: 'EdgeDeviceSubmissionSummary', createdAt: string, edgeDeviceId: number, id: number, remoteIp: string, success: boolean, updatedAt: string };

export type EdgeDeviceV2Fragment = { __typename?: 'EdgeDeviceNest', createdAt: string, deviceName: string, deviceType: EdgeDeviceTypeNest, enabled: boolean, id: number, integrationMetadata?: Record<string, unknown> | null, lastReceivedAt?: string | null, organizationId: number, organizationName?: string | null, updatedAt: string };

export type EntryTsDataPointFragment = { __typename?: 'EntryTSDataPoint', appliedAt: string, booleanValue?: boolean | null, calculatedNondetectValue?: boolean | null, calculatedValue?: string | null, comment?: string | null, connectValue?: string | null, dateTimeValue?: string | null, dateValue?: string | null, edgeDeviceSubmissionId?: number | null, effectiveNumericValue?: number | null, id: string, intervalId?: number | null, isArchived?: boolean | null, isCalculatedResult?: boolean | null, isInterpolated: boolean, isNondetect: boolean, journalEntryRecordId: string, jsonValue?: string | null, locatorEntityId: string, locatorEntityType: string, locatorNamespace: string, measuredAt: string, metricId: number, numericValue?: number | null, reportDate: string, storedAt: string, textValue?: string | null, timeValue?: string | null, type: string, value?: string | null, valueType: string, metaData: { __typename?: 'EntryTSDataPointMetadata', connectValue?: string | null, edgeDeviceSubmissionId?: number | null, id: string, intervalId?: number | null, reportDate: string } };

export type ExternalFacilityFragment = { __typename?: 'ExternalFacility', externalId: string, externalMetadata: Record<string, unknown>, name: string };

export type ExternalSystemFragment = { __typename?: 'ExternalSystem', externalId: string, externalOwner: string, id: string, name: string };

export type IntervalFragment = { __typename?: 'Interval', displayName?: string | null, id: number, time: string };

export type IntervalNestFragment = { __typename?: 'IntervalNest', createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string };

export type LabImportBatchFragment = { __typename?: 'LabImportBatch', checksumSha256: string, committedAt?: string | null, committedRowCount: number, createdAt: string, errorDetails?: Record<string, unknown> | null, id: string, invalidRowCount: number, originalFileName: string, profileName?: string | null, profileVersionId?: string | null, readyMetricCount: number, readySiteCount: number, reconciliationRequiredRowCount: number, skippedRowCount: number, sourceFileSizeBytes: number, sourceMimeType: string, sourceUploadId: string, status: LabImportBatchStatus, systemId: number, totalRowCount: number, validatedAt?: string | null, validRowCount: number, parserMetadata: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, profileVersion?: { __typename?: 'LabImportProfileVersion', createdAt: string, createdByUserId: number, id: string, profileId: string, version: number, definition: { __typename?: 'LabImportProfileDefinition', columnMappings: Array<{ __typename?: 'LabImportColumnMapping', column: string, field: string }>, parserConfig: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, targetMappings: Array<{ __typename?: 'LabImportTargetMapping', decision: LabImportTargetDecision, id: string, importedUnitLabel?: string | null, metricId?: number | null, metricUnitLabel?: string | null, siteId?: number | null, sourceAnalyte: string, sourceProject: string, sourceSampleSite: string, unitDecision?: LabImportUnitDecision | null }> } } | null };

export type LabImportPendingProfileFragment = { __typename?: 'LabImportPendingProfile', baseProfileVersionId?: string | null, name: string, profileId?: string | null, definition: { __typename?: 'LabImportProfileDefinition', columnMappings: Array<{ __typename?: 'LabImportColumnMapping', column: string, field: string }>, parserConfig: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, targetMappings: Array<{ __typename?: 'LabImportTargetMapping', decision: LabImportTargetDecision, id: string, importedUnitLabel?: string | null, metricId?: number | null, metricUnitLabel?: string | null, siteId?: number | null, sourceAnalyte: string, sourceProject: string, sourceSampleSite: string, unitDecision?: LabImportUnitDecision | null }> } };

export type LabImportProfileFragment = { __typename?: 'LabImportProfile', createdAt: string, createdByUserId: number, id: string, name: string, organizationId: number, systemId: number, versions: Array<{ __typename?: 'LabImportProfileVersion', createdAt: string, createdByUserId: number, id: string, profileId: string, version: number, definition: { __typename?: 'LabImportProfileDefinition', columnMappings: Array<{ __typename?: 'LabImportColumnMapping', column: string, field: string }>, parserConfig: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, targetMappings: Array<{ __typename?: 'LabImportTargetMapping', decision: LabImportTargetDecision, id: string, importedUnitLabel?: string | null, metricId?: number | null, metricUnitLabel?: string | null, siteId?: number | null, sourceAnalyte: string, sourceProject: string, sourceSampleSite: string, unitDecision?: LabImportUnitDecision | null }> } }> };

export type LabImportProfileDefinitionFragment = { __typename?: 'LabImportProfileDefinition', columnMappings: Array<{ __typename?: 'LabImportColumnMapping', column: string, field: string }>, parserConfig: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, targetMappings: Array<{ __typename?: 'LabImportTargetMapping', decision: LabImportTargetDecision, id: string, importedUnitLabel?: string | null, metricId?: number | null, metricUnitLabel?: string | null, siteId?: number | null, sourceAnalyte: string, sourceProject: string, sourceSampleSite: string, unitDecision?: LabImportUnitDecision | null }> };

export type LabImportRowFragment = { __typename?: 'LabImportRow', batchId: string, canonicalValues: Record<string, unknown>, comments?: string | null, id: string, importedUnitLabel?: string | null, intervalId?: number | null, isNondetect?: boolean | null, metricId?: number | null, rawValues: Record<string, unknown>, reportDate?: string | null, requestId?: string | null, resultName?: string | null, resultValue?: string | null, rowNumber: number, sampleDate?: string | null, sampleIdentifier?: string | null, siteId?: number | null, status: LabImportRowStatus, systemId?: number | null, writeErrorDetails?: Record<string, unknown> | null, writeStatus?: LabImportDataPointWriteStatus | null, writtenAt?: string | null, validationResults: Array<{ __typename?: 'LabImportValidationResult', attempt: number, code: string, details?: Record<string, unknown> | null, field?: string | null, id: string, message: string, status: LabImportValidationStatus }> };

export type LicenseFragment = { __typename?: 'LicenseNest', authority: string, displayName: string, id: number, licenseLabel: string, licenseNumber: string, userId: number };

export type LogBookEntryFragment = { __typename?: 'LogBookEntryNest', createdAt: string, deletedAt?: string | null, id: string, message: string, organizationId: number, pinned: boolean, updatedAt: string, userId: number };

export type LogBookEntryDashboardViewFragment = { __typename?: 'LogBookEntryDashboardViewNest', createdAt: string, deletedAt?: string | null, id: string, message?: string | null, name: string, organizationId?: number | null, siteIds?: Array<number> | null, sortDirection: string, sortField: string, systemIds?: Array<number> | null, tagIds?: Array<string> | null, updatedAt: string, userId: number, userIds?: Array<number> | null };

export type LogBookEntryListItemFragment = { __typename?: 'LogBookEntryNest', createdAt: string, deletedAt?: string | null, id: string, message: string, organizationId: number, pinned: boolean, updatedAt: string, attachments: { __typename?: 'LogBookEntryAttachmentsNest', components: Array<{ __typename?: 'ComponentNest', id: number, name: string }>, metrics: Array<{ __typename?: 'MetricNest', id: number, name: string }>, processes: Array<{ __typename?: 'ProcessNest', id: number, name: string }>, sites: Array<{ __typename?: 'SiteNest', id: number, name: string }>, systems: Array<{ __typename?: 'SystemNest', id: number, name: string }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, uploads: Array<{ __typename?: 'Upload', fileName: string, id: string, url: string }> }, user: { __typename?: 'UserNest', firstName: string, id: number, lastName: string } };

export type MetricFragment = { __typename?: 'MetricType', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, dataPointCommentPolicy?: DataPointCommentPolicy | null, dataType: MetricDataTypeEnum, deletedAt?: string | null, detectionLimit?: number | null, displayName: string, displayNameSiteLocal: string, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null };

export type MetricContextFragment = { __typename?: 'MetricType', id: number, name: string, component?: { __typename?: 'ComponentType', id: number, name: string } | null, process?: { __typename?: 'ProcessType', id: number, name: string } | null, site?: { __typename?: 'SiteType', id: number, name?: string | null, systemId: number } | null };

export type MetricDataPointDetailsFragment = { __typename?: 'MetricDataPointType', appliedAt: string, calculatedNondetectValue?: boolean | null, calculatedValue?: string | null, comment?: string | null, connectValue?: string | null, edgeDeviceSubmissionId?: number | null, effectiveValue?: string | null, error?: string | null, id?: number | null, intervalId?: number | null, isInterpolated?: boolean | null, isNondetect?: boolean | null, measuredAt: string, metricId: number, reportDate: string, type: string, value?: string | null, version?: number | null };

export type MetricOrderWithMetricIdFragment = { __typename?: 'MetricOrderWithMetricId', id: string, metricId: number, order: number };

export type MetricKeynameFragment = { __typename?: 'MetricKeyname', compliance: boolean, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, systemTypes?: Array<string> | null, updatedAt: string };

export type MetricNestFragment = { __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean };

export type MetricRangeFragment = { __typename?: 'MetricRange', color: string, createdAt: string, deletedAt?: string | null, id: string, ideal: boolean, maxTagId?: string | null, metricId: number, minTagId?: string | null, name: string, notificationEnabled: boolean, rangeMax?: number | null, rangeMaxInclusive: boolean, rangeMin?: number | null, rangeMinInclusive: boolean, updatedAt: string };

export type MetricWithCalculatedMetricFragment = { __typename?: 'MetricWithCalculatedMetric', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean, calculatedMetric: { __typename?: 'CalculatedMetric', calculatedMetricId: number, sourceMetricId: number }, intervals?: Array<{ __typename?: 'IntervalNest', createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string }> | null };

export type NotificationFragment = { __typename?: 'Notification', active: boolean, appearance: NotificationAppearance, createdAt: string, deletedAt?: string | null, dismissable: boolean, displayPosition: NotificationDisplayPosition, endDate?: string | null, icon?: SelectableIcons | null, id: string, message: string, name: string, organizationId: number, startDate: string, systemGroupId?: number | null, systemId?: number | null, title?: string | null, updatedAt: string };

export type OrganizationFragment = { __typename?: 'OrganizationType', dateFormat: OrganizationDateFormat, fiscalYearStartDate: string, id: number, idpKey?: string | null, isExternalSystemSearchEnabled: boolean, isUserDirectoryEnabled: boolean, name: string, selfServiceEnabled: boolean };

export type OrganizationNestFragment = { __typename?: 'OrganizationNest', dateFormat: OrganizationDateFormat, fiscalYearStartDate: string, id: number, idpKey?: string | null, name: string, selfServiceEnabled: boolean };

export type PermitFragment = { __typename?: 'Permit', createdAt: string, deletedAt?: string | null, id: string, isPublicWaterSystemId: boolean, name: string, permitCode: string, systemId: number, updatedAt: string };

export type PhoneNumberFragment = { __typename?: 'PhoneNumberNest', country: string, id: number, phoneNumber: string };

export type PhraseFragment = { __typename?: 'Phrase', bodyText: string, id: string, name: string, organizationId?: number | null, userId?: number | null };

export type ProcessFragment = { __typename?: 'ProcessType', deletedAt?: string | null, displayName: string, id: number, internalKeyname?: string | null, name: string, order: number, siteId: number };

export type ProcessNestFragment = { __typename?: 'ProcessNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, siteId: number, updatedAt: string };

export type QueueStatsFragment = { __typename?: 'QueueStats', completedInLastHour: number, completedPerMinute: Array<number>, failedInLastHour: number, failedPerMinute: Array<number>, generatedAt: string, queue: string, workersCount: number, groupsCount: Array<{ __typename?: 'GroupCount', count: number, id: string, status: string, userJobCounts: Array<{ __typename?: 'UserJobCount', count: number, senderEmail: string }> } | null>, groupsCountByStatus: { __typename?: 'GroupQueueCounts', limited: number, maxed: number, paused: number, waiting: number } };

export type ReportDefinitionFragment = { __typename?: 'ReportDefinition', annualPeriod?: string | null, configSchemaId?: string | null, customFooter?: string | null, id: number, isFlex: boolean, metadata?: Record<string, unknown> | null, name: string, order: number, paperOrientation: PaperOrientationEnum, paperSize: PaperSizeEnum, reportGroupId?: number | null, reportTemplateId: number, reportType: ReportTypeEnum, showDayOfWeek: boolean, siteId?: number | null, supplementaryEnabled: boolean, systemId: number, timeFormat: TimeFormatEnum, reportGroup?: { __typename?: 'ReportGroup', id: number, name: string, order: number, systemId: number } | null, system: { __typename?: 'SystemType', id: number, name: string } };

export type ReportDefinitionNestFragment = { __typename?: 'ReportDefinitionNest', annualPeriod?: string | null, configSchemaId?: string | null, customFooter?: string | null, id: number, name: string, order: number, paperOrientation: string, paperSize: string, reportTemplateId?: number | null, reportType: string, showDayOfWeek: boolean, siteId?: number | null, supplementaryEnabled: boolean, systemId: number };

export type ReportDefinitionSiteFragment = { __typename?: 'ReportDefinition', site?: { __typename?: 'SiteType', flex?: boolean | null, id: number, name?: string | null, processes: Array<{ __typename?: 'ProcessType', deletedAt?: string | null, enabledForReport?: boolean | null, id: number, name: string, order: number, components: Array<{ __typename?: 'ComponentType', enabledForReport?: boolean | null, id: number, name: string, order: number, metrics: Array<{ __typename?: 'MetricType', deletedAt?: string | null, enabledForReport: boolean, id: number, isReportComments: boolean, name: string, order: number, enabledIntervalForMonthlyReport?: { __typename?: 'Interval', displayName?: string | null, id: number, time: string } | null, intervals: Array<{ __typename?: 'Interval', displayName?: string | null, id: number, time: string }>, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null }> }>, metrics: Array<{ __typename?: 'MetricType', deletedAt?: string | null, enabledForReport: boolean, id: number, isReportComments: boolean, name: string, order: number, enabledIntervalForMonthlyReport?: { __typename?: 'Interval', displayName?: string | null, id: number, time: string } | null, intervals: Array<{ __typename?: 'Interval', displayName?: string | null, id: number, time: string }>, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null }> }> } | null };

export type ReportDistributionListFragment = { __typename?: 'ReportDistributionList', createdAt: string, deletedAt?: string | null, description?: string | null, displaySummary: string, id: string, isArchived: boolean, memberCount: number, name: string, normalizedName: string, organizationId?: number | null, scope: ReportDistributionListScope, siteId?: number | null, systemId?: number | null, updatedAt: string, members: Array<{ __typename?: 'ReportDistributionListMember', createdAt: string, displayName?: string | null, id: string, memberType: ReportDistributionListMemberType, normalizedEmail: string, sortOrder: number, updatedAt: string, userId?: number | null }> };

export type ReportMetricFragment = { __typename?: 'MetricType', deletedAt?: string | null, enabledForReport: boolean, id: number, isReportComments: boolean, name: string, order: number, enabledIntervalForMonthlyReport?: { __typename?: 'Interval', displayName?: string | null, id: number, time: string } | null, intervals: Array<{ __typename?: 'Interval', displayName?: string | null, id: number, time: string }>, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null };

export type ReportNestFragment = { __typename?: 'ReportNest', description: string, id: string, name: string, organizationId?: number | null, reportTemplate?: string | null, reportType: ReportType, siteId?: number | null, systemId?: number | null };

export type ReportNodeFragment = { __typename?: 'ReportNode', columnGroupId?: string | null, columnGroupItemId?: string | null, createdAt: string, deletedAt?: string | null, id: string, metricId?: number | null, order: number, parentId?: string | null, reportDefinitionId: number, type: ReportNodeType, updatedAt: string };

export type ReportSnapshotFragment = { __typename?: 'ReportSnapshot', config?: Record<string, unknown> | null, configSchemaVersion: ReportSnapshotConfigSchemaVersion, createdAt: string, data?: Record<string, unknown> | null, deletedAt?: string | null, enterpriseReportId?: string | null, id: string, name: string, reportDateTime: string, reportDefinitionId?: number | null, status: ReportStatus, updatedAt: string, url?: string | null };

export type RetentionRiskNestFragment = { __typename?: 'RetentionRiskNest', createdAt: string, deletedAt?: string | null, displayName: string, flag: boolean, flagType: RetentionRiskFlagType, id: string, itemId: string, itemType: RetentionRiskItemType, organizationId: number, score: number, snooze?: string | null, updatedAt: string };

export type SampleCollectionFragment = { __typename?: 'SampleCollection', createdAt: string, deletedAt?: string | null, id: string, sampleSiteId: string, scheduledItemId?: string | null, systemId: number, updatedAt: string };

export type SampleCollectionCustodyFragment = { __typename?: 'SampleCollectionCustody', comment?: string | null, createdAt: string, createdBy: number, deletedAt?: string | null, id: string, previousCustodyId?: string | null, relinquishedBy?: number | null, relinquishedTo: number, sampleCollectionId: string, systemId: number, updatedAt: string };

export type SampleCollectionResultFragment = { __typename?: 'SampleCollectionResult', analyteId: string, booleanValue?: boolean | null, createdAt: string, deletedAt?: string | null, id: string, measuredAt?: string | null, numericValue?: number | null, sampleCollectionId: string, textValue?: string | null, updatedAt: string, valueType: ValueType };

export type SampleScheduleFragment = { __typename?: 'SampleSchedule', analyteGroupId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, sampleSiteId: string, sampleType: SampleType, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string };

export type SampleSiteFragment = { __typename?: 'SampleSite', address?: string | null, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, isActive: boolean, lastInspectionDate?: string | null, latitude?: number | null, longitude?: number | null, name: string, organizationId: number, samplePointType?: string | null, updatedAt: string, url?: string | null, photoUpload?: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } | null };

export type ScheduledItemFragment = { __typename?: 'ScheduledItem', assigneeId?: number | null, completedAt?: string | null, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, isStackable: boolean, notBefore?: string | null, photoRequired: boolean, recurrenceType: RecurrenceType, scheduledAt: string, sourceScheduleId: string, sourceScheduleType: SourceScheduleType, status: ScheduledItemStatus, systemId: number, targetDate?: string | null, title: string, updatedAt: string, comments: Array<{ __typename?: 'ScheduledItemComment', comment: string, commentType: ScheduledItemCommentType, createdAt: string, id: string, scheduledItemId: string, updatedAt: string, userId: number, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } }>, photoUpload?: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } | null };

export type ScheduledItemCommentFragment = { __typename?: 'ScheduledItemComment', comment: string, commentType: ScheduledItemCommentType, createdAt: string, id: string, scheduledItemId: string, updatedAt: string, userId: number, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } };

export type ScheduledItemsUploadsFragment = { __typename?: 'ScheduledItemUpload', id: string, scheduledItemId: string, uploadId: string };

export type SiteFlexMetricFragment = { __typename?: 'SiteFlexMetric', createdAt: string, deletedAt?: string | null, folderViewOrder: number, id: string, metricId: number, name?: string | null, required: boolean, siteId: number, updatedAt: string };

export type SiteNestFragment = { __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string };

export type SsoConfigurationFragment = { __typename?: 'SSOConfigurationType', audience?: string | null, authority: string, clientId: string, id: number, idpKey: string, logoSvg?: string | null, scope: string, signoutRedirectUrl: string };

export type SuccessResponseFragment = { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean };

export type SystemFragment = { __typename?: 'SystemType', displayName: string, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, hasSitesWithIntervals: boolean, hideDataSites: boolean, id: number, isFavorite: boolean, isTemplate: boolean, licenseId?: number | null, myRole: SystemGroupRoleEnum, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId?: number | null, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type?: SystemTypeEnum | null };

export type SystemGroupFragment = { __typename?: 'SystemGroupType', displayName: string, id: number, isTopLevel: boolean, name: string, organizationId: number, parentSystemGroupId?: number | null };

export type SystemGroupUserFragment = { __typename?: 'UserInfoType', roleForSystemGroup: SystemGroupRoleEnum, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean };

export type SystemGroupWithUsersFragment = { __typename?: 'SystemGroupType', displayName: string, id: number, isTopLevel: boolean, name: string, organizationId: number, parentSystemGroupId?: number | null, users: Array<{ __typename?: 'UserInfoType', roleForSystemGroup: SystemGroupRoleEnum, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean }> };

export type SystemNestFragment = { __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string };

export type TagFragment = { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string };

export type TagMappingFragment = { __typename?: 'TagMappingType', edgeDeviceId: number, id: number, metricId: number, tagName: string };

export type TrendFragment = { __typename?: 'TrendNest', id: number, isGlobal: boolean, keynameFilters: Array<string>, name: string, ownerId: number, resolvedMetricIds: Array<number>, systemId?: number | null, systemType: SystemTypeEnum };

export type TsDataPointFragment = { __typename?: 'TSDataPoint', appliedAt: string, booleanValue?: boolean | null, calculatedNondetectValue?: boolean | null, calculatedValue?: string | null, comment?: string | null, connectValue?: string | null, dateTimeValue?: string | null, dateValue?: string | null, edgeDeviceSubmissionId?: number | null, effectiveNumericValue?: number | null, id: string, intervalId?: number | null, isArchived?: boolean | null, isCalculatedResult?: boolean | null, isInterpolated: boolean, isNondetect: boolean, journalEntryRecordId: string, jsonValue?: string | null, locatorEntityId: string, locatorEntityType: string, locatorNamespace: string, measuredAt: string, metricId: number, numericValue?: number | null, reportDate: string, storedAt: string, textValue?: string | null, timeValue?: string | null, type: MetricDataTypeEnum, value?: string | null, valueType: TsDataPointValueType, metaData: { __typename?: 'TSDataPointMetadata', connectValue?: string | null, edgeDeviceSubmissionId?: number | null, id: string, intervalId?: number | null, reportDate: string } };

export type UnitFragment = { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string };

export type UnitNestFragment = { __typename?: 'UnitNest', createdAt: string, deletedAt?: string | null, id: number, isInterpolatable: boolean, name: string, updatedAt: string };

export type UpdatePermitMutationVariables = Exact<{
  input: PermitUpdateInput;
}>;


export type UpdatePermitMutation = { __typename?: 'Mutation', updatePermit: { __typename?: 'Permit', createdAt: string, deletedAt?: string | null, id: string, isPublicWaterSystemId: boolean, name: string, permitCode: string, systemId: number, updatedAt: string } };

export type UploadsFragment = { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string };

export type UserFragment = { __typename?: 'UserInfoType', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean };

export type UserManagerUserFieldsFragment = { __typename?: 'UserManagerUser', createdAt: string, deletedAt?: string | null, email: string, firstName: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationName?: string | null, readonlySuperadmin: boolean, superadmin: boolean };

export type UserNestFragment = { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean };

export type UserOrganizationPermissionFragment = { __typename?: 'UserOrganizationPermission', id: string, name: string, organizationId: number, organizationRole: SystemGroupRoleEnum, selfServiceEnabled: boolean, systemGroupPermissions: Array<{ __typename?: 'UserSystemGroupPermission', id: string, name: string, role: SystemGroupRoleEnum, systemGroupId: number }>, systemPermissions: Array<{ __typename?: 'UserSystemPermission', id: string, inheritedFromSystemGroupId?: number | null, isTemplate: boolean, name: string, role: SystemGroupRoleEnum, systemId: number }> };

export type UserOrganizationPermissionNestFragment = { __typename?: 'UserOrganizationPermissionNest', id: string, name: string, organizationId: number, organizationRole: SystemGroupRoleEnum, selfServiceEnabled: boolean, systemGroupPermissions: Array<{ __typename?: 'UserSystemGroupPermissionNest', id: string, name: string, role: SystemGroupRoleEnum, systemGroupId: number }>, systemPermissions: Array<{ __typename?: 'UserSystemPermissionNest', id: string, inheritedFromSystemGroupId?: number | null, isTemplate: boolean, name: string, role: SystemGroupRoleEnum, systemId: number }> };

export type UserSystemGroupPermissionFragment = { __typename?: 'UserSystemGroupPermission', id: string, name: string, role: SystemGroupRoleEnum, systemGroupId: number };

export type UserSystemGroupPermissionNestFragment = { __typename?: 'UserSystemGroupPermissionNest', id: string, name: string, role: SystemGroupRoleEnum, systemGroupId: number };

export type UserSystemPermissionFragment = { __typename?: 'UserSystemPermission', id: string, inheritedFromSystemGroupId?: number | null, isTemplate: boolean, name: string, role: SystemGroupRoleEnum, systemId: number };

export type UserSystemPermissionNestFragment = { __typename?: 'UserSystemPermissionNest', id: string, inheritedFromSystemGroupId?: number | null, isTemplate: boolean, name: string, role: SystemGroupRoleEnum, systemId: number };

export type WeatherDataStationFieldsFragment = { __typename?: 'WeatherDataStationNest', deletedAt?: string | null, id: string, latitude: number, locationName: string, longitude: number, stateCode?: string | null, usgsStationId?: string | null };

export type AddActivityScheduleMutationVariables = Exact<{
  input: ActivityScheduleAddInput;
}>;


export type AddActivityScheduleMutation = { __typename?: 'Mutation', addActivitySchedule: { __typename?: 'ActivitySchedule', activityScheduleTypeId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, deletedAt?: string | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string } };

export type AddEdgeDeviceMutationVariables = Exact<{
  input: AddEdgeDeviceNestInput;
}>;


export type AddEdgeDeviceMutation = { __typename?: 'Mutation', addEdgeDevice: { __typename?: 'EdgeDeviceNest', createdAt: string, deviceName: string, deviceType: EdgeDeviceTypeNest, enabled: boolean, id: number, integrationMetadata?: Record<string, unknown> | null, lastReceivedAt?: string | null, organizationId: number, organizationName?: string | null, updatedAt: string } };

export type AddLicenseMutationVariables = Exact<{
  input: AddLicenseInput;
}>;


export type AddLicenseMutation = { __typename?: 'Mutation', addLicense: { __typename?: 'LicenseNest', authority: string, displayName: string, id: number, licenseLabel: string, licenseNumber: string, userId: number } };

export type AddNewReportDefinitionMutationVariables = Exact<{
  input: ReportDefinitionCreateInput;
}>;


export type AddNewReportDefinitionMutation = { __typename?: 'Mutation', addNewReportDefinition: { __typename?: 'ReportDefinitionNest', annualPeriod?: string | null, configSchemaId?: string | null, customFooter?: string | null, id: number, name: string, order: number, paperOrientation: string, paperSize: string, reportTemplateId?: number | null, reportType: string, showDayOfWeek: boolean, siteId?: number | null, supplementaryEnabled: boolean, systemId: number } };

export type AddPhoneNumberMutationVariables = Exact<{
  input: AddPhoneNumberInput;
}>;


export type AddPhoneNumberMutation = { __typename?: 'Mutation', addPhoneNumber: { __typename?: 'PhoneNumberNest', country: string, id: number, phoneNumber: string } };

export type AddScheduledItemUploadMutationVariables = Exact<{
  input: AddScheduledItemUploadInput;
}>;


export type AddScheduledItemUploadMutation = { __typename?: 'Mutation', addScheduledItemUpload: { __typename?: 'ScheduledItemUpload', id: string, scheduledItemId: string, uploadId: string } };

export type AddSiteMutationVariables = Exact<{
  input: AddSiteInput;
}>;


export type AddSiteMutation = { __typename?: 'Mutation', addSite: { __typename?: 'SiteType', dataEntryCompletionEmail?: DataEntryCompletionEmailOption | null, dataEntryCompletionEnabled?: boolean | null, displayName: string, emoji?: string | null, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, flex?: boolean | null, fullName: string, id: number, isEntry?: boolean | null, latitude?: number | null, licenseId?: number | null, longitude?: number | null, name?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType?: SiteTypeEnum | null, systemId: number } };

export type AddSiteFlexMetricsToFolderMutationVariables = Exact<{
  input: AddSiteFlexMetricsToFolderInput;
}>;


export type AddSiteFlexMetricsToFolderMutation = { __typename?: 'Mutation', addSiteFlexMetricsToFolder: Array<{ __typename?: 'SiteFlexMetric', createdAt: string, deletedAt?: string | null, folderViewOrder: number, id: string, metricId: number, name?: string | null, required: boolean, siteId: number, updatedAt: string, metric?: { __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean } | null }> };

export type AddSsoUserToSystemMutationVariables = Exact<{
  input: AddSsoUserToSystemTypeInput;
  systemId: Scalars['Int'];
}>;


export type AddSsoUserToSystemMutation = { __typename?: 'Mutation', addSsoUserToSystem: { __typename?: 'UserInfoType', roleForSystem: SystemRoleType, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean } };

export type AddSsoUserToSystemGroupMutationVariables = Exact<{
  input: AddSsoUserToSystemGroupInput;
  systemGroupId: Scalars['Int'];
}>;


export type AddSsoUserToSystemGroupMutation = { __typename?: 'Mutation', addSSOUserToSystemGroup: { __typename?: 'UserInfoType', roleForSystemGroup: SystemGroupRoleEnum, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean } };

export type AddSystemFavoriteMutationVariables = Exact<{
  input: AddSystemFavoriteInput;
}>;


export type AddSystemFavoriteMutation = { __typename?: 'Mutation', addSystemFavorite: { __typename?: 'SystemType', displayName: string, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, hasSitesWithIntervals: boolean, hideDataSites: boolean, id: number, isFavorite: boolean, isTemplate: boolean, licenseId?: number | null, myRole: SystemGroupRoleEnum, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId?: number | null, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type?: SystemTypeEnum | null } };

export type AddSystemGroupMutationVariables = Exact<{
  input: AddSystemGroupInput;
}>;


export type AddSystemGroupMutation = { __typename?: 'Mutation', addSystemGroup: { __typename?: 'SystemGroupType', displayName: string, id: number, isTopLevel: boolean, name: string, organizationId: number, parentSystemGroupId?: number | null } };

export type AddTagMappingMutationVariables = Exact<{
  input: AddTagMappingInput;
}>;


export type AddTagMappingMutation = { __typename?: 'Mutation', addTagMapping: { __typename?: 'TagMappingType', edgeDeviceId: number, id: number, metricId: number, tagName: string } };

export type AddTrendMutationVariables = Exact<{
  input: AddTrendInput;
  systemId: Scalars['Int'];
}>;


export type AddTrendMutation = { __typename?: 'Mutation', addTrend: { __typename?: 'TrendNest', id: number, isGlobal: boolean, keynameFilters: Array<string>, name: string, ownerId: number, resolvedMetricIds: Array<number>, systemId?: number | null, systemType: SystemTypeEnum, owner: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean }, system?: { __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string } | null } };

export type AddUploadMutationVariables = Exact<{
  input: CreateUploadInput;
}>;


export type AddUploadMutation = { __typename?: 'Mutation', createUpload: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } };

export type AddUserToSystemMutationVariables = Exact<{
  input: AddUserToSystemInput;
  systemId: Scalars['Int'];
}>;


export type AddUserToSystemMutation = { __typename?: 'Mutation', addUserToSystem?: { __typename?: 'UserInfoType', roleForSystem: SystemRoleType, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean } | null };

export type AddUserToSystemGroupMutationVariables = Exact<{
  input: AddUserToSystemGroupInput;
  systemGroupId: Scalars['Int'];
}>;


export type AddUserToSystemGroupMutation = { __typename?: 'Mutation', addUserToSystemGroup: { __typename?: 'UserInfoType', roleForSystemGroup: SystemGroupRoleEnum, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean } };

export type ArchiveConstantDefinitionMutationVariables = Exact<{
  input: ArchiveConstantDefinitionInput;
}>;


export type ArchiveConstantDefinitionMutation = { __typename?: 'Mutation', archiveConstantDefinition: { __typename?: 'ConstantDefinition', createdAt: string, dataType: ConstantDataType, deletedAt?: string | null, description?: string | null, id: number, keyname: string, name: string, organizationId?: number | null, precision?: number | null, scope: ConstantScope, systemId?: number | null, unitId?: number | null, updatedAt: string } };

export type ArchiveConstantValueMutationVariables = Exact<{
  input: ArchiveConstantValueInput;
}>;


export type ArchiveConstantValueMutation = { __typename?: 'Mutation', archiveConstantValue: { __typename?: 'ConstantValue', constantDefinitionId: number, createdAt: string, deletedAt?: string | null, effectiveDate: string, id: number, note?: string | null, numericValue?: number | null, textValue?: string | null, updatedAt: string } };

export type ArchiveSampleScheduleMutationVariables = Exact<{
  input: ArchiveSampleScheduleInput;
}>;


export type ArchiveSampleScheduleMutation = { __typename?: 'Mutation', archiveSampleSchedule?: { __typename?: 'SampleSchedule', analyteGroupId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, sampleSiteId: string, sampleType: SampleType, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string } | null };

export type ArchiveScheduledItemCommentMutationVariables = Exact<{
  input: ArchiveScheduledItemCommentInput;
}>;


export type ArchiveScheduledItemCommentMutation = { __typename?: 'Mutation', archiveScheduledItemComment: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type ArchiveScheduledItemUploadMutationVariables = Exact<{
  input: ArchiveScheduledItemUploadInput;
}>;


export type ArchiveScheduledItemUploadMutation = { __typename?: 'Mutation', archiveByScheduledItemId?: { __typename?: 'ScheduledItemUpload', id: string, scheduledItemId: string, uploadId: string } | null };

export type ArchiveScheduledItemsMutationVariables = Exact<{
  input: ArchiveScheduledItemsInput;
}>;


export type ArchiveScheduledItemsMutation = { __typename?: 'Mutation', archiveScheduledItems: Array<{ __typename?: 'ScheduledItem', id: string }> };

export type ArchiveUploadMutationVariables = Exact<{
  input: ArchiveUploadInput;
}>;


export type ArchiveUploadMutation = { __typename?: 'Mutation', archiveUpload: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } };

export type ArchiveWeatherDataStationMutationVariables = Exact<{
  input: WeatherDataStationIdInput;
}>;


export type ArchiveWeatherDataStationMutation = { __typename?: 'Mutation', archiveWeatherDataStation: { __typename?: 'WeatherDataStationNest', deletedAt?: string | null, id: string, latitude: number, locationName: string, longitude: number, stateCode?: string | null, usgsStationId?: string | null } };

export type CancelActivityScheduleMutationVariables = Exact<{
  input: ActivityScheduleCancelInput;
}>;


export type CancelActivityScheduleMutation = { __typename?: 'Mutation', cancelActivitySchedule: { __typename?: 'ActivitySchedule', activityScheduleTypeId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, deletedAt?: string | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string } };

export type CancelSampleScheduleMutationVariables = Exact<{
  input: CancelSampleScheduleInput;
}>;


export type CancelSampleScheduleMutation = { __typename?: 'Mutation', cancelSampleSchedule: { __typename?: 'SampleSchedule', analyteGroupId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, sampleSiteId: string, sampleType: SampleType, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string } };

export type ClearRuntimeLoggerOverrideMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type ClearRuntimeLoggerOverrideMutation = { __typename?: 'Mutation', clearRuntimeLoggerOverride: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type ClearSsoCacheMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearSsoCacheMutation = { __typename?: 'Mutation', clearSSOCache: boolean };

export type CloneComponentsMutationVariables = Exact<{
  input: CloneComponentsInput;
}>;


export type CloneComponentsMutation = { __typename?: 'Mutation', cloneComponents: Array<{ __typename?: 'ClonedComponentPayload', component: { __typename?: 'ComponentNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, processId: number, updatedAt: string }, metrics: Array<{ __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean, intervals?: Array<{ __typename?: 'IntervalNest', siteFullName?: string | null, createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string }> | null, metricKeyname?: { __typename?: 'MetricKeyname', compliance: boolean, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, systemTypes?: Array<string> | null, updatedAt: string } | null, metricRanges: Array<{ __typename?: 'MetricRange', color: string, createdAt: string, deletedAt?: string | null, id: string, ideal: boolean, maxTagId?: string | null, metricId: number, minTagId?: string | null, name: string, notificationEnabled: boolean, rangeMax?: number | null, rangeMaxInclusive: boolean, rangeMin?: number | null, rangeMinInclusive: boolean, updatedAt: string, maxTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null, minTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null }>, unit?: { __typename?: 'UnitNest', createdAt: string, deletedAt?: string | null, id: number, isInterpolatable: boolean, name: string, updatedAt: string } | null }> }> };

export type CloneMetricsMutationVariables = Exact<{
  input: CloneMetricsInput;
}>;


export type CloneMetricsMutation = { __typename?: 'Mutation', cloneMetrics: Array<{ __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean, intervals?: Array<{ __typename?: 'IntervalNest', siteFullName?: string | null, createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string }> | null, metricKeyname?: { __typename?: 'MetricKeyname', compliance: boolean, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, systemTypes?: Array<string> | null, updatedAt: string } | null, metricRanges: Array<{ __typename?: 'MetricRange', color: string, createdAt: string, deletedAt?: string | null, id: string, ideal: boolean, maxTagId?: string | null, metricId: number, minTagId?: string | null, name: string, notificationEnabled: boolean, rangeMax?: number | null, rangeMaxInclusive: boolean, rangeMin?: number | null, rangeMinInclusive: boolean, updatedAt: string, maxTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null, minTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null }>, unit?: { __typename?: 'UnitNest', createdAt: string, deletedAt?: string | null, id: number, isInterpolatable: boolean, name: string, updatedAt: string } | null }> };

export type CloneProcessesMutationVariables = Exact<{
  input: CloneProcessesInput;
}>;


export type CloneProcessesMutation = { __typename?: 'Mutation', cloneProcesses: Array<{ __typename?: 'ClonedProcessPayload', components: Array<{ __typename?: 'ComponentNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, processId: number, updatedAt: string }>, metrics: Array<{ __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean, intervals?: Array<{ __typename?: 'IntervalNest', siteFullName?: string | null, createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string }> | null, metricKeyname?: { __typename?: 'MetricKeyname', compliance: boolean, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, systemTypes?: Array<string> | null, updatedAt: string } | null, metricRanges: Array<{ __typename?: 'MetricRange', color: string, createdAt: string, deletedAt?: string | null, id: string, ideal: boolean, maxTagId?: string | null, metricId: number, minTagId?: string | null, name: string, notificationEnabled: boolean, rangeMax?: number | null, rangeMaxInclusive: boolean, rangeMin?: number | null, rangeMinInclusive: boolean, updatedAt: string, maxTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null, minTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null }>, unit?: { __typename?: 'UnitNest', createdAt: string, deletedAt?: string | null, id: number, isInterpolatable: boolean, name: string, updatedAt: string } | null }>, process: { __typename?: 'ProcessNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, siteId: number, updatedAt: string } }> };

export type CloneSitesMutationVariables = Exact<{
  input: CloneSitesInput;
}>;


export type CloneSitesMutation = { __typename?: 'Mutation', cloneSites: Array<{ __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string }> };

export type CloneSystemMutationVariables = Exact<{
  input: CloneSystemInput;
}>;


export type CloneSystemMutation = { __typename?: 'Mutation', cloneSystem: Array<{ __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string }> };

export type CloneSystemWithSelectedDescendantsMutationVariables = Exact<{
  input: CloneSystemWithSelectedDescendantsInput;
}>;


export type CloneSystemWithSelectedDescendantsMutation = { __typename?: 'Mutation', cloneSystemWithSelectedDescendants: Array<{ __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string }> };

export type CloneToTargetMutationVariables = Exact<{
  input: CloneToTargetInput;
}>;


export type CloneToTargetMutation = { __typename?: 'Mutation', cloneToTarget: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type CommitDirtyDataPointsMutationVariables = Exact<{
  input: CommitDirtyDataPointsInput;
}>;


export type CommitDirtyDataPointsMutation = { __typename?: 'Mutation', commitDirtyDataPoints: Array<{ __typename?: 'MetricDataPointType', appliedAt: string, calculatedNondetectValue?: boolean | null, calculatedValue?: string | null, comment?: string | null, connectValue?: string | null, edgeDeviceSubmissionId?: number | null, effectiveValue?: string | null, error?: string | null, id?: number | null, intervalId?: number | null, isInterpolated?: boolean | null, isNondetect?: boolean | null, measuredAt: string, metricId: number, reportDate: string, type: string, value?: string | null, version?: number | null } | null> };

export type CommitLabImportBatchMutationVariables = Exact<{
  input: CommitLabImportBatchInput;
}>;


export type CommitLabImportBatchMutation = { __typename?: 'Mutation', commitLabImportBatch: { __typename?: 'LabImportCommitResult', committedCount: number, failedCount: number, batch: { __typename?: 'LabImportBatch', checksumSha256: string, committedAt?: string | null, committedRowCount: number, createdAt: string, errorDetails?: Record<string, unknown> | null, id: string, invalidRowCount: number, originalFileName: string, profileName?: string | null, profileVersionId?: string | null, readyMetricCount: number, readySiteCount: number, reconciliationRequiredRowCount: number, skippedRowCount: number, sourceFileSizeBytes: number, sourceMimeType: string, sourceUploadId: string, status: LabImportBatchStatus, systemId: number, totalRowCount: number, validatedAt?: string | null, validRowCount: number, parserMetadata: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, profileVersion?: { __typename?: 'LabImportProfileVersion', createdAt: string, createdByUserId: number, id: string, profileId: string, version: number, definition: { __typename?: 'LabImportProfileDefinition', columnMappings: Array<{ __typename?: 'LabImportColumnMapping', column: string, field: string }>, parserConfig: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, targetMappings: Array<{ __typename?: 'LabImportTargetMapping', decision: LabImportTargetDecision, id: string, importedUnitLabel?: string | null, metricId?: number | null, metricUnitLabel?: string | null, siteId?: number | null, sourceAnalyte: string, sourceProject: string, sourceSampleSite: string, unitDecision?: LabImportUnitDecision | null }> } } | null } } };

export type ConvertToFlexReportMutationVariables = Exact<{
  reportDefinitionId: Scalars['Int'];
}>;


export type ConvertToFlexReportMutation = { __typename?: 'Mutation', convertToFlexReport: { __typename?: 'ReportDefinitionNest', annualPeriod?: string | null, configSchemaId?: string | null, customFooter?: string | null, id: number, name: string, order: number, paperOrientation: string, paperSize: string, reportTemplateId?: number | null, reportType: string, showDayOfWeek: boolean, siteId?: number | null, supplementaryEnabled: boolean, systemId: number } };

export type CreateAddressMutationVariables = Exact<{
  input: CreateAddressInput;
}>;


export type CreateAddressMutation = { __typename?: 'Mutation', createAddress: { __typename?: 'Address', city?: string | null, countryCode: string, createdAt: string, id: string, label?: string | null, line1?: string | null, line2?: string | null, organizationId?: number | null, phone?: string | null, postalCode?: string | null, purpose: AddressPurpose, recipientName?: string | null, region?: string | null, siteId?: number | null, systemId?: number | null, updatedAt: string } };

export type CreateAnalyteGroupMutationVariables = Exact<{
  input: AnalyteGroupCreateInput;
}>;


export type CreateAnalyteGroupMutation = { __typename?: 'Mutation', createAnalyteGroup: { __typename?: 'AnalyteGroup', createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, organizationId: number, updatedAt: string } };

export type CreateApiTokenMutationVariables = Exact<{
  input: CreateApiTokenInput;
}>;


export type CreateApiTokenMutation = { __typename?: 'Mutation', createApiToken: { __typename?: 'CreateApiTokenPayloadNest', credentials: { __typename?: 'MintedApiTokenCredentialsNest', realm: string, secret: string, username: string }, token: { __typename?: 'ApiTokenNest', createdAt: string, createdByUserId: number, expiresAt: string, id: number, lastUsedAt?: string | null, name: string, organizationId: number, realm: string, revokedAt?: string | null, scopes: Array<ApiTokenScope>, updatedAt: string, username: string } } };

export type CreateCalcClusterDebugByClusterIdMutationVariables = Exact<{
  input: CreateCalcClusterDebugInput;
}>;


export type CreateCalcClusterDebugByClusterIdMutation = { __typename?: 'Mutation', createCalcClusterDebugByClusterId: { __typename?: 'CalcClusterDebug', clusterId: string, enabled: boolean, id: string, metricId: number, updatedAt: string } };

export type CreateColumnGroupMutationVariables = Exact<{
  input: CreateColumnGroupInput;
}>;


export type CreateColumnGroupMutation = { __typename?: 'Mutation', createColumnGroup: { __typename?: 'ColumnGroup', createdAt: string, deletedAt?: string | null, id: string, name: string, reportDefinitionId: number, updatedAt: string } };

export type CreateColumnGroupItemsMutationVariables = Exact<{
  input: CreateColumnGroupItemsInput;
}>;


export type CreateColumnGroupItemsMutation = { __typename?: 'Mutation', createColumnGroupItems: Array<{ __typename?: 'ColumnGroupItem', aggregation?: ColumnAggregation | null, calculationType?: ColumnCalculation | null, createdAt: string, deletedAt?: string | null, id: string, intervalId?: number | null, metricId?: number | null, name?: string | null, type: ColumnGroupItemType, updatedAt: string }> };

export type CreateColumnGroupsAndItemsMutationVariables = Exact<{
  input: CreateColumnGroupsAndItemsInput;
}>;


export type CreateColumnGroupsAndItemsMutation = { __typename?: 'Mutation', createColumnGroupsAndItems: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type CreateComponentMutationVariables = Exact<{
  input: ComponentCreateInput;
}>;


export type CreateComponentMutation = { __typename?: 'Mutation', createComponent: { __typename?: 'ComponentNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, processId: number, updatedAt: string } };

export type CreateConstantDefinitionMutationVariables = Exact<{
  input: CreateConstantDefinitionInput;
}>;


export type CreateConstantDefinitionMutation = { __typename?: 'Mutation', createConstantDefinition: { __typename?: 'ConstantDefinition', createdAt: string, dataType: ConstantDataType, deletedAt?: string | null, description?: string | null, id: number, keyname: string, name: string, organizationId?: number | null, precision?: number | null, scope: ConstantScope, systemId?: number | null, unitId?: number | null, updatedAt: string } };

export type CreateEnterpriseReportShareLinkMutationVariables = Exact<{
  input: CreateEnterpriseReportShareLinkInput;
}>;


export type CreateEnterpriseReportShareLinkMutation = { __typename?: 'Mutation', createEnterpriseReportShareLink: { __typename?: 'CreateEnterpriseReportShareLinkPayload', publicUrl: string, shareLink: { __typename?: 'EnterpriseReportShareLink', createdAt: string, createdByUserId: number, deletedAt?: string | null, disabledAt?: string | null, disabledByUserId?: number | null, expiresAt: string, id: string, reportSnapshotId: string, updatedAt: string } } };

export type CreateEntryIntervalsMutationVariables = Exact<{
  input: Array<EntryIntervalCreateInput> | EntryIntervalCreateInput;
}>;


export type CreateEntryIntervalsMutation = { __typename?: 'Mutation', createEntryIntervals: Array<{ __typename?: 'IntervalNest', createdByUserId?: number | null, date?: string | null, deletedAt?: string | null, siteFullName?: string | null, createdAt: string, displayName: string, id: number, siteId: number, time: string, updatedAt: string, createdByUser?: { __typename?: 'UserNest', displayName: string, email: string, fullNameOrEmail: string, id: number } | null }> };

export type CreateFlexFormFromSystemMutationVariables = Exact<{
  input: CreateFlexFormFromSystemInput;
}>;


export type CreateFlexFormFromSystemMutation = { __typename?: 'Mutation', createFlexFormFromSystem: { __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string } };

export type CreateFolderMutationVariables = Exact<{
  input: CreateFolderInput;
}>;


export type CreateFolderMutation = { __typename?: 'Mutation', createFolder: { __typename?: 'BaseFolder', color?: string | null, createdAt: string, default: boolean, deletedAt?: string | null, depth: number, id: string, name: string, order: number, parentId?: string | null, siteId: number, updatedAt: string } };

export type CreateIntervalMutationVariables = Exact<{
  input: CreateIntervalInput;
}>;


export type CreateIntervalMutation = { __typename?: 'Mutation', createInterval: { __typename?: 'IntervalNest', siteFullName?: string | null, createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string } };

export type CreateIntervalsMutationVariables = Exact<{
  input: CreateIntervalsInput;
}>;


export type CreateIntervalsMutation = { __typename?: 'Mutation', createIntervals: Array<{ __typename?: 'IntervalNest', siteFullName?: string | null, createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string }> };

export type CreateLabImportBatchMutationVariables = Exact<{
  input: CreateLabImportBatchInput;
}>;


export type CreateLabImportBatchMutation = { __typename?: 'Mutation', createLabImportBatch: { __typename?: 'LabImportBatch', checksumSha256: string, committedAt?: string | null, committedRowCount: number, createdAt: string, errorDetails?: Record<string, unknown> | null, id: string, invalidRowCount: number, originalFileName: string, profileName?: string | null, profileVersionId?: string | null, readyMetricCount: number, readySiteCount: number, reconciliationRequiredRowCount: number, skippedRowCount: number, sourceFileSizeBytes: number, sourceMimeType: string, sourceUploadId: string, status: LabImportBatchStatus, systemId: number, totalRowCount: number, validatedAt?: string | null, validRowCount: number, parserMetadata: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, profileVersion?: { __typename?: 'LabImportProfileVersion', createdAt: string, createdByUserId: number, id: string, profileId: string, version: number, definition: { __typename?: 'LabImportProfileDefinition', columnMappings: Array<{ __typename?: 'LabImportColumnMapping', column: string, field: string }>, parserConfig: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, targetMappings: Array<{ __typename?: 'LabImportTargetMapping', decision: LabImportTargetDecision, id: string, importedUnitLabel?: string | null, metricId?: number | null, metricUnitLabel?: string | null, siteId?: number | null, sourceAnalyte: string, sourceProject: string, sourceSampleSite: string, unitDecision?: LabImportUnitDecision | null }> } } | null } };

export type CreateLogBookEntryMutationVariables = Exact<{
  input: CreateLogBookEntryInput;
}>;


export type CreateLogBookEntryMutation = { __typename?: 'Mutation', createLogBookEntry: { __typename?: 'LogBookEntryNest', createdAt: string, deletedAt?: string | null, id: string, message: string, organizationId: number, pinned: boolean, updatedAt: string, userId: number, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } } };

export type CreateLogBookEntryDashboardViewMutationVariables = Exact<{
  input: CreateLogBookEntryDashboardViewInput;
}>;


export type CreateLogBookEntryDashboardViewMutation = { __typename?: 'Mutation', createLogBookEntryDashboardView: { __typename?: 'LogBookEntryDashboardViewNest', createdAt: string, deletedAt?: string | null, id: string, message?: string | null, name: string, organizationId?: number | null, siteIds?: Array<number> | null, sortDirection: string, sortField: string, systemIds?: Array<number> | null, tagIds?: Array<string> | null, updatedAt: string, userId: number, userIds?: Array<number> | null } };

export type CreateMetricMutationVariables = Exact<{
  input: MetricCreateInput;
}>;


export type CreateMetricMutation = { __typename?: 'Mutation', createMetric: { __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean, intervals?: Array<{ __typename?: 'IntervalNest', siteFullName?: string | null, createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string }> | null, metricKeyname?: { __typename?: 'MetricKeyname', compliance: boolean, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, systemTypes?: Array<string> | null, updatedAt: string } | null, metricRanges: Array<{ __typename?: 'MetricRange', color: string, createdAt: string, deletedAt?: string | null, id: string, ideal: boolean, maxTagId?: string | null, metricId: number, minTagId?: string | null, name: string, notificationEnabled: boolean, rangeMax?: number | null, rangeMaxInclusive: boolean, rangeMin?: number | null, rangeMinInclusive: boolean, updatedAt: string, maxTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null, minTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null }>, unit?: { __typename?: 'UnitNest', createdAt: string, deletedAt?: string | null, id: number, isInterpolatable: boolean, name: string, updatedAt: string } | null } };

export type CreateMetricKeynameMutationVariables = Exact<{
  input: MetricKeynameCreateInput;
}>;


export type CreateMetricKeynameMutation = { __typename?: 'Mutation', createMetricKeyname: { __typename?: 'MetricKeyname', compliance: boolean, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, systemTypes?: Array<string> | null, updatedAt: string } };

export type CreateNotificationMutationVariables = Exact<{
  input: CreateNotificationInput;
}>;


export type CreateNotificationMutation = { __typename?: 'Mutation', createNotification: { __typename?: 'Notification', active: boolean, appearance: NotificationAppearance, createdAt: string, deletedAt?: string | null, dismissable: boolean, displayPosition: NotificationDisplayPosition, endDate?: string | null, icon?: SelectableIcons | null, id: string, message: string, name: string, organizationId: number, startDate: string, systemGroupId?: number | null, systemId?: number | null, title?: string | null, updatedAt: string } };

export type CreateOrganizationIntegrationMutationVariables = Exact<{
  input: CreateOrganizationIntegrationInput;
}>;


export type CreateOrganizationIntegrationMutation = { __typename?: 'Mutation', createOrganizationIntegration: { __typename?: 'OrganizationIntegrationNest', id: number } };

export type CreatePermitMutationVariables = Exact<{
  input: PermitCreateInput;
}>;


export type CreatePermitMutation = { __typename?: 'Mutation', createPermit: { __typename?: 'Permit', createdAt: string, deletedAt?: string | null, id: string, isPublicWaterSystemId: boolean, name: string, permitCode: string, systemId: number, updatedAt: string } };

export type CreateProcessMutationVariables = Exact<{
  input: ProcessCreateInput;
}>;


export type CreateProcessMutation = { __typename?: 'Mutation', createProcess: { __typename?: 'ProcessNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, siteId: number, updatedAt: string } };

export type CreateReportDistributionListMutationVariables = Exact<{
  input: CreateReportDistributionListInput;
}>;


export type CreateReportDistributionListMutation = { __typename?: 'Mutation', createReportDistributionList: { __typename?: 'ReportDistributionList', createdAt: string, deletedAt?: string | null, description?: string | null, displaySummary: string, id: string, isArchived: boolean, memberCount: number, name: string, normalizedName: string, organizationId?: number | null, scope: ReportDistributionListScope, siteId?: number | null, systemId?: number | null, updatedAt: string, members: Array<{ __typename?: 'ReportDistributionListMember', createdAt: string, displayName?: string | null, id: string, memberType: ReportDistributionListMemberType, normalizedEmail: string, sortOrder: number, updatedAt: string, userId?: number | null }> } };

export type CreateRoundsShiftNoteMutationVariables = Exact<{
  input: CreateRoundsShiftNoteInput;
}>;


export type CreateRoundsShiftNoteMutation = { __typename?: 'Mutation', createRoundsShiftNote: { __typename?: 'RoundsShiftNoteCreateResult', noteId: string, viewUrl: string } };

export type CreateSampleCollectionMutationVariables = Exact<{
  input: SampleCollectionCreateInput;
}>;


export type CreateSampleCollectionMutation = { __typename?: 'Mutation', createSampleCollection: { __typename?: 'SampleCollection', createdAt: string, deletedAt?: string | null, id: string, sampleSiteId: string, scheduledItemId?: string | null, systemId: number, updatedAt: string } };

export type CreateSampleCollectionCustodyMutationVariables = Exact<{
  input: SampleCollectionCustodyCreateInput;
}>;


export type CreateSampleCollectionCustodyMutation = { __typename?: 'Mutation', createSampleCollectionCustody: Array<{ __typename?: 'SampleCollectionCustody', comment?: string | null, createdAt: string, createdBy: number, deletedAt?: string | null, id: string, previousCustodyId?: string | null, relinquishedBy?: number | null, relinquishedTo: number, sampleCollectionId: string, systemId: number, updatedAt: string }> };

export type CreateSampleScheduleMutationVariables = Exact<{
  input: CreateSampleScheduleInput;
}>;


export type CreateSampleScheduleMutation = { __typename?: 'Mutation', createSampleSchedule: { __typename?: 'SampleSchedule', analyteGroupId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, sampleSiteId: string, sampleType: SampleType, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string } };

export type CreateSampleSiteMutationVariables = Exact<{
  input: SampleSiteCreateInput;
}>;


export type CreateSampleSiteMutation = { __typename?: 'Mutation', createSampleSite: { __typename?: 'SampleSite', address?: string | null, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, isActive: boolean, lastInspectionDate?: string | null, latitude?: number | null, longitude?: number | null, name: string, organizationId: number, samplePointType?: string | null, updatedAt: string, url?: string | null, photoUpload?: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } | null } };

export type CreateScheduledItemCommentMutationVariables = Exact<{
  input: CreateScheduledItemCommentInput;
}>;


export type CreateScheduledItemCommentMutation = { __typename?: 'Mutation', createScheduledItemComment: { __typename?: 'ScheduledItemComment', comment: string, commentType: ScheduledItemCommentType, createdAt: string, id: string, scheduledItemId: string, updatedAt: string, userId: number, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } } };

export type CreateSystemMutationVariables = Exact<{
  input: CreateSystemInput;
}>;


export type CreateSystemMutation = { __typename?: 'Mutation', createSystem: { __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string, addresses: Array<{ __typename?: 'Address', city?: string | null, countryCode: string, createdAt: string, id: string, label?: string | null, line1?: string | null, line2?: string | null, organizationId?: number | null, phone?: string | null, postalCode?: string | null, purpose: AddressPurpose, recipientName?: string | null, region?: string | null, siteId?: number | null, systemId?: number | null, updatedAt: string }> } };

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } };

export type CreateUnitMutationVariables = Exact<{
  input: UnitCreateInput;
}>;


export type CreateUnitMutation = { __typename?: 'Mutation', createUnit: { __typename?: 'UnitNest', createdAt: string, deletedAt?: string | null, id: number, isInterpolatable: boolean, name: string, updatedAt: string } };

export type CreateUserPhraseMutationVariables = Exact<{
  input: CreatePhraseInput;
}>;


export type CreateUserPhraseMutation = { __typename?: 'Mutation', createPhrase: { __typename?: 'Phrase', bodyText: string, id: string, name: string, organizationId?: number | null, userId?: number | null } };

export type CreateWeatherDataStationMutationVariables = Exact<{
  input: CreateWeatherDataStationInput;
}>;


export type CreateWeatherDataStationMutation = { __typename?: 'Mutation', createWeatherDataStation: { __typename?: 'WeatherDataStationNest', deletedAt?: string | null, id: string, latitude: number, locationName: string, longitude: number, stateCode?: string | null, usgsStationId?: string | null } };

export type DeleteActivityScheduleMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteActivityScheduleMutation = { __typename?: 'Mutation', deleteActivitySchedule?: { __typename?: 'ActivitySchedule', id: string } | null };

export type DeleteColumnGroupItemMutationVariables = Exact<{
  input: DeleteColumnGroupItemInput;
}>;


export type DeleteColumnGroupItemMutation = { __typename?: 'Mutation', deleteColumnGroupItem: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteComponentMutationVariables = Exact<{
  input: DeleteComponentInput;
}>;


export type DeleteComponentMutation = { __typename?: 'Mutation', deleteComponent: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteFolderMutationVariables = Exact<{
  input: DeleteFolderInput;
}>;


export type DeleteFolderMutation = { __typename?: 'Mutation', deleteFolder: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteIntervalMutationVariables = Exact<{
  input: DeleteIntervalInput;
}>;


export type DeleteIntervalMutation = { __typename?: 'Mutation', deleteInterval?: { __typename?: 'Interval', displayName?: string | null, id: number, time: string } | null };

export type DeleteLicenseMutationVariables = Exact<{
  input: DeleteLicenseInput;
}>;


export type DeleteLicenseMutation = { __typename?: 'Mutation', deleteLicense?: { __typename?: 'LicenseNest', authority: string, displayName: string, id: number, licenseLabel: string, licenseNumber: string, userId: number } | null };

export type DeleteLogBookEntryMutationVariables = Exact<{
  input: DeleteLogBookEntryInput;
}>;


export type DeleteLogBookEntryMutation = { __typename?: 'Mutation', deleteLogBookEntry: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteLogBookEntryDashboardViewMutationVariables = Exact<{
  input: DeleteLogBookEntryDashboardViewInput;
}>;


export type DeleteLogBookEntryDashboardViewMutation = { __typename?: 'Mutation', deleteLogBookEntryDashboardView: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteMetricMutationVariables = Exact<{
  input: DeleteMetricInput;
}>;


export type DeleteMetricMutation = { __typename?: 'Mutation', deleteMetric: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteMetricKeynameMutationVariables = Exact<{
  input: MetricKeynameDeleteInput;
}>;


export type DeleteMetricKeynameMutation = { __typename?: 'Mutation', deleteMetricKeyname: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteMetricRangeMutationVariables = Exact<{
  input: DeleteMetricRangeInput;
}>;


export type DeleteMetricRangeMutation = { __typename?: 'Mutation', deleteMetricRange: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteNotificationMutationVariables = Exact<{
  input: DeleteNotificationInput;
}>;


export type DeleteNotificationMutation = { __typename?: 'Mutation', deleteNotification: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteOrganizationIntegrationMutationVariables = Exact<{
  input: DeleteOrganizationIntegrationInput;
}>;


export type DeleteOrganizationIntegrationMutation = { __typename?: 'Mutation', deleteOrganizationIntegration: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeletePermitMutationVariables = Exact<{
  input: DeletePermitInput;
}>;


export type DeletePermitMutation = { __typename?: 'Mutation', deletePermit: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeletePhoneNumberMutationVariables = Exact<{
  input: DeletePhoneNumberInput;
}>;


export type DeletePhoneNumberMutation = { __typename?: 'Mutation', deletePhoneNumber: { __typename?: 'PhoneNumberNest', country: string, id: number, phoneNumber: string } };

export type DeletePhraseMutationVariables = Exact<{
  input: DeletePhraseInput;
}>;


export type DeletePhraseMutation = { __typename?: 'Mutation', deletePhrase: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteProcessMutationVariables = Exact<{
  input: DeleteProcessInput;
}>;


export type DeleteProcessMutation = { __typename?: 'Mutation', deleteProcess: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteReportNodesMutationVariables = Exact<{
  input: DeleteReportNodesInput;
}>;


export type DeleteReportNodesMutation = { __typename?: 'Mutation', deleteReportNodes: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteSiteMutationVariables = Exact<{
  input: DeleteSiteInput;
}>;


export type DeleteSiteMutation = { __typename?: 'Mutation', deleteSite: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteSiteFlexMetricMutationVariables = Exact<{
  input: SiteFlexMetricDeleteInput;
}>;


export type DeleteSiteFlexMetricMutation = { __typename?: 'Mutation', deleteSiteFlexMetric: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteSystemMutationVariables = Exact<{
  input: DeleteSystemInput;
}>;


export type DeleteSystemMutation = { __typename?: 'Mutation', deleteSystem: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteSystemFavoriteMutationVariables = Exact<{
  input: DeleteSystemFavoriteInput;
}>;


export type DeleteSystemFavoriteMutation = { __typename?: 'Mutation', deleteSystemFavorite: { __typename?: 'SystemType', displayName: string, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, hasSitesWithIntervals: boolean, hideDataSites: boolean, id: number, isFavorite: boolean, isTemplate: boolean, licenseId?: number | null, myRole: SystemGroupRoleEnum, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId?: number | null, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type?: SystemTypeEnum | null } };

export type DeleteSystemGroupMutationVariables = Exact<{
  input: DeleteSystemGroupInput;
}>;


export type DeleteSystemGroupMutation = { __typename?: 'Mutation', deleteSystemGroup?: { __typename?: 'SystemGroupType', displayName: string, id: number, isTopLevel: boolean, name: string, organizationId: number, parentSystemGroupId?: number | null } | null };

export type DeleteTagMutationVariables = Exact<{
  input: DeleteTagInput;
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteTagMappingMutationVariables = Exact<{
  input: DeleteTagMappingInput;
}>;


export type DeleteTagMappingMutation = { __typename?: 'Mutation', deleteTagMapping?: { __typename?: 'TagMappingType', edgeDeviceId: number, id: number, metricId: number, tagName: string } | null };

export type DeleteTrendMutationVariables = Exact<{
  input: DeleteTrendInput;
  systemId: Scalars['Int'];
}>;


export type DeleteTrendMutation = { __typename?: 'Mutation', deleteTrend: { __typename?: 'TrendNest', id: number, isGlobal: boolean, keynameFilters: Array<string>, name: string, ownerId: number, resolvedMetricIds: Array<number>, systemId?: number | null, systemType: SystemTypeEnum, owner: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean }, system?: { __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string } | null } };

export type DeleteUnitMutationVariables = Exact<{
  input: DeleteUnitInput;
}>;


export type DeleteUnitMutation = { __typename?: 'Mutation', deleteUnit: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type DeleteUserFromSystemMutationVariables = Exact<{
  input: DeleteUserFromSystemInput;
}>;


export type DeleteUserFromSystemMutation = { __typename?: 'Mutation', deleteUserFromSystem: Array<{ __typename?: 'UserInfoType', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean } | null> };

export type InitSsoUserMutationVariables = Exact<{ [key: string]: never; }>;


export type InitSsoUserMutation = { __typename?: 'Mutation', initSSOUser: { __typename?: 'UserInfoType', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean } };

export type MigrateSiteDataToTimeSeriesMutationVariables = Exact<{
  input: MigrateSiteDataToTimeSeriesInput;
}>;


export type MigrateSiteDataToTimeSeriesMutation = { __typename?: 'Mutation', migrateSiteDataToTimeSeries: { __typename?: 'MigrateSiteDataToTimeSeriesResult', id: number, success: boolean } };

export type RecalculateMetricMutationVariables = Exact<{
  input: RecalculateMetricInput;
}>;


export type RecalculateMetricMutation = { __typename?: 'Mutation', recalculateMetric: { __typename?: 'MetricType', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, dataPointCommentPolicy?: DataPointCommentPolicy | null, dataType: MetricDataTypeEnum, deletedAt?: string | null, detectionLimit?: number | null, displayName: string, displayNameSiteLocal: string, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null } };

export type RemoveUserFromSystemGroupMutationVariables = Exact<{
  input: RemoveUserFromSystemGroupInput;
  systemGroupId: Scalars['Int'];
}>;


export type RemoveUserFromSystemGroupMutation = { __typename?: 'Mutation', removeUserFromSystemGroup: { __typename?: 'UserInfoType', roleForSystemGroup: SystemGroupRoleEnum, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean } };

export type ReplayWaterlyConnectSubmissionMutationVariables = Exact<{
  submissionId: Scalars['Int'];
}>;


export type ReplayWaterlyConnectSubmissionMutation = { __typename?: 'Mutation', replayWaterlyConnectSubmission: { __typename?: 'EdgeDeviceSubmission', createdAt: string, dataExcerpt: string, edgeDeviceId: number, id: number, remoteIp?: string | null, status: EdgeDeviceSubmissionStatus, updatedAt: string, edgeDevice: { __typename?: 'EdgeDeviceType', deviceName?: string | null, id: number } } };

export type ArchiveReportingReportGroupMutationVariables = Exact<{
  input: ArchiveReportingReportGroupInput;
}>;


export type ArchiveReportingReportGroupMutation = { __typename?: 'Mutation', archiveReportingReportGroup: { __typename?: 'ReportingReportGroupNest', id: number, name: string, order: number, systemId: number } };

export type CreateReportingReportGroupMutationVariables = Exact<{
  input: CreateReportingReportGroupInput;
}>;


export type CreateReportingReportGroupMutation = { __typename?: 'Mutation', createReportingReportGroup: { __typename?: 'ReportingReportGroupNest', id: number, name: string, order: number, systemId: number } };

export type DeleteReportDefinitionMutationVariables = Exact<{
  input: DeleteReportDefinitionByIdInput;
}>;


export type DeleteReportDefinitionMutation = { __typename?: 'Mutation', deleteReportDefinitionById: boolean };

export type UpdateMetricForReportMutationVariables = Exact<{
  input: UpdateMetricForReportInput;
}>;


export type UpdateMetricForReportMutation = { __typename?: 'Mutation', updateMetricForReport: { __typename?: 'ReportDefinition', annualPeriod?: string | null, configSchemaId?: string | null, customFooter?: string | null, id: number, isFlex: boolean, metadata?: Record<string, unknown> | null, name: string, order: number, paperOrientation: PaperOrientationEnum, paperSize: PaperSizeEnum, reportGroupId?: number | null, reportTemplateId: number, reportType: ReportTypeEnum, showDayOfWeek: boolean, siteId?: number | null, supplementaryEnabled: boolean, systemId: number, timeFormat: TimeFormatEnum, reportGroup?: { __typename?: 'ReportGroup', id: number, name: string, order: number, systemId: number } | null, system: { __typename?: 'SystemType', id: number, name: string } } };

export type UpdateProcessForReportMutationVariables = Exact<{
  input: UpdateProcessForReportInput;
  reportDefinitionId: Scalars['Int'];
}>;


export type UpdateProcessForReportMutation = { __typename?: 'Mutation', updateProcessForReport: { __typename?: 'ReportDefinition', annualPeriod?: string | null, configSchemaId?: string | null, customFooter?: string | null, id: number, isFlex: boolean, metadata?: Record<string, unknown> | null, name: string, order: number, paperOrientation: PaperOrientationEnum, paperSize: PaperSizeEnum, reportGroupId?: number | null, reportTemplateId: number, reportType: ReportTypeEnum, showDayOfWeek: boolean, siteId?: number | null, supplementaryEnabled: boolean, systemId: number, timeFormat: TimeFormatEnum, reportGroup?: { __typename?: 'ReportGroup', id: number, name: string, order: number, systemId: number } | null, system: { __typename?: 'SystemType', id: number, name: string }, site?: { __typename?: 'SiteType', flex?: boolean | null, id: number, name?: string | null, processes: Array<{ __typename?: 'ProcessType', deletedAt?: string | null, enabledForReport?: boolean | null, id: number, name: string, order: number, components: Array<{ __typename?: 'ComponentType', enabledForReport?: boolean | null, id: number, name: string, order: number, metrics: Array<{ __typename?: 'MetricType', deletedAt?: string | null, enabledForReport: boolean, id: number, isReportComments: boolean, name: string, order: number, enabledIntervalForMonthlyReport?: { __typename?: 'Interval', displayName?: string | null, id: number, time: string } | null, intervals: Array<{ __typename?: 'Interval', displayName?: string | null, id: number, time: string }>, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null }> }>, metrics: Array<{ __typename?: 'MetricType', deletedAt?: string | null, enabledForReport: boolean, id: number, isReportComments: boolean, name: string, order: number, enabledIntervalForMonthlyReport?: { __typename?: 'Interval', displayName?: string | null, id: number, time: string } | null, intervals: Array<{ __typename?: 'Interval', displayName?: string | null, id: number, time: string }>, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null }> }> } | null } };

export type UpdateReportDefinitionMutationVariables = Exact<{
  input: UpdateReportDefinitionInput;
}>;


export type UpdateReportDefinitionMutation = { __typename?: 'Mutation', updateReportDefinition: { __typename?: 'ReportDefinition', annualPeriod?: string | null, configSchemaId?: string | null, customFooter?: string | null, id: number, isFlex: boolean, metadata?: Record<string, unknown> | null, name: string, order: number, paperOrientation: PaperOrientationEnum, paperSize: PaperSizeEnum, reportGroupId?: number | null, reportTemplateId: number, reportType: ReportTypeEnum, showDayOfWeek: boolean, siteId?: number | null, supplementaryEnabled: boolean, systemId: number, timeFormat: TimeFormatEnum, reportGroup?: { __typename?: 'ReportGroup', id: number, name: string, order: number, systemId: number } | null, system: { __typename?: 'SystemType', id: number, name: string } } };

export type UpdateReportingReportDefinitionGroupsMutationVariables = Exact<{
  input: UpdateReportingReportDefinitionGroupsInput;
}>;


export type UpdateReportingReportDefinitionGroupsMutation = { __typename?: 'Mutation', updateReportingReportDefinitionGroups: boolean };

export type UpdateReportingReportGroupMutationVariables = Exact<{
  input: UpdateReportingReportGroupInput;
}>;


export type UpdateReportingReportGroupMutation = { __typename?: 'Mutation', updateReportingReportGroup: { __typename?: 'ReportingReportGroupNest', id: number, name: string, order: number, systemId: number } };

export type RequestEnterpriseReportShareLinkAccessMutationVariables = Exact<{
  input: RequestEnterpriseReportShareLinkAccessInput;
}>;


export type RequestEnterpriseReportShareLinkAccessMutation = { __typename?: 'Mutation', requestEnterpriseReportShareLinkAccess: { __typename?: 'EnterpriseReportShareLinkAccessRequestPayload', emailRecipient?: string | null, submitted: boolean } };

export type RestoreComponentMutationVariables = Exact<{
  input: RestoreComponentInput;
}>;


export type RestoreComponentMutation = { __typename?: 'Mutation', restoreComponent: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type RestoreConstantDefinitionMutationVariables = Exact<{
  input: RestoreConstantDefinitionInput;
}>;


export type RestoreConstantDefinitionMutation = { __typename?: 'Mutation', restoreConstantDefinition: { __typename?: 'ConstantDefinition', usedByMetricCount: number, createdAt: string, dataType: ConstantDataType, deletedAt?: string | null, description?: string | null, id: number, keyname: string, name: string, organizationId?: number | null, precision?: number | null, scope: ConstantScope, systemId?: number | null, unitId?: number | null, updatedAt: string, values: Array<{ __typename?: 'ConstantValue', constantDefinitionId: number, createdAt: string, deletedAt?: string | null, effectiveDate: string, id: number, note?: string | null, numericValue?: number | null, textValue?: string | null, updatedAt: string }> } };

export type RestoreConstantValueMutationVariables = Exact<{
  input: RestoreConstantValueInput;
}>;


export type RestoreConstantValueMutation = { __typename?: 'Mutation', restoreConstantValue: { __typename?: 'ConstantValue', constantDefinitionId: number, createdAt: string, deletedAt?: string | null, effectiveDate: string, id: number, note?: string | null, numericValue?: number | null, textValue?: string | null, updatedAt: string } };

export type RestoreFolderMutationVariables = Exact<{
  input: RestoreFolderInput;
}>;


export type RestoreFolderMutation = { __typename?: 'Mutation', restoreFolder: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type RestoreMetricMutationVariables = Exact<{
  input: RestoreMetricInput;
}>;


export type RestoreMetricMutation = { __typename?: 'Mutation', restoreMetric: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type RestoreProcessMutationVariables = Exact<{
  input: RestoreProcessInput;
}>;


export type RestoreProcessMutation = { __typename?: 'Mutation', restoreProcess: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type RestoreSiteMutationVariables = Exact<{
  input: RestoreSiteInput;
}>;


export type RestoreSiteMutation = { __typename?: 'Mutation', restoreSite: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type RestoreSiteFlexMetricMutationVariables = Exact<{
  input: SiteFlexMetricRestoreInput;
}>;


export type RestoreSiteFlexMetricMutation = { __typename?: 'Mutation', restoreSiteFlexMetric: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type RestoreWeatherDataStationMutationVariables = Exact<{
  input: WeatherDataStationIdInput;
}>;


export type RestoreWeatherDataStationMutation = { __typename?: 'Mutation', restoreWeatherDataStation: { __typename?: 'WeatherDataStationNest', deletedAt?: string | null, id: string, latitude: number, locationName: string, longitude: number, stateCode?: string | null, usgsStationId?: string | null } };

export type RevokeApiTokenMutationVariables = Exact<{
  input: RevokeApiTokenInput;
}>;


export type RevokeApiTokenMutation = { __typename?: 'Mutation', revokeApiToken: { __typename?: 'ApiTokenNest', createdAt: string, createdByUserId: number, expiresAt: string, id: number, lastUsedAt?: string | null, name: string, organizationId: number, realm: string, revokedAt?: string | null, scopes: Array<ApiTokenScope>, updatedAt: string, username: string } };

export type SendEmailVerificationMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type SendEmailVerificationMutation = { __typename?: 'Mutation', sendEmailVerification: { __typename?: 'UserInfoType', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean } };

export type SendManualReportEmailMutationVariables = Exact<{
  input: SendManualReportEmailInput;
}>;


export type SendManualReportEmailMutation = { __typename?: 'Mutation', sendManualReportEmail: { __typename?: 'SendManualReportEmailPayload', publicUrl: string, shareLinkId: string, emailEvent: { __typename?: 'ManualReportEmailEvent', comment?: string | null, createdAt: string, id: string, providerMessageId?: string | null, reportSnapshotId: string, senderEmail: string, senderUserId: number, sentAt?: string | null, shareLinkId: string, status: ManualReportEmailEventStatus, subject: string, updatedAt: string, recipients: Array<{ __typename?: 'ManualReportEmailRecipient', id: string, normalizedEmail: string, recipientKind: ManualReportEmailRecipientKind, recipientSource: ManualReportEmailRecipientSource, sourceDistributionListId?: string | null, sourceDistributionListName?: string | null, userId?: number | null }> } } };

export type SetRuntimeLoggerOverrideMutationVariables = Exact<{
  input: SetRuntimeLoggerOverrideInput;
}>;


export type SetRuntimeLoggerOverrideMutation = { __typename?: 'Mutation', setRuntimeLoggerOverride: { __typename?: 'RuntimeLoggerOverride', expiresAt: string, level: RuntimeLogLevel, updatedAt: string } };

export type SnoozeAllOrgRetentionRisksMutationVariables = Exact<{
  input: SnoozeAllOrgRetentionRisksInput;
}>;


export type SnoozeAllOrgRetentionRisksMutation = { __typename?: 'Mutation', snoozeAllOrgRetentionRisks: Array<{ __typename?: 'RetentionRiskNest', createdAt: string, deletedAt?: string | null, displayName: string, flag: boolean, flagType: RetentionRiskFlagType, id: string, itemId: string, itemType: RetentionRiskItemType, organizationId: number, score: number, snooze?: string | null, updatedAt: string }> };

export type SnoozeRetentionRiskMutationVariables = Exact<{
  input: SnoozeRetentionRiskInput;
}>;


export type SnoozeRetentionRiskMutation = { __typename?: 'Mutation', snoozeRetentionRisk?: { __typename?: 'RetentionRiskNest', createdAt: string, deletedAt?: string | null, displayName: string, flag: boolean, flagType: RetentionRiskFlagType, id: string, itemId: string, itemType: RetentionRiskItemType, organizationId: number, score: number, snooze?: string | null, updatedAt: string } | null };

export type StartMirroringMutationVariables = Exact<{
  input: StartMirroringInput;
}>;


export type StartMirroringMutation = { __typename?: 'Mutation', startMirroring: { __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string } };

export type StopMirroringMutationVariables = Exact<{
  input: StopMirroringInput;
}>;


export type StopMirroringMutation = { __typename?: 'Mutation', stopMirroring: { __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string } };

export type SubmitConstantRecalculationMutationVariables = Exact<{
  input: ConstantRecalculationInput;
}>;


export type SubmitConstantRecalculationMutation = { __typename?: 'Mutation', submitConstantRecalculation: { __typename?: 'ConstantRecalculationEstimate', capped: boolean, dayCount: number, effectiveFromDate: string, recalcFromDate: string, toDate: string, totalRecalculationCount: number, metrics: Array<{ __typename?: 'ConstantImpactedMetric', metricId: number, metricName: string, recalculationCount: number, siteName?: string | null }> } };

export type SubmitSiteRecalculationMutationVariables = Exact<{
  input: SubmitSiteRecalculationInput;
}>;


export type SubmitSiteRecalculationMutation = { __typename?: 'Mutation', submitSiteRecalculation: { __typename?: 'RecalculatedMetricsResult', recalculationCount: number } };

export type TransferComponentMutationVariables = Exact<{
  input: TransferComponentInput;
}>;


export type TransferComponentMutation = { __typename?: 'Mutation', transferComponent: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type TransferMetricMutationVariables = Exact<{
  input: TransferMetricInput;
}>;


export type TransferMetricMutation = { __typename?: 'Mutation', transferMetric: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type TransferMetricToFolderMutationVariables = Exact<{
  input: TransferMetricToFolderInput;
}>;


export type TransferMetricToFolderMutation = { __typename?: 'Mutation', transferMetricToFolder: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type TransferSystemMutationVariables = Exact<{
  input: TransferSystemInput;
}>;


export type TransferSystemMutation = { __typename?: 'Mutation', transferSystem: { __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string } };

export type TriggerAnalyticsReportSnapshotMutationVariables = Exact<{
  input: TriggerAnalyticsReportSnapshotInput;
}>;


export type TriggerAnalyticsReportSnapshotMutation = { __typename?: 'Mutation', triggerAnalyticsReportSnapshot: { __typename?: 'ReportSnapshot', config?: Record<string, unknown> | null, configSchemaVersion: ReportSnapshotConfigSchemaVersion, createdAt: string, data?: Record<string, unknown> | null, deletedAt?: string | null, enterpriseReportId?: string | null, id: string, name: string, reportDateTime: string, reportDefinitionId?: number | null, status: ReportStatus, updatedAt: string, url?: string | null, report: { __typename?: 'ReportNest', description: string, id: string, name: string, organizationId?: number | null, reportTemplate?: string | null, reportType: ReportType, siteId?: number | null, systemId?: number | null }, reportDefinition?: { __typename?: 'ReportDefinitionNest', annualPeriod?: string | null, configSchemaId?: string | null, customFooter?: string | null, id: number, name: string, order: number, paperOrientation: string, paperSize: string, reportTemplateId?: number | null, reportType: string, showDayOfWeek: boolean, siteId?: number | null, supplementaryEnabled: boolean, systemId: number } | null, system?: { __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string } | null } };

export type TriggerMetricRangeEmailsMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerMetricRangeEmailsMutation = { __typename?: 'Mutation', triggerMetricRangeEmails: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type UpdateActivityScheduleMutationVariables = Exact<{
  input: ActivityScheduleUpdateInput;
}>;


export type UpdateActivityScheduleMutation = { __typename?: 'Mutation', updateActivitySchedule: { __typename?: 'ActivitySchedule', activityScheduleTypeId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, deletedAt?: string | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string } };

export type UpdateAddressMutationVariables = Exact<{
  input: UpdateAddressInput;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', updateAddress?: { __typename?: 'Address', city?: string | null, countryCode: string, createdAt: string, id: string, label?: string | null, line1?: string | null, line2?: string | null, organizationId?: number | null, phone?: string | null, postalCode?: string | null, purpose: AddressPurpose, recipientName?: string | null, region?: string | null, siteId?: number | null, systemId?: number | null, updatedAt: string } | null };

export type UpdateAnalyteGroupMutationVariables = Exact<{
  input: AnalyteGroupUpdateInput;
}>;


export type UpdateAnalyteGroupMutation = { __typename?: 'Mutation', updateAnalyteGroup: { __typename?: 'AnalyteGroup', createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, organizationId: number, updatedAt: string } };

export type UpdateCalcClusterDebugMutationVariables = Exact<{
  input: CalcClusterDebugUpdateInput;
}>;


export type UpdateCalcClusterDebugMutation = { __typename?: 'Mutation', updateCalcClusterDebug: { __typename?: 'CalcClusterDebug', clusterId: string, enabled: boolean, id: string, metricId: number, updatedAt: string } };

export type UpdateColumnGroupMutationVariables = Exact<{
  input: UpdateColumnGroupInput;
}>;


export type UpdateColumnGroupMutation = { __typename?: 'Mutation', updateColumnGroup: { __typename?: 'ColumnGroup', createdAt: string, deletedAt?: string | null, id: string, name: string, reportDefinitionId: number, updatedAt: string } };

export type UpdateColumnGroupItemMutationVariables = Exact<{
  input: UpdateColumnGroupItemInput;
}>;


export type UpdateColumnGroupItemMutation = { __typename?: 'Mutation', updateColumnGroupItem: { __typename?: 'ColumnGroupItem', aggregation?: ColumnAggregation | null, calculationType?: ColumnCalculation | null, createdAt: string, deletedAt?: string | null, id: string, intervalId?: number | null, metricId?: number | null, name?: string | null, type: ColumnGroupItemType, updatedAt: string } };

export type UpdateComponentsMutationVariables = Exact<{
  input: UpdateComponentsInput;
}>;


export type UpdateComponentsMutation = { __typename?: 'Mutation', updateComponents: Array<{ __typename?: 'ComponentNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, processId: number, updatedAt: string }> };

export type UpdateConstantDefinitionMutationVariables = Exact<{
  input: UpdateConstantDefinitionInput;
}>;


export type UpdateConstantDefinitionMutation = { __typename?: 'Mutation', updateConstantDefinition: { __typename?: 'ConstantDefinition', createdAt: string, dataType: ConstantDataType, deletedAt?: string | null, description?: string | null, id: number, keyname: string, name: string, organizationId?: number | null, precision?: number | null, scope: ConstantScope, systemId?: number | null, unitId?: number | null, updatedAt: string } };

export type UpdateDataEntryMetricsMutationVariables = Exact<{
  input: MetricsUpdateInput;
}>;


export type UpdateDataEntryMetricsMutation = { __typename?: 'Mutation', updateMetrics: Array<{ __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean, intervals?: Array<{ __typename?: 'IntervalNest', siteFullName?: string | null, createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string }> | null, metricKeyname?: { __typename?: 'MetricKeyname', compliance: boolean, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, systemTypes?: Array<string> | null, updatedAt: string } | null, metricRanges: Array<{ __typename?: 'MetricRange', color: string, createdAt: string, deletedAt?: string | null, id: string, ideal: boolean, maxTagId?: string | null, metricId: number, minTagId?: string | null, name: string, notificationEnabled: boolean, rangeMax?: number | null, rangeMaxInclusive: boolean, rangeMin?: number | null, rangeMinInclusive: boolean, updatedAt: string, maxTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null, minTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null }>, unit?: { __typename?: 'UnitNest', createdAt: string, deletedAt?: string | null, id: number, isInterpolatable: boolean, name: string, updatedAt: string } | null }> };

export type UpdateEdgeDeviceMutationVariables = Exact<{
  input: UpdateEdgeDeviceNestInput;
}>;


export type UpdateEdgeDeviceMutation = { __typename?: 'Mutation', updateEdgeDevice: { __typename?: 'EdgeDeviceNest', createdAt: string, deviceName: string, deviceType: EdgeDeviceTypeNest, enabled: boolean, id: number, integrationMetadata?: Record<string, unknown> | null, lastReceivedAt?: string | null, organizationId: number, organizationName?: string | null, updatedAt: string } };

export type UpdateEnterpriseReportShareLinkMutationVariables = Exact<{
  input: UpdateEnterpriseReportShareLinkInput;
}>;


export type UpdateEnterpriseReportShareLinkMutation = { __typename?: 'Mutation', updateEnterpriseReportShareLink: { __typename?: 'UpdateEnterpriseReportShareLinkPayload', publicUrl: string, shareLink: { __typename?: 'EnterpriseReportShareLink', createdAt: string, createdByUserId: number, deletedAt?: string | null, disabledAt?: string | null, disabledByUserId?: number | null, expiresAt: string, id: string, reportSnapshotId: string, updatedAt: string } } };

export type UpdateFolderMutationVariables = Exact<{
  input: UpdateFolderInput;
}>;


export type UpdateFolderMutation = { __typename?: 'Mutation', updateFolder: { __typename?: 'BaseFolder', color?: string | null, createdAt: string, default: boolean, deletedAt?: string | null, depth: number, id: string, name: string, order: number, parentId?: string | null, siteId: number, updatedAt: string } };

export type UpdateFoldersMutationVariables = Exact<{
  input: UpdateFoldersInput;
}>;


export type UpdateFoldersMutation = { __typename?: 'Mutation', updateFolders: Array<{ __typename?: 'BaseFolder', color?: string | null, createdAt: string, default: boolean, deletedAt?: string | null, depth: number, id: string, name: string, order: number, parentId?: string | null, siteId: number, updatedAt: string }> };

export type UpdateLicenseMutationVariables = Exact<{
  input: UpdateLicenseInput;
}>;


export type UpdateLicenseMutation = { __typename?: 'Mutation', updateLicense: { __typename?: 'LicenseNest', authority: string, displayName: string, id: number, licenseLabel: string, licenseNumber: string, userId: number } };

export type UpdateLogBookEntryMutationVariables = Exact<{
  input: UpdateLogBookEntryInput;
}>;


export type UpdateLogBookEntryMutation = { __typename?: 'Mutation', updateLogBookEntry: { __typename?: 'LogBookEntryNest', createdAt: string, deletedAt?: string | null, id: string, message: string, organizationId: number, pinned: boolean, updatedAt: string, userId: number } };

export type UpdateLogBookEntryDashboardViewMutationVariables = Exact<{
  input: UpdateLogBookEntryDashboardViewInput;
}>;


export type UpdateLogBookEntryDashboardViewMutation = { __typename?: 'Mutation', updateLogBookEntryDashboardView: { __typename?: 'LogBookEntryDashboardViewNest', createdAt: string, deletedAt?: string | null, id: string, message?: string | null, name: string, organizationId?: number | null, siteIds?: Array<number> | null, sortDirection: string, sortField: string, systemIds?: Array<number> | null, tagIds?: Array<string> | null, updatedAt: string, userId: number, userIds?: Array<number> | null } };

export type UpdateMetricMutationVariables = Exact<{
  input: MetricUpdateInput;
}>;


export type UpdateMetricMutation = { __typename?: 'Mutation', updateMetric: { __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean } };

export type UpdateMetricKeynameMutationVariables = Exact<{
  input: MetricKeynameUpdateInput;
}>;


export type UpdateMetricKeynameMutation = { __typename?: 'Mutation', updateMetricKeyname: { __typename?: 'MetricKeyname', compliance: boolean, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, systemTypes?: Array<string> | null, updatedAt: string } };

export type UpdateMetricsMutationVariables = Exact<{
  input: MetricsUpdateInput;
}>;


export type UpdateMetricsMutation = { __typename?: 'Mutation', updateMetrics: Array<{ __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean }> };

export type UpdateNotificationMutationVariables = Exact<{
  input: UpdateNotificationInput;
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updateNotification: { __typename?: 'Notification', active: boolean, appearance: NotificationAppearance, createdAt: string, deletedAt?: string | null, dismissable: boolean, displayPosition: NotificationDisplayPosition, endDate?: string | null, icon?: SelectableIcons | null, id: string, message: string, name: string, organizationId: number, startDate: string, systemGroupId?: number | null, systemId?: number | null, title?: string | null, updatedAt: string } };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization?: { __typename?: 'OrganizationNest', dateFormat: OrganizationDateFormat, fiscalYearStartDate: string, id: number, idpKey?: string | null, name: string, selfServiceEnabled: boolean } | null };

export type UpdateOrganizationIntegrationMutationVariables = Exact<{
  input: UpdateOrganizationIntegrationInput;
}>;


export type UpdateOrganizationIntegrationMutation = { __typename?: 'Mutation', updateOrganizationIntegration: { __typename?: 'OrganizationIntegrationNest', id: number } };

export type UpdatePhoneNumberMutationVariables = Exact<{
  input: UpdatePhoneNumberInput;
}>;


export type UpdatePhoneNumberMutation = { __typename?: 'Mutation', updatePhoneNumber: { __typename?: 'PhoneNumberNest', country: string, id: number, phoneNumber: string } };

export type UpdatePhraseMutationVariables = Exact<{
  input: UpdatePhraseInput;
}>;


export type UpdatePhraseMutation = { __typename?: 'Mutation', updatePhrase: { __typename?: 'Phrase', bodyText: string, id: string, name: string, organizationId?: number | null, userId?: number | null } };

export type UpdateProcessesMutationVariables = Exact<{
  input: UpdateProcessesInput;
}>;


export type UpdateProcessesMutation = { __typename?: 'Mutation', updateProcesses: Array<{ __typename?: 'ProcessNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, siteId: number, updatedAt: string }> };

export type UpdateReportDistributionListMutationVariables = Exact<{
  input: UpdateReportDistributionListInput;
}>;


export type UpdateReportDistributionListMutation = { __typename?: 'Mutation', updateReportDistributionList: { __typename?: 'ReportDistributionList', createdAt: string, deletedAt?: string | null, description?: string | null, displaySummary: string, id: string, isArchived: boolean, memberCount: number, name: string, normalizedName: string, organizationId?: number | null, scope: ReportDistributionListScope, siteId?: number | null, systemId?: number | null, updatedAt: string, members: Array<{ __typename?: 'ReportDistributionListMember', createdAt: string, displayName?: string | null, id: string, memberType: ReportDistributionListMemberType, normalizedEmail: string, sortOrder: number, updatedAt: string, userId?: number | null }> } };

export type UpdateReportNodesMutationVariables = Exact<{
  input: UpdateReportNodesInput;
}>;


export type UpdateReportNodesMutation = { __typename?: 'Mutation', updateReportNodes: Array<{ __typename?: 'ReportNode', columnGroupId?: string | null, columnGroupItemId?: string | null, createdAt: string, deletedAt?: string | null, id: string, metricId?: number | null, order: number, parentId?: string | null, reportDefinitionId: number, type: ReportNodeType, updatedAt: string }> };

export type UpdateSampleCollectionMutationVariables = Exact<{
  input: SampleCollectionUpdateInput;
}>;


export type UpdateSampleCollectionMutation = { __typename?: 'Mutation', updateSampleCollection: { __typename?: 'SampleCollection', createdAt: string, deletedAt?: string | null, id: string, sampleSiteId: string, scheduledItemId?: string | null, systemId: number, updatedAt: string } };

export type UpdateSampleScheduleMutationVariables = Exact<{
  input: UpdateSampleScheduleInput;
}>;


export type UpdateSampleScheduleMutation = { __typename?: 'Mutation', updateSampleSchedule: { __typename?: 'SampleSchedule', analyteGroupId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, sampleSiteId: string, sampleType: SampleType, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string } };

export type UpdateSampleSiteMutationVariables = Exact<{
  input: SampleSiteUpdateInput;
}>;


export type UpdateSampleSiteMutation = { __typename?: 'Mutation', updateSampleSite: { __typename?: 'SampleSite', address?: string | null, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, isActive: boolean, lastInspectionDate?: string | null, latitude?: number | null, longitude?: number | null, name: string, organizationId: number, samplePointType?: string | null, updatedAt: string, url?: string | null, photoUpload?: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } | null } };

export type UpdateScheduledItemMutationVariables = Exact<{
  input: UpdateScheduledItemInput;
}>;


export type UpdateScheduledItemMutation = { __typename?: 'Mutation', updateScheduledItem: { __typename?: 'ScheduledItem', assigneeId?: number | null, completedAt?: string | null, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, isStackable: boolean, notBefore?: string | null, photoRequired: boolean, recurrenceType: RecurrenceType, scheduledAt: string, sourceScheduleId: string, sourceScheduleType: SourceScheduleType, status: ScheduledItemStatus, systemId: number, targetDate?: string | null, title: string, updatedAt: string, comments: Array<{ __typename?: 'ScheduledItemComment', comment: string, commentType: ScheduledItemCommentType, createdAt: string, id: string, scheduledItemId: string, updatedAt: string, userId: number, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } }>, photoUpload?: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } | null } };

export type UpdateScheduledItemCommentMutationVariables = Exact<{
  input: UpdateScheduledItemCommentInput;
}>;


export type UpdateScheduledItemCommentMutation = { __typename?: 'Mutation', updateScheduledItemComment: { __typename?: 'ScheduledItemComment', comment: string, commentType: ScheduledItemCommentType, createdAt: string, id: string, scheduledItemId: string, updatedAt: string, userId: number, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } } };

export type UpdateSiteMutationVariables = Exact<{
  input: SiteUpdateInput;
}>;


export type UpdateSiteMutation = { __typename?: 'Mutation', updateSite: { __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string } };

export type UpdateSiteFlexMetricMutationVariables = Exact<{
  input: SiteFlexMetricUpdateInput;
}>;


export type UpdateSiteFlexMetricMutation = { __typename?: 'Mutation', updateSiteFlexMetric: { __typename?: 'SiteFlexMetric', createdAt: string, deletedAt?: string | null, folderViewOrder: number, id: string, metricId: number, name?: string | null, required: boolean, siteId: number, updatedAt: string, metric?: { __typename?: 'MetricNest', id: number, internalKeyname?: string | null, name: string, displayNameBreadcrumbs?: Array<{ __typename?: 'Breadcrumb', key: string, value: string }> | null, unit?: { __typename?: 'UnitNest', id: number, name: string } | null } | null } };

export type UpdateSiteFlexMetricsMutationVariables = Exact<{
  input: SiteFlexMetricsUpdateInput;
}>;


export type UpdateSiteFlexMetricsMutation = { __typename?: 'Mutation', updateSiteFlexMetrics: Array<{ __typename?: 'SiteFlexMetric', createdAt: string, deletedAt?: string | null, folderViewOrder: number, id: string, metricId: number, name?: string | null, required: boolean, siteId: number, updatedAt: string, metric?: { __typename?: 'MetricNest', id: number, internalKeyname?: string | null, name: string, displayNameBreadcrumbs?: Array<{ __typename?: 'Breadcrumb', key: string, value: string }> | null, unit?: { __typename?: 'UnitNest', id: number, name: string } | null } | null }> };

export type UpdateSiteStructureMutationVariables = Exact<{
  input: UpdateSiteStructureInput;
}>;


export type UpdateSiteStructureMutation = { __typename?: 'Mutation', updateSiteStructure: { __typename?: 'SiteType', dataEntryCompletionEmail?: DataEntryCompletionEmailOption | null, dataEntryCompletionEnabled?: boolean | null, displayName: string, emoji?: string | null, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, flex?: boolean | null, fullName: string, id: number, isEntry?: boolean | null, latitude?: number | null, licenseId?: number | null, longitude?: number | null, name?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType?: SiteTypeEnum | null, systemId: number } };

export type UpdateSitesMutationVariables = Exact<{
  input: UpdateSitesInput;
}>;


export type UpdateSitesMutation = { __typename?: 'Mutation', updateSites: Array<{ __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string }> };

export type UpdateSystemMutationVariables = Exact<{
  input: UpdateSystemInput;
}>;


export type UpdateSystemMutation = { __typename?: 'Mutation', updateSystem: { __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string, addresses: Array<{ __typename?: 'Address', city?: string | null, countryCode: string, createdAt: string, id: string, label?: string | null, line1?: string | null, line2?: string | null, organizationId?: number | null, phone?: string | null, postalCode?: string | null, purpose: AddressPurpose, recipientName?: string | null, region?: string | null, siteId?: number | null, systemId?: number | null, updatedAt: string }> } };

export type UpdateSystemGroupMutationVariables = Exact<{
  input: UpdateSystemGroupInput;
  systemGroupId: Scalars['Int'];
}>;


export type UpdateSystemGroupMutation = { __typename?: 'Mutation', updateSystemGroup: { __typename?: 'SystemGroupType', displayName: string, id: number, isTopLevel: boolean, name: string, organizationId: number, parentSystemGroupId?: number | null, users: Array<{ __typename?: 'UserInfoType', roleForSystemGroup: SystemGroupRoleEnum, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean }> } };

export type UpdateTagMutationVariables = Exact<{
  input: UpdateTagInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } };

export type UpdateTrendMutationVariables = Exact<{
  input: UpdateTrendInput;
  systemId: Scalars['Int'];
}>;


export type UpdateTrendMutation = { __typename?: 'Mutation', updateTrend: { __typename?: 'TrendNest', id: number, isGlobal: boolean, keynameFilters: Array<string>, name: string, ownerId: number, resolvedMetricIds: Array<number>, systemId?: number | null, systemType: SystemTypeEnum, owner: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean }, system?: { __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string } | null } };

export type UpdateUnitMutationVariables = Exact<{
  input: UnitUpdateInput;
}>;


export type UpdateUnitMutation = { __typename?: 'Mutation', updateUnit: { __typename?: 'UnitNest', createdAt: string, deletedAt?: string | null, id: number, isInterpolatable: boolean, name: string, updatedAt: string } };

export type UpdateUploadMutationVariables = Exact<{
  input: UpdateUploadInput;
}>;


export type UpdateUploadMutation = { __typename?: 'Mutation', updateUpload: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } };

export type UpdateUserMutationVariables = Exact<{
  enableIphoneMetricNumberInput?: InputMaybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  userId: Scalars['Int'];
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserInfoType', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean } };

export type UpdateUserByTokenMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  userToken: Scalars['String'];
  verifyPassword: Scalars['String'];
}>;


export type UpdateUserByTokenMutation = { __typename?: 'Mutation', updateUserByToken: { __typename?: 'UserInfoType', displayName: string, email: string, externalId?: string | null, externalOwner?: string | null, firstName: string, id: number, idpKey: string, lastName: string, pending: boolean, subject: string, superadmin: boolean } };

export type UpdateUserRoleForSystemMutationVariables = Exact<{
  input: UpdateUserRoleForSystemInput;
  systemId: Scalars['Int'];
}>;


export type UpdateUserRoleForSystemMutation = { __typename?: 'Mutation', updateUserRoleForSystem: Array<{ __typename?: 'UserInfoType', roleForSystem: SystemRoleType, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean } | null> };

export type UpdateUserRoleForSystemGroupMutationVariables = Exact<{
  input: UpdateUserRoleForSystemGroupInput;
  systemGroupId: Scalars['Int'];
}>;


export type UpdateUserRoleForSystemGroupMutation = { __typename?: 'Mutation', updateUserRoleForSystemGroup: { __typename?: 'UserInfoType', roleForSystemGroup: SystemGroupRoleEnum, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean } };

export type UpdateWeatherDataStationMutationVariables = Exact<{
  input: UpdateWeatherDataStationInput;
}>;


export type UpdateWeatherDataStationMutation = { __typename?: 'Mutation', updateWeatherDataStation: { __typename?: 'WeatherDataStationNest', deletedAt?: string | null, id: string, latitude: number, locationName: string, longitude: number, stateCode?: string | null, usgsStationId?: string | null } };

export type UpdatedRetentionRiskForOrgsMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdatedRetentionRiskForOrgsMutation = { __typename?: 'Mutation', updatedRetentionRiskForOrgs: { __typename?: 'SuccessResponse', id: string, message?: string | null, success: boolean } };

export type UpsertConstantValueMutationVariables = Exact<{
  input: UpsertConstantValueInput;
}>;


export type UpsertConstantValueMutation = { __typename?: 'Mutation', upsertConstantValue: { __typename?: 'ConstantValue', constantDefinitionId: number, createdAt: string, deletedAt?: string | null, effectiveDate: string, id: number, note?: string | null, numericValue?: number | null, textValue?: string | null, updatedAt: string } };

export type UpsertDataEntryCompletionMutationVariables = Exact<{
  input: UpsertDataEntryCompletionInput;
}>;


export type UpsertDataEntryCompletionMutation = { __typename?: 'Mutation', upsertDataEntryCompletion: { __typename?: 'DataEntryCompletion', appliedAt: string, createdAt: string, id: string, intervalTime?: string | null, isComplete: boolean, siteId: number, updatedAt: string, userId?: number | null } };

export type UpsertMetricRangesMutationVariables = Exact<{
  input: UpsertMetricRangesInput;
}>;


export type UpsertMetricRangesMutation = { __typename?: 'Mutation', upsertMetricRanges: Array<{ __typename?: 'MetricRange', color: string, createdAt: string, deletedAt?: string | null, id: string, ideal: boolean, maxTagId?: string | null, metricId: number, minTagId?: string | null, name: string, notificationEnabled: boolean, rangeMax?: number | null, rangeMaxInclusive: boolean, rangeMin?: number | null, rangeMinInclusive: boolean, updatedAt: string, maxTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null, minTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null }> };

export type ValidateLabImportBatchMutationVariables = Exact<{
  input: ValidateLabImportBatchInput;
}>;


export type ValidateLabImportBatchMutation = { __typename?: 'Mutation', validateLabImportBatch: { __typename?: 'LabImportBatch', checksumSha256: string, committedAt?: string | null, committedRowCount: number, createdAt: string, errorDetails?: Record<string, unknown> | null, id: string, invalidRowCount: number, originalFileName: string, profileName?: string | null, profileVersionId?: string | null, readyMetricCount: number, readySiteCount: number, reconciliationRequiredRowCount: number, skippedRowCount: number, sourceFileSizeBytes: number, sourceMimeType: string, sourceUploadId: string, status: LabImportBatchStatus, systemId: number, totalRowCount: number, validatedAt?: string | null, validRowCount: number, parserMetadata: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, profileVersion?: { __typename?: 'LabImportProfileVersion', createdAt: string, createdByUserId: number, id: string, profileId: string, version: number, definition: { __typename?: 'LabImportProfileDefinition', columnMappings: Array<{ __typename?: 'LabImportColumnMapping', column: string, field: string }>, parserConfig: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, targetMappings: Array<{ __typename?: 'LabImportTargetMapping', decision: LabImportTargetDecision, id: string, importedUnitLabel?: string | null, metricId?: number | null, metricUnitLabel?: string | null, siteId?: number | null, sourceAnalyte: string, sourceProject: string, sourceSampleSite: string, unitDecision?: LabImportUnitDecision | null }> } } | null } };

export type ValidateLabImportProfileMutationVariables = Exact<{
  input: LabImportProfileDefinitionInput;
}>;


export type ValidateLabImportProfileMutation = { __typename?: 'Mutation', validateLabImportProfile: { __typename?: 'LabImportProfileValidation', valid: boolean, issues: Array<{ __typename?: 'LabImportProfileValidationIssue', code: string, field: string, message: string }> } };

export type ActiveMetricStatsQueryVariables = Exact<{
  input: ActiveMetricStatsInput;
}>;


export type ActiveMetricStatsQuery = { __typename?: 'Query', activeMetricStats: { __typename?: 'ActiveMetricStats', metricCalculationCount: number, metricCount: number, metricDataWaterlyConnectCount: number } };

export type ActiveUserStatsQueryVariables = Exact<{
  input: ActiveUserDetailsInput;
}>;


export type ActiveUserStatsQuery = { __typename?: 'Query', activeUserStats: { __typename?: 'ActiveUserStats', activeUserCount: number, userCount: number, users: Array<{ __typename?: 'UserStats', activityCount: number, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } }> } };

export type ActivityScheduleByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ActivityScheduleByIdQuery = { __typename?: 'Query', getActivityScheduleById: { __typename?: 'ActivitySchedule', activityScheduleTypeId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, deletedAt?: string | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string, defaultAssignee?: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } | null } };

export type ActivitySchedulesQueryVariables = Exact<{
  input: ActivitySchedulesInput;
}>;


export type ActivitySchedulesQuery = { __typename?: 'Query', getActivitySchedules: { __typename?: 'ActivityScheduleWithCount', count: number, items: Array<{ __typename?: 'ActivitySchedule', activityScheduleTypeId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, deletedAt?: string | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string, defaultAssignee?: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } | null, system: { __typename?: 'SystemNest', id: number, isFavorite?: boolean | null, name: string, organizationId: number, parentSystemGroupId: number, timeZone: string, type: string } }> } };

export type AdjacentEntryIntervalQueryVariables = Exact<{
  input: AdjacentEntryIntervalInput;
}>;


export type AdjacentEntryIntervalQuery = { __typename?: 'Query', adjacentEntryInterval?: { __typename?: 'IntervalNest', createdByUserId?: number | null, date?: string | null, deletedAt?: string | null, createdAt: string, displayName: string, id: number, siteId: number, time: string, updatedAt: string, createdByUser?: { __typename?: 'UserNest', displayName: string, email: string, fullNameOrEmail: string, id: number } | null } | null };

export type AnalyteGroupByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AnalyteGroupByIdQuery = { __typename?: 'Query', analyteGroupById: { __typename?: 'AnalyteGroup', createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, organizationId: number, updatedAt: string, analytes: Array<{ __typename?: 'Analyte', analyteType: AnalyteType, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, unitId?: number | null, updatedAt: string }> } };

export type AnalyteGroupsQueryVariables = Exact<{
  input: AnalyteGroupsInput;
}>;


export type AnalyteGroupsQuery = { __typename?: 'Query', analyteGroups: { __typename?: 'AnalyteGroupsWithCount', count: number, items: Array<{ __typename?: 'AnalyteGroup', createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, organizationId: number, updatedAt: string }> } };

export type AnalytesQueryVariables = Exact<{
  input: AnalytesInput;
}>;


export type AnalytesQuery = { __typename?: 'Query', analytes: { __typename?: 'AnalytesWithCount', count: number, items: Array<{ __typename?: 'Analyte', analyteType: AnalyteType, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, unitId?: number | null, updatedAt: string }> } };

export type ApiTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiTokensQuery = { __typename?: 'Query', apiTokens: Array<{ __typename?: 'ApiTokenNest', createdAt: string, createdByUserId: number, expiresAt: string, id: number, lastUsedAt?: string | null, name: string, organizationId: number, realm: string, revokedAt?: string | null, scopes: Array<ApiTokenScope>, updatedAt: string, username: string }> };

export type ApiTokensByOrganizationQueryVariables = Exact<{
  input: ApiTokensByOrganizationInput;
}>;


export type ApiTokensByOrganizationQuery = { __typename?: 'Query', apiTokensByOrganization: Array<{ __typename?: 'ApiTokenNest', createdAt: string, createdByUserId: number, expiresAt: string, id: number, lastUsedAt?: string | null, name: string, organizationId: number, realm: string, revokedAt?: string | null, scopes: Array<ApiTokenScope>, updatedAt: string, username: string }> };

export type AuditEventSiteCreatedQueryVariables = Exact<{
  input: AuditEventFindOneInput;
}>;


export type AuditEventSiteCreatedQuery = { __typename?: 'Query', auditEventSiteCreated: { __typename?: 'AuditEventNest', appliedAtWithTimeZone?: string | null, event: string, id: string, rolledBackAt?: string | null, timestamp: number, type: AuditEventType, userId: number, version: AuditEventVersion, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } } };

export type AuditEventsQueryVariables = Exact<{
  input: AuditEventsInput;
}>;


export type AuditEventsQuery = { __typename?: 'Query', auditEvents: Array<{ __typename?: 'AuditEventNest', appliedAtWithTimeZone?: string | null, event: string, id: string, rolledBackAt?: string | null, timestamp: number, type: AuditEventType, userId: number, version: AuditEventVersion, activitySchedule?: { __typename?: 'ActivitySchedule', activityScheduleTypeId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, deletedAt?: string | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string } | null, component?: { __typename?: 'ComponentNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, processId: number, updatedAt: string } | null, metric?: { __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean } | null, process?: { __typename?: 'ProcessNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, siteId: number, updatedAt: string } | null, scheduledItem?: { __typename?: 'ScheduledItem', assigneeId?: number | null, completedAt?: string | null, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, isStackable: boolean, notBefore?: string | null, photoRequired: boolean, recurrenceType: RecurrenceType, scheduledAt: string, sourceScheduleId: string, sourceScheduleType: SourceScheduleType, status: ScheduledItemStatus, systemId: number, targetDate?: string | null, title: string, updatedAt: string, comments: Array<{ __typename?: 'ScheduledItemComment', comment: string, commentType: ScheduledItemCommentType, createdAt: string, id: string, scheduledItemId: string, updatedAt: string, userId: number, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } }>, photoUpload?: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } | null } | null, site?: { __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string } | null, system?: { __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string } | null, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } }> };

export type AuditEventsByItemTypeAndItemIdQueryVariables = Exact<{
  input: AuditEventsByItemTypeAndItemId;
}>;


export type AuditEventsByItemTypeAndItemIdQuery = { __typename?: 'Query', auditEventsByItemTypeAndItemId: Array<{ __typename?: 'AuditEventNest', appliedAtWithTimeZone?: string | null, event: string, id: string, rolledBackAt?: string | null, timestamp: number, type: AuditEventType, userId: number, version: AuditEventVersion, activitySchedule?: { __typename?: 'ActivitySchedule', activityScheduleTypeId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, deletedAt?: string | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string } | null, component?: { __typename?: 'ComponentNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, processId: number, updatedAt: string } | null, metric?: { __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean } | null, process?: { __typename?: 'ProcessNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, siteId: number, updatedAt: string } | null, scheduledItem?: { __typename?: 'ScheduledItem', assigneeId?: number | null, completedAt?: string | null, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, isStackable: boolean, notBefore?: string | null, photoRequired: boolean, recurrenceType: RecurrenceType, scheduledAt: string, sourceScheduleId: string, sourceScheduleType: SourceScheduleType, status: ScheduledItemStatus, systemId: number, targetDate?: string | null, title: string, updatedAt: string, comments: Array<{ __typename?: 'ScheduledItemComment', comment: string, commentType: ScheduledItemCommentType, createdAt: string, id: string, scheduledItemId: string, updatedAt: string, userId: number, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } }>, photoUpload?: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } | null } | null, site?: { __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string } | null, system?: { __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string } | null, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } }> };

export type AuditEventsByMetricIdQueryVariables = Exact<{
  input: AuditEventsByMetricIdInput;
}>;


export type AuditEventsByMetricIdQuery = { __typename?: 'Query', auditEventsByMetricId: { __typename?: 'AuditEventWithCount', count: number, items: Array<{ __typename?: 'AuditEventNest', appliedAtWithTimeZone?: string | null, event: string, id: string, rolledBackAt?: string | null, timestamp: number, type: AuditEventType, userId: number, system?: { __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string } | null, user: { __typename?: 'UserNest', email: string, firstName: string, id: number, lastName: string } }> } };

export type AuditEventsByScheduledItemIdQueryVariables = Exact<{
  input: AuditEventsByScheduledItemIdInput;
}>;


export type AuditEventsByScheduledItemIdQuery = { __typename?: 'Query', auditEventsByScheduledItemId: Array<{ __typename?: 'AuditEventNest', event: string, id: string, rolledBackAt?: string | null, timestamp: number, type: AuditEventType, userId: number, user: { __typename?: 'UserNest', email: string, externalId?: string | null, externalOwner?: string | null, firstName: string, id: number, idpKey?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } }> };

export type BulkMetricEditorFilterOptionsQueryVariables = Exact<{
  input: BulkMetricEditorMetricsFilterInput;
}>;


export type BulkMetricEditorFilterOptionsQuery = { __typename?: 'Query', bulkMetricEditorFilterOptions: { __typename?: 'BulkMetricEditorFilterOptions', calculationNames: Array<string>, componentKeynames: Array<string>, copyPreviousValueEnabled: Array<boolean>, dataPointCommentPolicies: Array<DataPointCommentPolicy>, dataTypes: Array<MetricDataTypeEnum>, expressions: Array<string>, hasIntervals: Array<boolean>, hideFromDataEntry: Array<boolean>, interpolated: Array<boolean>, isLockedByWaterly: Array<boolean>, isReportComments: Array<boolean>, keynames: Array<string>, limits: Array<BulkMetricEditorCompositePresenceFilter>, metricRangeTypes: Array<MetricRangeType>, notificationEnabled: Array<boolean>, processKeynames: Array<string>, reportAggregations: Array<BulkMetricEditorCompositePresenceFilter>, required: Array<boolean>, siteTypes: Array<string>, systemTypes: Array<string>, units: Array<string>, components: Array<{ __typename?: 'BulkMetricEditorEntityFilterOption', id: number, name: string }>, organizations: Array<{ __typename?: 'BulkMetricEditorEntityFilterOption', id: number, name: string }>, processes: Array<{ __typename?: 'BulkMetricEditorEntityFilterOption', id: number, name: string }>, sites: Array<{ __typename?: 'BulkMetricEditorEntityFilterOption', id: number, name: string }>, systems: Array<{ __typename?: 'BulkMetricEditorEntityFilterOption', id: number, name: string }> } };

export type BulkMetricEditorMetricsQueryVariables = Exact<{
  input: BulkMetricEditorMetricsInput;
}>;


export type BulkMetricEditorMetricsQuery = { __typename?: 'Query', bulkMetricEditorMetrics: { __typename?: 'BulkMetricEditorMetrics', filteredCount: number, totalCount: number, items: Array<{ __typename?: 'BulkMetricEditorRow', calculationName?: string | null, componentKeyname?: string | null, componentName?: string | null, copyPreviousValueEnabled: boolean, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, expression?: string | null, hasIntervals: boolean, hideFromDataEntry: boolean, interpolated: boolean, isLockedByWaterly: boolean, isReportComments: boolean, keyname?: string | null, metricId: number, metricRangeType?: MetricRangeType | null, name: string, notificationEnabled: boolean, order: number, organizationName: string, precision?: number | null, processKeyname?: string | null, processName: string, rangeMax?: number | null, rangeMin?: number | null, required: boolean, siteId: number, siteName: string, siteType: string, systemId: number, systemName: string, systemType: string, units?: string | null, limits: { __typename?: 'BulkMetricEditorLimitsSummary', belowReportingLimitValue?: number | null, configured: boolean, detectionLimit?: number | null, reportingLimit?: number | null, treatBelowReportingLimitAsPercent: boolean }, reportAggregations: { __typename?: 'BulkMetricEditorReportAggregationSummary', canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, configured: boolean } }> } };

export type CalcClusterDebugByClusterIdQueryVariables = Exact<{
  clusterId: Scalars['String'];
}>;


export type CalcClusterDebugByClusterIdQuery = { __typename?: 'Query', calcClusterDebugByClusterId?: { __typename?: 'CalcClusterDebug', clusterId: string, enabled: boolean, id: string, metricId: number, updatedAt: string } | null };

export type CalcClusterDebugLogsQueryVariables = Exact<{
  input: CalcClusterDebugLogsInput;
}>;


export type CalcClusterDebugLogsQuery = { __typename?: 'Query', calcClusterDebugLogs: Array<{ __typename?: 'CalcClusterDebugLog', appliedAt: string, calcClusterDebugId: string, clusterId: string, createdAt: string, deletedAt?: string | null, id: string, measuredAt: string, metricId: number, oldValue?: string | null, transactionId: string, updatedAt: string, value?: string | null }> };

export type CalcClusterDebugsQueryVariables = Exact<{
  input: CalcClusterDebugInputs;
}>;


export type CalcClusterDebugsQuery = { __typename?: 'Query', calcClusterDebugs: { __typename?: 'CalcClusterDebugsWithCount', count: number, items: Array<{ __typename?: 'CalcClusterDebug', clusterId: string, enabled: boolean, id: string, metricId: number, updatedAt: string, logStats: { __typename?: 'CalcClusterDebugLogStats', avgLogsPerTransaction: number, lastLoggedAt?: string | null, logCount: number, maxLogsPerTransaction: number, transactionCount: number }, metrics: Array<{ __typename?: 'MetricWithSPCIntervalsUnit', displayName: string, id: number, site: { __typename?: 'SiteNest', id: number, name: string, systemId: number } }>, systems: Array<{ __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string }> }> } };

export type ColumnGroupsQueryVariables = Exact<{
  input: ColumnGroupsInput;
}>;


export type ColumnGroupsQuery = { __typename?: 'Query', columnGroups: Array<{ __typename?: 'ColumnGroup', createdAt: string, deletedAt?: string | null, id: string, name: string, reportDefinitionId: number, updatedAt: string }> };

export type ColumnGroupsWithItemsQueryVariables = Exact<{
  input: ColumnGroupsWithItemsInput;
}>;


export type ColumnGroupsWithItemsQuery = { __typename?: 'Query', columnGroupsWithItems: Array<{ __typename?: 'ColumnGroupWithItems', id: string, name: string, reportDefinitionId: number, columnGroupItems?: Array<{ __typename?: 'ColumnGroupItemWithMetric', id: string, metricId?: number | null, name?: string | null, type: ColumnGroupItemType, metric?: { __typename?: 'MetricNest', id: number, name: string } | null }> | null }> };

export type ConstantRecalculationEstimateQueryVariables = Exact<{
  input: ConstantRecalculationInput;
}>;


export type ConstantRecalculationEstimateQuery = { __typename?: 'Query', constantRecalculationEstimate: { __typename?: 'ConstantRecalculationEstimate', capped: boolean, dayCount: number, effectiveFromDate: string, recalcFromDate: string, toDate: string, totalRecalculationCount: number, metrics: Array<{ __typename?: 'ConstantImpactedMetric', metricId: number, metricName: string, recalculationCount: number, siteName?: string | null }> } };

export type ConstantsDiscoveryQueryVariables = Exact<{
  organizationInput: ConstantsForOrganizationInput;
  systemInput: ConstantsForSystemInput;
}>;


export type ConstantsDiscoveryQuery = { __typename?: 'Query', constantsForOrganization: Array<{ __typename?: 'ResolvedConstant', source: ConstantScope, constantDefinition: { __typename?: 'ConstantDefinition', createdAt: string, dataType: ConstantDataType, deletedAt?: string | null, description?: string | null, id: number, keyname: string, name: string, organizationId?: number | null, precision?: number | null, scope: ConstantScope, systemId?: number | null, unitId?: number | null, updatedAt: string }, constantValue?: { __typename?: 'ConstantValue', constantDefinitionId: number, createdAt: string, deletedAt?: string | null, effectiveDate: string, id: number, note?: string | null, numericValue?: number | null, textValue?: string | null, updatedAt: string } | null }>, constantsForSystem: Array<{ __typename?: 'ResolvedConstant', source: ConstantScope, constantDefinition: { __typename?: 'ConstantDefinition', createdAt: string, dataType: ConstantDataType, deletedAt?: string | null, description?: string | null, id: number, keyname: string, name: string, organizationId?: number | null, precision?: number | null, scope: ConstantScope, systemId?: number | null, unitId?: number | null, updatedAt: string }, constantValue?: { __typename?: 'ConstantValue', constantDefinitionId: number, createdAt: string, deletedAt?: string | null, effectiveDate: string, id: number, note?: string | null, numericValue?: number | null, textValue?: string | null, updatedAt: string } | null }> };

export type ConstantsForOrganizationQueryVariables = Exact<{
  input: ConstantsForOrganizationInput;
}>;


export type ConstantsForOrganizationQuery = { __typename?: 'Query', constantsForOrganization: Array<{ __typename?: 'ResolvedConstant', source: ConstantScope, constantDefinition: { __typename?: 'ConstantDefinition', usedByMetricCount: number, createdAt: string, dataType: ConstantDataType, deletedAt?: string | null, description?: string | null, id: number, keyname: string, name: string, organizationId?: number | null, precision?: number | null, scope: ConstantScope, systemId?: number | null, unitId?: number | null, updatedAt: string, values: Array<{ __typename?: 'ConstantValue', constantDefinitionId: number, createdAt: string, deletedAt?: string | null, effectiveDate: string, id: number, note?: string | null, numericValue?: number | null, textValue?: string | null, updatedAt: string }> }, constantValue?: { __typename?: 'ConstantValue', constantDefinitionId: number, createdAt: string, deletedAt?: string | null, effectiveDate: string, id: number, note?: string | null, numericValue?: number | null, textValue?: string | null, updatedAt: string } | null }> };

export type ConstantsForSystemQueryVariables = Exact<{
  input: ConstantsForSystemInput;
}>;


export type ConstantsForSystemQuery = { __typename?: 'Query', constantsForSystem: Array<{ __typename?: 'ResolvedConstant', source: ConstantScope, constantDefinition: { __typename?: 'ConstantDefinition', usedByMetricCount: number, createdAt: string, dataType: ConstantDataType, deletedAt?: string | null, description?: string | null, id: number, keyname: string, name: string, organizationId?: number | null, precision?: number | null, scope: ConstantScope, systemId?: number | null, unitId?: number | null, updatedAt: string, values: Array<{ __typename?: 'ConstantValue', constantDefinitionId: number, createdAt: string, deletedAt?: string | null, effectiveDate: string, id: number, note?: string | null, numericValue?: number | null, textValue?: string | null, updatedAt: string }> }, constantValue?: { __typename?: 'ConstantValue', constantDefinitionId: number, createdAt: string, deletedAt?: string | null, effectiveDate: string, id: number, note?: string | null, numericValue?: number | null, textValue?: string | null, updatedAt: string } | null }> };

export type DataEntryCompletionsByReportDateQueryVariables = Exact<{
  input: DataEntryCompletionsByReportDateInput;
}>;


export type DataEntryCompletionsByReportDateQuery = { __typename?: 'Query', dataEntryCompletionsByReportDate: { __typename?: 'DataEntryCompletionsByAppliedAt', daily?: { __typename?: 'DataEntryCompletion', appliedAt: string, createdAt: string, id: string, intervalTime?: string | null, isComplete: boolean, siteId: number, updatedAt: string, userId?: number | null } | null, intervals?: Array<{ __typename?: 'DataEntryCompletion', appliedAt: string, createdAt: string, id: string, intervalTime?: string | null, isComplete: boolean, siteId: number, updatedAt: string, userId?: number | null }> | null } };

export type DataModelSitesForMirrorQueryVariables = Exact<{
  input: SitesInput;
}>;


export type DataModelSitesForMirrorQuery = { __typename?: 'Query', sitesV2: Array<{ __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string, metrics: Array<{ __typename?: 'MetricNest', deletedAt?: string | null, id: number }>, processes: Array<{ __typename?: 'ProcessNest', deletedAt?: string | null, id: number, name: string, order: number }> }> };

export type EligibleManualReportEmailRecipientsQueryVariables = Exact<{
  input: EligibleManualReportEmailRecipientsInput;
}>;


export type EligibleManualReportEmailRecipientsQuery = { __typename?: 'Query', eligibleManualReportEmailRecipients: Array<{ __typename?: 'ManualReportEmailEligibleRecipient', displayName: string, email: string, primaryOrganizationName?: string | null, userId: number }> };

export type EnterpriseReportShareLinkQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type EnterpriseReportShareLinkQuery = { __typename?: 'Query', enterpriseReportShareLink: { __typename?: 'EnterpriseReportShareLinkResolution', disabledAt?: string | null, expiresAt?: string | null, redirectPath?: string | null, reportSnapshotId?: string | null, shareLinkId?: string | null, state: EnterpriseReportShareLinkResolutionState } };

export type EnterpriseReportsForAnalyticsAdminQueryVariables = Exact<{
  input: EnterpriseReportsInput;
}>;


export type EnterpriseReportsForAnalyticsAdminQuery = { __typename?: 'Query', enterpriseReports: Array<{ __typename?: 'EnterpriseReport', id: string, inputConfig: string, name: string, organizationId?: number | null, siteId?: number | null, systemId?: number | null, reportSnapshots?: Array<{ __typename?: 'ReportSnapshot', configSchemaVersion: ReportSnapshotConfigSchemaVersion, id: string, name: string, reportDateTime: string, status: ReportStatus, updatedAt: string, url?: string | null }> | null }> };

export type EntryIntervalsByDateRangeQueryVariables = Exact<{
  input: EntryIntervalDateRangeInput;
}>;


export type EntryIntervalsByDateRangeQuery = { __typename?: 'Query', entryIntervalsByDateRange: Array<{ __typename?: 'IntervalNest', date?: string | null, id: number }> };

export type EstimateSiteRecalculationQueryVariables = Exact<{
  input: SubmitSiteRecalculationInput;
}>;


export type EstimateSiteRecalculationQuery = { __typename?: 'Query', estimateSiteRecalculation: { __typename?: 'RecalculatedMetricsEstimate', totalRecalculationCount: number, metrics: Array<{ __typename?: 'RecalculatedMetricData', metricId: number, metricName: string, recalculationCount: number }> } };

export type ExportBulkMetricEditorMetricsCsvQueryVariables = Exact<{
  input: BulkMetricEditorMetricsCsvExportInput;
}>;


export type ExportBulkMetricEditorMetricsCsvQuery = { __typename?: 'Query', exportBulkMetricEditorMetricsCsv: { __typename?: 'BulkMetricEditorMetricsCsvExport', contentType: string, csv?: string | null, downloadUrl?: string | null, filename: string, message?: string | null, rowCount: number, status: BulkMetricEditorCsvExportStatus } };

export type ExportLogBookEntriesCsvQueryVariables = Exact<{
  input: LogBookEntriesInput;
}>;


export type ExportLogBookEntriesCsvQuery = { __typename?: 'Query', exportLogBookEntriesCsv: string };

export type ExportUserManagerUsersCsvQueryVariables = Exact<{
  input?: InputMaybe<UserManagerUsersCsvExportInput>;
}>;


export type ExportUserManagerUsersCsvQuery = { __typename?: 'Query', exportUserManagerUsersCsv: string };

export type ExternalFacilitiesQueryVariables = Exact<{
  input: ExternalFacilitiesInput;
}>;


export type ExternalFacilitiesQuery = { __typename?: 'Query', externalFacilities: Array<{ __typename?: 'ExternalFacility', externalId: string, externalMetadata: Record<string, unknown>, name: string }> };

export type ExternalSystemsQueryVariables = Exact<{
  input: ExternalSystemsInput;
}>;


export type ExternalSystemsQuery = { __typename?: 'Query', externalSystems: Array<{ __typename?: 'ExternalSystem', externalId: string, externalOwner: string, id: string, name: string }> };

export type FindEdgeDeviceSubmissionsQueryVariables = Exact<{
  input: EdgeDeviceSubmissionFindRecentForDeviceIdInput;
}>;


export type FindEdgeDeviceSubmissionsQuery = { __typename?: 'Query', findEdgeDeviceSubmissions: { __typename?: 'EdgeDeviceSubmissionSummariesWithCount', count: number, items: Array<{ __typename?: 'EdgeDeviceSubmissionSummary', createdAt: string, edgeDeviceId: number, id: number, remoteIp: string, success: boolean, updatedAt: string }> } };

export type FindRecentEdgeDeviceSubmissionsQueryVariables = Exact<{
  input: EdgeDeviceSubmissionFindRecentForDeviceIdInput;
}>;


export type FindRecentEdgeDeviceSubmissionsQuery = { __typename?: 'Query', findRecentEdgeDeviceSubmissions: Array<{ __typename?: 'EdgeDeviceSubmissionSummary', createdAt: string, edgeDeviceId: number, id: number, remoteIp: string, success: boolean, updatedAt: string }> };

export type FindUploadByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type FindUploadByIdQuery = { __typename?: 'Query', findUploadById: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } };

export type FlexSitesAssociatedWithMetricIdQueryVariables = Exact<{
  input: FlexSitesAssociatedWithMetricId;
}>;


export type FlexSitesAssociatedWithMetricIdQuery = { __typename?: 'Query', flexSitesAssociatedWithMetricId: Array<{ __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string }> };

export type GenerateUploadParametersQueryVariables = Exact<{
  fileName: Scalars['String'];
  mimeType: Scalars['MimeType'];
  organizationId?: InputMaybe<Scalars['Int']>;
}>;


export type GenerateUploadParametersQuery = { __typename?: 'Query', generateUploadParameters: { __typename?: 'UploadBlobInfo', blobId: string, downloadUrl: string, fileName?: string | null, mimeType?: string | null, uploadHeadersJSON: string, uploadToken: string, uploadUrl: string } };

export type GetAdminStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminStatsQuery = { __typename?: 'Query', adminStats: { __typename?: 'AdminStats', numberOfMetrics: number, numberOfSites: number, numberOfStates: number, numberOfSystems: number, numberOfUsers: number } };

export type GetAllEdgeDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEdgeDevicesQuery = { __typename?: 'Query', allEdgeDevices: Array<{ __typename?: 'EdgeDeviceType', deviceName?: string | null, id: number }> };

export type GetAllEdgeDevicesV2QueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEdgeDevicesV2Query = { __typename?: 'Query', edgeDevicesV2: Array<{ __typename?: 'EdgeDeviceNest', createdAt: string, deviceName: string, deviceType: EdgeDeviceTypeNest, enabled: boolean, id: number, integrationMetadata?: Record<string, unknown> | null, lastReceivedAt?: string | null, organizationId: number, organizationName?: string | null, updatedAt: string }> };

export type GetAllSitesQueryVariables = Exact<{
  input?: InputMaybe<SitesInput>;
}>;


export type GetAllSitesQuery = { __typename?: 'Query', allSites: Array<{ __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string, displayNameBreadcrumbs: Array<{ __typename?: 'Breadcrumb', key: string, value: string }> }> };

export type GetCalcTreeQueryVariables = Exact<{
  input: GetCalcTreeInput;
}>;


export type GetCalcTreeQuery = { __typename?: 'Query', getCalcTree: { __typename?: 'CalcTree', dot: string, id: string } };

export type GetCalcTreesWithCyclesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCalcTreesWithCyclesQuery = { __typename?: 'Query', getCalcTreesWithCycles: Array<string> };

export type GetEdgeDeviceSubmissionDataQueryVariables = Exact<{
  submissionId: Scalars['Int'];
}>;


export type GetEdgeDeviceSubmissionDataQuery = { __typename?: 'Query', getEdgeDeviceSubmissionData: string };

export type GetEdgeDeviceTokenQueryVariables = Exact<{
  edgeDeviceId: Scalars['Int'];
}>;


export type GetEdgeDeviceTokenQuery = { __typename?: 'Query', edgeDeviceToken: string };

export type GetEdgeDeviceV2QueryVariables = Exact<{
  edgeDeviceId: Scalars['Int'];
}>;


export type GetEdgeDeviceV2Query = { __typename?: 'Query', getEdgeDeviceV2: { __typename?: 'EdgeDeviceNest', createdAt: string, deviceName: string, deviceType: EdgeDeviceTypeNest, enabled: boolean, id: number, integrationMetadata?: Record<string, unknown> | null, lastReceivedAt?: string | null, organizationId: number, organizationName?: string | null, updatedAt: string } };

export type GetEdgeDevicesByOrganizationIdQueryVariables = Exact<{
  organizationId: Scalars['Int'];
}>;


export type GetEdgeDevicesByOrganizationIdQuery = { __typename?: 'Query', edgeDevicesByOrganizationId: Array<{ __typename?: 'EdgeDeviceType', deviceName?: string | null, id: number }> };

export type GetEntrySparklineDataQueryVariables = Exact<{
  input: EntrySparklineDataInput;
}>;


export type GetEntrySparklineDataQuery = { __typename?: 'Query', entrySparklineData: Array<{ __typename?: 'EntrySparklineType', id: string, metricId: number, metricType: MetricDataTypeEnum, dataPoints: Array<{ __typename?: 'EntrySparklineDataPointType', appliedAt: string, id: string, intervalId?: number | null, time?: string | null, dataPoint?: { __typename?: 'EntryTSDataPoint', appliedAt: string, booleanValue?: boolean | null, calculatedNondetectValue?: boolean | null, calculatedValue?: string | null, comment?: string | null, connectValue?: string | null, dateTimeValue?: string | null, dateValue?: string | null, edgeDeviceSubmissionId?: number | null, effectiveNumericValue?: number | null, id: string, intervalId?: number | null, isArchived?: boolean | null, isCalculatedResult?: boolean | null, isInterpolated: boolean, isNondetect: boolean, journalEntryRecordId: string, jsonValue?: string | null, locatorEntityId: string, locatorEntityType: string, locatorNamespace: string, measuredAt: string, metricId: number, numericValue?: number | null, reportDate: string, storedAt: string, textValue?: string | null, timeValue?: string | null, type: string, value?: string | null, valueType: string, metaData: { __typename?: 'EntryTSDataPointMetadata', connectValue?: string | null, edgeDeviceSubmissionId?: number | null, id: string, intervalId?: number | null, reportDate: string } } | null }> }> };

export type GetFindUserByTokenQueryVariables = Exact<{
  userToken: Scalars['String'];
}>;


export type GetFindUserByTokenQuery = { __typename?: 'Query', findUserByToken: { __typename?: 'UserInfoType', displayName: string, email: string, externalId?: string | null, externalOwner?: string | null, firstName: string, id: number, idpKey: string, lastName: string, pending: boolean, subject: string, superadmin: boolean } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me: { __typename?: 'UserInfoType', primaryOrganizationDateFormat: OrganizationDateFormat, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean, permissions: Array<{ __typename?: 'UserOrganizationPermission', id: string, name: string, organizationId: number, organizationRole: SystemGroupRoleEnum, selfServiceEnabled: boolean, systemGroupPermissions: Array<{ __typename?: 'UserSystemGroupPermission', id: string, name: string, role: SystemGroupRoleEnum, systemGroupId: number }>, systemPermissions: Array<{ __typename?: 'UserSystemPermission', id: string, inheritedFromSystemGroupId?: number | null, isTemplate: boolean, name: string, role: SystemGroupRoleEnum, systemId: number }> }>, primaryOrganization: { __typename?: 'OrganizationType', id: number, name: string } } };

export type GetMetricQueryVariables = Exact<{
  metricId: Scalars['Int'];
  withIntervals?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetMetricQuery = { __typename?: 'Query', metric: { __typename?: 'MetricType', hasIntervals?: string, belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, dataPointCommentPolicy?: DataPointCommentPolicy | null, dataType: MetricDataTypeEnum, deletedAt?: string | null, detectionLimit?: number | null, displayName: string, displayNameSiteLocal: string, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, intervals?: Array<{ __typename?: 'Interval', displayName?: string | null, id: number, time: string }>, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null } };

export type GetMetricCalcClusterQueryVariables = Exact<{
  metricId: Scalars['Int'];
}>;


export type GetMetricCalcClusterQuery = { __typename?: 'Query', metricById: { __typename?: 'MetricNest', calcClusterId?: string | null, id: number } };

export type GetMetricChartDataQueryVariables = Exact<{
  endDate: Scalars['DateType'];
  metricIds: Array<Scalars['Int']> | Scalars['Int'];
  startDate: Scalars['DateType'];
  systemId: Scalars['Int'];
}>;


export type GetMetricChartDataQuery = { __typename?: 'Query', metricChartData: { __typename?: 'MetricChartDataContainerType', endDate: string, startDate: string, data?: Array<{ __typename?: 'MetricChartDataType', metricId: number, dataPoints: Array<{ __typename?: 'MetricChartDataPointType', effectiveValue?: number | null, reportDate: string, value?: number | null } | null> } | null> | null } };

export type GetMetricWithContextAndSystemQueryVariables = Exact<{
  metricId: Scalars['Int'];
}>;


export type GetMetricWithContextAndSystemQuery = { __typename?: 'Query', metric: { __typename?: 'MetricType', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, dataPointCommentPolicy?: DataPointCommentPolicy | null, dataType: MetricDataTypeEnum, deletedAt?: string | null, detectionLimit?: number | null, displayName: string, displayNameSiteLocal: string, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, system?: { __typename?: 'SystemType', displayName: string, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, hasSitesWithIntervals: boolean, hideDataSites: boolean, id: number, isFavorite: boolean, isTemplate: boolean, licenseId?: number | null, myRole: SystemGroupRoleEnum, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId?: number | null, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type?: SystemTypeEnum | null } | null, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null, component?: { __typename?: 'ComponentType', id: number, name: string } | null, process?: { __typename?: 'ProcessType', id: number, name: string } | null, site?: { __typename?: 'SiteType', id: number, name?: string | null, systemId: number } | null } };

export type GetMetricsDataPointsForDayQueryVariables = Exact<{
  metricIds: Array<Scalars['Int']> | Scalars['Int'];
  reportDate: Scalars['Date'];
  systemId: Scalars['Int'];
}>;


export type GetMetricsDataPointsForDayQuery = { __typename?: 'Query', getDataPointsForDay: Array<{ __typename?: 'DataPointsForDay', id: string, metricId: number, dataPoints: Array<{ __typename?: 'DataPointValueAndInterval', id: string, intervalId?: number | null, value?: string | null, waterlyConnect: boolean }> }> };

export type GetNextNewUnitIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNextNewUnitIdQuery = { __typename?: 'Query', getNextNewUnitId: number };

export type GetOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'OrganizationType', dateFormat: OrganizationDateFormat, fiscalYearStartDate: string, id: number, idpKey?: string | null, isExternalSystemSearchEnabled: boolean, isUserDirectoryEnabled: boolean, name: string, selfServiceEnabled: boolean }> };

export type GetPingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPingQuery = { __typename?: 'Query', ping: boolean };

export type GetRelatedMetricsQueryVariables = Exact<{
  metricId: Scalars['Int'];
}>;


export type GetRelatedMetricsQuery = { __typename?: 'Query', metric: { __typename?: 'MetricType', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, dataPointCommentPolicy?: DataPointCommentPolicy | null, dataType: MetricDataTypeEnum, deletedAt?: string | null, detectionLimit?: number | null, displayName: string, displayNameSiteLocal: string, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, calculatedMetrics: Array<{ __typename?: 'MetricType', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, dataPointCommentPolicy?: DataPointCommentPolicy | null, dataType: MetricDataTypeEnum, deletedAt?: string | null, detectionLimit?: number | null, displayName: string, displayNameSiteLocal: string, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null, component?: { __typename?: 'ComponentType', id: number, name: string } | null, process?: { __typename?: 'ProcessType', id: number, name: string } | null, site?: { __typename?: 'SiteType', id: number, name?: string | null, systemId: number } | null }>, sourceMetrics: Array<{ __typename?: 'MetricType', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, dataPointCommentPolicy?: DataPointCommentPolicy | null, dataType: MetricDataTypeEnum, deletedAt?: string | null, detectionLimit?: number | null, displayName: string, displayNameSiteLocal: string, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null, component?: { __typename?: 'ComponentType', id: number, name: string } | null, process?: { __typename?: 'ProcessType', id: number, name: string } | null, site?: { __typename?: 'SiteType', id: number, name?: string | null, systemId: number } | null }>, tagMapping?: { __typename?: 'TagMappingType', edgeDeviceId: number, id: number, metricId: number, tagName: string, edgeDevice?: { __typename?: 'EdgeDeviceNest', deviceName: string, id: number } | null } | null, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null } };

export type GetReportDefinitionQueryVariables = Exact<{
  input: ReportDefinitionInput;
  reportDefinitionId: Scalars['Int'];
}>;


export type GetReportDefinitionQuery = { __typename?: 'Query', reportDefinition: { __typename?: 'ReportDefinition', annualPeriod?: string | null, configSchemaId?: string | null, customFooter?: string | null, id: number, isFlex: boolean, metadata?: Record<string, unknown> | null, name: string, order: number, paperOrientation: PaperOrientationEnum, paperSize: PaperSizeEnum, reportGroupId?: number | null, reportTemplateId: number, reportType: ReportTypeEnum, showDayOfWeek: boolean, siteId?: number | null, supplementaryEnabled: boolean, systemId: number, timeFormat: TimeFormatEnum, reportGroup?: { __typename?: 'ReportGroup', id: number, name: string, order: number, systemId: number } | null, system: { __typename?: 'SystemType', id: number, name: string }, site?: { __typename?: 'SiteType', flex?: boolean | null, id: number, name?: string | null, processes: Array<{ __typename?: 'ProcessType', deletedAt?: string | null, enabledForReport?: boolean | null, id: number, name: string, order: number, components: Array<{ __typename?: 'ComponentType', enabledForReport?: boolean | null, id: number, name: string, order: number, metrics: Array<{ __typename?: 'MetricType', deletedAt?: string | null, enabledForReport: boolean, id: number, isReportComments: boolean, name: string, order: number, enabledIntervalForMonthlyReport?: { __typename?: 'Interval', displayName?: string | null, id: number, time: string } | null, intervals: Array<{ __typename?: 'Interval', displayName?: string | null, id: number, time: string }>, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null }> }>, metrics: Array<{ __typename?: 'MetricType', deletedAt?: string | null, enabledForReport: boolean, id: number, isReportComments: boolean, name: string, order: number, enabledIntervalForMonthlyReport?: { __typename?: 'Interval', displayName?: string | null, id: number, time: string } | null, intervals: Array<{ __typename?: 'Interval', displayName?: string | null, id: number, time: string }>, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null }> }> } | null } };

export type GetReportTemplatesQueryVariables = Exact<{
  input: ReportTemplatesWhere;
}>;


export type GetReportTemplatesQuery = { __typename?: 'Query', reportTemplates: Array<{ __typename?: 'ReportTemplate', agencyName?: string | null, configSchemaId?: string | null, id: number, legalStatement?: string | null, outputTypes: Array<ReportOutputType>, stateOrProvince: string, variant: string }> };

export type GetSiteDataEntriesQueryVariables = Exact<{
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  intervalIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  reportDate: Scalars['Date'];
  siteId: Scalars['Int'];
}>;


export type GetSiteDataEntriesQuery = { __typename?: 'Query', site: { __typename?: 'SiteType', id: number, dataEntries: Array<{ __typename?: 'SiteDataEntriesCollectionType', id: string, metricId: number, current: { __typename?: 'MetricDataPointType', appliedAt: string, calculatedNondetectValue?: boolean | null, calculatedValue?: string | null, comment?: string | null, connectValue?: string | null, edgeDeviceSubmissionId?: number | null, effectiveValue?: string | null, error?: string | null, id?: number | null, intervalId?: number | null, isInterpolated?: boolean | null, isNondetect?: boolean | null, measuredAt: string, metricId: number, reportDate: string, type: string, value?: string | null, version?: number | null } }> } };

export type GetSiteDataEntriesDayQueryVariables = Exact<{
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  intervalIds: Array<Scalars['Int']> | Scalars['Int'];
  reportDate: Scalars['Date'];
  siteId: Scalars['Int'];
}>;


export type GetSiteDataEntriesDayQuery = { __typename?: 'Query', site: { __typename?: 'SiteType', id: number, dataEntriesDay: Array<{ __typename?: 'SiteDataEntriesDayType', id: string, metricId: number, metricType: MetricDataTypeEnum, dataPoints: Array<{ __typename?: 'SiteDataEntriesDayDataPointType', appliedAt: string, id: string, intervalId?: number | null, reportDate: string, time?: string | null, dataPoint?: { __typename?: 'TSDataPoint', appliedAt: string, booleanValue?: boolean | null, calculatedNondetectValue?: boolean | null, calculatedValue?: string | null, comment?: string | null, connectValue?: string | null, dateTimeValue?: string | null, dateValue?: string | null, edgeDeviceSubmissionId?: number | null, effectiveNumericValue?: number | null, id: string, intervalId?: number | null, isArchived?: boolean | null, isCalculatedResult?: boolean | null, isInterpolated: boolean, isNondetect: boolean, journalEntryRecordId: string, jsonValue?: string | null, locatorEntityId: string, locatorEntityType: string, locatorNamespace: string, measuredAt: string, metricId: number, numericValue?: number | null, reportDate: string, storedAt: string, textValue?: string | null, timeValue?: string | null, type: MetricDataTypeEnum, value?: string | null, valueType: TsDataPointValueType, metaData: { __typename?: 'TSDataPointMetadata', connectValue?: string | null, edgeDeviceSubmissionId?: number | null, id: string, intervalId?: number | null, reportDate: string } } | null }> }> } };

export type GetSiteDataEntriesHistoryQueryVariables = Exact<{
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  intervalIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  reportDate: Scalars['Date'];
  siteId: Scalars['Int'];
}>;


export type GetSiteDataEntriesHistoryQuery = { __typename?: 'Query', site: { __typename?: 'SiteType', id: number, dataEntriesHistory: Array<{ __typename?: 'SiteDataEntriesHistoryCollectionType', id: string, metricId: number, history: Array<{ __typename?: 'MetricDataPointType', appliedAt: string, calculatedNondetectValue?: boolean | null, calculatedValue?: string | null, comment?: string | null, connectValue?: string | null, edgeDeviceSubmissionId?: number | null, effectiveValue?: string | null, error?: string | null, id?: number | null, intervalId?: number | null, isInterpolated?: boolean | null, isNondetect?: boolean | null, measuredAt: string, metricId: number, reportDate: string, type: string, value?: string | null, version?: number | null }> }> } };

export type GetSiteMetricsV2QueryVariables = Exact<{
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  siteId: Scalars['Int'];
}>;


export type GetSiteMetricsV2Query = { __typename?: 'Query', siteV2: { __typename?: 'SiteNest', id: number, metrics: Array<{ __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean, intervals?: Array<{ __typename?: 'IntervalNest', createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string }> | null, metricKeyname?: { __typename?: 'MetricKeyname', compliance: boolean, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, systemTypes?: Array<string> | null, updatedAt: string } | null, unit?: { __typename?: 'UnitNest', createdAt: string, deletedAt?: string | null, id: number, isInterpolatable: boolean, name: string, updatedAt: string } | null }> } };

export type GetSiteSourceMetricsQueryVariables = Exact<{
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  siteId: Scalars['Int'];
}>;


export type GetSiteSourceMetricsQuery = { __typename?: 'Query', siteV2: { __typename?: 'SiteNest', id: number, sourceMetrics: Array<{ __typename?: 'MetricWithCalculatedMetric', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean, calculatedMetric: { __typename?: 'CalculatedMetric', calculatedMetricId: number, sourceMetricId: number }, intervals?: Array<{ __typename?: 'IntervalNest', createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string }> | null }> } };

export type GetSiteV2QueryVariables = Exact<{
  entryDate?: InputMaybe<Scalars['Date']>;
  siteId: Scalars['Int'];
}>;


export type GetSiteV2Query = { __typename?: 'Query', siteV2: { __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string, addresses: Array<{ __typename?: 'Address', city?: string | null, countryCode: string, createdAt: string, id: string, label?: string | null, line1?: string | null, line2?: string | null, organizationId?: number | null, phone?: string | null, postalCode?: string | null, purpose: AddressPurpose, recipientName?: string | null, region?: string | null, siteId?: number | null, systemId?: number | null, updatedAt: string }>, components: Array<{ __typename?: 'ComponentNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, processId: number, updatedAt: string }>, dataModelSite?: { __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string } | null, foldersWithMetricIdsAndOrder: Array<{ __typename?: 'FolderWithMetricIdsAndOrder', color?: string | null, createdAt: string, default: boolean, deletedAt?: string | null, depth: number, id: string, name: string, order: number, parentId?: string | null, siteId: number, updatedAt: string, metricIdsWithOrder: Array<{ __typename?: 'MetricOrderWithMetricId', id: string, metricId: number, order: number }> }>, intervals: Array<{ __typename?: 'IntervalNest', siteFullName?: string | null, createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string }>, metrics: Array<{ __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean, intervals?: Array<{ __typename?: 'IntervalNest', siteFullName?: string | null, createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string }> | null, metricKeyname?: { __typename?: 'MetricKeyname', compliance: boolean, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, systemTypes?: Array<string> | null, updatedAt: string } | null, metricRanges: Array<{ __typename?: 'MetricRange', color: string, createdAt: string, deletedAt?: string | null, id: string, ideal: boolean, maxTagId?: string | null, metricId: number, minTagId?: string | null, name: string, notificationEnabled: boolean, rangeMax?: number | null, rangeMaxInclusive: boolean, rangeMin?: number | null, rangeMinInclusive: boolean, updatedAt: string, maxTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null, minTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null }>, unit?: { __typename?: 'UnitNest', createdAt: string, deletedAt?: string | null, id: number, isInterpolatable: boolean, name: string, updatedAt: string } | null }>, processes: Array<{ __typename?: 'ProcessNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, siteId: number, updatedAt: string }>, siteFlexMetricsWithParentSite?: Array<{ __typename?: 'SiteFlexMetricWithParentSite', createdAt: string, deletedAt?: string | null, folderViewOrder: number, id: string, metricId: number, name?: string | null, required: boolean, siteId: number, updatedAt: string, parentSite: { __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, id: number, isEntry: boolean, latitude?: number | null, longitude?: number | null, name: string, npdesPermitNumber?: string | null, order: number, siteType: string, systemId: number, updatedAt: string } }> | null } };

export type GetSitesQueryVariables = Exact<{
  input: SitesInput;
}>;


export type GetSitesQuery = { __typename?: 'Query', sitesV2: Array<{ __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string }> };

export type GetSitesForSystemQueryVariables = Exact<{
  systemId: Scalars['Int'];
}>;


export type GetSitesForSystemQuery = { __typename?: 'Query', system?: { __typename?: 'SystemType', hideDataSites: boolean, id: number, sites: Array<{ __typename?: 'SiteType', dataEntryCompletionEmail?: DataEntryCompletionEmailOption | null, dataEntryCompletionEnabled?: boolean | null, displayName: string, emoji?: string | null, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, flex?: boolean | null, fullName: string, id: number, isEntry?: boolean | null, latitude?: number | null, licenseId?: number | null, longitude?: number | null, name?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType?: SiteTypeEnum | null, systemId: number }> } | null };

export type GetSsoConfigurationQueryVariables = Exact<{
  idpKey: Scalars['String'];
}>;


export type GetSsoConfigurationQuery = { __typename?: 'Query', getSSOConfigurationByIDP?: { __typename?: 'SSOConfigurationType', audience?: string | null, authority: string, clientId: string, id: number, idpKey: string, logoSvg?: string | null, scope: string, signoutRedirectUrl: string } | null };

export type GetSystemQueryVariables = Exact<{
  systemId: Scalars['Int'];
  withHasSitesWithIntervals?: InputMaybe<Scalars['Boolean']>;
  withOperator?: InputMaybe<Scalars['Boolean']>;
  withUserDirectoryEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetSystemQuery = { __typename?: 'Query', system?: { __typename?: 'SystemType', hasSitesWithIntervals: boolean, organizationId: number, userDirectoryEnabled?: boolean, displayName: string, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite: boolean, isTemplate: boolean, licenseId?: number | null, myRole: SystemGroupRoleEnum, name: string, operatorId?: number | null, parentSystemGroupId?: number | null, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type?: SystemTypeEnum | null, operator?: { __typename?: 'UserInfoType', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean } | null, organization: { __typename?: 'OrganizationType', dateFormat: OrganizationDateFormat, fiscalYearStartDate: string, id: number, idpKey?: string | null, isExternalSystemSearchEnabled: boolean, isUserDirectoryEnabled: boolean, name: string, selfServiceEnabled: boolean }, sites: Array<{ __typename?: 'SiteType', id: number }> } | null };

export type GetSystemComponentsQueryVariables = Exact<{
  systemId: Scalars['Int'];
}>;


export type GetSystemComponentsQuery = { __typename?: 'Query', system?: { __typename?: 'SystemType', id: number, components: Array<{ __typename?: 'ComponentType', displayName: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, process: { __typename?: 'ProcessType', id: number, name: string }, site: { __typename?: 'SiteType', id: number, name?: string | null } }> } | null };

export type GetSystemMetricsForValidationQueryVariables = Exact<{
  systemId: Scalars['Int'];
}>;


export type GetSystemMetricsForValidationQuery = { __typename?: 'Query', system?: { __typename?: 'SystemType', id: number, metrics: Array<{ __typename?: 'MetricType', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, dataPointCommentPolicy?: DataPointCommentPolicy | null, dataType: MetricDataTypeEnum, deletedAt?: string | null, detectionLimit?: number | null, displayName: string, displayNameSiteLocal: string, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, intervals: Array<{ __typename?: 'Interval', displayName?: string | null, id: number, time: string }>, sourceMetrics: Array<{ __typename?: 'MetricType', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, dataPointCommentPolicy?: DataPointCommentPolicy | null, dataType: MetricDataTypeEnum, deletedAt?: string | null, detectionLimit?: number | null, displayName: string, displayNameSiteLocal: string, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, intervals: Array<{ __typename?: 'Interval', displayName?: string | null, id: number, time: string }>, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null }>, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null, component?: { __typename?: 'ComponentType', id: number, name: string } | null, process?: { __typename?: 'ProcessType', id: number, name: string } | null, site?: { __typename?: 'SiteType', id: number, name?: string | null, systemId: number } | null }> } | null };

export type GetSystemProcessesQueryVariables = Exact<{
  systemId: Scalars['Int'];
}>;


export type GetSystemProcessesQuery = { __typename?: 'Query', system?: { __typename?: 'SystemType', id: number, processes: Array<{ __typename?: 'ProcessType', displayName: string, id: number, name: string, site: { __typename?: 'SiteType', id: number, name?: string | null } }> } | null };

export type GetSystemSiteDetailsQueryVariables = Exact<{
  endDateTime: Scalars['Timestamp'];
  includeMetricRanges?: Scalars['Boolean'];
  startDateTime: Scalars['Timestamp'];
  systemId: Scalars['Int'];
}>;


export type GetSystemSiteDetailsQuery = { __typename?: 'Query', system?: { __typename?: 'SystemType', id: number, sites: Array<{ __typename?: 'SiteType', dataEntryCompletionEmail?: DataEntryCompletionEmailOption | null, dataEntryCompletionEnabled?: boolean | null, displayName: string, emoji?: string | null, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, flex?: boolean | null, fullName: string, id: number, isEntry?: boolean | null, latitude?: number | null, licenseId?: number | null, longitude?: number | null, name?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType?: SiteTypeEnum | null, systemId: number, outOfIdealRangeMetrics: Array<{ __typename?: 'SiteOutOfIdealRangeMetricType', metric: { __typename?: 'MetricType', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, dataPointCommentPolicy?: DataPointCommentPolicy | null, dataType: MetricDataTypeEnum, deletedAt?: string | null, detectionLimit?: number | null, displayName: string, displayNameSiteLocal: string, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, intervals: Array<{ __typename?: 'Interval', id: number, time: string }>, metricRanges?: Array<{ __typename?: 'MetricRange', color: string, createdAt: string, deletedAt?: string | null, id: string, ideal: boolean, maxTagId?: string | null, metricId: number, minTagId?: string | null, name: string, notificationEnabled: boolean, rangeMax?: number | null, rangeMaxInclusive: boolean, rangeMin?: number | null, rangeMinInclusive: boolean, updatedAt: string }>, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null }, outOfIdealRange: Array<{ __typename?: 'TSDataPoint', appliedAt: string, calculatedNondetectValue?: boolean | null, calculatedValue?: string | null, comment?: string | null, effectiveNumericValue?: number | null, intervalId?: number | null, isArchived?: boolean | null, isCalculatedResult?: boolean | null, isInterpolated: boolean, isNondetect: boolean, measuredAt: string, metricId: number, numericValue?: number | null, reportDate: string, storedAt: string, type: MetricDataTypeEnum, value?: string | null, valueType: TsDataPointValueType, metaData: { __typename?: 'TSDataPointMetadata', intervalId?: number | null, reportDate: string } }> }>, outOfRangeMetrics: Array<{ __typename?: 'SiteOutOfRangeMetricType', metric: { __typename?: 'MetricType', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, dataPointCommentPolicy?: DataPointCommentPolicy | null, dataType: MetricDataTypeEnum, deletedAt?: string | null, detectionLimit?: number | null, displayName: string, displayNameSiteLocal: string, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, intervals: Array<{ __typename?: 'Interval', id: number, time: string }>, unit?: { __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string } | null }, outOfRange: Array<{ __typename?: 'TSDataPoint', appliedAt: string, calculatedNondetectValue?: boolean | null, calculatedValue?: string | null, comment?: string | null, effectiveNumericValue?: number | null, intervalId?: number | null, isArchived?: boolean | null, isCalculatedResult?: boolean | null, isInterpolated: boolean, isNondetect: boolean, measuredAt: string, metricId: number, numericValue?: number | null, reportDate: string, storedAt: string, type: MetricDataTypeEnum, value?: string | null, valueType: TsDataPointValueType, metaData: { __typename?: 'TSDataPointMetadata', intervalId?: number | null, reportDate: string } }> }>, processes: Array<{ __typename?: 'ProcessType', deletedAt?: string | null, displayName: string, id: number, internalKeyname?: string | null, name: string, order: number, siteId: number, components: Array<{ __typename?: 'ComponentType', deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number }> }> }> } | null };

export type GetSystemSitesQueryVariables = Exact<{
  systemId: Scalars['Int'];
}>;


export type GetSystemSitesQuery = { __typename?: 'Query', system?: { __typename?: 'SystemType', id: number, sites: Array<{ __typename?: 'SiteType', displayName: string, flex?: boolean | null, id: number, name?: string | null, order: number, intervals: Array<{ __typename?: 'Interval', id: number, time: string }> }> } | null };

export type GetSystemUsersQueryVariables = Exact<{
  systemId: Scalars['Int'];
}>;


export type GetSystemUsersQuery = { __typename?: 'Query', system?: { __typename?: 'SystemType', id: number, users: Array<{ __typename?: 'UserInfoType', roleForSystem: SystemRoleType, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean }> } | null };

export type GetSystemsQueryVariables = Exact<{
  input?: InputMaybe<SystemsInput>;
}>;


export type GetSystemsQuery = { __typename?: 'Query', systems: Array<{ __typename?: 'SystemType', displayName: string, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, hasSitesWithIntervals: boolean, hideDataSites: boolean, id: number, isFavorite: boolean, isTemplate: boolean, licenseId?: number | null, myRole: SystemGroupRoleEnum, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId?: number | null, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type?: SystemTypeEnum | null }> };

export type GetSystemsWithOperatorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSystemsWithOperatorQuery = { __typename?: 'Query', systemsV2: Array<{ __typename?: 'SystemNest', displayName: string, id: number, isFavorite?: boolean | null, isTemplate: boolean, myRole: SystemGroupRoleEnum, name: string, organizationId: number, regulatoryId?: string | null, type: string, addresses: Array<{ __typename?: 'Address', id: string, region?: string | null }> }> };

export type GetTrendsQueryVariables = Exact<{
  input: TrendsQueryInput;
  systemId: Scalars['Int'];
}>;


export type GetTrendsQuery = { __typename?: 'Query', trends: Array<{ __typename?: 'TrendNest', id: number, isGlobal: boolean, keynameFilters: Array<string>, name: string, ownerId: number, resolvedMetricIds: Array<number>, systemId?: number | null, systemType: SystemTypeEnum, owner: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean }, system?: { __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string } | null }> };

export type GetUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitsQuery = { __typename?: 'Query', units: Array<{ __typename?: 'UnitType', id: number, isInterpolatable: boolean, name: string }> };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } | null };

export type GetUserFullInfoQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserFullInfoQuery = { __typename?: 'Query', user?: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean, licenses: Array<{ __typename?: 'LicenseNest', authority: string, displayName: string, id: number, licenseLabel: string, licenseNumber: string, userId: number }>, permissions?: Array<{ __typename?: 'UserOrganizationPermissionNest', id: string, name: string, organizationId: number, organizationRole: SystemGroupRoleEnum, selfServiceEnabled: boolean, systemGroupPermissions: Array<{ __typename?: 'UserSystemGroupPermissionNest', id: string, name: string, role: SystemGroupRoleEnum, systemGroupId: number }>, systemPermissions: Array<{ __typename?: 'UserSystemPermissionNest', id: string, inheritedFromSystemGroupId?: number | null, isTemplate: boolean, name: string, role: SystemGroupRoleEnum, systemId: number }> }> | null, ssoConfig?: { __typename?: 'SsoConfigurationNest', id: number, idpKey: string, isNameEditable: boolean } | null } | null };

export type GetUserLicensesQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserLicensesQuery = { __typename?: 'Query', licenses: Array<{ __typename?: 'LicenseNest', authority: string, displayName: string, id: number, licenseLabel: string, licenseNumber: string, userId: number }> };

export type GetUserPhoneNumbersQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserPhoneNumbersQuery = { __typename?: 'Query', phoneNumbers: Array<{ __typename?: 'PhoneNumberNest', country: string, id: number, phoneNumber: string }> };

export type GetWaterlyConnectErrorStatsQueryVariables = Exact<{
  edgeDeviceId?: InputMaybe<Scalars['Int']>;
  forMonthStartingUtc: Scalars['String'];
}>;


export type GetWaterlyConnectErrorStatsQuery = { __typename?: 'Query', waterlyConnectErrorStats: { __typename?: 'WaterlyConnectErrorStatsByMonth', errorCountByDay: Array<number>, id: string } };

export type GetWaterlyConnectStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWaterlyConnectStatsQuery = { __typename?: 'Query', waterlyConnectStats: { __typename?: 'WaterlyConnectStats', activeQueueJobCount: number, countLast24HourSubmissions: number, countLast24HourSubmissionsSuccessful: number, id: number, waitingQueueJobCount: number, queueJobCountsByEdgeDevice: Array<{ __typename?: 'WaterlyConnectQueueJobCountByEdgeDevice', activeCount: number, edgeDeviceId: number, edgeDeviceName: string, waitingCount: number }> } };

export type GetWaterlyConnectSubmissionHistoryQueryVariables = Exact<{
  options: EdgeDeviceSubmissionSearchOptions;
}>;


export type GetWaterlyConnectSubmissionHistoryQuery = { __typename?: 'Query', waterlyConnectSubmissionHistory: Array<{ __typename?: 'EdgeDeviceSubmission', createdAt: string, dataExcerpt: string, edgeDeviceId: number, id: number, remoteIp?: string | null, status: EdgeDeviceSubmissionStatus, updatedAt: string, edgeDevice: { __typename?: 'EdgeDeviceType', deviceName?: string | null, id: number } }> };

export type HasLinkedServiceReportEnterpriseReportQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type HasLinkedServiceReportEnterpriseReportQuery = { __typename?: 'Query', hasLinkedServiceReportEnterpriseReport: boolean };

export type LabImportBatchQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type LabImportBatchQuery = { __typename?: 'Query', labImportBatch: { __typename?: 'LabImportBatch', checksumSha256: string, committedAt?: string | null, committedRowCount: number, createdAt: string, errorDetails?: Record<string, unknown> | null, id: string, invalidRowCount: number, originalFileName: string, profileName?: string | null, profileVersionId?: string | null, readyMetricCount: number, readySiteCount: number, reconciliationRequiredRowCount: number, skippedRowCount: number, sourceFileSizeBytes: number, sourceMimeType: string, sourceUploadId: string, status: LabImportBatchStatus, systemId: number, totalRowCount: number, validatedAt?: string | null, validRowCount: number, parserMetadata: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, profileVersion?: { __typename?: 'LabImportProfileVersion', createdAt: string, createdByUserId: number, id: string, profileId: string, version: number, definition: { __typename?: 'LabImportProfileDefinition', columnMappings: Array<{ __typename?: 'LabImportColumnMapping', column: string, field: string }>, parserConfig: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, targetMappings: Array<{ __typename?: 'LabImportTargetMapping', decision: LabImportTargetDecision, id: string, importedUnitLabel?: string | null, metricId?: number | null, metricUnitLabel?: string | null, siteId?: number | null, sourceAnalyte: string, sourceProject: string, sourceSampleSite: string, unitDecision?: LabImportUnitDecision | null }> } } | null } };

export type LabImportBatchResumeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type LabImportBatchResumeQuery = { __typename?: 'Query', labImportBatchResume: { __typename?: 'LabImportBatchResume', batch: { __typename?: 'LabImportBatch', checksumSha256: string, committedAt?: string | null, committedRowCount: number, createdAt: string, errorDetails?: Record<string, unknown> | null, id: string, invalidRowCount: number, originalFileName: string, profileName?: string | null, profileVersionId?: string | null, readyMetricCount: number, readySiteCount: number, reconciliationRequiredRowCount: number, skippedRowCount: number, sourceFileSizeBytes: number, sourceMimeType: string, sourceUploadId: string, status: LabImportBatchStatus, systemId: number, totalRowCount: number, validatedAt?: string | null, validRowCount: number, parserMetadata: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, profileVersion?: { __typename?: 'LabImportProfileVersion', createdAt: string, createdByUserId: number, id: string, profileId: string, version: number, definition: { __typename?: 'LabImportProfileDefinition', columnMappings: Array<{ __typename?: 'LabImportColumnMapping', column: string, field: string }>, parserConfig: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, targetMappings: Array<{ __typename?: 'LabImportTargetMapping', decision: LabImportTargetDecision, id: string, importedUnitLabel?: string | null, metricId?: number | null, metricUnitLabel?: string | null, siteId?: number | null, sourceAnalyte: string, sourceProject: string, sourceSampleSite: string, unitDecision?: LabImportUnitDecision | null }> } } | null }, pendingProfile?: { __typename?: 'LabImportPendingProfile', baseProfileVersionId?: string | null, name: string, profileId?: string | null, definition: { __typename?: 'LabImportProfileDefinition', columnMappings: Array<{ __typename?: 'LabImportColumnMapping', column: string, field: string }>, parserConfig: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, targetMappings: Array<{ __typename?: 'LabImportTargetMapping', decision: LabImportTargetDecision, id: string, importedUnitLabel?: string | null, metricId?: number | null, metricUnitLabel?: string | null, siteId?: number | null, sourceAnalyte: string, sourceProject: string, sourceSampleSite: string, unitDecision?: LabImportUnitDecision | null }> } } | null } };

export type LabImportBatchesQueryVariables = Exact<{
  input: LabImportBatchesInput;
}>;


export type LabImportBatchesQuery = { __typename?: 'Query', labImportBatches: { __typename?: 'LabImportBatchesPage', count: number, items: Array<{ __typename?: 'LabImportBatchSummary', committedAt?: string | null, committedRowCount: number, createdAt: string, fileLength?: number | null, fileName?: string | null, id: string, invalidRowCount: number, profileName?: string | null, reconciliationRequiredRowCount: number, skippedRowCount: number, status: LabImportBatchStatus, totalRowCount: number, validRowCount: number }> } };

export type LabImportBootstrapQueryVariables = Exact<{
  systemId: Scalars['Int'];
}>;


export type LabImportBootstrapQuery = { __typename?: 'Query', labImportProfiles: Array<{ __typename?: 'LabImportProfile', createdAt: string, createdByUserId: number, id: string, name: string, organizationId: number, systemId: number, versions: Array<{ __typename?: 'LabImportProfileVersion', createdAt: string, createdByUserId: number, id: string, profileId: string, version: number, definition: { __typename?: 'LabImportProfileDefinition', columnMappings: Array<{ __typename?: 'LabImportColumnMapping', column: string, field: string }>, parserConfig: { __typename?: 'LabImportParserConfig', columns: Array<string>, delimiter: string, hasHeader: boolean, quote: string }, targetMappings: Array<{ __typename?: 'LabImportTargetMapping', decision: LabImportTargetDecision, id: string, importedUnitLabel?: string | null, metricId?: number | null, metricUnitLabel?: string | null, siteId?: number | null, sourceAnalyte: string, sourceProject: string, sourceSampleSite: string, unitDecision?: LabImportUnitDecision | null }> } }> }>, labImportTargets: Array<{ __typename?: 'LabImportTarget', metricId: number, metricName: string, metricUnitLabel: string, siteId: number, siteName: string }> };

export type LabImportFileDownloadQueryVariables = Exact<{
  batchId: Scalars['UUID'];
}>;


export type LabImportFileDownloadQuery = { __typename?: 'Query', labImportFileDownload: { __typename?: 'LabImportFileDownload', downloadUrl: string, fileName: string, mimeType: string } };

export type LabImportRowsQueryVariables = Exact<{
  input: LabImportRowsInput;
}>;


export type LabImportRowsQuery = { __typename?: 'Query', labImportRows: { __typename?: 'LabImportRowsPage', count: number, items: Array<{ __typename?: 'LabImportRow', batchId: string, canonicalValues: Record<string, unknown>, comments?: string | null, id: string, importedUnitLabel?: string | null, intervalId?: number | null, isNondetect?: boolean | null, metricId?: number | null, rawValues: Record<string, unknown>, reportDate?: string | null, requestId?: string | null, resultName?: string | null, resultValue?: string | null, rowNumber: number, sampleDate?: string | null, sampleIdentifier?: string | null, siteId?: number | null, status: LabImportRowStatus, systemId?: number | null, writeErrorDetails?: Record<string, unknown> | null, writeStatus?: LabImportDataPointWriteStatus | null, writtenAt?: string | null, validationResults: Array<{ __typename?: 'LabImportValidationResult', attempt: number, code: string, details?: Record<string, unknown> | null, field?: string | null, id: string, message: string, status: LabImportValidationStatus }> }> } };

export type LabImportSourceGroupsQueryVariables = Exact<{
  input: LabImportSourceGroupsInput;
}>;


export type LabImportSourceGroupsQuery = { __typename?: 'Query', labImportSourceGroups: Array<{ __typename?: 'LabImportSourceGroup', analyte: string, project: string, rowCount: number, sampleSite: string, unit: string }> };

export type LatestServiceReportSnapshotBySiteAndReportDateQueryVariables = Exact<{
  input: LatestServiceReportSnapshotBySiteAndReportDateInput;
}>;


export type LatestServiceReportSnapshotBySiteAndReportDateQuery = { __typename?: 'Query', latestServiceReportSnapshotBySiteAndReportDate?: { __typename?: 'ReportSnapshot', enterpriseReportId?: string | null, id: string, name: string, reportDateTime: string, status: ReportStatus, updatedAt: string } | null };

export type LogBookEntriesQueryVariables = Exact<{
  input: LogBookEntriesInput;
}>;


export type LogBookEntriesQuery = { __typename?: 'Query', logBookEntries: Array<{ __typename?: 'LogBookEntryNest', createdAt: string, deletedAt?: string | null, id: string, message: string, organizationId: number, pinned: boolean, updatedAt: string, attachments: { __typename?: 'LogBookEntryAttachmentsNest', components: Array<{ __typename?: 'ComponentNest', id: number, name: string }>, metrics: Array<{ __typename?: 'MetricNest', id: number, name: string }>, processes: Array<{ __typename?: 'ProcessNest', id: number, name: string }>, sites: Array<{ __typename?: 'SiteNest', id: number, name: string }>, systems: Array<{ __typename?: 'SystemNest', id: number, name: string }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, uploads: Array<{ __typename?: 'Upload', fileName: string, id: string, url: string }> }, user: { __typename?: 'UserNest', firstName: string, id: number, lastName: string } }> };

export type LogBookEntriesWithCountQueryVariables = Exact<{
  input: LogBookEntriesInput;
}>;


export type LogBookEntriesWithCountQuery = { __typename?: 'Query', logBookEntriesWithCount: { __typename?: 'LogBookEntriesWithCount', count: number, items: Array<{ __typename?: 'LogBookEntryNest', createdAt: string, deletedAt?: string | null, id: string, message: string, organizationId: number, pinned: boolean, updatedAt: string, userId: number, attachments: { __typename?: 'LogBookEntryAttachmentsNest', components: Array<{ __typename?: 'ComponentNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, processId: number, updatedAt: string }>, metrics: Array<{ __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean }>, processes: Array<{ __typename?: 'ProcessNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, siteId: number, updatedAt: string }>, sites: Array<{ __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string }>, systems: Array<{ __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string }>, tags: Array<{ __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string }>, uploads: Array<{ __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string }> }, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } }> } };

export type LogBookEntryByIdQueryVariables = Exact<{
  logBookEntryId: Scalars['UUID'];
  withDeleted?: InputMaybe<Scalars['Boolean']>;
}>;


export type LogBookEntryByIdQuery = { __typename?: 'Query', logBookEntryById?: { __typename?: 'LogBookEntryNest', createdAt: string, deletedAt?: string | null, id: string, message: string, organizationId: number, pinned: boolean, updatedAt: string, userId: number, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } } | null };

export type LogBookEntryDashboardViewByUserIdQueryVariables = Exact<{
  input: LogBookEntryDashboardViewByUserIdInput;
}>;


export type LogBookEntryDashboardViewByUserIdQuery = { __typename?: 'Query', logBookEntryDashboardViewByUserId: Array<{ __typename?: 'LogBookEntryDashboardViewNest', createdAt: string, deletedAt?: string | null, id: string, message?: string | null, name: string, organizationId?: number | null, siteIds?: Array<number> | null, sortDirection: string, sortField: string, systemIds?: Array<number> | null, tagIds?: Array<string> | null, updatedAt: string, userId: number, userIds?: Array<number> | null }> };

export type ManualReportEmailSharingScopeQueryVariables = Exact<{
  reportSnapshotId: Scalars['UUID'];
}>;


export type ManualReportEmailSharingScopeQuery = { __typename?: 'Query', manualReportEmailSharingScope: { __typename?: 'ManualReportEmailSharingScope', organizationId?: number | null, organizationName?: string | null, scope: ReportDistributionListScope, siteId?: number | null, systemId?: number | null } };

export type MetricKeynameWithCountQueryVariables = Exact<{
  input: MetricKeynameInput;
}>;


export type MetricKeynameWithCountQuery = { __typename?: 'Query', metricKeynamesWithCount: { __typename?: 'MetricKeynameJoinedWithCount', count: number, items: Array<{ __typename?: 'MetricKeynameWithUnitsAndTags', compliance: boolean, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, systemTypes?: Array<string> | null, updatedAt: string, tags?: Array<{ __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string }> | null, units?: Array<{ __typename?: 'UnitNest', createdAt: string, deletedAt?: string | null, id: number, isInterpolatable: boolean, name: string, updatedAt: string }> | null }> } };

export type MetricKeynamesWithCountAndMetricCountQueryVariables = Exact<{
  input: MetricKeynameInput;
}>;


export type MetricKeynamesWithCountAndMetricCountQuery = { __typename?: 'Query', metricKeynamesWithCount: { __typename?: 'MetricKeynameJoinedWithCount', count: number, items: Array<{ __typename?: 'MetricKeynameWithUnitsAndTags', compliance: boolean, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, metricsCount: number, name: string, systemTypes?: Array<string> | null, updatedAt: string, tags?: Array<{ __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string }> | null, units?: Array<{ __typename?: 'UnitNest', createdAt: string, deletedAt?: string | null, id: number, isInterpolatable: boolean, name: string, updatedAt: string }> | null }> } };

export type MetricRangesForCloneQueryVariables = Exact<{
  metricId: Scalars['Int'];
}>;


export type MetricRangesForCloneQuery = { __typename?: 'Query', metricById: { __typename?: 'MetricNest', id: number, metricRangeType?: MetricRangeType | null, metricRanges: Array<{ __typename?: 'MetricRange', color: string, createdAt: string, deletedAt?: string | null, id: string, ideal: boolean, maxTagId?: string | null, metricId: number, minTagId?: string | null, name: string, notificationEnabled: boolean, rangeMax?: number | null, rangeMaxInclusive: boolean, rangeMin?: number | null, rangeMinInclusive: boolean, updatedAt: string }> } };

export type MetricsBySiteProcessComponentQueryVariables = Exact<{
  input: MetricsInput;
}>;


export type MetricsBySiteProcessComponentQuery = { __typename?: 'Query', metricsBySiteProcessComponent: Array<{ __typename?: 'MetricNest', id: number, name: string, displayNameBreadcrumbs?: Array<{ __typename?: 'Breadcrumb', key: string, value: string }> | null }> };

export type MetricsBySystemIdsQueryVariables = Exact<{
  input: MetricsBySystemIdsInput;
}>;


export type MetricsBySystemIdsQuery = { __typename?: 'Query', metricsBySystemIds: Array<{ __typename?: 'MetricWithSPCIntervalsUnit', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, displayName: string, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean, component?: { __typename?: 'ComponentNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, processId: number, updatedAt: string } | null, intervals?: Array<{ __typename?: 'IntervalNest', createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string }> | null, process: { __typename?: 'ProcessNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, siteId: number, updatedAt: string }, site: { __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string }, unit?: { __typename?: 'UnitNest', createdAt: string, deletedAt?: string | null, id: number, isInterpolatable: boolean, name: string, updatedAt: string } | null }> };

export type MetricsForSelectQueryVariables = Exact<{
  input: MetricsBySystemIdsInput;
}>;


export type MetricsForSelectQuery = { __typename?: 'Query', metricsBySystemIds: Array<{ __typename?: 'MetricWithSPCIntervalsUnit', canBeAveraged: CanBeAveraged, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, dataType: MetricDataTypeEnum, displayName: string, id: number, internalKeyname?: string | null, name: string, order: number, precision?: number | null, component?: { __typename?: 'ComponentNest', id: number, name: string, order: number } | null, intervals?: Array<{ __typename?: 'IntervalNest', id: number }> | null, process: { __typename?: 'ProcessNest', id: number, name: string, order: number }, site: { __typename?: 'SiteNest', id: number, name: string, order: number, systemId: number }, unit?: { __typename?: 'UnitNest', id: number, name: string } | null }> };

export type MetricsWithDownstreamCalcCountsQueryVariables = Exact<{
  input: MetricsWithDownstreamCalcCountsInput;
}>;


export type MetricsWithDownstreamCalcCountsQuery = { __typename?: 'Query', metricsWithDownstreamCalcCounts: Array<{ __typename?: 'MetricWithCalculatedMetrics', downstreamCalcCount: number, id: number, name: string }> };

export type NotificationsQueryVariables = Exact<{
  input: NotificationsInput;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationsWithCount', count: number, items: Array<{ __typename?: 'Notification', active: boolean, appearance: NotificationAppearance, createdAt: string, deletedAt?: string | null, dismissable: boolean, displayPosition: NotificationDisplayPosition, endDate?: string | null, icon?: SelectableIcons | null, id: string, message: string, name: string, organizationId: number, startDate: string, systemGroupId?: number | null, systemId?: number | null, title?: string | null, updatedAt: string }> } };

export type OrganizationQueryVariables = Exact<{
  organizationId: Scalars['Int'];
}>;


export type OrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'OrganizationType', dateFormat: OrganizationDateFormat, fiscalYearStartDate: string, id: number, idpKey?: string | null, isExternalSystemSearchEnabled: boolean, isUserDirectoryEnabled: boolean, name: string, selfServiceEnabled: boolean } };

export type OrganizationIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationIntegrationsQuery = { __typename?: 'Query', organizationIntegrations: Array<{ __typename?: 'OrganizationIntegrationNest', createdAt: string, credentialsSecretReference: string, id: number, integrationType: OrganizationIntegrationType, organizationId: number, tokenExpiresAt?: string | null, tokenId?: number | null, updatedAt: string }> };

export type OrganizationWithSystemGroupsAndSystemsQueryVariables = Exact<{
  organizationId: Scalars['Int'];
}>;


export type OrganizationWithSystemGroupsAndSystemsQuery = { __typename?: 'Query', organization: { __typename?: 'OrganizationType', dateFormat: OrganizationDateFormat, fiscalYearStartDate: string, id: number, idpKey?: string | null, isExternalSystemSearchEnabled: boolean, isUserDirectoryEnabled: boolean, name: string, selfServiceEnabled: boolean, addresses: Array<{ __typename?: 'Address', city?: string | null, countryCode: string, createdAt: string, id: string, label?: string | null, line1?: string | null, line2?: string | null, organizationId?: number | null, phone?: string | null, postalCode?: string | null, purpose: AddressPurpose, recipientName?: string | null, region?: string | null, siteId?: number | null, systemId?: number | null, updatedAt: string }>, systemGroups: Array<{ __typename?: 'SystemGroupType', displayName: string, id: number, isTopLevel: boolean, name: string, organizationId: number, parentSystemGroupId?: number | null, systems: Array<{ __typename?: 'SystemType', displayName: string, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, hasSitesWithIntervals: boolean, hideDataSites: boolean, id: number, isFavorite: boolean, isTemplate: boolean, licenseId?: number | null, myRole: SystemGroupRoleEnum, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId?: number | null, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type?: SystemTypeEnum | null }> }> } };

export type OrganizationsWithSystemGroupsAndSystemsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationsWithSystemGroupsAndSystemsQuery = { __typename?: 'Query', organizationsWithSystemGroupsAndSystems: Array<{ __typename?: 'OrganizationType', dateFormat: OrganizationDateFormat, fiscalYearStartDate: string, id: number, idpKey?: string | null, isExternalSystemSearchEnabled: boolean, isUserDirectoryEnabled: boolean, name: string, selfServiceEnabled: boolean, systemGroups: Array<{ __typename?: 'SystemGroupType', displayName: string, id: number, isTopLevel: boolean, name: string, organizationId: number, parentSystemGroupId?: number | null, systems: Array<{ __typename?: 'SystemType', displayName: string, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, hasSitesWithIntervals: boolean, hideDataSites: boolean, id: number, isFavorite: boolean, isTemplate: boolean, licenseId?: number | null, myRole: SystemGroupRoleEnum, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId?: number | null, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type?: SystemTypeEnum | null }> }> }> };

export type PermitByIdQueryVariables = Exact<{
  permitId: Scalars['UUID'];
}>;


export type PermitByIdQuery = { __typename?: 'Query', permitById?: { __typename?: 'Permit', createdAt: string, deletedAt?: string | null, id: string, isPublicWaterSystemId: boolean, name: string, permitCode: string, systemId: number, updatedAt: string } | null };

export type PermitsQueryVariables = Exact<{
  input: PermitsInput;
}>;


export type PermitsQuery = { __typename?: 'Query', permits: Array<{ __typename?: 'Permit', createdAt: string, deletedAt?: string | null, id: string, isPublicWaterSystemId: boolean, name: string, permitCode: string, systemId: number, updatedAt: string }> };

export type PhrasesQueryVariables = Exact<{
  input: PhrasesInput;
}>;


export type PhrasesQuery = { __typename?: 'Query', phrases: Array<{ __typename?: 'Phrase', bodyText: string, id: string, name: string, organizationId?: number | null, userId?: number | null }> };

export type ProcessComponentsQueryVariables = Exact<{
  processId: Scalars['Int'];
}>;


export type ProcessComponentsQuery = { __typename?: 'Query', process: { __typename?: 'ProcessType', id: number, components: Array<{ __typename?: 'ComponentType', deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number }> } };

export type ProcessesAndComponentsBySiteIdQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type ProcessesAndComponentsBySiteIdQuery = { __typename?: 'Query', siteV2: { __typename?: 'SiteNest', id: number, components: Array<{ __typename?: 'ComponentNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, processId: number, updatedAt: string }>, processes: Array<{ __typename?: 'ProcessNest', createdAt: string, deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, order: number, siteId: number, updatedAt: string }> } };

export type RecentEntryIntervalsBySiteIdQueryVariables = Exact<{
  beforeDate?: InputMaybe<Scalars['Date']>;
  includeServiceReportSnapshot?: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Int']>;
  siteId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type RecentEntryIntervalsBySiteIdQuery = { __typename?: 'Query', recentEntryIntervalsBySiteId: { __typename?: 'IntervalsWithCount', count: number, items: Array<{ __typename?: 'IntervalNest', createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string, createdByUser?: { __typename?: 'UserNest', displayName: string, email: string, fullNameOrEmail: string, id: number } | null, recentEntryCompletion?: { __typename?: 'DataEntryCompletion', appliedAt: string, createdAt: string, id: string, intervalTime?: string | null, isComplete: boolean, siteId: number, updatedAt: string, userId?: number | null, latestServiceReportSnapshot?: { __typename?: 'ReportSnapshot', id: string, status: ReportStatus } | null, user?: { __typename?: 'UserNest', displayName: string, email: string, fullNameOrEmail: string, id: number } | null } | null }> } };

export type RegulatoryReportDefinitionsForGroupingQueryVariables = Exact<{
  input: ReportDefinitionsForDiscoveryInput;
}>;


export type RegulatoryReportDefinitionsForGroupingQuery = { __typename?: 'Query', regulatoryReportDefinitionsForGrouping: Array<{ __typename?: 'RegulatoryReportDefinitionForGroupingNest', id: number, name: string, order: number, outputTypes: Array<ReportOutputType>, reportGroupId?: number | null, reportType: ReportDiscoveryReportType, siteId?: number | null, systemId: number, reportGroup?: { __typename?: 'ReportingReportGroupNest', id: number, name: string, order: number, systemId: number } | null, site?: { __typename?: 'ReportDiscoverySiteNest', id: number, name: string } | null, system?: { __typename?: 'ReportDiscoverySystemNest', id: number, name: string, organizationId: number, timeZone: string } | null }> };

export type ReportDataQueryVariables = Exact<{
  reportDefinitionId: Scalars['Int'];
}>;


export type ReportDataQuery = { __typename?: 'Query', reportData: { __typename?: 'ReportDataFlatTree', reportNodes: Array<{ __typename?: 'ReportNodeWithRelations', columnGroupId?: string | null, columnGroupItemId?: string | null, createdAt: string, deletedAt?: string | null, id: string, metricId?: number | null, order: number, parentId?: string | null, reportDefinitionId: number, type: ReportNodeType, updatedAt: string, columnGroup?: { __typename?: 'ColumnGroup', createdAt: string, deletedAt?: string | null, id: string, name: string, reportDefinitionId: number, updatedAt: string } | null, columnGroupItem?: { __typename?: 'ColumnGroupItem', aggregation?: ColumnAggregation | null, calculationType?: ColumnCalculation | null, createdAt: string, deletedAt?: string | null, id: string, intervalId?: number | null, metricId?: number | null, name?: string | null, type: ColumnGroupItemType, updatedAt: string, sourceMetrics: Array<{ __typename?: 'MetricNest', id: number, name: string }> } | null, metric?: { __typename?: 'MetricNest', belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, id: number, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, isWaterlyConnected: boolean, keynameId?: string | null, maxValue?: number | null, metricRangeType?: MetricRangeType | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean, intervals?: Array<{ __typename?: 'IntervalNest', displayName: string, id: number, time: string }> | null, metricRanges: Array<{ __typename?: 'MetricRange', color: string, createdAt: string, deletedAt?: string | null, id: string, ideal: boolean, maxTagId?: string | null, metricId: number, minTagId?: string | null, name: string, notificationEnabled: boolean, rangeMax?: number | null, rangeMaxInclusive: boolean, rangeMin?: number | null, rangeMinInclusive: boolean, updatedAt: string, maxTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null, minTag?: { __typename?: 'Tag', color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string } | null }> } | null }> } };

export type ReportDataForSiteQueryVariables = Exact<{
  reportDefinitionId: Scalars['Int'];
}>;


export type ReportDataForSiteQuery = { __typename?: 'Query', reportDataForSite: { __typename?: 'ReportData', metricsWithReportData: Array<{ __typename?: 'MetricWithReportData', enabledForReport: boolean, enabledIntervalId?: number | null, metricId: number }>, processesWithReportData: Array<{ __typename?: 'ProcessWithReportData', enabledForReport: boolean, processId: number }> } };

export type ReportDefinitionDiscoveryFilterCountsQueryVariables = Exact<{
  input: ReportDefinitionsForDiscoveryInput;
}>;


export type ReportDefinitionDiscoveryFilterCountsQuery = { __typename?: 'Query', reportDefinitionDiscoveryFilterCounts: { __typename?: 'ReportDefinitionDiscoveryFilterCounts', frequencies: { __typename?: 'ReportDefinitionDiscoveryFrequencyCounts', annual: number, daily: number, monthly: number, other: number, quarterly: number }, scopes: { __typename?: 'ReportDefinitionDiscoveryScopeCounts', component: number, organization: number, process: number, site: number, system: number } } };

export type ReportDefinitionHistorySnapshotsQueryVariables = Exact<{
  input: ReportSnapshotInput;
}>;


export type ReportDefinitionHistorySnapshotsQuery = { __typename?: 'Query', reportSnapshotsWithCount: { __typename?: 'ReportSnapshotItemsWithCount', count: number, items: Array<{ __typename?: 'ReportSnapshot', config?: Record<string, unknown> | null, configSchemaVersion: ReportSnapshotConfigSchemaVersion, createdAt: string, data?: Record<string, unknown> | null, deletedAt?: string | null, enterpriseReportId?: string | null, id: string, name: string, reportDateTime: string, reportDefinitionId?: number | null, status: ReportStatus, updatedAt: string, url?: string | null }> } };

export type ReportDefinitionsForDiscoveryQueryVariables = Exact<{
  input: ReportDefinitionsForDiscoveryInput;
}>;


export type ReportDefinitionsForDiscoveryQuery = { __typename?: 'Query', reportDefinitionsForDiscovery: { __typename?: 'ReportDefinitionsForDiscoveryWithCount', count: number, items: Array<{ __typename?: 'ReportDiscoveryItem', createdAt: string, enterpriseReportId?: string | null, id: string, isFlex: boolean, latestSnapshotReportDateTime?: string | null, latestSnapshotStatus?: ReportStatus | null, latestSnapshotUpdatedAt?: string | null, name: string, order?: number | null, outputTypes: Array<ReportOutputType>, reportDefinitionId?: number | null, reportGroupId?: number | null, reportSnapshotId?: string | null, reportType: ReportDiscoveryReportType, siteId?: number | null, snapshotCount?: number | null, sourceType: ReportDiscoverySourceType, systemId?: number | null, recentSnapshots: Array<{ __typename?: 'ReportDiscoverySnapshot', enterpriseReportId: string, id: string, name: string, reportDateTime: string, status: ReportStatus, updatedAt: string }>, reportGroup?: { __typename?: 'ReportingReportGroupNest', id: number, name: string, order: number, systemId: number } | null, site?: { __typename?: 'ReportDiscoverySiteNest', id: number, name: string } | null, system?: { __typename?: 'ReportDiscoverySystemNest', createdAt: string, id: number, name: string, organizationId: number, timeZone: string } | null }> } };

export type ReportDistributionListsQueryVariables = Exact<{
  input: ReportDistributionListsInput;
}>;


export type ReportDistributionListsQuery = { __typename?: 'Query', reportDistributionLists: Array<{ __typename?: 'ReportDistributionList', createdAt: string, deletedAt?: string | null, description?: string | null, displaySummary: string, id: string, isArchived: boolean, memberCount: number, name: string, normalizedName: string, organizationId?: number | null, scope: ReportDistributionListScope, siteId?: number | null, systemId?: number | null, updatedAt: string, members: Array<{ __typename?: 'ReportDistributionListMember', createdAt: string, displayName?: string | null, id: string, memberType: ReportDistributionListMemberType, normalizedEmail: string, sortOrder: number, updatedAt: string, userId?: number | null }> }> };

export type ReportSnapshotByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ReportSnapshotByIdQuery = { __typename?: 'Query', reportSnapshotById: { __typename?: 'ReportSnapshot', config?: Record<string, unknown> | null, configSchemaVersion: ReportSnapshotConfigSchemaVersion, createdAt: string, data?: Record<string, unknown> | null, deletedAt?: string | null, enterpriseReportId?: string | null, id: string, name: string, reportDateTime: string, reportDefinitionId?: number | null, status: ReportStatus, updatedAt: string, url?: string | null } };

export type RetentionRisksQueryVariables = Exact<{
  input: RetentionRisksInput;
}>;


export type RetentionRisksQuery = { __typename?: 'Query', retentionRisks?: Array<{ __typename?: 'RetentionRiskResultNest', organizationId: number, score: number, organizationRetentionRisks: Array<{ __typename?: 'RetentionRiskNest', createdAt: string, deletedAt?: string | null, displayName: string, flag: boolean, flagType: RetentionRiskFlagType, id: string, itemId: string, itemType: RetentionRiskItemType, organizationId: number, score: number, snooze?: string | null, updatedAt: string, organization: { __typename?: 'OrganizationNest', id: number, name: string } }>, systemRetentionRisks: Array<{ __typename?: 'RetentionRiskNest', createdAt: string, deletedAt?: string | null, displayName: string, flag: boolean, flagType: RetentionRiskFlagType, id: string, itemId: string, itemType: RetentionRiskItemType, organizationId: number, score: number, snooze?: string | null, updatedAt: string, organization: { __typename?: 'OrganizationNest', id: number, name: string } }> }> | null };

export type RoundsAssetsMappingsByEntitiesQueryVariables = Exact<{
  input: RoundsAssetsMappingsByEntitiesInput;
}>;


export type RoundsAssetsMappingsByEntitiesQuery = { __typename?: 'Query', roundsAssetsMappingsByEntities: Array<{ __typename?: 'RoundsAssetsMappingNest', assetsEntityId: number, assetsEntityType: AssetsEntityType, assetsInstanceId: number, id: string, roundsEntityId: number, roundsEntityType: RoundsEntityType, systemId: number }> };

export type RoundsShiftNoteFormContextQueryVariables = Exact<{
  input: RoundsShiftNoteFormContextInput;
}>;


export type RoundsShiftNoteFormContextQuery = { __typename?: 'Query', roundsShiftNoteFormContext: { __typename?: 'RoundsShiftNoteFormContext', defaultDate: string, defaultTime: string, notifyAssignedByDefault: boolean, sourceType: RoundsShiftNoteSourceType, asset?: { __typename?: 'RoundsShiftNoteLocationTier', id: number, name: string } | null, assetChoices: Array<{ __typename?: 'RoundsShiftNoteAssetChoice', componentId: number, name: string }>, assigneeRoles: Array<{ __typename?: 'RoundsShiftNoteAssigneeRole', isUnassignedBucket: boolean, roleId: number, roleName: string, users: Array<{ __typename?: 'RoundsShiftNoteAssigneeUser', label: string, userId: number }> }>, facility: { __typename?: 'RoundsShiftNoteLocationTier', id: number, name: string }, system?: { __typename?: 'RoundsShiftNoteLocationTier', id: number, name: string } | null, systemChoices: Array<{ __typename?: 'RoundsShiftNoteSystemChoice', name: string, processId: number, assets: Array<{ __typename?: 'RoundsShiftNoteAssetChoice', componentId: number, name: string }> }> } };

export type RuntimeLoggersQueryVariables = Exact<{ [key: string]: never; }>;


export type RuntimeLoggersQuery = { __typename?: 'Query', runtimeLoggers: { __typename?: 'RuntimeLoggerSnapshot', available: boolean, complete: boolean, observedAt?: string | null, loggers: Array<{ __typename?: 'RuntimeLogger', name: string, overrideStatus: string, recent: boolean, defaults: Array<{ __typename?: 'RuntimeLoggerDefault', instanceId: string, lastSeenAt: string, level: RuntimeLogLevel, role: string }>, override?: { __typename?: 'RuntimeLoggerOverride', expiresAt: string, level: RuntimeLogLevel, updatedAt: string } | null }> } };

export type SampleCollectionByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SampleCollectionByIdQuery = { __typename?: 'Query', sampleCollectionById: { __typename?: 'SampleCollection', createdAt: string, deletedAt?: string | null, id: string, sampleSiteId: string, scheduledItemId?: string | null, systemId: number, updatedAt: string, currentCustody?: { __typename?: 'SampleCollectionCustody', comment?: string | null, createdAt: string, createdBy: number, deletedAt?: string | null, id: string, previousCustodyId?: string | null, relinquishedBy?: number | null, relinquishedTo: number, sampleCollectionId: string, systemId: number, updatedAt: string, relinquishedByUser?: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } | null, relinquishedToUser: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } } | null, sampleCollectionResults?: Array<{ __typename?: 'SampleCollectionResult', analyteId: string, booleanValue?: boolean | null, createdAt: string, deletedAt?: string | null, id: string, measuredAt?: string | null, numericValue?: number | null, sampleCollectionId: string, textValue?: string | null, updatedAt: string, valueType: ValueType, analyte?: { __typename?: 'Analyte', analyteType: AnalyteType, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, unitId?: number | null, updatedAt: string } | null }> | null, sampleSite?: { __typename?: 'SampleSite', address?: string | null, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, isActive: boolean, lastInspectionDate?: string | null, latitude?: number | null, longitude?: number | null, name: string, organizationId: number, samplePointType?: string | null, updatedAt: string, url?: string | null, photoUpload?: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } | null } | null } };

export type SampleCollectionCustodiesQueryVariables = Exact<{
  input: SampleCollectionCustodiesInput;
}>;


export type SampleCollectionCustodiesQuery = { __typename?: 'Query', sampleCollectionCustodies: { __typename?: 'SampleCollectionCustodiesWithCount', count: number, items: Array<{ __typename?: 'SampleCollectionCustody', comment?: string | null, createdAt: string, createdBy: number, deletedAt?: string | null, id: string, previousCustodyId?: string | null, relinquishedBy?: number | null, relinquishedTo: number, sampleCollectionId: string, systemId: number, updatedAt: string }> } };

export type SampleCollectionsQueryVariables = Exact<{
  input: SampleCollectionsInput;
}>;


export type SampleCollectionsQuery = { __typename?: 'Query', sampleCollections: { __typename?: 'SampleCollectionsWithCount', count: number, items: Array<{ __typename?: 'SampleCollection', createdAt: string, deletedAt?: string | null, id: string, sampleSiteId: string, scheduledItemId?: string | null, systemId: number, updatedAt: string, currentCustody?: { __typename?: 'SampleCollectionCustody', comment?: string | null, createdAt: string, createdBy: number, deletedAt?: string | null, id: string, previousCustodyId?: string | null, relinquishedBy?: number | null, relinquishedTo: number, sampleCollectionId: string, systemId: number, updatedAt: string, relinquishedByUser?: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } | null, relinquishedToUser: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } } | null }> } };

export type SampleScheduleByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SampleScheduleByIdQuery = { __typename?: 'Query', sampleScheduleById: { __typename?: 'SampleSchedule', analyteGroupId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, sampleSiteId: string, sampleType: SampleType, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string } };

export type SampleSchedulesQueryVariables = Exact<{
  input: SampleSchedulesInput;
}>;


export type SampleSchedulesQuery = { __typename?: 'Query', sampleSchedules: { __typename?: 'SampleSchedulesWithCount', count: number, items: Array<{ __typename?: 'SampleSchedule', analyteGroupId?: string | null, createdAt: string, createdByUserId: number, defaultAssigneeId?: number | null, description: string, endDate?: string | null, exDates?: Array<string> | null, id: string, isStackable: boolean, notBeforeUnit?: DurationUnit | null, notBeforeValue?: number | null, photoRequired: boolean, rDates?: Array<string> | null, recurrenceType: RecurrenceType, rrule: string, sampleSiteId: string, sampleType: SampleType, siteId?: number | null, startDate?: string | null, systemId: number, targetBeforeUnit?: DurationUnit | null, targetBeforeValue?: number | null, title: string, updatedAt: string, analytes: Array<{ __typename?: 'Analyte', analyteType: AnalyteType, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, name: string, unitId?: number | null, updatedAt: string }>, defaultAssignee?: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } | null, sampleSite?: { __typename?: 'SampleSite', address?: string | null, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, isActive: boolean, lastInspectionDate?: string | null, latitude?: number | null, longitude?: number | null, name: string, organizationId: number, samplePointType?: string | null, updatedAt: string, url?: string | null, photoUpload?: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } | null } | null, system: { __typename?: 'SystemNest', id: number, isFavorite?: boolean | null, name: string, organizationId: number, parentSystemGroupId: number, timeZone: string, type: string } }> } };

export type SampleSiteByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SampleSiteByIdQuery = { __typename?: 'Query', sampleSiteById: { __typename?: 'SampleSite', address?: string | null, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, isActive: boolean, lastInspectionDate?: string | null, latitude?: number | null, longitude?: number | null, name: string, organizationId: number, samplePointType?: string | null, updatedAt: string, url?: string | null, photoUpload?: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } | null } };

export type SampleSitesQueryVariables = Exact<{
  input: SampleSitesInput;
}>;


export type SampleSitesQuery = { __typename?: 'Query', sampleSites: Array<{ __typename?: 'SampleSite', address?: string | null, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, isActive: boolean, lastInspectionDate?: string | null, latitude?: number | null, longitude?: number | null, name: string, organizationId: number, samplePointType?: string | null, updatedAt: string, url?: string | null, photoUpload?: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } | null }> };

export type ScheduledItemByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ScheduledItemByIdQuery = { __typename?: 'Query', getScheduledItemById: { __typename?: 'ScheduledItem', assigneeId?: number | null, completedAt?: string | null, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, isStackable: boolean, notBefore?: string | null, photoRequired: boolean, recurrenceType: RecurrenceType, scheduledAt: string, sourceScheduleId: string, sourceScheduleType: SourceScheduleType, status: ScheduledItemStatus, systemId: number, targetDate?: string | null, title: string, updatedAt: string, assignee?: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } | null, comments: Array<{ __typename?: 'ScheduledItemComment', comment: string, commentType: ScheduledItemCommentType, createdAt: string, id: string, scheduledItemId: string, updatedAt: string, userId: number, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } }>, photoUpload?: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } | null } };

export type ScheduledItemCountQueryVariables = Exact<{
  input: ScheduledItemsInput;
}>;


export type ScheduledItemCountQuery = { __typename?: 'Query', scheduledItemCount: { __typename?: 'ScheduledItemCount', count: number } };

export type ScheduledItemsQueryVariables = Exact<{
  input: ScheduledItemsInput;
}>;


export type ScheduledItemsQuery = { __typename?: 'Query', getScheduledItems: { __typename?: 'ScheduledItemsWithCount', count: number, items: Array<{ __typename?: 'ScheduledItem', assigneeId?: number | null, completedAt?: string | null, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, isStackable: boolean, notBefore?: string | null, photoRequired: boolean, recurrenceType: RecurrenceType, scheduledAt: string, sourceScheduleId: string, sourceScheduleType: SourceScheduleType, status: ScheduledItemStatus, systemId: number, targetDate?: string | null, title: string, updatedAt: string, assignee?: { __typename?: 'UserNest', firstName: string, id: number, lastName: string } | null, system: { __typename?: 'SystemNest', id: number, name: string, timeZone: string }, comments: Array<{ __typename?: 'ScheduledItemComment', comment: string, commentType: ScheduledItemCommentType, createdAt: string, id: string, scheduledItemId: string, updatedAt: string, userId: number, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } }>, photoUpload?: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } | null }> } };

export type SiteDataEntryCompletionByDateQueryVariables = Exact<{
  input: SiteDataEntryCompletionByDateInput;
}>;


export type SiteDataEntryCompletionByDateQuery = { __typename?: 'Query', siteDataEntryCompletionByDate: Array<{ __typename?: 'SiteDataEntryCompletionByDate', dailyCompletion: { __typename?: 'SiteIntervalCompletionStatus', hasRequiredMetrics: boolean, dataEntryCompletion?: { __typename?: 'DataEntryCompletion', appliedAt: string, createdAt: string, id: string, intervalTime?: string | null, isComplete: boolean, siteId: number, updatedAt: string, userId?: number | null, user?: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } | null } | null, interval?: { __typename?: 'IntervalNest', createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string } | null }, intervalCompletions: Array<{ __typename?: 'SiteIntervalCompletionStatus', hasRequiredMetrics: boolean, dataEntryCompletion?: { __typename?: 'DataEntryCompletion', appliedAt: string, createdAt: string, id: string, intervalTime?: string | null, isComplete: boolean, siteId: number, updatedAt: string, userId?: number | null, user?: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } | null } | null, interval?: { __typename?: 'IntervalNest', createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string } | null }>, site: { __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string, intervals: Array<{ __typename?: 'IntervalNest', createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string }> } }> };

export type SiteFlexMetricsQueryVariables = Exact<{
  input: SiteFlexMetricsInput;
}>;


export type SiteFlexMetricsQuery = { __typename?: 'Query', siteFlexMetrics: Array<{ __typename?: 'SiteFlexMetric', createdAt: string, deletedAt?: string | null, folderViewOrder: number, id: string, metricId: number, name?: string | null, required: boolean, siteId: number, updatedAt: string, metric?: { __typename?: 'MetricNest', deletedAt?: string | null, id: number, internalKeyname?: string | null, name: string, displayNameBreadcrumbs?: Array<{ __typename?: 'Breadcrumb', key: string, value: string }> | null, unit?: { __typename?: 'UnitNest', id: number, name: string } | null } | null }> };

export type SiteProcessesQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type SiteProcessesQuery = { __typename?: 'Query', site: { __typename?: 'SiteType', id: number, processes: Array<{ __typename?: 'ProcessType', deletedAt?: string | null, displayName: string, id: number, internalKeyname?: string | null, name: string, order: number, siteId: number }> } };

export type SitesV2QueryVariables = Exact<{
  input: SitesInput;
}>;


export type SitesV2Query = { __typename?: 'Query', sitesV2: Array<{ __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string }> };

export type SourceMetricsBySystemIdQueryVariables = Exact<{
  systemId: Scalars['Int'];
}>;


export type SourceMetricsBySystemIdQuery = { __typename?: 'Query', sourceMetricsBySystemId: Array<{ __typename?: 'MetricWithCalculatedMetric', id: number, belowRlValue?: number | null, calculated: boolean, calculationName?: string | null, canBeAveraged: CanBeAveraged, canBeCounted: boolean, canBeMaximized: boolean, canBeMinimized: boolean, canBeTotaled: boolean, componentId?: number | null, copyPreviousValueEnabled: boolean, createdAt: string, dataPointCommentPolicy: DataPointCommentPolicy, dataType: MetricDataTypeEnum, debug: boolean, deletedAt?: string | null, detectionLimit?: number | null, expression?: string | null, hideFromDataEntry: boolean, internalKeyname?: string | null, interpolated: boolean, isDecreasing: boolean, isIncreasing: boolean, isLockedByWaterly: boolean, isReportComments: boolean, maxValue?: number | null, minValue?: number | null, name: string, notificationEnabled: boolean, order: number, precision?: number | null, processId: number, rangeMax?: number | null, rangeMin?: number | null, reportingLimit?: number | null, required: boolean, treatBelowRlAsPercent: boolean, unitId?: number | null, updatedAt: string, updatesPriorDay: boolean, calculatedMetric: { __typename?: 'CalculatedMetric', calculatedMetricId: number, sourceMetricId: number }, intervals?: Array<{ __typename?: 'IntervalNest', createdAt: string, createdByUserId?: number | null, date?: string | null, displayName: string, id: number, siteId: number, time: string, updatedAt: string }> | null }> };

export type SsoOrgUsersForSystemQueryVariables = Exact<{
  searchInput: Scalars['String'];
  systemId: Scalars['Int'];
}>;


export type SsoOrgUsersForSystemQuery = { __typename?: 'Query', ssoOrgUsersForSystem: Array<{ __typename?: 'SSODirectoryUser', firstName?: string | null, id: string, lastName?: string | null }> };

export type SsoUsersForOrganizationQueryVariables = Exact<{
  input: SsoUsersForOrganizationInput;
}>;


export type SsoUsersForOrganizationQuery = { __typename?: 'Query', ssoUsersForOrganization: Array<{ __typename?: 'SSODirectoryUser', firstName?: string | null, id: string, lastName?: string | null }> };

export type SystemQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SystemQuery = { __typename?: 'Query', systemV2: { __typename?: 'SystemNest', userDirectoryEnabled: boolean, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string, addresses: Array<{ __typename?: 'Address', city?: string | null, countryCode: string, createdAt: string, id: string, label?: string | null, line1?: string | null, line2?: string | null, organizationId?: number | null, phone?: string | null, postalCode?: string | null, purpose: AddressPurpose, recipientName?: string | null, region?: string | null, siteId?: number | null, systemId?: number | null, updatedAt: string }>, operator?: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } | null, organization: { __typename?: 'OrganizationNest', isExternalSystemSearchEnabled: boolean, dateFormat: OrganizationDateFormat, fiscalYearStartDate: string, id: number, idpKey?: string | null, name: string, selfServiceEnabled: boolean }, permits: Array<{ __typename?: 'Permit', createdAt: string, deletedAt?: string | null, id: string, isPublicWaterSystemId: boolean, name: string, permitCode: string, systemId: number, updatedAt: string }>, users: Array<{ __typename?: 'UserNest', roleForSystem: string, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean }> } };

export type SystemGroupQueryVariables = Exact<{
  input: SystemGroupInput;
  systemGroupId: Scalars['Int'];
}>;


export type SystemGroupQuery = { __typename?: 'Query', systemGroup: { __typename?: 'SystemGroupType', displayName: string, id: number, isTopLevel: boolean, name: string, organizationId: number, parentSystemGroupId?: number | null, users: Array<{ __typename?: 'UserInfoType', roleForSystemGroup: SystemGroupRoleEnum, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean }> } };

export type SystemGroupDirectUsersQueryVariables = Exact<{
  input: SystemGroupInput;
  systemGroupId: Scalars['Int'];
}>;


export type SystemGroupDirectUsersQuery = { __typename?: 'Query', systemGroup: { __typename?: 'SystemGroupType', id: number, users: Array<{ __typename?: 'UserInfoType', roleForSystemGroup: SystemGroupRoleEnum, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean }> } };

export type SystemGroupWithSystemGroupsAndSystemsQueryVariables = Exact<{
  input: SystemGroupInput;
}>;


export type SystemGroupWithSystemGroupsAndSystemsQuery = { __typename?: 'Query', systemGroup: { __typename?: 'SystemGroupType', displayName: string, id: number, isTopLevel: boolean, name: string, organizationId: number, parentSystemGroupId?: number | null, systemGroups: Array<{ __typename?: 'SystemGroupType', displayName: string, id: number, isTopLevel: boolean, name: string, organizationId: number, parentSystemGroupId?: number | null }>, systems: Array<{ __typename?: 'SystemType', displayName: string, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, hasSitesWithIntervals: boolean, hideDataSites: boolean, id: number, isFavorite: boolean, isTemplate: boolean, licenseId?: number | null, myRole: SystemGroupRoleEnum, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId?: number | null, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type?: SystemTypeEnum | null }> } };

export type SystemGroupsQueryVariables = Exact<{
  input: SystemGroupsInput;
}>;


export type SystemGroupsQuery = { __typename?: 'Query', systemGroups: Array<{ __typename?: 'SystemGroupType', displayName: string, id: number, isTopLevel: boolean, name: string, organizationId: number, parentSystemGroupId?: number | null }> };

export type SystemSettingsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SystemSettingsQuery = { __typename?: 'Query', systemV2: { __typename?: 'SystemNest', userDirectoryEnabled: boolean, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string, addresses: Array<{ __typename?: 'Address', city?: string | null, countryCode: string, createdAt: string, id: string, label?: string | null, line1?: string | null, line2?: string | null, organizationId?: number | null, phone?: string | null, postalCode?: string | null, purpose: AddressPurpose, recipientName?: string | null, region?: string | null, siteId?: number | null, systemId?: number | null, updatedAt: string }>, operator?: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } | null, organization: { __typename?: 'OrganizationNest', isExternalSystemSearchEnabled: boolean, dateFormat: OrganizationDateFormat, fiscalYearStartDate: string, id: number, idpKey?: string | null, name: string, selfServiceEnabled: boolean }, permits: Array<{ __typename?: 'Permit', createdAt: string, deletedAt?: string | null, id: string, isPublicWaterSystemId: boolean, name: string, permitCode: string, systemId: number, updatedAt: string }>, users: Array<{ __typename?: 'UserNest', roleForSystem: string, displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean }> } };

export type SystemWithDeepSitesQueryVariables = Exact<{
  id: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
}>;


export type SystemWithDeepSitesQuery = { __typename?: 'Query', systemWithDeepSites: { __typename?: 'SystemWithSites', id: number, isTemplate: boolean, name: string, organizationId: number, type: string, sites: Array<{ __typename?: 'SiteWithProcesses', deletedAt?: string | null, flex: boolean, id: number, isEntry: boolean, name: string, order: number, processes: Array<{ __typename?: 'ProcessWithComponentsAndMetrics', deletedAt?: string | null, id: number, name: string, order: number, components: Array<{ __typename?: 'ComponentWithMetrics', deletedAt?: string | null, id: number, name: string, order: number }>, metrics: Array<{ __typename?: 'MetricWithRelatedMetrics', calculated: boolean, componentId?: number | null, deletedAt?: string | null, hideFromDataEntry: boolean, id: number, name: string, order: number, processId: number, required: boolean, calculatedMetrics: Array<{ __typename?: 'CalculatedMetric', sourceMetricId: number }>, sourceMetrics: Array<{ __typename?: 'CalculatedMetric', calculatedMetricId: number }> }> }> }> } };

export type TagMappingsQueryVariables = Exact<{
  input: TagMappingsInput;
}>;


export type TagMappingsQuery = { __typename?: 'Query', tagMappings: { __typename?: 'TagMappingsResult', id: string, total: number, data: Array<{ __typename?: 'TagMappingType', id: number, tagName: string, edgeDevice?: { __typename?: 'EdgeDeviceNest', deviceName: string, id: number } | null, metric: { __typename?: 'MetricNest', id: number, name: string, component?: { __typename?: 'ComponentNest', id: number, name: string } | null, process?: { __typename?: 'ProcessNest', id: number, name: string } | null }, site: { __typename?: 'SiteNest', id: number, name: string }, system: { __typename?: 'SystemNest', id: number, name: string } }> } };

export type TagsQueryVariables = Exact<{
  input: TagsInput;
}>;


export type TagsQuery = { __typename?: 'Query', tags: { __typename?: 'TagsWithCount', count: number, items: Array<{ __typename?: 'Tag', keynameTagCount: number, logBookEntryTagCount: number, reportTagCount: number, color?: string | null, createdAt: string, deletedAt?: string | null, displayName: string, id: string, name: string, nameEs?: string | null, organizationId?: number | null, type: TagType, updatedAt: string, organization?: { __typename?: 'OrganizationNest', id: number, name: string } | null }> } };

export type TemplateSystemsQueryVariables = Exact<{
  organizationId: Scalars['Int'];
}>;


export type TemplateSystemsQuery = { __typename?: 'Query', templateSystems: Array<{ __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string }> };

export type TransactionInfoWithCalcClusterDebugLogsQueryVariables = Exact<{
  input: CalcClusterDebugLogsInput;
}>;


export type TransactionInfoWithCalcClusterDebugLogsQuery = { __typename?: 'Query', transactionInfoWithCalcClusterDebugLogs: Array<{ __typename?: 'TransactionInfoWithCalcClusterDebugLogs', id: string, originTimestamp: string, transactionId: string, logs: Array<{ __typename?: 'CalcClusterDebugLog', appliedAt: string, calcClusterDebugId: string, clusterId: string, createdAt: string, deletedAt?: string | null, id: string, measuredAt: string, metricId: number, oldValue?: string | null, transactionId: string, updatedAt: string, value?: string | null, site: { __typename?: 'SiteNest', createdAt: string, dataEntryCompletionEmail: DataEntryCompletionEmailOption, dataEntryCompletionEnabled: boolean, deletedAt?: string | null, emoji?: string | null, externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, flex: boolean, fullName: string, id: number, isEntry: boolean, latitude?: number | null, licenseId?: number | null, longitude?: number | null, mirrorSiteId?: number | null, name: string, npdesPermitNumber?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType: string, systemId: number, updatedAt: string } }> }> };

export type UnitNestsQueryVariables = Exact<{
  input: UnitsInput;
}>;


export type UnitNestsQuery = { __typename?: 'Query', unitNests: Array<{ __typename?: 'UnitNest', createdAt: string, deletedAt?: string | null, id: number, isInterpolatable: boolean, name: string, updatedAt: string }> };

export type UserManagerUserQueryVariables = Exact<{
  input: UserManagerUserDetailsInput;
}>;


export type UserManagerUserQuery = { __typename?: 'Query', userManagerUser?: { __typename?: 'UserManagerUser', createdAt: string, deletedAt?: string | null, email: string, firstName: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationName?: string | null, readonlySuperadmin: boolean, superadmin: boolean } | null };

export type UserManagerUsersQueryVariables = Exact<{
  input?: InputMaybe<UserManagerUsersInput>;
}>;


export type UserManagerUsersQuery = { __typename?: 'Query', userManagerUsers: { __typename?: 'UserManagerUsersPage', count: number, items: Array<{ __typename?: 'UserManagerUser', createdAt: string, deletedAt?: string | null, email: string, firstName: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationName?: string | null, readonlySuperadmin: boolean, superadmin: boolean }> } };

export type UsersQueryVariables = Exact<{
  input: UsersInput;
}>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'UserInfoType', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey: string, lastLoginAt?: string | null, lastName: string, pending: boolean, primaryOrganizationId: number, readonlySuperadmin: boolean, subject: string, superadmin: boolean }> };

export type WeatherDataStationsQueryVariables = Exact<{
  includeArchived?: InputMaybe<Scalars['Boolean']>;
}>;


export type WeatherDataStationsQuery = { __typename?: 'Query', weatherDataStations: Array<{ __typename?: 'WeatherDataStationNest', deletedAt?: string | null, id: string, latitude: number, locationName: string, longitude: number, stateCode?: string | null, usgsStationId?: string | null }> };

export type SiteFragment = { __typename?: 'SiteType', dataEntryCompletionEmail?: DataEntryCompletionEmailOption | null, dataEntryCompletionEnabled?: boolean | null, displayName: string, emoji?: string | null, externalId?: string | null, externalMetadataJSON?: string | null, externalOwner?: string | null, flex?: boolean | null, fullName: string, id: number, isEntry?: boolean | null, latitude?: number | null, licenseId?: number | null, longitude?: number | null, name?: string | null, operatorId?: number | null, order: number, phoneNumberId?: number | null, siteType?: SiteTypeEnum | null, systemId: number };

export type OnAuditEventPublishedSubscriptionVariables = Exact<{
  accessToken: Scalars['String'];
  input: AuditEventSubscriptionInput;
}>;


export type OnAuditEventPublishedSubscription = { __typename?: 'Subscription', onAuditEventPublished: { __typename?: 'AuditEventNest', event: string, id: string, rolledBackAt?: string | null, timestamp: number, type: AuditEventType, userId: number, version: AuditEventVersion, system?: { __typename?: 'SystemNest', externalId?: string | null, externalMetadata?: string | null, externalOwner?: string | null, hideDataSites: boolean, id: number, isFavorite?: boolean | null, isTemplate: boolean, licenseId?: number | null, name: string, operatorId?: number | null, organizationId: number, parentSystemGroupId: number, phoneNumberId?: number | null, regulatoryId?: string | null, timeZone: string, type: string } | null, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } } };

export type OnCalcQueueJobsPublishedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnCalcQueueJobsPublishedSubscription = { __typename?: 'Subscription', onCalcQueueJobsPublished: { __typename?: 'JobEvent', job: { __typename?: 'JobLite', groupId?: string | null, id: string, name: string } } };

export type OnCalcQueueStatsPublishedSubscriptionVariables = Exact<{
  accessToken: Scalars['String'];
}>;


export type OnCalcQueueStatsPublishedSubscription = { __typename?: 'Subscription', onCalcQueueStatsPublished: { __typename?: 'QueueStats', completedInLastHour: number, completedPerMinute: Array<number>, failedInLastHour: number, failedPerMinute: Array<number>, generatedAt: string, queue: string, workersCount: number, groupsCount: Array<{ __typename?: 'GroupCount', count: number, id: string, status: string, userJobCounts: Array<{ __typename?: 'UserJobCount', count: number, senderEmail: string }> } | null>, groupsCountByStatus: { __typename?: 'GroupQueueCounts', limited: number, maxed: number, paused: number, waiting: number } } };

export type OnDataEntryCompletionPublishedSubscriptionVariables = Exact<{
  accessToken: Scalars['String'];
  siteId: Scalars['Float'];
}>;


export type OnDataEntryCompletionPublishedSubscription = { __typename?: 'Subscription', onDataEntryCompletionPublished: { __typename?: 'DataEntryCompletion', appliedAt: string, createdAt: string, id: string, intervalTime?: string | null, isComplete: boolean, siteId: number, updatedAt: string, userId?: number | null } };

export type OnLogBookEntryPublishedSubscriptionVariables = Exact<{
  accessToken: Scalars['String'];
  siteId: Scalars['Float'];
}>;


export type OnLogBookEntryPublishedSubscription = { __typename?: 'Subscription', onLogBookEntryPublished: { __typename?: 'LogBookEntryNest', createdAt: string, deletedAt?: string | null, id: string, message: string, organizationId: number, pinned: boolean, updatedAt: string, attachments: { __typename?: 'LogBookEntryAttachmentsNest', components: Array<{ __typename?: 'ComponentNest', id: number, name: string }>, metrics: Array<{ __typename?: 'MetricNest', id: number, name: string }>, processes: Array<{ __typename?: 'ProcessNest', id: number, name: string }>, sites: Array<{ __typename?: 'SiteNest', id: number, name: string }>, systems: Array<{ __typename?: 'SystemNest', id: number, name: string }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, uploads: Array<{ __typename?: 'Upload', fileName: string, id: string, url: string }> }, user: { __typename?: 'UserNest', firstName: string, id: number, lastName: string } } };

export type OnNotificationPublishedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnNotificationPublishedSubscription = { __typename?: 'Subscription', onNotificationPublished?: { __typename?: 'Notification', active: boolean, appearance: NotificationAppearance, createdAt: string, deletedAt?: string | null, dismissable: boolean, displayPosition: NotificationDisplayPosition, endDate?: string | null, icon?: SelectableIcons | null, id: string, message: string, name: string, organizationId: number, startDate: string, systemGroupId?: number | null, systemId?: number | null, title?: string | null, updatedAt: string } | null };

export type OnScheduledItemPublishedSubscriptionVariables = Exact<{
  accessToken: Scalars['String'];
}>;


export type OnScheduledItemPublishedSubscription = { __typename?: 'Subscription', onScheduledItemPublished: { __typename?: 'ScheduledItem', assigneeId?: number | null, completedAt?: string | null, createdAt: string, deletedAt?: string | null, description?: string | null, id: string, isStackable: boolean, notBefore?: string | null, photoRequired: boolean, recurrenceType: RecurrenceType, scheduledAt: string, sourceScheduleId: string, sourceScheduleType: SourceScheduleType, status: ScheduledItemStatus, systemId: number, targetDate?: string | null, title: string, updatedAt: string, comments: Array<{ __typename?: 'ScheduledItemComment', comment: string, commentType: ScheduledItemCommentType, createdAt: string, id: string, scheduledItemId: string, updatedAt: string, userId: number, user: { __typename?: 'UserNest', displayName: string, email: string, enableIphoneMetricNumberInput: boolean, externalId?: string | null, externalOwner?: string | null, firstName: string, fullNameOrEmail: string, id: number, idpKey?: string | null, lastLoginAt?: string | null, lastName: string, pending?: boolean | null, primaryOrganizationId: number, readonlySuperadmin?: boolean | null, subject: string, superadmin: boolean } }>, photoUpload?: { __typename?: 'Upload', blobId: string, createdAt: string, deletedAt?: string | null, description?: string | null, fileLength: number, fileName: string, id: string, mimeType: string, organizationId?: number | null, updatedAt?: string | null, url: string } | null } };

export type OnSiteDataEntryChangedSubscriptionVariables = Exact<{
  accessToken: Scalars['String'];
  intervalIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  reportDate: Scalars['DateType'];
  siteId: Scalars['Int'];
  subscriptionClientId: Scalars['String'];
}>;


export type OnSiteDataEntryChangedSubscription = { __typename?: 'Subscription', onSiteDataEntryChanged: { __typename?: 'SiteDataEntryChangeType', entryIntervalDate?: string | null, entryIntervalTime?: string | null, dataPoint: { __typename?: 'MetricDataPointType', appliedAt: string, calculatedNondetectValue?: boolean | null, calculatedValue?: string | null, comment?: string | null, connectValue?: string | null, edgeDeviceSubmissionId?: number | null, effectiveValue?: string | null, error?: string | null, id?: number | null, intervalId?: number | null, isInterpolated?: boolean | null, isNondetect?: boolean | null, measuredAt: string, metricId: number, reportDate: string, type: string, value?: string | null, version?: number | null } } };

export type ActiveMetricStatsKeySpecifier = ('metricCalculationCount' | 'metricCount' | 'metricDataWaterlyConnectCount' | ActiveMetricStatsKeySpecifier)[];
export type ActiveMetricStatsFieldPolicy = {
	metricCalculationCount?: FieldPolicy<any> | FieldReadFunction<any>,
	metricCount?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataWaterlyConnectCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActiveUserStatsKeySpecifier = ('activeUserCount' | 'userCount' | 'users' | ActiveUserStatsKeySpecifier)[];
export type ActiveUserStatsFieldPolicy = {
	activeUserCount?: FieldPolicy<any> | FieldReadFunction<any>,
	userCount?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityScheduleKeySpecifier = ('activityScheduleTypeId' | 'createdAt' | 'createdByUserId' | 'defaultAssignee' | 'defaultAssigneeId' | 'deletedAt' | 'description' | 'endDate' | 'exDates' | 'id' | 'isStackable' | 'notBeforeUnit' | 'notBeforeValue' | 'photoRequired' | 'rDates' | 'recurrenceType' | 'rrule' | 'siteId' | 'startDate' | 'system' | 'systemId' | 'targetBeforeUnit' | 'targetBeforeValue' | 'title' | 'updatedAt' | ActivityScheduleKeySpecifier)[];
export type ActivityScheduleFieldPolicy = {
	activityScheduleTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultAssignee?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultAssigneeId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	exDates?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isStackable?: FieldPolicy<any> | FieldReadFunction<any>,
	notBeforeUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	notBeforeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	photoRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	rDates?: FieldPolicy<any> | FieldReadFunction<any>,
	recurrenceType?: FieldPolicy<any> | FieldReadFunction<any>,
	rrule?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	targetBeforeUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	targetBeforeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityScheduleWithCountKeySpecifier = ('count' | 'items' | ActivityScheduleWithCountKeySpecifier)[];
export type ActivityScheduleWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressKeySpecifier = ('city' | 'countryCode' | 'createdAt' | 'id' | 'label' | 'line1' | 'line2' | 'organizationId' | 'phone' | 'postalCode' | 'purpose' | 'recipientName' | 'region' | 'siteId' | 'systemId' | 'updatedAt' | AddressKeySpecifier)[];
export type AddressFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	line1?: FieldPolicy<any> | FieldReadFunction<any>,
	line2?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	purpose?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientName?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminStatsKeySpecifier = ('numberOfMetrics' | 'numberOfSites' | 'numberOfStates' | 'numberOfSystems' | 'numberOfUsers' | AdminStatsKeySpecifier)[];
export type AdminStatsFieldPolicy = {
	numberOfMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfSites?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfStates?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfSystems?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfUsers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnalyteKeySpecifier = ('analyteType' | 'createdAt' | 'deletedAt' | 'description' | 'id' | 'name' | 'unitId' | 'updatedAt' | AnalyteKeySpecifier)[];
export type AnalyteFieldPolicy = {
	analyteType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	unitId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnalyteGroupKeySpecifier = ('analytes' | 'createdAt' | 'deletedAt' | 'description' | 'id' | 'name' | 'organizationId' | 'updatedAt' | AnalyteGroupKeySpecifier)[];
export type AnalyteGroupFieldPolicy = {
	analytes?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnalyteGroupsWithCountKeySpecifier = ('count' | 'items' | AnalyteGroupsWithCountKeySpecifier)[];
export type AnalyteGroupsWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnalytesWithCountKeySpecifier = ('count' | 'items' | AnalytesWithCountKeySpecifier)[];
export type AnalytesWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ApiTokenNestKeySpecifier = ('createdAt' | 'createdByUserId' | 'expiresAt' | 'id' | 'lastUsedAt' | 'name' | 'organizationId' | 'realm' | 'revokedAt' | 'scopes' | 'updatedAt' | 'username' | ApiTokenNestKeySpecifier)[];
export type ApiTokenNestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUsedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	realm?: FieldPolicy<any> | FieldReadFunction<any>,
	revokedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	scopes?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditEventNestKeySpecifier = ('activitySchedule' | 'appliedAtWithTimeZone' | 'component' | 'componentId' | 'event' | 'id' | 'itemId' | 'itemType' | 'metric' | 'metricId' | 'organizationId' | 'process' | 'processId' | 'rolledBackAt' | 'scheduledItem' | 'site' | 'siteId' | 'system' | 'systemId' | 'timestamp' | 'type' | 'user' | 'userId' | 'version' | AuditEventNestKeySpecifier)[];
export type AuditEventNestFieldPolicy = {
	activitySchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	appliedAtWithTimeZone?: FieldPolicy<any> | FieldReadFunction<any>,
	component?: FieldPolicy<any> | FieldReadFunction<any>,
	componentId?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	metric?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	process?: FieldPolicy<any> | FieldReadFunction<any>,
	processId?: FieldPolicy<any> | FieldReadFunction<any>,
	rolledBackAt?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledItem?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditEventWithCountKeySpecifier = ('count' | 'items' | AuditEventWithCountKeySpecifier)[];
export type AuditEventWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BaseFolderKeySpecifier = ('color' | 'createdAt' | 'default' | 'deletedAt' | 'depth' | 'id' | 'name' | 'order' | 'parentId' | 'siteId' | 'updatedAt' | BaseFolderKeySpecifier)[];
export type BaseFolderFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	depth?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	parentId?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BaseScheduleKeySpecifier = ('createdAt' | 'createdByUserId' | 'defaultAssignee' | 'defaultAssigneeId' | 'deletedAt' | 'description' | 'endDate' | 'exDates' | 'id' | 'isStackable' | 'notBeforeUnit' | 'notBeforeValue' | 'photoRequired' | 'rDates' | 'recurrenceType' | 'rrule' | 'siteId' | 'startDate' | 'system' | 'systemId' | 'targetBeforeUnit' | 'targetBeforeValue' | 'title' | 'updatedAt' | BaseScheduleKeySpecifier)[];
export type BaseScheduleFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultAssignee?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultAssigneeId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	exDates?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isStackable?: FieldPolicy<any> | FieldReadFunction<any>,
	notBeforeUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	notBeforeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	photoRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	rDates?: FieldPolicy<any> | FieldReadFunction<any>,
	recurrenceType?: FieldPolicy<any> | FieldReadFunction<any>,
	rrule?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	targetBeforeUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	targetBeforeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BreadcrumbKeySpecifier = ('key' | 'value' | BreadcrumbKeySpecifier)[];
export type BreadcrumbFieldPolicy = {
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkMetricEditorEntityFilterOptionKeySpecifier = ('id' | 'name' | BulkMetricEditorEntityFilterOptionKeySpecifier)[];
export type BulkMetricEditorEntityFilterOptionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkMetricEditorFilterOptionsKeySpecifier = ('calculationNames' | 'componentKeynames' | 'components' | 'copyPreviousValueEnabled' | 'dataPointCommentPolicies' | 'dataTypes' | 'expressions' | 'hasIntervals' | 'hideFromDataEntry' | 'interpolated' | 'isLockedByWaterly' | 'isReportComments' | 'keynames' | 'limits' | 'metricRangeTypes' | 'notificationEnabled' | 'organizations' | 'processKeynames' | 'processes' | 'reportAggregations' | 'required' | 'siteTypes' | 'sites' | 'systemTypes' | 'systems' | 'units' | BulkMetricEditorFilterOptionsKeySpecifier)[];
export type BulkMetricEditorFilterOptionsFieldPolicy = {
	calculationNames?: FieldPolicy<any> | FieldReadFunction<any>,
	componentKeynames?: FieldPolicy<any> | FieldReadFunction<any>,
	components?: FieldPolicy<any> | FieldReadFunction<any>,
	copyPreviousValueEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	dataPointCommentPolicies?: FieldPolicy<any> | FieldReadFunction<any>,
	dataTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	expressions?: FieldPolicy<any> | FieldReadFunction<any>,
	hasIntervals?: FieldPolicy<any> | FieldReadFunction<any>,
	hideFromDataEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	interpolated?: FieldPolicy<any> | FieldReadFunction<any>,
	isLockedByWaterly?: FieldPolicy<any> | FieldReadFunction<any>,
	isReportComments?: FieldPolicy<any> | FieldReadFunction<any>,
	keynames?: FieldPolicy<any> | FieldReadFunction<any>,
	limits?: FieldPolicy<any> | FieldReadFunction<any>,
	metricRangeTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	organizations?: FieldPolicy<any> | FieldReadFunction<any>,
	processKeynames?: FieldPolicy<any> | FieldReadFunction<any>,
	processes?: FieldPolicy<any> | FieldReadFunction<any>,
	reportAggregations?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>,
	siteTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	sites?: FieldPolicy<any> | FieldReadFunction<any>,
	systemTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	systems?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkMetricEditorLimitsSummaryKeySpecifier = ('belowReportingLimitValue' | 'configured' | 'detectionLimit' | 'reportingLimit' | 'treatBelowReportingLimitAsPercent' | BulkMetricEditorLimitsSummaryKeySpecifier)[];
export type BulkMetricEditorLimitsSummaryFieldPolicy = {
	belowReportingLimitValue?: FieldPolicy<any> | FieldReadFunction<any>,
	configured?: FieldPolicy<any> | FieldReadFunction<any>,
	detectionLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	treatBelowReportingLimitAsPercent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkMetricEditorMetricsKeySpecifier = ('filteredCount' | 'items' | 'totalCount' | BulkMetricEditorMetricsKeySpecifier)[];
export type BulkMetricEditorMetricsFieldPolicy = {
	filteredCount?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkMetricEditorMetricsCsvExportKeySpecifier = ('contentType' | 'csv' | 'downloadUrl' | 'filename' | 'message' | 'rowCount' | 'status' | BulkMetricEditorMetricsCsvExportKeySpecifier)[];
export type BulkMetricEditorMetricsCsvExportFieldPolicy = {
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	csv?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	rowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkMetricEditorReportAggregationSummaryKeySpecifier = ('canBeAveraged' | 'canBeCounted' | 'canBeMaximized' | 'canBeMinimized' | 'canBeTotaled' | 'configured' | BulkMetricEditorReportAggregationSummaryKeySpecifier)[];
export type BulkMetricEditorReportAggregationSummaryFieldPolicy = {
	canBeAveraged?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeCounted?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeMaximized?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeMinimized?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeTotaled?: FieldPolicy<any> | FieldReadFunction<any>,
	configured?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkMetricEditorRowKeySpecifier = ('calculationName' | 'componentKeyname' | 'componentName' | 'copyPreviousValueEnabled' | 'dataPointCommentPolicy' | 'dataType' | 'expression' | 'hasIntervals' | 'hideFromDataEntry' | 'interpolated' | 'isLockedByWaterly' | 'isReportComments' | 'keyname' | 'limits' | 'metricId' | 'metricRangeType' | 'name' | 'notificationEnabled' | 'order' | 'organizationName' | 'precision' | 'processKeyname' | 'processName' | 'rangeMax' | 'rangeMin' | 'reportAggregations' | 'required' | 'siteId' | 'siteName' | 'siteType' | 'systemId' | 'systemName' | 'systemType' | 'units' | BulkMetricEditorRowKeySpecifier)[];
export type BulkMetricEditorRowFieldPolicy = {
	calculationName?: FieldPolicy<any> | FieldReadFunction<any>,
	componentKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	componentName?: FieldPolicy<any> | FieldReadFunction<any>,
	copyPreviousValueEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	dataPointCommentPolicy?: FieldPolicy<any> | FieldReadFunction<any>,
	dataType?: FieldPolicy<any> | FieldReadFunction<any>,
	expression?: FieldPolicy<any> | FieldReadFunction<any>,
	hasIntervals?: FieldPolicy<any> | FieldReadFunction<any>,
	hideFromDataEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	interpolated?: FieldPolicy<any> | FieldReadFunction<any>,
	isLockedByWaterly?: FieldPolicy<any> | FieldReadFunction<any>,
	isReportComments?: FieldPolicy<any> | FieldReadFunction<any>,
	keyname?: FieldPolicy<any> | FieldReadFunction<any>,
	limits?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	metricRangeType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationName?: FieldPolicy<any> | FieldReadFunction<any>,
	precision?: FieldPolicy<any> | FieldReadFunction<any>,
	processKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	processName?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	reportAggregations?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	siteName?: FieldPolicy<any> | FieldReadFunction<any>,
	siteType?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	systemName?: FieldPolicy<any> | FieldReadFunction<any>,
	systemType?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CalcClusterDebugKeySpecifier = ('clusterId' | 'enabled' | 'id' | 'logStats' | 'metricId' | 'metrics' | 'systems' | 'updatedAt' | CalcClusterDebugKeySpecifier)[];
export type CalcClusterDebugFieldPolicy = {
	clusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logStats?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	systems?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CalcClusterDebugLogKeySpecifier = ('appliedAt' | 'calcClusterDebugId' | 'clusterId' | 'createdAt' | 'deletedAt' | 'id' | 'measuredAt' | 'metricId' | 'oldValue' | 'site' | 'transactionId' | 'updatedAt' | 'value' | CalcClusterDebugLogKeySpecifier)[];
export type CalcClusterDebugLogFieldPolicy = {
	appliedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	calcClusterDebugId?: FieldPolicy<any> | FieldReadFunction<any>,
	clusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	measuredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	oldValue?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CalcClusterDebugLogStatsKeySpecifier = ('avgLogsPerTransaction' | 'lastLoggedAt' | 'logCount' | 'maxLogsPerTransaction' | 'transactionCount' | CalcClusterDebugLogStatsKeySpecifier)[];
export type CalcClusterDebugLogStatsFieldPolicy = {
	avgLogsPerTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	lastLoggedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	logCount?: FieldPolicy<any> | FieldReadFunction<any>,
	maxLogsPerTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CalcClusterDebugsWithCountKeySpecifier = ('count' | 'items' | CalcClusterDebugsWithCountKeySpecifier)[];
export type CalcClusterDebugsWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CalcTreeKeySpecifier = ('dot' | 'id' | CalcTreeKeySpecifier)[];
export type CalcTreeFieldPolicy = {
	dot?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CalculatedMetricKeySpecifier = ('calculatedMetricId' | 'sourceMetricId' | CalculatedMetricKeySpecifier)[];
export type CalculatedMetricFieldPolicy = {
	calculatedMetricId?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMetricId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClonedComponentPayloadKeySpecifier = ('component' | 'metrics' | ClonedComponentPayloadKeySpecifier)[];
export type ClonedComponentPayloadFieldPolicy = {
	component?: FieldPolicy<any> | FieldReadFunction<any>,
	metrics?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClonedProcessPayloadKeySpecifier = ('components' | 'metrics' | 'process' | ClonedProcessPayloadKeySpecifier)[];
export type ClonedProcessPayloadFieldPolicy = {
	components?: FieldPolicy<any> | FieldReadFunction<any>,
	metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	process?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ColumnGroupKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'name' | 'reportDefinitionId' | 'updatedAt' | ColumnGroupKeySpecifier)[];
export type ColumnGroupFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDefinitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ColumnGroupItemKeySpecifier = ('aggregation' | 'calculationType' | 'createdAt' | 'deletedAt' | 'id' | 'intervalId' | 'metricId' | 'name' | 'sourceMetrics' | 'type' | 'updatedAt' | ColumnGroupItemKeySpecifier)[];
export type ColumnGroupItemFieldPolicy = {
	aggregation?: FieldPolicy<any> | FieldReadFunction<any>,
	calculationType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalId?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ColumnGroupItemWithMetricKeySpecifier = ('aggregation' | 'calculationType' | 'createdAt' | 'deletedAt' | 'id' | 'intervalId' | 'metric' | 'metricId' | 'name' | 'sourceMetrics' | 'type' | 'updatedAt' | ColumnGroupItemWithMetricKeySpecifier)[];
export type ColumnGroupItemWithMetricFieldPolicy = {
	aggregation?: FieldPolicy<any> | FieldReadFunction<any>,
	calculationType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalId?: FieldPolicy<any> | FieldReadFunction<any>,
	metric?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ColumnGroupWithItemsKeySpecifier = ('columnGroupItems' | 'createdAt' | 'deletedAt' | 'id' | 'name' | 'reportDefinitionId' | 'updatedAt' | ColumnGroupWithItemsKeySpecifier)[];
export type ColumnGroupWithItemsFieldPolicy = {
	columnGroupItems?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDefinitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentNestKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'internalKeyname' | 'name' | 'order' | 'processId' | 'updatedAt' | ComponentNestKeySpecifier)[];
export type ComponentNestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	processId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentTypeKeySpecifier = ('deletedAt' | 'displayName' | 'enabledForReport' | 'id' | 'internalKeyname' | 'metrics' | 'name' | 'order' | 'process' | 'site' | 'system' | ComponentTypeKeySpecifier)[];
export type ComponentTypeFieldPolicy = {
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	enabledForReport?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	process?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentWithMetricsKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'internalKeyname' | 'metrics' | 'name' | 'order' | 'processId' | 'updatedAt' | ComponentWithMetricsKeySpecifier)[];
export type ComponentWithMetricsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	processId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConstantDefinitionKeySpecifier = ('createdAt' | 'dataType' | 'deletedAt' | 'description' | 'id' | 'keyname' | 'name' | 'organizationId' | 'precision' | 'scope' | 'systemId' | 'unitId' | 'updatedAt' | 'usedByMetricCount' | 'values' | ConstantDefinitionKeySpecifier)[];
export type ConstantDefinitionFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dataType?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	keyname?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	precision?: FieldPolicy<any> | FieldReadFunction<any>,
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	unitId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	usedByMetricCount?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConstantImpactedMetricKeySpecifier = ('metricId' | 'metricName' | 'recalculationCount' | 'siteName' | ConstantImpactedMetricKeySpecifier)[];
export type ConstantImpactedMetricFieldPolicy = {
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	metricName?: FieldPolicy<any> | FieldReadFunction<any>,
	recalculationCount?: FieldPolicy<any> | FieldReadFunction<any>,
	siteName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConstantRecalculationEstimateKeySpecifier = ('capped' | 'dayCount' | 'effectiveFromDate' | 'metrics' | 'recalcFromDate' | 'toDate' | 'totalRecalculationCount' | ConstantRecalculationEstimateKeySpecifier)[];
export type ConstantRecalculationEstimateFieldPolicy = {
	capped?: FieldPolicy<any> | FieldReadFunction<any>,
	dayCount?: FieldPolicy<any> | FieldReadFunction<any>,
	effectiveFromDate?: FieldPolicy<any> | FieldReadFunction<any>,
	metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	recalcFromDate?: FieldPolicy<any> | FieldReadFunction<any>,
	toDate?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRecalculationCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConstantValueKeySpecifier = ('constantDefinitionId' | 'createdAt' | 'deletedAt' | 'effectiveDate' | 'id' | 'note' | 'numericValue' | 'textValue' | 'updatedAt' | ConstantValueKeySpecifier)[];
export type ConstantValueFieldPolicy = {
	constantDefinitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	effectiveDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	numericValue?: FieldPolicy<any> | FieldReadFunction<any>,
	textValue?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateApiTokenPayloadNestKeySpecifier = ('credentials' | 'token' | CreateApiTokenPayloadNestKeySpecifier)[];
export type CreateApiTokenPayloadNestFieldPolicy = {
	credentials?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateEnterpriseReportShareLinkPayloadKeySpecifier = ('publicUrl' | 'shareLink' | CreateEnterpriseReportShareLinkPayloadKeySpecifier)[];
export type CreateEnterpriseReportShareLinkPayloadFieldPolicy = {
	publicUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	shareLink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataEntryCompletionKeySpecifier = ('appliedAt' | 'createdAt' | 'id' | 'intervalTime' | 'isComplete' | 'latestServiceReportSnapshot' | 'siteId' | 'updatedAt' | 'user' | 'userId' | DataEntryCompletionKeySpecifier)[];
export type DataEntryCompletionFieldPolicy = {
	appliedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalTime?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	latestServiceReportSnapshot?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataEntryCompletionsByAppliedAtKeySpecifier = ('daily' | 'intervals' | DataEntryCompletionsByAppliedAtKeySpecifier)[];
export type DataEntryCompletionsByAppliedAtFieldPolicy = {
	daily?: FieldPolicy<any> | FieldReadFunction<any>,
	intervals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataPointTypeKeySpecifier = ('id' | 'reportDate' | 'type' | 'value' | 'version' | DataPointTypeKeySpecifier)[];
export type DataPointTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDate?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataPointValueAndIntervalKeySpecifier = ('id' | 'intervalId' | 'value' | 'waterlyConnect' | DataPointValueAndIntervalKeySpecifier)[];
export type DataPointValueAndIntervalFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalId?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	waterlyConnect?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataPointsForDayKeySpecifier = ('dataPoints' | 'id' | 'metricId' | DataPointsForDayKeySpecifier)[];
export type DataPointsForDayFieldPolicy = {
	dataPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DiagnosticsResultKeySpecifier = ('id' | 'lastUpdated' | 'success' | DiagnosticsResultKeySpecifier)[];
export type DiagnosticsResultFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EdgeDeviceNestKeySpecifier = ('createdAt' | 'deviceName' | 'deviceType' | 'enabled' | 'id' | 'integrationMetadata' | 'lastReceivedAt' | 'organizationId' | 'organizationName' | 'updatedAt' | EdgeDeviceNestKeySpecifier)[];
export type EdgeDeviceNestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceName?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceType?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	integrationMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	lastReceivedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationName?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EdgeDeviceSubmissionKeySpecifier = ('createdAt' | 'dataExcerpt' | 'edgeDevice' | 'edgeDeviceId' | 'id' | 'remoteIp' | 'status' | 'success' | 'updatedAt' | EdgeDeviceSubmissionKeySpecifier)[];
export type EdgeDeviceSubmissionFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dataExcerpt?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDeviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	remoteIp?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EdgeDeviceSubmissionSummariesWithCountKeySpecifier = ('count' | 'items' | EdgeDeviceSubmissionSummariesWithCountKeySpecifier)[];
export type EdgeDeviceSubmissionSummariesWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EdgeDeviceSubmissionSummaryKeySpecifier = ('createdAt' | 'edgeDeviceId' | 'id' | 'remoteIp' | 'success' | 'updatedAt' | EdgeDeviceSubmissionSummaryKeySpecifier)[];
export type EdgeDeviceSubmissionSummaryFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDeviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	remoteIp?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EdgeDeviceTypeKeySpecifier = ('deviceName' | 'id' | 'organizationId' | EdgeDeviceTypeKeySpecifier)[];
export type EdgeDeviceTypeFieldPolicy = {
	deviceName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnterpriseReportKeySpecifier = ('createdAt' | 'frequency' | 'id' | 'inputConfig' | 'name' | 'organizationId' | 'reportId' | 'reportSnapshots' | 'reportTemplate' | 'siteId' | 'systemId' | 'timeZone' | 'updatedAt' | EnterpriseReportKeySpecifier)[];
export type EnterpriseReportFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	frequency?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inputConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportSnapshots?: FieldPolicy<any> | FieldReadFunction<any>,
	reportTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZone?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnterpriseReportShareLinkKeySpecifier = ('createdAt' | 'createdByUserId' | 'deletedAt' | 'disabledAt' | 'disabledByUserId' | 'expiresAt' | 'id' | 'reportSnapshotId' | 'updatedAt' | EnterpriseReportShareLinkKeySpecifier)[];
export type EnterpriseReportShareLinkFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	disabledAt?: FieldPolicy<any> | FieldReadFunction<any>,
	disabledByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	reportSnapshotId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnterpriseReportShareLinkAccessRequestPayloadKeySpecifier = ('emailRecipient' | 'submitted' | EnterpriseReportShareLinkAccessRequestPayloadKeySpecifier)[];
export type EnterpriseReportShareLinkAccessRequestPayloadFieldPolicy = {
	emailRecipient?: FieldPolicy<any> | FieldReadFunction<any>,
	submitted?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnterpriseReportShareLinkResolutionKeySpecifier = ('disabledAt' | 'expiresAt' | 'redirectPath' | 'reportSnapshotId' | 'shareLinkId' | 'state' | EnterpriseReportShareLinkResolutionKeySpecifier)[];
export type EnterpriseReportShareLinkResolutionFieldPolicy = {
	disabledAt?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectPath?: FieldPolicy<any> | FieldReadFunction<any>,
	reportSnapshotId?: FieldPolicy<any> | FieldReadFunction<any>,
	shareLinkId?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntrySparklineDataPointTypeKeySpecifier = ('appliedAt' | 'dataPoint' | 'id' | 'intervalId' | 'time' | EntrySparklineDataPointTypeKeySpecifier)[];
export type EntrySparklineDataPointTypeFieldPolicy = {
	appliedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dataPoint?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalId?: FieldPolicy<any> | FieldReadFunction<any>,
	time?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntrySparklineTypeKeySpecifier = ('dataPoints' | 'id' | 'metricId' | 'metricType' | EntrySparklineTypeKeySpecifier)[];
export type EntrySparklineTypeFieldPolicy = {
	dataPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	metricType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntryTSDataPointKeySpecifier = ('appliedAt' | 'booleanValue' | 'calculatedNondetectValue' | 'calculatedValue' | 'comment' | 'connectValue' | 'dateTimeValue' | 'dateValue' | 'edgeDeviceSubmissionId' | 'effectiveNumericValue' | 'error' | 'id' | 'intervalId' | 'isArchived' | 'isCalculatedResult' | 'isInterpolated' | 'isNondetect' | 'journalEntryRecordId' | 'jsonValue' | 'locatorEntityId' | 'locatorEntityType' | 'locatorNamespace' | 'measuredAt' | 'metaData' | 'metricId' | 'numericValue' | 'reportDate' | 'storedAt' | 'textValue' | 'timeValue' | 'type' | 'value' | 'valueType' | EntryTSDataPointKeySpecifier)[];
export type EntryTSDataPointFieldPolicy = {
	appliedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	booleanValue?: FieldPolicy<any> | FieldReadFunction<any>,
	calculatedNondetectValue?: FieldPolicy<any> | FieldReadFunction<any>,
	calculatedValue?: FieldPolicy<any> | FieldReadFunction<any>,
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	connectValue?: FieldPolicy<any> | FieldReadFunction<any>,
	dateTimeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	dateValue?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDeviceSubmissionId?: FieldPolicy<any> | FieldReadFunction<any>,
	effectiveNumericValue?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalId?: FieldPolicy<any> | FieldReadFunction<any>,
	isArchived?: FieldPolicy<any> | FieldReadFunction<any>,
	isCalculatedResult?: FieldPolicy<any> | FieldReadFunction<any>,
	isInterpolated?: FieldPolicy<any> | FieldReadFunction<any>,
	isNondetect?: FieldPolicy<any> | FieldReadFunction<any>,
	journalEntryRecordId?: FieldPolicy<any> | FieldReadFunction<any>,
	jsonValue?: FieldPolicy<any> | FieldReadFunction<any>,
	locatorEntityId?: FieldPolicy<any> | FieldReadFunction<any>,
	locatorEntityType?: FieldPolicy<any> | FieldReadFunction<any>,
	locatorNamespace?: FieldPolicy<any> | FieldReadFunction<any>,
	measuredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	metaData?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	numericValue?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDate?: FieldPolicy<any> | FieldReadFunction<any>,
	storedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	textValue?: FieldPolicy<any> | FieldReadFunction<any>,
	timeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	valueType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntryTSDataPointMetadataKeySpecifier = ('connectValue' | 'edgeDeviceSubmissionId' | 'id' | 'intervalId' | 'reportDate' | EntryTSDataPointMetadataKeySpecifier)[];
export type EntryTSDataPointMetadataFieldPolicy = {
	connectValue?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDeviceSubmissionId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalFacilityKeySpecifier = ('externalId' | 'externalMetadata' | 'name' | ExternalFacilityKeySpecifier)[];
export type ExternalFacilityFieldPolicy = {
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	externalMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalSystemKeySpecifier = ('externalId' | 'externalMetadata' | 'externalOwner' | 'id' | 'name' | 'state' | ExternalSystemKeySpecifier)[];
export type ExternalSystemFieldPolicy = {
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	externalMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	externalOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FolderWithMetricIdsAndOrderKeySpecifier = ('color' | 'createdAt' | 'default' | 'deletedAt' | 'depth' | 'id' | 'metricIdsWithOrder' | 'name' | 'order' | 'parentId' | 'siteId' | 'updatedAt' | FolderWithMetricIdsAndOrderKeySpecifier)[];
export type FolderWithMetricIdsAndOrderFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	depth?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metricIdsWithOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	parentId?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupCountKeySpecifier = ('count' | 'id' | 'status' | 'userJobCounts' | GroupCountKeySpecifier)[];
export type GroupCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	userJobCounts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupQueueCountsKeySpecifier = ('limited' | 'maxed' | 'paused' | 'waiting' | GroupQueueCountsKeySpecifier)[];
export type GroupQueueCountsFieldPolicy = {
	limited?: FieldPolicy<any> | FieldReadFunction<any>,
	maxed?: FieldPolicy<any> | FieldReadFunction<any>,
	paused?: FieldPolicy<any> | FieldReadFunction<any>,
	waiting?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IntervalKeySpecifier = ('displayName' | 'id' | 'time' | IntervalKeySpecifier)[];
export type IntervalFieldPolicy = {
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	time?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IntervalNestKeySpecifier = ('createdAt' | 'createdByUser' | 'createdByUserId' | 'date' | 'deletedAt' | 'displayName' | 'id' | 'recentEntryCompletion' | 'siteFullName' | 'siteId' | 'time' | 'updatedAt' | IntervalNestKeySpecifier)[];
export type IntervalNestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	recentEntryCompletion?: FieldPolicy<any> | FieldReadFunction<any>,
	siteFullName?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	time?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IntervalsWithCountKeySpecifier = ('count' | 'items' | IntervalsWithCountKeySpecifier)[];
export type IntervalsWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JobEventKeySpecifier = ('data' | 'job' | 'queue' | 'type' | JobEventKeySpecifier)[];
export type JobEventFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	job?: FieldPolicy<any> | FieldReadFunction<any>,
	queue?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JobLiteKeySpecifier = ('groupId' | 'id' | 'name' | 'progress' | 'returnValue' | 'state' | JobLiteKeySpecifier)[];
export type JobLiteFieldPolicy = {
	groupId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	progress?: FieldPolicy<any> | FieldReadFunction<any>,
	returnValue?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportBatchKeySpecifier = ('checksumSha256' | 'committedAt' | 'committedRowCount' | 'createdAt' | 'errorDetails' | 'id' | 'invalidRowCount' | 'organizationId' | 'originalFileName' | 'parserMetadata' | 'profileName' | 'profileVersion' | 'profileVersionId' | 'readyMetricCount' | 'readySiteCount' | 'reconciliationRequiredRowCount' | 'skippedRowCount' | 'sourceFileSizeBytes' | 'sourceMimeType' | 'sourceUploadId' | 'status' | 'systemId' | 'totalRowCount' | 'uploadedByUserId' | 'validRowCount' | 'validatedAt' | LabImportBatchKeySpecifier)[];
export type LabImportBatchFieldPolicy = {
	checksumSha256?: FieldPolicy<any> | FieldReadFunction<any>,
	committedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	committedRowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	errorDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invalidRowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	originalFileName?: FieldPolicy<any> | FieldReadFunction<any>,
	parserMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	profileName?: FieldPolicy<any> | FieldReadFunction<any>,
	profileVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	profileVersionId?: FieldPolicy<any> | FieldReadFunction<any>,
	readyMetricCount?: FieldPolicy<any> | FieldReadFunction<any>,
	readySiteCount?: FieldPolicy<any> | FieldReadFunction<any>,
	reconciliationRequiredRowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	skippedRowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceFileSizeBytes?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceUploadId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	validRowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	validatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportBatchResumeKeySpecifier = ('batch' | 'pendingProfile' | LabImportBatchResumeKeySpecifier)[];
export type LabImportBatchResumeFieldPolicy = {
	batch?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingProfile?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportBatchSummaryKeySpecifier = ('committedAt' | 'committedRowCount' | 'createdAt' | 'fileLength' | 'fileName' | 'id' | 'invalidRowCount' | 'profileName' | 'reconciliationRequiredRowCount' | 'skippedRowCount' | 'status' | 'totalRowCount' | 'validRowCount' | LabImportBatchSummaryKeySpecifier)[];
export type LabImportBatchSummaryFieldPolicy = {
	committedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	committedRowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	fileLength?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invalidRowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	profileName?: FieldPolicy<any> | FieldReadFunction<any>,
	reconciliationRequiredRowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	skippedRowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	validRowCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportBatchesPageKeySpecifier = ('count' | 'items' | LabImportBatchesPageKeySpecifier)[];
export type LabImportBatchesPageFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportColumnMappingKeySpecifier = ('column' | 'field' | LabImportColumnMappingKeySpecifier)[];
export type LabImportColumnMappingFieldPolicy = {
	column?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportCommitResultKeySpecifier = ('batch' | 'committedCount' | 'failedCount' | 'reconciliationRequiredCount' | LabImportCommitResultKeySpecifier)[];
export type LabImportCommitResultFieldPolicy = {
	batch?: FieldPolicy<any> | FieldReadFunction<any>,
	committedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	failedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	reconciliationRequiredCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportFileDownloadKeySpecifier = ('downloadUrl' | 'fileName' | 'mimeType' | LabImportFileDownloadKeySpecifier)[];
export type LabImportFileDownloadFieldPolicy = {
	downloadUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportParserConfigKeySpecifier = ('columns' | 'delimiter' | 'hasHeader' | 'quote' | LabImportParserConfigKeySpecifier)[];
export type LabImportParserConfigFieldPolicy = {
	columns?: FieldPolicy<any> | FieldReadFunction<any>,
	delimiter?: FieldPolicy<any> | FieldReadFunction<any>,
	hasHeader?: FieldPolicy<any> | FieldReadFunction<any>,
	quote?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportPendingProfileKeySpecifier = ('baseProfileVersionId' | 'definition' | 'name' | 'profileId' | LabImportPendingProfileKeySpecifier)[];
export type LabImportPendingProfileFieldPolicy = {
	baseProfileVersionId?: FieldPolicy<any> | FieldReadFunction<any>,
	definition?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	profileId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportProfileKeySpecifier = ('createdAt' | 'createdByUserId' | 'id' | 'name' | 'organizationId' | 'systemId' | 'versions' | LabImportProfileKeySpecifier)[];
export type LabImportProfileFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	versions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportProfileDefinitionKeySpecifier = ('columnMappings' | 'parserConfig' | 'targetMappings' | LabImportProfileDefinitionKeySpecifier)[];
export type LabImportProfileDefinitionFieldPolicy = {
	columnMappings?: FieldPolicy<any> | FieldReadFunction<any>,
	parserConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	targetMappings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportProfileValidationKeySpecifier = ('issues' | 'valid' | LabImportProfileValidationKeySpecifier)[];
export type LabImportProfileValidationFieldPolicy = {
	issues?: FieldPolicy<any> | FieldReadFunction<any>,
	valid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportProfileValidationIssueKeySpecifier = ('code' | 'field' | 'message' | LabImportProfileValidationIssueKeySpecifier)[];
export type LabImportProfileValidationIssueFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportProfileVersionKeySpecifier = ('createdAt' | 'createdByUserId' | 'definition' | 'id' | 'profileId' | 'version' | LabImportProfileVersionKeySpecifier)[];
export type LabImportProfileVersionFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	definition?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	profileId?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportRowKeySpecifier = ('batchId' | 'canonicalValues' | 'comments' | 'id' | 'importedUnitLabel' | 'intervalId' | 'isNondetect' | 'metricId' | 'rawValues' | 'reportDate' | 'requestId' | 'resultName' | 'resultValue' | 'rowNumber' | 'sampleDate' | 'sampleIdentifier' | 'siteId' | 'status' | 'systemId' | 'validationResults' | 'writeErrorDetails' | 'writeStatus' | 'writtenAt' | LabImportRowKeySpecifier)[];
export type LabImportRowFieldPolicy = {
	batchId?: FieldPolicy<any> | FieldReadFunction<any>,
	canonicalValues?: FieldPolicy<any> | FieldReadFunction<any>,
	comments?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	importedUnitLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalId?: FieldPolicy<any> | FieldReadFunction<any>,
	isNondetect?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	rawValues?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDate?: FieldPolicy<any> | FieldReadFunction<any>,
	requestId?: FieldPolicy<any> | FieldReadFunction<any>,
	resultName?: FieldPolicy<any> | FieldReadFunction<any>,
	resultValue?: FieldPolicy<any> | FieldReadFunction<any>,
	rowNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleDate?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleIdentifier?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	validationResults?: FieldPolicy<any> | FieldReadFunction<any>,
	writeErrorDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	writeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	writtenAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportRowsPageKeySpecifier = ('count' | 'items' | LabImportRowsPageKeySpecifier)[];
export type LabImportRowsPageFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportSourceGroupKeySpecifier = ('analyte' | 'project' | 'rowCount' | 'sampleSite' | 'unit' | LabImportSourceGroupKeySpecifier)[];
export type LabImportSourceGroupFieldPolicy = {
	analyte?: FieldPolicy<any> | FieldReadFunction<any>,
	project?: FieldPolicy<any> | FieldReadFunction<any>,
	rowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleSite?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportTargetKeySpecifier = ('metricId' | 'metricName' | 'metricUnitLabel' | 'siteId' | 'siteName' | LabImportTargetKeySpecifier)[];
export type LabImportTargetFieldPolicy = {
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	metricName?: FieldPolicy<any> | FieldReadFunction<any>,
	metricUnitLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	siteName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportTargetMappingKeySpecifier = ('decision' | 'id' | 'importedUnitLabel' | 'metricId' | 'metricUnitLabel' | 'siteId' | 'sourceAnalyte' | 'sourceProject' | 'sourceSampleSite' | 'unitDecision' | LabImportTargetMappingKeySpecifier)[];
export type LabImportTargetMappingFieldPolicy = {
	decision?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	importedUnitLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	metricUnitLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceAnalyte?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceProject?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceSampleSite?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDecision?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabImportValidationResultKeySpecifier = ('attempt' | 'code' | 'details' | 'field' | 'id' | 'message' | 'status' | LabImportValidationResultKeySpecifier)[];
export type LabImportValidationResultFieldPolicy = {
	attempt?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	details?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LicenseNestKeySpecifier = ('authority' | 'createdAt' | 'displayName' | 'id' | 'licenseLabel' | 'licenseNumber' | 'updatedAt' | 'userId' | LicenseNestKeySpecifier)[];
export type LicenseNestFieldPolicy = {
	authority?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	licenseLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	licenseNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LogBookEntriesWithCountKeySpecifier = ('count' | 'items' | LogBookEntriesWithCountKeySpecifier)[];
export type LogBookEntriesWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LogBookEntryAttachmentsNestKeySpecifier = ('components' | 'metrics' | 'processes' | 'sites' | 'systems' | 'tags' | 'uploads' | LogBookEntryAttachmentsNestKeySpecifier)[];
export type LogBookEntryAttachmentsNestFieldPolicy = {
	components?: FieldPolicy<any> | FieldReadFunction<any>,
	metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	processes?: FieldPolicy<any> | FieldReadFunction<any>,
	sites?: FieldPolicy<any> | FieldReadFunction<any>,
	systems?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	uploads?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LogBookEntryDashboardViewNestKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'message' | 'name' | 'organizationId' | 'siteIds' | 'sortDirection' | 'sortField' | 'systemIds' | 'tagIds' | 'updatedAt' | 'userId' | 'userIds' | LogBookEntryDashboardViewNestKeySpecifier)[];
export type LogBookEntryDashboardViewNestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	siteIds?: FieldPolicy<any> | FieldReadFunction<any>,
	sortDirection?: FieldPolicy<any> | FieldReadFunction<any>,
	sortField?: FieldPolicy<any> | FieldReadFunction<any>,
	systemIds?: FieldPolicy<any> | FieldReadFunction<any>,
	tagIds?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>,
	userIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LogBookEntryNestKeySpecifier = ('attachments' | 'createdAt' | 'deletedAt' | 'id' | 'message' | 'organizationId' | 'pinned' | 'updatedAt' | 'user' | 'userId' | LogBookEntryNestKeySpecifier)[];
export type LogBookEntryNestFieldPolicy = {
	attachments?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	pinned?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManualReportEmailEligibleRecipientKeySpecifier = ('displayName' | 'email' | 'primaryOrganizationName' | 'userId' | ManualReportEmailEligibleRecipientKeySpecifier)[];
export type ManualReportEmailEligibleRecipientFieldPolicy = {
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryOrganizationName?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManualReportEmailEventKeySpecifier = ('comment' | 'createdAt' | 'id' | 'providerMessageId' | 'recipients' | 'reportSnapshotId' | 'senderEmail' | 'senderUserId' | 'sentAt' | 'shareLinkId' | 'status' | 'subject' | 'updatedAt' | ManualReportEmailEventKeySpecifier)[];
export type ManualReportEmailEventFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	providerMessageId?: FieldPolicy<any> | FieldReadFunction<any>,
	recipients?: FieldPolicy<any> | FieldReadFunction<any>,
	reportSnapshotId?: FieldPolicy<any> | FieldReadFunction<any>,
	senderEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	senderUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	sentAt?: FieldPolicy<any> | FieldReadFunction<any>,
	shareLinkId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManualReportEmailRecipientKeySpecifier = ('createdAt' | 'id' | 'normalizedEmail' | 'recipientKind' | 'recipientSource' | 'sourceDistributionListId' | 'sourceDistributionListName' | 'updatedAt' | 'userId' | ManualReportEmailRecipientKeySpecifier)[];
export type ManualReportEmailRecipientFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	normalizedEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientKind?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientSource?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceDistributionListId?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceDistributionListName?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManualReportEmailSharingScopeKeySpecifier = ('organizationId' | 'organizationName' | 'scope' | 'siteId' | 'systemId' | ManualReportEmailSharingScopeKeySpecifier)[];
export type ManualReportEmailSharingScopeFieldPolicy = {
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationName?: FieldPolicy<any> | FieldReadFunction<any>,
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricChartDataContainerTypeKeySpecifier = ('data' | 'endDate' | 'startDate' | MetricChartDataContainerTypeKeySpecifier)[];
export type MetricChartDataContainerTypeFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricChartDataPointTypeKeySpecifier = ('effectiveValue' | 'reportDate' | 'value' | MetricChartDataPointTypeKeySpecifier)[];
export type MetricChartDataPointTypeFieldPolicy = {
	effectiveValue?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricChartDataTypeKeySpecifier = ('dataPoints' | 'metricId' | MetricChartDataTypeKeySpecifier)[];
export type MetricChartDataTypeFieldPolicy = {
	dataPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricDataPointTypeKeySpecifier = ('appliedAt' | 'calculatedNondetectValue' | 'calculatedValue' | 'comment' | 'connectValue' | 'edgeDeviceSubmissionId' | 'effectiveValue' | 'error' | 'id' | 'intervalId' | 'isInterpolated' | 'isNondetect' | 'measuredAt' | 'metricId' | 'reportDate' | 'type' | 'value' | 'version' | MetricDataPointTypeKeySpecifier)[];
export type MetricDataPointTypeFieldPolicy = {
	appliedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	calculatedNondetectValue?: FieldPolicy<any> | FieldReadFunction<any>,
	calculatedValue?: FieldPolicy<any> | FieldReadFunction<any>,
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	connectValue?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDeviceSubmissionId?: FieldPolicy<any> | FieldReadFunction<any>,
	effectiveValue?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalId?: FieldPolicy<any> | FieldReadFunction<any>,
	isInterpolated?: FieldPolicy<any> | FieldReadFunction<any>,
	isNondetect?: FieldPolicy<any> | FieldReadFunction<any>,
	measuredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDate?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricKeynameKeySpecifier = ('compliance' | 'createdAt' | 'deletedAt' | 'description' | 'id' | 'name' | 'systemTypes' | 'updatedAt' | MetricKeynameKeySpecifier)[];
export type MetricKeynameFieldPolicy = {
	compliance?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	systemTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricKeynameJoinedWithCountKeySpecifier = ('count' | 'items' | MetricKeynameJoinedWithCountKeySpecifier)[];
export type MetricKeynameJoinedWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricKeynameWithUnitsAndTagsKeySpecifier = ('compliance' | 'createdAt' | 'deletedAt' | 'description' | 'id' | 'metricsCount' | 'name' | 'systemTypes' | 'tags' | 'units' | 'updatedAt' | MetricKeynameWithUnitsAndTagsKeySpecifier)[];
export type MetricKeynameWithUnitsAndTagsFieldPolicy = {
	compliance?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metricsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	systemTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricNestKeySpecifier = ('belowRlValue' | 'calcClusterId' | 'calculated' | 'calculationName' | 'canBeAveraged' | 'canBeCounted' | 'canBeMaximized' | 'canBeMinimized' | 'canBeTotaled' | 'component' | 'componentId' | 'copyPreviousValueEnabled' | 'createdAt' | 'dataPointCommentPolicy' | 'dataType' | 'debug' | 'deletedAt' | 'detectionLimit' | 'displayNameBreadcrumbs' | 'expression' | 'hideFromDataEntry' | 'id' | 'internalKeyname' | 'interpolated' | 'intervals' | 'isDecreasing' | 'isIncreasing' | 'isLockedByWaterly' | 'isReportComments' | 'isWaterlyConnected' | 'keynameId' | 'maxValue' | 'metricKeyname' | 'metricRangeType' | 'metricRanges' | 'minValue' | 'name' | 'notificationEnabled' | 'order' | 'precision' | 'process' | 'processId' | 'rangeMax' | 'rangeMin' | 'reportingLimit' | 'required' | 'treatBelowRlAsPercent' | 'unit' | 'unitId' | 'updatedAt' | 'updatesPriorDay' | MetricNestKeySpecifier)[];
export type MetricNestFieldPolicy = {
	belowRlValue?: FieldPolicy<any> | FieldReadFunction<any>,
	calcClusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	calculated?: FieldPolicy<any> | FieldReadFunction<any>,
	calculationName?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeAveraged?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeCounted?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeMaximized?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeMinimized?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeTotaled?: FieldPolicy<any> | FieldReadFunction<any>,
	component?: FieldPolicy<any> | FieldReadFunction<any>,
	componentId?: FieldPolicy<any> | FieldReadFunction<any>,
	copyPreviousValueEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dataPointCommentPolicy?: FieldPolicy<any> | FieldReadFunction<any>,
	dataType?: FieldPolicy<any> | FieldReadFunction<any>,
	debug?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	detectionLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	displayNameBreadcrumbs?: FieldPolicy<any> | FieldReadFunction<any>,
	expression?: FieldPolicy<any> | FieldReadFunction<any>,
	hideFromDataEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	interpolated?: FieldPolicy<any> | FieldReadFunction<any>,
	intervals?: FieldPolicy<any> | FieldReadFunction<any>,
	isDecreasing?: FieldPolicy<any> | FieldReadFunction<any>,
	isIncreasing?: FieldPolicy<any> | FieldReadFunction<any>,
	isLockedByWaterly?: FieldPolicy<any> | FieldReadFunction<any>,
	isReportComments?: FieldPolicy<any> | FieldReadFunction<any>,
	isWaterlyConnected?: FieldPolicy<any> | FieldReadFunction<any>,
	keynameId?: FieldPolicy<any> | FieldReadFunction<any>,
	maxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	metricKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	metricRangeType?: FieldPolicy<any> | FieldReadFunction<any>,
	metricRanges?: FieldPolicy<any> | FieldReadFunction<any>,
	minValue?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	precision?: FieldPolicy<any> | FieldReadFunction<any>,
	process?: FieldPolicy<any> | FieldReadFunction<any>,
	processId?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>,
	treatBelowRlAsPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	unitId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatesPriorDay?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricOrderWithMetricIdKeySpecifier = ('id' | 'metricId' | 'order' | MetricOrderWithMetricIdKeySpecifier)[];
export type MetricOrderWithMetricIdFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricRangeKeySpecifier = ('color' | 'createdAt' | 'deletedAt' | 'id' | 'ideal' | 'maxTag' | 'maxTagId' | 'metricId' | 'minTag' | 'minTagId' | 'name' | 'notificationEnabled' | 'rangeMax' | 'rangeMaxInclusive' | 'rangeMin' | 'rangeMinInclusive' | 'updatedAt' | MetricRangeKeySpecifier)[];
export type MetricRangeFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ideal?: FieldPolicy<any> | FieldReadFunction<any>,
	maxTag?: FieldPolicy<any> | FieldReadFunction<any>,
	maxTagId?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	minTag?: FieldPolicy<any> | FieldReadFunction<any>,
	minTagId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMaxInclusive?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMinInclusive?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricTypeKeySpecifier = ('belowRlValue' | 'calculated' | 'calculatedMetrics' | 'calculationName' | 'canBeAveraged' | 'canBeCounted' | 'canBeMaximized' | 'canBeMinimized' | 'canBeTotaled' | 'component' | 'componentId' | 'copyPreviousValueEnabled' | 'dataPointCommentPolicy' | 'dataType' | 'deletedAt' | 'detectionLimit' | 'displayName' | 'displayNameSiteLocal' | 'enabledForReport' | 'enabledIntervalForMonthlyReport' | 'expression' | 'hasIntervals' | 'hideFromDataEntry' | 'id' | 'internalKeyname' | 'interpolated' | 'intervals' | 'isDecreasing' | 'isIncreasing' | 'isLockedByWaterly' | 'isReportComments' | 'isWaterlyConnected' | 'keynameId' | 'maxValue' | 'metricRanges' | 'minValue' | 'name' | 'notificationEnabled' | 'order' | 'precision' | 'process' | 'processId' | 'rangeMax' | 'rangeMin' | 'reportingLimit' | 'required' | 'site' | 'sourceMetrics' | 'system' | 'tagMapping' | 'treatBelowRlAsPercent' | 'unit' | 'unitId' | MetricTypeKeySpecifier)[];
export type MetricTypeFieldPolicy = {
	belowRlValue?: FieldPolicy<any> | FieldReadFunction<any>,
	calculated?: FieldPolicy<any> | FieldReadFunction<any>,
	calculatedMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	calculationName?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeAveraged?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeCounted?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeMaximized?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeMinimized?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeTotaled?: FieldPolicy<any> | FieldReadFunction<any>,
	component?: FieldPolicy<any> | FieldReadFunction<any>,
	componentId?: FieldPolicy<any> | FieldReadFunction<any>,
	copyPreviousValueEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	dataPointCommentPolicy?: FieldPolicy<any> | FieldReadFunction<any>,
	dataType?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	detectionLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	displayNameSiteLocal?: FieldPolicy<any> | FieldReadFunction<any>,
	enabledForReport?: FieldPolicy<any> | FieldReadFunction<any>,
	enabledIntervalForMonthlyReport?: FieldPolicy<any> | FieldReadFunction<any>,
	expression?: FieldPolicy<any> | FieldReadFunction<any>,
	hasIntervals?: FieldPolicy<any> | FieldReadFunction<any>,
	hideFromDataEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	interpolated?: FieldPolicy<any> | FieldReadFunction<any>,
	intervals?: FieldPolicy<any> | FieldReadFunction<any>,
	isDecreasing?: FieldPolicy<any> | FieldReadFunction<any>,
	isIncreasing?: FieldPolicy<any> | FieldReadFunction<any>,
	isLockedByWaterly?: FieldPolicy<any> | FieldReadFunction<any>,
	isReportComments?: FieldPolicy<any> | FieldReadFunction<any>,
	isWaterlyConnected?: FieldPolicy<any> | FieldReadFunction<any>,
	keynameId?: FieldPolicy<any> | FieldReadFunction<any>,
	maxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	metricRanges?: FieldPolicy<any> | FieldReadFunction<any>,
	minValue?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	precision?: FieldPolicy<any> | FieldReadFunction<any>,
	process?: FieldPolicy<any> | FieldReadFunction<any>,
	processId?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	tagMapping?: FieldPolicy<any> | FieldReadFunction<any>,
	treatBelowRlAsPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	unitId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricWithCalculatedMetricKeySpecifier = ('belowRlValue' | 'calcClusterId' | 'calculated' | 'calculatedMetric' | 'calculationName' | 'canBeAveraged' | 'canBeCounted' | 'canBeMaximized' | 'canBeMinimized' | 'canBeTotaled' | 'component' | 'componentId' | 'copyPreviousValueEnabled' | 'createdAt' | 'dataPointCommentPolicy' | 'dataType' | 'debug' | 'deletedAt' | 'detectionLimit' | 'displayNameBreadcrumbs' | 'expression' | 'hideFromDataEntry' | 'id' | 'internalKeyname' | 'interpolated' | 'intervals' | 'isDecreasing' | 'isIncreasing' | 'isLockedByWaterly' | 'isReportComments' | 'isWaterlyConnected' | 'keynameId' | 'maxValue' | 'metricKeyname' | 'metricRangeType' | 'metricRanges' | 'minValue' | 'name' | 'notificationEnabled' | 'order' | 'precision' | 'process' | 'processId' | 'rangeMax' | 'rangeMin' | 'reportingLimit' | 'required' | 'treatBelowRlAsPercent' | 'unit' | 'unitId' | 'updatedAt' | 'updatesPriorDay' | MetricWithCalculatedMetricKeySpecifier)[];
export type MetricWithCalculatedMetricFieldPolicy = {
	belowRlValue?: FieldPolicy<any> | FieldReadFunction<any>,
	calcClusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	calculated?: FieldPolicy<any> | FieldReadFunction<any>,
	calculatedMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	calculationName?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeAveraged?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeCounted?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeMaximized?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeMinimized?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeTotaled?: FieldPolicy<any> | FieldReadFunction<any>,
	component?: FieldPolicy<any> | FieldReadFunction<any>,
	componentId?: FieldPolicy<any> | FieldReadFunction<any>,
	copyPreviousValueEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dataPointCommentPolicy?: FieldPolicy<any> | FieldReadFunction<any>,
	dataType?: FieldPolicy<any> | FieldReadFunction<any>,
	debug?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	detectionLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	displayNameBreadcrumbs?: FieldPolicy<any> | FieldReadFunction<any>,
	expression?: FieldPolicy<any> | FieldReadFunction<any>,
	hideFromDataEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	interpolated?: FieldPolicy<any> | FieldReadFunction<any>,
	intervals?: FieldPolicy<any> | FieldReadFunction<any>,
	isDecreasing?: FieldPolicy<any> | FieldReadFunction<any>,
	isIncreasing?: FieldPolicy<any> | FieldReadFunction<any>,
	isLockedByWaterly?: FieldPolicy<any> | FieldReadFunction<any>,
	isReportComments?: FieldPolicy<any> | FieldReadFunction<any>,
	isWaterlyConnected?: FieldPolicy<any> | FieldReadFunction<any>,
	keynameId?: FieldPolicy<any> | FieldReadFunction<any>,
	maxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	metricKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	metricRangeType?: FieldPolicy<any> | FieldReadFunction<any>,
	metricRanges?: FieldPolicy<any> | FieldReadFunction<any>,
	minValue?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	precision?: FieldPolicy<any> | FieldReadFunction<any>,
	process?: FieldPolicy<any> | FieldReadFunction<any>,
	processId?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>,
	treatBelowRlAsPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	unitId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatesPriorDay?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricWithCalculatedMetricsKeySpecifier = ('belowRlValue' | 'calcClusterId' | 'calculated' | 'calculationName' | 'canBeAveraged' | 'canBeCounted' | 'canBeMaximized' | 'canBeMinimized' | 'canBeTotaled' | 'component' | 'componentId' | 'copyPreviousValueEnabled' | 'createdAt' | 'dataPointCommentPolicy' | 'dataType' | 'debug' | 'deletedAt' | 'detectionLimit' | 'displayNameBreadcrumbs' | 'downstreamCalcCount' | 'expression' | 'hideFromDataEntry' | 'id' | 'internalKeyname' | 'interpolated' | 'intervals' | 'isDecreasing' | 'isIncreasing' | 'isLockedByWaterly' | 'isReportComments' | 'isWaterlyConnected' | 'keynameId' | 'maxValue' | 'metricKeyname' | 'metricRangeType' | 'metricRanges' | 'minValue' | 'name' | 'notificationEnabled' | 'order' | 'precision' | 'process' | 'processId' | 'rangeMax' | 'rangeMin' | 'reportingLimit' | 'required' | 'treatBelowRlAsPercent' | 'unit' | 'unitId' | 'updatedAt' | 'updatesPriorDay' | MetricWithCalculatedMetricsKeySpecifier)[];
export type MetricWithCalculatedMetricsFieldPolicy = {
	belowRlValue?: FieldPolicy<any> | FieldReadFunction<any>,
	calcClusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	calculated?: FieldPolicy<any> | FieldReadFunction<any>,
	calculationName?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeAveraged?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeCounted?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeMaximized?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeMinimized?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeTotaled?: FieldPolicy<any> | FieldReadFunction<any>,
	component?: FieldPolicy<any> | FieldReadFunction<any>,
	componentId?: FieldPolicy<any> | FieldReadFunction<any>,
	copyPreviousValueEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dataPointCommentPolicy?: FieldPolicy<any> | FieldReadFunction<any>,
	dataType?: FieldPolicy<any> | FieldReadFunction<any>,
	debug?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	detectionLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	displayNameBreadcrumbs?: FieldPolicy<any> | FieldReadFunction<any>,
	downstreamCalcCount?: FieldPolicy<any> | FieldReadFunction<any>,
	expression?: FieldPolicy<any> | FieldReadFunction<any>,
	hideFromDataEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	interpolated?: FieldPolicy<any> | FieldReadFunction<any>,
	intervals?: FieldPolicy<any> | FieldReadFunction<any>,
	isDecreasing?: FieldPolicy<any> | FieldReadFunction<any>,
	isIncreasing?: FieldPolicy<any> | FieldReadFunction<any>,
	isLockedByWaterly?: FieldPolicy<any> | FieldReadFunction<any>,
	isReportComments?: FieldPolicy<any> | FieldReadFunction<any>,
	isWaterlyConnected?: FieldPolicy<any> | FieldReadFunction<any>,
	keynameId?: FieldPolicy<any> | FieldReadFunction<any>,
	maxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	metricKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	metricRangeType?: FieldPolicy<any> | FieldReadFunction<any>,
	metricRanges?: FieldPolicy<any> | FieldReadFunction<any>,
	minValue?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	precision?: FieldPolicy<any> | FieldReadFunction<any>,
	process?: FieldPolicy<any> | FieldReadFunction<any>,
	processId?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>,
	treatBelowRlAsPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	unitId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatesPriorDay?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricWithRelatedMetricsKeySpecifier = ('belowRlValue' | 'calcClusterId' | 'calculated' | 'calculatedMetrics' | 'calculationName' | 'canBeAveraged' | 'canBeCounted' | 'canBeMaximized' | 'canBeMinimized' | 'canBeTotaled' | 'component' | 'componentId' | 'copyPreviousValueEnabled' | 'createdAt' | 'dataPointCommentPolicy' | 'dataType' | 'debug' | 'deletedAt' | 'detectionLimit' | 'displayNameBreadcrumbs' | 'expression' | 'hideFromDataEntry' | 'id' | 'internalKeyname' | 'interpolated' | 'intervals' | 'isDecreasing' | 'isIncreasing' | 'isLockedByWaterly' | 'isReportComments' | 'isWaterlyConnected' | 'keynameId' | 'maxValue' | 'metricKeyname' | 'metricRangeType' | 'metricRanges' | 'minValue' | 'name' | 'notificationEnabled' | 'order' | 'precision' | 'process' | 'processId' | 'rangeMax' | 'rangeMin' | 'reportingLimit' | 'required' | 'sourceMetrics' | 'treatBelowRlAsPercent' | 'unit' | 'unitId' | 'updatedAt' | 'updatesPriorDay' | MetricWithRelatedMetricsKeySpecifier)[];
export type MetricWithRelatedMetricsFieldPolicy = {
	belowRlValue?: FieldPolicy<any> | FieldReadFunction<any>,
	calcClusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	calculated?: FieldPolicy<any> | FieldReadFunction<any>,
	calculatedMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	calculationName?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeAveraged?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeCounted?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeMaximized?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeMinimized?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeTotaled?: FieldPolicy<any> | FieldReadFunction<any>,
	component?: FieldPolicy<any> | FieldReadFunction<any>,
	componentId?: FieldPolicy<any> | FieldReadFunction<any>,
	copyPreviousValueEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dataPointCommentPolicy?: FieldPolicy<any> | FieldReadFunction<any>,
	dataType?: FieldPolicy<any> | FieldReadFunction<any>,
	debug?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	detectionLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	displayNameBreadcrumbs?: FieldPolicy<any> | FieldReadFunction<any>,
	expression?: FieldPolicy<any> | FieldReadFunction<any>,
	hideFromDataEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	interpolated?: FieldPolicy<any> | FieldReadFunction<any>,
	intervals?: FieldPolicy<any> | FieldReadFunction<any>,
	isDecreasing?: FieldPolicy<any> | FieldReadFunction<any>,
	isIncreasing?: FieldPolicy<any> | FieldReadFunction<any>,
	isLockedByWaterly?: FieldPolicy<any> | FieldReadFunction<any>,
	isReportComments?: FieldPolicy<any> | FieldReadFunction<any>,
	isWaterlyConnected?: FieldPolicy<any> | FieldReadFunction<any>,
	keynameId?: FieldPolicy<any> | FieldReadFunction<any>,
	maxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	metricKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	metricRangeType?: FieldPolicy<any> | FieldReadFunction<any>,
	metricRanges?: FieldPolicy<any> | FieldReadFunction<any>,
	minValue?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	precision?: FieldPolicy<any> | FieldReadFunction<any>,
	process?: FieldPolicy<any> | FieldReadFunction<any>,
	processId?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	treatBelowRlAsPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	unitId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatesPriorDay?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricWithReportDataKeySpecifier = ('enabledForReport' | 'enabledIntervalId' | 'metricId' | MetricWithReportDataKeySpecifier)[];
export type MetricWithReportDataFieldPolicy = {
	enabledForReport?: FieldPolicy<any> | FieldReadFunction<any>,
	enabledIntervalId?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricWithSPCIntervalsUnitKeySpecifier = ('belowRlValue' | 'calcClusterId' | 'calculated' | 'calculationName' | 'canBeAveraged' | 'canBeCounted' | 'canBeMaximized' | 'canBeMinimized' | 'canBeTotaled' | 'component' | 'componentId' | 'copyPreviousValueEnabled' | 'createdAt' | 'dataPointCommentPolicy' | 'dataType' | 'debug' | 'deletedAt' | 'detectionLimit' | 'displayName' | 'displayNameBreadcrumbs' | 'expression' | 'hideFromDataEntry' | 'id' | 'internalKeyname' | 'interpolated' | 'intervals' | 'isDecreasing' | 'isIncreasing' | 'isLockedByWaterly' | 'isReportComments' | 'isWaterlyConnected' | 'keynameId' | 'maxValue' | 'metricKeyname' | 'metricRangeType' | 'metricRanges' | 'minValue' | 'name' | 'notificationEnabled' | 'order' | 'precision' | 'process' | 'processId' | 'rangeMax' | 'rangeMin' | 'reportingLimit' | 'required' | 'site' | 'treatBelowRlAsPercent' | 'unit' | 'unitId' | 'updatedAt' | 'updatesPriorDay' | MetricWithSPCIntervalsUnitKeySpecifier)[];
export type MetricWithSPCIntervalsUnitFieldPolicy = {
	belowRlValue?: FieldPolicy<any> | FieldReadFunction<any>,
	calcClusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	calculated?: FieldPolicy<any> | FieldReadFunction<any>,
	calculationName?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeAveraged?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeCounted?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeMaximized?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeMinimized?: FieldPolicy<any> | FieldReadFunction<any>,
	canBeTotaled?: FieldPolicy<any> | FieldReadFunction<any>,
	component?: FieldPolicy<any> | FieldReadFunction<any>,
	componentId?: FieldPolicy<any> | FieldReadFunction<any>,
	copyPreviousValueEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dataPointCommentPolicy?: FieldPolicy<any> | FieldReadFunction<any>,
	dataType?: FieldPolicy<any> | FieldReadFunction<any>,
	debug?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	detectionLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	displayNameBreadcrumbs?: FieldPolicy<any> | FieldReadFunction<any>,
	expression?: FieldPolicy<any> | FieldReadFunction<any>,
	hideFromDataEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	interpolated?: FieldPolicy<any> | FieldReadFunction<any>,
	intervals?: FieldPolicy<any> | FieldReadFunction<any>,
	isDecreasing?: FieldPolicy<any> | FieldReadFunction<any>,
	isIncreasing?: FieldPolicy<any> | FieldReadFunction<any>,
	isLockedByWaterly?: FieldPolicy<any> | FieldReadFunction<any>,
	isReportComments?: FieldPolicy<any> | FieldReadFunction<any>,
	isWaterlyConnected?: FieldPolicy<any> | FieldReadFunction<any>,
	keynameId?: FieldPolicy<any> | FieldReadFunction<any>,
	maxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	metricKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	metricRangeType?: FieldPolicy<any> | FieldReadFunction<any>,
	metricRanges?: FieldPolicy<any> | FieldReadFunction<any>,
	minValue?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	precision?: FieldPolicy<any> | FieldReadFunction<any>,
	process?: FieldPolicy<any> | FieldReadFunction<any>,
	processId?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>,
	treatBelowRlAsPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	unitId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatesPriorDay?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MigrateSiteDataToTimeSeriesResultKeySpecifier = ('id' | 'success' | MigrateSiteDataToTimeSeriesResultKeySpecifier)[];
export type MigrateSiteDataToTimeSeriesResultFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MintedApiTokenCredentialsNestKeySpecifier = ('realm' | 'secret' | 'username' | MintedApiTokenCredentialsNestKeySpecifier)[];
export type MintedApiTokenCredentialsNestFieldPolicy = {
	realm?: FieldPolicy<any> | FieldReadFunction<any>,
	secret?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('addActivitySchedule' | 'addEdgeDevice' | 'addLicense' | 'addNewReportDefinition' | 'addPhoneNumber' | 'addSSOUserToSystemGroup' | 'addSampleSiteUpload' | 'addScheduledItemUpload' | 'addSite' | 'addSiteFlexMetricsToFolder' | 'addSsoUserToSystem' | 'addSystemFavorite' | 'addSystemGroup' | 'addTagMapping' | 'addTrend' | 'addUserToSystem' | 'addUserToSystemGroup' | 'archiveBySampleSiteId' | 'archiveByScheduledItemId' | 'archiveConstantDefinition' | 'archiveConstantValue' | 'archiveLabImportBatch' | 'archiveLabImportProfile' | 'archiveReportDistributionList' | 'archiveReportingReportGroup' | 'archiveSampleCollectionComment' | 'archiveSampleSchedule' | 'archiveScheduledItemComment' | 'archiveScheduledItems' | 'archiveUpload' | 'archiveWeatherDataStation' | 'cancelActivitySchedule' | 'cancelSampleSchedule' | 'clearRuntimeLoggerOverride' | 'clearSSOCache' | 'cloneComponents' | 'cloneMetrics' | 'cloneProcesses' | 'cloneSites' | 'cloneSystem' | 'cloneSystemWithSelectedDescendants' | 'cloneToTarget' | 'commitDirtyDataPoints' | 'commitLabImportBatch' | 'convertToFlexReport' | 'createAddress' | 'createAnalyteGroup' | 'createApiToken' | 'createCalcClusterDebugByClusterId' | 'createColumnGroup' | 'createColumnGroupItems' | 'createColumnGroupsAndItems' | 'createComponent' | 'createConstantDefinition' | 'createEnterpriseReportShareLink' | 'createEntryIntervals' | 'createFlexFormFromSystem' | 'createFolder' | 'createInterval' | 'createIntervals' | 'createLabImportBatch' | 'createLogBookEntry' | 'createLogBookEntryDashboardView' | 'createMetric' | 'createMetricKeyname' | 'createNotification' | 'createOrganizationIntegration' | 'createPermit' | 'createPhrase' | 'createProcess' | 'createReportDistributionList' | 'createReportingReportGroup' | 'createRoundsShiftNote' | 'createSampleCollection' | 'createSampleCollectionComment' | 'createSampleCollectionCustody' | 'createSampleSchedule' | 'createSampleSite' | 'createScheduledItemComment' | 'createSystem' | 'createTag' | 'createUnit' | 'createUpload' | 'createWeatherDataStation' | 'deleteActivitySchedule' | 'deleteColumnGroupItem' | 'deleteComponent' | 'deleteFolder' | 'deleteInterval' | 'deleteLicense' | 'deleteLogBookEntry' | 'deleteLogBookEntryDashboardView' | 'deleteMetric' | 'deleteMetricKeyname' | 'deleteMetricRange' | 'deleteNotification' | 'deleteOrganizationIntegration' | 'deletePermit' | 'deletePhoneNumber' | 'deletePhrase' | 'deleteProcess' | 'deleteReportDefinitionById' | 'deleteReportNodes' | 'deleteSite' | 'deleteSiteFlexMetric' | 'deleteSystem' | 'deleteSystemFavorite' | 'deleteSystemGroup' | 'deleteTag' | 'deleteTagMapping' | 'deleteTrend' | 'deleteUnit' | 'deleteUserFromSystem' | 'disableEnterpriseReportShareLink' | 'initSSOUser' | 'migrateSiteDataToTimeSeries' | 'recalculateMetric' | 'reconcileLabImportBatch' | 'removeUserFromSystemGroup' | 'replayWaterlyConnectSubmission' | 'requestEnterpriseReportShareLinkAccess' | 'requestId' | 'resolveLabImportReconciliation' | 'restoreComponent' | 'restoreConstantDefinition' | 'restoreConstantValue' | 'restoreFolder' | 'restoreMetric' | 'restoreProcess' | 'restoreSite' | 'restoreSiteFlexMetric' | 'restoreWeatherDataStation' | 'revokeApiToken' | 'sendEmailVerification' | 'sendManualReportEmail' | 'setRuntimeLoggerOverride' | 'snoozeAllOrgRetentionRisks' | 'snoozeRetentionRisk' | 'startMirroring' | 'stopMirroring' | 'submitConstantRecalculation' | 'submitSiteRecalculation' | 'transferComponent' | 'transferMetric' | 'transferMetricToFolder' | 'transferSystem' | 'triggerAnalyticsReportSnapshot' | 'triggerMetricRangeEmails' | 'updateActivitySchedule' | 'updateAddress' | 'updateAnalyteGroup' | 'updateCalcClusterDebug' | 'updateColumnGroup' | 'updateColumnGroupItem' | 'updateComponents' | 'updateConstantDefinition' | 'updateEdgeDevice' | 'updateEnterpriseReportShareLink' | 'updateFolder' | 'updateFolders' | 'updateLicense' | 'updateLogBookEntry' | 'updateLogBookEntryDashboardView' | 'updateMetric' | 'updateMetricForReport' | 'updateMetricKeyname' | 'updateMetrics' | 'updateNotification' | 'updateOrganization' | 'updateOrganizationIntegration' | 'updatePermit' | 'updatePhoneNumber' | 'updatePhrase' | 'updateProcessForReport' | 'updateProcesses' | 'updateReportDefinition' | 'updateReportDistributionList' | 'updateReportNodes' | 'updateReportingReportDefinitionGroups' | 'updateReportingReportGroup' | 'updateSampleCollection' | 'updateSampleCollectionComment' | 'updateSampleSchedule' | 'updateSampleSite' | 'updateScheduleItemsBySourceScheduleId' | 'updateScheduledItem' | 'updateScheduledItemComment' | 'updateSite' | 'updateSiteFlexMetric' | 'updateSiteFlexMetrics' | 'updateSiteStructure' | 'updateSites' | 'updateSystem' | 'updateSystemGroup' | 'updateTag' | 'updateTrend' | 'updateUnit' | 'updateUpload' | 'updateUser' | 'updateUserByToken' | 'updateUserRoleForSystem' | 'updateUserRoleForSystemGroup' | 'updateWeatherDataStation' | 'updatedRetentionRiskForOrgs' | 'upsertConstantValue' | 'upsertDataEntryCompletion' | 'upsertMetricRanges' | 'validateLabImportBatch' | 'validateLabImportProfile' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	addActivitySchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	addEdgeDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	addLicense?: FieldPolicy<any> | FieldReadFunction<any>,
	addNewReportDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	addPhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	addSSOUserToSystemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	addSampleSiteUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	addScheduledItemUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	addSite?: FieldPolicy<any> | FieldReadFunction<any>,
	addSiteFlexMetricsToFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	addSsoUserToSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	addSystemFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	addSystemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	addTagMapping?: FieldPolicy<any> | FieldReadFunction<any>,
	addTrend?: FieldPolicy<any> | FieldReadFunction<any>,
	addUserToSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	addUserToSystemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveBySampleSiteId?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveByScheduledItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveConstantDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveConstantValue?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveLabImportBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveLabImportProfile?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveReportDistributionList?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveReportingReportGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveSampleCollectionComment?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveSampleSchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveScheduledItemComment?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveScheduledItems?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveWeatherDataStation?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelActivitySchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelSampleSchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	clearRuntimeLoggerOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	clearSSOCache?: FieldPolicy<any> | FieldReadFunction<any>,
	cloneComponents?: FieldPolicy<any> | FieldReadFunction<any>,
	cloneMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	cloneProcesses?: FieldPolicy<any> | FieldReadFunction<any>,
	cloneSites?: FieldPolicy<any> | FieldReadFunction<any>,
	cloneSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	cloneSystemWithSelectedDescendants?: FieldPolicy<any> | FieldReadFunction<any>,
	cloneToTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	commitDirtyDataPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	commitLabImportBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	convertToFlexReport?: FieldPolicy<any> | FieldReadFunction<any>,
	createAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	createAnalyteGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	createApiToken?: FieldPolicy<any> | FieldReadFunction<any>,
	createCalcClusterDebugByClusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	createColumnGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	createColumnGroupItems?: FieldPolicy<any> | FieldReadFunction<any>,
	createColumnGroupsAndItems?: FieldPolicy<any> | FieldReadFunction<any>,
	createComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	createConstantDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	createEnterpriseReportShareLink?: FieldPolicy<any> | FieldReadFunction<any>,
	createEntryIntervals?: FieldPolicy<any> | FieldReadFunction<any>,
	createFlexFormFromSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	createFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	createInterval?: FieldPolicy<any> | FieldReadFunction<any>,
	createIntervals?: FieldPolicy<any> | FieldReadFunction<any>,
	createLabImportBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	createLogBookEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	createLogBookEntryDashboardView?: FieldPolicy<any> | FieldReadFunction<any>,
	createMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	createMetricKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	createNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	createOrganizationIntegration?: FieldPolicy<any> | FieldReadFunction<any>,
	createPermit?: FieldPolicy<any> | FieldReadFunction<any>,
	createPhrase?: FieldPolicy<any> | FieldReadFunction<any>,
	createProcess?: FieldPolicy<any> | FieldReadFunction<any>,
	createReportDistributionList?: FieldPolicy<any> | FieldReadFunction<any>,
	createReportingReportGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	createRoundsShiftNote?: FieldPolicy<any> | FieldReadFunction<any>,
	createSampleCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	createSampleCollectionComment?: FieldPolicy<any> | FieldReadFunction<any>,
	createSampleCollectionCustody?: FieldPolicy<any> | FieldReadFunction<any>,
	createSampleSchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	createSampleSite?: FieldPolicy<any> | FieldReadFunction<any>,
	createScheduledItemComment?: FieldPolicy<any> | FieldReadFunction<any>,
	createSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	createTag?: FieldPolicy<any> | FieldReadFunction<any>,
	createUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	createWeatherDataStation?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteActivitySchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteColumnGroupItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteInterval?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLicense?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLogBookEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLogBookEntryDashboardView?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMetricKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMetricRange?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteOrganizationIntegration?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePermit?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePhrase?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteProcess?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteReportDefinitionById?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteReportNodes?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSite?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSiteFlexMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSystemFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSystemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTag?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTagMapping?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTrend?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUserFromSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	disableEnterpriseReportShareLink?: FieldPolicy<any> | FieldReadFunction<any>,
	initSSOUser?: FieldPolicy<any> | FieldReadFunction<any>,
	migrateSiteDataToTimeSeries?: FieldPolicy<any> | FieldReadFunction<any>,
	recalculateMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	reconcileLabImportBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	removeUserFromSystemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	replayWaterlyConnectSubmission?: FieldPolicy<any> | FieldReadFunction<any>,
	requestEnterpriseReportShareLinkAccess?: FieldPolicy<any> | FieldReadFunction<any>,
	requestId?: FieldPolicy<any> | FieldReadFunction<any>,
	resolveLabImportReconciliation?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreConstantDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreConstantValue?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreProcess?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreSite?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreSiteFlexMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreWeatherDataStation?: FieldPolicy<any> | FieldReadFunction<any>,
	revokeApiToken?: FieldPolicy<any> | FieldReadFunction<any>,
	sendEmailVerification?: FieldPolicy<any> | FieldReadFunction<any>,
	sendManualReportEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	setRuntimeLoggerOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	snoozeAllOrgRetentionRisks?: FieldPolicy<any> | FieldReadFunction<any>,
	snoozeRetentionRisk?: FieldPolicy<any> | FieldReadFunction<any>,
	startMirroring?: FieldPolicy<any> | FieldReadFunction<any>,
	stopMirroring?: FieldPolicy<any> | FieldReadFunction<any>,
	submitConstantRecalculation?: FieldPolicy<any> | FieldReadFunction<any>,
	submitSiteRecalculation?: FieldPolicy<any> | FieldReadFunction<any>,
	transferComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	transferMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	transferMetricToFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	transferSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	triggerAnalyticsReportSnapshot?: FieldPolicy<any> | FieldReadFunction<any>,
	triggerMetricRangeEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	updateActivitySchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAnalyteGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCalcClusterDebug?: FieldPolicy<any> | FieldReadFunction<any>,
	updateColumnGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	updateColumnGroupItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateComponents?: FieldPolicy<any> | FieldReadFunction<any>,
	updateConstantDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEdgeDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEnterpriseReportShareLink?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFolders?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLicense?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLogBookEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLogBookEntryDashboardView?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMetricForReport?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMetricKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	updateNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	updateOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	updateOrganizationIntegration?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePermit?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePhrase?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProcessForReport?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProcesses?: FieldPolicy<any> | FieldReadFunction<any>,
	updateReportDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	updateReportDistributionList?: FieldPolicy<any> | FieldReadFunction<any>,
	updateReportNodes?: FieldPolicy<any> | FieldReadFunction<any>,
	updateReportingReportDefinitionGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	updateReportingReportGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSampleCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSampleCollectionComment?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSampleSchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSampleSite?: FieldPolicy<any> | FieldReadFunction<any>,
	updateScheduleItemsBySourceScheduleId?: FieldPolicy<any> | FieldReadFunction<any>,
	updateScheduledItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateScheduledItemComment?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSite?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSiteFlexMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSiteFlexMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSiteStructure?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSites?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSystemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTag?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTrend?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserByToken?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserRoleForSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserRoleForSystemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	updateWeatherDataStation?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedRetentionRiskForOrgs?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertConstantValue?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertDataEntryCompletion?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertMetricRanges?: FieldPolicy<any> | FieldReadFunction<any>,
	validateLabImportBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	validateLabImportProfile?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationKeySpecifier = ('active' | 'appearance' | 'createdAt' | 'deletedAt' | 'dismissable' | 'displayPosition' | 'endDate' | 'icon' | 'id' | 'message' | 'name' | 'organizationId' | 'startDate' | 'systemGroupId' | 'systemId' | 'title' | 'updatedAt' | NotificationKeySpecifier)[];
export type NotificationFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	appearance?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dismissable?: FieldPolicy<any> | FieldReadFunction<any>,
	displayPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	systemGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationsWithCountKeySpecifier = ('count' | 'items' | NotificationsWithCountKeySpecifier)[];
export type NotificationsWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationIntegrationNestKeySpecifier = ('createdAt' | 'credentialsSecretReference' | 'id' | 'integrationType' | 'organizationId' | 'tokenExpiresAt' | 'tokenId' | 'updatedAt' | OrganizationIntegrationNestKeySpecifier)[];
export type OrganizationIntegrationNestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	credentialsSecretReference?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	integrationType?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenExpiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationNestKeySpecifier = ('addresses' | 'dateFormat' | 'fiscalYearStartDate' | 'id' | 'idpKey' | 'isExternalSystemSearchEnabled' | 'name' | 'selfServiceEnabled' | OrganizationNestKeySpecifier)[];
export type OrganizationNestFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	dateFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	fiscalYearStartDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idpKey?: FieldPolicy<any> | FieldReadFunction<any>,
	isExternalSystemSearchEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	selfServiceEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationTypeKeySpecifier = ('addresses' | 'dateFormat' | 'fiscalYearStartDate' | 'id' | 'idpKey' | 'isExternalSystemSearchEnabled' | 'isUserDirectoryEnabled' | 'name' | 'selfServiceEnabled' | 'systemGroups' | 'systems' | 'users' | OrganizationTypeKeySpecifier)[];
export type OrganizationTypeFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	dateFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	fiscalYearStartDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idpKey?: FieldPolicy<any> | FieldReadFunction<any>,
	isExternalSystemSearchEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isUserDirectoryEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	selfServiceEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	systemGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	systems?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PermitKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'isPublicWaterSystemId' | 'name' | 'permitCode' | 'systemId' | 'updatedAt' | PermitKeySpecifier)[];
export type PermitFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublicWaterSystemId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	permitCode?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhoneNumberNestKeySpecifier = ('country' | 'createdAt' | 'id' | 'phoneNumber' | 'updatedAt' | 'userId' | PhoneNumberNestKeySpecifier)[];
export type PhoneNumberNestFieldPolicy = {
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhraseKeySpecifier = ('bodyText' | 'createdAt' | 'deletedAt' | 'id' | 'name' | 'organizationId' | 'updatedAt' | 'userId' | PhraseKeySpecifier)[];
export type PhraseFieldPolicy = {
	bodyText?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProcessNestKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'internalKeyname' | 'name' | 'order' | 'siteId' | 'updatedAt' | ProcessNestKeySpecifier)[];
export type ProcessNestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProcessTypeKeySpecifier = ('components' | 'deletedAt' | 'displayName' | 'enabledForReport' | 'id' | 'internalKeyname' | 'metrics' | 'name' | 'order' | 'site' | 'siteId' | 'system' | ProcessTypeKeySpecifier)[];
export type ProcessTypeFieldPolicy = {
	components?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	enabledForReport?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProcessWithComponentsAndMetricsKeySpecifier = ('components' | 'createdAt' | 'deletedAt' | 'id' | 'internalKeyname' | 'metrics' | 'name' | 'order' | 'siteId' | 'updatedAt' | ProcessWithComponentsAndMetricsKeySpecifier)[];
export type ProcessWithComponentsAndMetricsFieldPolicy = {
	components?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalKeyname?: FieldPolicy<any> | FieldReadFunction<any>,
	metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProcessWithReportDataKeySpecifier = ('enabledForReport' | 'processId' | ProcessWithReportDataKeySpecifier)[];
export type ProcessWithReportDataFieldPolicy = {
	enabledForReport?: FieldPolicy<any> | FieldReadFunction<any>,
	processId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('SampleScheduleAnalytes' | '_usersByOrganizationId' | 'activeMetricStats' | 'activeUserStats' | 'address' | 'adjacentEntryInterval' | 'adminStats' | 'allEdgeDevices' | 'allSites' | 'analyteGroupById' | 'analyteGroups' | 'analytes' | 'apiTokens' | 'apiTokensByOrganization' | 'auditEventSiteCreated' | 'auditEvents' | 'auditEventsByItemTypeAndItemId' | 'auditEventsByMetricId' | 'auditEventsByScheduledItemId' | 'bulkMetricEditorFilterOptions' | 'bulkMetricEditorMetrics' | 'calcClusterDebugByClusterId' | 'calcClusterDebugLogs' | 'calcClusterDebugs' | 'columnGroupById' | 'columnGroupItemById' | 'columnGroups' | 'columnGroupsWithItems' | 'component' | 'componentById' | 'components' | 'constantDefinitions' | 'constantRecalculationEstimate' | 'constantsForOrganization' | 'constantsForSystem' | 'dataEntryCompletionsByReportDate' | 'diagnostics' | 'edgeDeviceToken' | 'edgeDevicesByOrganizationId' | 'edgeDevicesV2' | 'eligibleManualReportEmailRecipients' | 'enterpriseReportById' | 'enterpriseReportShareLink' | 'enterpriseReports' | 'entryIntervalsByDateRange' | 'entryIntervalsBySiteId' | 'entrySparklineData' | 'estimateSiteRecalculation' | 'exportBulkMetricEditorMetricsCsv' | 'exportLogBookEntriesCsv' | 'exportUserManagerUsersCsv' | 'externalFacilities' | 'externalSystems' | 'findAllUploads' | 'findEdgeDeviceSubmissions' | 'findRecentEdgeDeviceSubmissions' | 'findUploadById' | 'findUserByToken' | 'flexSitesAssociatedWithMetricId' | 'generateUploadParameters' | 'getActivityScheduleById' | 'getActivitySchedules' | 'getCalcTree' | 'getCalcTreesWithCycles' | 'getDataPointsForDay' | 'getEdgeDeviceSubmissionData' | 'getEdgeDeviceV2' | 'getEmptyBaseSchedule' | 'getNextNewUnitId' | 'getSSOConfigurationByIDP' | 'getScheduledItemById' | 'getScheduledItems' | 'hasLinkedServiceReportEnterpriseReport' | 'intervalById' | 'intervals' | 'labImportBatch' | 'labImportBatchResume' | 'labImportBatches' | 'labImportFileDownload' | 'labImportProfiles' | 'labImportRows' | 'labImportSourceGroups' | 'labImportTargets' | 'latestServiceReportSnapshotBySiteAndReportDate' | 'license' | 'licenses' | 'logBookEntries' | 'logBookEntriesWithCount' | 'logBookEntryById' | 'logBookEntryDashboardViewByUserId' | 'manualReportEmailSharingScope' | 'me' | 'metric' | 'metricById' | 'metricChartData' | 'metricKeynamesWithCount' | 'metricRangesByMetricId' | 'metricsBySiteProcessComponent' | 'metricsBySystemIds' | 'metricsWithDownstreamCalcCounts' | 'notifications' | 'organization' | 'organizationIntegrations' | 'organizations' | 'organizationsWithSystemGroupsAndSystems' | 'permitById' | 'permits' | 'phoneNumbers' | 'phrases' | 'ping' | 'process' | 'processById' | 'processes' | 'recentEntryIntervalsBySiteId' | 'regulatoryReportDefinitionsForGrouping' | 'reportData' | 'reportDataForSite' | 'reportDefinition' | 'reportDefinitionDiscoveryFilterCounts' | 'reportDefinitionsForDiscovery' | 'reportDistributionList' | 'reportDistributionLists' | 'reportNodesTree' | 'reportSnapshotById' | 'reportSnapshotsWithCount' | 'reportTemplates' | 'requestId' | 'retentionRisks' | 'retentionRisksByOrganizationId' | 'roundsAssetsMappingsByEntities' | 'roundsShiftNoteFormContext' | 'runtimeLoggers' | 'sampleCollectionById' | 'sampleCollectionComments' | 'sampleCollectionCustodies' | 'sampleCollections' | 'sampleScheduleById' | 'sampleSchedules' | 'sampleSiteById' | 'sampleSites' | 'scheduledItemComments' | 'scheduledItemCount' | 'site' | 'siteDataEntryCompletionByDate' | 'siteFlexMetricById' | 'siteFlexMetrics' | 'siteV2' | 'sitesV2' | 'sourceMetricsBySystemId' | 'ssoOrgUsersForSystem' | 'ssoUsersForOrganization' | 'system' | 'systemGroup' | 'systemGroups' | 'systemV2' | 'systemWithDeepSites' | 'systems' | 'systemsV2' | 'tagMappings' | 'tags' | 'templateSystems' | 'transactionInfoWithCalcClusterDebugLogs' | 'trends' | 'unitById' | 'unitNests' | 'units' | 'user' | 'userManagerUser' | 'userManagerUsers' | 'users' | 'waterlyConnectErrorStats' | 'waterlyConnectStats' | 'waterlyConnectSubmissionHistory' | 'weatherDataStations' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	SampleScheduleAnalytes?: FieldPolicy<any> | FieldReadFunction<any>,
	_usersByOrganizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	activeMetricStats?: FieldPolicy<any> | FieldReadFunction<any>,
	activeUserStats?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	adjacentEntryInterval?: FieldPolicy<any> | FieldReadFunction<any>,
	adminStats?: FieldPolicy<any> | FieldReadFunction<any>,
	allEdgeDevices?: FieldPolicy<any> | FieldReadFunction<any>,
	allSites?: FieldPolicy<any> | FieldReadFunction<any>,
	analyteGroupById?: FieldPolicy<any> | FieldReadFunction<any>,
	analyteGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	analytes?: FieldPolicy<any> | FieldReadFunction<any>,
	apiTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	apiTokensByOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	auditEventSiteCreated?: FieldPolicy<any> | FieldReadFunction<any>,
	auditEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	auditEventsByItemTypeAndItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	auditEventsByMetricId?: FieldPolicy<any> | FieldReadFunction<any>,
	auditEventsByScheduledItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	bulkMetricEditorFilterOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	bulkMetricEditorMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	calcClusterDebugByClusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	calcClusterDebugLogs?: FieldPolicy<any> | FieldReadFunction<any>,
	calcClusterDebugs?: FieldPolicy<any> | FieldReadFunction<any>,
	columnGroupById?: FieldPolicy<any> | FieldReadFunction<any>,
	columnGroupItemById?: FieldPolicy<any> | FieldReadFunction<any>,
	columnGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	columnGroupsWithItems?: FieldPolicy<any> | FieldReadFunction<any>,
	component?: FieldPolicy<any> | FieldReadFunction<any>,
	componentById?: FieldPolicy<any> | FieldReadFunction<any>,
	components?: FieldPolicy<any> | FieldReadFunction<any>,
	constantDefinitions?: FieldPolicy<any> | FieldReadFunction<any>,
	constantRecalculationEstimate?: FieldPolicy<any> | FieldReadFunction<any>,
	constantsForOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	constantsForSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	dataEntryCompletionsByReportDate?: FieldPolicy<any> | FieldReadFunction<any>,
	diagnostics?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDeviceToken?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDevicesByOrganizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDevicesV2?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibleManualReportEmailRecipients?: FieldPolicy<any> | FieldReadFunction<any>,
	enterpriseReportById?: FieldPolicy<any> | FieldReadFunction<any>,
	enterpriseReportShareLink?: FieldPolicy<any> | FieldReadFunction<any>,
	enterpriseReports?: FieldPolicy<any> | FieldReadFunction<any>,
	entryIntervalsByDateRange?: FieldPolicy<any> | FieldReadFunction<any>,
	entryIntervalsBySiteId?: FieldPolicy<any> | FieldReadFunction<any>,
	entrySparklineData?: FieldPolicy<any> | FieldReadFunction<any>,
	estimateSiteRecalculation?: FieldPolicy<any> | FieldReadFunction<any>,
	exportBulkMetricEditorMetricsCsv?: FieldPolicy<any> | FieldReadFunction<any>,
	exportLogBookEntriesCsv?: FieldPolicy<any> | FieldReadFunction<any>,
	exportUserManagerUsersCsv?: FieldPolicy<any> | FieldReadFunction<any>,
	externalFacilities?: FieldPolicy<any> | FieldReadFunction<any>,
	externalSystems?: FieldPolicy<any> | FieldReadFunction<any>,
	findAllUploads?: FieldPolicy<any> | FieldReadFunction<any>,
	findEdgeDeviceSubmissions?: FieldPolicy<any> | FieldReadFunction<any>,
	findRecentEdgeDeviceSubmissions?: FieldPolicy<any> | FieldReadFunction<any>,
	findUploadById?: FieldPolicy<any> | FieldReadFunction<any>,
	findUserByToken?: FieldPolicy<any> | FieldReadFunction<any>,
	flexSitesAssociatedWithMetricId?: FieldPolicy<any> | FieldReadFunction<any>,
	generateUploadParameters?: FieldPolicy<any> | FieldReadFunction<any>,
	getActivityScheduleById?: FieldPolicy<any> | FieldReadFunction<any>,
	getActivitySchedules?: FieldPolicy<any> | FieldReadFunction<any>,
	getCalcTree?: FieldPolicy<any> | FieldReadFunction<any>,
	getCalcTreesWithCycles?: FieldPolicy<any> | FieldReadFunction<any>,
	getDataPointsForDay?: FieldPolicy<any> | FieldReadFunction<any>,
	getEdgeDeviceSubmissionData?: FieldPolicy<any> | FieldReadFunction<any>,
	getEdgeDeviceV2?: FieldPolicy<any> | FieldReadFunction<any>,
	getEmptyBaseSchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	getNextNewUnitId?: FieldPolicy<any> | FieldReadFunction<any>,
	getSSOConfigurationByIDP?: FieldPolicy<any> | FieldReadFunction<any>,
	getScheduledItemById?: FieldPolicy<any> | FieldReadFunction<any>,
	getScheduledItems?: FieldPolicy<any> | FieldReadFunction<any>,
	hasLinkedServiceReportEnterpriseReport?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalById?: FieldPolicy<any> | FieldReadFunction<any>,
	intervals?: FieldPolicy<any> | FieldReadFunction<any>,
	labImportBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	labImportBatchResume?: FieldPolicy<any> | FieldReadFunction<any>,
	labImportBatches?: FieldPolicy<any> | FieldReadFunction<any>,
	labImportFileDownload?: FieldPolicy<any> | FieldReadFunction<any>,
	labImportProfiles?: FieldPolicy<any> | FieldReadFunction<any>,
	labImportRows?: FieldPolicy<any> | FieldReadFunction<any>,
	labImportSourceGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	labImportTargets?: FieldPolicy<any> | FieldReadFunction<any>,
	latestServiceReportSnapshotBySiteAndReportDate?: FieldPolicy<any> | FieldReadFunction<any>,
	license?: FieldPolicy<any> | FieldReadFunction<any>,
	licenses?: FieldPolicy<any> | FieldReadFunction<any>,
	logBookEntries?: FieldPolicy<any> | FieldReadFunction<any>,
	logBookEntriesWithCount?: FieldPolicy<any> | FieldReadFunction<any>,
	logBookEntryById?: FieldPolicy<any> | FieldReadFunction<any>,
	logBookEntryDashboardViewByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	manualReportEmailSharingScope?: FieldPolicy<any> | FieldReadFunction<any>,
	me?: FieldPolicy<any> | FieldReadFunction<any>,
	metric?: FieldPolicy<any> | FieldReadFunction<any>,
	metricById?: FieldPolicy<any> | FieldReadFunction<any>,
	metricChartData?: FieldPolicy<any> | FieldReadFunction<any>,
	metricKeynamesWithCount?: FieldPolicy<any> | FieldReadFunction<any>,
	metricRangesByMetricId?: FieldPolicy<any> | FieldReadFunction<any>,
	metricsBySiteProcessComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	metricsBySystemIds?: FieldPolicy<any> | FieldReadFunction<any>,
	metricsWithDownstreamCalcCounts?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationIntegrations?: FieldPolicy<any> | FieldReadFunction<any>,
	organizations?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationsWithSystemGroupsAndSystems?: FieldPolicy<any> | FieldReadFunction<any>,
	permitById?: FieldPolicy<any> | FieldReadFunction<any>,
	permits?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumbers?: FieldPolicy<any> | FieldReadFunction<any>,
	phrases?: FieldPolicy<any> | FieldReadFunction<any>,
	ping?: FieldPolicy<any> | FieldReadFunction<any>,
	process?: FieldPolicy<any> | FieldReadFunction<any>,
	processById?: FieldPolicy<any> | FieldReadFunction<any>,
	processes?: FieldPolicy<any> | FieldReadFunction<any>,
	recentEntryIntervalsBySiteId?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryReportDefinitionsForGrouping?: FieldPolicy<any> | FieldReadFunction<any>,
	reportData?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDataForSite?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDefinitionDiscoveryFilterCounts?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDefinitionsForDiscovery?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDistributionList?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDistributionLists?: FieldPolicy<any> | FieldReadFunction<any>,
	reportNodesTree?: FieldPolicy<any> | FieldReadFunction<any>,
	reportSnapshotById?: FieldPolicy<any> | FieldReadFunction<any>,
	reportSnapshotsWithCount?: FieldPolicy<any> | FieldReadFunction<any>,
	reportTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	requestId?: FieldPolicy<any> | FieldReadFunction<any>,
	retentionRisks?: FieldPolicy<any> | FieldReadFunction<any>,
	retentionRisksByOrganizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	roundsAssetsMappingsByEntities?: FieldPolicy<any> | FieldReadFunction<any>,
	roundsShiftNoteFormContext?: FieldPolicy<any> | FieldReadFunction<any>,
	runtimeLoggers?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleCollectionById?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleCollectionComments?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleCollectionCustodies?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleScheduleById?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleSchedules?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleSiteById?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleSites?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledItemComments?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledItemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>,
	siteDataEntryCompletionByDate?: FieldPolicy<any> | FieldReadFunction<any>,
	siteFlexMetricById?: FieldPolicy<any> | FieldReadFunction<any>,
	siteFlexMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	siteV2?: FieldPolicy<any> | FieldReadFunction<any>,
	sitesV2?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMetricsBySystemId?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoOrgUsersForSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoUsersForOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	systemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	systemGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	systemV2?: FieldPolicy<any> | FieldReadFunction<any>,
	systemWithDeepSites?: FieldPolicy<any> | FieldReadFunction<any>,
	systems?: FieldPolicy<any> | FieldReadFunction<any>,
	systemsV2?: FieldPolicy<any> | FieldReadFunction<any>,
	tagMappings?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	templateSystems?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionInfoWithCalcClusterDebugLogs?: FieldPolicy<any> | FieldReadFunction<any>,
	trends?: FieldPolicy<any> | FieldReadFunction<any>,
	unitById?: FieldPolicy<any> | FieldReadFunction<any>,
	unitNests?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userManagerUser?: FieldPolicy<any> | FieldReadFunction<any>,
	userManagerUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	waterlyConnectErrorStats?: FieldPolicy<any> | FieldReadFunction<any>,
	waterlyConnectStats?: FieldPolicy<any> | FieldReadFunction<any>,
	waterlyConnectSubmissionHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	weatherDataStations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueueStatsKeySpecifier = ('completedInLastHour' | 'completedPerMinute' | 'failedInLastHour' | 'failedPerMinute' | 'generatedAt' | 'groupsCount' | 'groupsCountByStatus' | 'queue' | 'workersCount' | QueueStatsKeySpecifier)[];
export type QueueStatsFieldPolicy = {
	completedInLastHour?: FieldPolicy<any> | FieldReadFunction<any>,
	completedPerMinute?: FieldPolicy<any> | FieldReadFunction<any>,
	failedInLastHour?: FieldPolicy<any> | FieldReadFunction<any>,
	failedPerMinute?: FieldPolicy<any> | FieldReadFunction<any>,
	generatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	groupsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	groupsCountByStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	queue?: FieldPolicy<any> | FieldReadFunction<any>,
	workersCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueuedRecalculationKeySpecifier = ('canRunForwardCalculations' | 'edgeDeviceSubmissionId' | 'intervalId' | 'metricId' | 'queuedAt' | 'reportDate' | 'senderEmail' | 'stackDepth' | 'subscriptionClientId' | 'type' | QueuedRecalculationKeySpecifier)[];
export type QueuedRecalculationFieldPolicy = {
	canRunForwardCalculations?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDeviceSubmissionId?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalId?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	queuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDate?: FieldPolicy<any> | FieldReadFunction<any>,
	senderEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	stackDepth?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionClientId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RecalculatedMetricDataKeySpecifier = ('metricId' | 'metricName' | 'recalculationCount' | RecalculatedMetricDataKeySpecifier)[];
export type RecalculatedMetricDataFieldPolicy = {
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	metricName?: FieldPolicy<any> | FieldReadFunction<any>,
	recalculationCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RecalculatedMetricsEstimateKeySpecifier = ('metrics' | 'totalRecalculationCount' | RecalculatedMetricsEstimateKeySpecifier)[];
export type RecalculatedMetricsEstimateFieldPolicy = {
	metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRecalculationCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RecalculatedMetricsResultKeySpecifier = ('recalculationCount' | RecalculatedMetricsResultKeySpecifier)[];
export type RecalculatedMetricsResultFieldPolicy = {
	recalculationCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegulatoryReportDefinitionForGroupingNestKeySpecifier = ('id' | 'name' | 'order' | 'outputTypes' | 'reportGroup' | 'reportGroupId' | 'reportType' | 'site' | 'siteId' | 'system' | 'systemId' | RegulatoryReportDefinitionForGroupingNestKeySpecifier)[];
export type RegulatoryReportDefinitionForGroupingNestFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	outputTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	reportGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	reportGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportType?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportDataKeySpecifier = ('metricsWithReportData' | 'processesWithReportData' | ReportDataKeySpecifier)[];
export type ReportDataFieldPolicy = {
	metricsWithReportData?: FieldPolicy<any> | FieldReadFunction<any>,
	processesWithReportData?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportDataFlatTreeKeySpecifier = ('reportNodes' | ReportDataFlatTreeKeySpecifier)[];
export type ReportDataFlatTreeFieldPolicy = {
	reportNodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportDefinitionKeySpecifier = ('annualPeriod' | 'configSchemaId' | 'customFooter' | 'id' | 'isFlex' | 'metadata' | 'name' | 'order' | 'paperOrientation' | 'paperSize' | 'reportGroup' | 'reportGroupId' | 'reportTemplateId' | 'reportType' | 'showDayOfWeek' | 'site' | 'siteId' | 'supplementaryEnabled' | 'system' | 'systemId' | 'timeFormat' | ReportDefinitionKeySpecifier)[];
export type ReportDefinitionFieldPolicy = {
	annualPeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	configSchemaId?: FieldPolicy<any> | FieldReadFunction<any>,
	customFooter?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isFlex?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	paperOrientation?: FieldPolicy<any> | FieldReadFunction<any>,
	paperSize?: FieldPolicy<any> | FieldReadFunction<any>,
	reportGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	reportGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportTemplateId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportType?: FieldPolicy<any> | FieldReadFunction<any>,
	showDayOfWeek?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	supplementaryEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	timeFormat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportDefinitionDiscoveryFilterCountsKeySpecifier = ('frequencies' | 'scopes' | ReportDefinitionDiscoveryFilterCountsKeySpecifier)[];
export type ReportDefinitionDiscoveryFilterCountsFieldPolicy = {
	frequencies?: FieldPolicy<any> | FieldReadFunction<any>,
	scopes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportDefinitionDiscoveryFrequencyCountsKeySpecifier = ('annual' | 'daily' | 'monthly' | 'other' | 'quarterly' | ReportDefinitionDiscoveryFrequencyCountsKeySpecifier)[];
export type ReportDefinitionDiscoveryFrequencyCountsFieldPolicy = {
	annual?: FieldPolicy<any> | FieldReadFunction<any>,
	daily?: FieldPolicy<any> | FieldReadFunction<any>,
	monthly?: FieldPolicy<any> | FieldReadFunction<any>,
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	quarterly?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportDefinitionDiscoveryScopeCountsKeySpecifier = ('component' | 'organization' | 'process' | 'site' | 'system' | ReportDefinitionDiscoveryScopeCountsKeySpecifier)[];
export type ReportDefinitionDiscoveryScopeCountsFieldPolicy = {
	component?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	process?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportDefinitionNestKeySpecifier = ('annualPeriod' | 'bacterialsEnabled' | 'configSchemaId' | 'createdAt' | 'customFooter' | 'deletedAt' | 'id' | 'isFlex' | 'metadata' | 'name' | 'order' | 'paperOrientation' | 'paperSize' | 'reportGroup' | 'reportGroupId' | 'reportId' | 'reportNodes' | 'reportTemplate' | 'reportTemplateId' | 'reportType' | 'showDayOfWeek' | 'site' | 'siteId' | 'supplementaryEnabled' | 'system' | 'systemId' | 'timeFormat' | 'updatedAt' | ReportDefinitionNestKeySpecifier)[];
export type ReportDefinitionNestFieldPolicy = {
	annualPeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	bacterialsEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	configSchemaId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	customFooter?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isFlex?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	paperOrientation?: FieldPolicy<any> | FieldReadFunction<any>,
	paperSize?: FieldPolicy<any> | FieldReadFunction<any>,
	reportGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	reportGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportNodes?: FieldPolicy<any> | FieldReadFunction<any>,
	reportTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	reportTemplateId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportType?: FieldPolicy<any> | FieldReadFunction<any>,
	showDayOfWeek?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	supplementaryEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	timeFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportDefinitionsForDiscoveryWithCountKeySpecifier = ('count' | 'items' | ReportDefinitionsForDiscoveryWithCountKeySpecifier)[];
export type ReportDefinitionsForDiscoveryWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportDiscoveryItemKeySpecifier = ('createdAt' | 'enterpriseReportId' | 'id' | 'isFlex' | 'latestSnapshotReportDateTime' | 'latestSnapshotStatus' | 'latestSnapshotUpdatedAt' | 'name' | 'order' | 'outputTypes' | 'recentSnapshots' | 'reportDefinitionId' | 'reportGroup' | 'reportGroupId' | 'reportSnapshotId' | 'reportType' | 'site' | 'siteId' | 'snapshotCount' | 'sourceType' | 'system' | 'systemId' | ReportDiscoveryItemKeySpecifier)[];
export type ReportDiscoveryItemFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	enterpriseReportId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isFlex?: FieldPolicy<any> | FieldReadFunction<any>,
	latestSnapshotReportDateTime?: FieldPolicy<any> | FieldReadFunction<any>,
	latestSnapshotStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	latestSnapshotUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	outputTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	recentSnapshots?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDefinitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	reportGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportSnapshotId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportType?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	snapshotCount?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceType?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportDiscoverySiteNestKeySpecifier = ('id' | 'name' | ReportDiscoverySiteNestKeySpecifier)[];
export type ReportDiscoverySiteNestFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportDiscoverySnapshotKeySpecifier = ('enterpriseReportId' | 'id' | 'name' | 'reportDateTime' | 'status' | 'updatedAt' | ReportDiscoverySnapshotKeySpecifier)[];
export type ReportDiscoverySnapshotFieldPolicy = {
	enterpriseReportId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDateTime?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportDiscoverySystemNestKeySpecifier = ('createdAt' | 'id' | 'name' | 'organizationId' | 'timeZone' | ReportDiscoverySystemNestKeySpecifier)[];
export type ReportDiscoverySystemNestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportDistributionListKeySpecifier = ('createdAt' | 'deletedAt' | 'description' | 'displaySummary' | 'id' | 'isArchived' | 'memberCount' | 'members' | 'name' | 'normalizedName' | 'organizationId' | 'scope' | 'siteId' | 'systemId' | 'updatedAt' | ReportDistributionListKeySpecifier)[];
export type ReportDistributionListFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displaySummary?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isArchived?: FieldPolicy<any> | FieldReadFunction<any>,
	memberCount?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	normalizedName?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportDistributionListMemberKeySpecifier = ('createdAt' | 'displayName' | 'id' | 'memberType' | 'normalizedEmail' | 'sortOrder' | 'updatedAt' | 'userId' | ReportDistributionListMemberKeySpecifier)[];
export type ReportDistributionListMemberFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	memberType?: FieldPolicy<any> | FieldReadFunction<any>,
	normalizedEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportGroupKeySpecifier = ('createdAt' | 'id' | 'name' | 'order' | 'systemId' | 'updatedAt' | ReportGroupKeySpecifier)[];
export type ReportGroupFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportNestKeySpecifier = ('description' | 'id' | 'name' | 'organization' | 'organizationId' | 'reportTemplate' | 'reportType' | 'site' | 'siteId' | 'system' | 'systemId' | ReportNestKeySpecifier)[];
export type ReportNestFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	reportType?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportNodeKeySpecifier = ('columnGroupId' | 'columnGroupItemId' | 'createdAt' | 'deletedAt' | 'id' | 'metricId' | 'order' | 'parentId' | 'reportDefinitionId' | 'type' | 'updatedAt' | ReportNodeKeySpecifier)[];
export type ReportNodeFieldPolicy = {
	columnGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	columnGroupItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	parentId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDefinitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportNodeWithRelationsKeySpecifier = ('columnGroup' | 'columnGroupId' | 'columnGroupItem' | 'columnGroupItemId' | 'createdAt' | 'deletedAt' | 'id' | 'metric' | 'metricId' | 'order' | 'parentId' | 'reportDefinition' | 'reportDefinitionId' | 'type' | 'updatedAt' | ReportNodeWithRelationsKeySpecifier)[];
export type ReportNodeWithRelationsFieldPolicy = {
	columnGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	columnGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	columnGroupItem?: FieldPolicy<any> | FieldReadFunction<any>,
	columnGroupItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metric?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	parentId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDefinitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportSnapshotKeySpecifier = ('config' | 'configSchemaVersion' | 'createdAt' | 'data' | 'deletedAt' | 'enterpriseReportId' | 'id' | 'name' | 'report' | 'reportDateTime' | 'reportDefinition' | 'reportDefinitionId' | 'status' | 'system' | 'updatedAt' | 'url' | ReportSnapshotKeySpecifier)[];
export type ReportSnapshotFieldPolicy = {
	config?: FieldPolicy<any> | FieldReadFunction<any>,
	configSchemaVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	enterpriseReportId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	report?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDateTime?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDefinitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportSnapshotItemsWithCountKeySpecifier = ('count' | 'items' | ReportSnapshotItemsWithCountKeySpecifier)[];
export type ReportSnapshotItemsWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportTemplateKeySpecifier = ('agencyName' | 'configSchemaId' | 'createdAt' | 'fileName' | 'id' | 'isEditable' | 'legalStatement' | 'outputTypes' | 'stateOrProvince' | 'updatedAt' | 'variant' | ReportTemplateKeySpecifier)[];
export type ReportTemplateFieldPolicy = {
	agencyName?: FieldPolicy<any> | FieldReadFunction<any>,
	configSchemaId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isEditable?: FieldPolicy<any> | FieldReadFunction<any>,
	legalStatement?: FieldPolicy<any> | FieldReadFunction<any>,
	outputTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	stateOrProvince?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportingReportGroupNestKeySpecifier = ('id' | 'name' | 'order' | 'systemId' | ReportingReportGroupNestKeySpecifier)[];
export type ReportingReportGroupNestFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResolvedConstantKeySpecifier = ('constantDefinition' | 'constantValue' | 'source' | ResolvedConstantKeySpecifier)[];
export type ResolvedConstantFieldPolicy = {
	constantDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	constantValue?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RetentionRiskNestKeySpecifier = ('createdAt' | 'deletedAt' | 'displayName' | 'flag' | 'flagType' | 'id' | 'itemId' | 'itemType' | 'organization' | 'organizationId' | 'score' | 'snooze' | 'updatedAt' | RetentionRiskNestKeySpecifier)[];
export type RetentionRiskNestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	flag?: FieldPolicy<any> | FieldReadFunction<any>,
	flagType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>,
	snooze?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RetentionRiskResultNestKeySpecifier = ('organizationId' | 'organizationRetentionRisks' | 'score' | 'systemRetentionRisks' | RetentionRiskResultNestKeySpecifier)[];
export type RetentionRiskResultNestFieldPolicy = {
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationRetentionRisks?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>,
	systemRetentionRisks?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoundsAssetsMappingNestKeySpecifier = ('assetsEntityId' | 'assetsEntityType' | 'assetsInstanceId' | 'id' | 'roundsEntityId' | 'roundsEntityType' | 'systemId' | RoundsAssetsMappingNestKeySpecifier)[];
export type RoundsAssetsMappingNestFieldPolicy = {
	assetsEntityId?: FieldPolicy<any> | FieldReadFunction<any>,
	assetsEntityType?: FieldPolicy<any> | FieldReadFunction<any>,
	assetsInstanceId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	roundsEntityId?: FieldPolicy<any> | FieldReadFunction<any>,
	roundsEntityType?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoundsShiftNoteAssetChoiceKeySpecifier = ('componentId' | 'name' | RoundsShiftNoteAssetChoiceKeySpecifier)[];
export type RoundsShiftNoteAssetChoiceFieldPolicy = {
	componentId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoundsShiftNoteAssigneeRoleKeySpecifier = ('isUnassignedBucket' | 'roleId' | 'roleName' | 'users' | RoundsShiftNoteAssigneeRoleKeySpecifier)[];
export type RoundsShiftNoteAssigneeRoleFieldPolicy = {
	isUnassignedBucket?: FieldPolicy<any> | FieldReadFunction<any>,
	roleId?: FieldPolicy<any> | FieldReadFunction<any>,
	roleName?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoundsShiftNoteAssigneeUserKeySpecifier = ('label' | 'userId' | RoundsShiftNoteAssigneeUserKeySpecifier)[];
export type RoundsShiftNoteAssigneeUserFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoundsShiftNoteCreateResultKeySpecifier = ('noteId' | 'viewUrl' | RoundsShiftNoteCreateResultKeySpecifier)[];
export type RoundsShiftNoteCreateResultFieldPolicy = {
	noteId?: FieldPolicy<any> | FieldReadFunction<any>,
	viewUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoundsShiftNoteFormContextKeySpecifier = ('asset' | 'assetChoices' | 'assigneeRoles' | 'defaultDate' | 'defaultTime' | 'facility' | 'notifyAssignedByDefault' | 'sourceType' | 'system' | 'systemChoices' | RoundsShiftNoteFormContextKeySpecifier)[];
export type RoundsShiftNoteFormContextFieldPolicy = {
	asset?: FieldPolicy<any> | FieldReadFunction<any>,
	assetChoices?: FieldPolicy<any> | FieldReadFunction<any>,
	assigneeRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultDate?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultTime?: FieldPolicy<any> | FieldReadFunction<any>,
	facility?: FieldPolicy<any> | FieldReadFunction<any>,
	notifyAssignedByDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceType?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	systemChoices?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoundsShiftNoteLocationTierKeySpecifier = ('id' | 'name' | RoundsShiftNoteLocationTierKeySpecifier)[];
export type RoundsShiftNoteLocationTierFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoundsShiftNoteSystemChoiceKeySpecifier = ('assets' | 'name' | 'processId' | RoundsShiftNoteSystemChoiceKeySpecifier)[];
export type RoundsShiftNoteSystemChoiceFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	processId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RuntimeLoggerKeySpecifier = ('defaults' | 'name' | 'override' | 'overrideStatus' | 'recent' | RuntimeLoggerKeySpecifier)[];
export type RuntimeLoggerFieldPolicy = {
	defaults?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	override?: FieldPolicy<any> | FieldReadFunction<any>,
	overrideStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	recent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RuntimeLoggerDefaultKeySpecifier = ('instanceId' | 'lastSeenAt' | 'level' | 'role' | RuntimeLoggerDefaultKeySpecifier)[];
export type RuntimeLoggerDefaultFieldPolicy = {
	instanceId?: FieldPolicy<any> | FieldReadFunction<any>,
	lastSeenAt?: FieldPolicy<any> | FieldReadFunction<any>,
	level?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RuntimeLoggerOverrideKeySpecifier = ('expiresAt' | 'level' | 'updatedAt' | RuntimeLoggerOverrideKeySpecifier)[];
export type RuntimeLoggerOverrideFieldPolicy = {
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	level?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RuntimeLoggerSnapshotKeySpecifier = ('available' | 'complete' | 'loggers' | 'observedAt' | RuntimeLoggerSnapshotKeySpecifier)[];
export type RuntimeLoggerSnapshotFieldPolicy = {
	available?: FieldPolicy<any> | FieldReadFunction<any>,
	complete?: FieldPolicy<any> | FieldReadFunction<any>,
	loggers?: FieldPolicy<any> | FieldReadFunction<any>,
	observedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SSOConfigurationTypeKeySpecifier = ('audience' | 'authority' | 'clientId' | 'id' | 'idpKey' | 'isNameEditable' | 'logoSvg' | 'scope' | 'signoutRedirectUrl' | 'userDirectoryEnabled' | SSOConfigurationTypeKeySpecifier)[];
export type SSOConfigurationTypeFieldPolicy = {
	audience?: FieldPolicy<any> | FieldReadFunction<any>,
	authority?: FieldPolicy<any> | FieldReadFunction<any>,
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idpKey?: FieldPolicy<any> | FieldReadFunction<any>,
	isNameEditable?: FieldPolicy<any> | FieldReadFunction<any>,
	logoSvg?: FieldPolicy<any> | FieldReadFunction<any>,
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	signoutRedirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	userDirectoryEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SSODirectoryUserKeySpecifier = ('email' | 'firstName' | 'id' | 'lastName' | 'metadataJSON' | SSODirectoryUserKeySpecifier)[];
export type SSODirectoryUserFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	metadataJSON?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SampleCollectionKeySpecifier = ('createdAt' | 'currentCustody' | 'deletedAt' | 'id' | 'sampleCollectionResults' | 'sampleSite' | 'sampleSiteId' | 'scheduledItemId' | 'systemId' | 'updatedAt' | SampleCollectionKeySpecifier)[];
export type SampleCollectionFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currentCustody?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleCollectionResults?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleSite?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleSiteId?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SampleCollectionCommentKeySpecifier = ('comment' | 'commentType' | 'createdAt' | 'deletedAt' | 'id' | 'sampleCollectionId' | 'updatedAt' | 'user' | 'userId' | SampleCollectionCommentKeySpecifier)[];
export type SampleCollectionCommentFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	commentType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleCollectionId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SampleCollectionCustodiesWithCountKeySpecifier = ('count' | 'items' | SampleCollectionCustodiesWithCountKeySpecifier)[];
export type SampleCollectionCustodiesWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SampleCollectionCustodyKeySpecifier = ('comment' | 'createdAt' | 'createdBy' | 'deletedAt' | 'id' | 'previousCustodyId' | 'relinquishedBy' | 'relinquishedByUser' | 'relinquishedTo' | 'relinquishedToUser' | 'sampleCollectionId' | 'systemId' | 'updatedAt' | SampleCollectionCustodyKeySpecifier)[];
export type SampleCollectionCustodyFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	previousCustodyId?: FieldPolicy<any> | FieldReadFunction<any>,
	relinquishedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	relinquishedByUser?: FieldPolicy<any> | FieldReadFunction<any>,
	relinquishedTo?: FieldPolicy<any> | FieldReadFunction<any>,
	relinquishedToUser?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleCollectionId?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SampleCollectionResultKeySpecifier = ('analyte' | 'analyteId' | 'booleanValue' | 'createdAt' | 'deletedAt' | 'id' | 'measuredAt' | 'numericValue' | 'sampleCollectionId' | 'textValue' | 'updatedAt' | 'valueType' | SampleCollectionResultKeySpecifier)[];
export type SampleCollectionResultFieldPolicy = {
	analyte?: FieldPolicy<any> | FieldReadFunction<any>,
	analyteId?: FieldPolicy<any> | FieldReadFunction<any>,
	booleanValue?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	measuredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	numericValue?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleCollectionId?: FieldPolicy<any> | FieldReadFunction<any>,
	textValue?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	valueType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SampleCollectionsWithCountKeySpecifier = ('count' | 'items' | SampleCollectionsWithCountKeySpecifier)[];
export type SampleCollectionsWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SampleScheduleKeySpecifier = ('analyteGroupId' | 'analytes' | 'createdAt' | 'createdByUserId' | 'defaultAssignee' | 'defaultAssigneeId' | 'deletedAt' | 'description' | 'endDate' | 'exDates' | 'id' | 'isStackable' | 'notBeforeUnit' | 'notBeforeValue' | 'photoRequired' | 'rDates' | 'recurrenceType' | 'rrule' | 'sampleSite' | 'sampleSiteId' | 'sampleType' | 'siteId' | 'startDate' | 'system' | 'systemId' | 'targetBeforeUnit' | 'targetBeforeValue' | 'title' | 'updatedAt' | SampleScheduleKeySpecifier)[];
export type SampleScheduleFieldPolicy = {
	analyteGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	analytes?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultAssignee?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultAssigneeId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	exDates?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isStackable?: FieldPolicy<any> | FieldReadFunction<any>,
	notBeforeUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	notBeforeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	photoRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	rDates?: FieldPolicy<any> | FieldReadFunction<any>,
	recurrenceType?: FieldPolicy<any> | FieldReadFunction<any>,
	rrule?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleSite?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleSiteId?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleType?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	targetBeforeUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	targetBeforeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SampleScheduleAnalyteKeySpecifier = ('analyteId' | 'createdAt' | 'deletedAt' | 'id' | 'sampleScheduleId' | 'updatedAt' | SampleScheduleAnalyteKeySpecifier)[];
export type SampleScheduleAnalyteFieldPolicy = {
	analyteId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleScheduleId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SampleScheduleAnalytesWithCountKeySpecifier = ('count' | 'items' | SampleScheduleAnalytesWithCountKeySpecifier)[];
export type SampleScheduleAnalytesWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SampleSchedulesWithCountKeySpecifier = ('count' | 'items' | SampleSchedulesWithCountKeySpecifier)[];
export type SampleSchedulesWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SampleSiteKeySpecifier = ('address' | 'createdAt' | 'deletedAt' | 'description' | 'id' | 'isActive' | 'lastInspectionDate' | 'latitude' | 'longitude' | 'name' | 'organizationId' | 'photoUpload' | 'samplePointType' | 'updatedAt' | 'url' | SampleSiteKeySpecifier)[];
export type SampleSiteFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	lastInspectionDate?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	photoUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	samplePointType?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SampleSiteUploadKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'sampleSiteId' | 'updatedAt' | 'uploadId' | SampleSiteUploadKeySpecifier)[];
export type SampleSiteUploadFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleSiteId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduledItemKeySpecifier = ('assignee' | 'assigneeId' | 'comments' | 'completedAt' | 'createdAt' | 'deletedAt' | 'description' | 'id' | 'isStackable' | 'notBefore' | 'photoRequired' | 'photoUpload' | 'recurrenceType' | 'scheduledAt' | 'sourceScheduleId' | 'sourceScheduleType' | 'status' | 'system' | 'systemId' | 'targetDate' | 'title' | 'updatedAt' | ScheduledItemKeySpecifier)[];
export type ScheduledItemFieldPolicy = {
	assignee?: FieldPolicy<any> | FieldReadFunction<any>,
	assigneeId?: FieldPolicy<any> | FieldReadFunction<any>,
	comments?: FieldPolicy<any> | FieldReadFunction<any>,
	completedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isStackable?: FieldPolicy<any> | FieldReadFunction<any>,
	notBefore?: FieldPolicy<any> | FieldReadFunction<any>,
	photoRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	photoUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	recurrenceType?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledAt?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceScheduleId?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceScheduleType?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	targetDate?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduledItemCommentKeySpecifier = ('comment' | 'commentType' | 'createdAt' | 'deletedAt' | 'id' | 'scheduledItemId' | 'updatedAt' | 'user' | 'userId' | ScheduledItemCommentKeySpecifier)[];
export type ScheduledItemCommentFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	commentType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduledItemCountKeySpecifier = ('count' | ScheduledItemCountKeySpecifier)[];
export type ScheduledItemCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduledItemUploadKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'scheduledItemId' | 'updatedAt' | 'uploadId' | ScheduledItemUploadKeySpecifier)[];
export type ScheduledItemUploadFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduledItemsWithCountKeySpecifier = ('count' | 'items' | ScheduledItemsWithCountKeySpecifier)[];
export type ScheduledItemsWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendManualReportEmailPayloadKeySpecifier = ('emailEvent' | 'publicUrl' | 'reportSnapshot' | 'shareLinkId' | SendManualReportEmailPayloadKeySpecifier)[];
export type SendManualReportEmailPayloadFieldPolicy = {
	emailEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	publicUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	reportSnapshot?: FieldPolicy<any> | FieldReadFunction<any>,
	shareLinkId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SiteDataEntriesCollectionTypeKeySpecifier = ('current' | 'id' | 'metricId' | SiteDataEntriesCollectionTypeKeySpecifier)[];
export type SiteDataEntriesCollectionTypeFieldPolicy = {
	current?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SiteDataEntriesDayDataPointTypeKeySpecifier = ('appliedAt' | 'dataPoint' | 'id' | 'intervalId' | 'reportDate' | 'time' | SiteDataEntriesDayDataPointTypeKeySpecifier)[];
export type SiteDataEntriesDayDataPointTypeFieldPolicy = {
	appliedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dataPoint?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDate?: FieldPolicy<any> | FieldReadFunction<any>,
	time?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SiteDataEntriesDayTypeKeySpecifier = ('dataPoints' | 'id' | 'metricId' | 'metricType' | SiteDataEntriesDayTypeKeySpecifier)[];
export type SiteDataEntriesDayTypeFieldPolicy = {
	dataPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	metricType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SiteDataEntriesHistoryCollectionTypeKeySpecifier = ('history' | 'id' | 'metricId' | SiteDataEntriesHistoryCollectionTypeKeySpecifier)[];
export type SiteDataEntriesHistoryCollectionTypeFieldPolicy = {
	history?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SiteDataEntryChangeTypeKeySpecifier = ('dataPoint' | 'entryIntervalDate' | 'entryIntervalTime' | SiteDataEntryChangeTypeKeySpecifier)[];
export type SiteDataEntryChangeTypeFieldPolicy = {
	dataPoint?: FieldPolicy<any> | FieldReadFunction<any>,
	entryIntervalDate?: FieldPolicy<any> | FieldReadFunction<any>,
	entryIntervalTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SiteDataEntryCompletionByDateKeySpecifier = ('dailyCompletion' | 'intervalCompletions' | 'site' | SiteDataEntryCompletionByDateKeySpecifier)[];
export type SiteDataEntryCompletionByDateFieldPolicy = {
	dailyCompletion?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalCompletions?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SiteFlexMetricKeySpecifier = ('createdAt' | 'deletedAt' | 'folderViewOrder' | 'id' | 'metric' | 'metricId' | 'name' | 'required' | 'siteId' | 'updatedAt' | SiteFlexMetricKeySpecifier)[];
export type SiteFlexMetricFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	folderViewOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metric?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SiteFlexMetricWithParentSiteKeySpecifier = ('createdAt' | 'deletedAt' | 'folderViewOrder' | 'id' | 'metric' | 'metricId' | 'name' | 'parentSite' | 'required' | 'siteId' | 'updatedAt' | SiteFlexMetricWithParentSiteKeySpecifier)[];
export type SiteFlexMetricWithParentSiteFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	folderViewOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metric?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	parentSite?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>,
	siteId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SiteIntervalCompletionStatusKeySpecifier = ('dataEntryCompletion' | 'hasRequiredMetrics' | 'interval' | SiteIntervalCompletionStatusKeySpecifier)[];
export type SiteIntervalCompletionStatusFieldPolicy = {
	dataEntryCompletion?: FieldPolicy<any> | FieldReadFunction<any>,
	hasRequiredMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	interval?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SiteNestKeySpecifier = ('addresses' | 'components' | 'createdAt' | 'dataEntryCompletionEmail' | 'dataEntryCompletionEnabled' | 'dataModelSite' | 'deletedAt' | 'displayNameBreadcrumbs' | 'emoji' | 'externalId' | 'externalMetadata' | 'externalOwner' | 'flex' | 'foldersWithMetricIdsAndOrder' | 'fullName' | 'id' | 'intervals' | 'isEntry' | 'latitude' | 'licenseId' | 'longitude' | 'metrics' | 'mirrorSiteId' | 'name' | 'npdesPermitNumber' | 'operatorId' | 'order' | 'phoneNumber' | 'phoneNumberId' | 'processes' | 'siteFlexMetricsWithParentSite' | 'siteType' | 'sourceMetrics' | 'systemId' | 'timeSeriesEnabled' | 'updatedAt' | SiteNestKeySpecifier)[];
export type SiteNestFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	components?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dataEntryCompletionEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	dataEntryCompletionEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	dataModelSite?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	displayNameBreadcrumbs?: FieldPolicy<any> | FieldReadFunction<any>,
	emoji?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	externalMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	externalOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	flex?: FieldPolicy<any> | FieldReadFunction<any>,
	foldersWithMetricIdsAndOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intervals?: FieldPolicy<any> | FieldReadFunction<any>,
	isEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	licenseId?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	mirrorSiteId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	npdesPermitNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	operatorId?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumberId?: FieldPolicy<any> | FieldReadFunction<any>,
	processes?: FieldPolicy<any> | FieldReadFunction<any>,
	siteFlexMetricsWithParentSite?: FieldPolicy<any> | FieldReadFunction<any>,
	siteType?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	timeSeriesEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SiteOutOfIdealRangeMetricTypeKeySpecifier = ('metric' | 'outOfIdealRange' | SiteOutOfIdealRangeMetricTypeKeySpecifier)[];
export type SiteOutOfIdealRangeMetricTypeFieldPolicy = {
	metric?: FieldPolicy<any> | FieldReadFunction<any>,
	outOfIdealRange?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SiteOutOfRangeMetricTypeKeySpecifier = ('metric' | 'outOfRange' | SiteOutOfRangeMetricTypeKeySpecifier)[];
export type SiteOutOfRangeMetricTypeFieldPolicy = {
	metric?: FieldPolicy<any> | FieldReadFunction<any>,
	outOfRange?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SiteTypeKeySpecifier = ('addresses' | 'dataEntries' | 'dataEntriesDay' | 'dataEntriesHistory' | 'dataEntryCompletionEmail' | 'dataEntryCompletionEnabled' | 'displayName' | 'emoji' | 'externalId' | 'externalMetadataJSON' | 'externalOwner' | 'flex' | 'fullName' | 'hasIntervals' | 'id' | 'intervals' | 'isEntry' | 'latitude' | 'licenseId' | 'longitude' | 'metrics' | 'name' | 'npdesPermitNumber' | 'operator' | 'operatorId' | 'order' | 'outOfIdealRangeMetrics' | 'outOfRangeMetrics' | 'phoneNumber' | 'phoneNumberId' | 'processes' | 'siteType' | 'system' | 'systemId' | SiteTypeKeySpecifier)[];
export type SiteTypeFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	dataEntries?: FieldPolicy<any> | FieldReadFunction<any>,
	dataEntriesDay?: FieldPolicy<any> | FieldReadFunction<any>,
	dataEntriesHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	dataEntryCompletionEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	dataEntryCompletionEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	emoji?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	externalMetadataJSON?: FieldPolicy<any> | FieldReadFunction<any>,
	externalOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	flex?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	hasIntervals?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intervals?: FieldPolicy<any> | FieldReadFunction<any>,
	isEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	licenseId?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	npdesPermitNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	operator?: FieldPolicy<any> | FieldReadFunction<any>,
	operatorId?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	outOfIdealRangeMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	outOfRangeMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumberId?: FieldPolicy<any> | FieldReadFunction<any>,
	processes?: FieldPolicy<any> | FieldReadFunction<any>,
	siteType?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SiteWithProcessesKeySpecifier = ('addresses' | 'components' | 'createdAt' | 'dataEntryCompletionEmail' | 'dataEntryCompletionEnabled' | 'dataModelSite' | 'deletedAt' | 'displayNameBreadcrumbs' | 'emoji' | 'externalId' | 'externalMetadata' | 'externalOwner' | 'flex' | 'foldersWithMetricIdsAndOrder' | 'fullName' | 'id' | 'intervals' | 'isEntry' | 'latitude' | 'licenseId' | 'longitude' | 'metrics' | 'mirrorSiteId' | 'name' | 'npdesPermitNumber' | 'operatorId' | 'order' | 'phoneNumber' | 'phoneNumberId' | 'processes' | 'siteFlexMetricsWithParentSite' | 'siteType' | 'sourceMetrics' | 'systemId' | 'timeSeriesEnabled' | 'updatedAt' | SiteWithProcessesKeySpecifier)[];
export type SiteWithProcessesFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	components?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dataEntryCompletionEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	dataEntryCompletionEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	dataModelSite?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	displayNameBreadcrumbs?: FieldPolicy<any> | FieldReadFunction<any>,
	emoji?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	externalMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	externalOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	flex?: FieldPolicy<any> | FieldReadFunction<any>,
	foldersWithMetricIdsAndOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intervals?: FieldPolicy<any> | FieldReadFunction<any>,
	isEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	licenseId?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	mirrorSiteId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	npdesPermitNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	operatorId?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumberId?: FieldPolicy<any> | FieldReadFunction<any>,
	processes?: FieldPolicy<any> | FieldReadFunction<any>,
	siteFlexMetricsWithParentSite?: FieldPolicy<any> | FieldReadFunction<any>,
	siteType?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	timeSeriesEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SsoConfigurationNestKeySpecifier = ('audience' | 'authority' | 'clientId' | 'createdAt' | 'facilitySearchUrl' | 'id' | 'idpKey' | 'isNameEditable' | 'issuer' | 'logoSvg' | 'provisioner' | 'scope' | 'signoutRedirectUrl' | 'systemSearchUrl' | 'updatedAt' | 'userDirectoryAuthVaultEntry' | 'userDirectoryEnabled' | 'userDirectorySearchUrl' | SsoConfigurationNestKeySpecifier)[];
export type SsoConfigurationNestFieldPolicy = {
	audience?: FieldPolicy<any> | FieldReadFunction<any>,
	authority?: FieldPolicy<any> | FieldReadFunction<any>,
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	facilitySearchUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idpKey?: FieldPolicy<any> | FieldReadFunction<any>,
	isNameEditable?: FieldPolicy<any> | FieldReadFunction<any>,
	issuer?: FieldPolicy<any> | FieldReadFunction<any>,
	logoSvg?: FieldPolicy<any> | FieldReadFunction<any>,
	provisioner?: FieldPolicy<any> | FieldReadFunction<any>,
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	signoutRedirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	systemSearchUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userDirectoryAuthVaultEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	userDirectoryEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	userDirectorySearchUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionKeySpecifier = ('onAuditEventPublished' | 'onCalcQueueJobsPublished' | 'onCalcQueueStatsPublished' | 'onDataEntryCompletionPublished' | 'onLogBookEntryPublished' | 'onNotificationPublished' | 'onScheduledItemPublished' | 'onSiteDataEntryChanged' | SubscriptionKeySpecifier)[];
export type SubscriptionFieldPolicy = {
	onAuditEventPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	onCalcQueueJobsPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	onCalcQueueStatsPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	onDataEntryCompletionPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	onLogBookEntryPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	onNotificationPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	onScheduledItemPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	onSiteDataEntryChanged?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SuccessResponseKeySpecifier = ('id' | 'message' | 'success' | SuccessResponseKeySpecifier)[];
export type SuccessResponseFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SystemGroupTypeKeySpecifier = ('displayName' | 'id' | 'isTopLevel' | 'name' | 'organization' | 'organizationId' | 'parentSystemGroup' | 'parentSystemGroupId' | 'systemGroups' | 'systems' | 'users' | SystemGroupTypeKeySpecifier)[];
export type SystemGroupTypeFieldPolicy = {
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isTopLevel?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	parentSystemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	parentSystemGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	systemGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	systems?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SystemNestKeySpecifier = ('addresses' | 'displayName' | 'externalId' | 'externalMetadata' | 'externalOwner' | 'hideDataSites' | 'id' | 'isFavorite' | 'isTemplate' | 'licenseId' | 'myRole' | 'name' | 'operator' | 'operatorId' | 'organization' | 'organizationId' | 'parentSystemGroupId' | 'permits' | 'phoneNumber' | 'phoneNumberId' | 'regulatoryId' | 'timeZone' | 'type' | 'userDirectoryEnabled' | 'users' | SystemNestKeySpecifier)[];
export type SystemNestFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	externalMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	externalOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	hideDataSites?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	isTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	licenseId?: FieldPolicy<any> | FieldReadFunction<any>,
	myRole?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	operator?: FieldPolicy<any> | FieldReadFunction<any>,
	operatorId?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	parentSystemGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	permits?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumberId?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZone?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	userDirectoryEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SystemTypeKeySpecifier = ('addresses' | 'components' | 'displayName' | 'externalId' | 'externalMetadataJSON' | 'externalOwner' | 'hasSitesWithIntervals' | 'hideDataSites' | 'id' | 'isFavorite' | 'isTemplate' | 'licenseId' | 'metrics' | 'myRole' | 'name' | 'operator' | 'operatorId' | 'organization' | 'organizationId' | 'parentSystemGroup' | 'parentSystemGroupId' | 'phoneNumber' | 'phoneNumberId' | 'processes' | 'regulatoryId' | 'sites' | 'timeZone' | 'type' | 'userDirectoryEnabled' | 'users' | SystemTypeKeySpecifier)[];
export type SystemTypeFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	components?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	externalMetadataJSON?: FieldPolicy<any> | FieldReadFunction<any>,
	externalOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	hasSitesWithIntervals?: FieldPolicy<any> | FieldReadFunction<any>,
	hideDataSites?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	isTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	licenseId?: FieldPolicy<any> | FieldReadFunction<any>,
	metrics?: FieldPolicy<any> | FieldReadFunction<any>,
	myRole?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	operator?: FieldPolicy<any> | FieldReadFunction<any>,
	operatorId?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	parentSystemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	parentSystemGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumberId?: FieldPolicy<any> | FieldReadFunction<any>,
	processes?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	sites?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZone?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	userDirectoryEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SystemWithSitesKeySpecifier = ('addresses' | 'externalId' | 'externalMetadata' | 'externalOwner' | 'hideDataSites' | 'id' | 'isFavorite' | 'isTemplate' | 'licenseId' | 'myRole' | 'name' | 'operator' | 'operatorId' | 'organization' | 'organizationId' | 'parentSystemGroupId' | 'permits' | 'phoneNumber' | 'phoneNumberId' | 'regulatoryId' | 'sites' | 'timeZone' | 'type' | 'userDirectoryEnabled' | 'users' | SystemWithSitesKeySpecifier)[];
export type SystemWithSitesFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	externalMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	externalOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	hideDataSites?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	isTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	licenseId?: FieldPolicy<any> | FieldReadFunction<any>,
	myRole?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	operator?: FieldPolicy<any> | FieldReadFunction<any>,
	operatorId?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	parentSystemGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	permits?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumberId?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	sites?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZone?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	userDirectoryEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TSDataPointKeySpecifier = ('appliedAt' | 'booleanValue' | 'calculatedNondetectValue' | 'calculatedValue' | 'comment' | 'connectValue' | 'dateTimeValue' | 'dateValue' | 'edgeDeviceSubmissionId' | 'effectiveNumericValue' | 'error' | 'id' | 'intervalId' | 'isArchived' | 'isCalculatedResult' | 'isInterpolated' | 'isNondetect' | 'journalEntryRecordId' | 'jsonValue' | 'locatorEntityId' | 'locatorEntityType' | 'locatorNamespace' | 'measuredAt' | 'metaData' | 'metricId' | 'numericValue' | 'reportDate' | 'storedAt' | 'textValue' | 'timeValue' | 'type' | 'value' | 'valueType' | TSDataPointKeySpecifier)[];
export type TSDataPointFieldPolicy = {
	appliedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	booleanValue?: FieldPolicy<any> | FieldReadFunction<any>,
	calculatedNondetectValue?: FieldPolicy<any> | FieldReadFunction<any>,
	calculatedValue?: FieldPolicy<any> | FieldReadFunction<any>,
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	connectValue?: FieldPolicy<any> | FieldReadFunction<any>,
	dateTimeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	dateValue?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDeviceSubmissionId?: FieldPolicy<any> | FieldReadFunction<any>,
	effectiveNumericValue?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalId?: FieldPolicy<any> | FieldReadFunction<any>,
	isArchived?: FieldPolicy<any> | FieldReadFunction<any>,
	isCalculatedResult?: FieldPolicy<any> | FieldReadFunction<any>,
	isInterpolated?: FieldPolicy<any> | FieldReadFunction<any>,
	isNondetect?: FieldPolicy<any> | FieldReadFunction<any>,
	journalEntryRecordId?: FieldPolicy<any> | FieldReadFunction<any>,
	jsonValue?: FieldPolicy<any> | FieldReadFunction<any>,
	locatorEntityId?: FieldPolicy<any> | FieldReadFunction<any>,
	locatorEntityType?: FieldPolicy<any> | FieldReadFunction<any>,
	locatorNamespace?: FieldPolicy<any> | FieldReadFunction<any>,
	measuredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	metaData?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	numericValue?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDate?: FieldPolicy<any> | FieldReadFunction<any>,
	storedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	textValue?: FieldPolicy<any> | FieldReadFunction<any>,
	timeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	valueType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TSDataPointMetadataKeySpecifier = ('connectValue' | 'edgeDeviceSubmissionId' | 'id' | 'intervalId' | 'reportDate' | TSDataPointMetadataKeySpecifier)[];
export type TSDataPointMetadataFieldPolicy = {
	connectValue?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDeviceSubmissionId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intervalId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagKeySpecifier = ('color' | 'createdAt' | 'deletedAt' | 'displayName' | 'id' | 'keynameTagCount' | 'logBookEntryTagCount' | 'name' | 'nameEs' | 'organization' | 'organizationId' | 'reportTagCount' | 'type' | 'updatedAt' | TagKeySpecifier)[];
export type TagFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	keynameTagCount?: FieldPolicy<any> | FieldReadFunction<any>,
	logBookEntryTagCount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nameEs?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportTagCount?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagMappingTypeKeySpecifier = ('edgeDevice' | 'edgeDeviceId' | 'id' | 'metric' | 'metricId' | 'site' | 'system' | 'tagName' | TagMappingTypeKeySpecifier)[];
export type TagMappingTypeFieldPolicy = {
	edgeDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDeviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metric?: FieldPolicy<any> | FieldReadFunction<any>,
	metricId?: FieldPolicy<any> | FieldReadFunction<any>,
	site?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	tagName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagMappingsResultKeySpecifier = ('data' | 'id' | 'total' | TagMappingsResultKeySpecifier)[];
export type TagMappingsResultFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagsWithCountKeySpecifier = ('count' | 'items' | TagsWithCountKeySpecifier)[];
export type TagsWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionInfoWithCalcClusterDebugLogsKeySpecifier = ('id' | 'logs' | 'originTimestamp' | 'transactionId' | TransactionInfoWithCalcClusterDebugLogsKeySpecifier)[];
export type TransactionInfoWithCalcClusterDebugLogsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logs?: FieldPolicy<any> | FieldReadFunction<any>,
	originTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TrendNestKeySpecifier = ('id' | 'isGlobal' | 'keynameFilters' | 'name' | 'owner' | 'ownerId' | 'resolvedMetricIds' | 'system' | 'systemId' | 'systemType' | TrendNestKeySpecifier)[];
export type TrendNestFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isGlobal?: FieldPolicy<any> | FieldReadFunction<any>,
	keynameFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	resolvedMetricIds?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>,
	systemType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnitNestKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'isInterpolatable' | 'name' | 'updatedAt' | UnitNestKeySpecifier)[];
export type UnitNestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isInterpolatable?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnitTypeKeySpecifier = ('id' | 'isInterpolatable' | 'name' | UnitTypeKeySpecifier)[];
export type UnitTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isInterpolatable?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateEnterpriseReportShareLinkPayloadKeySpecifier = ('publicUrl' | 'shareLink' | UpdateEnterpriseReportShareLinkPayloadKeySpecifier)[];
export type UpdateEnterpriseReportShareLinkPayloadFieldPolicy = {
	publicUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	shareLink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadKeySpecifier = ('blobId' | 'createdAt' | 'deletedAt' | 'description' | 'fileLength' | 'fileName' | 'id' | 'mimeType' | 'organizationId' | 'updatedAt' | 'url' | UploadKeySpecifier)[];
export type UploadFieldPolicy = {
	blobId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	fileLength?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadBlobInfoKeySpecifier = ('blobId' | 'downloadUrl' | 'fileName' | 'mimeType' | 'uploadHeadersJSON' | 'uploadToken' | 'uploadUrl' | UploadBlobInfoKeySpecifier)[];
export type UploadBlobInfoFieldPolicy = {
	blobId?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadHeadersJSON?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadToken?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadsWithCountKeySpecifier = ('count' | 'items' | UploadsWithCountKeySpecifier)[];
export type UploadsWithCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserInfoTypeKeySpecifier = ('displayName' | 'email' | 'enableIphoneMetricNumberInput' | 'externalId' | 'externalMetadataJSON' | 'externalOwner' | 'firstName' | 'fullNameOrEmail' | 'id' | 'idpKey' | 'lastLoginAt' | 'lastName' | 'licenses' | 'pending' | 'permissions' | 'phoneNumbers' | 'primaryOrganization' | 'primaryOrganizationDateFormat' | 'primaryOrganizationId' | 'readonlySuperadmin' | 'roleForSystem' | 'roleForSystemGroup' | 'ssoConfig' | 'subject' | 'superadmin' | UserInfoTypeKeySpecifier)[];
export type UserInfoTypeFieldPolicy = {
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	enableIphoneMetricNumberInput?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	externalMetadataJSON?: FieldPolicy<any> | FieldReadFunction<any>,
	externalOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	fullNameOrEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idpKey?: FieldPolicy<any> | FieldReadFunction<any>,
	lastLoginAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	licenses?: FieldPolicy<any> | FieldReadFunction<any>,
	pending?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumbers?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryOrganizationDateFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryOrganizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	readonlySuperadmin?: FieldPolicy<any> | FieldReadFunction<any>,
	roleForSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	roleForSystemGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	superadmin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserJobCountKeySpecifier = ('count' | 'senderEmail' | UserJobCountKeySpecifier)[];
export type UserJobCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	senderEmail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserManagerUserKeySpecifier = ('createdAt' | 'deletedAt' | 'email' | 'firstName' | 'id' | 'idpKey' | 'lastLoginAt' | 'lastName' | 'pending' | 'primaryOrganizationName' | 'readonlySuperadmin' | 'superadmin' | UserManagerUserKeySpecifier)[];
export type UserManagerUserFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idpKey?: FieldPolicy<any> | FieldReadFunction<any>,
	lastLoginAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	pending?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryOrganizationName?: FieldPolicy<any> | FieldReadFunction<any>,
	readonlySuperadmin?: FieldPolicy<any> | FieldReadFunction<any>,
	superadmin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserManagerUsersPageKeySpecifier = ('count' | 'items' | UserManagerUsersPageKeySpecifier)[];
export type UserManagerUsersPageFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserNestKeySpecifier = ('displayName' | 'email' | 'enableIphoneMetricNumberInput' | 'externalId' | 'externalOwner' | 'firstName' | 'fullNameOrEmail' | 'id' | 'idpKey' | 'lastLoginAt' | 'lastName' | 'licenses' | 'pending' | 'permissions' | 'phoneNumbers' | 'primaryOrganizationId' | 'readonlySuperadmin' | 'roleForSystem' | 'ssoConfig' | 'subject' | 'superadmin' | UserNestKeySpecifier)[];
export type UserNestFieldPolicy = {
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	enableIphoneMetricNumberInput?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	externalOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	fullNameOrEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idpKey?: FieldPolicy<any> | FieldReadFunction<any>,
	lastLoginAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	licenses?: FieldPolicy<any> | FieldReadFunction<any>,
	pending?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumbers?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryOrganizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	readonlySuperadmin?: FieldPolicy<any> | FieldReadFunction<any>,
	roleForSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	superadmin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserOrganizationPermissionKeySpecifier = ('id' | 'name' | 'organizationId' | 'organizationRole' | 'selfServiceEnabled' | 'systemGroupPermissions' | 'systemPermissions' | UserOrganizationPermissionKeySpecifier)[];
export type UserOrganizationPermissionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationRole?: FieldPolicy<any> | FieldReadFunction<any>,
	selfServiceEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	systemGroupPermissions?: FieldPolicy<any> | FieldReadFunction<any>,
	systemPermissions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserOrganizationPermissionNestKeySpecifier = ('id' | 'name' | 'organizationId' | 'organizationRole' | 'selfServiceEnabled' | 'systemGroupPermissions' | 'systemPermissions' | UserOrganizationPermissionNestKeySpecifier)[];
export type UserOrganizationPermissionNestFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationId?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationRole?: FieldPolicy<any> | FieldReadFunction<any>,
	selfServiceEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	systemGroupPermissions?: FieldPolicy<any> | FieldReadFunction<any>,
	systemPermissions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserStatsKeySpecifier = ('activityCount' | 'user' | UserStatsKeySpecifier)[];
export type UserStatsFieldPolicy = {
	activityCount?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserSystemGroupPermissionKeySpecifier = ('id' | 'name' | 'role' | 'systemGroupId' | UserSystemGroupPermissionKeySpecifier)[];
export type UserSystemGroupPermissionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	systemGroupId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserSystemGroupPermissionNestKeySpecifier = ('id' | 'name' | 'role' | 'systemGroupId' | UserSystemGroupPermissionNestKeySpecifier)[];
export type UserSystemGroupPermissionNestFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	systemGroupId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserSystemPermissionKeySpecifier = ('id' | 'inheritedFromSystemGroupId' | 'isTemplate' | 'name' | 'role' | 'systemId' | UserSystemPermissionKeySpecifier)[];
export type UserSystemPermissionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inheritedFromSystemGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	isTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserSystemPermissionNestKeySpecifier = ('id' | 'inheritedFromSystemGroupId' | 'isTemplate' | 'name' | 'role' | 'systemId' | UserSystemPermissionNestKeySpecifier)[];
export type UserSystemPermissionNestFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inheritedFromSystemGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	isTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	systemId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WaterlyConnectErrorStatsByMonthKeySpecifier = ('errorCountByDay' | 'id' | WaterlyConnectErrorStatsByMonthKeySpecifier)[];
export type WaterlyConnectErrorStatsByMonthFieldPolicy = {
	errorCountByDay?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WaterlyConnectQueueJobCountByEdgeDeviceKeySpecifier = ('activeCount' | 'edgeDeviceId' | 'edgeDeviceName' | 'waitingCount' | WaterlyConnectQueueJobCountByEdgeDeviceKeySpecifier)[];
export type WaterlyConnectQueueJobCountByEdgeDeviceFieldPolicy = {
	activeCount?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDeviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeDeviceName?: FieldPolicy<any> | FieldReadFunction<any>,
	waitingCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WaterlyConnectStatsKeySpecifier = ('activeQueueJobCount' | 'countLast24HourSubmissions' | 'countLast24HourSubmissionsFailed' | 'countLast24HourSubmissionsSuccessful' | 'id' | 'queueJobCountsByEdgeDevice' | 'waitingQueueJobCount' | WaterlyConnectStatsKeySpecifier)[];
export type WaterlyConnectStatsFieldPolicy = {
	activeQueueJobCount?: FieldPolicy<any> | FieldReadFunction<any>,
	countLast24HourSubmissions?: FieldPolicy<any> | FieldReadFunction<any>,
	countLast24HourSubmissionsFailed?: FieldPolicy<any> | FieldReadFunction<any>,
	countLast24HourSubmissionsSuccessful?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	queueJobCountsByEdgeDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	waitingQueueJobCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WeatherDataStationNestKeySpecifier = ('deletedAt' | 'id' | 'latitude' | 'locationName' | 'longitude' | 'stateCode' | 'usgsStationId' | WeatherDataStationNestKeySpecifier)[];
export type WeatherDataStationNestFieldPolicy = {
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	locationName?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	stateCode?: FieldPolicy<any> | FieldReadFunction<any>,
	usgsStationId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	ActiveMetricStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActiveMetricStatsKeySpecifier | (() => undefined | ActiveMetricStatsKeySpecifier),
		fields?: ActiveMetricStatsFieldPolicy,
	},
	ActiveUserStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActiveUserStatsKeySpecifier | (() => undefined | ActiveUserStatsKeySpecifier),
		fields?: ActiveUserStatsFieldPolicy,
	},
	ActivitySchedule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityScheduleKeySpecifier | (() => undefined | ActivityScheduleKeySpecifier),
		fields?: ActivityScheduleFieldPolicy,
	},
	ActivityScheduleWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityScheduleWithCountKeySpecifier | (() => undefined | ActivityScheduleWithCountKeySpecifier),
		fields?: ActivityScheduleWithCountFieldPolicy,
	},
	Address?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressKeySpecifier | (() => undefined | AddressKeySpecifier),
		fields?: AddressFieldPolicy,
	},
	AdminStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminStatsKeySpecifier | (() => undefined | AdminStatsKeySpecifier),
		fields?: AdminStatsFieldPolicy,
	},
	Analyte?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnalyteKeySpecifier | (() => undefined | AnalyteKeySpecifier),
		fields?: AnalyteFieldPolicy,
	},
	AnalyteGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnalyteGroupKeySpecifier | (() => undefined | AnalyteGroupKeySpecifier),
		fields?: AnalyteGroupFieldPolicy,
	},
	AnalyteGroupsWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnalyteGroupsWithCountKeySpecifier | (() => undefined | AnalyteGroupsWithCountKeySpecifier),
		fields?: AnalyteGroupsWithCountFieldPolicy,
	},
	AnalytesWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnalytesWithCountKeySpecifier | (() => undefined | AnalytesWithCountKeySpecifier),
		fields?: AnalytesWithCountFieldPolicy,
	},
	ApiTokenNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ApiTokenNestKeySpecifier | (() => undefined | ApiTokenNestKeySpecifier),
		fields?: ApiTokenNestFieldPolicy,
	},
	AuditEventNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditEventNestKeySpecifier | (() => undefined | AuditEventNestKeySpecifier),
		fields?: AuditEventNestFieldPolicy,
	},
	AuditEventWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditEventWithCountKeySpecifier | (() => undefined | AuditEventWithCountKeySpecifier),
		fields?: AuditEventWithCountFieldPolicy,
	},
	BaseFolder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BaseFolderKeySpecifier | (() => undefined | BaseFolderKeySpecifier),
		fields?: BaseFolderFieldPolicy,
	},
	BaseSchedule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BaseScheduleKeySpecifier | (() => undefined | BaseScheduleKeySpecifier),
		fields?: BaseScheduleFieldPolicy,
	},
	Breadcrumb?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BreadcrumbKeySpecifier | (() => undefined | BreadcrumbKeySpecifier),
		fields?: BreadcrumbFieldPolicy,
	},
	BulkMetricEditorEntityFilterOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkMetricEditorEntityFilterOptionKeySpecifier | (() => undefined | BulkMetricEditorEntityFilterOptionKeySpecifier),
		fields?: BulkMetricEditorEntityFilterOptionFieldPolicy,
	},
	BulkMetricEditorFilterOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkMetricEditorFilterOptionsKeySpecifier | (() => undefined | BulkMetricEditorFilterOptionsKeySpecifier),
		fields?: BulkMetricEditorFilterOptionsFieldPolicy,
	},
	BulkMetricEditorLimitsSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkMetricEditorLimitsSummaryKeySpecifier | (() => undefined | BulkMetricEditorLimitsSummaryKeySpecifier),
		fields?: BulkMetricEditorLimitsSummaryFieldPolicy,
	},
	BulkMetricEditorMetrics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkMetricEditorMetricsKeySpecifier | (() => undefined | BulkMetricEditorMetricsKeySpecifier),
		fields?: BulkMetricEditorMetricsFieldPolicy,
	},
	BulkMetricEditorMetricsCsvExport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkMetricEditorMetricsCsvExportKeySpecifier | (() => undefined | BulkMetricEditorMetricsCsvExportKeySpecifier),
		fields?: BulkMetricEditorMetricsCsvExportFieldPolicy,
	},
	BulkMetricEditorReportAggregationSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkMetricEditorReportAggregationSummaryKeySpecifier | (() => undefined | BulkMetricEditorReportAggregationSummaryKeySpecifier),
		fields?: BulkMetricEditorReportAggregationSummaryFieldPolicy,
	},
	BulkMetricEditorRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkMetricEditorRowKeySpecifier | (() => undefined | BulkMetricEditorRowKeySpecifier),
		fields?: BulkMetricEditorRowFieldPolicy,
	},
	CalcClusterDebug?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CalcClusterDebugKeySpecifier | (() => undefined | CalcClusterDebugKeySpecifier),
		fields?: CalcClusterDebugFieldPolicy,
	},
	CalcClusterDebugLog?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CalcClusterDebugLogKeySpecifier | (() => undefined | CalcClusterDebugLogKeySpecifier),
		fields?: CalcClusterDebugLogFieldPolicy,
	},
	CalcClusterDebugLogStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CalcClusterDebugLogStatsKeySpecifier | (() => undefined | CalcClusterDebugLogStatsKeySpecifier),
		fields?: CalcClusterDebugLogStatsFieldPolicy,
	},
	CalcClusterDebugsWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CalcClusterDebugsWithCountKeySpecifier | (() => undefined | CalcClusterDebugsWithCountKeySpecifier),
		fields?: CalcClusterDebugsWithCountFieldPolicy,
	},
	CalcTree?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CalcTreeKeySpecifier | (() => undefined | CalcTreeKeySpecifier),
		fields?: CalcTreeFieldPolicy,
	},
	CalculatedMetric?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CalculatedMetricKeySpecifier | (() => undefined | CalculatedMetricKeySpecifier),
		fields?: CalculatedMetricFieldPolicy,
	},
	ClonedComponentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClonedComponentPayloadKeySpecifier | (() => undefined | ClonedComponentPayloadKeySpecifier),
		fields?: ClonedComponentPayloadFieldPolicy,
	},
	ClonedProcessPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClonedProcessPayloadKeySpecifier | (() => undefined | ClonedProcessPayloadKeySpecifier),
		fields?: ClonedProcessPayloadFieldPolicy,
	},
	ColumnGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ColumnGroupKeySpecifier | (() => undefined | ColumnGroupKeySpecifier),
		fields?: ColumnGroupFieldPolicy,
	},
	ColumnGroupItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ColumnGroupItemKeySpecifier | (() => undefined | ColumnGroupItemKeySpecifier),
		fields?: ColumnGroupItemFieldPolicy,
	},
	ColumnGroupItemWithMetric?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ColumnGroupItemWithMetricKeySpecifier | (() => undefined | ColumnGroupItemWithMetricKeySpecifier),
		fields?: ColumnGroupItemWithMetricFieldPolicy,
	},
	ColumnGroupWithItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ColumnGroupWithItemsKeySpecifier | (() => undefined | ColumnGroupWithItemsKeySpecifier),
		fields?: ColumnGroupWithItemsFieldPolicy,
	},
	ComponentNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentNestKeySpecifier | (() => undefined | ComponentNestKeySpecifier),
		fields?: ComponentNestFieldPolicy,
	},
	ComponentType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentTypeKeySpecifier | (() => undefined | ComponentTypeKeySpecifier),
		fields?: ComponentTypeFieldPolicy,
	},
	ComponentWithMetrics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentWithMetricsKeySpecifier | (() => undefined | ComponentWithMetricsKeySpecifier),
		fields?: ComponentWithMetricsFieldPolicy,
	},
	ConstantDefinition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConstantDefinitionKeySpecifier | (() => undefined | ConstantDefinitionKeySpecifier),
		fields?: ConstantDefinitionFieldPolicy,
	},
	ConstantImpactedMetric?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConstantImpactedMetricKeySpecifier | (() => undefined | ConstantImpactedMetricKeySpecifier),
		fields?: ConstantImpactedMetricFieldPolicy,
	},
	ConstantRecalculationEstimate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConstantRecalculationEstimateKeySpecifier | (() => undefined | ConstantRecalculationEstimateKeySpecifier),
		fields?: ConstantRecalculationEstimateFieldPolicy,
	},
	ConstantValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConstantValueKeySpecifier | (() => undefined | ConstantValueKeySpecifier),
		fields?: ConstantValueFieldPolicy,
	},
	CreateApiTokenPayloadNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateApiTokenPayloadNestKeySpecifier | (() => undefined | CreateApiTokenPayloadNestKeySpecifier),
		fields?: CreateApiTokenPayloadNestFieldPolicy,
	},
	CreateEnterpriseReportShareLinkPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateEnterpriseReportShareLinkPayloadKeySpecifier | (() => undefined | CreateEnterpriseReportShareLinkPayloadKeySpecifier),
		fields?: CreateEnterpriseReportShareLinkPayloadFieldPolicy,
	},
	DataEntryCompletion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataEntryCompletionKeySpecifier | (() => undefined | DataEntryCompletionKeySpecifier),
		fields?: DataEntryCompletionFieldPolicy,
	},
	DataEntryCompletionsByAppliedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataEntryCompletionsByAppliedAtKeySpecifier | (() => undefined | DataEntryCompletionsByAppliedAtKeySpecifier),
		fields?: DataEntryCompletionsByAppliedAtFieldPolicy,
	},
	DataPointType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataPointTypeKeySpecifier | (() => undefined | DataPointTypeKeySpecifier),
		fields?: DataPointTypeFieldPolicy,
	},
	DataPointValueAndInterval?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataPointValueAndIntervalKeySpecifier | (() => undefined | DataPointValueAndIntervalKeySpecifier),
		fields?: DataPointValueAndIntervalFieldPolicy,
	},
	DataPointsForDay?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataPointsForDayKeySpecifier | (() => undefined | DataPointsForDayKeySpecifier),
		fields?: DataPointsForDayFieldPolicy,
	},
	DiagnosticsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DiagnosticsResultKeySpecifier | (() => undefined | DiagnosticsResultKeySpecifier),
		fields?: DiagnosticsResultFieldPolicy,
	},
	EdgeDeviceNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EdgeDeviceNestKeySpecifier | (() => undefined | EdgeDeviceNestKeySpecifier),
		fields?: EdgeDeviceNestFieldPolicy,
	},
	EdgeDeviceSubmission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EdgeDeviceSubmissionKeySpecifier | (() => undefined | EdgeDeviceSubmissionKeySpecifier),
		fields?: EdgeDeviceSubmissionFieldPolicy,
	},
	EdgeDeviceSubmissionSummariesWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EdgeDeviceSubmissionSummariesWithCountKeySpecifier | (() => undefined | EdgeDeviceSubmissionSummariesWithCountKeySpecifier),
		fields?: EdgeDeviceSubmissionSummariesWithCountFieldPolicy,
	},
	EdgeDeviceSubmissionSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EdgeDeviceSubmissionSummaryKeySpecifier | (() => undefined | EdgeDeviceSubmissionSummaryKeySpecifier),
		fields?: EdgeDeviceSubmissionSummaryFieldPolicy,
	},
	EdgeDeviceType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EdgeDeviceTypeKeySpecifier | (() => undefined | EdgeDeviceTypeKeySpecifier),
		fields?: EdgeDeviceTypeFieldPolicy,
	},
	EnterpriseReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnterpriseReportKeySpecifier | (() => undefined | EnterpriseReportKeySpecifier),
		fields?: EnterpriseReportFieldPolicy,
	},
	EnterpriseReportShareLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnterpriseReportShareLinkKeySpecifier | (() => undefined | EnterpriseReportShareLinkKeySpecifier),
		fields?: EnterpriseReportShareLinkFieldPolicy,
	},
	EnterpriseReportShareLinkAccessRequestPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnterpriseReportShareLinkAccessRequestPayloadKeySpecifier | (() => undefined | EnterpriseReportShareLinkAccessRequestPayloadKeySpecifier),
		fields?: EnterpriseReportShareLinkAccessRequestPayloadFieldPolicy,
	},
	EnterpriseReportShareLinkResolution?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnterpriseReportShareLinkResolutionKeySpecifier | (() => undefined | EnterpriseReportShareLinkResolutionKeySpecifier),
		fields?: EnterpriseReportShareLinkResolutionFieldPolicy,
	},
	EntrySparklineDataPointType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntrySparklineDataPointTypeKeySpecifier | (() => undefined | EntrySparklineDataPointTypeKeySpecifier),
		fields?: EntrySparklineDataPointTypeFieldPolicy,
	},
	EntrySparklineType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntrySparklineTypeKeySpecifier | (() => undefined | EntrySparklineTypeKeySpecifier),
		fields?: EntrySparklineTypeFieldPolicy,
	},
	EntryTSDataPoint?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntryTSDataPointKeySpecifier | (() => undefined | EntryTSDataPointKeySpecifier),
		fields?: EntryTSDataPointFieldPolicy,
	},
	EntryTSDataPointMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntryTSDataPointMetadataKeySpecifier | (() => undefined | EntryTSDataPointMetadataKeySpecifier),
		fields?: EntryTSDataPointMetadataFieldPolicy,
	},
	ExternalFacility?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalFacilityKeySpecifier | (() => undefined | ExternalFacilityKeySpecifier),
		fields?: ExternalFacilityFieldPolicy,
	},
	ExternalSystem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalSystemKeySpecifier | (() => undefined | ExternalSystemKeySpecifier),
		fields?: ExternalSystemFieldPolicy,
	},
	FolderWithMetricIdsAndOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FolderWithMetricIdsAndOrderKeySpecifier | (() => undefined | FolderWithMetricIdsAndOrderKeySpecifier),
		fields?: FolderWithMetricIdsAndOrderFieldPolicy,
	},
	GroupCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupCountKeySpecifier | (() => undefined | GroupCountKeySpecifier),
		fields?: GroupCountFieldPolicy,
	},
	GroupQueueCounts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupQueueCountsKeySpecifier | (() => undefined | GroupQueueCountsKeySpecifier),
		fields?: GroupQueueCountsFieldPolicy,
	},
	Interval?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IntervalKeySpecifier | (() => undefined | IntervalKeySpecifier),
		fields?: IntervalFieldPolicy,
	},
	IntervalNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IntervalNestKeySpecifier | (() => undefined | IntervalNestKeySpecifier),
		fields?: IntervalNestFieldPolicy,
	},
	IntervalsWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IntervalsWithCountKeySpecifier | (() => undefined | IntervalsWithCountKeySpecifier),
		fields?: IntervalsWithCountFieldPolicy,
	},
	JobEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JobEventKeySpecifier | (() => undefined | JobEventKeySpecifier),
		fields?: JobEventFieldPolicy,
	},
	JobLite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JobLiteKeySpecifier | (() => undefined | JobLiteKeySpecifier),
		fields?: JobLiteFieldPolicy,
	},
	LabImportBatch?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportBatchKeySpecifier | (() => undefined | LabImportBatchKeySpecifier),
		fields?: LabImportBatchFieldPolicy,
	},
	LabImportBatchResume?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportBatchResumeKeySpecifier | (() => undefined | LabImportBatchResumeKeySpecifier),
		fields?: LabImportBatchResumeFieldPolicy,
	},
	LabImportBatchSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportBatchSummaryKeySpecifier | (() => undefined | LabImportBatchSummaryKeySpecifier),
		fields?: LabImportBatchSummaryFieldPolicy,
	},
	LabImportBatchesPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportBatchesPageKeySpecifier | (() => undefined | LabImportBatchesPageKeySpecifier),
		fields?: LabImportBatchesPageFieldPolicy,
	},
	LabImportColumnMapping?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportColumnMappingKeySpecifier | (() => undefined | LabImportColumnMappingKeySpecifier),
		fields?: LabImportColumnMappingFieldPolicy,
	},
	LabImportCommitResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportCommitResultKeySpecifier | (() => undefined | LabImportCommitResultKeySpecifier),
		fields?: LabImportCommitResultFieldPolicy,
	},
	LabImportFileDownload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportFileDownloadKeySpecifier | (() => undefined | LabImportFileDownloadKeySpecifier),
		fields?: LabImportFileDownloadFieldPolicy,
	},
	LabImportParserConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportParserConfigKeySpecifier | (() => undefined | LabImportParserConfigKeySpecifier),
		fields?: LabImportParserConfigFieldPolicy,
	},
	LabImportPendingProfile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportPendingProfileKeySpecifier | (() => undefined | LabImportPendingProfileKeySpecifier),
		fields?: LabImportPendingProfileFieldPolicy,
	},
	LabImportProfile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportProfileKeySpecifier | (() => undefined | LabImportProfileKeySpecifier),
		fields?: LabImportProfileFieldPolicy,
	},
	LabImportProfileDefinition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportProfileDefinitionKeySpecifier | (() => undefined | LabImportProfileDefinitionKeySpecifier),
		fields?: LabImportProfileDefinitionFieldPolicy,
	},
	LabImportProfileValidation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportProfileValidationKeySpecifier | (() => undefined | LabImportProfileValidationKeySpecifier),
		fields?: LabImportProfileValidationFieldPolicy,
	},
	LabImportProfileValidationIssue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportProfileValidationIssueKeySpecifier | (() => undefined | LabImportProfileValidationIssueKeySpecifier),
		fields?: LabImportProfileValidationIssueFieldPolicy,
	},
	LabImportProfileVersion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportProfileVersionKeySpecifier | (() => undefined | LabImportProfileVersionKeySpecifier),
		fields?: LabImportProfileVersionFieldPolicy,
	},
	LabImportRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportRowKeySpecifier | (() => undefined | LabImportRowKeySpecifier),
		fields?: LabImportRowFieldPolicy,
	},
	LabImportRowsPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportRowsPageKeySpecifier | (() => undefined | LabImportRowsPageKeySpecifier),
		fields?: LabImportRowsPageFieldPolicy,
	},
	LabImportSourceGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportSourceGroupKeySpecifier | (() => undefined | LabImportSourceGroupKeySpecifier),
		fields?: LabImportSourceGroupFieldPolicy,
	},
	LabImportTarget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportTargetKeySpecifier | (() => undefined | LabImportTargetKeySpecifier),
		fields?: LabImportTargetFieldPolicy,
	},
	LabImportTargetMapping?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportTargetMappingKeySpecifier | (() => undefined | LabImportTargetMappingKeySpecifier),
		fields?: LabImportTargetMappingFieldPolicy,
	},
	LabImportValidationResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabImportValidationResultKeySpecifier | (() => undefined | LabImportValidationResultKeySpecifier),
		fields?: LabImportValidationResultFieldPolicy,
	},
	LicenseNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LicenseNestKeySpecifier | (() => undefined | LicenseNestKeySpecifier),
		fields?: LicenseNestFieldPolicy,
	},
	LogBookEntriesWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LogBookEntriesWithCountKeySpecifier | (() => undefined | LogBookEntriesWithCountKeySpecifier),
		fields?: LogBookEntriesWithCountFieldPolicy,
	},
	LogBookEntryAttachmentsNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LogBookEntryAttachmentsNestKeySpecifier | (() => undefined | LogBookEntryAttachmentsNestKeySpecifier),
		fields?: LogBookEntryAttachmentsNestFieldPolicy,
	},
	LogBookEntryDashboardViewNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LogBookEntryDashboardViewNestKeySpecifier | (() => undefined | LogBookEntryDashboardViewNestKeySpecifier),
		fields?: LogBookEntryDashboardViewNestFieldPolicy,
	},
	LogBookEntryNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LogBookEntryNestKeySpecifier | (() => undefined | LogBookEntryNestKeySpecifier),
		fields?: LogBookEntryNestFieldPolicy,
	},
	ManualReportEmailEligibleRecipient?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManualReportEmailEligibleRecipientKeySpecifier | (() => undefined | ManualReportEmailEligibleRecipientKeySpecifier),
		fields?: ManualReportEmailEligibleRecipientFieldPolicy,
	},
	ManualReportEmailEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManualReportEmailEventKeySpecifier | (() => undefined | ManualReportEmailEventKeySpecifier),
		fields?: ManualReportEmailEventFieldPolicy,
	},
	ManualReportEmailRecipient?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManualReportEmailRecipientKeySpecifier | (() => undefined | ManualReportEmailRecipientKeySpecifier),
		fields?: ManualReportEmailRecipientFieldPolicy,
	},
	ManualReportEmailSharingScope?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManualReportEmailSharingScopeKeySpecifier | (() => undefined | ManualReportEmailSharingScopeKeySpecifier),
		fields?: ManualReportEmailSharingScopeFieldPolicy,
	},
	MetricChartDataContainerType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricChartDataContainerTypeKeySpecifier | (() => undefined | MetricChartDataContainerTypeKeySpecifier),
		fields?: MetricChartDataContainerTypeFieldPolicy,
	},
	MetricChartDataPointType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricChartDataPointTypeKeySpecifier | (() => undefined | MetricChartDataPointTypeKeySpecifier),
		fields?: MetricChartDataPointTypeFieldPolicy,
	},
	MetricChartDataType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricChartDataTypeKeySpecifier | (() => undefined | MetricChartDataTypeKeySpecifier),
		fields?: MetricChartDataTypeFieldPolicy,
	},
	MetricDataPointType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricDataPointTypeKeySpecifier | (() => undefined | MetricDataPointTypeKeySpecifier),
		fields?: MetricDataPointTypeFieldPolicy,
	},
	MetricKeyname?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricKeynameKeySpecifier | (() => undefined | MetricKeynameKeySpecifier),
		fields?: MetricKeynameFieldPolicy,
	},
	MetricKeynameJoinedWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricKeynameJoinedWithCountKeySpecifier | (() => undefined | MetricKeynameJoinedWithCountKeySpecifier),
		fields?: MetricKeynameJoinedWithCountFieldPolicy,
	},
	MetricKeynameWithUnitsAndTags?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricKeynameWithUnitsAndTagsKeySpecifier | (() => undefined | MetricKeynameWithUnitsAndTagsKeySpecifier),
		fields?: MetricKeynameWithUnitsAndTagsFieldPolicy,
	},
	MetricNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricNestKeySpecifier | (() => undefined | MetricNestKeySpecifier),
		fields?: MetricNestFieldPolicy,
	},
	MetricOrderWithMetricId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricOrderWithMetricIdKeySpecifier | (() => undefined | MetricOrderWithMetricIdKeySpecifier),
		fields?: MetricOrderWithMetricIdFieldPolicy,
	},
	MetricRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricRangeKeySpecifier | (() => undefined | MetricRangeKeySpecifier),
		fields?: MetricRangeFieldPolicy,
	},
	MetricType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricTypeKeySpecifier | (() => undefined | MetricTypeKeySpecifier),
		fields?: MetricTypeFieldPolicy,
	},
	MetricWithCalculatedMetric?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricWithCalculatedMetricKeySpecifier | (() => undefined | MetricWithCalculatedMetricKeySpecifier),
		fields?: MetricWithCalculatedMetricFieldPolicy,
	},
	MetricWithCalculatedMetrics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricWithCalculatedMetricsKeySpecifier | (() => undefined | MetricWithCalculatedMetricsKeySpecifier),
		fields?: MetricWithCalculatedMetricsFieldPolicy,
	},
	MetricWithRelatedMetrics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricWithRelatedMetricsKeySpecifier | (() => undefined | MetricWithRelatedMetricsKeySpecifier),
		fields?: MetricWithRelatedMetricsFieldPolicy,
	},
	MetricWithReportData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricWithReportDataKeySpecifier | (() => undefined | MetricWithReportDataKeySpecifier),
		fields?: MetricWithReportDataFieldPolicy,
	},
	MetricWithSPCIntervalsUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricWithSPCIntervalsUnitKeySpecifier | (() => undefined | MetricWithSPCIntervalsUnitKeySpecifier),
		fields?: MetricWithSPCIntervalsUnitFieldPolicy,
	},
	MigrateSiteDataToTimeSeriesResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MigrateSiteDataToTimeSeriesResultKeySpecifier | (() => undefined | MigrateSiteDataToTimeSeriesResultKeySpecifier),
		fields?: MigrateSiteDataToTimeSeriesResultFieldPolicy,
	},
	MintedApiTokenCredentialsNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MintedApiTokenCredentialsNestKeySpecifier | (() => undefined | MintedApiTokenCredentialsNestKeySpecifier),
		fields?: MintedApiTokenCredentialsNestFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	Notification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationKeySpecifier | (() => undefined | NotificationKeySpecifier),
		fields?: NotificationFieldPolicy,
	},
	NotificationsWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationsWithCountKeySpecifier | (() => undefined | NotificationsWithCountKeySpecifier),
		fields?: NotificationsWithCountFieldPolicy,
	},
	OrganizationIntegrationNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationIntegrationNestKeySpecifier | (() => undefined | OrganizationIntegrationNestKeySpecifier),
		fields?: OrganizationIntegrationNestFieldPolicy,
	},
	OrganizationNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationNestKeySpecifier | (() => undefined | OrganizationNestKeySpecifier),
		fields?: OrganizationNestFieldPolicy,
	},
	OrganizationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationTypeKeySpecifier | (() => undefined | OrganizationTypeKeySpecifier),
		fields?: OrganizationTypeFieldPolicy,
	},
	Permit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PermitKeySpecifier | (() => undefined | PermitKeySpecifier),
		fields?: PermitFieldPolicy,
	},
	PhoneNumberNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhoneNumberNestKeySpecifier | (() => undefined | PhoneNumberNestKeySpecifier),
		fields?: PhoneNumberNestFieldPolicy,
	},
	Phrase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhraseKeySpecifier | (() => undefined | PhraseKeySpecifier),
		fields?: PhraseFieldPolicy,
	},
	ProcessNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProcessNestKeySpecifier | (() => undefined | ProcessNestKeySpecifier),
		fields?: ProcessNestFieldPolicy,
	},
	ProcessType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProcessTypeKeySpecifier | (() => undefined | ProcessTypeKeySpecifier),
		fields?: ProcessTypeFieldPolicy,
	},
	ProcessWithComponentsAndMetrics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProcessWithComponentsAndMetricsKeySpecifier | (() => undefined | ProcessWithComponentsAndMetricsKeySpecifier),
		fields?: ProcessWithComponentsAndMetricsFieldPolicy,
	},
	ProcessWithReportData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProcessWithReportDataKeySpecifier | (() => undefined | ProcessWithReportDataKeySpecifier),
		fields?: ProcessWithReportDataFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	QueueStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueueStatsKeySpecifier | (() => undefined | QueueStatsKeySpecifier),
		fields?: QueueStatsFieldPolicy,
	},
	QueuedRecalculation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueuedRecalculationKeySpecifier | (() => undefined | QueuedRecalculationKeySpecifier),
		fields?: QueuedRecalculationFieldPolicy,
	},
	RecalculatedMetricData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RecalculatedMetricDataKeySpecifier | (() => undefined | RecalculatedMetricDataKeySpecifier),
		fields?: RecalculatedMetricDataFieldPolicy,
	},
	RecalculatedMetricsEstimate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RecalculatedMetricsEstimateKeySpecifier | (() => undefined | RecalculatedMetricsEstimateKeySpecifier),
		fields?: RecalculatedMetricsEstimateFieldPolicy,
	},
	RecalculatedMetricsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RecalculatedMetricsResultKeySpecifier | (() => undefined | RecalculatedMetricsResultKeySpecifier),
		fields?: RecalculatedMetricsResultFieldPolicy,
	},
	RegulatoryReportDefinitionForGroupingNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegulatoryReportDefinitionForGroupingNestKeySpecifier | (() => undefined | RegulatoryReportDefinitionForGroupingNestKeySpecifier),
		fields?: RegulatoryReportDefinitionForGroupingNestFieldPolicy,
	},
	ReportData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportDataKeySpecifier | (() => undefined | ReportDataKeySpecifier),
		fields?: ReportDataFieldPolicy,
	},
	ReportDataFlatTree?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportDataFlatTreeKeySpecifier | (() => undefined | ReportDataFlatTreeKeySpecifier),
		fields?: ReportDataFlatTreeFieldPolicy,
	},
	ReportDefinition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportDefinitionKeySpecifier | (() => undefined | ReportDefinitionKeySpecifier),
		fields?: ReportDefinitionFieldPolicy,
	},
	ReportDefinitionDiscoveryFilterCounts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportDefinitionDiscoveryFilterCountsKeySpecifier | (() => undefined | ReportDefinitionDiscoveryFilterCountsKeySpecifier),
		fields?: ReportDefinitionDiscoveryFilterCountsFieldPolicy,
	},
	ReportDefinitionDiscoveryFrequencyCounts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportDefinitionDiscoveryFrequencyCountsKeySpecifier | (() => undefined | ReportDefinitionDiscoveryFrequencyCountsKeySpecifier),
		fields?: ReportDefinitionDiscoveryFrequencyCountsFieldPolicy,
	},
	ReportDefinitionDiscoveryScopeCounts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportDefinitionDiscoveryScopeCountsKeySpecifier | (() => undefined | ReportDefinitionDiscoveryScopeCountsKeySpecifier),
		fields?: ReportDefinitionDiscoveryScopeCountsFieldPolicy,
	},
	ReportDefinitionNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportDefinitionNestKeySpecifier | (() => undefined | ReportDefinitionNestKeySpecifier),
		fields?: ReportDefinitionNestFieldPolicy,
	},
	ReportDefinitionsForDiscoveryWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportDefinitionsForDiscoveryWithCountKeySpecifier | (() => undefined | ReportDefinitionsForDiscoveryWithCountKeySpecifier),
		fields?: ReportDefinitionsForDiscoveryWithCountFieldPolicy,
	},
	ReportDiscoveryItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportDiscoveryItemKeySpecifier | (() => undefined | ReportDiscoveryItemKeySpecifier),
		fields?: ReportDiscoveryItemFieldPolicy,
	},
	ReportDiscoverySiteNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportDiscoverySiteNestKeySpecifier | (() => undefined | ReportDiscoverySiteNestKeySpecifier),
		fields?: ReportDiscoverySiteNestFieldPolicy,
	},
	ReportDiscoverySnapshot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportDiscoverySnapshotKeySpecifier | (() => undefined | ReportDiscoverySnapshotKeySpecifier),
		fields?: ReportDiscoverySnapshotFieldPolicy,
	},
	ReportDiscoverySystemNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportDiscoverySystemNestKeySpecifier | (() => undefined | ReportDiscoverySystemNestKeySpecifier),
		fields?: ReportDiscoverySystemNestFieldPolicy,
	},
	ReportDistributionList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportDistributionListKeySpecifier | (() => undefined | ReportDistributionListKeySpecifier),
		fields?: ReportDistributionListFieldPolicy,
	},
	ReportDistributionListMember?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportDistributionListMemberKeySpecifier | (() => undefined | ReportDistributionListMemberKeySpecifier),
		fields?: ReportDistributionListMemberFieldPolicy,
	},
	ReportGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportGroupKeySpecifier | (() => undefined | ReportGroupKeySpecifier),
		fields?: ReportGroupFieldPolicy,
	},
	ReportNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportNestKeySpecifier | (() => undefined | ReportNestKeySpecifier),
		fields?: ReportNestFieldPolicy,
	},
	ReportNode?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportNodeKeySpecifier | (() => undefined | ReportNodeKeySpecifier),
		fields?: ReportNodeFieldPolicy,
	},
	ReportNodeWithRelations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportNodeWithRelationsKeySpecifier | (() => undefined | ReportNodeWithRelationsKeySpecifier),
		fields?: ReportNodeWithRelationsFieldPolicy,
	},
	ReportSnapshot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportSnapshotKeySpecifier | (() => undefined | ReportSnapshotKeySpecifier),
		fields?: ReportSnapshotFieldPolicy,
	},
	ReportSnapshotItemsWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportSnapshotItemsWithCountKeySpecifier | (() => undefined | ReportSnapshotItemsWithCountKeySpecifier),
		fields?: ReportSnapshotItemsWithCountFieldPolicy,
	},
	ReportTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportTemplateKeySpecifier | (() => undefined | ReportTemplateKeySpecifier),
		fields?: ReportTemplateFieldPolicy,
	},
	ReportingReportGroupNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportingReportGroupNestKeySpecifier | (() => undefined | ReportingReportGroupNestKeySpecifier),
		fields?: ReportingReportGroupNestFieldPolicy,
	},
	ResolvedConstant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResolvedConstantKeySpecifier | (() => undefined | ResolvedConstantKeySpecifier),
		fields?: ResolvedConstantFieldPolicy,
	},
	RetentionRiskNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RetentionRiskNestKeySpecifier | (() => undefined | RetentionRiskNestKeySpecifier),
		fields?: RetentionRiskNestFieldPolicy,
	},
	RetentionRiskResultNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RetentionRiskResultNestKeySpecifier | (() => undefined | RetentionRiskResultNestKeySpecifier),
		fields?: RetentionRiskResultNestFieldPolicy,
	},
	RoundsAssetsMappingNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoundsAssetsMappingNestKeySpecifier | (() => undefined | RoundsAssetsMappingNestKeySpecifier),
		fields?: RoundsAssetsMappingNestFieldPolicy,
	},
	RoundsShiftNoteAssetChoice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoundsShiftNoteAssetChoiceKeySpecifier | (() => undefined | RoundsShiftNoteAssetChoiceKeySpecifier),
		fields?: RoundsShiftNoteAssetChoiceFieldPolicy,
	},
	RoundsShiftNoteAssigneeRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoundsShiftNoteAssigneeRoleKeySpecifier | (() => undefined | RoundsShiftNoteAssigneeRoleKeySpecifier),
		fields?: RoundsShiftNoteAssigneeRoleFieldPolicy,
	},
	RoundsShiftNoteAssigneeUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoundsShiftNoteAssigneeUserKeySpecifier | (() => undefined | RoundsShiftNoteAssigneeUserKeySpecifier),
		fields?: RoundsShiftNoteAssigneeUserFieldPolicy,
	},
	RoundsShiftNoteCreateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoundsShiftNoteCreateResultKeySpecifier | (() => undefined | RoundsShiftNoteCreateResultKeySpecifier),
		fields?: RoundsShiftNoteCreateResultFieldPolicy,
	},
	RoundsShiftNoteFormContext?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoundsShiftNoteFormContextKeySpecifier | (() => undefined | RoundsShiftNoteFormContextKeySpecifier),
		fields?: RoundsShiftNoteFormContextFieldPolicy,
	},
	RoundsShiftNoteLocationTier?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoundsShiftNoteLocationTierKeySpecifier | (() => undefined | RoundsShiftNoteLocationTierKeySpecifier),
		fields?: RoundsShiftNoteLocationTierFieldPolicy,
	},
	RoundsShiftNoteSystemChoice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoundsShiftNoteSystemChoiceKeySpecifier | (() => undefined | RoundsShiftNoteSystemChoiceKeySpecifier),
		fields?: RoundsShiftNoteSystemChoiceFieldPolicy,
	},
	RuntimeLogger?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RuntimeLoggerKeySpecifier | (() => undefined | RuntimeLoggerKeySpecifier),
		fields?: RuntimeLoggerFieldPolicy,
	},
	RuntimeLoggerDefault?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RuntimeLoggerDefaultKeySpecifier | (() => undefined | RuntimeLoggerDefaultKeySpecifier),
		fields?: RuntimeLoggerDefaultFieldPolicy,
	},
	RuntimeLoggerOverride?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RuntimeLoggerOverrideKeySpecifier | (() => undefined | RuntimeLoggerOverrideKeySpecifier),
		fields?: RuntimeLoggerOverrideFieldPolicy,
	},
	RuntimeLoggerSnapshot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RuntimeLoggerSnapshotKeySpecifier | (() => undefined | RuntimeLoggerSnapshotKeySpecifier),
		fields?: RuntimeLoggerSnapshotFieldPolicy,
	},
	SSOConfigurationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SSOConfigurationTypeKeySpecifier | (() => undefined | SSOConfigurationTypeKeySpecifier),
		fields?: SSOConfigurationTypeFieldPolicy,
	},
	SSODirectoryUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SSODirectoryUserKeySpecifier | (() => undefined | SSODirectoryUserKeySpecifier),
		fields?: SSODirectoryUserFieldPolicy,
	},
	SampleCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SampleCollectionKeySpecifier | (() => undefined | SampleCollectionKeySpecifier),
		fields?: SampleCollectionFieldPolicy,
	},
	SampleCollectionComment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SampleCollectionCommentKeySpecifier | (() => undefined | SampleCollectionCommentKeySpecifier),
		fields?: SampleCollectionCommentFieldPolicy,
	},
	SampleCollectionCustodiesWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SampleCollectionCustodiesWithCountKeySpecifier | (() => undefined | SampleCollectionCustodiesWithCountKeySpecifier),
		fields?: SampleCollectionCustodiesWithCountFieldPolicy,
	},
	SampleCollectionCustody?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SampleCollectionCustodyKeySpecifier | (() => undefined | SampleCollectionCustodyKeySpecifier),
		fields?: SampleCollectionCustodyFieldPolicy,
	},
	SampleCollectionResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SampleCollectionResultKeySpecifier | (() => undefined | SampleCollectionResultKeySpecifier),
		fields?: SampleCollectionResultFieldPolicy,
	},
	SampleCollectionsWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SampleCollectionsWithCountKeySpecifier | (() => undefined | SampleCollectionsWithCountKeySpecifier),
		fields?: SampleCollectionsWithCountFieldPolicy,
	},
	SampleSchedule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SampleScheduleKeySpecifier | (() => undefined | SampleScheduleKeySpecifier),
		fields?: SampleScheduleFieldPolicy,
	},
	SampleScheduleAnalyte?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SampleScheduleAnalyteKeySpecifier | (() => undefined | SampleScheduleAnalyteKeySpecifier),
		fields?: SampleScheduleAnalyteFieldPolicy,
	},
	SampleScheduleAnalytesWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SampleScheduleAnalytesWithCountKeySpecifier | (() => undefined | SampleScheduleAnalytesWithCountKeySpecifier),
		fields?: SampleScheduleAnalytesWithCountFieldPolicy,
	},
	SampleSchedulesWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SampleSchedulesWithCountKeySpecifier | (() => undefined | SampleSchedulesWithCountKeySpecifier),
		fields?: SampleSchedulesWithCountFieldPolicy,
	},
	SampleSite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SampleSiteKeySpecifier | (() => undefined | SampleSiteKeySpecifier),
		fields?: SampleSiteFieldPolicy,
	},
	SampleSiteUpload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SampleSiteUploadKeySpecifier | (() => undefined | SampleSiteUploadKeySpecifier),
		fields?: SampleSiteUploadFieldPolicy,
	},
	ScheduledItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduledItemKeySpecifier | (() => undefined | ScheduledItemKeySpecifier),
		fields?: ScheduledItemFieldPolicy,
	},
	ScheduledItemComment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduledItemCommentKeySpecifier | (() => undefined | ScheduledItemCommentKeySpecifier),
		fields?: ScheduledItemCommentFieldPolicy,
	},
	ScheduledItemCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduledItemCountKeySpecifier | (() => undefined | ScheduledItemCountKeySpecifier),
		fields?: ScheduledItemCountFieldPolicy,
	},
	ScheduledItemUpload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduledItemUploadKeySpecifier | (() => undefined | ScheduledItemUploadKeySpecifier),
		fields?: ScheduledItemUploadFieldPolicy,
	},
	ScheduledItemsWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduledItemsWithCountKeySpecifier | (() => undefined | ScheduledItemsWithCountKeySpecifier),
		fields?: ScheduledItemsWithCountFieldPolicy,
	},
	SendManualReportEmailPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendManualReportEmailPayloadKeySpecifier | (() => undefined | SendManualReportEmailPayloadKeySpecifier),
		fields?: SendManualReportEmailPayloadFieldPolicy,
	},
	SiteDataEntriesCollectionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SiteDataEntriesCollectionTypeKeySpecifier | (() => undefined | SiteDataEntriesCollectionTypeKeySpecifier),
		fields?: SiteDataEntriesCollectionTypeFieldPolicy,
	},
	SiteDataEntriesDayDataPointType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SiteDataEntriesDayDataPointTypeKeySpecifier | (() => undefined | SiteDataEntriesDayDataPointTypeKeySpecifier),
		fields?: SiteDataEntriesDayDataPointTypeFieldPolicy,
	},
	SiteDataEntriesDayType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SiteDataEntriesDayTypeKeySpecifier | (() => undefined | SiteDataEntriesDayTypeKeySpecifier),
		fields?: SiteDataEntriesDayTypeFieldPolicy,
	},
	SiteDataEntriesHistoryCollectionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SiteDataEntriesHistoryCollectionTypeKeySpecifier | (() => undefined | SiteDataEntriesHistoryCollectionTypeKeySpecifier),
		fields?: SiteDataEntriesHistoryCollectionTypeFieldPolicy,
	},
	SiteDataEntryChangeType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SiteDataEntryChangeTypeKeySpecifier | (() => undefined | SiteDataEntryChangeTypeKeySpecifier),
		fields?: SiteDataEntryChangeTypeFieldPolicy,
	},
	SiteDataEntryCompletionByDate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SiteDataEntryCompletionByDateKeySpecifier | (() => undefined | SiteDataEntryCompletionByDateKeySpecifier),
		fields?: SiteDataEntryCompletionByDateFieldPolicy,
	},
	SiteFlexMetric?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SiteFlexMetricKeySpecifier | (() => undefined | SiteFlexMetricKeySpecifier),
		fields?: SiteFlexMetricFieldPolicy,
	},
	SiteFlexMetricWithParentSite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SiteFlexMetricWithParentSiteKeySpecifier | (() => undefined | SiteFlexMetricWithParentSiteKeySpecifier),
		fields?: SiteFlexMetricWithParentSiteFieldPolicy,
	},
	SiteIntervalCompletionStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SiteIntervalCompletionStatusKeySpecifier | (() => undefined | SiteIntervalCompletionStatusKeySpecifier),
		fields?: SiteIntervalCompletionStatusFieldPolicy,
	},
	SiteNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SiteNestKeySpecifier | (() => undefined | SiteNestKeySpecifier),
		fields?: SiteNestFieldPolicy,
	},
	SiteOutOfIdealRangeMetricType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SiteOutOfIdealRangeMetricTypeKeySpecifier | (() => undefined | SiteOutOfIdealRangeMetricTypeKeySpecifier),
		fields?: SiteOutOfIdealRangeMetricTypeFieldPolicy,
	},
	SiteOutOfRangeMetricType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SiteOutOfRangeMetricTypeKeySpecifier | (() => undefined | SiteOutOfRangeMetricTypeKeySpecifier),
		fields?: SiteOutOfRangeMetricTypeFieldPolicy,
	},
	SiteType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SiteTypeKeySpecifier | (() => undefined | SiteTypeKeySpecifier),
		fields?: SiteTypeFieldPolicy,
	},
	SiteWithProcesses?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SiteWithProcessesKeySpecifier | (() => undefined | SiteWithProcessesKeySpecifier),
		fields?: SiteWithProcessesFieldPolicy,
	},
	SsoConfigurationNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SsoConfigurationNestKeySpecifier | (() => undefined | SsoConfigurationNestKeySpecifier),
		fields?: SsoConfigurationNestFieldPolicy,
	},
	Subscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionKeySpecifier | (() => undefined | SubscriptionKeySpecifier),
		fields?: SubscriptionFieldPolicy,
	},
	SuccessResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SuccessResponseKeySpecifier | (() => undefined | SuccessResponseKeySpecifier),
		fields?: SuccessResponseFieldPolicy,
	},
	SystemGroupType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SystemGroupTypeKeySpecifier | (() => undefined | SystemGroupTypeKeySpecifier),
		fields?: SystemGroupTypeFieldPolicy,
	},
	SystemNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SystemNestKeySpecifier | (() => undefined | SystemNestKeySpecifier),
		fields?: SystemNestFieldPolicy,
	},
	SystemType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SystemTypeKeySpecifier | (() => undefined | SystemTypeKeySpecifier),
		fields?: SystemTypeFieldPolicy,
	},
	SystemWithSites?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SystemWithSitesKeySpecifier | (() => undefined | SystemWithSitesKeySpecifier),
		fields?: SystemWithSitesFieldPolicy,
	},
	TSDataPoint?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TSDataPointKeySpecifier | (() => undefined | TSDataPointKeySpecifier),
		fields?: TSDataPointFieldPolicy,
	},
	TSDataPointMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TSDataPointMetadataKeySpecifier | (() => undefined | TSDataPointMetadataKeySpecifier),
		fields?: TSDataPointMetadataFieldPolicy,
	},
	Tag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagKeySpecifier | (() => undefined | TagKeySpecifier),
		fields?: TagFieldPolicy,
	},
	TagMappingType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagMappingTypeKeySpecifier | (() => undefined | TagMappingTypeKeySpecifier),
		fields?: TagMappingTypeFieldPolicy,
	},
	TagMappingsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagMappingsResultKeySpecifier | (() => undefined | TagMappingsResultKeySpecifier),
		fields?: TagMappingsResultFieldPolicy,
	},
	TagsWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagsWithCountKeySpecifier | (() => undefined | TagsWithCountKeySpecifier),
		fields?: TagsWithCountFieldPolicy,
	},
	TransactionInfoWithCalcClusterDebugLogs?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionInfoWithCalcClusterDebugLogsKeySpecifier | (() => undefined | TransactionInfoWithCalcClusterDebugLogsKeySpecifier),
		fields?: TransactionInfoWithCalcClusterDebugLogsFieldPolicy,
	},
	TrendNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TrendNestKeySpecifier | (() => undefined | TrendNestKeySpecifier),
		fields?: TrendNestFieldPolicy,
	},
	UnitNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnitNestKeySpecifier | (() => undefined | UnitNestKeySpecifier),
		fields?: UnitNestFieldPolicy,
	},
	UnitType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnitTypeKeySpecifier | (() => undefined | UnitTypeKeySpecifier),
		fields?: UnitTypeFieldPolicy,
	},
	UpdateEnterpriseReportShareLinkPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateEnterpriseReportShareLinkPayloadKeySpecifier | (() => undefined | UpdateEnterpriseReportShareLinkPayloadKeySpecifier),
		fields?: UpdateEnterpriseReportShareLinkPayloadFieldPolicy,
	},
	Upload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadKeySpecifier | (() => undefined | UploadKeySpecifier),
		fields?: UploadFieldPolicy,
	},
	UploadBlobInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadBlobInfoKeySpecifier | (() => undefined | UploadBlobInfoKeySpecifier),
		fields?: UploadBlobInfoFieldPolicy,
	},
	UploadsWithCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadsWithCountKeySpecifier | (() => undefined | UploadsWithCountKeySpecifier),
		fields?: UploadsWithCountFieldPolicy,
	},
	UserInfoType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserInfoTypeKeySpecifier | (() => undefined | UserInfoTypeKeySpecifier),
		fields?: UserInfoTypeFieldPolicy,
	},
	UserJobCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserJobCountKeySpecifier | (() => undefined | UserJobCountKeySpecifier),
		fields?: UserJobCountFieldPolicy,
	},
	UserManagerUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserManagerUserKeySpecifier | (() => undefined | UserManagerUserKeySpecifier),
		fields?: UserManagerUserFieldPolicy,
	},
	UserManagerUsersPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserManagerUsersPageKeySpecifier | (() => undefined | UserManagerUsersPageKeySpecifier),
		fields?: UserManagerUsersPageFieldPolicy,
	},
	UserNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserNestKeySpecifier | (() => undefined | UserNestKeySpecifier),
		fields?: UserNestFieldPolicy,
	},
	UserOrganizationPermission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserOrganizationPermissionKeySpecifier | (() => undefined | UserOrganizationPermissionKeySpecifier),
		fields?: UserOrganizationPermissionFieldPolicy,
	},
	UserOrganizationPermissionNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserOrganizationPermissionNestKeySpecifier | (() => undefined | UserOrganizationPermissionNestKeySpecifier),
		fields?: UserOrganizationPermissionNestFieldPolicy,
	},
	UserStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserStatsKeySpecifier | (() => undefined | UserStatsKeySpecifier),
		fields?: UserStatsFieldPolicy,
	},
	UserSystemGroupPermission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserSystemGroupPermissionKeySpecifier | (() => undefined | UserSystemGroupPermissionKeySpecifier),
		fields?: UserSystemGroupPermissionFieldPolicy,
	},
	UserSystemGroupPermissionNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserSystemGroupPermissionNestKeySpecifier | (() => undefined | UserSystemGroupPermissionNestKeySpecifier),
		fields?: UserSystemGroupPermissionNestFieldPolicy,
	},
	UserSystemPermission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserSystemPermissionKeySpecifier | (() => undefined | UserSystemPermissionKeySpecifier),
		fields?: UserSystemPermissionFieldPolicy,
	},
	UserSystemPermissionNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserSystemPermissionNestKeySpecifier | (() => undefined | UserSystemPermissionNestKeySpecifier),
		fields?: UserSystemPermissionNestFieldPolicy,
	},
	WaterlyConnectErrorStatsByMonth?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WaterlyConnectErrorStatsByMonthKeySpecifier | (() => undefined | WaterlyConnectErrorStatsByMonthKeySpecifier),
		fields?: WaterlyConnectErrorStatsByMonthFieldPolicy,
	},
	WaterlyConnectQueueJobCountByEdgeDevice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WaterlyConnectQueueJobCountByEdgeDeviceKeySpecifier | (() => undefined | WaterlyConnectQueueJobCountByEdgeDeviceKeySpecifier),
		fields?: WaterlyConnectQueueJobCountByEdgeDeviceFieldPolicy,
	},
	WaterlyConnectStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WaterlyConnectStatsKeySpecifier | (() => undefined | WaterlyConnectStatsKeySpecifier),
		fields?: WaterlyConnectStatsFieldPolicy,
	},
	WeatherDataStationNest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WeatherDataStationNestKeySpecifier | (() => undefined | WeatherDataStationNestKeySpecifier),
		fields?: WeatherDataStationNestFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
export const CalcClusterDebugLogFragmentDoc = /*#__PURE__*/ gql`
    fragment CalcClusterDebugLog on CalcClusterDebugLog {
  appliedAt
  calcClusterDebugId
  clusterId
  createdAt
  deletedAt
  id
  measuredAt
  metricId
  oldValue
  transactionId
  updatedAt
  value
}
    `;
export const DataEntryCompletionFragmentDoc = /*#__PURE__*/ gql`
    fragment DataEntryCompletion on DataEntryCompletion {
  appliedAt
  createdAt
  id
  intervalTime
  isComplete
  siteId
  updatedAt
  userId
}
    `;
export const FolderWithMetricIdsAndOrderFragmentDoc = /*#__PURE__*/ gql`
    fragment FolderWithMetricIdsAndOrder on FolderWithMetricIdsAndOrder {
  color
  createdAt
  default
  deletedAt
  depth
  id
  name
  order
  parentId
  siteId
  updatedAt
}
    `;
export const SiteFlexMetricWithParentSiteFragmentDoc = /*#__PURE__*/ gql`
    fragment SiteFlexMetricWithParentSite on SiteFlexMetricWithParentSite {
  createdAt
  deletedAt
  folderViewOrder
  id
  metricId
  name
  parentSite {
    createdAt
    dataEntryCompletionEnabled
    deletedAt
    externalId
    externalMetadata
    externalOwner
    flex
    id
    isEntry
    latitude
    longitude
    name
    npdesPermitNumber
    order
    siteType
    systemId
    updatedAt
  }
  required
  siteId
  updatedAt
}
    `;
export const ActivityScheduleFragmentDoc = /*#__PURE__*/ gql`
    fragment ActivitySchedule on ActivitySchedule {
  activityScheduleTypeId
  createdAt
  createdByUserId
  defaultAssigneeId
  deletedAt
  description
  endDate
  exDates
  id
  isStackable
  notBeforeUnit
  notBeforeValue
  photoRequired
  rDates
  recurrenceType
  rrule
  siteId
  startDate
  systemId
  targetBeforeUnit
  targetBeforeValue
  title
  updatedAt
}
    `;
export const AddressFragmentDoc = /*#__PURE__*/ gql`
    fragment Address on Address {
  city
  countryCode
  createdAt
  id
  label
  line1
  line2
  organizationId
  phone
  postalCode
  purpose
  recipientName
  region
  siteId
  systemId
  updatedAt
}
    `;
export const AnalyteFragmentDoc = /*#__PURE__*/ gql`
    fragment Analyte on Analyte {
  analyteType
  createdAt
  deletedAt
  description
  id
  name
  unitId
  updatedAt
}
    `;
export const AnalyteGroupFragmentDoc = /*#__PURE__*/ gql`
    fragment AnalyteGroup on AnalyteGroup {
  createdAt
  deletedAt
  description
  id
  name
  organizationId
  updatedAt
}
    `;
export const ApiTokenFragmentDoc = /*#__PURE__*/ gql`
    fragment ApiToken on ApiTokenNest {
  createdAt
  createdByUserId
  expiresAt
  id
  lastUsedAt
  name
  organizationId
  realm
  revokedAt
  scopes
  updatedAt
  username
}
    `;
export const AuditEventFragmentDoc = /*#__PURE__*/ gql`
    fragment AuditEvent on AuditEventNest {
  event
  id
  rolledBackAt
  timestamp
  type
  userId
  version
}
    `;
export const AuditEventNestFragmentDoc = /*#__PURE__*/ gql`
    fragment AuditEventNest on AuditEventNest {
  appliedAtWithTimeZone
  event
  id
  rolledBackAt
  timestamp
  type
  userId
  version
}
    `;
export const BaseFolderFragmentDoc = /*#__PURE__*/ gql`
    fragment BaseFolder on BaseFolder {
  color
  createdAt
  default
  deletedAt
  depth
  id
  name
  order
  parentId
  siteId
  updatedAt
}
    `;
export const BulkMetricEditorRowFragmentDoc = /*#__PURE__*/ gql`
    fragment BulkMetricEditorRow on BulkMetricEditorRow {
  calculationName
  componentKeyname
  componentName
  copyPreviousValueEnabled
  dataPointCommentPolicy
  dataType
  expression
  hasIntervals
  hideFromDataEntry
  interpolated
  isLockedByWaterly
  isReportComments
  keyname
  limits {
    belowReportingLimitValue
    configured
    detectionLimit
    reportingLimit
    treatBelowReportingLimitAsPercent
  }
  metricId
  metricRangeType
  name
  notificationEnabled
  order
  organizationName
  precision
  processKeyname
  processName
  rangeMax
  rangeMin
  reportAggregations {
    canBeAveraged
    canBeCounted
    canBeMaximized
    canBeMinimized
    canBeTotaled
    configured
  }
  required
  siteId
  siteName
  siteType
  systemId
  systemName
  systemType
  units
}
    `;
export const CalcClusterDebugFragmentDoc = /*#__PURE__*/ gql`
    fragment CalcClusterDebug on CalcClusterDebug {
  clusterId
  enabled
  id
  metricId
  updatedAt
}
    `;
export const ColumnGroupFragmentDoc = /*#__PURE__*/ gql`
    fragment ColumnGroup on ColumnGroup {
  createdAt
  deletedAt
  id
  name
  reportDefinitionId
  updatedAt
}
    `;
export const ColumnGroupItemFragmentDoc = /*#__PURE__*/ gql`
    fragment ColumnGroupItem on ColumnGroupItem {
  aggregation
  calculationType
  createdAt
  deletedAt
  id
  intervalId
  metricId
  name
  type
  updatedAt
}
    `;
export const ComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment Component on ComponentType {
  deletedAt
  id
  internalKeyname
  name
  order
}
    `;
export const ComponentNestFragmentDoc = /*#__PURE__*/ gql`
    fragment ComponentNest on ComponentNest {
  createdAt
  deletedAt
  id
  internalKeyname
  name
  order
  processId
  updatedAt
}
    `;
export const ConstantDefinitionFragmentDoc = /*#__PURE__*/ gql`
    fragment ConstantDefinition on ConstantDefinition {
  createdAt
  dataType
  deletedAt
  description
  id
  keyname
  name
  organizationId
  precision
  scope
  systemId
  unitId
  updatedAt
}
    `;
export const ConstantValueFragmentDoc = /*#__PURE__*/ gql`
    fragment ConstantValue on ConstantValue {
  constantDefinitionId
  createdAt
  deletedAt
  effectiveDate
  id
  note
  numericValue
  textValue
  updatedAt
}
    `;
export const EdgeDeviceFragmentDoc = /*#__PURE__*/ gql`
    fragment EdgeDevice on EdgeDeviceType {
  deviceName
  id
}
    `;
export const EdgeDeviceSubmissionFragmentDoc = /*#__PURE__*/ gql`
    fragment EdgeDeviceSubmission on EdgeDeviceSubmission {
  createdAt
  dataExcerpt
  edgeDeviceId
  id
  remoteIp
  status
  updatedAt
}
    `;
export const EdgeDeviceSubmissionSummaryFragmentDoc = /*#__PURE__*/ gql`
    fragment EdgeDeviceSubmissionSummary on EdgeDeviceSubmissionSummary {
  createdAt
  edgeDeviceId
  id
  remoteIp
  success
  updatedAt
}
    `;
export const EdgeDeviceV2FragmentDoc = /*#__PURE__*/ gql`
    fragment EdgeDeviceV2 on EdgeDeviceNest {
  createdAt
  deviceName
  deviceType
  enabled
  id
  integrationMetadata
  lastReceivedAt
  organizationId
  organizationName
  updatedAt
}
    `;
export const EntryTsDataPointFragmentDoc = /*#__PURE__*/ gql`
    fragment EntryTsDataPoint on EntryTSDataPoint {
  appliedAt
  booleanValue
  calculatedNondetectValue
  calculatedValue
  comment
  connectValue
  dateTimeValue
  dateValue
  edgeDeviceSubmissionId
  effectiveNumericValue
  id
  intervalId
  isArchived
  isCalculatedResult
  isInterpolated
  isNondetect
  journalEntryRecordId
  jsonValue
  locatorEntityId
  locatorEntityType
  locatorNamespace
  measuredAt
  metaData {
    connectValue
    edgeDeviceSubmissionId
    id
    intervalId
    reportDate
  }
  metricId
  numericValue
  reportDate
  storedAt
  textValue
  timeValue
  type
  value
  valueType
}
    `;
export const ExternalFacilityFragmentDoc = /*#__PURE__*/ gql`
    fragment ExternalFacility on ExternalFacility {
  externalId
  externalMetadata
  name
}
    `;
export const ExternalSystemFragmentDoc = /*#__PURE__*/ gql`
    fragment ExternalSystem on ExternalSystem {
  externalId
  externalOwner
  id
  name
}
    `;
export const IntervalFragmentDoc = /*#__PURE__*/ gql`
    fragment Interval on Interval {
  displayName @client
  id
  time
}
    `;
export const LabImportBatchFragmentDoc = /*#__PURE__*/ gql`
    fragment LabImportBatch on LabImportBatch {
  checksumSha256
  committedAt
  committedRowCount
  createdAt
  errorDetails
  id
  invalidRowCount
  originalFileName
  parserMetadata {
    columns
    delimiter
    hasHeader
    quote
  }
  profileName
  profileVersion {
    createdAt
    createdByUserId
    definition {
      columnMappings {
        column
        field
      }
      parserConfig {
        columns
        delimiter
        hasHeader
        quote
      }
      targetMappings {
        decision
        id
        importedUnitLabel
        metricId
        metricUnitLabel
        siteId
        sourceAnalyte
        sourceProject
        sourceSampleSite
        unitDecision
      }
    }
    id
    profileId
    version
  }
  profileVersionId
  readyMetricCount
  readySiteCount
  reconciliationRequiredRowCount
  skippedRowCount
  sourceFileSizeBytes
  sourceMimeType
  sourceUploadId
  status
  systemId
  totalRowCount
  validatedAt
  validRowCount
}
    `;
export const LabImportProfileDefinitionFragmentDoc = /*#__PURE__*/ gql`
    fragment LabImportProfileDefinition on LabImportProfileDefinition {
  columnMappings {
    column
    field
  }
  parserConfig {
    columns
    delimiter
    hasHeader
    quote
  }
  targetMappings {
    decision
    id
    importedUnitLabel
    metricId
    metricUnitLabel
    siteId
    sourceAnalyte
    sourceProject
    sourceSampleSite
    unitDecision
  }
}
    `;
export const LabImportPendingProfileFragmentDoc = /*#__PURE__*/ gql`
    fragment LabImportPendingProfile on LabImportPendingProfile {
  baseProfileVersionId
  definition {
    ...LabImportProfileDefinition
  }
  name
  profileId
}
    ${LabImportProfileDefinitionFragmentDoc}`;
export const LabImportProfileFragmentDoc = /*#__PURE__*/ gql`
    fragment LabImportProfile on LabImportProfile {
  createdAt
  createdByUserId
  id
  name
  organizationId
  systemId
  versions {
    createdAt
    createdByUserId
    definition {
      ...LabImportProfileDefinition
    }
    id
    profileId
    version
  }
}
    ${LabImportProfileDefinitionFragmentDoc}`;
export const LabImportRowFragmentDoc = /*#__PURE__*/ gql`
    fragment LabImportRow on LabImportRow {
  batchId
  canonicalValues
  comments
  id
  importedUnitLabel
  intervalId
  isNondetect
  metricId
  rawValues
  reportDate
  requestId
  resultName
  resultValue
  rowNumber
  sampleDate
  sampleIdentifier
  siteId
  status
  systemId
  validationResults {
    attempt
    code
    details
    field
    id
    message
    status
  }
  writeErrorDetails
  writeStatus
  writtenAt
}
    `;
export const LicenseFragmentDoc = /*#__PURE__*/ gql`
    fragment License on LicenseNest {
  authority
  displayName
  id
  licenseLabel
  licenseNumber
  userId
}
    `;
export const LogBookEntryFragmentDoc = /*#__PURE__*/ gql`
    fragment LogBookEntry on LogBookEntryNest {
  createdAt
  deletedAt
  id
  message
  organizationId
  pinned
  updatedAt
  userId
}
    `;
export const LogBookEntryDashboardViewFragmentDoc = /*#__PURE__*/ gql`
    fragment LogBookEntryDashboardView on LogBookEntryDashboardViewNest {
  createdAt
  deletedAt
  id
  message
  name
  organizationId
  siteIds
  sortDirection
  sortField
  systemIds
  tagIds
  updatedAt
  userId
  userIds
}
    `;
export const LogBookEntryListItemFragmentDoc = /*#__PURE__*/ gql`
    fragment LogBookEntryListItem on LogBookEntryNest {
  attachments {
    components {
      id
      name
    }
    metrics {
      id
      name
    }
    processes {
      id
      name
    }
    sites {
      id
      name
    }
    systems {
      id
      name
    }
    tags {
      id
      name
    }
    uploads {
      fileName
      id
      url
    }
  }
  createdAt
  deletedAt
  id
  message
  organizationId
  pinned
  updatedAt
  user {
    firstName
    id
    lastName
  }
}
    `;
export const UnitFragmentDoc = /*#__PURE__*/ gql`
    fragment Unit on UnitType {
  id
  isInterpolatable
  name
}
    `;
export const MetricFragmentDoc = /*#__PURE__*/ gql`
    fragment Metric on MetricType {
  belowRlValue
  calculated
  calculationName
  canBeAveraged
  canBeCounted
  canBeMaximized
  canBeMinimized
  canBeTotaled
  componentId
  copyPreviousValueEnabled
  dataPointCommentPolicy
  dataType
  deletedAt
  detectionLimit
  displayName @client
  displayNameSiteLocal @client
  expression
  hideFromDataEntry
  id
  internalKeyname
  interpolated
  isDecreasing
  isIncreasing
  isLockedByWaterly
  isReportComments
  isWaterlyConnected
  keynameId
  maxValue
  minValue
  name
  notificationEnabled
  order
  precision
  processId
  rangeMax
  rangeMin
  reportingLimit
  required
  treatBelowRlAsPercent
  unit {
    ...Unit
  }
  unitId
}
    ${UnitFragmentDoc}`;
export const MetricContextFragmentDoc = /*#__PURE__*/ gql`
    fragment MetricContext on MetricType {
  component {
    id
    name
  }
  id
  name
  process {
    id
    name
  }
  site {
    id
    name
    systemId
  }
}
    `;
export const MetricDataPointDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment MetricDataPointDetails on MetricDataPointType {
  appliedAt
  calculatedNondetectValue
  calculatedValue
  comment
  connectValue
  edgeDeviceSubmissionId
  effectiveValue
  error
  id
  intervalId
  isInterpolated
  isNondetect
  measuredAt
  metricId
  reportDate
  type
  value
  version
}
    `;
export const MetricOrderWithMetricIdFragmentDoc = /*#__PURE__*/ gql`
    fragment MetricOrderWithMetricId on MetricOrderWithMetricId {
  id
  metricId
  order
}
    `;
export const MetricKeynameFragmentDoc = /*#__PURE__*/ gql`
    fragment MetricKeyname on MetricKeyname {
  compliance
  createdAt
  deletedAt
  description
  id
  name
  systemTypes
  updatedAt
}
    `;
export const MetricNestFragmentDoc = /*#__PURE__*/ gql`
    fragment MetricNest on MetricNest {
  belowRlValue
  calculated
  calculationName
  canBeAveraged
  canBeCounted
  canBeMaximized
  canBeMinimized
  canBeTotaled
  componentId
  copyPreviousValueEnabled
  createdAt
  dataPointCommentPolicy
  dataType
  debug
  deletedAt
  detectionLimit
  expression
  hideFromDataEntry
  id
  internalKeyname
  interpolated
  isDecreasing
  isIncreasing
  isLockedByWaterly
  isReportComments
  isWaterlyConnected
  keynameId
  maxValue
  metricRangeType
  minValue
  name
  notificationEnabled
  order
  precision
  processId
  rangeMax
  rangeMin
  reportingLimit
  required
  treatBelowRlAsPercent
  unitId
  updatedAt
  updatesPriorDay
}
    `;
export const MetricRangeFragmentDoc = /*#__PURE__*/ gql`
    fragment MetricRange on MetricRange {
  color
  createdAt
  deletedAt
  id
  ideal
  maxTagId
  metricId
  minTagId
  name
  notificationEnabled
  rangeMax
  rangeMaxInclusive
  rangeMin
  rangeMinInclusive
  updatedAt
}
    `;
export const IntervalNestFragmentDoc = /*#__PURE__*/ gql`
    fragment IntervalNest on IntervalNest {
  createdAt
  createdByUserId
  date
  displayName
  id
  siteId
  time
  updatedAt
}
    `;
export const MetricWithCalculatedMetricFragmentDoc = /*#__PURE__*/ gql`
    fragment MetricWithCalculatedMetric on MetricWithCalculatedMetric {
  belowRlValue
  calculated
  calculatedMetric {
    calculatedMetricId
    sourceMetricId
  }
  calculationName
  canBeAveraged
  canBeCounted
  canBeMaximized
  canBeMinimized
  canBeTotaled
  componentId
  copyPreviousValueEnabled
  createdAt
  dataPointCommentPolicy
  dataType
  debug
  deletedAt
  detectionLimit
  expression
  hideFromDataEntry
  id
  internalKeyname
  interpolated
  intervals {
    ...IntervalNest
  }
  isDecreasing
  isIncreasing
  isLockedByWaterly
  isReportComments
  maxValue
  minValue
  name
  notificationEnabled
  order
  precision
  processId
  rangeMax
  rangeMin
  reportingLimit
  required
  treatBelowRlAsPercent
  unitId
  updatedAt
  updatesPriorDay
}
    ${IntervalNestFragmentDoc}`;
export const NotificationFragmentDoc = /*#__PURE__*/ gql`
    fragment Notification on Notification {
  active
  appearance
  createdAt
  deletedAt
  dismissable
  displayPosition
  endDate
  icon
  id
  message
  name
  organizationId
  startDate
  systemGroupId
  systemId
  title
  updatedAt
}
    `;
export const OrganizationFragmentDoc = /*#__PURE__*/ gql`
    fragment Organization on OrganizationType {
  dateFormat
  fiscalYearStartDate
  id
  idpKey
  isExternalSystemSearchEnabled
  isUserDirectoryEnabled
  name
  selfServiceEnabled
}
    `;
export const OrganizationNestFragmentDoc = /*#__PURE__*/ gql`
    fragment OrganizationNest on OrganizationNest {
  dateFormat
  fiscalYearStartDate
  id
  idpKey
  name
  selfServiceEnabled
}
    `;
export const PermitFragmentDoc = /*#__PURE__*/ gql`
    fragment Permit on Permit {
  createdAt
  deletedAt
  id
  isPublicWaterSystemId
  name
  permitCode
  systemId
  updatedAt
}
    `;
export const PhoneNumberFragmentDoc = /*#__PURE__*/ gql`
    fragment PhoneNumber on PhoneNumberNest {
  country
  id
  phoneNumber
}
    `;
export const PhraseFragmentDoc = /*#__PURE__*/ gql`
    fragment Phrase on Phrase {
  bodyText
  id
  name
  organizationId
  userId
}
    `;
export const ProcessFragmentDoc = /*#__PURE__*/ gql`
    fragment Process on ProcessType {
  deletedAt
  displayName @client
  id
  internalKeyname
  name
  order
  siteId
}
    `;
export const ProcessNestFragmentDoc = /*#__PURE__*/ gql`
    fragment ProcessNest on ProcessNest {
  createdAt
  deletedAt
  id
  internalKeyname
  name
  order
  siteId
  updatedAt
}
    `;
export const QueueStatsFragmentDoc = /*#__PURE__*/ gql`
    fragment QueueStats on QueueStats {
  completedInLastHour
  completedPerMinute
  failedInLastHour
  failedPerMinute
  generatedAt
  groupsCount {
    count
    id
    status
    userJobCounts {
      count
      senderEmail
    }
  }
  groupsCountByStatus {
    limited
    maxed
    paused
    waiting
  }
  queue
  workersCount
}
    `;
export const ReportDefinitionFragmentDoc = /*#__PURE__*/ gql`
    fragment ReportDefinition on ReportDefinition {
  annualPeriod
  configSchemaId
  customFooter
  id
  isFlex
  metadata
  name
  order
  paperOrientation
  paperSize
  reportGroup {
    id
    name
    order
    systemId
  }
  reportGroupId
  reportTemplateId
  reportType
  showDayOfWeek
  siteId
  supplementaryEnabled
  system {
    id
    name
  }
  systemId
  timeFormat
}
    `;
export const ReportDefinitionNestFragmentDoc = /*#__PURE__*/ gql`
    fragment ReportDefinitionNest on ReportDefinitionNest {
  annualPeriod
  configSchemaId
  customFooter
  id
  name
  order
  paperOrientation
  paperSize
  reportTemplateId
  reportType
  showDayOfWeek
  siteId
  supplementaryEnabled
  systemId
}
    `;
export const ReportMetricFragmentDoc = /*#__PURE__*/ gql`
    fragment ReportMetric on MetricType {
  deletedAt
  enabledForReport(reportDefinitionId: $reportDefinitionId)
  enabledIntervalForMonthlyReport(reportDefinitionId: $reportDefinitionId) {
    displayName @client
    id
    time
  }
  id
  intervals {
    displayName @client
    id
    time
  }
  isReportComments
  name
  order
  unit {
    ...Unit
  }
}
    ${UnitFragmentDoc}`;
export const ReportDefinitionSiteFragmentDoc = /*#__PURE__*/ gql`
    fragment ReportDefinitionSite on ReportDefinition {
  site {
    flex
    id
    name
    processes(includeDeleted: true) {
      components {
        enabledForReport(reportDefinitionId: $reportDefinitionId)
        id
        metrics(includeDeleted: true) {
          ...ReportMetric
        }
        name
        order
      }
      deletedAt
      enabledForReport(reportDefinitionId: $reportDefinitionId)
      id
      metrics(includeDeleted: true) {
        ...ReportMetric
      }
      name
      order
    }
  }
}
    ${ReportMetricFragmentDoc}`;
export const ReportDistributionListFragmentDoc = /*#__PURE__*/ gql`
    fragment ReportDistributionList on ReportDistributionList {
  createdAt
  deletedAt
  description
  displaySummary
  id
  isArchived
  memberCount
  members {
    createdAt
    displayName
    id
    memberType
    normalizedEmail
    sortOrder
    updatedAt
    userId
  }
  name
  normalizedName
  organizationId
  scope
  siteId
  systemId
  updatedAt
}
    `;
export const ReportNestFragmentDoc = /*#__PURE__*/ gql`
    fragment ReportNest on ReportNest {
  description
  id
  name
  organizationId
  reportTemplate
  reportType
  siteId
  systemId
}
    `;
export const ReportNodeFragmentDoc = /*#__PURE__*/ gql`
    fragment ReportNode on ReportNode {
  columnGroupId
  columnGroupItemId
  createdAt
  deletedAt
  id
  metricId
  order
  parentId
  reportDefinitionId
  type
  updatedAt
}
    `;
export const ReportSnapshotFragmentDoc = /*#__PURE__*/ gql`
    fragment ReportSnapshot on ReportSnapshot {
  config
  configSchemaVersion
  createdAt
  data
  deletedAt
  enterpriseReportId
  id
  name
  reportDateTime
  reportDefinitionId
  status
  updatedAt
  url
}
    `;
export const RetentionRiskNestFragmentDoc = /*#__PURE__*/ gql`
    fragment RetentionRiskNest on RetentionRiskNest {
  createdAt
  deletedAt
  displayName
  flag
  flagType
  id
  itemId
  itemType
  organizationId
  score
  snooze
  updatedAt
}
    `;
export const SampleCollectionFragmentDoc = /*#__PURE__*/ gql`
    fragment SampleCollection on SampleCollection {
  createdAt
  deletedAt
  id
  sampleSiteId
  scheduledItemId
  systemId
  updatedAt
}
    `;
export const SampleCollectionCustodyFragmentDoc = /*#__PURE__*/ gql`
    fragment SampleCollectionCustody on SampleCollectionCustody {
  comment
  createdAt
  createdBy
  deletedAt
  id
  previousCustodyId
  relinquishedBy
  relinquishedTo
  sampleCollectionId
  systemId
  updatedAt
}
    `;
export const SampleCollectionResultFragmentDoc = /*#__PURE__*/ gql`
    fragment SampleCollectionResult on SampleCollectionResult {
  analyteId
  booleanValue
  createdAt
  deletedAt
  id
  measuredAt
  numericValue
  sampleCollectionId
  textValue
  updatedAt
  valueType
}
    `;
export const SampleScheduleFragmentDoc = /*#__PURE__*/ gql`
    fragment SampleSchedule on SampleSchedule {
  analyteGroupId
  createdAt
  createdByUserId
  defaultAssigneeId
  description
  endDate
  exDates
  id
  isStackable
  notBeforeUnit
  notBeforeValue
  photoRequired
  rDates
  recurrenceType
  rrule
  sampleSiteId
  sampleType
  siteId
  startDate
  systemId
  targetBeforeUnit
  targetBeforeValue
  title
  updatedAt
}
    `;
export const UploadsFragmentDoc = /*#__PURE__*/ gql`
    fragment Uploads on Upload {
  blobId
  createdAt
  deletedAt
  description
  fileLength
  fileName
  id
  mimeType
  organizationId
  updatedAt
  url
}
    `;
export const SampleSiteFragmentDoc = /*#__PURE__*/ gql`
    fragment SampleSite on SampleSite {
  address
  createdAt
  deletedAt
  description
  id
  isActive
  lastInspectionDate
  latitude
  longitude
  name
  organizationId
  photoUpload {
    ...Uploads
  }
  samplePointType
  updatedAt
  url
}
    ${UploadsFragmentDoc}`;
export const UserNestFragmentDoc = /*#__PURE__*/ gql`
    fragment UserNest on UserNest {
  displayName
  email
  enableIphoneMetricNumberInput
  externalId
  externalOwner
  firstName
  fullNameOrEmail
  id
  idpKey
  lastLoginAt
  lastName
  pending
  primaryOrganizationId
  readonlySuperadmin
  subject
  superadmin
}
    `;
export const ScheduledItemCommentFragmentDoc = /*#__PURE__*/ gql`
    fragment ScheduledItemComment on ScheduledItemComment {
  comment
  commentType
  createdAt
  id
  scheduledItemId
  updatedAt
  user {
    ...UserNest
  }
  userId
}
    ${UserNestFragmentDoc}`;
export const ScheduledItemFragmentDoc = /*#__PURE__*/ gql`
    fragment ScheduledItem on ScheduledItem {
  assigneeId
  comments {
    ...ScheduledItemComment
  }
  completedAt
  createdAt
  deletedAt
  description
  id
  isStackable
  notBefore
  photoRequired
  photoUpload {
    ...Uploads
  }
  recurrenceType
  scheduledAt
  sourceScheduleId
  sourceScheduleType
  status
  systemId
  targetDate
  title
  updatedAt
}
    ${ScheduledItemCommentFragmentDoc}
${UploadsFragmentDoc}`;
export const ScheduledItemsUploadsFragmentDoc = /*#__PURE__*/ gql`
    fragment ScheduledItemsUploads on ScheduledItemUpload {
  id
  scheduledItemId
  uploadId
}
    `;
export const SiteFlexMetricFragmentDoc = /*#__PURE__*/ gql`
    fragment SiteFlexMetric on SiteFlexMetric {
  createdAt
  deletedAt
  folderViewOrder
  id
  metricId
  name
  required
  siteId
  updatedAt
}
    `;
export const SiteNestFragmentDoc = /*#__PURE__*/ gql`
    fragment SiteNest on SiteNest {
  createdAt
  dataEntryCompletionEmail
  dataEntryCompletionEnabled
  deletedAt
  emoji
  externalId
  externalMetadata
  externalOwner
  flex
  fullName
  id
  isEntry
  latitude
  licenseId
  longitude
  mirrorSiteId
  name
  npdesPermitNumber
  operatorId
  order
  phoneNumberId
  siteType
  systemId
  updatedAt
}
    `;
export const SsoConfigurationFragmentDoc = /*#__PURE__*/ gql`
    fragment SSOConfiguration on SSOConfigurationType {
  audience
  authority
  clientId
  id
  idpKey
  logoSvg
  scope
  signoutRedirectUrl
}
    `;
export const SuccessResponseFragmentDoc = /*#__PURE__*/ gql`
    fragment SuccessResponse on SuccessResponse {
  id
  message
  success
}
    `;
export const SystemFragmentDoc = /*#__PURE__*/ gql`
    fragment System on SystemType {
  displayName @client
  externalId
  externalMetadataJSON
  externalOwner
  hasSitesWithIntervals
  hideDataSites
  id
  isFavorite
  isTemplate
  licenseId
  myRole
  name
  operatorId
  organizationId
  parentSystemGroupId
  phoneNumberId
  regulatoryId
  timeZone
  type
}
    `;
export const SystemGroupFragmentDoc = /*#__PURE__*/ gql`
    fragment SystemGroup on SystemGroupType {
  displayName
  id
  isTopLevel @client
  name
  organizationId
  parentSystemGroupId
}
    `;
export const UserFragmentDoc = /*#__PURE__*/ gql`
    fragment User on UserInfoType {
  displayName @client
  email
  enableIphoneMetricNumberInput
  externalId
  externalMetadataJSON
  externalOwner
  firstName
  fullNameOrEmail @client
  id
  idpKey
  lastLoginAt
  lastName
  pending
  primaryOrganizationId
  readonlySuperadmin
  subject
  superadmin
}
    `;
export const SystemGroupUserFragmentDoc = /*#__PURE__*/ gql`
    fragment SystemGroupUser on UserInfoType {
  roleForSystemGroup(systemGroupId: $systemGroupId)
  ...User
}
    ${UserFragmentDoc}`;
export const SystemGroupWithUsersFragmentDoc = /*#__PURE__*/ gql`
    fragment SystemGroupWithUsers on SystemGroupType {
  ...SystemGroup
  users {
    ...SystemGroupUser
  }
}
    ${SystemGroupFragmentDoc}
${SystemGroupUserFragmentDoc}`;
export const SystemNestFragmentDoc = /*#__PURE__*/ gql`
    fragment SystemNest on SystemNest {
  externalId
  externalMetadata
  externalOwner
  hideDataSites
  id
  isFavorite
  isTemplate
  licenseId
  name
  operatorId
  organizationId
  parentSystemGroupId
  phoneNumberId
  regulatoryId
  timeZone
  type
}
    `;
export const TagFragmentDoc = /*#__PURE__*/ gql`
    fragment Tag on Tag {
  color
  createdAt
  deletedAt
  displayName @client
  id
  name
  nameEs
  organizationId
  type
  updatedAt
}
    `;
export const TagMappingFragmentDoc = /*#__PURE__*/ gql`
    fragment TagMapping on TagMappingType {
  edgeDeviceId
  id
  metricId
  tagName
}
    `;
export const TrendFragmentDoc = /*#__PURE__*/ gql`
    fragment Trend on TrendNest {
  id
  isGlobal
  keynameFilters
  name
  ownerId
  resolvedMetricIds(systemId: $systemId)
  systemId
  systemType
}
    `;
export const TsDataPointFragmentDoc = /*#__PURE__*/ gql`
    fragment TsDataPoint on TSDataPoint {
  appliedAt
  booleanValue
  calculatedNondetectValue
  calculatedValue
  comment
  connectValue
  dateTimeValue
  dateValue
  edgeDeviceSubmissionId
  effectiveNumericValue
  id
  intervalId
  isArchived
  isCalculatedResult
  isInterpolated
  isNondetect
  journalEntryRecordId
  jsonValue
  locatorEntityId
  locatorEntityType
  locatorNamespace
  measuredAt
  metaData {
    connectValue
    edgeDeviceSubmissionId
    id
    intervalId
    reportDate
  }
  metricId
  numericValue
  reportDate
  storedAt
  textValue
  timeValue
  type
  value
  valueType
}
    `;
export const UnitNestFragmentDoc = /*#__PURE__*/ gql`
    fragment UnitNest on UnitNest {
  createdAt
  deletedAt
  id
  isInterpolatable
  name
  updatedAt
}
    `;
export const UserManagerUserFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment UserManagerUserFields on UserManagerUser {
  createdAt
  deletedAt
  email
  firstName
  id
  idpKey
  lastLoginAt
  lastName
  pending
  primaryOrganizationName
  readonlySuperadmin
  superadmin
}
    `;
export const UserSystemGroupPermissionFragmentDoc = /*#__PURE__*/ gql`
    fragment UserSystemGroupPermission on UserSystemGroupPermission {
  id
  name
  role
  systemGroupId
}
    `;
export const UserSystemPermissionFragmentDoc = /*#__PURE__*/ gql`
    fragment UserSystemPermission on UserSystemPermission {
  id
  inheritedFromSystemGroupId
  isTemplate
  name
  role
  systemId
}
    `;
export const UserOrganizationPermissionFragmentDoc = /*#__PURE__*/ gql`
    fragment UserOrganizationPermission on UserOrganizationPermission {
  id
  name
  organizationId
  organizationRole
  selfServiceEnabled
  systemGroupPermissions {
    ...UserSystemGroupPermission
  }
  systemPermissions {
    ...UserSystemPermission
  }
}
    ${UserSystemGroupPermissionFragmentDoc}
${UserSystemPermissionFragmentDoc}`;
export const UserSystemGroupPermissionNestFragmentDoc = /*#__PURE__*/ gql`
    fragment UserSystemGroupPermissionNest on UserSystemGroupPermissionNest {
  id
  name
  role
  systemGroupId
}
    `;
export const UserSystemPermissionNestFragmentDoc = /*#__PURE__*/ gql`
    fragment UserSystemPermissionNest on UserSystemPermissionNest {
  id
  inheritedFromSystemGroupId
  isTemplate
  name
  role
  systemId
}
    `;
export const UserOrganizationPermissionNestFragmentDoc = /*#__PURE__*/ gql`
    fragment UserOrganizationPermissionNest on UserOrganizationPermissionNest {
  id
  name
  organizationId
  organizationRole
  selfServiceEnabled
  systemGroupPermissions {
    ...UserSystemGroupPermissionNest
  }
  systemPermissions {
    ...UserSystemPermissionNest
  }
}
    ${UserSystemGroupPermissionNestFragmentDoc}
${UserSystemPermissionNestFragmentDoc}`;
export const WeatherDataStationFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment WeatherDataStationFields on WeatherDataStationNest {
  deletedAt
  id
  latitude
  locationName
  longitude
  stateCode
  usgsStationId
}
    `;
export const SiteFragmentDoc = /*#__PURE__*/ gql`
    fragment Site on SiteType {
  dataEntryCompletionEmail
  dataEntryCompletionEnabled
  displayName @client
  emoji
  externalId
  externalMetadataJSON
  externalOwner
  flex
  fullName
  id
  isEntry
  latitude
  licenseId
  longitude
  name
  operatorId
  order
  phoneNumberId
  siteType
  systemId
}
    `;
export const UpdatePermitDocument = /*#__PURE__*/ gql`
    mutation UpdatePermit($input: PermitUpdateInput!) {
  updatePermit(input: $input) {
    ...Permit
  }
}
    ${PermitFragmentDoc}`;
export type UpdatePermitMutationFn = Apollo.MutationFunction<UpdatePermitMutation, UpdatePermitMutationVariables>;

/**
 * __useUpdatePermitMutation__
 *
 * To run a mutation, you first call `useUpdatePermitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermitMutation, { data, loading, error }] = useUpdatePermitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePermitMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePermitMutation, UpdatePermitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePermitMutation, UpdatePermitMutationVariables>(UpdatePermitDocument, options);
      }
export type UpdatePermitMutationHookResult = ReturnType<typeof useUpdatePermitMutation>;
export type UpdatePermitMutationResult = Apollo.MutationResult<UpdatePermitMutation>;
export type UpdatePermitMutationOptions = Apollo.BaseMutationOptions<UpdatePermitMutation, UpdatePermitMutationVariables>;
export const AddActivityScheduleDocument = /*#__PURE__*/ gql`
    mutation AddActivitySchedule($input: ActivityScheduleAddInput!) {
  addActivitySchedule(input: $input) {
    ...ActivitySchedule
  }
}
    ${ActivityScheduleFragmentDoc}`;
export type AddActivityScheduleMutationFn = Apollo.MutationFunction<AddActivityScheduleMutation, AddActivityScheduleMutationVariables>;

/**
 * __useAddActivityScheduleMutation__
 *
 * To run a mutation, you first call `useAddActivityScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddActivityScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addActivityScheduleMutation, { data, loading, error }] = useAddActivityScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddActivityScheduleMutation(baseOptions?: Apollo.MutationHookOptions<AddActivityScheduleMutation, AddActivityScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddActivityScheduleMutation, AddActivityScheduleMutationVariables>(AddActivityScheduleDocument, options);
      }
export type AddActivityScheduleMutationHookResult = ReturnType<typeof useAddActivityScheduleMutation>;
export type AddActivityScheduleMutationResult = Apollo.MutationResult<AddActivityScheduleMutation>;
export type AddActivityScheduleMutationOptions = Apollo.BaseMutationOptions<AddActivityScheduleMutation, AddActivityScheduleMutationVariables>;
export const AddEdgeDeviceDocument = /*#__PURE__*/ gql`
    mutation AddEdgeDevice($input: AddEdgeDeviceNestInput!) {
  addEdgeDevice(input: $input) {
    ...EdgeDeviceV2
  }
}
    ${EdgeDeviceV2FragmentDoc}`;
export type AddEdgeDeviceMutationFn = Apollo.MutationFunction<AddEdgeDeviceMutation, AddEdgeDeviceMutationVariables>;

/**
 * __useAddEdgeDeviceMutation__
 *
 * To run a mutation, you first call `useAddEdgeDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEdgeDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEdgeDeviceMutation, { data, loading, error }] = useAddEdgeDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEdgeDeviceMutation(baseOptions?: Apollo.MutationHookOptions<AddEdgeDeviceMutation, AddEdgeDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEdgeDeviceMutation, AddEdgeDeviceMutationVariables>(AddEdgeDeviceDocument, options);
      }
export type AddEdgeDeviceMutationHookResult = ReturnType<typeof useAddEdgeDeviceMutation>;
export type AddEdgeDeviceMutationResult = Apollo.MutationResult<AddEdgeDeviceMutation>;
export type AddEdgeDeviceMutationOptions = Apollo.BaseMutationOptions<AddEdgeDeviceMutation, AddEdgeDeviceMutationVariables>;
export const AddLicenseDocument = /*#__PURE__*/ gql`
    mutation AddLicense($input: AddLicenseInput!) {
  addLicense(input: $input) {
    ...License
  }
}
    ${LicenseFragmentDoc}`;
export type AddLicenseMutationFn = Apollo.MutationFunction<AddLicenseMutation, AddLicenseMutationVariables>;

/**
 * __useAddLicenseMutation__
 *
 * To run a mutation, you first call `useAddLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLicenseMutation, { data, loading, error }] = useAddLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLicenseMutation(baseOptions?: Apollo.MutationHookOptions<AddLicenseMutation, AddLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLicenseMutation, AddLicenseMutationVariables>(AddLicenseDocument, options);
      }
export type AddLicenseMutationHookResult = ReturnType<typeof useAddLicenseMutation>;
export type AddLicenseMutationResult = Apollo.MutationResult<AddLicenseMutation>;
export type AddLicenseMutationOptions = Apollo.BaseMutationOptions<AddLicenseMutation, AddLicenseMutationVariables>;
export const AddNewReportDefinitionDocument = /*#__PURE__*/ gql`
    mutation AddNewReportDefinition($input: ReportDefinitionCreateInput!) {
  addNewReportDefinition(input: $input) {
    ...ReportDefinitionNest
  }
}
    ${ReportDefinitionNestFragmentDoc}`;
export type AddNewReportDefinitionMutationFn = Apollo.MutationFunction<AddNewReportDefinitionMutation, AddNewReportDefinitionMutationVariables>;

/**
 * __useAddNewReportDefinitionMutation__
 *
 * To run a mutation, you first call `useAddNewReportDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewReportDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewReportDefinitionMutation, { data, loading, error }] = useAddNewReportDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNewReportDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<AddNewReportDefinitionMutation, AddNewReportDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewReportDefinitionMutation, AddNewReportDefinitionMutationVariables>(AddNewReportDefinitionDocument, options);
      }
export type AddNewReportDefinitionMutationHookResult = ReturnType<typeof useAddNewReportDefinitionMutation>;
export type AddNewReportDefinitionMutationResult = Apollo.MutationResult<AddNewReportDefinitionMutation>;
export type AddNewReportDefinitionMutationOptions = Apollo.BaseMutationOptions<AddNewReportDefinitionMutation, AddNewReportDefinitionMutationVariables>;
export const AddPhoneNumberDocument = /*#__PURE__*/ gql`
    mutation AddPhoneNumber($input: AddPhoneNumberInput!) {
  addPhoneNumber(input: $input) {
    ...PhoneNumber
  }
}
    ${PhoneNumberFragmentDoc}`;
export type AddPhoneNumberMutationFn = Apollo.MutationFunction<AddPhoneNumberMutation, AddPhoneNumberMutationVariables>;

/**
 * __useAddPhoneNumberMutation__
 *
 * To run a mutation, you first call `useAddPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPhoneNumberMutation, { data, loading, error }] = useAddPhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<AddPhoneNumberMutation, AddPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPhoneNumberMutation, AddPhoneNumberMutationVariables>(AddPhoneNumberDocument, options);
      }
export type AddPhoneNumberMutationHookResult = ReturnType<typeof useAddPhoneNumberMutation>;
export type AddPhoneNumberMutationResult = Apollo.MutationResult<AddPhoneNumberMutation>;
export type AddPhoneNumberMutationOptions = Apollo.BaseMutationOptions<AddPhoneNumberMutation, AddPhoneNumberMutationVariables>;
export const AddScheduledItemUploadDocument = /*#__PURE__*/ gql`
    mutation AddScheduledItemUpload($input: AddScheduledItemUploadInput!) {
  addScheduledItemUpload(input: $input) {
    ...ScheduledItemsUploads
  }
}
    ${ScheduledItemsUploadsFragmentDoc}`;
export type AddScheduledItemUploadMutationFn = Apollo.MutationFunction<AddScheduledItemUploadMutation, AddScheduledItemUploadMutationVariables>;

/**
 * __useAddScheduledItemUploadMutation__
 *
 * To run a mutation, you first call `useAddScheduledItemUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddScheduledItemUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addScheduledItemUploadMutation, { data, loading, error }] = useAddScheduledItemUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddScheduledItemUploadMutation(baseOptions?: Apollo.MutationHookOptions<AddScheduledItemUploadMutation, AddScheduledItemUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddScheduledItemUploadMutation, AddScheduledItemUploadMutationVariables>(AddScheduledItemUploadDocument, options);
      }
export type AddScheduledItemUploadMutationHookResult = ReturnType<typeof useAddScheduledItemUploadMutation>;
export type AddScheduledItemUploadMutationResult = Apollo.MutationResult<AddScheduledItemUploadMutation>;
export type AddScheduledItemUploadMutationOptions = Apollo.BaseMutationOptions<AddScheduledItemUploadMutation, AddScheduledItemUploadMutationVariables>;
export const AddSiteDocument = /*#__PURE__*/ gql`
    mutation AddSite($input: AddSiteInput!) {
  addSite(input: $input) {
    ...Site
  }
}
    ${SiteFragmentDoc}`;
export type AddSiteMutationFn = Apollo.MutationFunction<AddSiteMutation, AddSiteMutationVariables>;

/**
 * __useAddSiteMutation__
 *
 * To run a mutation, you first call `useAddSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSiteMutation, { data, loading, error }] = useAddSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSiteMutation(baseOptions?: Apollo.MutationHookOptions<AddSiteMutation, AddSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSiteMutation, AddSiteMutationVariables>(AddSiteDocument, options);
      }
export type AddSiteMutationHookResult = ReturnType<typeof useAddSiteMutation>;
export type AddSiteMutationResult = Apollo.MutationResult<AddSiteMutation>;
export type AddSiteMutationOptions = Apollo.BaseMutationOptions<AddSiteMutation, AddSiteMutationVariables>;
export const AddSiteFlexMetricsToFolderDocument = /*#__PURE__*/ gql`
    mutation AddSiteFlexMetricsToFolder($input: AddSiteFlexMetricsToFolderInput!) {
  addSiteFlexMetricsToFolder(input: $input) {
    metric {
      ...MetricNest
    }
    ...SiteFlexMetric
  }
}
    ${MetricNestFragmentDoc}
${SiteFlexMetricFragmentDoc}`;
export type AddSiteFlexMetricsToFolderMutationFn = Apollo.MutationFunction<AddSiteFlexMetricsToFolderMutation, AddSiteFlexMetricsToFolderMutationVariables>;

/**
 * __useAddSiteFlexMetricsToFolderMutation__
 *
 * To run a mutation, you first call `useAddSiteFlexMetricsToFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSiteFlexMetricsToFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSiteFlexMetricsToFolderMutation, { data, loading, error }] = useAddSiteFlexMetricsToFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSiteFlexMetricsToFolderMutation(baseOptions?: Apollo.MutationHookOptions<AddSiteFlexMetricsToFolderMutation, AddSiteFlexMetricsToFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSiteFlexMetricsToFolderMutation, AddSiteFlexMetricsToFolderMutationVariables>(AddSiteFlexMetricsToFolderDocument, options);
      }
export type AddSiteFlexMetricsToFolderMutationHookResult = ReturnType<typeof useAddSiteFlexMetricsToFolderMutation>;
export type AddSiteFlexMetricsToFolderMutationResult = Apollo.MutationResult<AddSiteFlexMetricsToFolderMutation>;
export type AddSiteFlexMetricsToFolderMutationOptions = Apollo.BaseMutationOptions<AddSiteFlexMetricsToFolderMutation, AddSiteFlexMetricsToFolderMutationVariables>;
export const AddSsoUserToSystemDocument = /*#__PURE__*/ gql`
    mutation AddSsoUserToSystem($input: AddSsoUserToSystemTypeInput!, $systemId: Int!) {
  addSsoUserToSystem(input: $input) {
    roleForSystem(systemId: $systemId)
    ...User
  }
}
    ${UserFragmentDoc}`;
export type AddSsoUserToSystemMutationFn = Apollo.MutationFunction<AddSsoUserToSystemMutation, AddSsoUserToSystemMutationVariables>;

/**
 * __useAddSsoUserToSystemMutation__
 *
 * To run a mutation, you first call `useAddSsoUserToSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSsoUserToSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSsoUserToSystemMutation, { data, loading, error }] = useAddSsoUserToSystemMutation({
 *   variables: {
 *      input: // value for 'input'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useAddSsoUserToSystemMutation(baseOptions?: Apollo.MutationHookOptions<AddSsoUserToSystemMutation, AddSsoUserToSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSsoUserToSystemMutation, AddSsoUserToSystemMutationVariables>(AddSsoUserToSystemDocument, options);
      }
export type AddSsoUserToSystemMutationHookResult = ReturnType<typeof useAddSsoUserToSystemMutation>;
export type AddSsoUserToSystemMutationResult = Apollo.MutationResult<AddSsoUserToSystemMutation>;
export type AddSsoUserToSystemMutationOptions = Apollo.BaseMutationOptions<AddSsoUserToSystemMutation, AddSsoUserToSystemMutationVariables>;
export const AddSsoUserToSystemGroupDocument = /*#__PURE__*/ gql`
    mutation AddSSOUserToSystemGroup($input: AddSSOUserToSystemGroupInput!, $systemGroupId: Int!) {
  addSSOUserToSystemGroup(input: $input) {
    ...SystemGroupUser
  }
}
    ${SystemGroupUserFragmentDoc}`;
export type AddSsoUserToSystemGroupMutationFn = Apollo.MutationFunction<AddSsoUserToSystemGroupMutation, AddSsoUserToSystemGroupMutationVariables>;

/**
 * __useAddSsoUserToSystemGroupMutation__
 *
 * To run a mutation, you first call `useAddSsoUserToSystemGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSsoUserToSystemGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSsoUserToSystemGroupMutation, { data, loading, error }] = useAddSsoUserToSystemGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      systemGroupId: // value for 'systemGroupId'
 *   },
 * });
 */
export function useAddSsoUserToSystemGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddSsoUserToSystemGroupMutation, AddSsoUserToSystemGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSsoUserToSystemGroupMutation, AddSsoUserToSystemGroupMutationVariables>(AddSsoUserToSystemGroupDocument, options);
      }
export type AddSsoUserToSystemGroupMutationHookResult = ReturnType<typeof useAddSsoUserToSystemGroupMutation>;
export type AddSsoUserToSystemGroupMutationResult = Apollo.MutationResult<AddSsoUserToSystemGroupMutation>;
export type AddSsoUserToSystemGroupMutationOptions = Apollo.BaseMutationOptions<AddSsoUserToSystemGroupMutation, AddSsoUserToSystemGroupMutationVariables>;
export const AddSystemFavoriteDocument = /*#__PURE__*/ gql`
    mutation AddSystemFavorite($input: AddSystemFavoriteInput!) {
  addSystemFavorite(input: $input) {
    ...System
  }
}
    ${SystemFragmentDoc}`;
export type AddSystemFavoriteMutationFn = Apollo.MutationFunction<AddSystemFavoriteMutation, AddSystemFavoriteMutationVariables>;

/**
 * __useAddSystemFavoriteMutation__
 *
 * To run a mutation, you first call `useAddSystemFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSystemFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSystemFavoriteMutation, { data, loading, error }] = useAddSystemFavoriteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSystemFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<AddSystemFavoriteMutation, AddSystemFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSystemFavoriteMutation, AddSystemFavoriteMutationVariables>(AddSystemFavoriteDocument, options);
      }
export type AddSystemFavoriteMutationHookResult = ReturnType<typeof useAddSystemFavoriteMutation>;
export type AddSystemFavoriteMutationResult = Apollo.MutationResult<AddSystemFavoriteMutation>;
export type AddSystemFavoriteMutationOptions = Apollo.BaseMutationOptions<AddSystemFavoriteMutation, AddSystemFavoriteMutationVariables>;
export const AddSystemGroupDocument = /*#__PURE__*/ gql`
    mutation AddSystemGroup($input: AddSystemGroupInput!) {
  addSystemGroup(input: $input) {
    ...SystemGroup
  }
}
    ${SystemGroupFragmentDoc}`;
export type AddSystemGroupMutationFn = Apollo.MutationFunction<AddSystemGroupMutation, AddSystemGroupMutationVariables>;

/**
 * __useAddSystemGroupMutation__
 *
 * To run a mutation, you first call `useAddSystemGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSystemGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSystemGroupMutation, { data, loading, error }] = useAddSystemGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSystemGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddSystemGroupMutation, AddSystemGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSystemGroupMutation, AddSystemGroupMutationVariables>(AddSystemGroupDocument, options);
      }
export type AddSystemGroupMutationHookResult = ReturnType<typeof useAddSystemGroupMutation>;
export type AddSystemGroupMutationResult = Apollo.MutationResult<AddSystemGroupMutation>;
export type AddSystemGroupMutationOptions = Apollo.BaseMutationOptions<AddSystemGroupMutation, AddSystemGroupMutationVariables>;
export const AddTagMappingDocument = /*#__PURE__*/ gql`
    mutation AddTagMapping($input: AddTagMappingInput!) {
  addTagMapping(input: $input) {
    edgeDeviceId
    id
    metricId
    tagName
  }
}
    `;
export type AddTagMappingMutationFn = Apollo.MutationFunction<AddTagMappingMutation, AddTagMappingMutationVariables>;

/**
 * __useAddTagMappingMutation__
 *
 * To run a mutation, you first call `useAddTagMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagMappingMutation, { data, loading, error }] = useAddTagMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTagMappingMutation(baseOptions?: Apollo.MutationHookOptions<AddTagMappingMutation, AddTagMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTagMappingMutation, AddTagMappingMutationVariables>(AddTagMappingDocument, options);
      }
export type AddTagMappingMutationHookResult = ReturnType<typeof useAddTagMappingMutation>;
export type AddTagMappingMutationResult = Apollo.MutationResult<AddTagMappingMutation>;
export type AddTagMappingMutationOptions = Apollo.BaseMutationOptions<AddTagMappingMutation, AddTagMappingMutationVariables>;
export const AddTrendDocument = /*#__PURE__*/ gql`
    mutation AddTrend($input: AddTrendInput!, $systemId: Int!) {
  addTrend(input: $input) {
    owner {
      ...UserNest
    }
    system {
      ...SystemNest
    }
    ...Trend
  }
}
    ${UserNestFragmentDoc}
${SystemNestFragmentDoc}
${TrendFragmentDoc}`;
export type AddTrendMutationFn = Apollo.MutationFunction<AddTrendMutation, AddTrendMutationVariables>;

/**
 * __useAddTrendMutation__
 *
 * To run a mutation, you first call `useAddTrendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrendMutation, { data, loading, error }] = useAddTrendMutation({
 *   variables: {
 *      input: // value for 'input'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useAddTrendMutation(baseOptions?: Apollo.MutationHookOptions<AddTrendMutation, AddTrendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTrendMutation, AddTrendMutationVariables>(AddTrendDocument, options);
      }
export type AddTrendMutationHookResult = ReturnType<typeof useAddTrendMutation>;
export type AddTrendMutationResult = Apollo.MutationResult<AddTrendMutation>;
export type AddTrendMutationOptions = Apollo.BaseMutationOptions<AddTrendMutation, AddTrendMutationVariables>;
export const AddUploadDocument = /*#__PURE__*/ gql`
    mutation AddUpload($input: CreateUploadInput!) {
  createUpload(input: $input) {
    ...Uploads
  }
}
    ${UploadsFragmentDoc}`;
export type AddUploadMutationFn = Apollo.MutationFunction<AddUploadMutation, AddUploadMutationVariables>;

/**
 * __useAddUploadMutation__
 *
 * To run a mutation, you first call `useAddUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUploadMutation, { data, loading, error }] = useAddUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUploadMutation(baseOptions?: Apollo.MutationHookOptions<AddUploadMutation, AddUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUploadMutation, AddUploadMutationVariables>(AddUploadDocument, options);
      }
export type AddUploadMutationHookResult = ReturnType<typeof useAddUploadMutation>;
export type AddUploadMutationResult = Apollo.MutationResult<AddUploadMutation>;
export type AddUploadMutationOptions = Apollo.BaseMutationOptions<AddUploadMutation, AddUploadMutationVariables>;
export const AddUserToSystemDocument = /*#__PURE__*/ gql`
    mutation AddUserToSystem($input: AddUserToSystemInput!, $systemId: Int!) {
  addUserToSystem(input: $input) {
    roleForSystem(systemId: $systemId)
    ...User
  }
}
    ${UserFragmentDoc}`;
export type AddUserToSystemMutationFn = Apollo.MutationFunction<AddUserToSystemMutation, AddUserToSystemMutationVariables>;

/**
 * __useAddUserToSystemMutation__
 *
 * To run a mutation, you first call `useAddUserToSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToSystemMutation, { data, loading, error }] = useAddUserToSystemMutation({
 *   variables: {
 *      input: // value for 'input'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useAddUserToSystemMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToSystemMutation, AddUserToSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToSystemMutation, AddUserToSystemMutationVariables>(AddUserToSystemDocument, options);
      }
export type AddUserToSystemMutationHookResult = ReturnType<typeof useAddUserToSystemMutation>;
export type AddUserToSystemMutationResult = Apollo.MutationResult<AddUserToSystemMutation>;
export type AddUserToSystemMutationOptions = Apollo.BaseMutationOptions<AddUserToSystemMutation, AddUserToSystemMutationVariables>;
export const AddUserToSystemGroupDocument = /*#__PURE__*/ gql`
    mutation AddUserToSystemGroup($input: AddUserToSystemGroupInput!, $systemGroupId: Int!) {
  addUserToSystemGroup(input: $input) {
    ...SystemGroupUser
  }
}
    ${SystemGroupUserFragmentDoc}`;
export type AddUserToSystemGroupMutationFn = Apollo.MutationFunction<AddUserToSystemGroupMutation, AddUserToSystemGroupMutationVariables>;

/**
 * __useAddUserToSystemGroupMutation__
 *
 * To run a mutation, you first call `useAddUserToSystemGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToSystemGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToSystemGroupMutation, { data, loading, error }] = useAddUserToSystemGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      systemGroupId: // value for 'systemGroupId'
 *   },
 * });
 */
export function useAddUserToSystemGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToSystemGroupMutation, AddUserToSystemGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToSystemGroupMutation, AddUserToSystemGroupMutationVariables>(AddUserToSystemGroupDocument, options);
      }
export type AddUserToSystemGroupMutationHookResult = ReturnType<typeof useAddUserToSystemGroupMutation>;
export type AddUserToSystemGroupMutationResult = Apollo.MutationResult<AddUserToSystemGroupMutation>;
export type AddUserToSystemGroupMutationOptions = Apollo.BaseMutationOptions<AddUserToSystemGroupMutation, AddUserToSystemGroupMutationVariables>;
export const ArchiveConstantDefinitionDocument = /*#__PURE__*/ gql`
    mutation ArchiveConstantDefinition($input: ArchiveConstantDefinitionInput!) {
  archiveConstantDefinition(input: $input) {
    ...ConstantDefinition
  }
}
    ${ConstantDefinitionFragmentDoc}`;
export type ArchiveConstantDefinitionMutationFn = Apollo.MutationFunction<ArchiveConstantDefinitionMutation, ArchiveConstantDefinitionMutationVariables>;

/**
 * __useArchiveConstantDefinitionMutation__
 *
 * To run a mutation, you first call `useArchiveConstantDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveConstantDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveConstantDefinitionMutation, { data, loading, error }] = useArchiveConstantDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveConstantDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveConstantDefinitionMutation, ArchiveConstantDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveConstantDefinitionMutation, ArchiveConstantDefinitionMutationVariables>(ArchiveConstantDefinitionDocument, options);
      }
export type ArchiveConstantDefinitionMutationHookResult = ReturnType<typeof useArchiveConstantDefinitionMutation>;
export type ArchiveConstantDefinitionMutationResult = Apollo.MutationResult<ArchiveConstantDefinitionMutation>;
export type ArchiveConstantDefinitionMutationOptions = Apollo.BaseMutationOptions<ArchiveConstantDefinitionMutation, ArchiveConstantDefinitionMutationVariables>;
export const ArchiveConstantValueDocument = /*#__PURE__*/ gql`
    mutation ArchiveConstantValue($input: ArchiveConstantValueInput!) {
  archiveConstantValue(input: $input) {
    ...ConstantValue
  }
}
    ${ConstantValueFragmentDoc}`;
export type ArchiveConstantValueMutationFn = Apollo.MutationFunction<ArchiveConstantValueMutation, ArchiveConstantValueMutationVariables>;

/**
 * __useArchiveConstantValueMutation__
 *
 * To run a mutation, you first call `useArchiveConstantValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveConstantValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveConstantValueMutation, { data, loading, error }] = useArchiveConstantValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveConstantValueMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveConstantValueMutation, ArchiveConstantValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveConstantValueMutation, ArchiveConstantValueMutationVariables>(ArchiveConstantValueDocument, options);
      }
export type ArchiveConstantValueMutationHookResult = ReturnType<typeof useArchiveConstantValueMutation>;
export type ArchiveConstantValueMutationResult = Apollo.MutationResult<ArchiveConstantValueMutation>;
export type ArchiveConstantValueMutationOptions = Apollo.BaseMutationOptions<ArchiveConstantValueMutation, ArchiveConstantValueMutationVariables>;
export const ArchiveSampleScheduleDocument = /*#__PURE__*/ gql`
    mutation ArchiveSampleSchedule($input: ArchiveSampleScheduleInput!) {
  archiveSampleSchedule(input: $input) {
    ...SampleSchedule
  }
}
    ${SampleScheduleFragmentDoc}`;
export type ArchiveSampleScheduleMutationFn = Apollo.MutationFunction<ArchiveSampleScheduleMutation, ArchiveSampleScheduleMutationVariables>;

/**
 * __useArchiveSampleScheduleMutation__
 *
 * To run a mutation, you first call `useArchiveSampleScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSampleScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSampleScheduleMutation, { data, loading, error }] = useArchiveSampleScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveSampleScheduleMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveSampleScheduleMutation, ArchiveSampleScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveSampleScheduleMutation, ArchiveSampleScheduleMutationVariables>(ArchiveSampleScheduleDocument, options);
      }
export type ArchiveSampleScheduleMutationHookResult = ReturnType<typeof useArchiveSampleScheduleMutation>;
export type ArchiveSampleScheduleMutationResult = Apollo.MutationResult<ArchiveSampleScheduleMutation>;
export type ArchiveSampleScheduleMutationOptions = Apollo.BaseMutationOptions<ArchiveSampleScheduleMutation, ArchiveSampleScheduleMutationVariables>;
export const ArchiveScheduledItemCommentDocument = /*#__PURE__*/ gql`
    mutation ArchiveScheduledItemComment($input: ArchiveScheduledItemCommentInput!) {
  archiveScheduledItemComment(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type ArchiveScheduledItemCommentMutationFn = Apollo.MutationFunction<ArchiveScheduledItemCommentMutation, ArchiveScheduledItemCommentMutationVariables>;

/**
 * __useArchiveScheduledItemCommentMutation__
 *
 * To run a mutation, you first call `useArchiveScheduledItemCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveScheduledItemCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveScheduledItemCommentMutation, { data, loading, error }] = useArchiveScheduledItemCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveScheduledItemCommentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveScheduledItemCommentMutation, ArchiveScheduledItemCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveScheduledItemCommentMutation, ArchiveScheduledItemCommentMutationVariables>(ArchiveScheduledItemCommentDocument, options);
      }
export type ArchiveScheduledItemCommentMutationHookResult = ReturnType<typeof useArchiveScheduledItemCommentMutation>;
export type ArchiveScheduledItemCommentMutationResult = Apollo.MutationResult<ArchiveScheduledItemCommentMutation>;
export type ArchiveScheduledItemCommentMutationOptions = Apollo.BaseMutationOptions<ArchiveScheduledItemCommentMutation, ArchiveScheduledItemCommentMutationVariables>;
export const ArchiveScheduledItemUploadDocument = /*#__PURE__*/ gql`
    mutation ArchiveScheduledItemUpload($input: ArchiveScheduledItemUploadInput!) {
  archiveByScheduledItemId(input: $input) {
    ...ScheduledItemsUploads
  }
}
    ${ScheduledItemsUploadsFragmentDoc}`;
export type ArchiveScheduledItemUploadMutationFn = Apollo.MutationFunction<ArchiveScheduledItemUploadMutation, ArchiveScheduledItemUploadMutationVariables>;

/**
 * __useArchiveScheduledItemUploadMutation__
 *
 * To run a mutation, you first call `useArchiveScheduledItemUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveScheduledItemUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveScheduledItemUploadMutation, { data, loading, error }] = useArchiveScheduledItemUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveScheduledItemUploadMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveScheduledItemUploadMutation, ArchiveScheduledItemUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveScheduledItemUploadMutation, ArchiveScheduledItemUploadMutationVariables>(ArchiveScheduledItemUploadDocument, options);
      }
export type ArchiveScheduledItemUploadMutationHookResult = ReturnType<typeof useArchiveScheduledItemUploadMutation>;
export type ArchiveScheduledItemUploadMutationResult = Apollo.MutationResult<ArchiveScheduledItemUploadMutation>;
export type ArchiveScheduledItemUploadMutationOptions = Apollo.BaseMutationOptions<ArchiveScheduledItemUploadMutation, ArchiveScheduledItemUploadMutationVariables>;
export const ArchiveScheduledItemsDocument = /*#__PURE__*/ gql`
    mutation ArchiveScheduledItems($input: ArchiveScheduledItemsInput!) {
  archiveScheduledItems(input: $input) {
    id
  }
}
    `;
export type ArchiveScheduledItemsMutationFn = Apollo.MutationFunction<ArchiveScheduledItemsMutation, ArchiveScheduledItemsMutationVariables>;

/**
 * __useArchiveScheduledItemsMutation__
 *
 * To run a mutation, you first call `useArchiveScheduledItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveScheduledItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveScheduledItemsMutation, { data, loading, error }] = useArchiveScheduledItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveScheduledItemsMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveScheduledItemsMutation, ArchiveScheduledItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveScheduledItemsMutation, ArchiveScheduledItemsMutationVariables>(ArchiveScheduledItemsDocument, options);
      }
export type ArchiveScheduledItemsMutationHookResult = ReturnType<typeof useArchiveScheduledItemsMutation>;
export type ArchiveScheduledItemsMutationResult = Apollo.MutationResult<ArchiveScheduledItemsMutation>;
export type ArchiveScheduledItemsMutationOptions = Apollo.BaseMutationOptions<ArchiveScheduledItemsMutation, ArchiveScheduledItemsMutationVariables>;
export const ArchiveUploadDocument = /*#__PURE__*/ gql`
    mutation ArchiveUpload($input: ArchiveUploadInput!) {
  archiveUpload(input: $input) {
    ...Uploads
  }
}
    ${UploadsFragmentDoc}`;
export type ArchiveUploadMutationFn = Apollo.MutationFunction<ArchiveUploadMutation, ArchiveUploadMutationVariables>;

/**
 * __useArchiveUploadMutation__
 *
 * To run a mutation, you first call `useArchiveUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveUploadMutation, { data, loading, error }] = useArchiveUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveUploadMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveUploadMutation, ArchiveUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveUploadMutation, ArchiveUploadMutationVariables>(ArchiveUploadDocument, options);
      }
export type ArchiveUploadMutationHookResult = ReturnType<typeof useArchiveUploadMutation>;
export type ArchiveUploadMutationResult = Apollo.MutationResult<ArchiveUploadMutation>;
export type ArchiveUploadMutationOptions = Apollo.BaseMutationOptions<ArchiveUploadMutation, ArchiveUploadMutationVariables>;
export const ArchiveWeatherDataStationDocument = /*#__PURE__*/ gql`
    mutation ArchiveWeatherDataStation($input: WeatherDataStationIdInput!) {
  archiveWeatherDataStation(input: $input) {
    ...WeatherDataStationFields
  }
}
    ${WeatherDataStationFieldsFragmentDoc}`;
export type ArchiveWeatherDataStationMutationFn = Apollo.MutationFunction<ArchiveWeatherDataStationMutation, ArchiveWeatherDataStationMutationVariables>;

/**
 * __useArchiveWeatherDataStationMutation__
 *
 * To run a mutation, you first call `useArchiveWeatherDataStationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveWeatherDataStationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveWeatherDataStationMutation, { data, loading, error }] = useArchiveWeatherDataStationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveWeatherDataStationMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveWeatherDataStationMutation, ArchiveWeatherDataStationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveWeatherDataStationMutation, ArchiveWeatherDataStationMutationVariables>(ArchiveWeatherDataStationDocument, options);
      }
export type ArchiveWeatherDataStationMutationHookResult = ReturnType<typeof useArchiveWeatherDataStationMutation>;
export type ArchiveWeatherDataStationMutationResult = Apollo.MutationResult<ArchiveWeatherDataStationMutation>;
export type ArchiveWeatherDataStationMutationOptions = Apollo.BaseMutationOptions<ArchiveWeatherDataStationMutation, ArchiveWeatherDataStationMutationVariables>;
export const CancelActivityScheduleDocument = /*#__PURE__*/ gql`
    mutation CancelActivitySchedule($input: ActivityScheduleCancelInput!) {
  cancelActivitySchedule(input: $input) {
    ...ActivitySchedule
  }
}
    ${ActivityScheduleFragmentDoc}`;
export type CancelActivityScheduleMutationFn = Apollo.MutationFunction<CancelActivityScheduleMutation, CancelActivityScheduleMutationVariables>;

/**
 * __useCancelActivityScheduleMutation__
 *
 * To run a mutation, you first call `useCancelActivityScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelActivityScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelActivityScheduleMutation, { data, loading, error }] = useCancelActivityScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelActivityScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CancelActivityScheduleMutation, CancelActivityScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelActivityScheduleMutation, CancelActivityScheduleMutationVariables>(CancelActivityScheduleDocument, options);
      }
export type CancelActivityScheduleMutationHookResult = ReturnType<typeof useCancelActivityScheduleMutation>;
export type CancelActivityScheduleMutationResult = Apollo.MutationResult<CancelActivityScheduleMutation>;
export type CancelActivityScheduleMutationOptions = Apollo.BaseMutationOptions<CancelActivityScheduleMutation, CancelActivityScheduleMutationVariables>;
export const CancelSampleScheduleDocument = /*#__PURE__*/ gql`
    mutation CancelSampleSchedule($input: CancelSampleScheduleInput!) {
  cancelSampleSchedule(input: $input) {
    ...SampleSchedule
  }
}
    ${SampleScheduleFragmentDoc}`;
export type CancelSampleScheduleMutationFn = Apollo.MutationFunction<CancelSampleScheduleMutation, CancelSampleScheduleMutationVariables>;

/**
 * __useCancelSampleScheduleMutation__
 *
 * To run a mutation, you first call `useCancelSampleScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSampleScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSampleScheduleMutation, { data, loading, error }] = useCancelSampleScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSampleScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CancelSampleScheduleMutation, CancelSampleScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSampleScheduleMutation, CancelSampleScheduleMutationVariables>(CancelSampleScheduleDocument, options);
      }
export type CancelSampleScheduleMutationHookResult = ReturnType<typeof useCancelSampleScheduleMutation>;
export type CancelSampleScheduleMutationResult = Apollo.MutationResult<CancelSampleScheduleMutation>;
export type CancelSampleScheduleMutationOptions = Apollo.BaseMutationOptions<CancelSampleScheduleMutation, CancelSampleScheduleMutationVariables>;
export const ClearRuntimeLoggerOverrideDocument = /*#__PURE__*/ gql`
    mutation ClearRuntimeLoggerOverride($name: String!) {
  clearRuntimeLoggerOverride(name: $name) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type ClearRuntimeLoggerOverrideMutationFn = Apollo.MutationFunction<ClearRuntimeLoggerOverrideMutation, ClearRuntimeLoggerOverrideMutationVariables>;

/**
 * __useClearRuntimeLoggerOverrideMutation__
 *
 * To run a mutation, you first call `useClearRuntimeLoggerOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearRuntimeLoggerOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearRuntimeLoggerOverrideMutation, { data, loading, error }] = useClearRuntimeLoggerOverrideMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useClearRuntimeLoggerOverrideMutation(baseOptions?: Apollo.MutationHookOptions<ClearRuntimeLoggerOverrideMutation, ClearRuntimeLoggerOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearRuntimeLoggerOverrideMutation, ClearRuntimeLoggerOverrideMutationVariables>(ClearRuntimeLoggerOverrideDocument, options);
      }
export type ClearRuntimeLoggerOverrideMutationHookResult = ReturnType<typeof useClearRuntimeLoggerOverrideMutation>;
export type ClearRuntimeLoggerOverrideMutationResult = Apollo.MutationResult<ClearRuntimeLoggerOverrideMutation>;
export type ClearRuntimeLoggerOverrideMutationOptions = Apollo.BaseMutationOptions<ClearRuntimeLoggerOverrideMutation, ClearRuntimeLoggerOverrideMutationVariables>;
export const ClearSsoCacheDocument = /*#__PURE__*/ gql`
    mutation ClearSsoCache {
  clearSSOCache
}
    `;
export type ClearSsoCacheMutationFn = Apollo.MutationFunction<ClearSsoCacheMutation, ClearSsoCacheMutationVariables>;

/**
 * __useClearSsoCacheMutation__
 *
 * To run a mutation, you first call `useClearSsoCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearSsoCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearSsoCacheMutation, { data, loading, error }] = useClearSsoCacheMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearSsoCacheMutation(baseOptions?: Apollo.MutationHookOptions<ClearSsoCacheMutation, ClearSsoCacheMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearSsoCacheMutation, ClearSsoCacheMutationVariables>(ClearSsoCacheDocument, options);
      }
export type ClearSsoCacheMutationHookResult = ReturnType<typeof useClearSsoCacheMutation>;
export type ClearSsoCacheMutationResult = Apollo.MutationResult<ClearSsoCacheMutation>;
export type ClearSsoCacheMutationOptions = Apollo.BaseMutationOptions<ClearSsoCacheMutation, ClearSsoCacheMutationVariables>;
export const CloneComponentsDocument = /*#__PURE__*/ gql`
    mutation CloneComponents($input: CloneComponentsInput!) {
  cloneComponents(input: $input) {
    component {
      ...ComponentNest
    }
    metrics {
      intervals {
        ...IntervalNest
        siteFullName
      }
      metricKeyname {
        ...MetricKeyname
      }
      ...MetricNest
      metricRanges {
        maxTag {
          ...Tag
        }
        ...MetricRange
        minTag {
          ...Tag
        }
      }
      unit {
        ...UnitNest
      }
    }
  }
}
    ${ComponentNestFragmentDoc}
${IntervalNestFragmentDoc}
${MetricKeynameFragmentDoc}
${MetricNestFragmentDoc}
${TagFragmentDoc}
${MetricRangeFragmentDoc}
${UnitNestFragmentDoc}`;
export type CloneComponentsMutationFn = Apollo.MutationFunction<CloneComponentsMutation, CloneComponentsMutationVariables>;

/**
 * __useCloneComponentsMutation__
 *
 * To run a mutation, you first call `useCloneComponentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneComponentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneComponentsMutation, { data, loading, error }] = useCloneComponentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneComponentsMutation(baseOptions?: Apollo.MutationHookOptions<CloneComponentsMutation, CloneComponentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneComponentsMutation, CloneComponentsMutationVariables>(CloneComponentsDocument, options);
      }
export type CloneComponentsMutationHookResult = ReturnType<typeof useCloneComponentsMutation>;
export type CloneComponentsMutationResult = Apollo.MutationResult<CloneComponentsMutation>;
export type CloneComponentsMutationOptions = Apollo.BaseMutationOptions<CloneComponentsMutation, CloneComponentsMutationVariables>;
export const CloneMetricsDocument = /*#__PURE__*/ gql`
    mutation CloneMetrics($input: CloneMetricsInput!) {
  cloneMetrics(input: $input) {
    intervals {
      ...IntervalNest
      siteFullName
    }
    metricKeyname {
      ...MetricKeyname
    }
    ...MetricNest
    metricRanges {
      maxTag {
        ...Tag
      }
      ...MetricRange
      minTag {
        ...Tag
      }
    }
    unit {
      ...UnitNest
    }
  }
}
    ${IntervalNestFragmentDoc}
${MetricKeynameFragmentDoc}
${MetricNestFragmentDoc}
${TagFragmentDoc}
${MetricRangeFragmentDoc}
${UnitNestFragmentDoc}`;
export type CloneMetricsMutationFn = Apollo.MutationFunction<CloneMetricsMutation, CloneMetricsMutationVariables>;

/**
 * __useCloneMetricsMutation__
 *
 * To run a mutation, you first call `useCloneMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneMetricsMutation, { data, loading, error }] = useCloneMetricsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneMetricsMutation(baseOptions?: Apollo.MutationHookOptions<CloneMetricsMutation, CloneMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneMetricsMutation, CloneMetricsMutationVariables>(CloneMetricsDocument, options);
      }
export type CloneMetricsMutationHookResult = ReturnType<typeof useCloneMetricsMutation>;
export type CloneMetricsMutationResult = Apollo.MutationResult<CloneMetricsMutation>;
export type CloneMetricsMutationOptions = Apollo.BaseMutationOptions<CloneMetricsMutation, CloneMetricsMutationVariables>;
export const CloneProcessesDocument = /*#__PURE__*/ gql`
    mutation CloneProcesses($input: CloneProcessesInput!) {
  cloneProcesses(input: $input) {
    components {
      ...ComponentNest
    }
    metrics {
      intervals {
        ...IntervalNest
        siteFullName
      }
      metricKeyname {
        ...MetricKeyname
      }
      ...MetricNest
      metricRanges {
        maxTag {
          ...Tag
        }
        ...MetricRange
        minTag {
          ...Tag
        }
      }
      unit {
        ...UnitNest
      }
    }
    process {
      ...ProcessNest
    }
  }
}
    ${ComponentNestFragmentDoc}
${IntervalNestFragmentDoc}
${MetricKeynameFragmentDoc}
${MetricNestFragmentDoc}
${TagFragmentDoc}
${MetricRangeFragmentDoc}
${UnitNestFragmentDoc}
${ProcessNestFragmentDoc}`;
export type CloneProcessesMutationFn = Apollo.MutationFunction<CloneProcessesMutation, CloneProcessesMutationVariables>;

/**
 * __useCloneProcessesMutation__
 *
 * To run a mutation, you first call `useCloneProcessesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneProcessesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneProcessesMutation, { data, loading, error }] = useCloneProcessesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneProcessesMutation(baseOptions?: Apollo.MutationHookOptions<CloneProcessesMutation, CloneProcessesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneProcessesMutation, CloneProcessesMutationVariables>(CloneProcessesDocument, options);
      }
export type CloneProcessesMutationHookResult = ReturnType<typeof useCloneProcessesMutation>;
export type CloneProcessesMutationResult = Apollo.MutationResult<CloneProcessesMutation>;
export type CloneProcessesMutationOptions = Apollo.BaseMutationOptions<CloneProcessesMutation, CloneProcessesMutationVariables>;
export const CloneSitesDocument = /*#__PURE__*/ gql`
    mutation CloneSites($input: CloneSitesInput!) {
  cloneSites(input: $input) {
    ...SiteNest
  }
}
    ${SiteNestFragmentDoc}`;
export type CloneSitesMutationFn = Apollo.MutationFunction<CloneSitesMutation, CloneSitesMutationVariables>;

/**
 * __useCloneSitesMutation__
 *
 * To run a mutation, you first call `useCloneSitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneSitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneSitesMutation, { data, loading, error }] = useCloneSitesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneSitesMutation(baseOptions?: Apollo.MutationHookOptions<CloneSitesMutation, CloneSitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneSitesMutation, CloneSitesMutationVariables>(CloneSitesDocument, options);
      }
export type CloneSitesMutationHookResult = ReturnType<typeof useCloneSitesMutation>;
export type CloneSitesMutationResult = Apollo.MutationResult<CloneSitesMutation>;
export type CloneSitesMutationOptions = Apollo.BaseMutationOptions<CloneSitesMutation, CloneSitesMutationVariables>;
export const CloneSystemDocument = /*#__PURE__*/ gql`
    mutation CloneSystem($input: CloneSystemInput!) {
  cloneSystem(input: $input) {
    ...SystemNest
  }
}
    ${SystemNestFragmentDoc}`;
export type CloneSystemMutationFn = Apollo.MutationFunction<CloneSystemMutation, CloneSystemMutationVariables>;

/**
 * __useCloneSystemMutation__
 *
 * To run a mutation, you first call `useCloneSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneSystemMutation, { data, loading, error }] = useCloneSystemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneSystemMutation(baseOptions?: Apollo.MutationHookOptions<CloneSystemMutation, CloneSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneSystemMutation, CloneSystemMutationVariables>(CloneSystemDocument, options);
      }
export type CloneSystemMutationHookResult = ReturnType<typeof useCloneSystemMutation>;
export type CloneSystemMutationResult = Apollo.MutationResult<CloneSystemMutation>;
export type CloneSystemMutationOptions = Apollo.BaseMutationOptions<CloneSystemMutation, CloneSystemMutationVariables>;
export const CloneSystemWithSelectedDescendantsDocument = /*#__PURE__*/ gql`
    mutation CloneSystemWithSelectedDescendants($input: CloneSystemWithSelectedDescendantsInput!) {
  cloneSystemWithSelectedDescendants(input: $input) {
    ...SystemNest
  }
}
    ${SystemNestFragmentDoc}`;
export type CloneSystemWithSelectedDescendantsMutationFn = Apollo.MutationFunction<CloneSystemWithSelectedDescendantsMutation, CloneSystemWithSelectedDescendantsMutationVariables>;

/**
 * __useCloneSystemWithSelectedDescendantsMutation__
 *
 * To run a mutation, you first call `useCloneSystemWithSelectedDescendantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneSystemWithSelectedDescendantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneSystemWithSelectedDescendantsMutation, { data, loading, error }] = useCloneSystemWithSelectedDescendantsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneSystemWithSelectedDescendantsMutation(baseOptions?: Apollo.MutationHookOptions<CloneSystemWithSelectedDescendantsMutation, CloneSystemWithSelectedDescendantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneSystemWithSelectedDescendantsMutation, CloneSystemWithSelectedDescendantsMutationVariables>(CloneSystemWithSelectedDescendantsDocument, options);
      }
export type CloneSystemWithSelectedDescendantsMutationHookResult = ReturnType<typeof useCloneSystemWithSelectedDescendantsMutation>;
export type CloneSystemWithSelectedDescendantsMutationResult = Apollo.MutationResult<CloneSystemWithSelectedDescendantsMutation>;
export type CloneSystemWithSelectedDescendantsMutationOptions = Apollo.BaseMutationOptions<CloneSystemWithSelectedDescendantsMutation, CloneSystemWithSelectedDescendantsMutationVariables>;
export const CloneToTargetDocument = /*#__PURE__*/ gql`
    mutation CloneToTarget($input: CloneToTargetInput!) {
  cloneToTarget(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type CloneToTargetMutationFn = Apollo.MutationFunction<CloneToTargetMutation, CloneToTargetMutationVariables>;

/**
 * __useCloneToTargetMutation__
 *
 * To run a mutation, you first call `useCloneToTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneToTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneToTargetMutation, { data, loading, error }] = useCloneToTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneToTargetMutation(baseOptions?: Apollo.MutationHookOptions<CloneToTargetMutation, CloneToTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneToTargetMutation, CloneToTargetMutationVariables>(CloneToTargetDocument, options);
      }
export type CloneToTargetMutationHookResult = ReturnType<typeof useCloneToTargetMutation>;
export type CloneToTargetMutationResult = Apollo.MutationResult<CloneToTargetMutation>;
export type CloneToTargetMutationOptions = Apollo.BaseMutationOptions<CloneToTargetMutation, CloneToTargetMutationVariables>;
export const CommitDirtyDataPointsDocument = /*#__PURE__*/ gql`
    mutation CommitDirtyDataPoints($input: CommitDirtyDataPointsInput!) {
  commitDirtyDataPoints(input: $input) {
    ...MetricDataPointDetails
  }
}
    ${MetricDataPointDetailsFragmentDoc}`;
export type CommitDirtyDataPointsMutationFn = Apollo.MutationFunction<CommitDirtyDataPointsMutation, CommitDirtyDataPointsMutationVariables>;

/**
 * __useCommitDirtyDataPointsMutation__
 *
 * To run a mutation, you first call `useCommitDirtyDataPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitDirtyDataPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitDirtyDataPointsMutation, { data, loading, error }] = useCommitDirtyDataPointsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommitDirtyDataPointsMutation(baseOptions?: Apollo.MutationHookOptions<CommitDirtyDataPointsMutation, CommitDirtyDataPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitDirtyDataPointsMutation, CommitDirtyDataPointsMutationVariables>(CommitDirtyDataPointsDocument, options);
      }
export type CommitDirtyDataPointsMutationHookResult = ReturnType<typeof useCommitDirtyDataPointsMutation>;
export type CommitDirtyDataPointsMutationResult = Apollo.MutationResult<CommitDirtyDataPointsMutation>;
export type CommitDirtyDataPointsMutationOptions = Apollo.BaseMutationOptions<CommitDirtyDataPointsMutation, CommitDirtyDataPointsMutationVariables>;
export const CommitLabImportBatchDocument = /*#__PURE__*/ gql`
    mutation CommitLabImportBatch($input: CommitLabImportBatchInput!) {
  commitLabImportBatch(input: $input) {
    batch {
      ...LabImportBatch
    }
    committedCount
    failedCount
  }
}
    ${LabImportBatchFragmentDoc}`;
export type CommitLabImportBatchMutationFn = Apollo.MutationFunction<CommitLabImportBatchMutation, CommitLabImportBatchMutationVariables>;

/**
 * __useCommitLabImportBatchMutation__
 *
 * To run a mutation, you first call `useCommitLabImportBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitLabImportBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitLabImportBatchMutation, { data, loading, error }] = useCommitLabImportBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommitLabImportBatchMutation(baseOptions?: Apollo.MutationHookOptions<CommitLabImportBatchMutation, CommitLabImportBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitLabImportBatchMutation, CommitLabImportBatchMutationVariables>(CommitLabImportBatchDocument, options);
      }
export type CommitLabImportBatchMutationHookResult = ReturnType<typeof useCommitLabImportBatchMutation>;
export type CommitLabImportBatchMutationResult = Apollo.MutationResult<CommitLabImportBatchMutation>;
export type CommitLabImportBatchMutationOptions = Apollo.BaseMutationOptions<CommitLabImportBatchMutation, CommitLabImportBatchMutationVariables>;
export const ConvertToFlexReportDocument = /*#__PURE__*/ gql`
    mutation ConvertToFlexReport($reportDefinitionId: Int!) {
  convertToFlexReport(reportDefinitionId: $reportDefinitionId) {
    ...ReportDefinitionNest
  }
}
    ${ReportDefinitionNestFragmentDoc}`;
export type ConvertToFlexReportMutationFn = Apollo.MutationFunction<ConvertToFlexReportMutation, ConvertToFlexReportMutationVariables>;

/**
 * __useConvertToFlexReportMutation__
 *
 * To run a mutation, you first call `useConvertToFlexReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertToFlexReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertToFlexReportMutation, { data, loading, error }] = useConvertToFlexReportMutation({
 *   variables: {
 *      reportDefinitionId: // value for 'reportDefinitionId'
 *   },
 * });
 */
export function useConvertToFlexReportMutation(baseOptions?: Apollo.MutationHookOptions<ConvertToFlexReportMutation, ConvertToFlexReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertToFlexReportMutation, ConvertToFlexReportMutationVariables>(ConvertToFlexReportDocument, options);
      }
export type ConvertToFlexReportMutationHookResult = ReturnType<typeof useConvertToFlexReportMutation>;
export type ConvertToFlexReportMutationResult = Apollo.MutationResult<ConvertToFlexReportMutation>;
export type ConvertToFlexReportMutationOptions = Apollo.BaseMutationOptions<ConvertToFlexReportMutation, ConvertToFlexReportMutationVariables>;
export const CreateAddressDocument = /*#__PURE__*/ gql`
    mutation CreateAddress($input: CreateAddressInput!) {
  createAddress(input: $input) {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export type CreateAddressMutationFn = Apollo.MutationFunction<CreateAddressMutation, CreateAddressMutationVariables>;

/**
 * __useCreateAddressMutation__
 *
 * To run a mutation, you first call `useCreateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddressMutation, { data, loading, error }] = useCreateAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateAddressMutation, CreateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAddressMutation, CreateAddressMutationVariables>(CreateAddressDocument, options);
      }
export type CreateAddressMutationHookResult = ReturnType<typeof useCreateAddressMutation>;
export type CreateAddressMutationResult = Apollo.MutationResult<CreateAddressMutation>;
export type CreateAddressMutationOptions = Apollo.BaseMutationOptions<CreateAddressMutation, CreateAddressMutationVariables>;
export const CreateAnalyteGroupDocument = /*#__PURE__*/ gql`
    mutation CreateAnalyteGroup($input: AnalyteGroupCreateInput!) {
  createAnalyteGroup(input: $input) {
    ...AnalyteGroup
  }
}
    ${AnalyteGroupFragmentDoc}`;
export type CreateAnalyteGroupMutationFn = Apollo.MutationFunction<CreateAnalyteGroupMutation, CreateAnalyteGroupMutationVariables>;

/**
 * __useCreateAnalyteGroupMutation__
 *
 * To run a mutation, you first call `useCreateAnalyteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnalyteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnalyteGroupMutation, { data, loading, error }] = useCreateAnalyteGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnalyteGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnalyteGroupMutation, CreateAnalyteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnalyteGroupMutation, CreateAnalyteGroupMutationVariables>(CreateAnalyteGroupDocument, options);
      }
export type CreateAnalyteGroupMutationHookResult = ReturnType<typeof useCreateAnalyteGroupMutation>;
export type CreateAnalyteGroupMutationResult = Apollo.MutationResult<CreateAnalyteGroupMutation>;
export type CreateAnalyteGroupMutationOptions = Apollo.BaseMutationOptions<CreateAnalyteGroupMutation, CreateAnalyteGroupMutationVariables>;
export const CreateApiTokenDocument = /*#__PURE__*/ gql`
    mutation CreateApiToken($input: CreateApiTokenInput!) {
  createApiToken(input: $input) {
    credentials {
      realm
      secret
      username
    }
    token {
      ...ApiToken
    }
  }
}
    ${ApiTokenFragmentDoc}`;
export type CreateApiTokenMutationFn = Apollo.MutationFunction<CreateApiTokenMutation, CreateApiTokenMutationVariables>;

/**
 * __useCreateApiTokenMutation__
 *
 * To run a mutation, you first call `useCreateApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiTokenMutation, { data, loading, error }] = useCreateApiTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiTokenMutation, CreateApiTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiTokenMutation, CreateApiTokenMutationVariables>(CreateApiTokenDocument, options);
      }
export type CreateApiTokenMutationHookResult = ReturnType<typeof useCreateApiTokenMutation>;
export type CreateApiTokenMutationResult = Apollo.MutationResult<CreateApiTokenMutation>;
export type CreateApiTokenMutationOptions = Apollo.BaseMutationOptions<CreateApiTokenMutation, CreateApiTokenMutationVariables>;
export const CreateCalcClusterDebugByClusterIdDocument = /*#__PURE__*/ gql`
    mutation CreateCalcClusterDebugByClusterId($input: CreateCalcClusterDebugInput!) {
  createCalcClusterDebugByClusterId(input: $input) {
    ...CalcClusterDebug
  }
}
    ${CalcClusterDebugFragmentDoc}`;
export type CreateCalcClusterDebugByClusterIdMutationFn = Apollo.MutationFunction<CreateCalcClusterDebugByClusterIdMutation, CreateCalcClusterDebugByClusterIdMutationVariables>;

/**
 * __useCreateCalcClusterDebugByClusterIdMutation__
 *
 * To run a mutation, you first call `useCreateCalcClusterDebugByClusterIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalcClusterDebugByClusterIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalcClusterDebugByClusterIdMutation, { data, loading, error }] = useCreateCalcClusterDebugByClusterIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCalcClusterDebugByClusterIdMutation(baseOptions?: Apollo.MutationHookOptions<CreateCalcClusterDebugByClusterIdMutation, CreateCalcClusterDebugByClusterIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCalcClusterDebugByClusterIdMutation, CreateCalcClusterDebugByClusterIdMutationVariables>(CreateCalcClusterDebugByClusterIdDocument, options);
      }
export type CreateCalcClusterDebugByClusterIdMutationHookResult = ReturnType<typeof useCreateCalcClusterDebugByClusterIdMutation>;
export type CreateCalcClusterDebugByClusterIdMutationResult = Apollo.MutationResult<CreateCalcClusterDebugByClusterIdMutation>;
export type CreateCalcClusterDebugByClusterIdMutationOptions = Apollo.BaseMutationOptions<CreateCalcClusterDebugByClusterIdMutation, CreateCalcClusterDebugByClusterIdMutationVariables>;
export const CreateColumnGroupDocument = /*#__PURE__*/ gql`
    mutation CreateColumnGroup($input: CreateColumnGroupInput!) {
  createColumnGroup(input: $input) {
    ...ColumnGroup
  }
}
    ${ColumnGroupFragmentDoc}`;
export type CreateColumnGroupMutationFn = Apollo.MutationFunction<CreateColumnGroupMutation, CreateColumnGroupMutationVariables>;

/**
 * __useCreateColumnGroupMutation__
 *
 * To run a mutation, you first call `useCreateColumnGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateColumnGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createColumnGroupMutation, { data, loading, error }] = useCreateColumnGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateColumnGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateColumnGroupMutation, CreateColumnGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateColumnGroupMutation, CreateColumnGroupMutationVariables>(CreateColumnGroupDocument, options);
      }
export type CreateColumnGroupMutationHookResult = ReturnType<typeof useCreateColumnGroupMutation>;
export type CreateColumnGroupMutationResult = Apollo.MutationResult<CreateColumnGroupMutation>;
export type CreateColumnGroupMutationOptions = Apollo.BaseMutationOptions<CreateColumnGroupMutation, CreateColumnGroupMutationVariables>;
export const CreateColumnGroupItemsDocument = /*#__PURE__*/ gql`
    mutation CreateColumnGroupItems($input: CreateColumnGroupItemsInput!) {
  createColumnGroupItems(input: $input) {
    ...ColumnGroupItem
  }
}
    ${ColumnGroupItemFragmentDoc}`;
export type CreateColumnGroupItemsMutationFn = Apollo.MutationFunction<CreateColumnGroupItemsMutation, CreateColumnGroupItemsMutationVariables>;

/**
 * __useCreateColumnGroupItemsMutation__
 *
 * To run a mutation, you first call `useCreateColumnGroupItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateColumnGroupItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createColumnGroupItemsMutation, { data, loading, error }] = useCreateColumnGroupItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateColumnGroupItemsMutation(baseOptions?: Apollo.MutationHookOptions<CreateColumnGroupItemsMutation, CreateColumnGroupItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateColumnGroupItemsMutation, CreateColumnGroupItemsMutationVariables>(CreateColumnGroupItemsDocument, options);
      }
export type CreateColumnGroupItemsMutationHookResult = ReturnType<typeof useCreateColumnGroupItemsMutation>;
export type CreateColumnGroupItemsMutationResult = Apollo.MutationResult<CreateColumnGroupItemsMutation>;
export type CreateColumnGroupItemsMutationOptions = Apollo.BaseMutationOptions<CreateColumnGroupItemsMutation, CreateColumnGroupItemsMutationVariables>;
export const CreateColumnGroupsAndItemsDocument = /*#__PURE__*/ gql`
    mutation CreateColumnGroupsAndItems($input: CreateColumnGroupsAndItemsInput!) {
  createColumnGroupsAndItems(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type CreateColumnGroupsAndItemsMutationFn = Apollo.MutationFunction<CreateColumnGroupsAndItemsMutation, CreateColumnGroupsAndItemsMutationVariables>;

/**
 * __useCreateColumnGroupsAndItemsMutation__
 *
 * To run a mutation, you first call `useCreateColumnGroupsAndItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateColumnGroupsAndItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createColumnGroupsAndItemsMutation, { data, loading, error }] = useCreateColumnGroupsAndItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateColumnGroupsAndItemsMutation(baseOptions?: Apollo.MutationHookOptions<CreateColumnGroupsAndItemsMutation, CreateColumnGroupsAndItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateColumnGroupsAndItemsMutation, CreateColumnGroupsAndItemsMutationVariables>(CreateColumnGroupsAndItemsDocument, options);
      }
export type CreateColumnGroupsAndItemsMutationHookResult = ReturnType<typeof useCreateColumnGroupsAndItemsMutation>;
export type CreateColumnGroupsAndItemsMutationResult = Apollo.MutationResult<CreateColumnGroupsAndItemsMutation>;
export type CreateColumnGroupsAndItemsMutationOptions = Apollo.BaseMutationOptions<CreateColumnGroupsAndItemsMutation, CreateColumnGroupsAndItemsMutationVariables>;
export const CreateComponentDocument = /*#__PURE__*/ gql`
    mutation CreateComponent($input: ComponentCreateInput!) {
  createComponent(input: $input) {
    ...ComponentNest
  }
}
    ${ComponentNestFragmentDoc}`;
export type CreateComponentMutationFn = Apollo.MutationFunction<CreateComponentMutation, CreateComponentMutationVariables>;

/**
 * __useCreateComponentMutation__
 *
 * To run a mutation, you first call `useCreateComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createComponentMutation, { data, loading, error }] = useCreateComponentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateComponentMutation(baseOptions?: Apollo.MutationHookOptions<CreateComponentMutation, CreateComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateComponentMutation, CreateComponentMutationVariables>(CreateComponentDocument, options);
      }
export type CreateComponentMutationHookResult = ReturnType<typeof useCreateComponentMutation>;
export type CreateComponentMutationResult = Apollo.MutationResult<CreateComponentMutation>;
export type CreateComponentMutationOptions = Apollo.BaseMutationOptions<CreateComponentMutation, CreateComponentMutationVariables>;
export const CreateConstantDefinitionDocument = /*#__PURE__*/ gql`
    mutation CreateConstantDefinition($input: CreateConstantDefinitionInput!) {
  createConstantDefinition(input: $input) {
    ...ConstantDefinition
  }
}
    ${ConstantDefinitionFragmentDoc}`;
export type CreateConstantDefinitionMutationFn = Apollo.MutationFunction<CreateConstantDefinitionMutation, CreateConstantDefinitionMutationVariables>;

/**
 * __useCreateConstantDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateConstantDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConstantDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConstantDefinitionMutation, { data, loading, error }] = useCreateConstantDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConstantDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateConstantDefinitionMutation, CreateConstantDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConstantDefinitionMutation, CreateConstantDefinitionMutationVariables>(CreateConstantDefinitionDocument, options);
      }
export type CreateConstantDefinitionMutationHookResult = ReturnType<typeof useCreateConstantDefinitionMutation>;
export type CreateConstantDefinitionMutationResult = Apollo.MutationResult<CreateConstantDefinitionMutation>;
export type CreateConstantDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateConstantDefinitionMutation, CreateConstantDefinitionMutationVariables>;
export const CreateEnterpriseReportShareLinkDocument = /*#__PURE__*/ gql`
    mutation CreateEnterpriseReportShareLink($input: CreateEnterpriseReportShareLinkInput!) {
  createEnterpriseReportShareLink(input: $input) {
    publicUrl
    shareLink {
      createdAt
      createdByUserId
      deletedAt
      disabledAt
      disabledByUserId
      expiresAt
      id
      reportSnapshotId
      updatedAt
    }
  }
}
    `;
export type CreateEnterpriseReportShareLinkMutationFn = Apollo.MutationFunction<CreateEnterpriseReportShareLinkMutation, CreateEnterpriseReportShareLinkMutationVariables>;

/**
 * __useCreateEnterpriseReportShareLinkMutation__
 *
 * To run a mutation, you first call `useCreateEnterpriseReportShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnterpriseReportShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnterpriseReportShareLinkMutation, { data, loading, error }] = useCreateEnterpriseReportShareLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnterpriseReportShareLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateEnterpriseReportShareLinkMutation, CreateEnterpriseReportShareLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEnterpriseReportShareLinkMutation, CreateEnterpriseReportShareLinkMutationVariables>(CreateEnterpriseReportShareLinkDocument, options);
      }
export type CreateEnterpriseReportShareLinkMutationHookResult = ReturnType<typeof useCreateEnterpriseReportShareLinkMutation>;
export type CreateEnterpriseReportShareLinkMutationResult = Apollo.MutationResult<CreateEnterpriseReportShareLinkMutation>;
export type CreateEnterpriseReportShareLinkMutationOptions = Apollo.BaseMutationOptions<CreateEnterpriseReportShareLinkMutation, CreateEnterpriseReportShareLinkMutationVariables>;
export const CreateEntryIntervalsDocument = /*#__PURE__*/ gql`
    mutation CreateEntryIntervals($input: [EntryIntervalCreateInput!]!) {
  createEntryIntervals(input: $input) {
    createdByUser {
      displayName
      email
      fullNameOrEmail
      id
    }
    createdByUserId
    date
    deletedAt
    ...IntervalNest
    siteFullName
  }
}
    ${IntervalNestFragmentDoc}`;
export type CreateEntryIntervalsMutationFn = Apollo.MutationFunction<CreateEntryIntervalsMutation, CreateEntryIntervalsMutationVariables>;

/**
 * __useCreateEntryIntervalsMutation__
 *
 * To run a mutation, you first call `useCreateEntryIntervalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntryIntervalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntryIntervalsMutation, { data, loading, error }] = useCreateEntryIntervalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntryIntervalsMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntryIntervalsMutation, CreateEntryIntervalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntryIntervalsMutation, CreateEntryIntervalsMutationVariables>(CreateEntryIntervalsDocument, options);
      }
export type CreateEntryIntervalsMutationHookResult = ReturnType<typeof useCreateEntryIntervalsMutation>;
export type CreateEntryIntervalsMutationResult = Apollo.MutationResult<CreateEntryIntervalsMutation>;
export type CreateEntryIntervalsMutationOptions = Apollo.BaseMutationOptions<CreateEntryIntervalsMutation, CreateEntryIntervalsMutationVariables>;
export const CreateFlexFormFromSystemDocument = /*#__PURE__*/ gql`
    mutation CreateFlexFormFromSystem($input: CreateFlexFormFromSystemInput!) {
  createFlexFormFromSystem(input: $input) {
    ...SiteNest
  }
}
    ${SiteNestFragmentDoc}`;
export type CreateFlexFormFromSystemMutationFn = Apollo.MutationFunction<CreateFlexFormFromSystemMutation, CreateFlexFormFromSystemMutationVariables>;

/**
 * __useCreateFlexFormFromSystemMutation__
 *
 * To run a mutation, you first call `useCreateFlexFormFromSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFlexFormFromSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFlexFormFromSystemMutation, { data, loading, error }] = useCreateFlexFormFromSystemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFlexFormFromSystemMutation(baseOptions?: Apollo.MutationHookOptions<CreateFlexFormFromSystemMutation, CreateFlexFormFromSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFlexFormFromSystemMutation, CreateFlexFormFromSystemMutationVariables>(CreateFlexFormFromSystemDocument, options);
      }
export type CreateFlexFormFromSystemMutationHookResult = ReturnType<typeof useCreateFlexFormFromSystemMutation>;
export type CreateFlexFormFromSystemMutationResult = Apollo.MutationResult<CreateFlexFormFromSystemMutation>;
export type CreateFlexFormFromSystemMutationOptions = Apollo.BaseMutationOptions<CreateFlexFormFromSystemMutation, CreateFlexFormFromSystemMutationVariables>;
export const CreateFolderDocument = /*#__PURE__*/ gql`
    mutation CreateFolder($input: CreateFolderInput!) {
  createFolder(input: $input) {
    ...BaseFolder
  }
}
    ${BaseFolderFragmentDoc}`;
export type CreateFolderMutationFn = Apollo.MutationFunction<CreateFolderMutation, CreateFolderMutationVariables>;

/**
 * __useCreateFolderMutation__
 *
 * To run a mutation, you first call `useCreateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFolderMutation, { data, loading, error }] = useCreateFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateFolderMutation, CreateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFolderMutation, CreateFolderMutationVariables>(CreateFolderDocument, options);
      }
export type CreateFolderMutationHookResult = ReturnType<typeof useCreateFolderMutation>;
export type CreateFolderMutationResult = Apollo.MutationResult<CreateFolderMutation>;
export type CreateFolderMutationOptions = Apollo.BaseMutationOptions<CreateFolderMutation, CreateFolderMutationVariables>;
export const CreateIntervalDocument = /*#__PURE__*/ gql`
    mutation CreateInterval($input: CreateIntervalInput!) {
  createInterval(input: $input) {
    ...IntervalNest
    siteFullName
  }
}
    ${IntervalNestFragmentDoc}`;
export type CreateIntervalMutationFn = Apollo.MutationFunction<CreateIntervalMutation, CreateIntervalMutationVariables>;

/**
 * __useCreateIntervalMutation__
 *
 * To run a mutation, you first call `useCreateIntervalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntervalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntervalMutation, { data, loading, error }] = useCreateIntervalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIntervalMutation(baseOptions?: Apollo.MutationHookOptions<CreateIntervalMutation, CreateIntervalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIntervalMutation, CreateIntervalMutationVariables>(CreateIntervalDocument, options);
      }
export type CreateIntervalMutationHookResult = ReturnType<typeof useCreateIntervalMutation>;
export type CreateIntervalMutationResult = Apollo.MutationResult<CreateIntervalMutation>;
export type CreateIntervalMutationOptions = Apollo.BaseMutationOptions<CreateIntervalMutation, CreateIntervalMutationVariables>;
export const CreateIntervalsDocument = /*#__PURE__*/ gql`
    mutation CreateIntervals($input: CreateIntervalsInput!) {
  createIntervals(input: $input) {
    ...IntervalNest
    siteFullName
  }
}
    ${IntervalNestFragmentDoc}`;
export type CreateIntervalsMutationFn = Apollo.MutationFunction<CreateIntervalsMutation, CreateIntervalsMutationVariables>;

/**
 * __useCreateIntervalsMutation__
 *
 * To run a mutation, you first call `useCreateIntervalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntervalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntervalsMutation, { data, loading, error }] = useCreateIntervalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIntervalsMutation(baseOptions?: Apollo.MutationHookOptions<CreateIntervalsMutation, CreateIntervalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIntervalsMutation, CreateIntervalsMutationVariables>(CreateIntervalsDocument, options);
      }
export type CreateIntervalsMutationHookResult = ReturnType<typeof useCreateIntervalsMutation>;
export type CreateIntervalsMutationResult = Apollo.MutationResult<CreateIntervalsMutation>;
export type CreateIntervalsMutationOptions = Apollo.BaseMutationOptions<CreateIntervalsMutation, CreateIntervalsMutationVariables>;
export const CreateLabImportBatchDocument = /*#__PURE__*/ gql`
    mutation CreateLabImportBatch($input: CreateLabImportBatchInput!) {
  createLabImportBatch(input: $input) {
    ...LabImportBatch
  }
}
    ${LabImportBatchFragmentDoc}`;
export type CreateLabImportBatchMutationFn = Apollo.MutationFunction<CreateLabImportBatchMutation, CreateLabImportBatchMutationVariables>;

/**
 * __useCreateLabImportBatchMutation__
 *
 * To run a mutation, you first call `useCreateLabImportBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLabImportBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLabImportBatchMutation, { data, loading, error }] = useCreateLabImportBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLabImportBatchMutation(baseOptions?: Apollo.MutationHookOptions<CreateLabImportBatchMutation, CreateLabImportBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLabImportBatchMutation, CreateLabImportBatchMutationVariables>(CreateLabImportBatchDocument, options);
      }
export type CreateLabImportBatchMutationHookResult = ReturnType<typeof useCreateLabImportBatchMutation>;
export type CreateLabImportBatchMutationResult = Apollo.MutationResult<CreateLabImportBatchMutation>;
export type CreateLabImportBatchMutationOptions = Apollo.BaseMutationOptions<CreateLabImportBatchMutation, CreateLabImportBatchMutationVariables>;
export const CreateLogBookEntryDocument = /*#__PURE__*/ gql`
    mutation CreateLogBookEntry($input: CreateLogBookEntryInput!) {
  createLogBookEntry(input: $input) {
    ...LogBookEntry
    user {
      ...UserNest
    }
  }
}
    ${LogBookEntryFragmentDoc}
${UserNestFragmentDoc}`;
export type CreateLogBookEntryMutationFn = Apollo.MutationFunction<CreateLogBookEntryMutation, CreateLogBookEntryMutationVariables>;

/**
 * __useCreateLogBookEntryMutation__
 *
 * To run a mutation, you first call `useCreateLogBookEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLogBookEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLogBookEntryMutation, { data, loading, error }] = useCreateLogBookEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLogBookEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateLogBookEntryMutation, CreateLogBookEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLogBookEntryMutation, CreateLogBookEntryMutationVariables>(CreateLogBookEntryDocument, options);
      }
export type CreateLogBookEntryMutationHookResult = ReturnType<typeof useCreateLogBookEntryMutation>;
export type CreateLogBookEntryMutationResult = Apollo.MutationResult<CreateLogBookEntryMutation>;
export type CreateLogBookEntryMutationOptions = Apollo.BaseMutationOptions<CreateLogBookEntryMutation, CreateLogBookEntryMutationVariables>;
export const CreateLogBookEntryDashboardViewDocument = /*#__PURE__*/ gql`
    mutation CreateLogBookEntryDashboardView($input: CreateLogBookEntryDashboardViewInput!) {
  createLogBookEntryDashboardView(input: $input) {
    ...LogBookEntryDashboardView
  }
}
    ${LogBookEntryDashboardViewFragmentDoc}`;
export type CreateLogBookEntryDashboardViewMutationFn = Apollo.MutationFunction<CreateLogBookEntryDashboardViewMutation, CreateLogBookEntryDashboardViewMutationVariables>;

/**
 * __useCreateLogBookEntryDashboardViewMutation__
 *
 * To run a mutation, you first call `useCreateLogBookEntryDashboardViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLogBookEntryDashboardViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLogBookEntryDashboardViewMutation, { data, loading, error }] = useCreateLogBookEntryDashboardViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLogBookEntryDashboardViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateLogBookEntryDashboardViewMutation, CreateLogBookEntryDashboardViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLogBookEntryDashboardViewMutation, CreateLogBookEntryDashboardViewMutationVariables>(CreateLogBookEntryDashboardViewDocument, options);
      }
export type CreateLogBookEntryDashboardViewMutationHookResult = ReturnType<typeof useCreateLogBookEntryDashboardViewMutation>;
export type CreateLogBookEntryDashboardViewMutationResult = Apollo.MutationResult<CreateLogBookEntryDashboardViewMutation>;
export type CreateLogBookEntryDashboardViewMutationOptions = Apollo.BaseMutationOptions<CreateLogBookEntryDashboardViewMutation, CreateLogBookEntryDashboardViewMutationVariables>;
export const CreateMetricDocument = /*#__PURE__*/ gql`
    mutation CreateMetric($input: MetricCreateInput!) {
  createMetric(input: $input) {
    intervals {
      ...IntervalNest
      siteFullName
    }
    metricKeyname {
      ...MetricKeyname
    }
    ...MetricNest
    metricRanges {
      maxTag {
        ...Tag
      }
      ...MetricRange
      minTag {
        ...Tag
      }
    }
    unit {
      ...UnitNest
    }
  }
}
    ${IntervalNestFragmentDoc}
${MetricKeynameFragmentDoc}
${MetricNestFragmentDoc}
${TagFragmentDoc}
${MetricRangeFragmentDoc}
${UnitNestFragmentDoc}`;
export type CreateMetricMutationFn = Apollo.MutationFunction<CreateMetricMutation, CreateMetricMutationVariables>;

/**
 * __useCreateMetricMutation__
 *
 * To run a mutation, you first call `useCreateMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetricMutation, { data, loading, error }] = useCreateMetricMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMetricMutation(baseOptions?: Apollo.MutationHookOptions<CreateMetricMutation, CreateMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMetricMutation, CreateMetricMutationVariables>(CreateMetricDocument, options);
      }
export type CreateMetricMutationHookResult = ReturnType<typeof useCreateMetricMutation>;
export type CreateMetricMutationResult = Apollo.MutationResult<CreateMetricMutation>;
export type CreateMetricMutationOptions = Apollo.BaseMutationOptions<CreateMetricMutation, CreateMetricMutationVariables>;
export const CreateMetricKeynameDocument = /*#__PURE__*/ gql`
    mutation CreateMetricKeyname($input: MetricKeynameCreateInput!) {
  createMetricKeyname(input: $input) {
    ...MetricKeyname
  }
}
    ${MetricKeynameFragmentDoc}`;
export type CreateMetricKeynameMutationFn = Apollo.MutationFunction<CreateMetricKeynameMutation, CreateMetricKeynameMutationVariables>;

/**
 * __useCreateMetricKeynameMutation__
 *
 * To run a mutation, you first call `useCreateMetricKeynameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetricKeynameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetricKeynameMutation, { data, loading, error }] = useCreateMetricKeynameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMetricKeynameMutation(baseOptions?: Apollo.MutationHookOptions<CreateMetricKeynameMutation, CreateMetricKeynameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMetricKeynameMutation, CreateMetricKeynameMutationVariables>(CreateMetricKeynameDocument, options);
      }
export type CreateMetricKeynameMutationHookResult = ReturnType<typeof useCreateMetricKeynameMutation>;
export type CreateMetricKeynameMutationResult = Apollo.MutationResult<CreateMetricKeynameMutation>;
export type CreateMetricKeynameMutationOptions = Apollo.BaseMutationOptions<CreateMetricKeynameMutation, CreateMetricKeynameMutationVariables>;
export const CreateNotificationDocument = /*#__PURE__*/ gql`
    mutation CreateNotification($input: CreateNotificationInput!) {
  createNotification(input: $input) {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;
export type CreateNotificationMutationFn = Apollo.MutationFunction<CreateNotificationMutation, CreateNotificationMutationVariables>;

/**
 * __useCreateNotificationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = useCreateNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationMutation, CreateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationMutation, CreateNotificationMutationVariables>(CreateNotificationDocument, options);
      }
export type CreateNotificationMutationHookResult = ReturnType<typeof useCreateNotificationMutation>;
export type CreateNotificationMutationResult = Apollo.MutationResult<CreateNotificationMutation>;
export type CreateNotificationMutationOptions = Apollo.BaseMutationOptions<CreateNotificationMutation, CreateNotificationMutationVariables>;
export const CreateOrganizationIntegrationDocument = /*#__PURE__*/ gql`
    mutation CreateOrganizationIntegration($input: CreateOrganizationIntegrationInput!) {
  createOrganizationIntegration(input: $input) {
    id
  }
}
    `;
export type CreateOrganizationIntegrationMutationFn = Apollo.MutationFunction<CreateOrganizationIntegrationMutation, CreateOrganizationIntegrationMutationVariables>;

/**
 * __useCreateOrganizationIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationIntegrationMutation, { data, loading, error }] = useCreateOrganizationIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationIntegrationMutation, CreateOrganizationIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationIntegrationMutation, CreateOrganizationIntegrationMutationVariables>(CreateOrganizationIntegrationDocument, options);
      }
export type CreateOrganizationIntegrationMutationHookResult = ReturnType<typeof useCreateOrganizationIntegrationMutation>;
export type CreateOrganizationIntegrationMutationResult = Apollo.MutationResult<CreateOrganizationIntegrationMutation>;
export type CreateOrganizationIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationIntegrationMutation, CreateOrganizationIntegrationMutationVariables>;
export const CreatePermitDocument = /*#__PURE__*/ gql`
    mutation CreatePermit($input: PermitCreateInput!) {
  createPermit(input: $input) {
    ...Permit
  }
}
    ${PermitFragmentDoc}`;
export type CreatePermitMutationFn = Apollo.MutationFunction<CreatePermitMutation, CreatePermitMutationVariables>;

/**
 * __useCreatePermitMutation__
 *
 * To run a mutation, you first call `useCreatePermitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermitMutation, { data, loading, error }] = useCreatePermitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePermitMutation(baseOptions?: Apollo.MutationHookOptions<CreatePermitMutation, CreatePermitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePermitMutation, CreatePermitMutationVariables>(CreatePermitDocument, options);
      }
export type CreatePermitMutationHookResult = ReturnType<typeof useCreatePermitMutation>;
export type CreatePermitMutationResult = Apollo.MutationResult<CreatePermitMutation>;
export type CreatePermitMutationOptions = Apollo.BaseMutationOptions<CreatePermitMutation, CreatePermitMutationVariables>;
export const CreateProcessDocument = /*#__PURE__*/ gql`
    mutation CreateProcess($input: ProcessCreateInput!) {
  createProcess(input: $input) {
    ...ProcessNest
  }
}
    ${ProcessNestFragmentDoc}`;
export type CreateProcessMutationFn = Apollo.MutationFunction<CreateProcessMutation, CreateProcessMutationVariables>;

/**
 * __useCreateProcessMutation__
 *
 * To run a mutation, you first call `useCreateProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcessMutation, { data, loading, error }] = useCreateProcessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcessMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcessMutation, CreateProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcessMutation, CreateProcessMutationVariables>(CreateProcessDocument, options);
      }
export type CreateProcessMutationHookResult = ReturnType<typeof useCreateProcessMutation>;
export type CreateProcessMutationResult = Apollo.MutationResult<CreateProcessMutation>;
export type CreateProcessMutationOptions = Apollo.BaseMutationOptions<CreateProcessMutation, CreateProcessMutationVariables>;
export const CreateReportDistributionListDocument = /*#__PURE__*/ gql`
    mutation CreateReportDistributionList($input: CreateReportDistributionListInput!) {
  createReportDistributionList(input: $input) {
    ...ReportDistributionList
  }
}
    ${ReportDistributionListFragmentDoc}`;
export type CreateReportDistributionListMutationFn = Apollo.MutationFunction<CreateReportDistributionListMutation, CreateReportDistributionListMutationVariables>;

/**
 * __useCreateReportDistributionListMutation__
 *
 * To run a mutation, you first call `useCreateReportDistributionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportDistributionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportDistributionListMutation, { data, loading, error }] = useCreateReportDistributionListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportDistributionListMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportDistributionListMutation, CreateReportDistributionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportDistributionListMutation, CreateReportDistributionListMutationVariables>(CreateReportDistributionListDocument, options);
      }
export type CreateReportDistributionListMutationHookResult = ReturnType<typeof useCreateReportDistributionListMutation>;
export type CreateReportDistributionListMutationResult = Apollo.MutationResult<CreateReportDistributionListMutation>;
export type CreateReportDistributionListMutationOptions = Apollo.BaseMutationOptions<CreateReportDistributionListMutation, CreateReportDistributionListMutationVariables>;
export const CreateRoundsShiftNoteDocument = /*#__PURE__*/ gql`
    mutation CreateRoundsShiftNote($input: CreateRoundsShiftNoteInput!) {
  createRoundsShiftNote(input: $input) {
    noteId
    viewUrl
  }
}
    `;
export type CreateRoundsShiftNoteMutationFn = Apollo.MutationFunction<CreateRoundsShiftNoteMutation, CreateRoundsShiftNoteMutationVariables>;

/**
 * __useCreateRoundsShiftNoteMutation__
 *
 * To run a mutation, you first call `useCreateRoundsShiftNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoundsShiftNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoundsShiftNoteMutation, { data, loading, error }] = useCreateRoundsShiftNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoundsShiftNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoundsShiftNoteMutation, CreateRoundsShiftNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoundsShiftNoteMutation, CreateRoundsShiftNoteMutationVariables>(CreateRoundsShiftNoteDocument, options);
      }
export type CreateRoundsShiftNoteMutationHookResult = ReturnType<typeof useCreateRoundsShiftNoteMutation>;
export type CreateRoundsShiftNoteMutationResult = Apollo.MutationResult<CreateRoundsShiftNoteMutation>;
export type CreateRoundsShiftNoteMutationOptions = Apollo.BaseMutationOptions<CreateRoundsShiftNoteMutation, CreateRoundsShiftNoteMutationVariables>;
export const CreateSampleCollectionDocument = /*#__PURE__*/ gql`
    mutation CreateSampleCollection($input: SampleCollectionCreateInput!) {
  createSampleCollection(input: $input) {
    ...SampleCollection
  }
}
    ${SampleCollectionFragmentDoc}`;
export type CreateSampleCollectionMutationFn = Apollo.MutationFunction<CreateSampleCollectionMutation, CreateSampleCollectionMutationVariables>;

/**
 * __useCreateSampleCollectionMutation__
 *
 * To run a mutation, you first call `useCreateSampleCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSampleCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSampleCollectionMutation, { data, loading, error }] = useCreateSampleCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSampleCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSampleCollectionMutation, CreateSampleCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSampleCollectionMutation, CreateSampleCollectionMutationVariables>(CreateSampleCollectionDocument, options);
      }
export type CreateSampleCollectionMutationHookResult = ReturnType<typeof useCreateSampleCollectionMutation>;
export type CreateSampleCollectionMutationResult = Apollo.MutationResult<CreateSampleCollectionMutation>;
export type CreateSampleCollectionMutationOptions = Apollo.BaseMutationOptions<CreateSampleCollectionMutation, CreateSampleCollectionMutationVariables>;
export const CreateSampleCollectionCustodyDocument = /*#__PURE__*/ gql`
    mutation CreateSampleCollectionCustody($input: SampleCollectionCustodyCreateInput!) {
  createSampleCollectionCustody(input: $input) {
    ...SampleCollectionCustody
  }
}
    ${SampleCollectionCustodyFragmentDoc}`;
export type CreateSampleCollectionCustodyMutationFn = Apollo.MutationFunction<CreateSampleCollectionCustodyMutation, CreateSampleCollectionCustodyMutationVariables>;

/**
 * __useCreateSampleCollectionCustodyMutation__
 *
 * To run a mutation, you first call `useCreateSampleCollectionCustodyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSampleCollectionCustodyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSampleCollectionCustodyMutation, { data, loading, error }] = useCreateSampleCollectionCustodyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSampleCollectionCustodyMutation(baseOptions?: Apollo.MutationHookOptions<CreateSampleCollectionCustodyMutation, CreateSampleCollectionCustodyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSampleCollectionCustodyMutation, CreateSampleCollectionCustodyMutationVariables>(CreateSampleCollectionCustodyDocument, options);
      }
export type CreateSampleCollectionCustodyMutationHookResult = ReturnType<typeof useCreateSampleCollectionCustodyMutation>;
export type CreateSampleCollectionCustodyMutationResult = Apollo.MutationResult<CreateSampleCollectionCustodyMutation>;
export type CreateSampleCollectionCustodyMutationOptions = Apollo.BaseMutationOptions<CreateSampleCollectionCustodyMutation, CreateSampleCollectionCustodyMutationVariables>;
export const CreateSampleScheduleDocument = /*#__PURE__*/ gql`
    mutation CreateSampleSchedule($input: CreateSampleScheduleInput!) {
  createSampleSchedule(input: $input) {
    ...SampleSchedule
  }
}
    ${SampleScheduleFragmentDoc}`;
export type CreateSampleScheduleMutationFn = Apollo.MutationFunction<CreateSampleScheduleMutation, CreateSampleScheduleMutationVariables>;

/**
 * __useCreateSampleScheduleMutation__
 *
 * To run a mutation, you first call `useCreateSampleScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSampleScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSampleScheduleMutation, { data, loading, error }] = useCreateSampleScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSampleScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateSampleScheduleMutation, CreateSampleScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSampleScheduleMutation, CreateSampleScheduleMutationVariables>(CreateSampleScheduleDocument, options);
      }
export type CreateSampleScheduleMutationHookResult = ReturnType<typeof useCreateSampleScheduleMutation>;
export type CreateSampleScheduleMutationResult = Apollo.MutationResult<CreateSampleScheduleMutation>;
export type CreateSampleScheduleMutationOptions = Apollo.BaseMutationOptions<CreateSampleScheduleMutation, CreateSampleScheduleMutationVariables>;
export const CreateSampleSiteDocument = /*#__PURE__*/ gql`
    mutation CreateSampleSite($input: SampleSiteCreateInput!) {
  createSampleSite(input: $input) {
    ...SampleSite
  }
}
    ${SampleSiteFragmentDoc}`;
export type CreateSampleSiteMutationFn = Apollo.MutationFunction<CreateSampleSiteMutation, CreateSampleSiteMutationVariables>;

/**
 * __useCreateSampleSiteMutation__
 *
 * To run a mutation, you first call `useCreateSampleSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSampleSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSampleSiteMutation, { data, loading, error }] = useCreateSampleSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSampleSiteMutation(baseOptions?: Apollo.MutationHookOptions<CreateSampleSiteMutation, CreateSampleSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSampleSiteMutation, CreateSampleSiteMutationVariables>(CreateSampleSiteDocument, options);
      }
export type CreateSampleSiteMutationHookResult = ReturnType<typeof useCreateSampleSiteMutation>;
export type CreateSampleSiteMutationResult = Apollo.MutationResult<CreateSampleSiteMutation>;
export type CreateSampleSiteMutationOptions = Apollo.BaseMutationOptions<CreateSampleSiteMutation, CreateSampleSiteMutationVariables>;
export const CreateScheduledItemCommentDocument = /*#__PURE__*/ gql`
    mutation CreateScheduledItemComment($input: CreateScheduledItemCommentInput!) {
  createScheduledItemComment(input: $input) {
    ...ScheduledItemComment
  }
}
    ${ScheduledItemCommentFragmentDoc}`;
export type CreateScheduledItemCommentMutationFn = Apollo.MutationFunction<CreateScheduledItemCommentMutation, CreateScheduledItemCommentMutationVariables>;

/**
 * __useCreateScheduledItemCommentMutation__
 *
 * To run a mutation, you first call `useCreateScheduledItemCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledItemCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledItemCommentMutation, { data, loading, error }] = useCreateScheduledItemCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduledItemCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduledItemCommentMutation, CreateScheduledItemCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduledItemCommentMutation, CreateScheduledItemCommentMutationVariables>(CreateScheduledItemCommentDocument, options);
      }
export type CreateScheduledItemCommentMutationHookResult = ReturnType<typeof useCreateScheduledItemCommentMutation>;
export type CreateScheduledItemCommentMutationResult = Apollo.MutationResult<CreateScheduledItemCommentMutation>;
export type CreateScheduledItemCommentMutationOptions = Apollo.BaseMutationOptions<CreateScheduledItemCommentMutation, CreateScheduledItemCommentMutationVariables>;
export const CreateSystemDocument = /*#__PURE__*/ gql`
    mutation CreateSystem($input: CreateSystemInput!) {
  createSystem(input: $input) {
    addresses {
      ...Address
    }
    ...SystemNest
  }
}
    ${AddressFragmentDoc}
${SystemNestFragmentDoc}`;
export type CreateSystemMutationFn = Apollo.MutationFunction<CreateSystemMutation, CreateSystemMutationVariables>;

/**
 * __useCreateSystemMutation__
 *
 * To run a mutation, you first call `useCreateSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSystemMutation, { data, loading, error }] = useCreateSystemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSystemMutation(baseOptions?: Apollo.MutationHookOptions<CreateSystemMutation, CreateSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSystemMutation, CreateSystemMutationVariables>(CreateSystemDocument, options);
      }
export type CreateSystemMutationHookResult = ReturnType<typeof useCreateSystemMutation>;
export type CreateSystemMutationResult = Apollo.MutationResult<CreateSystemMutation>;
export type CreateSystemMutationOptions = Apollo.BaseMutationOptions<CreateSystemMutation, CreateSystemMutationVariables>;
export const CreateTagDocument = /*#__PURE__*/ gql`
    mutation CreateTag($input: CreateTagInput!) {
  createTag(input: $input) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const CreateUnitDocument = /*#__PURE__*/ gql`
    mutation CreateUnit($input: UnitCreateInput!) {
  createUnit(input: $input) {
    ...UnitNest
  }
}
    ${UnitNestFragmentDoc}`;
export type CreateUnitMutationFn = Apollo.MutationFunction<CreateUnitMutation, CreateUnitMutationVariables>;

/**
 * __useCreateUnitMutation__
 *
 * To run a mutation, you first call `useCreateUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnitMutation, { data, loading, error }] = useCreateUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUnitMutation(baseOptions?: Apollo.MutationHookOptions<CreateUnitMutation, CreateUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUnitMutation, CreateUnitMutationVariables>(CreateUnitDocument, options);
      }
export type CreateUnitMutationHookResult = ReturnType<typeof useCreateUnitMutation>;
export type CreateUnitMutationResult = Apollo.MutationResult<CreateUnitMutation>;
export type CreateUnitMutationOptions = Apollo.BaseMutationOptions<CreateUnitMutation, CreateUnitMutationVariables>;
export const CreateUserPhraseDocument = /*#__PURE__*/ gql`
    mutation CreateUserPhrase($input: CreatePhraseInput!) {
  createPhrase(input: $input) {
    ...Phrase
  }
}
    ${PhraseFragmentDoc}`;
export type CreateUserPhraseMutationFn = Apollo.MutationFunction<CreateUserPhraseMutation, CreateUserPhraseMutationVariables>;

/**
 * __useCreateUserPhraseMutation__
 *
 * To run a mutation, you first call `useCreateUserPhraseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserPhraseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserPhraseMutation, { data, loading, error }] = useCreateUserPhraseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserPhraseMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserPhraseMutation, CreateUserPhraseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserPhraseMutation, CreateUserPhraseMutationVariables>(CreateUserPhraseDocument, options);
      }
export type CreateUserPhraseMutationHookResult = ReturnType<typeof useCreateUserPhraseMutation>;
export type CreateUserPhraseMutationResult = Apollo.MutationResult<CreateUserPhraseMutation>;
export type CreateUserPhraseMutationOptions = Apollo.BaseMutationOptions<CreateUserPhraseMutation, CreateUserPhraseMutationVariables>;
export const CreateWeatherDataStationDocument = /*#__PURE__*/ gql`
    mutation CreateWeatherDataStation($input: CreateWeatherDataStationInput!) {
  createWeatherDataStation(input: $input) {
    ...WeatherDataStationFields
  }
}
    ${WeatherDataStationFieldsFragmentDoc}`;
export type CreateWeatherDataStationMutationFn = Apollo.MutationFunction<CreateWeatherDataStationMutation, CreateWeatherDataStationMutationVariables>;

/**
 * __useCreateWeatherDataStationMutation__
 *
 * To run a mutation, you first call `useCreateWeatherDataStationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWeatherDataStationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWeatherDataStationMutation, { data, loading, error }] = useCreateWeatherDataStationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWeatherDataStationMutation(baseOptions?: Apollo.MutationHookOptions<CreateWeatherDataStationMutation, CreateWeatherDataStationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWeatherDataStationMutation, CreateWeatherDataStationMutationVariables>(CreateWeatherDataStationDocument, options);
      }
export type CreateWeatherDataStationMutationHookResult = ReturnType<typeof useCreateWeatherDataStationMutation>;
export type CreateWeatherDataStationMutationResult = Apollo.MutationResult<CreateWeatherDataStationMutation>;
export type CreateWeatherDataStationMutationOptions = Apollo.BaseMutationOptions<CreateWeatherDataStationMutation, CreateWeatherDataStationMutationVariables>;
export const DeleteActivityScheduleDocument = /*#__PURE__*/ gql`
    mutation DeleteActivitySchedule($id: String!) {
  deleteActivitySchedule(id: $id) {
    id
  }
}
    `;
export type DeleteActivityScheduleMutationFn = Apollo.MutationFunction<DeleteActivityScheduleMutation, DeleteActivityScheduleMutationVariables>;

/**
 * __useDeleteActivityScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteActivityScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActivityScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActivityScheduleMutation, { data, loading, error }] = useDeleteActivityScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteActivityScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActivityScheduleMutation, DeleteActivityScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActivityScheduleMutation, DeleteActivityScheduleMutationVariables>(DeleteActivityScheduleDocument, options);
      }
export type DeleteActivityScheduleMutationHookResult = ReturnType<typeof useDeleteActivityScheduleMutation>;
export type DeleteActivityScheduleMutationResult = Apollo.MutationResult<DeleteActivityScheduleMutation>;
export type DeleteActivityScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteActivityScheduleMutation, DeleteActivityScheduleMutationVariables>;
export const DeleteColumnGroupItemDocument = /*#__PURE__*/ gql`
    mutation DeleteColumnGroupItem($input: DeleteColumnGroupItemInput!) {
  deleteColumnGroupItem(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteColumnGroupItemMutationFn = Apollo.MutationFunction<DeleteColumnGroupItemMutation, DeleteColumnGroupItemMutationVariables>;

/**
 * __useDeleteColumnGroupItemMutation__
 *
 * To run a mutation, you first call `useDeleteColumnGroupItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteColumnGroupItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteColumnGroupItemMutation, { data, loading, error }] = useDeleteColumnGroupItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteColumnGroupItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteColumnGroupItemMutation, DeleteColumnGroupItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteColumnGroupItemMutation, DeleteColumnGroupItemMutationVariables>(DeleteColumnGroupItemDocument, options);
      }
export type DeleteColumnGroupItemMutationHookResult = ReturnType<typeof useDeleteColumnGroupItemMutation>;
export type DeleteColumnGroupItemMutationResult = Apollo.MutationResult<DeleteColumnGroupItemMutation>;
export type DeleteColumnGroupItemMutationOptions = Apollo.BaseMutationOptions<DeleteColumnGroupItemMutation, DeleteColumnGroupItemMutationVariables>;
export const DeleteComponentDocument = /*#__PURE__*/ gql`
    mutation DeleteComponent($input: DeleteComponentInput!) {
  deleteComponent(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteComponentMutationFn = Apollo.MutationFunction<DeleteComponentMutation, DeleteComponentMutationVariables>;

/**
 * __useDeleteComponentMutation__
 *
 * To run a mutation, you first call `useDeleteComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteComponentMutation, { data, loading, error }] = useDeleteComponentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteComponentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteComponentMutation, DeleteComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteComponentMutation, DeleteComponentMutationVariables>(DeleteComponentDocument, options);
      }
export type DeleteComponentMutationHookResult = ReturnType<typeof useDeleteComponentMutation>;
export type DeleteComponentMutationResult = Apollo.MutationResult<DeleteComponentMutation>;
export type DeleteComponentMutationOptions = Apollo.BaseMutationOptions<DeleteComponentMutation, DeleteComponentMutationVariables>;
export const DeleteFolderDocument = /*#__PURE__*/ gql`
    mutation DeleteFolder($input: DeleteFolderInput!) {
  deleteFolder(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteFolderMutationFn = Apollo.MutationFunction<DeleteFolderMutation, DeleteFolderMutationVariables>;

/**
 * __useDeleteFolderMutation__
 *
 * To run a mutation, you first call `useDeleteFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderMutation, { data, loading, error }] = useDeleteFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFolderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFolderMutation, DeleteFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFolderMutation, DeleteFolderMutationVariables>(DeleteFolderDocument, options);
      }
export type DeleteFolderMutationHookResult = ReturnType<typeof useDeleteFolderMutation>;
export type DeleteFolderMutationResult = Apollo.MutationResult<DeleteFolderMutation>;
export type DeleteFolderMutationOptions = Apollo.BaseMutationOptions<DeleteFolderMutation, DeleteFolderMutationVariables>;
export const DeleteIntervalDocument = /*#__PURE__*/ gql`
    mutation DeleteInterval($input: DeleteIntervalInput!) {
  deleteInterval(input: $input) {
    ...Interval
  }
}
    ${IntervalFragmentDoc}`;
export type DeleteIntervalMutationFn = Apollo.MutationFunction<DeleteIntervalMutation, DeleteIntervalMutationVariables>;

/**
 * __useDeleteIntervalMutation__
 *
 * To run a mutation, you first call `useDeleteIntervalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntervalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntervalMutation, { data, loading, error }] = useDeleteIntervalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteIntervalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIntervalMutation, DeleteIntervalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIntervalMutation, DeleteIntervalMutationVariables>(DeleteIntervalDocument, options);
      }
export type DeleteIntervalMutationHookResult = ReturnType<typeof useDeleteIntervalMutation>;
export type DeleteIntervalMutationResult = Apollo.MutationResult<DeleteIntervalMutation>;
export type DeleteIntervalMutationOptions = Apollo.BaseMutationOptions<DeleteIntervalMutation, DeleteIntervalMutationVariables>;
export const DeleteLicenseDocument = /*#__PURE__*/ gql`
    mutation DeleteLicense($input: DeleteLicenseInput!) {
  deleteLicense(input: $input) {
    ...License
  }
}
    ${LicenseFragmentDoc}`;
export type DeleteLicenseMutationFn = Apollo.MutationFunction<DeleteLicenseMutation, DeleteLicenseMutationVariables>;

/**
 * __useDeleteLicenseMutation__
 *
 * To run a mutation, you first call `useDeleteLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLicenseMutation, { data, loading, error }] = useDeleteLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLicenseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLicenseMutation, DeleteLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLicenseMutation, DeleteLicenseMutationVariables>(DeleteLicenseDocument, options);
      }
export type DeleteLicenseMutationHookResult = ReturnType<typeof useDeleteLicenseMutation>;
export type DeleteLicenseMutationResult = Apollo.MutationResult<DeleteLicenseMutation>;
export type DeleteLicenseMutationOptions = Apollo.BaseMutationOptions<DeleteLicenseMutation, DeleteLicenseMutationVariables>;
export const DeleteLogBookEntryDocument = /*#__PURE__*/ gql`
    mutation DeleteLogBookEntry($input: DeleteLogBookEntryInput!) {
  deleteLogBookEntry(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteLogBookEntryMutationFn = Apollo.MutationFunction<DeleteLogBookEntryMutation, DeleteLogBookEntryMutationVariables>;

/**
 * __useDeleteLogBookEntryMutation__
 *
 * To run a mutation, you first call `useDeleteLogBookEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLogBookEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLogBookEntryMutation, { data, loading, error }] = useDeleteLogBookEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLogBookEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLogBookEntryMutation, DeleteLogBookEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLogBookEntryMutation, DeleteLogBookEntryMutationVariables>(DeleteLogBookEntryDocument, options);
      }
export type DeleteLogBookEntryMutationHookResult = ReturnType<typeof useDeleteLogBookEntryMutation>;
export type DeleteLogBookEntryMutationResult = Apollo.MutationResult<DeleteLogBookEntryMutation>;
export type DeleteLogBookEntryMutationOptions = Apollo.BaseMutationOptions<DeleteLogBookEntryMutation, DeleteLogBookEntryMutationVariables>;
export const DeleteLogBookEntryDashboardViewDocument = /*#__PURE__*/ gql`
    mutation DeleteLogBookEntryDashboardView($input: DeleteLogBookEntryDashboardViewInput!) {
  deleteLogBookEntryDashboardView(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteLogBookEntryDashboardViewMutationFn = Apollo.MutationFunction<DeleteLogBookEntryDashboardViewMutation, DeleteLogBookEntryDashboardViewMutationVariables>;

/**
 * __useDeleteLogBookEntryDashboardViewMutation__
 *
 * To run a mutation, you first call `useDeleteLogBookEntryDashboardViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLogBookEntryDashboardViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLogBookEntryDashboardViewMutation, { data, loading, error }] = useDeleteLogBookEntryDashboardViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLogBookEntryDashboardViewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLogBookEntryDashboardViewMutation, DeleteLogBookEntryDashboardViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLogBookEntryDashboardViewMutation, DeleteLogBookEntryDashboardViewMutationVariables>(DeleteLogBookEntryDashboardViewDocument, options);
      }
export type DeleteLogBookEntryDashboardViewMutationHookResult = ReturnType<typeof useDeleteLogBookEntryDashboardViewMutation>;
export type DeleteLogBookEntryDashboardViewMutationResult = Apollo.MutationResult<DeleteLogBookEntryDashboardViewMutation>;
export type DeleteLogBookEntryDashboardViewMutationOptions = Apollo.BaseMutationOptions<DeleteLogBookEntryDashboardViewMutation, DeleteLogBookEntryDashboardViewMutationVariables>;
export const DeleteMetricDocument = /*#__PURE__*/ gql`
    mutation DeleteMetric($input: DeleteMetricInput!) {
  deleteMetric(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteMetricMutationFn = Apollo.MutationFunction<DeleteMetricMutation, DeleteMetricMutationVariables>;

/**
 * __useDeleteMetricMutation__
 *
 * To run a mutation, you first call `useDeleteMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMetricMutation, { data, loading, error }] = useDeleteMetricMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMetricMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMetricMutation, DeleteMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMetricMutation, DeleteMetricMutationVariables>(DeleteMetricDocument, options);
      }
export type DeleteMetricMutationHookResult = ReturnType<typeof useDeleteMetricMutation>;
export type DeleteMetricMutationResult = Apollo.MutationResult<DeleteMetricMutation>;
export type DeleteMetricMutationOptions = Apollo.BaseMutationOptions<DeleteMetricMutation, DeleteMetricMutationVariables>;
export const DeleteMetricKeynameDocument = /*#__PURE__*/ gql`
    mutation DeleteMetricKeyname($input: MetricKeynameDeleteInput!) {
  deleteMetricKeyname(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteMetricKeynameMutationFn = Apollo.MutationFunction<DeleteMetricKeynameMutation, DeleteMetricKeynameMutationVariables>;

/**
 * __useDeleteMetricKeynameMutation__
 *
 * To run a mutation, you first call `useDeleteMetricKeynameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMetricKeynameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMetricKeynameMutation, { data, loading, error }] = useDeleteMetricKeynameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMetricKeynameMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMetricKeynameMutation, DeleteMetricKeynameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMetricKeynameMutation, DeleteMetricKeynameMutationVariables>(DeleteMetricKeynameDocument, options);
      }
export type DeleteMetricKeynameMutationHookResult = ReturnType<typeof useDeleteMetricKeynameMutation>;
export type DeleteMetricKeynameMutationResult = Apollo.MutationResult<DeleteMetricKeynameMutation>;
export type DeleteMetricKeynameMutationOptions = Apollo.BaseMutationOptions<DeleteMetricKeynameMutation, DeleteMetricKeynameMutationVariables>;
export const DeleteMetricRangeDocument = /*#__PURE__*/ gql`
    mutation DeleteMetricRange($input: DeleteMetricRangeInput!) {
  deleteMetricRange(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteMetricRangeMutationFn = Apollo.MutationFunction<DeleteMetricRangeMutation, DeleteMetricRangeMutationVariables>;

/**
 * __useDeleteMetricRangeMutation__
 *
 * To run a mutation, you first call `useDeleteMetricRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMetricRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMetricRangeMutation, { data, loading, error }] = useDeleteMetricRangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMetricRangeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMetricRangeMutation, DeleteMetricRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMetricRangeMutation, DeleteMetricRangeMutationVariables>(DeleteMetricRangeDocument, options);
      }
export type DeleteMetricRangeMutationHookResult = ReturnType<typeof useDeleteMetricRangeMutation>;
export type DeleteMetricRangeMutationResult = Apollo.MutationResult<DeleteMetricRangeMutation>;
export type DeleteMetricRangeMutationOptions = Apollo.BaseMutationOptions<DeleteMetricRangeMutation, DeleteMetricRangeMutationVariables>;
export const DeleteNotificationDocument = /*#__PURE__*/ gql`
    mutation DeleteNotification($input: DeleteNotificationInput!) {
  deleteNotification(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteNotificationMutationFn = Apollo.MutationFunction<DeleteNotificationMutation, DeleteNotificationMutationVariables>;

/**
 * __useDeleteNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationMutation, { data, loading, error }] = useDeleteNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationMutation, DeleteNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationMutation, DeleteNotificationMutationVariables>(DeleteNotificationDocument, options);
      }
export type DeleteNotificationMutationHookResult = ReturnType<typeof useDeleteNotificationMutation>;
export type DeleteNotificationMutationResult = Apollo.MutationResult<DeleteNotificationMutation>;
export type DeleteNotificationMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationMutation, DeleteNotificationMutationVariables>;
export const DeleteOrganizationIntegrationDocument = /*#__PURE__*/ gql`
    mutation DeleteOrganizationIntegration($input: DeleteOrganizationIntegrationInput!) {
  deleteOrganizationIntegration(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteOrganizationIntegrationMutationFn = Apollo.MutationFunction<DeleteOrganizationIntegrationMutation, DeleteOrganizationIntegrationMutationVariables>;

/**
 * __useDeleteOrganizationIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationIntegrationMutation, { data, loading, error }] = useDeleteOrganizationIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganizationIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationIntegrationMutation, DeleteOrganizationIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationIntegrationMutation, DeleteOrganizationIntegrationMutationVariables>(DeleteOrganizationIntegrationDocument, options);
      }
export type DeleteOrganizationIntegrationMutationHookResult = ReturnType<typeof useDeleteOrganizationIntegrationMutation>;
export type DeleteOrganizationIntegrationMutationResult = Apollo.MutationResult<DeleteOrganizationIntegrationMutation>;
export type DeleteOrganizationIntegrationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationIntegrationMutation, DeleteOrganizationIntegrationMutationVariables>;
export const DeletePermitDocument = /*#__PURE__*/ gql`
    mutation DeletePermit($input: DeletePermitInput!) {
  deletePermit(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeletePermitMutationFn = Apollo.MutationFunction<DeletePermitMutation, DeletePermitMutationVariables>;

/**
 * __useDeletePermitMutation__
 *
 * To run a mutation, you first call `useDeletePermitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePermitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePermitMutation, { data, loading, error }] = useDeletePermitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePermitMutation(baseOptions?: Apollo.MutationHookOptions<DeletePermitMutation, DeletePermitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePermitMutation, DeletePermitMutationVariables>(DeletePermitDocument, options);
      }
export type DeletePermitMutationHookResult = ReturnType<typeof useDeletePermitMutation>;
export type DeletePermitMutationResult = Apollo.MutationResult<DeletePermitMutation>;
export type DeletePermitMutationOptions = Apollo.BaseMutationOptions<DeletePermitMutation, DeletePermitMutationVariables>;
export const DeletePhoneNumberDocument = /*#__PURE__*/ gql`
    mutation DeletePhoneNumber($input: DeletePhoneNumberInput!) {
  deletePhoneNumber(input: $input) {
    ...PhoneNumber
  }
}
    ${PhoneNumberFragmentDoc}`;
export type DeletePhoneNumberMutationFn = Apollo.MutationFunction<DeletePhoneNumberMutation, DeletePhoneNumberMutationVariables>;

/**
 * __useDeletePhoneNumberMutation__
 *
 * To run a mutation, you first call `useDeletePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePhoneNumberMutation, { data, loading, error }] = useDeletePhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<DeletePhoneNumberMutation, DeletePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePhoneNumberMutation, DeletePhoneNumberMutationVariables>(DeletePhoneNumberDocument, options);
      }
export type DeletePhoneNumberMutationHookResult = ReturnType<typeof useDeletePhoneNumberMutation>;
export type DeletePhoneNumberMutationResult = Apollo.MutationResult<DeletePhoneNumberMutation>;
export type DeletePhoneNumberMutationOptions = Apollo.BaseMutationOptions<DeletePhoneNumberMutation, DeletePhoneNumberMutationVariables>;
export const DeletePhraseDocument = /*#__PURE__*/ gql`
    mutation DeletePhrase($input: DeletePhraseInput!) {
  deletePhrase(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeletePhraseMutationFn = Apollo.MutationFunction<DeletePhraseMutation, DeletePhraseMutationVariables>;

/**
 * __useDeletePhraseMutation__
 *
 * To run a mutation, you first call `useDeletePhraseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhraseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePhraseMutation, { data, loading, error }] = useDeletePhraseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePhraseMutation(baseOptions?: Apollo.MutationHookOptions<DeletePhraseMutation, DeletePhraseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePhraseMutation, DeletePhraseMutationVariables>(DeletePhraseDocument, options);
      }
export type DeletePhraseMutationHookResult = ReturnType<typeof useDeletePhraseMutation>;
export type DeletePhraseMutationResult = Apollo.MutationResult<DeletePhraseMutation>;
export type DeletePhraseMutationOptions = Apollo.BaseMutationOptions<DeletePhraseMutation, DeletePhraseMutationVariables>;
export const DeleteProcessDocument = /*#__PURE__*/ gql`
    mutation DeleteProcess($input: DeleteProcessInput!) {
  deleteProcess(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteProcessMutationFn = Apollo.MutationFunction<DeleteProcessMutation, DeleteProcessMutationVariables>;

/**
 * __useDeleteProcessMutation__
 *
 * To run a mutation, you first call `useDeleteProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProcessMutation, { data, loading, error }] = useDeleteProcessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProcessMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProcessMutation, DeleteProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProcessMutation, DeleteProcessMutationVariables>(DeleteProcessDocument, options);
      }
export type DeleteProcessMutationHookResult = ReturnType<typeof useDeleteProcessMutation>;
export type DeleteProcessMutationResult = Apollo.MutationResult<DeleteProcessMutation>;
export type DeleteProcessMutationOptions = Apollo.BaseMutationOptions<DeleteProcessMutation, DeleteProcessMutationVariables>;
export const DeleteReportNodesDocument = /*#__PURE__*/ gql`
    mutation DeleteReportNodes($input: DeleteReportNodesInput!) {
  deleteReportNodes(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteReportNodesMutationFn = Apollo.MutationFunction<DeleteReportNodesMutation, DeleteReportNodesMutationVariables>;

/**
 * __useDeleteReportNodesMutation__
 *
 * To run a mutation, you first call `useDeleteReportNodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportNodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportNodesMutation, { data, loading, error }] = useDeleteReportNodesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReportNodesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportNodesMutation, DeleteReportNodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportNodesMutation, DeleteReportNodesMutationVariables>(DeleteReportNodesDocument, options);
      }
export type DeleteReportNodesMutationHookResult = ReturnType<typeof useDeleteReportNodesMutation>;
export type DeleteReportNodesMutationResult = Apollo.MutationResult<DeleteReportNodesMutation>;
export type DeleteReportNodesMutationOptions = Apollo.BaseMutationOptions<DeleteReportNodesMutation, DeleteReportNodesMutationVariables>;
export const DeleteSiteDocument = /*#__PURE__*/ gql`
    mutation DeleteSite($input: DeleteSiteInput!) {
  deleteSite(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteSiteMutationFn = Apollo.MutationFunction<DeleteSiteMutation, DeleteSiteMutationVariables>;

/**
 * __useDeleteSiteMutation__
 *
 * To run a mutation, you first call `useDeleteSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSiteMutation, { data, loading, error }] = useDeleteSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSiteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSiteMutation, DeleteSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSiteMutation, DeleteSiteMutationVariables>(DeleteSiteDocument, options);
      }
export type DeleteSiteMutationHookResult = ReturnType<typeof useDeleteSiteMutation>;
export type DeleteSiteMutationResult = Apollo.MutationResult<DeleteSiteMutation>;
export type DeleteSiteMutationOptions = Apollo.BaseMutationOptions<DeleteSiteMutation, DeleteSiteMutationVariables>;
export const DeleteSiteFlexMetricDocument = /*#__PURE__*/ gql`
    mutation DeleteSiteFlexMetric($input: SiteFlexMetricDeleteInput!) {
  deleteSiteFlexMetric(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteSiteFlexMetricMutationFn = Apollo.MutationFunction<DeleteSiteFlexMetricMutation, DeleteSiteFlexMetricMutationVariables>;

/**
 * __useDeleteSiteFlexMetricMutation__
 *
 * To run a mutation, you first call `useDeleteSiteFlexMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSiteFlexMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSiteFlexMetricMutation, { data, loading, error }] = useDeleteSiteFlexMetricMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSiteFlexMetricMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSiteFlexMetricMutation, DeleteSiteFlexMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSiteFlexMetricMutation, DeleteSiteFlexMetricMutationVariables>(DeleteSiteFlexMetricDocument, options);
      }
export type DeleteSiteFlexMetricMutationHookResult = ReturnType<typeof useDeleteSiteFlexMetricMutation>;
export type DeleteSiteFlexMetricMutationResult = Apollo.MutationResult<DeleteSiteFlexMetricMutation>;
export type DeleteSiteFlexMetricMutationOptions = Apollo.BaseMutationOptions<DeleteSiteFlexMetricMutation, DeleteSiteFlexMetricMutationVariables>;
export const DeleteSystemDocument = /*#__PURE__*/ gql`
    mutation DeleteSystem($input: DeleteSystemInput!) {
  deleteSystem(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteSystemMutationFn = Apollo.MutationFunction<DeleteSystemMutation, DeleteSystemMutationVariables>;

/**
 * __useDeleteSystemMutation__
 *
 * To run a mutation, you first call `useDeleteSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSystemMutation, { data, loading, error }] = useDeleteSystemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSystemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSystemMutation, DeleteSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSystemMutation, DeleteSystemMutationVariables>(DeleteSystemDocument, options);
      }
export type DeleteSystemMutationHookResult = ReturnType<typeof useDeleteSystemMutation>;
export type DeleteSystemMutationResult = Apollo.MutationResult<DeleteSystemMutation>;
export type DeleteSystemMutationOptions = Apollo.BaseMutationOptions<DeleteSystemMutation, DeleteSystemMutationVariables>;
export const DeleteSystemFavoriteDocument = /*#__PURE__*/ gql`
    mutation DeleteSystemFavorite($input: DeleteSystemFavoriteInput!) {
  deleteSystemFavorite(input: $input) {
    ...System
  }
}
    ${SystemFragmentDoc}`;
export type DeleteSystemFavoriteMutationFn = Apollo.MutationFunction<DeleteSystemFavoriteMutation, DeleteSystemFavoriteMutationVariables>;

/**
 * __useDeleteSystemFavoriteMutation__
 *
 * To run a mutation, you first call `useDeleteSystemFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSystemFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSystemFavoriteMutation, { data, loading, error }] = useDeleteSystemFavoriteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSystemFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSystemFavoriteMutation, DeleteSystemFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSystemFavoriteMutation, DeleteSystemFavoriteMutationVariables>(DeleteSystemFavoriteDocument, options);
      }
export type DeleteSystemFavoriteMutationHookResult = ReturnType<typeof useDeleteSystemFavoriteMutation>;
export type DeleteSystemFavoriteMutationResult = Apollo.MutationResult<DeleteSystemFavoriteMutation>;
export type DeleteSystemFavoriteMutationOptions = Apollo.BaseMutationOptions<DeleteSystemFavoriteMutation, DeleteSystemFavoriteMutationVariables>;
export const DeleteSystemGroupDocument = /*#__PURE__*/ gql`
    mutation DeleteSystemGroup($input: DeleteSystemGroupInput!) {
  deleteSystemGroup(input: $input) {
    ...SystemGroup
  }
}
    ${SystemGroupFragmentDoc}`;
export type DeleteSystemGroupMutationFn = Apollo.MutationFunction<DeleteSystemGroupMutation, DeleteSystemGroupMutationVariables>;

/**
 * __useDeleteSystemGroupMutation__
 *
 * To run a mutation, you first call `useDeleteSystemGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSystemGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSystemGroupMutation, { data, loading, error }] = useDeleteSystemGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSystemGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSystemGroupMutation, DeleteSystemGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSystemGroupMutation, DeleteSystemGroupMutationVariables>(DeleteSystemGroupDocument, options);
      }
export type DeleteSystemGroupMutationHookResult = ReturnType<typeof useDeleteSystemGroupMutation>;
export type DeleteSystemGroupMutationResult = Apollo.MutationResult<DeleteSystemGroupMutation>;
export type DeleteSystemGroupMutationOptions = Apollo.BaseMutationOptions<DeleteSystemGroupMutation, DeleteSystemGroupMutationVariables>;
export const DeleteTagDocument = /*#__PURE__*/ gql`
    mutation DeleteTag($input: DeleteTagInput!) {
  deleteTag(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const DeleteTagMappingDocument = /*#__PURE__*/ gql`
    mutation DeleteTagMapping($input: DeleteTagMappingInput!) {
  deleteTagMapping(input: $input) {
    ...TagMapping
  }
}
    ${TagMappingFragmentDoc}`;
export type DeleteTagMappingMutationFn = Apollo.MutationFunction<DeleteTagMappingMutation, DeleteTagMappingMutationVariables>;

/**
 * __useDeleteTagMappingMutation__
 *
 * To run a mutation, you first call `useDeleteTagMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMappingMutation, { data, loading, error }] = useDeleteTagMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTagMappingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMappingMutation, DeleteTagMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMappingMutation, DeleteTagMappingMutationVariables>(DeleteTagMappingDocument, options);
      }
export type DeleteTagMappingMutationHookResult = ReturnType<typeof useDeleteTagMappingMutation>;
export type DeleteTagMappingMutationResult = Apollo.MutationResult<DeleteTagMappingMutation>;
export type DeleteTagMappingMutationOptions = Apollo.BaseMutationOptions<DeleteTagMappingMutation, DeleteTagMappingMutationVariables>;
export const DeleteTrendDocument = /*#__PURE__*/ gql`
    mutation DeleteTrend($input: DeleteTrendInput!, $systemId: Int!) {
  deleteTrend(input: $input) {
    owner {
      ...UserNest
    }
    system {
      ...SystemNest
    }
    ...Trend
  }
}
    ${UserNestFragmentDoc}
${SystemNestFragmentDoc}
${TrendFragmentDoc}`;
export type DeleteTrendMutationFn = Apollo.MutationFunction<DeleteTrendMutation, DeleteTrendMutationVariables>;

/**
 * __useDeleteTrendMutation__
 *
 * To run a mutation, you first call `useDeleteTrendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrendMutation, { data, loading, error }] = useDeleteTrendMutation({
 *   variables: {
 *      input: // value for 'input'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useDeleteTrendMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrendMutation, DeleteTrendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrendMutation, DeleteTrendMutationVariables>(DeleteTrendDocument, options);
      }
export type DeleteTrendMutationHookResult = ReturnType<typeof useDeleteTrendMutation>;
export type DeleteTrendMutationResult = Apollo.MutationResult<DeleteTrendMutation>;
export type DeleteTrendMutationOptions = Apollo.BaseMutationOptions<DeleteTrendMutation, DeleteTrendMutationVariables>;
export const DeleteUnitDocument = /*#__PURE__*/ gql`
    mutation DeleteUnit($input: DeleteUnitInput!) {
  deleteUnit(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type DeleteUnitMutationFn = Apollo.MutationFunction<DeleteUnitMutation, DeleteUnitMutationVariables>;

/**
 * __useDeleteUnitMutation__
 *
 * To run a mutation, you first call `useDeleteUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnitMutation, { data, loading, error }] = useDeleteUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUnitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUnitMutation, DeleteUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUnitMutation, DeleteUnitMutationVariables>(DeleteUnitDocument, options);
      }
export type DeleteUnitMutationHookResult = ReturnType<typeof useDeleteUnitMutation>;
export type DeleteUnitMutationResult = Apollo.MutationResult<DeleteUnitMutation>;
export type DeleteUnitMutationOptions = Apollo.BaseMutationOptions<DeleteUnitMutation, DeleteUnitMutationVariables>;
export const DeleteUserFromSystemDocument = /*#__PURE__*/ gql`
    mutation DeleteUserFromSystem($input: DeleteUserFromSystemInput!) {
  deleteUserFromSystem(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type DeleteUserFromSystemMutationFn = Apollo.MutationFunction<DeleteUserFromSystemMutation, DeleteUserFromSystemMutationVariables>;

/**
 * __useDeleteUserFromSystemMutation__
 *
 * To run a mutation, you first call `useDeleteUserFromSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserFromSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserFromSystemMutation, { data, loading, error }] = useDeleteUserFromSystemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserFromSystemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserFromSystemMutation, DeleteUserFromSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserFromSystemMutation, DeleteUserFromSystemMutationVariables>(DeleteUserFromSystemDocument, options);
      }
export type DeleteUserFromSystemMutationHookResult = ReturnType<typeof useDeleteUserFromSystemMutation>;
export type DeleteUserFromSystemMutationResult = Apollo.MutationResult<DeleteUserFromSystemMutation>;
export type DeleteUserFromSystemMutationOptions = Apollo.BaseMutationOptions<DeleteUserFromSystemMutation, DeleteUserFromSystemMutationVariables>;
export const InitSsoUserDocument = /*#__PURE__*/ gql`
    mutation InitSsoUser {
  initSSOUser {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type InitSsoUserMutationFn = Apollo.MutationFunction<InitSsoUserMutation, InitSsoUserMutationVariables>;

/**
 * __useInitSsoUserMutation__
 *
 * To run a mutation, you first call `useInitSsoUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitSsoUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initSsoUserMutation, { data, loading, error }] = useInitSsoUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useInitSsoUserMutation(baseOptions?: Apollo.MutationHookOptions<InitSsoUserMutation, InitSsoUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitSsoUserMutation, InitSsoUserMutationVariables>(InitSsoUserDocument, options);
      }
export type InitSsoUserMutationHookResult = ReturnType<typeof useInitSsoUserMutation>;
export type InitSsoUserMutationResult = Apollo.MutationResult<InitSsoUserMutation>;
export type InitSsoUserMutationOptions = Apollo.BaseMutationOptions<InitSsoUserMutation, InitSsoUserMutationVariables>;
export const MigrateSiteDataToTimeSeriesDocument = /*#__PURE__*/ gql`
    mutation MigrateSiteDataToTimeSeries($input: MigrateSiteDataToTimeSeriesInput!) {
  migrateSiteDataToTimeSeries(input: $input) {
    id
    success
  }
}
    `;
export type MigrateSiteDataToTimeSeriesMutationFn = Apollo.MutationFunction<MigrateSiteDataToTimeSeriesMutation, MigrateSiteDataToTimeSeriesMutationVariables>;

/**
 * __useMigrateSiteDataToTimeSeriesMutation__
 *
 * To run a mutation, you first call `useMigrateSiteDataToTimeSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateSiteDataToTimeSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateSiteDataToTimeSeriesMutation, { data, loading, error }] = useMigrateSiteDataToTimeSeriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMigrateSiteDataToTimeSeriesMutation(baseOptions?: Apollo.MutationHookOptions<MigrateSiteDataToTimeSeriesMutation, MigrateSiteDataToTimeSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateSiteDataToTimeSeriesMutation, MigrateSiteDataToTimeSeriesMutationVariables>(MigrateSiteDataToTimeSeriesDocument, options);
      }
export type MigrateSiteDataToTimeSeriesMutationHookResult = ReturnType<typeof useMigrateSiteDataToTimeSeriesMutation>;
export type MigrateSiteDataToTimeSeriesMutationResult = Apollo.MutationResult<MigrateSiteDataToTimeSeriesMutation>;
export type MigrateSiteDataToTimeSeriesMutationOptions = Apollo.BaseMutationOptions<MigrateSiteDataToTimeSeriesMutation, MigrateSiteDataToTimeSeriesMutationVariables>;
export const RecalculateMetricDocument = /*#__PURE__*/ gql`
    mutation RecalculateMetric($input: RecalculateMetricInput!) {
  recalculateMetric(input: $input) {
    ...Metric
  }
}
    ${MetricFragmentDoc}`;
export type RecalculateMetricMutationFn = Apollo.MutationFunction<RecalculateMetricMutation, RecalculateMetricMutationVariables>;

/**
 * __useRecalculateMetricMutation__
 *
 * To run a mutation, you first call `useRecalculateMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalculateMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalculateMetricMutation, { data, loading, error }] = useRecalculateMetricMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecalculateMetricMutation(baseOptions?: Apollo.MutationHookOptions<RecalculateMetricMutation, RecalculateMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecalculateMetricMutation, RecalculateMetricMutationVariables>(RecalculateMetricDocument, options);
      }
export type RecalculateMetricMutationHookResult = ReturnType<typeof useRecalculateMetricMutation>;
export type RecalculateMetricMutationResult = Apollo.MutationResult<RecalculateMetricMutation>;
export type RecalculateMetricMutationOptions = Apollo.BaseMutationOptions<RecalculateMetricMutation, RecalculateMetricMutationVariables>;
export const RemoveUserFromSystemGroupDocument = /*#__PURE__*/ gql`
    mutation RemoveUserFromSystemGroup($input: RemoveUserFromSystemGroupInput!, $systemGroupId: Int!) {
  removeUserFromSystemGroup(input: $input) {
    ...SystemGroupUser
  }
}
    ${SystemGroupUserFragmentDoc}`;
export type RemoveUserFromSystemGroupMutationFn = Apollo.MutationFunction<RemoveUserFromSystemGroupMutation, RemoveUserFromSystemGroupMutationVariables>;

/**
 * __useRemoveUserFromSystemGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromSystemGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromSystemGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromSystemGroupMutation, { data, loading, error }] = useRemoveUserFromSystemGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      systemGroupId: // value for 'systemGroupId'
 *   },
 * });
 */
export function useRemoveUserFromSystemGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromSystemGroupMutation, RemoveUserFromSystemGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromSystemGroupMutation, RemoveUserFromSystemGroupMutationVariables>(RemoveUserFromSystemGroupDocument, options);
      }
export type RemoveUserFromSystemGroupMutationHookResult = ReturnType<typeof useRemoveUserFromSystemGroupMutation>;
export type RemoveUserFromSystemGroupMutationResult = Apollo.MutationResult<RemoveUserFromSystemGroupMutation>;
export type RemoveUserFromSystemGroupMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromSystemGroupMutation, RemoveUserFromSystemGroupMutationVariables>;
export const ReplayWaterlyConnectSubmissionDocument = /*#__PURE__*/ gql`
    mutation ReplayWaterlyConnectSubmission($submissionId: Int!) {
  replayWaterlyConnectSubmission(submissionId: $submissionId) {
    edgeDevice {
      ...EdgeDevice
    }
    ...EdgeDeviceSubmission
  }
}
    ${EdgeDeviceFragmentDoc}
${EdgeDeviceSubmissionFragmentDoc}`;
export type ReplayWaterlyConnectSubmissionMutationFn = Apollo.MutationFunction<ReplayWaterlyConnectSubmissionMutation, ReplayWaterlyConnectSubmissionMutationVariables>;

/**
 * __useReplayWaterlyConnectSubmissionMutation__
 *
 * To run a mutation, you first call `useReplayWaterlyConnectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplayWaterlyConnectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replayWaterlyConnectSubmissionMutation, { data, loading, error }] = useReplayWaterlyConnectSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useReplayWaterlyConnectSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<ReplayWaterlyConnectSubmissionMutation, ReplayWaterlyConnectSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplayWaterlyConnectSubmissionMutation, ReplayWaterlyConnectSubmissionMutationVariables>(ReplayWaterlyConnectSubmissionDocument, options);
      }
export type ReplayWaterlyConnectSubmissionMutationHookResult = ReturnType<typeof useReplayWaterlyConnectSubmissionMutation>;
export type ReplayWaterlyConnectSubmissionMutationResult = Apollo.MutationResult<ReplayWaterlyConnectSubmissionMutation>;
export type ReplayWaterlyConnectSubmissionMutationOptions = Apollo.BaseMutationOptions<ReplayWaterlyConnectSubmissionMutation, ReplayWaterlyConnectSubmissionMutationVariables>;
export const ArchiveReportingReportGroupDocument = /*#__PURE__*/ gql`
    mutation ArchiveReportingReportGroup($input: ArchiveReportingReportGroupInput!) {
  archiveReportingReportGroup(input: $input) {
    id
    name
    order
    systemId
  }
}
    `;
export type ArchiveReportingReportGroupMutationFn = Apollo.MutationFunction<ArchiveReportingReportGroupMutation, ArchiveReportingReportGroupMutationVariables>;

/**
 * __useArchiveReportingReportGroupMutation__
 *
 * To run a mutation, you first call `useArchiveReportingReportGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveReportingReportGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveReportingReportGroupMutation, { data, loading, error }] = useArchiveReportingReportGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveReportingReportGroupMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveReportingReportGroupMutation, ArchiveReportingReportGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveReportingReportGroupMutation, ArchiveReportingReportGroupMutationVariables>(ArchiveReportingReportGroupDocument, options);
      }
export type ArchiveReportingReportGroupMutationHookResult = ReturnType<typeof useArchiveReportingReportGroupMutation>;
export type ArchiveReportingReportGroupMutationResult = Apollo.MutationResult<ArchiveReportingReportGroupMutation>;
export type ArchiveReportingReportGroupMutationOptions = Apollo.BaseMutationOptions<ArchiveReportingReportGroupMutation, ArchiveReportingReportGroupMutationVariables>;
export const CreateReportingReportGroupDocument = /*#__PURE__*/ gql`
    mutation CreateReportingReportGroup($input: CreateReportingReportGroupInput!) {
  createReportingReportGroup(input: $input) {
    id
    name
    order
    systemId
  }
}
    `;
export type CreateReportingReportGroupMutationFn = Apollo.MutationFunction<CreateReportingReportGroupMutation, CreateReportingReportGroupMutationVariables>;

/**
 * __useCreateReportingReportGroupMutation__
 *
 * To run a mutation, you first call `useCreateReportingReportGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportingReportGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportingReportGroupMutation, { data, loading, error }] = useCreateReportingReportGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportingReportGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportingReportGroupMutation, CreateReportingReportGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportingReportGroupMutation, CreateReportingReportGroupMutationVariables>(CreateReportingReportGroupDocument, options);
      }
export type CreateReportingReportGroupMutationHookResult = ReturnType<typeof useCreateReportingReportGroupMutation>;
export type CreateReportingReportGroupMutationResult = Apollo.MutationResult<CreateReportingReportGroupMutation>;
export type CreateReportingReportGroupMutationOptions = Apollo.BaseMutationOptions<CreateReportingReportGroupMutation, CreateReportingReportGroupMutationVariables>;
export const DeleteReportDefinitionDocument = /*#__PURE__*/ gql`
    mutation DeleteReportDefinition($input: DeleteReportDefinitionByIdInput!) {
  deleteReportDefinitionById(input: $input)
}
    `;
export type DeleteReportDefinitionMutationFn = Apollo.MutationFunction<DeleteReportDefinitionMutation, DeleteReportDefinitionMutationVariables>;

/**
 * __useDeleteReportDefinitionMutation__
 *
 * To run a mutation, you first call `useDeleteReportDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportDefinitionMutation, { data, loading, error }] = useDeleteReportDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReportDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportDefinitionMutation, DeleteReportDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportDefinitionMutation, DeleteReportDefinitionMutationVariables>(DeleteReportDefinitionDocument, options);
      }
export type DeleteReportDefinitionMutationHookResult = ReturnType<typeof useDeleteReportDefinitionMutation>;
export type DeleteReportDefinitionMutationResult = Apollo.MutationResult<DeleteReportDefinitionMutation>;
export type DeleteReportDefinitionMutationOptions = Apollo.BaseMutationOptions<DeleteReportDefinitionMutation, DeleteReportDefinitionMutationVariables>;
export const UpdateMetricForReportDocument = /*#__PURE__*/ gql`
    mutation UpdateMetricForReport($input: UpdateMetricForReportInput!) {
  updateMetricForReport(input: $input) {
    ...ReportDefinition
  }
}
    ${ReportDefinitionFragmentDoc}`;
export type UpdateMetricForReportMutationFn = Apollo.MutationFunction<UpdateMetricForReportMutation, UpdateMetricForReportMutationVariables>;

/**
 * __useUpdateMetricForReportMutation__
 *
 * To run a mutation, you first call `useUpdateMetricForReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricForReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetricForReportMutation, { data, loading, error }] = useUpdateMetricForReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMetricForReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMetricForReportMutation, UpdateMetricForReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMetricForReportMutation, UpdateMetricForReportMutationVariables>(UpdateMetricForReportDocument, options);
      }
export type UpdateMetricForReportMutationHookResult = ReturnType<typeof useUpdateMetricForReportMutation>;
export type UpdateMetricForReportMutationResult = Apollo.MutationResult<UpdateMetricForReportMutation>;
export type UpdateMetricForReportMutationOptions = Apollo.BaseMutationOptions<UpdateMetricForReportMutation, UpdateMetricForReportMutationVariables>;
export const UpdateProcessForReportDocument = /*#__PURE__*/ gql`
    mutation UpdateProcessForReport($input: UpdateProcessForReportInput!, $reportDefinitionId: Int!) {
  updateProcessForReport(input: $input, reportDefinitionId: $reportDefinitionId) {
    ...ReportDefinition
    ...ReportDefinitionSite
  }
}
    ${ReportDefinitionFragmentDoc}
${ReportDefinitionSiteFragmentDoc}`;
export type UpdateProcessForReportMutationFn = Apollo.MutationFunction<UpdateProcessForReportMutation, UpdateProcessForReportMutationVariables>;

/**
 * __useUpdateProcessForReportMutation__
 *
 * To run a mutation, you first call `useUpdateProcessForReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcessForReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcessForReportMutation, { data, loading, error }] = useUpdateProcessForReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *      reportDefinitionId: // value for 'reportDefinitionId'
 *   },
 * });
 */
export function useUpdateProcessForReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcessForReportMutation, UpdateProcessForReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcessForReportMutation, UpdateProcessForReportMutationVariables>(UpdateProcessForReportDocument, options);
      }
export type UpdateProcessForReportMutationHookResult = ReturnType<typeof useUpdateProcessForReportMutation>;
export type UpdateProcessForReportMutationResult = Apollo.MutationResult<UpdateProcessForReportMutation>;
export type UpdateProcessForReportMutationOptions = Apollo.BaseMutationOptions<UpdateProcessForReportMutation, UpdateProcessForReportMutationVariables>;
export const UpdateReportDefinitionDocument = /*#__PURE__*/ gql`
    mutation UpdateReportDefinition($input: UpdateReportDefinitionInput!) {
  updateReportDefinition(input: $input) {
    ...ReportDefinition
  }
}
    ${ReportDefinitionFragmentDoc}`;
export type UpdateReportDefinitionMutationFn = Apollo.MutationFunction<UpdateReportDefinitionMutation, UpdateReportDefinitionMutationVariables>;

/**
 * __useUpdateReportDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateReportDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportDefinitionMutation, { data, loading, error }] = useUpdateReportDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportDefinitionMutation, UpdateReportDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportDefinitionMutation, UpdateReportDefinitionMutationVariables>(UpdateReportDefinitionDocument, options);
      }
export type UpdateReportDefinitionMutationHookResult = ReturnType<typeof useUpdateReportDefinitionMutation>;
export type UpdateReportDefinitionMutationResult = Apollo.MutationResult<UpdateReportDefinitionMutation>;
export type UpdateReportDefinitionMutationOptions = Apollo.BaseMutationOptions<UpdateReportDefinitionMutation, UpdateReportDefinitionMutationVariables>;
export const UpdateReportingReportDefinitionGroupsDocument = /*#__PURE__*/ gql`
    mutation UpdateReportingReportDefinitionGroups($input: UpdateReportingReportDefinitionGroupsInput!) {
  updateReportingReportDefinitionGroups(input: $input)
}
    `;
export type UpdateReportingReportDefinitionGroupsMutationFn = Apollo.MutationFunction<UpdateReportingReportDefinitionGroupsMutation, UpdateReportingReportDefinitionGroupsMutationVariables>;

/**
 * __useUpdateReportingReportDefinitionGroupsMutation__
 *
 * To run a mutation, you first call `useUpdateReportingReportDefinitionGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportingReportDefinitionGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportingReportDefinitionGroupsMutation, { data, loading, error }] = useUpdateReportingReportDefinitionGroupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportingReportDefinitionGroupsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportingReportDefinitionGroupsMutation, UpdateReportingReportDefinitionGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportingReportDefinitionGroupsMutation, UpdateReportingReportDefinitionGroupsMutationVariables>(UpdateReportingReportDefinitionGroupsDocument, options);
      }
export type UpdateReportingReportDefinitionGroupsMutationHookResult = ReturnType<typeof useUpdateReportingReportDefinitionGroupsMutation>;
export type UpdateReportingReportDefinitionGroupsMutationResult = Apollo.MutationResult<UpdateReportingReportDefinitionGroupsMutation>;
export type UpdateReportingReportDefinitionGroupsMutationOptions = Apollo.BaseMutationOptions<UpdateReportingReportDefinitionGroupsMutation, UpdateReportingReportDefinitionGroupsMutationVariables>;
export const UpdateReportingReportGroupDocument = /*#__PURE__*/ gql`
    mutation UpdateReportingReportGroup($input: UpdateReportingReportGroupInput!) {
  updateReportingReportGroup(input: $input) {
    id
    name
    order
    systemId
  }
}
    `;
export type UpdateReportingReportGroupMutationFn = Apollo.MutationFunction<UpdateReportingReportGroupMutation, UpdateReportingReportGroupMutationVariables>;

/**
 * __useUpdateReportingReportGroupMutation__
 *
 * To run a mutation, you first call `useUpdateReportingReportGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportingReportGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportingReportGroupMutation, { data, loading, error }] = useUpdateReportingReportGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportingReportGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportingReportGroupMutation, UpdateReportingReportGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportingReportGroupMutation, UpdateReportingReportGroupMutationVariables>(UpdateReportingReportGroupDocument, options);
      }
export type UpdateReportingReportGroupMutationHookResult = ReturnType<typeof useUpdateReportingReportGroupMutation>;
export type UpdateReportingReportGroupMutationResult = Apollo.MutationResult<UpdateReportingReportGroupMutation>;
export type UpdateReportingReportGroupMutationOptions = Apollo.BaseMutationOptions<UpdateReportingReportGroupMutation, UpdateReportingReportGroupMutationVariables>;
export const RequestEnterpriseReportShareLinkAccessDocument = /*#__PURE__*/ gql`
    mutation RequestEnterpriseReportShareLinkAccess($input: RequestEnterpriseReportShareLinkAccessInput!) {
  requestEnterpriseReportShareLinkAccess(input: $input) {
    emailRecipient
    submitted
  }
}
    `;
export type RequestEnterpriseReportShareLinkAccessMutationFn = Apollo.MutationFunction<RequestEnterpriseReportShareLinkAccessMutation, RequestEnterpriseReportShareLinkAccessMutationVariables>;

/**
 * __useRequestEnterpriseReportShareLinkAccessMutation__
 *
 * To run a mutation, you first call `useRequestEnterpriseReportShareLinkAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEnterpriseReportShareLinkAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEnterpriseReportShareLinkAccessMutation, { data, loading, error }] = useRequestEnterpriseReportShareLinkAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestEnterpriseReportShareLinkAccessMutation(baseOptions?: Apollo.MutationHookOptions<RequestEnterpriseReportShareLinkAccessMutation, RequestEnterpriseReportShareLinkAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestEnterpriseReportShareLinkAccessMutation, RequestEnterpriseReportShareLinkAccessMutationVariables>(RequestEnterpriseReportShareLinkAccessDocument, options);
      }
export type RequestEnterpriseReportShareLinkAccessMutationHookResult = ReturnType<typeof useRequestEnterpriseReportShareLinkAccessMutation>;
export type RequestEnterpriseReportShareLinkAccessMutationResult = Apollo.MutationResult<RequestEnterpriseReportShareLinkAccessMutation>;
export type RequestEnterpriseReportShareLinkAccessMutationOptions = Apollo.BaseMutationOptions<RequestEnterpriseReportShareLinkAccessMutation, RequestEnterpriseReportShareLinkAccessMutationVariables>;
export const RestoreComponentDocument = /*#__PURE__*/ gql`
    mutation RestoreComponent($input: RestoreComponentInput!) {
  restoreComponent(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type RestoreComponentMutationFn = Apollo.MutationFunction<RestoreComponentMutation, RestoreComponentMutationVariables>;

/**
 * __useRestoreComponentMutation__
 *
 * To run a mutation, you first call `useRestoreComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreComponentMutation, { data, loading, error }] = useRestoreComponentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreComponentMutation(baseOptions?: Apollo.MutationHookOptions<RestoreComponentMutation, RestoreComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreComponentMutation, RestoreComponentMutationVariables>(RestoreComponentDocument, options);
      }
export type RestoreComponentMutationHookResult = ReturnType<typeof useRestoreComponentMutation>;
export type RestoreComponentMutationResult = Apollo.MutationResult<RestoreComponentMutation>;
export type RestoreComponentMutationOptions = Apollo.BaseMutationOptions<RestoreComponentMutation, RestoreComponentMutationVariables>;
export const RestoreConstantDefinitionDocument = /*#__PURE__*/ gql`
    mutation RestoreConstantDefinition($input: RestoreConstantDefinitionInput!) {
  restoreConstantDefinition(input: $input) {
    ...ConstantDefinition
    usedByMetricCount
    values {
      ...ConstantValue
    }
  }
}
    ${ConstantDefinitionFragmentDoc}
${ConstantValueFragmentDoc}`;
export type RestoreConstantDefinitionMutationFn = Apollo.MutationFunction<RestoreConstantDefinitionMutation, RestoreConstantDefinitionMutationVariables>;

/**
 * __useRestoreConstantDefinitionMutation__
 *
 * To run a mutation, you first call `useRestoreConstantDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreConstantDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreConstantDefinitionMutation, { data, loading, error }] = useRestoreConstantDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreConstantDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<RestoreConstantDefinitionMutation, RestoreConstantDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreConstantDefinitionMutation, RestoreConstantDefinitionMutationVariables>(RestoreConstantDefinitionDocument, options);
      }
export type RestoreConstantDefinitionMutationHookResult = ReturnType<typeof useRestoreConstantDefinitionMutation>;
export type RestoreConstantDefinitionMutationResult = Apollo.MutationResult<RestoreConstantDefinitionMutation>;
export type RestoreConstantDefinitionMutationOptions = Apollo.BaseMutationOptions<RestoreConstantDefinitionMutation, RestoreConstantDefinitionMutationVariables>;
export const RestoreConstantValueDocument = /*#__PURE__*/ gql`
    mutation RestoreConstantValue($input: RestoreConstantValueInput!) {
  restoreConstantValue(input: $input) {
    ...ConstantValue
  }
}
    ${ConstantValueFragmentDoc}`;
export type RestoreConstantValueMutationFn = Apollo.MutationFunction<RestoreConstantValueMutation, RestoreConstantValueMutationVariables>;

/**
 * __useRestoreConstantValueMutation__
 *
 * To run a mutation, you first call `useRestoreConstantValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreConstantValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreConstantValueMutation, { data, loading, error }] = useRestoreConstantValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreConstantValueMutation(baseOptions?: Apollo.MutationHookOptions<RestoreConstantValueMutation, RestoreConstantValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreConstantValueMutation, RestoreConstantValueMutationVariables>(RestoreConstantValueDocument, options);
      }
export type RestoreConstantValueMutationHookResult = ReturnType<typeof useRestoreConstantValueMutation>;
export type RestoreConstantValueMutationResult = Apollo.MutationResult<RestoreConstantValueMutation>;
export type RestoreConstantValueMutationOptions = Apollo.BaseMutationOptions<RestoreConstantValueMutation, RestoreConstantValueMutationVariables>;
export const RestoreFolderDocument = /*#__PURE__*/ gql`
    mutation RestoreFolder($input: RestoreFolderInput!) {
  restoreFolder(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type RestoreFolderMutationFn = Apollo.MutationFunction<RestoreFolderMutation, RestoreFolderMutationVariables>;

/**
 * __useRestoreFolderMutation__
 *
 * To run a mutation, you first call `useRestoreFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreFolderMutation, { data, loading, error }] = useRestoreFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreFolderMutation(baseOptions?: Apollo.MutationHookOptions<RestoreFolderMutation, RestoreFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreFolderMutation, RestoreFolderMutationVariables>(RestoreFolderDocument, options);
      }
export type RestoreFolderMutationHookResult = ReturnType<typeof useRestoreFolderMutation>;
export type RestoreFolderMutationResult = Apollo.MutationResult<RestoreFolderMutation>;
export type RestoreFolderMutationOptions = Apollo.BaseMutationOptions<RestoreFolderMutation, RestoreFolderMutationVariables>;
export const RestoreMetricDocument = /*#__PURE__*/ gql`
    mutation RestoreMetric($input: RestoreMetricInput!) {
  restoreMetric(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type RestoreMetricMutationFn = Apollo.MutationFunction<RestoreMetricMutation, RestoreMetricMutationVariables>;

/**
 * __useRestoreMetricMutation__
 *
 * To run a mutation, you first call `useRestoreMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreMetricMutation, { data, loading, error }] = useRestoreMetricMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreMetricMutation(baseOptions?: Apollo.MutationHookOptions<RestoreMetricMutation, RestoreMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreMetricMutation, RestoreMetricMutationVariables>(RestoreMetricDocument, options);
      }
export type RestoreMetricMutationHookResult = ReturnType<typeof useRestoreMetricMutation>;
export type RestoreMetricMutationResult = Apollo.MutationResult<RestoreMetricMutation>;
export type RestoreMetricMutationOptions = Apollo.BaseMutationOptions<RestoreMetricMutation, RestoreMetricMutationVariables>;
export const RestoreProcessDocument = /*#__PURE__*/ gql`
    mutation RestoreProcess($input: RestoreProcessInput!) {
  restoreProcess(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type RestoreProcessMutationFn = Apollo.MutationFunction<RestoreProcessMutation, RestoreProcessMutationVariables>;

/**
 * __useRestoreProcessMutation__
 *
 * To run a mutation, you first call `useRestoreProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreProcessMutation, { data, loading, error }] = useRestoreProcessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreProcessMutation(baseOptions?: Apollo.MutationHookOptions<RestoreProcessMutation, RestoreProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreProcessMutation, RestoreProcessMutationVariables>(RestoreProcessDocument, options);
      }
export type RestoreProcessMutationHookResult = ReturnType<typeof useRestoreProcessMutation>;
export type RestoreProcessMutationResult = Apollo.MutationResult<RestoreProcessMutation>;
export type RestoreProcessMutationOptions = Apollo.BaseMutationOptions<RestoreProcessMutation, RestoreProcessMutationVariables>;
export const RestoreSiteDocument = /*#__PURE__*/ gql`
    mutation RestoreSite($input: RestoreSiteInput!) {
  restoreSite(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type RestoreSiteMutationFn = Apollo.MutationFunction<RestoreSiteMutation, RestoreSiteMutationVariables>;

/**
 * __useRestoreSiteMutation__
 *
 * To run a mutation, you first call `useRestoreSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreSiteMutation, { data, loading, error }] = useRestoreSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreSiteMutation(baseOptions?: Apollo.MutationHookOptions<RestoreSiteMutation, RestoreSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreSiteMutation, RestoreSiteMutationVariables>(RestoreSiteDocument, options);
      }
export type RestoreSiteMutationHookResult = ReturnType<typeof useRestoreSiteMutation>;
export type RestoreSiteMutationResult = Apollo.MutationResult<RestoreSiteMutation>;
export type RestoreSiteMutationOptions = Apollo.BaseMutationOptions<RestoreSiteMutation, RestoreSiteMutationVariables>;
export const RestoreSiteFlexMetricDocument = /*#__PURE__*/ gql`
    mutation RestoreSiteFlexMetric($input: SiteFlexMetricRestoreInput!) {
  restoreSiteFlexMetric(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type RestoreSiteFlexMetricMutationFn = Apollo.MutationFunction<RestoreSiteFlexMetricMutation, RestoreSiteFlexMetricMutationVariables>;

/**
 * __useRestoreSiteFlexMetricMutation__
 *
 * To run a mutation, you first call `useRestoreSiteFlexMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreSiteFlexMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreSiteFlexMetricMutation, { data, loading, error }] = useRestoreSiteFlexMetricMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreSiteFlexMetricMutation(baseOptions?: Apollo.MutationHookOptions<RestoreSiteFlexMetricMutation, RestoreSiteFlexMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreSiteFlexMetricMutation, RestoreSiteFlexMetricMutationVariables>(RestoreSiteFlexMetricDocument, options);
      }
export type RestoreSiteFlexMetricMutationHookResult = ReturnType<typeof useRestoreSiteFlexMetricMutation>;
export type RestoreSiteFlexMetricMutationResult = Apollo.MutationResult<RestoreSiteFlexMetricMutation>;
export type RestoreSiteFlexMetricMutationOptions = Apollo.BaseMutationOptions<RestoreSiteFlexMetricMutation, RestoreSiteFlexMetricMutationVariables>;
export const RestoreWeatherDataStationDocument = /*#__PURE__*/ gql`
    mutation RestoreWeatherDataStation($input: WeatherDataStationIdInput!) {
  restoreWeatherDataStation(input: $input) {
    ...WeatherDataStationFields
  }
}
    ${WeatherDataStationFieldsFragmentDoc}`;
export type RestoreWeatherDataStationMutationFn = Apollo.MutationFunction<RestoreWeatherDataStationMutation, RestoreWeatherDataStationMutationVariables>;

/**
 * __useRestoreWeatherDataStationMutation__
 *
 * To run a mutation, you first call `useRestoreWeatherDataStationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreWeatherDataStationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreWeatherDataStationMutation, { data, loading, error }] = useRestoreWeatherDataStationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreWeatherDataStationMutation(baseOptions?: Apollo.MutationHookOptions<RestoreWeatherDataStationMutation, RestoreWeatherDataStationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreWeatherDataStationMutation, RestoreWeatherDataStationMutationVariables>(RestoreWeatherDataStationDocument, options);
      }
export type RestoreWeatherDataStationMutationHookResult = ReturnType<typeof useRestoreWeatherDataStationMutation>;
export type RestoreWeatherDataStationMutationResult = Apollo.MutationResult<RestoreWeatherDataStationMutation>;
export type RestoreWeatherDataStationMutationOptions = Apollo.BaseMutationOptions<RestoreWeatherDataStationMutation, RestoreWeatherDataStationMutationVariables>;
export const RevokeApiTokenDocument = /*#__PURE__*/ gql`
    mutation RevokeApiToken($input: RevokeApiTokenInput!) {
  revokeApiToken(input: $input) {
    ...ApiToken
  }
}
    ${ApiTokenFragmentDoc}`;
export type RevokeApiTokenMutationFn = Apollo.MutationFunction<RevokeApiTokenMutation, RevokeApiTokenMutationVariables>;

/**
 * __useRevokeApiTokenMutation__
 *
 * To run a mutation, you first call `useRevokeApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApiTokenMutation, { data, loading, error }] = useRevokeApiTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeApiTokenMutation(baseOptions?: Apollo.MutationHookOptions<RevokeApiTokenMutation, RevokeApiTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeApiTokenMutation, RevokeApiTokenMutationVariables>(RevokeApiTokenDocument, options);
      }
export type RevokeApiTokenMutationHookResult = ReturnType<typeof useRevokeApiTokenMutation>;
export type RevokeApiTokenMutationResult = Apollo.MutationResult<RevokeApiTokenMutation>;
export type RevokeApiTokenMutationOptions = Apollo.BaseMutationOptions<RevokeApiTokenMutation, RevokeApiTokenMutationVariables>;
export const SendEmailVerificationDocument = /*#__PURE__*/ gql`
    mutation SendEmailVerification($userId: Int!) {
  sendEmailVerification(userId: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type SendEmailVerificationMutationFn = Apollo.MutationFunction<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>;

/**
 * __useSendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useSendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailVerificationMutation, { data, loading, error }] = useSendEmailVerificationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSendEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>(SendEmailVerificationDocument, options);
      }
export type SendEmailVerificationMutationHookResult = ReturnType<typeof useSendEmailVerificationMutation>;
export type SendEmailVerificationMutationResult = Apollo.MutationResult<SendEmailVerificationMutation>;
export type SendEmailVerificationMutationOptions = Apollo.BaseMutationOptions<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>;
export const SendManualReportEmailDocument = /*#__PURE__*/ gql`
    mutation SendManualReportEmail($input: SendManualReportEmailInput!) {
  sendManualReportEmail(input: $input) {
    emailEvent {
      comment
      createdAt
      id
      providerMessageId
      recipients {
        id
        normalizedEmail
        recipientKind
        recipientSource
        sourceDistributionListId
        sourceDistributionListName
        userId
      }
      reportSnapshotId
      senderEmail
      senderUserId
      sentAt
      shareLinkId
      status
      subject
      updatedAt
    }
    publicUrl
    shareLinkId
  }
}
    `;
export type SendManualReportEmailMutationFn = Apollo.MutationFunction<SendManualReportEmailMutation, SendManualReportEmailMutationVariables>;

/**
 * __useSendManualReportEmailMutation__
 *
 * To run a mutation, you first call `useSendManualReportEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendManualReportEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendManualReportEmailMutation, { data, loading, error }] = useSendManualReportEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendManualReportEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendManualReportEmailMutation, SendManualReportEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendManualReportEmailMutation, SendManualReportEmailMutationVariables>(SendManualReportEmailDocument, options);
      }
export type SendManualReportEmailMutationHookResult = ReturnType<typeof useSendManualReportEmailMutation>;
export type SendManualReportEmailMutationResult = Apollo.MutationResult<SendManualReportEmailMutation>;
export type SendManualReportEmailMutationOptions = Apollo.BaseMutationOptions<SendManualReportEmailMutation, SendManualReportEmailMutationVariables>;
export const SetRuntimeLoggerOverrideDocument = /*#__PURE__*/ gql`
    mutation SetRuntimeLoggerOverride($input: SetRuntimeLoggerOverrideInput!) {
  setRuntimeLoggerOverride(input: $input) {
    expiresAt
    level
    updatedAt
  }
}
    `;
export type SetRuntimeLoggerOverrideMutationFn = Apollo.MutationFunction<SetRuntimeLoggerOverrideMutation, SetRuntimeLoggerOverrideMutationVariables>;

/**
 * __useSetRuntimeLoggerOverrideMutation__
 *
 * To run a mutation, you first call `useSetRuntimeLoggerOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRuntimeLoggerOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRuntimeLoggerOverrideMutation, { data, loading, error }] = useSetRuntimeLoggerOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetRuntimeLoggerOverrideMutation(baseOptions?: Apollo.MutationHookOptions<SetRuntimeLoggerOverrideMutation, SetRuntimeLoggerOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRuntimeLoggerOverrideMutation, SetRuntimeLoggerOverrideMutationVariables>(SetRuntimeLoggerOverrideDocument, options);
      }
export type SetRuntimeLoggerOverrideMutationHookResult = ReturnType<typeof useSetRuntimeLoggerOverrideMutation>;
export type SetRuntimeLoggerOverrideMutationResult = Apollo.MutationResult<SetRuntimeLoggerOverrideMutation>;
export type SetRuntimeLoggerOverrideMutationOptions = Apollo.BaseMutationOptions<SetRuntimeLoggerOverrideMutation, SetRuntimeLoggerOverrideMutationVariables>;
export const SnoozeAllOrgRetentionRisksDocument = /*#__PURE__*/ gql`
    mutation SnoozeAllOrgRetentionRisks($input: SnoozeAllOrgRetentionRisksInput!) {
  snoozeAllOrgRetentionRisks(input: $input) {
    ...RetentionRiskNest
  }
}
    ${RetentionRiskNestFragmentDoc}`;
export type SnoozeAllOrgRetentionRisksMutationFn = Apollo.MutationFunction<SnoozeAllOrgRetentionRisksMutation, SnoozeAllOrgRetentionRisksMutationVariables>;

/**
 * __useSnoozeAllOrgRetentionRisksMutation__
 *
 * To run a mutation, you first call `useSnoozeAllOrgRetentionRisksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnoozeAllOrgRetentionRisksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snoozeAllOrgRetentionRisksMutation, { data, loading, error }] = useSnoozeAllOrgRetentionRisksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSnoozeAllOrgRetentionRisksMutation(baseOptions?: Apollo.MutationHookOptions<SnoozeAllOrgRetentionRisksMutation, SnoozeAllOrgRetentionRisksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnoozeAllOrgRetentionRisksMutation, SnoozeAllOrgRetentionRisksMutationVariables>(SnoozeAllOrgRetentionRisksDocument, options);
      }
export type SnoozeAllOrgRetentionRisksMutationHookResult = ReturnType<typeof useSnoozeAllOrgRetentionRisksMutation>;
export type SnoozeAllOrgRetentionRisksMutationResult = Apollo.MutationResult<SnoozeAllOrgRetentionRisksMutation>;
export type SnoozeAllOrgRetentionRisksMutationOptions = Apollo.BaseMutationOptions<SnoozeAllOrgRetentionRisksMutation, SnoozeAllOrgRetentionRisksMutationVariables>;
export const SnoozeRetentionRiskDocument = /*#__PURE__*/ gql`
    mutation SnoozeRetentionRisk($input: SnoozeRetentionRiskInput!) {
  snoozeRetentionRisk(input: $input) {
    ...RetentionRiskNest
  }
}
    ${RetentionRiskNestFragmentDoc}`;
export type SnoozeRetentionRiskMutationFn = Apollo.MutationFunction<SnoozeRetentionRiskMutation, SnoozeRetentionRiskMutationVariables>;

/**
 * __useSnoozeRetentionRiskMutation__
 *
 * To run a mutation, you first call `useSnoozeRetentionRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnoozeRetentionRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snoozeRetentionRiskMutation, { data, loading, error }] = useSnoozeRetentionRiskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSnoozeRetentionRiskMutation(baseOptions?: Apollo.MutationHookOptions<SnoozeRetentionRiskMutation, SnoozeRetentionRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnoozeRetentionRiskMutation, SnoozeRetentionRiskMutationVariables>(SnoozeRetentionRiskDocument, options);
      }
export type SnoozeRetentionRiskMutationHookResult = ReturnType<typeof useSnoozeRetentionRiskMutation>;
export type SnoozeRetentionRiskMutationResult = Apollo.MutationResult<SnoozeRetentionRiskMutation>;
export type SnoozeRetentionRiskMutationOptions = Apollo.BaseMutationOptions<SnoozeRetentionRiskMutation, SnoozeRetentionRiskMutationVariables>;
export const StartMirroringDocument = /*#__PURE__*/ gql`
    mutation StartMirroring($input: StartMirroringInput!) {
  startMirroring(input: $input) {
    ...SiteNest
  }
}
    ${SiteNestFragmentDoc}`;
export type StartMirroringMutationFn = Apollo.MutationFunction<StartMirroringMutation, StartMirroringMutationVariables>;

/**
 * __useStartMirroringMutation__
 *
 * To run a mutation, you first call `useStartMirroringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMirroringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMirroringMutation, { data, loading, error }] = useStartMirroringMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartMirroringMutation(baseOptions?: Apollo.MutationHookOptions<StartMirroringMutation, StartMirroringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMirroringMutation, StartMirroringMutationVariables>(StartMirroringDocument, options);
      }
export type StartMirroringMutationHookResult = ReturnType<typeof useStartMirroringMutation>;
export type StartMirroringMutationResult = Apollo.MutationResult<StartMirroringMutation>;
export type StartMirroringMutationOptions = Apollo.BaseMutationOptions<StartMirroringMutation, StartMirroringMutationVariables>;
export const StopMirroringDocument = /*#__PURE__*/ gql`
    mutation StopMirroring($input: StopMirroringInput!) {
  stopMirroring(input: $input) {
    ...SiteNest
  }
}
    ${SiteNestFragmentDoc}`;
export type StopMirroringMutationFn = Apollo.MutationFunction<StopMirroringMutation, StopMirroringMutationVariables>;

/**
 * __useStopMirroringMutation__
 *
 * To run a mutation, you first call `useStopMirroringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopMirroringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopMirroringMutation, { data, loading, error }] = useStopMirroringMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStopMirroringMutation(baseOptions?: Apollo.MutationHookOptions<StopMirroringMutation, StopMirroringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopMirroringMutation, StopMirroringMutationVariables>(StopMirroringDocument, options);
      }
export type StopMirroringMutationHookResult = ReturnType<typeof useStopMirroringMutation>;
export type StopMirroringMutationResult = Apollo.MutationResult<StopMirroringMutation>;
export type StopMirroringMutationOptions = Apollo.BaseMutationOptions<StopMirroringMutation, StopMirroringMutationVariables>;
export const SubmitConstantRecalculationDocument = /*#__PURE__*/ gql`
    mutation SubmitConstantRecalculation($input: ConstantRecalculationInput!) {
  submitConstantRecalculation(input: $input) {
    capped
    dayCount
    effectiveFromDate
    metrics {
      metricId
      metricName
      recalculationCount
      siteName
    }
    recalcFromDate
    toDate
    totalRecalculationCount
  }
}
    `;
export type SubmitConstantRecalculationMutationFn = Apollo.MutationFunction<SubmitConstantRecalculationMutation, SubmitConstantRecalculationMutationVariables>;

/**
 * __useSubmitConstantRecalculationMutation__
 *
 * To run a mutation, you first call `useSubmitConstantRecalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitConstantRecalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitConstantRecalculationMutation, { data, loading, error }] = useSubmitConstantRecalculationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitConstantRecalculationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitConstantRecalculationMutation, SubmitConstantRecalculationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitConstantRecalculationMutation, SubmitConstantRecalculationMutationVariables>(SubmitConstantRecalculationDocument, options);
      }
export type SubmitConstantRecalculationMutationHookResult = ReturnType<typeof useSubmitConstantRecalculationMutation>;
export type SubmitConstantRecalculationMutationResult = Apollo.MutationResult<SubmitConstantRecalculationMutation>;
export type SubmitConstantRecalculationMutationOptions = Apollo.BaseMutationOptions<SubmitConstantRecalculationMutation, SubmitConstantRecalculationMutationVariables>;
export const SubmitSiteRecalculationDocument = /*#__PURE__*/ gql`
    mutation SubmitSiteRecalculation($input: SubmitSiteRecalculationInput!) {
  submitSiteRecalculation(input: $input) {
    recalculationCount
  }
}
    `;
export type SubmitSiteRecalculationMutationFn = Apollo.MutationFunction<SubmitSiteRecalculationMutation, SubmitSiteRecalculationMutationVariables>;

/**
 * __useSubmitSiteRecalculationMutation__
 *
 * To run a mutation, you first call `useSubmitSiteRecalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSiteRecalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSiteRecalculationMutation, { data, loading, error }] = useSubmitSiteRecalculationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSiteRecalculationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSiteRecalculationMutation, SubmitSiteRecalculationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSiteRecalculationMutation, SubmitSiteRecalculationMutationVariables>(SubmitSiteRecalculationDocument, options);
      }
export type SubmitSiteRecalculationMutationHookResult = ReturnType<typeof useSubmitSiteRecalculationMutation>;
export type SubmitSiteRecalculationMutationResult = Apollo.MutationResult<SubmitSiteRecalculationMutation>;
export type SubmitSiteRecalculationMutationOptions = Apollo.BaseMutationOptions<SubmitSiteRecalculationMutation, SubmitSiteRecalculationMutationVariables>;
export const TransferComponentDocument = /*#__PURE__*/ gql`
    mutation TransferComponent($input: TransferComponentInput!) {
  transferComponent(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type TransferComponentMutationFn = Apollo.MutationFunction<TransferComponentMutation, TransferComponentMutationVariables>;

/**
 * __useTransferComponentMutation__
 *
 * To run a mutation, you first call `useTransferComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferComponentMutation, { data, loading, error }] = useTransferComponentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferComponentMutation(baseOptions?: Apollo.MutationHookOptions<TransferComponentMutation, TransferComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferComponentMutation, TransferComponentMutationVariables>(TransferComponentDocument, options);
      }
export type TransferComponentMutationHookResult = ReturnType<typeof useTransferComponentMutation>;
export type TransferComponentMutationResult = Apollo.MutationResult<TransferComponentMutation>;
export type TransferComponentMutationOptions = Apollo.BaseMutationOptions<TransferComponentMutation, TransferComponentMutationVariables>;
export const TransferMetricDocument = /*#__PURE__*/ gql`
    mutation TransferMetric($input: TransferMetricInput!) {
  transferMetric(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type TransferMetricMutationFn = Apollo.MutationFunction<TransferMetricMutation, TransferMetricMutationVariables>;

/**
 * __useTransferMetricMutation__
 *
 * To run a mutation, you first call `useTransferMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferMetricMutation, { data, loading, error }] = useTransferMetricMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferMetricMutation(baseOptions?: Apollo.MutationHookOptions<TransferMetricMutation, TransferMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferMetricMutation, TransferMetricMutationVariables>(TransferMetricDocument, options);
      }
export type TransferMetricMutationHookResult = ReturnType<typeof useTransferMetricMutation>;
export type TransferMetricMutationResult = Apollo.MutationResult<TransferMetricMutation>;
export type TransferMetricMutationOptions = Apollo.BaseMutationOptions<TransferMetricMutation, TransferMetricMutationVariables>;
export const TransferMetricToFolderDocument = /*#__PURE__*/ gql`
    mutation TransferMetricToFolder($input: TransferMetricToFolderInput!) {
  transferMetricToFolder(input: $input) {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type TransferMetricToFolderMutationFn = Apollo.MutationFunction<TransferMetricToFolderMutation, TransferMetricToFolderMutationVariables>;

/**
 * __useTransferMetricToFolderMutation__
 *
 * To run a mutation, you first call `useTransferMetricToFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferMetricToFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferMetricToFolderMutation, { data, loading, error }] = useTransferMetricToFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferMetricToFolderMutation(baseOptions?: Apollo.MutationHookOptions<TransferMetricToFolderMutation, TransferMetricToFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferMetricToFolderMutation, TransferMetricToFolderMutationVariables>(TransferMetricToFolderDocument, options);
      }
export type TransferMetricToFolderMutationHookResult = ReturnType<typeof useTransferMetricToFolderMutation>;
export type TransferMetricToFolderMutationResult = Apollo.MutationResult<TransferMetricToFolderMutation>;
export type TransferMetricToFolderMutationOptions = Apollo.BaseMutationOptions<TransferMetricToFolderMutation, TransferMetricToFolderMutationVariables>;
export const TransferSystemDocument = /*#__PURE__*/ gql`
    mutation TransferSystem($input: TransferSystemInput!) {
  transferSystem(input: $input) {
    ...SystemNest
  }
}
    ${SystemNestFragmentDoc}`;
export type TransferSystemMutationFn = Apollo.MutationFunction<TransferSystemMutation, TransferSystemMutationVariables>;

/**
 * __useTransferSystemMutation__
 *
 * To run a mutation, you first call `useTransferSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferSystemMutation, { data, loading, error }] = useTransferSystemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferSystemMutation(baseOptions?: Apollo.MutationHookOptions<TransferSystemMutation, TransferSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferSystemMutation, TransferSystemMutationVariables>(TransferSystemDocument, options);
      }
export type TransferSystemMutationHookResult = ReturnType<typeof useTransferSystemMutation>;
export type TransferSystemMutationResult = Apollo.MutationResult<TransferSystemMutation>;
export type TransferSystemMutationOptions = Apollo.BaseMutationOptions<TransferSystemMutation, TransferSystemMutationVariables>;
export const TriggerAnalyticsReportSnapshotDocument = /*#__PURE__*/ gql`
    mutation TriggerAnalyticsReportSnapshot($input: TriggerAnalyticsReportSnapshotInput!) {
  triggerAnalyticsReportSnapshot(input: $input) {
    report {
      ...ReportNest
    }
    reportDefinition {
      ...ReportDefinitionNest
    }
    ...ReportSnapshot
    system {
      ...SystemNest
    }
  }
}
    ${ReportNestFragmentDoc}
${ReportDefinitionNestFragmentDoc}
${ReportSnapshotFragmentDoc}
${SystemNestFragmentDoc}`;
export type TriggerAnalyticsReportSnapshotMutationFn = Apollo.MutationFunction<TriggerAnalyticsReportSnapshotMutation, TriggerAnalyticsReportSnapshotMutationVariables>;

/**
 * __useTriggerAnalyticsReportSnapshotMutation__
 *
 * To run a mutation, you first call `useTriggerAnalyticsReportSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerAnalyticsReportSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerAnalyticsReportSnapshotMutation, { data, loading, error }] = useTriggerAnalyticsReportSnapshotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerAnalyticsReportSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<TriggerAnalyticsReportSnapshotMutation, TriggerAnalyticsReportSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerAnalyticsReportSnapshotMutation, TriggerAnalyticsReportSnapshotMutationVariables>(TriggerAnalyticsReportSnapshotDocument, options);
      }
export type TriggerAnalyticsReportSnapshotMutationHookResult = ReturnType<typeof useTriggerAnalyticsReportSnapshotMutation>;
export type TriggerAnalyticsReportSnapshotMutationResult = Apollo.MutationResult<TriggerAnalyticsReportSnapshotMutation>;
export type TriggerAnalyticsReportSnapshotMutationOptions = Apollo.BaseMutationOptions<TriggerAnalyticsReportSnapshotMutation, TriggerAnalyticsReportSnapshotMutationVariables>;
export const TriggerMetricRangeEmailsDocument = /*#__PURE__*/ gql`
    mutation TriggerMetricRangeEmails {
  triggerMetricRangeEmails {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type TriggerMetricRangeEmailsMutationFn = Apollo.MutationFunction<TriggerMetricRangeEmailsMutation, TriggerMetricRangeEmailsMutationVariables>;

/**
 * __useTriggerMetricRangeEmailsMutation__
 *
 * To run a mutation, you first call `useTriggerMetricRangeEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerMetricRangeEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerMetricRangeEmailsMutation, { data, loading, error }] = useTriggerMetricRangeEmailsMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerMetricRangeEmailsMutation(baseOptions?: Apollo.MutationHookOptions<TriggerMetricRangeEmailsMutation, TriggerMetricRangeEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerMetricRangeEmailsMutation, TriggerMetricRangeEmailsMutationVariables>(TriggerMetricRangeEmailsDocument, options);
      }
export type TriggerMetricRangeEmailsMutationHookResult = ReturnType<typeof useTriggerMetricRangeEmailsMutation>;
export type TriggerMetricRangeEmailsMutationResult = Apollo.MutationResult<TriggerMetricRangeEmailsMutation>;
export type TriggerMetricRangeEmailsMutationOptions = Apollo.BaseMutationOptions<TriggerMetricRangeEmailsMutation, TriggerMetricRangeEmailsMutationVariables>;
export const UpdateActivityScheduleDocument = /*#__PURE__*/ gql`
    mutation UpdateActivitySchedule($input: ActivityScheduleUpdateInput!) {
  updateActivitySchedule(input: $input) {
    ...ActivitySchedule
  }
}
    ${ActivityScheduleFragmentDoc}`;
export type UpdateActivityScheduleMutationFn = Apollo.MutationFunction<UpdateActivityScheduleMutation, UpdateActivityScheduleMutationVariables>;

/**
 * __useUpdateActivityScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateActivityScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityScheduleMutation, { data, loading, error }] = useUpdateActivityScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActivityScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityScheduleMutation, UpdateActivityScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityScheduleMutation, UpdateActivityScheduleMutationVariables>(UpdateActivityScheduleDocument, options);
      }
export type UpdateActivityScheduleMutationHookResult = ReturnType<typeof useUpdateActivityScheduleMutation>;
export type UpdateActivityScheduleMutationResult = Apollo.MutationResult<UpdateActivityScheduleMutation>;
export type UpdateActivityScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateActivityScheduleMutation, UpdateActivityScheduleMutationVariables>;
export const UpdateAddressDocument = /*#__PURE__*/ gql`
    mutation UpdateAddress($input: UpdateAddressInput!) {
  updateAddress(input: $input) {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export type UpdateAddressMutationFn = Apollo.MutationFunction<UpdateAddressMutation, UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressMutation, UpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const UpdateAnalyteGroupDocument = /*#__PURE__*/ gql`
    mutation UpdateAnalyteGroup($input: AnalyteGroupUpdateInput!) {
  updateAnalyteGroup(input: $input) {
    ...AnalyteGroup
  }
}
    ${AnalyteGroupFragmentDoc}`;
export type UpdateAnalyteGroupMutationFn = Apollo.MutationFunction<UpdateAnalyteGroupMutation, UpdateAnalyteGroupMutationVariables>;

/**
 * __useUpdateAnalyteGroupMutation__
 *
 * To run a mutation, you first call `useUpdateAnalyteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnalyteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnalyteGroupMutation, { data, loading, error }] = useUpdateAnalyteGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnalyteGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnalyteGroupMutation, UpdateAnalyteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnalyteGroupMutation, UpdateAnalyteGroupMutationVariables>(UpdateAnalyteGroupDocument, options);
      }
export type UpdateAnalyteGroupMutationHookResult = ReturnType<typeof useUpdateAnalyteGroupMutation>;
export type UpdateAnalyteGroupMutationResult = Apollo.MutationResult<UpdateAnalyteGroupMutation>;
export type UpdateAnalyteGroupMutationOptions = Apollo.BaseMutationOptions<UpdateAnalyteGroupMutation, UpdateAnalyteGroupMutationVariables>;
export const UpdateCalcClusterDebugDocument = /*#__PURE__*/ gql`
    mutation UpdateCalcClusterDebug($input: CalcClusterDebugUpdateInput!) {
  updateCalcClusterDebug(input: $input) {
    ...CalcClusterDebug
  }
}
    ${CalcClusterDebugFragmentDoc}`;
export type UpdateCalcClusterDebugMutationFn = Apollo.MutationFunction<UpdateCalcClusterDebugMutation, UpdateCalcClusterDebugMutationVariables>;

/**
 * __useUpdateCalcClusterDebugMutation__
 *
 * To run a mutation, you first call `useUpdateCalcClusterDebugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalcClusterDebugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalcClusterDebugMutation, { data, loading, error }] = useUpdateCalcClusterDebugMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCalcClusterDebugMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalcClusterDebugMutation, UpdateCalcClusterDebugMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalcClusterDebugMutation, UpdateCalcClusterDebugMutationVariables>(UpdateCalcClusterDebugDocument, options);
      }
export type UpdateCalcClusterDebugMutationHookResult = ReturnType<typeof useUpdateCalcClusterDebugMutation>;
export type UpdateCalcClusterDebugMutationResult = Apollo.MutationResult<UpdateCalcClusterDebugMutation>;
export type UpdateCalcClusterDebugMutationOptions = Apollo.BaseMutationOptions<UpdateCalcClusterDebugMutation, UpdateCalcClusterDebugMutationVariables>;
export const UpdateColumnGroupDocument = /*#__PURE__*/ gql`
    mutation UpdateColumnGroup($input: UpdateColumnGroupInput!) {
  updateColumnGroup(input: $input) {
    ...ColumnGroup
  }
}
    ${ColumnGroupFragmentDoc}`;
export type UpdateColumnGroupMutationFn = Apollo.MutationFunction<UpdateColumnGroupMutation, UpdateColumnGroupMutationVariables>;

/**
 * __useUpdateColumnGroupMutation__
 *
 * To run a mutation, you first call `useUpdateColumnGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateColumnGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateColumnGroupMutation, { data, loading, error }] = useUpdateColumnGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateColumnGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateColumnGroupMutation, UpdateColumnGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateColumnGroupMutation, UpdateColumnGroupMutationVariables>(UpdateColumnGroupDocument, options);
      }
export type UpdateColumnGroupMutationHookResult = ReturnType<typeof useUpdateColumnGroupMutation>;
export type UpdateColumnGroupMutationResult = Apollo.MutationResult<UpdateColumnGroupMutation>;
export type UpdateColumnGroupMutationOptions = Apollo.BaseMutationOptions<UpdateColumnGroupMutation, UpdateColumnGroupMutationVariables>;
export const UpdateColumnGroupItemDocument = /*#__PURE__*/ gql`
    mutation UpdateColumnGroupItem($input: UpdateColumnGroupItemInput!) {
  updateColumnGroupItem(input: $input) {
    ...ColumnGroupItem
  }
}
    ${ColumnGroupItemFragmentDoc}`;
export type UpdateColumnGroupItemMutationFn = Apollo.MutationFunction<UpdateColumnGroupItemMutation, UpdateColumnGroupItemMutationVariables>;

/**
 * __useUpdateColumnGroupItemMutation__
 *
 * To run a mutation, you first call `useUpdateColumnGroupItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateColumnGroupItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateColumnGroupItemMutation, { data, loading, error }] = useUpdateColumnGroupItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateColumnGroupItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateColumnGroupItemMutation, UpdateColumnGroupItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateColumnGroupItemMutation, UpdateColumnGroupItemMutationVariables>(UpdateColumnGroupItemDocument, options);
      }
export type UpdateColumnGroupItemMutationHookResult = ReturnType<typeof useUpdateColumnGroupItemMutation>;
export type UpdateColumnGroupItemMutationResult = Apollo.MutationResult<UpdateColumnGroupItemMutation>;
export type UpdateColumnGroupItemMutationOptions = Apollo.BaseMutationOptions<UpdateColumnGroupItemMutation, UpdateColumnGroupItemMutationVariables>;
export const UpdateComponentsDocument = /*#__PURE__*/ gql`
    mutation UpdateComponents($input: UpdateComponentsInput!) {
  updateComponents(input: $input) {
    ...ComponentNest
  }
}
    ${ComponentNestFragmentDoc}`;
export type UpdateComponentsMutationFn = Apollo.MutationFunction<UpdateComponentsMutation, UpdateComponentsMutationVariables>;

/**
 * __useUpdateComponentsMutation__
 *
 * To run a mutation, you first call `useUpdateComponentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateComponentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateComponentsMutation, { data, loading, error }] = useUpdateComponentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateComponentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateComponentsMutation, UpdateComponentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateComponentsMutation, UpdateComponentsMutationVariables>(UpdateComponentsDocument, options);
      }
export type UpdateComponentsMutationHookResult = ReturnType<typeof useUpdateComponentsMutation>;
export type UpdateComponentsMutationResult = Apollo.MutationResult<UpdateComponentsMutation>;
export type UpdateComponentsMutationOptions = Apollo.BaseMutationOptions<UpdateComponentsMutation, UpdateComponentsMutationVariables>;
export const UpdateConstantDefinitionDocument = /*#__PURE__*/ gql`
    mutation UpdateConstantDefinition($input: UpdateConstantDefinitionInput!) {
  updateConstantDefinition(input: $input) {
    ...ConstantDefinition
  }
}
    ${ConstantDefinitionFragmentDoc}`;
export type UpdateConstantDefinitionMutationFn = Apollo.MutationFunction<UpdateConstantDefinitionMutation, UpdateConstantDefinitionMutationVariables>;

/**
 * __useUpdateConstantDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateConstantDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConstantDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConstantDefinitionMutation, { data, loading, error }] = useUpdateConstantDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConstantDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConstantDefinitionMutation, UpdateConstantDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConstantDefinitionMutation, UpdateConstantDefinitionMutationVariables>(UpdateConstantDefinitionDocument, options);
      }
export type UpdateConstantDefinitionMutationHookResult = ReturnType<typeof useUpdateConstantDefinitionMutation>;
export type UpdateConstantDefinitionMutationResult = Apollo.MutationResult<UpdateConstantDefinitionMutation>;
export type UpdateConstantDefinitionMutationOptions = Apollo.BaseMutationOptions<UpdateConstantDefinitionMutation, UpdateConstantDefinitionMutationVariables>;
export const UpdateDataEntryMetricsDocument = /*#__PURE__*/ gql`
    mutation UpdateDataEntryMetrics($input: MetricsUpdateInput!) {
  updateMetrics(input: $input) {
    intervals {
      ...IntervalNest
      siteFullName
    }
    metricKeyname {
      ...MetricKeyname
    }
    ...MetricNest
    metricRanges {
      maxTag {
        ...Tag
      }
      ...MetricRange
      minTag {
        ...Tag
      }
    }
    unit {
      ...UnitNest
    }
  }
}
    ${IntervalNestFragmentDoc}
${MetricKeynameFragmentDoc}
${MetricNestFragmentDoc}
${TagFragmentDoc}
${MetricRangeFragmentDoc}
${UnitNestFragmentDoc}`;
export type UpdateDataEntryMetricsMutationFn = Apollo.MutationFunction<UpdateDataEntryMetricsMutation, UpdateDataEntryMetricsMutationVariables>;

/**
 * __useUpdateDataEntryMetricsMutation__
 *
 * To run a mutation, you first call `useUpdateDataEntryMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataEntryMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataEntryMetricsMutation, { data, loading, error }] = useUpdateDataEntryMetricsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDataEntryMetricsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDataEntryMetricsMutation, UpdateDataEntryMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDataEntryMetricsMutation, UpdateDataEntryMetricsMutationVariables>(UpdateDataEntryMetricsDocument, options);
      }
export type UpdateDataEntryMetricsMutationHookResult = ReturnType<typeof useUpdateDataEntryMetricsMutation>;
export type UpdateDataEntryMetricsMutationResult = Apollo.MutationResult<UpdateDataEntryMetricsMutation>;
export type UpdateDataEntryMetricsMutationOptions = Apollo.BaseMutationOptions<UpdateDataEntryMetricsMutation, UpdateDataEntryMetricsMutationVariables>;
export const UpdateEdgeDeviceDocument = /*#__PURE__*/ gql`
    mutation UpdateEdgeDevice($input: UpdateEdgeDeviceNestInput!) {
  updateEdgeDevice(input: $input) {
    ...EdgeDeviceV2
  }
}
    ${EdgeDeviceV2FragmentDoc}`;
export type UpdateEdgeDeviceMutationFn = Apollo.MutationFunction<UpdateEdgeDeviceMutation, UpdateEdgeDeviceMutationVariables>;

/**
 * __useUpdateEdgeDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateEdgeDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEdgeDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEdgeDeviceMutation, { data, loading, error }] = useUpdateEdgeDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEdgeDeviceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEdgeDeviceMutation, UpdateEdgeDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEdgeDeviceMutation, UpdateEdgeDeviceMutationVariables>(UpdateEdgeDeviceDocument, options);
      }
export type UpdateEdgeDeviceMutationHookResult = ReturnType<typeof useUpdateEdgeDeviceMutation>;
export type UpdateEdgeDeviceMutationResult = Apollo.MutationResult<UpdateEdgeDeviceMutation>;
export type UpdateEdgeDeviceMutationOptions = Apollo.BaseMutationOptions<UpdateEdgeDeviceMutation, UpdateEdgeDeviceMutationVariables>;
export const UpdateEnterpriseReportShareLinkDocument = /*#__PURE__*/ gql`
    mutation UpdateEnterpriseReportShareLink($input: UpdateEnterpriseReportShareLinkInput!) {
  updateEnterpriseReportShareLink(input: $input) {
    publicUrl
    shareLink {
      createdAt
      createdByUserId
      deletedAt
      disabledAt
      disabledByUserId
      expiresAt
      id
      reportSnapshotId
      updatedAt
    }
  }
}
    `;
export type UpdateEnterpriseReportShareLinkMutationFn = Apollo.MutationFunction<UpdateEnterpriseReportShareLinkMutation, UpdateEnterpriseReportShareLinkMutationVariables>;

/**
 * __useUpdateEnterpriseReportShareLinkMutation__
 *
 * To run a mutation, you first call `useUpdateEnterpriseReportShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnterpriseReportShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnterpriseReportShareLinkMutation, { data, loading, error }] = useUpdateEnterpriseReportShareLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnterpriseReportShareLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnterpriseReportShareLinkMutation, UpdateEnterpriseReportShareLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEnterpriseReportShareLinkMutation, UpdateEnterpriseReportShareLinkMutationVariables>(UpdateEnterpriseReportShareLinkDocument, options);
      }
export type UpdateEnterpriseReportShareLinkMutationHookResult = ReturnType<typeof useUpdateEnterpriseReportShareLinkMutation>;
export type UpdateEnterpriseReportShareLinkMutationResult = Apollo.MutationResult<UpdateEnterpriseReportShareLinkMutation>;
export type UpdateEnterpriseReportShareLinkMutationOptions = Apollo.BaseMutationOptions<UpdateEnterpriseReportShareLinkMutation, UpdateEnterpriseReportShareLinkMutationVariables>;
export const UpdateFolderDocument = /*#__PURE__*/ gql`
    mutation UpdateFolder($input: UpdateFolderInput!) {
  updateFolder(input: $input) {
    ...BaseFolder
  }
}
    ${BaseFolderFragmentDoc}`;
export type UpdateFolderMutationFn = Apollo.MutationFunction<UpdateFolderMutation, UpdateFolderMutationVariables>;

/**
 * __useUpdateFolderMutation__
 *
 * To run a mutation, you first call `useUpdateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFolderMutation, { data, loading, error }] = useUpdateFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFolderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFolderMutation, UpdateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFolderMutation, UpdateFolderMutationVariables>(UpdateFolderDocument, options);
      }
export type UpdateFolderMutationHookResult = ReturnType<typeof useUpdateFolderMutation>;
export type UpdateFolderMutationResult = Apollo.MutationResult<UpdateFolderMutation>;
export type UpdateFolderMutationOptions = Apollo.BaseMutationOptions<UpdateFolderMutation, UpdateFolderMutationVariables>;
export const UpdateFoldersDocument = /*#__PURE__*/ gql`
    mutation UpdateFolders($input: UpdateFoldersInput!) {
  updateFolders(input: $input) {
    ...BaseFolder
  }
}
    ${BaseFolderFragmentDoc}`;
export type UpdateFoldersMutationFn = Apollo.MutationFunction<UpdateFoldersMutation, UpdateFoldersMutationVariables>;

/**
 * __useUpdateFoldersMutation__
 *
 * To run a mutation, you first call `useUpdateFoldersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFoldersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFoldersMutation, { data, loading, error }] = useUpdateFoldersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFoldersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFoldersMutation, UpdateFoldersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFoldersMutation, UpdateFoldersMutationVariables>(UpdateFoldersDocument, options);
      }
export type UpdateFoldersMutationHookResult = ReturnType<typeof useUpdateFoldersMutation>;
export type UpdateFoldersMutationResult = Apollo.MutationResult<UpdateFoldersMutation>;
export type UpdateFoldersMutationOptions = Apollo.BaseMutationOptions<UpdateFoldersMutation, UpdateFoldersMutationVariables>;
export const UpdateLicenseDocument = /*#__PURE__*/ gql`
    mutation UpdateLicense($input: UpdateLicenseInput!) {
  updateLicense(input: $input) {
    ...License
  }
}
    ${LicenseFragmentDoc}`;
export type UpdateLicenseMutationFn = Apollo.MutationFunction<UpdateLicenseMutation, UpdateLicenseMutationVariables>;

/**
 * __useUpdateLicenseMutation__
 *
 * To run a mutation, you first call `useUpdateLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLicenseMutation, { data, loading, error }] = useUpdateLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLicenseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLicenseMutation, UpdateLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLicenseMutation, UpdateLicenseMutationVariables>(UpdateLicenseDocument, options);
      }
export type UpdateLicenseMutationHookResult = ReturnType<typeof useUpdateLicenseMutation>;
export type UpdateLicenseMutationResult = Apollo.MutationResult<UpdateLicenseMutation>;
export type UpdateLicenseMutationOptions = Apollo.BaseMutationOptions<UpdateLicenseMutation, UpdateLicenseMutationVariables>;
export const UpdateLogBookEntryDocument = /*#__PURE__*/ gql`
    mutation UpdateLogBookEntry($input: UpdateLogBookEntryInput!) {
  updateLogBookEntry(input: $input) {
    ...LogBookEntry
  }
}
    ${LogBookEntryFragmentDoc}`;
export type UpdateLogBookEntryMutationFn = Apollo.MutationFunction<UpdateLogBookEntryMutation, UpdateLogBookEntryMutationVariables>;

/**
 * __useUpdateLogBookEntryMutation__
 *
 * To run a mutation, you first call `useUpdateLogBookEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLogBookEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLogBookEntryMutation, { data, loading, error }] = useUpdateLogBookEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLogBookEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLogBookEntryMutation, UpdateLogBookEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLogBookEntryMutation, UpdateLogBookEntryMutationVariables>(UpdateLogBookEntryDocument, options);
      }
export type UpdateLogBookEntryMutationHookResult = ReturnType<typeof useUpdateLogBookEntryMutation>;
export type UpdateLogBookEntryMutationResult = Apollo.MutationResult<UpdateLogBookEntryMutation>;
export type UpdateLogBookEntryMutationOptions = Apollo.BaseMutationOptions<UpdateLogBookEntryMutation, UpdateLogBookEntryMutationVariables>;
export const UpdateLogBookEntryDashboardViewDocument = /*#__PURE__*/ gql`
    mutation UpdateLogBookEntryDashboardView($input: UpdateLogBookEntryDashboardViewInput!) {
  updateLogBookEntryDashboardView(input: $input) {
    ...LogBookEntryDashboardView
  }
}
    ${LogBookEntryDashboardViewFragmentDoc}`;
export type UpdateLogBookEntryDashboardViewMutationFn = Apollo.MutationFunction<UpdateLogBookEntryDashboardViewMutation, UpdateLogBookEntryDashboardViewMutationVariables>;

/**
 * __useUpdateLogBookEntryDashboardViewMutation__
 *
 * To run a mutation, you first call `useUpdateLogBookEntryDashboardViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLogBookEntryDashboardViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLogBookEntryDashboardViewMutation, { data, loading, error }] = useUpdateLogBookEntryDashboardViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLogBookEntryDashboardViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLogBookEntryDashboardViewMutation, UpdateLogBookEntryDashboardViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLogBookEntryDashboardViewMutation, UpdateLogBookEntryDashboardViewMutationVariables>(UpdateLogBookEntryDashboardViewDocument, options);
      }
export type UpdateLogBookEntryDashboardViewMutationHookResult = ReturnType<typeof useUpdateLogBookEntryDashboardViewMutation>;
export type UpdateLogBookEntryDashboardViewMutationResult = Apollo.MutationResult<UpdateLogBookEntryDashboardViewMutation>;
export type UpdateLogBookEntryDashboardViewMutationOptions = Apollo.BaseMutationOptions<UpdateLogBookEntryDashboardViewMutation, UpdateLogBookEntryDashboardViewMutationVariables>;
export const UpdateMetricDocument = /*#__PURE__*/ gql`
    mutation UpdateMetric($input: MetricUpdateInput!) {
  updateMetric(input: $input) {
    ...MetricNest
  }
}
    ${MetricNestFragmentDoc}`;
export type UpdateMetricMutationFn = Apollo.MutationFunction<UpdateMetricMutation, UpdateMetricMutationVariables>;

/**
 * __useUpdateMetricMutation__
 *
 * To run a mutation, you first call `useUpdateMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetricMutation, { data, loading, error }] = useUpdateMetricMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMetricMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMetricMutation, UpdateMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMetricMutation, UpdateMetricMutationVariables>(UpdateMetricDocument, options);
      }
export type UpdateMetricMutationHookResult = ReturnType<typeof useUpdateMetricMutation>;
export type UpdateMetricMutationResult = Apollo.MutationResult<UpdateMetricMutation>;
export type UpdateMetricMutationOptions = Apollo.BaseMutationOptions<UpdateMetricMutation, UpdateMetricMutationVariables>;
export const UpdateMetricKeynameDocument = /*#__PURE__*/ gql`
    mutation UpdateMetricKeyname($input: MetricKeynameUpdateInput!) {
  updateMetricKeyname(input: $input) {
    ...MetricKeyname
  }
}
    ${MetricKeynameFragmentDoc}`;
export type UpdateMetricKeynameMutationFn = Apollo.MutationFunction<UpdateMetricKeynameMutation, UpdateMetricKeynameMutationVariables>;

/**
 * __useUpdateMetricKeynameMutation__
 *
 * To run a mutation, you first call `useUpdateMetricKeynameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricKeynameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetricKeynameMutation, { data, loading, error }] = useUpdateMetricKeynameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMetricKeynameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMetricKeynameMutation, UpdateMetricKeynameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMetricKeynameMutation, UpdateMetricKeynameMutationVariables>(UpdateMetricKeynameDocument, options);
      }
export type UpdateMetricKeynameMutationHookResult = ReturnType<typeof useUpdateMetricKeynameMutation>;
export type UpdateMetricKeynameMutationResult = Apollo.MutationResult<UpdateMetricKeynameMutation>;
export type UpdateMetricKeynameMutationOptions = Apollo.BaseMutationOptions<UpdateMetricKeynameMutation, UpdateMetricKeynameMutationVariables>;
export const UpdateMetricsDocument = /*#__PURE__*/ gql`
    mutation UpdateMetrics($input: MetricsUpdateInput!) {
  updateMetrics(input: $input) {
    ...MetricNest
  }
}
    ${MetricNestFragmentDoc}`;
export type UpdateMetricsMutationFn = Apollo.MutationFunction<UpdateMetricsMutation, UpdateMetricsMutationVariables>;

/**
 * __useUpdateMetricsMutation__
 *
 * To run a mutation, you first call `useUpdateMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetricsMutation, { data, loading, error }] = useUpdateMetricsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMetricsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMetricsMutation, UpdateMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMetricsMutation, UpdateMetricsMutationVariables>(UpdateMetricsDocument, options);
      }
export type UpdateMetricsMutationHookResult = ReturnType<typeof useUpdateMetricsMutation>;
export type UpdateMetricsMutationResult = Apollo.MutationResult<UpdateMetricsMutation>;
export type UpdateMetricsMutationOptions = Apollo.BaseMutationOptions<UpdateMetricsMutation, UpdateMetricsMutationVariables>;
export const UpdateNotificationDocument = /*#__PURE__*/ gql`
    mutation UpdateNotification($input: UpdateNotificationInput!) {
  updateNotification(input: $input) {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;
export type UpdateNotificationMutationFn = Apollo.MutationFunction<UpdateNotificationMutation, UpdateNotificationMutationVariables>;

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationMutation, UpdateNotificationMutationVariables>(UpdateNotificationDocument, options);
      }
export type UpdateNotificationMutationHookResult = ReturnType<typeof useUpdateNotificationMutation>;
export type UpdateNotificationMutationResult = Apollo.MutationResult<UpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const UpdateOrganizationDocument = /*#__PURE__*/ gql`
    mutation UpdateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    ...OrganizationNest
  }
}
    ${OrganizationNestFragmentDoc}`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateOrganizationIntegrationDocument = /*#__PURE__*/ gql`
    mutation UpdateOrganizationIntegration($input: UpdateOrganizationIntegrationInput!) {
  updateOrganizationIntegration(input: $input) {
    id
  }
}
    `;
export type UpdateOrganizationIntegrationMutationFn = Apollo.MutationFunction<UpdateOrganizationIntegrationMutation, UpdateOrganizationIntegrationMutationVariables>;

/**
 * __useUpdateOrganizationIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationIntegrationMutation, { data, loading, error }] = useUpdateOrganizationIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationIntegrationMutation, UpdateOrganizationIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationIntegrationMutation, UpdateOrganizationIntegrationMutationVariables>(UpdateOrganizationIntegrationDocument, options);
      }
export type UpdateOrganizationIntegrationMutationHookResult = ReturnType<typeof useUpdateOrganizationIntegrationMutation>;
export type UpdateOrganizationIntegrationMutationResult = Apollo.MutationResult<UpdateOrganizationIntegrationMutation>;
export type UpdateOrganizationIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationIntegrationMutation, UpdateOrganizationIntegrationMutationVariables>;
export const UpdatePhoneNumberDocument = /*#__PURE__*/ gql`
    mutation UpdatePhoneNumber($input: UpdatePhoneNumberInput!) {
  updatePhoneNumber(input: $input) {
    ...PhoneNumber
  }
}
    ${PhoneNumberFragmentDoc}`;
export type UpdatePhoneNumberMutationFn = Apollo.MutationFunction<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>;

/**
 * __useUpdatePhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneNumberMutation, { data, loading, error }] = useUpdatePhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>(UpdatePhoneNumberDocument, options);
      }
export type UpdatePhoneNumberMutationHookResult = ReturnType<typeof useUpdatePhoneNumberMutation>;
export type UpdatePhoneNumberMutationResult = Apollo.MutationResult<UpdatePhoneNumberMutation>;
export type UpdatePhoneNumberMutationOptions = Apollo.BaseMutationOptions<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>;
export const UpdatePhraseDocument = /*#__PURE__*/ gql`
    mutation UpdatePhrase($input: UpdatePhraseInput!) {
  updatePhrase(input: $input) {
    ...Phrase
  }
}
    ${PhraseFragmentDoc}`;
export type UpdatePhraseMutationFn = Apollo.MutationFunction<UpdatePhraseMutation, UpdatePhraseMutationVariables>;

/**
 * __useUpdatePhraseMutation__
 *
 * To run a mutation, you first call `useUpdatePhraseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhraseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhraseMutation, { data, loading, error }] = useUpdatePhraseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePhraseMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhraseMutation, UpdatePhraseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhraseMutation, UpdatePhraseMutationVariables>(UpdatePhraseDocument, options);
      }
export type UpdatePhraseMutationHookResult = ReturnType<typeof useUpdatePhraseMutation>;
export type UpdatePhraseMutationResult = Apollo.MutationResult<UpdatePhraseMutation>;
export type UpdatePhraseMutationOptions = Apollo.BaseMutationOptions<UpdatePhraseMutation, UpdatePhraseMutationVariables>;
export const UpdateProcessesDocument = /*#__PURE__*/ gql`
    mutation UpdateProcesses($input: UpdateProcessesInput!) {
  updateProcesses(input: $input) {
    ...ProcessNest
  }
}
    ${ProcessNestFragmentDoc}`;
export type UpdateProcessesMutationFn = Apollo.MutationFunction<UpdateProcessesMutation, UpdateProcessesMutationVariables>;

/**
 * __useUpdateProcessesMutation__
 *
 * To run a mutation, you first call `useUpdateProcessesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcessesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcessesMutation, { data, loading, error }] = useUpdateProcessesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProcessesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcessesMutation, UpdateProcessesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcessesMutation, UpdateProcessesMutationVariables>(UpdateProcessesDocument, options);
      }
export type UpdateProcessesMutationHookResult = ReturnType<typeof useUpdateProcessesMutation>;
export type UpdateProcessesMutationResult = Apollo.MutationResult<UpdateProcessesMutation>;
export type UpdateProcessesMutationOptions = Apollo.BaseMutationOptions<UpdateProcessesMutation, UpdateProcessesMutationVariables>;
export const UpdateReportDistributionListDocument = /*#__PURE__*/ gql`
    mutation UpdateReportDistributionList($input: UpdateReportDistributionListInput!) {
  updateReportDistributionList(input: $input) {
    ...ReportDistributionList
  }
}
    ${ReportDistributionListFragmentDoc}`;
export type UpdateReportDistributionListMutationFn = Apollo.MutationFunction<UpdateReportDistributionListMutation, UpdateReportDistributionListMutationVariables>;

/**
 * __useUpdateReportDistributionListMutation__
 *
 * To run a mutation, you first call `useUpdateReportDistributionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportDistributionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportDistributionListMutation, { data, loading, error }] = useUpdateReportDistributionListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportDistributionListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportDistributionListMutation, UpdateReportDistributionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportDistributionListMutation, UpdateReportDistributionListMutationVariables>(UpdateReportDistributionListDocument, options);
      }
export type UpdateReportDistributionListMutationHookResult = ReturnType<typeof useUpdateReportDistributionListMutation>;
export type UpdateReportDistributionListMutationResult = Apollo.MutationResult<UpdateReportDistributionListMutation>;
export type UpdateReportDistributionListMutationOptions = Apollo.BaseMutationOptions<UpdateReportDistributionListMutation, UpdateReportDistributionListMutationVariables>;
export const UpdateReportNodesDocument = /*#__PURE__*/ gql`
    mutation UpdateReportNodes($input: UpdateReportNodesInput!) {
  updateReportNodes(input: $input) {
    ...ReportNode
  }
}
    ${ReportNodeFragmentDoc}`;
export type UpdateReportNodesMutationFn = Apollo.MutationFunction<UpdateReportNodesMutation, UpdateReportNodesMutationVariables>;

/**
 * __useUpdateReportNodesMutation__
 *
 * To run a mutation, you first call `useUpdateReportNodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportNodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportNodesMutation, { data, loading, error }] = useUpdateReportNodesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportNodesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportNodesMutation, UpdateReportNodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportNodesMutation, UpdateReportNodesMutationVariables>(UpdateReportNodesDocument, options);
      }
export type UpdateReportNodesMutationHookResult = ReturnType<typeof useUpdateReportNodesMutation>;
export type UpdateReportNodesMutationResult = Apollo.MutationResult<UpdateReportNodesMutation>;
export type UpdateReportNodesMutationOptions = Apollo.BaseMutationOptions<UpdateReportNodesMutation, UpdateReportNodesMutationVariables>;
export const UpdateSampleCollectionDocument = /*#__PURE__*/ gql`
    mutation UpdateSampleCollection($input: SampleCollectionUpdateInput!) {
  updateSampleCollection(input: $input) {
    ...SampleCollection
  }
}
    ${SampleCollectionFragmentDoc}`;
export type UpdateSampleCollectionMutationFn = Apollo.MutationFunction<UpdateSampleCollectionMutation, UpdateSampleCollectionMutationVariables>;

/**
 * __useUpdateSampleCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateSampleCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSampleCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSampleCollectionMutation, { data, loading, error }] = useUpdateSampleCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSampleCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSampleCollectionMutation, UpdateSampleCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSampleCollectionMutation, UpdateSampleCollectionMutationVariables>(UpdateSampleCollectionDocument, options);
      }
export type UpdateSampleCollectionMutationHookResult = ReturnType<typeof useUpdateSampleCollectionMutation>;
export type UpdateSampleCollectionMutationResult = Apollo.MutationResult<UpdateSampleCollectionMutation>;
export type UpdateSampleCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateSampleCollectionMutation, UpdateSampleCollectionMutationVariables>;
export const UpdateSampleScheduleDocument = /*#__PURE__*/ gql`
    mutation UpdateSampleSchedule($input: UpdateSampleScheduleInput!) {
  updateSampleSchedule(input: $input) {
    ...SampleSchedule
  }
}
    ${SampleScheduleFragmentDoc}`;
export type UpdateSampleScheduleMutationFn = Apollo.MutationFunction<UpdateSampleScheduleMutation, UpdateSampleScheduleMutationVariables>;

/**
 * __useUpdateSampleScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateSampleScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSampleScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSampleScheduleMutation, { data, loading, error }] = useUpdateSampleScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSampleScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSampleScheduleMutation, UpdateSampleScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSampleScheduleMutation, UpdateSampleScheduleMutationVariables>(UpdateSampleScheduleDocument, options);
      }
export type UpdateSampleScheduleMutationHookResult = ReturnType<typeof useUpdateSampleScheduleMutation>;
export type UpdateSampleScheduleMutationResult = Apollo.MutationResult<UpdateSampleScheduleMutation>;
export type UpdateSampleScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateSampleScheduleMutation, UpdateSampleScheduleMutationVariables>;
export const UpdateSampleSiteDocument = /*#__PURE__*/ gql`
    mutation UpdateSampleSite($input: SampleSiteUpdateInput!) {
  updateSampleSite(input: $input) {
    ...SampleSite
  }
}
    ${SampleSiteFragmentDoc}`;
export type UpdateSampleSiteMutationFn = Apollo.MutationFunction<UpdateSampleSiteMutation, UpdateSampleSiteMutationVariables>;

/**
 * __useUpdateSampleSiteMutation__
 *
 * To run a mutation, you first call `useUpdateSampleSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSampleSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSampleSiteMutation, { data, loading, error }] = useUpdateSampleSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSampleSiteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSampleSiteMutation, UpdateSampleSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSampleSiteMutation, UpdateSampleSiteMutationVariables>(UpdateSampleSiteDocument, options);
      }
export type UpdateSampleSiteMutationHookResult = ReturnType<typeof useUpdateSampleSiteMutation>;
export type UpdateSampleSiteMutationResult = Apollo.MutationResult<UpdateSampleSiteMutation>;
export type UpdateSampleSiteMutationOptions = Apollo.BaseMutationOptions<UpdateSampleSiteMutation, UpdateSampleSiteMutationVariables>;
export const UpdateScheduledItemDocument = /*#__PURE__*/ gql`
    mutation UpdateScheduledItem($input: UpdateScheduledItemInput!) {
  updateScheduledItem(input: $input) {
    ...ScheduledItem
  }
}
    ${ScheduledItemFragmentDoc}`;
export type UpdateScheduledItemMutationFn = Apollo.MutationFunction<UpdateScheduledItemMutation, UpdateScheduledItemMutationVariables>;

/**
 * __useUpdateScheduledItemMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledItemMutation, { data, loading, error }] = useUpdateScheduledItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduledItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduledItemMutation, UpdateScheduledItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduledItemMutation, UpdateScheduledItemMutationVariables>(UpdateScheduledItemDocument, options);
      }
export type UpdateScheduledItemMutationHookResult = ReturnType<typeof useUpdateScheduledItemMutation>;
export type UpdateScheduledItemMutationResult = Apollo.MutationResult<UpdateScheduledItemMutation>;
export type UpdateScheduledItemMutationOptions = Apollo.BaseMutationOptions<UpdateScheduledItemMutation, UpdateScheduledItemMutationVariables>;
export const UpdateScheduledItemCommentDocument = /*#__PURE__*/ gql`
    mutation UpdateScheduledItemComment($input: UpdateScheduledItemCommentInput!) {
  updateScheduledItemComment(input: $input) {
    ...ScheduledItemComment
  }
}
    ${ScheduledItemCommentFragmentDoc}`;
export type UpdateScheduledItemCommentMutationFn = Apollo.MutationFunction<UpdateScheduledItemCommentMutation, UpdateScheduledItemCommentMutationVariables>;

/**
 * __useUpdateScheduledItemCommentMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledItemCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledItemCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledItemCommentMutation, { data, loading, error }] = useUpdateScheduledItemCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduledItemCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduledItemCommentMutation, UpdateScheduledItemCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduledItemCommentMutation, UpdateScheduledItemCommentMutationVariables>(UpdateScheduledItemCommentDocument, options);
      }
export type UpdateScheduledItemCommentMutationHookResult = ReturnType<typeof useUpdateScheduledItemCommentMutation>;
export type UpdateScheduledItemCommentMutationResult = Apollo.MutationResult<UpdateScheduledItemCommentMutation>;
export type UpdateScheduledItemCommentMutationOptions = Apollo.BaseMutationOptions<UpdateScheduledItemCommentMutation, UpdateScheduledItemCommentMutationVariables>;
export const UpdateSiteDocument = /*#__PURE__*/ gql`
    mutation UpdateSite($input: SiteUpdateInput!) {
  updateSite(input: $input) {
    ...SiteNest
  }
}
    ${SiteNestFragmentDoc}`;
export type UpdateSiteMutationFn = Apollo.MutationFunction<UpdateSiteMutation, UpdateSiteMutationVariables>;

/**
 * __useUpdateSiteMutation__
 *
 * To run a mutation, you first call `useUpdateSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteMutation, { data, loading, error }] = useUpdateSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSiteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteMutation, UpdateSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteMutation, UpdateSiteMutationVariables>(UpdateSiteDocument, options);
      }
export type UpdateSiteMutationHookResult = ReturnType<typeof useUpdateSiteMutation>;
export type UpdateSiteMutationResult = Apollo.MutationResult<UpdateSiteMutation>;
export type UpdateSiteMutationOptions = Apollo.BaseMutationOptions<UpdateSiteMutation, UpdateSiteMutationVariables>;
export const UpdateSiteFlexMetricDocument = /*#__PURE__*/ gql`
    mutation UpdateSiteFlexMetric($input: SiteFlexMetricUpdateInput!) {
  updateSiteFlexMetric(input: $input) {
    metric {
      displayNameBreadcrumbs {
        key
        value
      }
      id
      internalKeyname
      name
      unit {
        id
        name
      }
    }
    ...SiteFlexMetric
  }
}
    ${SiteFlexMetricFragmentDoc}`;
export type UpdateSiteFlexMetricMutationFn = Apollo.MutationFunction<UpdateSiteFlexMetricMutation, UpdateSiteFlexMetricMutationVariables>;

/**
 * __useUpdateSiteFlexMetricMutation__
 *
 * To run a mutation, you first call `useUpdateSiteFlexMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteFlexMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteFlexMetricMutation, { data, loading, error }] = useUpdateSiteFlexMetricMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSiteFlexMetricMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteFlexMetricMutation, UpdateSiteFlexMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteFlexMetricMutation, UpdateSiteFlexMetricMutationVariables>(UpdateSiteFlexMetricDocument, options);
      }
export type UpdateSiteFlexMetricMutationHookResult = ReturnType<typeof useUpdateSiteFlexMetricMutation>;
export type UpdateSiteFlexMetricMutationResult = Apollo.MutationResult<UpdateSiteFlexMetricMutation>;
export type UpdateSiteFlexMetricMutationOptions = Apollo.BaseMutationOptions<UpdateSiteFlexMetricMutation, UpdateSiteFlexMetricMutationVariables>;
export const UpdateSiteFlexMetricsDocument = /*#__PURE__*/ gql`
    mutation UpdateSiteFlexMetrics($input: SiteFlexMetricsUpdateInput!) {
  updateSiteFlexMetrics(input: $input) {
    metric {
      displayNameBreadcrumbs {
        key
        value
      }
      id
      internalKeyname
      name
      unit {
        id
        name
      }
    }
    ...SiteFlexMetric
  }
}
    ${SiteFlexMetricFragmentDoc}`;
export type UpdateSiteFlexMetricsMutationFn = Apollo.MutationFunction<UpdateSiteFlexMetricsMutation, UpdateSiteFlexMetricsMutationVariables>;

/**
 * __useUpdateSiteFlexMetricsMutation__
 *
 * To run a mutation, you first call `useUpdateSiteFlexMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteFlexMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteFlexMetricsMutation, { data, loading, error }] = useUpdateSiteFlexMetricsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSiteFlexMetricsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteFlexMetricsMutation, UpdateSiteFlexMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteFlexMetricsMutation, UpdateSiteFlexMetricsMutationVariables>(UpdateSiteFlexMetricsDocument, options);
      }
export type UpdateSiteFlexMetricsMutationHookResult = ReturnType<typeof useUpdateSiteFlexMetricsMutation>;
export type UpdateSiteFlexMetricsMutationResult = Apollo.MutationResult<UpdateSiteFlexMetricsMutation>;
export type UpdateSiteFlexMetricsMutationOptions = Apollo.BaseMutationOptions<UpdateSiteFlexMetricsMutation, UpdateSiteFlexMetricsMutationVariables>;
export const UpdateSiteStructureDocument = /*#__PURE__*/ gql`
    mutation UpdateSiteStructure($input: UpdateSiteStructureInput!) {
  updateSiteStructure(input: $input) {
    ...Site
  }
}
    ${SiteFragmentDoc}`;
export type UpdateSiteStructureMutationFn = Apollo.MutationFunction<UpdateSiteStructureMutation, UpdateSiteStructureMutationVariables>;

/**
 * __useUpdateSiteStructureMutation__
 *
 * To run a mutation, you first call `useUpdateSiteStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteStructureMutation, { data, loading, error }] = useUpdateSiteStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSiteStructureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteStructureMutation, UpdateSiteStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteStructureMutation, UpdateSiteStructureMutationVariables>(UpdateSiteStructureDocument, options);
      }
export type UpdateSiteStructureMutationHookResult = ReturnType<typeof useUpdateSiteStructureMutation>;
export type UpdateSiteStructureMutationResult = Apollo.MutationResult<UpdateSiteStructureMutation>;
export type UpdateSiteStructureMutationOptions = Apollo.BaseMutationOptions<UpdateSiteStructureMutation, UpdateSiteStructureMutationVariables>;
export const UpdateSitesDocument = /*#__PURE__*/ gql`
    mutation UpdateSites($input: UpdateSitesInput!) {
  updateSites(input: $input) {
    ...SiteNest
  }
}
    ${SiteNestFragmentDoc}`;
export type UpdateSitesMutationFn = Apollo.MutationFunction<UpdateSitesMutation, UpdateSitesMutationVariables>;

/**
 * __useUpdateSitesMutation__
 *
 * To run a mutation, you first call `useUpdateSitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSitesMutation, { data, loading, error }] = useUpdateSitesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSitesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSitesMutation, UpdateSitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSitesMutation, UpdateSitesMutationVariables>(UpdateSitesDocument, options);
      }
export type UpdateSitesMutationHookResult = ReturnType<typeof useUpdateSitesMutation>;
export type UpdateSitesMutationResult = Apollo.MutationResult<UpdateSitesMutation>;
export type UpdateSitesMutationOptions = Apollo.BaseMutationOptions<UpdateSitesMutation, UpdateSitesMutationVariables>;
export const UpdateSystemDocument = /*#__PURE__*/ gql`
    mutation UpdateSystem($input: UpdateSystemInput!) {
  updateSystem(input: $input) {
    addresses {
      ...Address
    }
    ...SystemNest
  }
}
    ${AddressFragmentDoc}
${SystemNestFragmentDoc}`;
export type UpdateSystemMutationFn = Apollo.MutationFunction<UpdateSystemMutation, UpdateSystemMutationVariables>;

/**
 * __useUpdateSystemMutation__
 *
 * To run a mutation, you first call `useUpdateSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSystemMutation, { data, loading, error }] = useUpdateSystemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSystemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSystemMutation, UpdateSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSystemMutation, UpdateSystemMutationVariables>(UpdateSystemDocument, options);
      }
export type UpdateSystemMutationHookResult = ReturnType<typeof useUpdateSystemMutation>;
export type UpdateSystemMutationResult = Apollo.MutationResult<UpdateSystemMutation>;
export type UpdateSystemMutationOptions = Apollo.BaseMutationOptions<UpdateSystemMutation, UpdateSystemMutationVariables>;
export const UpdateSystemGroupDocument = /*#__PURE__*/ gql`
    mutation UpdateSystemGroup($input: UpdateSystemGroupInput!, $systemGroupId: Int!) {
  updateSystemGroup(input: $input) {
    ...SystemGroup
    users {
      roleForSystemGroup(systemGroupId: $systemGroupId)
      ...User
    }
  }
}
    ${SystemGroupFragmentDoc}
${UserFragmentDoc}`;
export type UpdateSystemGroupMutationFn = Apollo.MutationFunction<UpdateSystemGroupMutation, UpdateSystemGroupMutationVariables>;

/**
 * __useUpdateSystemGroupMutation__
 *
 * To run a mutation, you first call `useUpdateSystemGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSystemGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSystemGroupMutation, { data, loading, error }] = useUpdateSystemGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      systemGroupId: // value for 'systemGroupId'
 *   },
 * });
 */
export function useUpdateSystemGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSystemGroupMutation, UpdateSystemGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSystemGroupMutation, UpdateSystemGroupMutationVariables>(UpdateSystemGroupDocument, options);
      }
export type UpdateSystemGroupMutationHookResult = ReturnType<typeof useUpdateSystemGroupMutation>;
export type UpdateSystemGroupMutationResult = Apollo.MutationResult<UpdateSystemGroupMutation>;
export type UpdateSystemGroupMutationOptions = Apollo.BaseMutationOptions<UpdateSystemGroupMutation, UpdateSystemGroupMutationVariables>;
export const UpdateTagDocument = /*#__PURE__*/ gql`
    mutation UpdateTag($input: UpdateTagInput!) {
  updateTag(input: $input) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const UpdateTrendDocument = /*#__PURE__*/ gql`
    mutation UpdateTrend($input: UpdateTrendInput!, $systemId: Int!) {
  updateTrend(input: $input) {
    owner {
      ...UserNest
    }
    system {
      ...SystemNest
    }
    ...Trend
  }
}
    ${UserNestFragmentDoc}
${SystemNestFragmentDoc}
${TrendFragmentDoc}`;
export type UpdateTrendMutationFn = Apollo.MutationFunction<UpdateTrendMutation, UpdateTrendMutationVariables>;

/**
 * __useUpdateTrendMutation__
 *
 * To run a mutation, you first call `useUpdateTrendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrendMutation, { data, loading, error }] = useUpdateTrendMutation({
 *   variables: {
 *      input: // value for 'input'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useUpdateTrendMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrendMutation, UpdateTrendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrendMutation, UpdateTrendMutationVariables>(UpdateTrendDocument, options);
      }
export type UpdateTrendMutationHookResult = ReturnType<typeof useUpdateTrendMutation>;
export type UpdateTrendMutationResult = Apollo.MutationResult<UpdateTrendMutation>;
export type UpdateTrendMutationOptions = Apollo.BaseMutationOptions<UpdateTrendMutation, UpdateTrendMutationVariables>;
export const UpdateUnitDocument = /*#__PURE__*/ gql`
    mutation UpdateUnit($input: UnitUpdateInput!) {
  updateUnit(input: $input) {
    ...UnitNest
  }
}
    ${UnitNestFragmentDoc}`;
export type UpdateUnitMutationFn = Apollo.MutationFunction<UpdateUnitMutation, UpdateUnitMutationVariables>;

/**
 * __useUpdateUnitMutation__
 *
 * To run a mutation, you first call `useUpdateUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnitMutation, { data, loading, error }] = useUpdateUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUnitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUnitMutation, UpdateUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUnitMutation, UpdateUnitMutationVariables>(UpdateUnitDocument, options);
      }
export type UpdateUnitMutationHookResult = ReturnType<typeof useUpdateUnitMutation>;
export type UpdateUnitMutationResult = Apollo.MutationResult<UpdateUnitMutation>;
export type UpdateUnitMutationOptions = Apollo.BaseMutationOptions<UpdateUnitMutation, UpdateUnitMutationVariables>;
export const UpdateUploadDocument = /*#__PURE__*/ gql`
    mutation UpdateUpload($input: UpdateUploadInput!) {
  updateUpload(input: $input) {
    ...Uploads
  }
}
    ${UploadsFragmentDoc}`;
export type UpdateUploadMutationFn = Apollo.MutationFunction<UpdateUploadMutation, UpdateUploadMutationVariables>;

/**
 * __useUpdateUploadMutation__
 *
 * To run a mutation, you first call `useUpdateUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUploadMutation, { data, loading, error }] = useUpdateUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUploadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUploadMutation, UpdateUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUploadMutation, UpdateUploadMutationVariables>(UpdateUploadDocument, options);
      }
export type UpdateUploadMutationHookResult = ReturnType<typeof useUpdateUploadMutation>;
export type UpdateUploadMutationResult = Apollo.MutationResult<UpdateUploadMutation>;
export type UpdateUploadMutationOptions = Apollo.BaseMutationOptions<UpdateUploadMutation, UpdateUploadMutationVariables>;
export const UpdateUserDocument = /*#__PURE__*/ gql`
    mutation UpdateUser($enableIphoneMetricNumberInput: Boolean, $firstName: String!, $lastName: String!, $userId: Int!) {
  updateUser(
    enableIphoneMetricNumberInput: $enableIphoneMetricNumberInput
    firstName: $firstName
    lastName: $lastName
    userId: $userId
  ) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      enableIphoneMetricNumberInput: // value for 'enableIphoneMetricNumberInput'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserByTokenDocument = /*#__PURE__*/ gql`
    mutation UpdateUserByToken($firstName: String!, $lastName: String!, $password: String!, $userToken: String!, $verifyPassword: String!) {
  updateUserByToken(
    firstName: $firstName
    lastName: $lastName
    password: $password
    userToken: $userToken
    verifyPassword: $verifyPassword
  ) {
    displayName @client
    email
    externalId
    externalOwner
    firstName
    id
    idpKey
    lastName
    pending
    subject
    superadmin
  }
}
    `;
export type UpdateUserByTokenMutationFn = Apollo.MutationFunction<UpdateUserByTokenMutation, UpdateUserByTokenMutationVariables>;

/**
 * __useUpdateUserByTokenMutation__
 *
 * To run a mutation, you first call `useUpdateUserByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserByTokenMutation, { data, loading, error }] = useUpdateUserByTokenMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      password: // value for 'password'
 *      userToken: // value for 'userToken'
 *      verifyPassword: // value for 'verifyPassword'
 *   },
 * });
 */
export function useUpdateUserByTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserByTokenMutation, UpdateUserByTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserByTokenMutation, UpdateUserByTokenMutationVariables>(UpdateUserByTokenDocument, options);
      }
export type UpdateUserByTokenMutationHookResult = ReturnType<typeof useUpdateUserByTokenMutation>;
export type UpdateUserByTokenMutationResult = Apollo.MutationResult<UpdateUserByTokenMutation>;
export type UpdateUserByTokenMutationOptions = Apollo.BaseMutationOptions<UpdateUserByTokenMutation, UpdateUserByTokenMutationVariables>;
export const UpdateUserRoleForSystemDocument = /*#__PURE__*/ gql`
    mutation UpdateUserRoleForSystem($input: UpdateUserRoleForSystemInput!, $systemId: Int!) {
  updateUserRoleForSystem(input: $input) {
    roleForSystem(systemId: $systemId)
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserRoleForSystemMutationFn = Apollo.MutationFunction<UpdateUserRoleForSystemMutation, UpdateUserRoleForSystemMutationVariables>;

/**
 * __useUpdateUserRoleForSystemMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleForSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleForSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleForSystemMutation, { data, loading, error }] = useUpdateUserRoleForSystemMutation({
 *   variables: {
 *      input: // value for 'input'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useUpdateUserRoleForSystemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleForSystemMutation, UpdateUserRoleForSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRoleForSystemMutation, UpdateUserRoleForSystemMutationVariables>(UpdateUserRoleForSystemDocument, options);
      }
export type UpdateUserRoleForSystemMutationHookResult = ReturnType<typeof useUpdateUserRoleForSystemMutation>;
export type UpdateUserRoleForSystemMutationResult = Apollo.MutationResult<UpdateUserRoleForSystemMutation>;
export type UpdateUserRoleForSystemMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleForSystemMutation, UpdateUserRoleForSystemMutationVariables>;
export const UpdateUserRoleForSystemGroupDocument = /*#__PURE__*/ gql`
    mutation UpdateUserRoleForSystemGroup($input: UpdateUserRoleForSystemGroupInput!, $systemGroupId: Int!) {
  updateUserRoleForSystemGroup(input: $input) {
    ...SystemGroupUser
  }
}
    ${SystemGroupUserFragmentDoc}`;
export type UpdateUserRoleForSystemGroupMutationFn = Apollo.MutationFunction<UpdateUserRoleForSystemGroupMutation, UpdateUserRoleForSystemGroupMutationVariables>;

/**
 * __useUpdateUserRoleForSystemGroupMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleForSystemGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleForSystemGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleForSystemGroupMutation, { data, loading, error }] = useUpdateUserRoleForSystemGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      systemGroupId: // value for 'systemGroupId'
 *   },
 * });
 */
export function useUpdateUserRoleForSystemGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleForSystemGroupMutation, UpdateUserRoleForSystemGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRoleForSystemGroupMutation, UpdateUserRoleForSystemGroupMutationVariables>(UpdateUserRoleForSystemGroupDocument, options);
      }
export type UpdateUserRoleForSystemGroupMutationHookResult = ReturnType<typeof useUpdateUserRoleForSystemGroupMutation>;
export type UpdateUserRoleForSystemGroupMutationResult = Apollo.MutationResult<UpdateUserRoleForSystemGroupMutation>;
export type UpdateUserRoleForSystemGroupMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleForSystemGroupMutation, UpdateUserRoleForSystemGroupMutationVariables>;
export const UpdateWeatherDataStationDocument = /*#__PURE__*/ gql`
    mutation UpdateWeatherDataStation($input: UpdateWeatherDataStationInput!) {
  updateWeatherDataStation(input: $input) {
    ...WeatherDataStationFields
  }
}
    ${WeatherDataStationFieldsFragmentDoc}`;
export type UpdateWeatherDataStationMutationFn = Apollo.MutationFunction<UpdateWeatherDataStationMutation, UpdateWeatherDataStationMutationVariables>;

/**
 * __useUpdateWeatherDataStationMutation__
 *
 * To run a mutation, you first call `useUpdateWeatherDataStationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWeatherDataStationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWeatherDataStationMutation, { data, loading, error }] = useUpdateWeatherDataStationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWeatherDataStationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWeatherDataStationMutation, UpdateWeatherDataStationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWeatherDataStationMutation, UpdateWeatherDataStationMutationVariables>(UpdateWeatherDataStationDocument, options);
      }
export type UpdateWeatherDataStationMutationHookResult = ReturnType<typeof useUpdateWeatherDataStationMutation>;
export type UpdateWeatherDataStationMutationResult = Apollo.MutationResult<UpdateWeatherDataStationMutation>;
export type UpdateWeatherDataStationMutationOptions = Apollo.BaseMutationOptions<UpdateWeatherDataStationMutation, UpdateWeatherDataStationMutationVariables>;
export const UpdatedRetentionRiskForOrgsDocument = /*#__PURE__*/ gql`
    mutation UpdatedRetentionRiskForOrgs {
  updatedRetentionRiskForOrgs {
    ...SuccessResponse
  }
}
    ${SuccessResponseFragmentDoc}`;
export type UpdatedRetentionRiskForOrgsMutationFn = Apollo.MutationFunction<UpdatedRetentionRiskForOrgsMutation, UpdatedRetentionRiskForOrgsMutationVariables>;

/**
 * __useUpdatedRetentionRiskForOrgsMutation__
 *
 * To run a mutation, you first call `useUpdatedRetentionRiskForOrgsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatedRetentionRiskForOrgsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatedRetentionRiskForOrgsMutation, { data, loading, error }] = useUpdatedRetentionRiskForOrgsMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdatedRetentionRiskForOrgsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatedRetentionRiskForOrgsMutation, UpdatedRetentionRiskForOrgsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatedRetentionRiskForOrgsMutation, UpdatedRetentionRiskForOrgsMutationVariables>(UpdatedRetentionRiskForOrgsDocument, options);
      }
export type UpdatedRetentionRiskForOrgsMutationHookResult = ReturnType<typeof useUpdatedRetentionRiskForOrgsMutation>;
export type UpdatedRetentionRiskForOrgsMutationResult = Apollo.MutationResult<UpdatedRetentionRiskForOrgsMutation>;
export type UpdatedRetentionRiskForOrgsMutationOptions = Apollo.BaseMutationOptions<UpdatedRetentionRiskForOrgsMutation, UpdatedRetentionRiskForOrgsMutationVariables>;
export const UpsertConstantValueDocument = /*#__PURE__*/ gql`
    mutation UpsertConstantValue($input: UpsertConstantValueInput!) {
  upsertConstantValue(input: $input) {
    ...ConstantValue
  }
}
    ${ConstantValueFragmentDoc}`;
export type UpsertConstantValueMutationFn = Apollo.MutationFunction<UpsertConstantValueMutation, UpsertConstantValueMutationVariables>;

/**
 * __useUpsertConstantValueMutation__
 *
 * To run a mutation, you first call `useUpsertConstantValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertConstantValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertConstantValueMutation, { data, loading, error }] = useUpsertConstantValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertConstantValueMutation(baseOptions?: Apollo.MutationHookOptions<UpsertConstantValueMutation, UpsertConstantValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertConstantValueMutation, UpsertConstantValueMutationVariables>(UpsertConstantValueDocument, options);
      }
export type UpsertConstantValueMutationHookResult = ReturnType<typeof useUpsertConstantValueMutation>;
export type UpsertConstantValueMutationResult = Apollo.MutationResult<UpsertConstantValueMutation>;
export type UpsertConstantValueMutationOptions = Apollo.BaseMutationOptions<UpsertConstantValueMutation, UpsertConstantValueMutationVariables>;
export const UpsertDataEntryCompletionDocument = /*#__PURE__*/ gql`
    mutation UpsertDataEntryCompletion($input: UpsertDataEntryCompletionInput!) {
  upsertDataEntryCompletion(input: $input) {
    ...DataEntryCompletion
  }
}
    ${DataEntryCompletionFragmentDoc}`;
export type UpsertDataEntryCompletionMutationFn = Apollo.MutationFunction<UpsertDataEntryCompletionMutation, UpsertDataEntryCompletionMutationVariables>;

/**
 * __useUpsertDataEntryCompletionMutation__
 *
 * To run a mutation, you first call `useUpsertDataEntryCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDataEntryCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDataEntryCompletionMutation, { data, loading, error }] = useUpsertDataEntryCompletionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertDataEntryCompletionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDataEntryCompletionMutation, UpsertDataEntryCompletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDataEntryCompletionMutation, UpsertDataEntryCompletionMutationVariables>(UpsertDataEntryCompletionDocument, options);
      }
export type UpsertDataEntryCompletionMutationHookResult = ReturnType<typeof useUpsertDataEntryCompletionMutation>;
export type UpsertDataEntryCompletionMutationResult = Apollo.MutationResult<UpsertDataEntryCompletionMutation>;
export type UpsertDataEntryCompletionMutationOptions = Apollo.BaseMutationOptions<UpsertDataEntryCompletionMutation, UpsertDataEntryCompletionMutationVariables>;
export const UpsertMetricRangesDocument = /*#__PURE__*/ gql`
    mutation UpsertMetricRanges($input: UpsertMetricRangesInput!) {
  upsertMetricRanges(input: $input) {
    maxTag {
      ...Tag
    }
    ...MetricRange
    minTag {
      ...Tag
    }
  }
}
    ${TagFragmentDoc}
${MetricRangeFragmentDoc}`;
export type UpsertMetricRangesMutationFn = Apollo.MutationFunction<UpsertMetricRangesMutation, UpsertMetricRangesMutationVariables>;

/**
 * __useUpsertMetricRangesMutation__
 *
 * To run a mutation, you first call `useUpsertMetricRangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMetricRangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMetricRangesMutation, { data, loading, error }] = useUpsertMetricRangesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertMetricRangesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMetricRangesMutation, UpsertMetricRangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMetricRangesMutation, UpsertMetricRangesMutationVariables>(UpsertMetricRangesDocument, options);
      }
export type UpsertMetricRangesMutationHookResult = ReturnType<typeof useUpsertMetricRangesMutation>;
export type UpsertMetricRangesMutationResult = Apollo.MutationResult<UpsertMetricRangesMutation>;
export type UpsertMetricRangesMutationOptions = Apollo.BaseMutationOptions<UpsertMetricRangesMutation, UpsertMetricRangesMutationVariables>;
export const ValidateLabImportBatchDocument = /*#__PURE__*/ gql`
    mutation ValidateLabImportBatch($input: ValidateLabImportBatchInput!) {
  validateLabImportBatch(input: $input) {
    ...LabImportBatch
  }
}
    ${LabImportBatchFragmentDoc}`;
export type ValidateLabImportBatchMutationFn = Apollo.MutationFunction<ValidateLabImportBatchMutation, ValidateLabImportBatchMutationVariables>;

/**
 * __useValidateLabImportBatchMutation__
 *
 * To run a mutation, you first call `useValidateLabImportBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateLabImportBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateLabImportBatchMutation, { data, loading, error }] = useValidateLabImportBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateLabImportBatchMutation(baseOptions?: Apollo.MutationHookOptions<ValidateLabImportBatchMutation, ValidateLabImportBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateLabImportBatchMutation, ValidateLabImportBatchMutationVariables>(ValidateLabImportBatchDocument, options);
      }
export type ValidateLabImportBatchMutationHookResult = ReturnType<typeof useValidateLabImportBatchMutation>;
export type ValidateLabImportBatchMutationResult = Apollo.MutationResult<ValidateLabImportBatchMutation>;
export type ValidateLabImportBatchMutationOptions = Apollo.BaseMutationOptions<ValidateLabImportBatchMutation, ValidateLabImportBatchMutationVariables>;
export const ValidateLabImportProfileDocument = /*#__PURE__*/ gql`
    mutation ValidateLabImportProfile($input: LabImportProfileDefinitionInput!) {
  validateLabImportProfile(input: $input) {
    issues {
      code
      field
      message
    }
    valid
  }
}
    `;
export type ValidateLabImportProfileMutationFn = Apollo.MutationFunction<ValidateLabImportProfileMutation, ValidateLabImportProfileMutationVariables>;

/**
 * __useValidateLabImportProfileMutation__
 *
 * To run a mutation, you first call `useValidateLabImportProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateLabImportProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateLabImportProfileMutation, { data, loading, error }] = useValidateLabImportProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateLabImportProfileMutation(baseOptions?: Apollo.MutationHookOptions<ValidateLabImportProfileMutation, ValidateLabImportProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateLabImportProfileMutation, ValidateLabImportProfileMutationVariables>(ValidateLabImportProfileDocument, options);
      }
export type ValidateLabImportProfileMutationHookResult = ReturnType<typeof useValidateLabImportProfileMutation>;
export type ValidateLabImportProfileMutationResult = Apollo.MutationResult<ValidateLabImportProfileMutation>;
export type ValidateLabImportProfileMutationOptions = Apollo.BaseMutationOptions<ValidateLabImportProfileMutation, ValidateLabImportProfileMutationVariables>;
export const ActiveMetricStatsDocument = /*#__PURE__*/ gql`
    query ActiveMetricStats($input: ActiveMetricStatsInput!) {
  activeMetricStats(input: $input) {
    metricCalculationCount
    metricCount
    metricDataWaterlyConnectCount
  }
}
    `;

/**
 * __useActiveMetricStatsQuery__
 *
 * To run a query within a React component, call `useActiveMetricStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveMetricStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveMetricStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActiveMetricStatsQuery(baseOptions: Apollo.QueryHookOptions<ActiveMetricStatsQuery, ActiveMetricStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveMetricStatsQuery, ActiveMetricStatsQueryVariables>(ActiveMetricStatsDocument, options);
      }
export function useActiveMetricStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveMetricStatsQuery, ActiveMetricStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveMetricStatsQuery, ActiveMetricStatsQueryVariables>(ActiveMetricStatsDocument, options);
        }
export type ActiveMetricStatsQueryHookResult = ReturnType<typeof useActiveMetricStatsQuery>;
export type ActiveMetricStatsLazyQueryHookResult = ReturnType<typeof useActiveMetricStatsLazyQuery>;
export type ActiveMetricStatsQueryResult = Apollo.QueryResult<ActiveMetricStatsQuery, ActiveMetricStatsQueryVariables>;
export function refetchActiveMetricStatsQuery(variables: ActiveMetricStatsQueryVariables) {
      return { query: ActiveMetricStatsDocument, variables: variables }
    }
export const ActiveUserStatsDocument = /*#__PURE__*/ gql`
    query ActiveUserStats($input: ActiveUserDetailsInput!) {
  activeUserStats(input: $input) {
    activeUserCount
    userCount
    users {
      activityCount
      user {
        ...UserNest
      }
    }
  }
}
    ${UserNestFragmentDoc}`;

/**
 * __useActiveUserStatsQuery__
 *
 * To run a query within a React component, call `useActiveUserStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveUserStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveUserStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActiveUserStatsQuery(baseOptions: Apollo.QueryHookOptions<ActiveUserStatsQuery, ActiveUserStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveUserStatsQuery, ActiveUserStatsQueryVariables>(ActiveUserStatsDocument, options);
      }
export function useActiveUserStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveUserStatsQuery, ActiveUserStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveUserStatsQuery, ActiveUserStatsQueryVariables>(ActiveUserStatsDocument, options);
        }
export type ActiveUserStatsQueryHookResult = ReturnType<typeof useActiveUserStatsQuery>;
export type ActiveUserStatsLazyQueryHookResult = ReturnType<typeof useActiveUserStatsLazyQuery>;
export type ActiveUserStatsQueryResult = Apollo.QueryResult<ActiveUserStatsQuery, ActiveUserStatsQueryVariables>;
export function refetchActiveUserStatsQuery(variables: ActiveUserStatsQueryVariables) {
      return { query: ActiveUserStatsDocument, variables: variables }
    }
export const ActivityScheduleByIdDocument = /*#__PURE__*/ gql`
    query ActivityScheduleById($id: String!) {
  getActivityScheduleById(id: $id) {
    ...ActivitySchedule
    defaultAssignee {
      ...UserNest
    }
  }
}
    ${ActivityScheduleFragmentDoc}
${UserNestFragmentDoc}`;

/**
 * __useActivityScheduleByIdQuery__
 *
 * To run a query within a React component, call `useActivityScheduleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityScheduleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityScheduleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivityScheduleByIdQuery(baseOptions: Apollo.QueryHookOptions<ActivityScheduleByIdQuery, ActivityScheduleByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityScheduleByIdQuery, ActivityScheduleByIdQueryVariables>(ActivityScheduleByIdDocument, options);
      }
export function useActivityScheduleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityScheduleByIdQuery, ActivityScheduleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityScheduleByIdQuery, ActivityScheduleByIdQueryVariables>(ActivityScheduleByIdDocument, options);
        }
export type ActivityScheduleByIdQueryHookResult = ReturnType<typeof useActivityScheduleByIdQuery>;
export type ActivityScheduleByIdLazyQueryHookResult = ReturnType<typeof useActivityScheduleByIdLazyQuery>;
export type ActivityScheduleByIdQueryResult = Apollo.QueryResult<ActivityScheduleByIdQuery, ActivityScheduleByIdQueryVariables>;
export function refetchActivityScheduleByIdQuery(variables: ActivityScheduleByIdQueryVariables) {
      return { query: ActivityScheduleByIdDocument, variables: variables }
    }
export const ActivitySchedulesDocument = /*#__PURE__*/ gql`
    query ActivitySchedules($input: ActivitySchedulesInput!) {
  getActivitySchedules(input: $input) {
    count
    items {
      ...ActivitySchedule
      defaultAssignee {
        ...UserNest
      }
      system {
        id
        isFavorite
        name
        organizationId
        parentSystemGroupId
        timeZone
        type
      }
    }
  }
}
    ${ActivityScheduleFragmentDoc}
${UserNestFragmentDoc}`;

/**
 * __useActivitySchedulesQuery__
 *
 * To run a query within a React component, call `useActivitySchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitySchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitySchedulesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivitySchedulesQuery(baseOptions: Apollo.QueryHookOptions<ActivitySchedulesQuery, ActivitySchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitySchedulesQuery, ActivitySchedulesQueryVariables>(ActivitySchedulesDocument, options);
      }
export function useActivitySchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitySchedulesQuery, ActivitySchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitySchedulesQuery, ActivitySchedulesQueryVariables>(ActivitySchedulesDocument, options);
        }
export type ActivitySchedulesQueryHookResult = ReturnType<typeof useActivitySchedulesQuery>;
export type ActivitySchedulesLazyQueryHookResult = ReturnType<typeof useActivitySchedulesLazyQuery>;
export type ActivitySchedulesQueryResult = Apollo.QueryResult<ActivitySchedulesQuery, ActivitySchedulesQueryVariables>;
export function refetchActivitySchedulesQuery(variables: ActivitySchedulesQueryVariables) {
      return { query: ActivitySchedulesDocument, variables: variables }
    }
export const AdjacentEntryIntervalDocument = /*#__PURE__*/ gql`
    query AdjacentEntryInterval($input: AdjacentEntryIntervalInput!) {
  adjacentEntryInterval(input: $input) {
    createdByUser {
      displayName
      email
      fullNameOrEmail
      id
    }
    createdByUserId
    date
    deletedAt
    ...IntervalNest
  }
}
    ${IntervalNestFragmentDoc}`;

/**
 * __useAdjacentEntryIntervalQuery__
 *
 * To run a query within a React component, call `useAdjacentEntryIntervalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdjacentEntryIntervalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdjacentEntryIntervalQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdjacentEntryIntervalQuery(baseOptions: Apollo.QueryHookOptions<AdjacentEntryIntervalQuery, AdjacentEntryIntervalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdjacentEntryIntervalQuery, AdjacentEntryIntervalQueryVariables>(AdjacentEntryIntervalDocument, options);
      }
export function useAdjacentEntryIntervalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdjacentEntryIntervalQuery, AdjacentEntryIntervalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdjacentEntryIntervalQuery, AdjacentEntryIntervalQueryVariables>(AdjacentEntryIntervalDocument, options);
        }
export type AdjacentEntryIntervalQueryHookResult = ReturnType<typeof useAdjacentEntryIntervalQuery>;
export type AdjacentEntryIntervalLazyQueryHookResult = ReturnType<typeof useAdjacentEntryIntervalLazyQuery>;
export type AdjacentEntryIntervalQueryResult = Apollo.QueryResult<AdjacentEntryIntervalQuery, AdjacentEntryIntervalQueryVariables>;
export function refetchAdjacentEntryIntervalQuery(variables: AdjacentEntryIntervalQueryVariables) {
      return { query: AdjacentEntryIntervalDocument, variables: variables }
    }
export const AnalyteGroupByIdDocument = /*#__PURE__*/ gql`
    query AnalyteGroupById($id: String!) {
  analyteGroupById(id: $id) {
    ...AnalyteGroup
    analytes {
      ...Analyte
    }
  }
}
    ${AnalyteGroupFragmentDoc}
${AnalyteFragmentDoc}`;

/**
 * __useAnalyteGroupByIdQuery__
 *
 * To run a query within a React component, call `useAnalyteGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyteGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyteGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnalyteGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<AnalyteGroupByIdQuery, AnalyteGroupByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyteGroupByIdQuery, AnalyteGroupByIdQueryVariables>(AnalyteGroupByIdDocument, options);
      }
export function useAnalyteGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyteGroupByIdQuery, AnalyteGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyteGroupByIdQuery, AnalyteGroupByIdQueryVariables>(AnalyteGroupByIdDocument, options);
        }
export type AnalyteGroupByIdQueryHookResult = ReturnType<typeof useAnalyteGroupByIdQuery>;
export type AnalyteGroupByIdLazyQueryHookResult = ReturnType<typeof useAnalyteGroupByIdLazyQuery>;
export type AnalyteGroupByIdQueryResult = Apollo.QueryResult<AnalyteGroupByIdQuery, AnalyteGroupByIdQueryVariables>;
export function refetchAnalyteGroupByIdQuery(variables: AnalyteGroupByIdQueryVariables) {
      return { query: AnalyteGroupByIdDocument, variables: variables }
    }
export const AnalyteGroupsDocument = /*#__PURE__*/ gql`
    query AnalyteGroups($input: AnalyteGroupsInput!) {
  analyteGroups(input: $input) {
    count
    items {
      ...AnalyteGroup
    }
  }
}
    ${AnalyteGroupFragmentDoc}`;

/**
 * __useAnalyteGroupsQuery__
 *
 * To run a query within a React component, call `useAnalyteGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyteGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyteGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnalyteGroupsQuery(baseOptions: Apollo.QueryHookOptions<AnalyteGroupsQuery, AnalyteGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyteGroupsQuery, AnalyteGroupsQueryVariables>(AnalyteGroupsDocument, options);
      }
export function useAnalyteGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyteGroupsQuery, AnalyteGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyteGroupsQuery, AnalyteGroupsQueryVariables>(AnalyteGroupsDocument, options);
        }
export type AnalyteGroupsQueryHookResult = ReturnType<typeof useAnalyteGroupsQuery>;
export type AnalyteGroupsLazyQueryHookResult = ReturnType<typeof useAnalyteGroupsLazyQuery>;
export type AnalyteGroupsQueryResult = Apollo.QueryResult<AnalyteGroupsQuery, AnalyteGroupsQueryVariables>;
export function refetchAnalyteGroupsQuery(variables: AnalyteGroupsQueryVariables) {
      return { query: AnalyteGroupsDocument, variables: variables }
    }
export const AnalytesDocument = /*#__PURE__*/ gql`
    query Analytes($input: AnalytesInput!) {
  analytes(input: $input) {
    count
    items {
      ...Analyte
    }
  }
}
    ${AnalyteFragmentDoc}`;

/**
 * __useAnalytesQuery__
 *
 * To run a query within a React component, call `useAnalytesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalytesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalytesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnalytesQuery(baseOptions: Apollo.QueryHookOptions<AnalytesQuery, AnalytesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalytesQuery, AnalytesQueryVariables>(AnalytesDocument, options);
      }
export function useAnalytesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalytesQuery, AnalytesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalytesQuery, AnalytesQueryVariables>(AnalytesDocument, options);
        }
export type AnalytesQueryHookResult = ReturnType<typeof useAnalytesQuery>;
export type AnalytesLazyQueryHookResult = ReturnType<typeof useAnalytesLazyQuery>;
export type AnalytesQueryResult = Apollo.QueryResult<AnalytesQuery, AnalytesQueryVariables>;
export function refetchAnalytesQuery(variables: AnalytesQueryVariables) {
      return { query: AnalytesDocument, variables: variables }
    }
export const ApiTokensDocument = /*#__PURE__*/ gql`
    query ApiTokens {
  apiTokens {
    ...ApiToken
  }
}
    ${ApiTokenFragmentDoc}`;

/**
 * __useApiTokensQuery__
 *
 * To run a query within a React component, call `useApiTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokensQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiTokensQuery(baseOptions?: Apollo.QueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiTokensQuery, ApiTokensQueryVariables>(ApiTokensDocument, options);
      }
export function useApiTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiTokensQuery, ApiTokensQueryVariables>(ApiTokensDocument, options);
        }
export type ApiTokensQueryHookResult = ReturnType<typeof useApiTokensQuery>;
export type ApiTokensLazyQueryHookResult = ReturnType<typeof useApiTokensLazyQuery>;
export type ApiTokensQueryResult = Apollo.QueryResult<ApiTokensQuery, ApiTokensQueryVariables>;
export function refetchApiTokensQuery(variables?: ApiTokensQueryVariables) {
      return { query: ApiTokensDocument, variables: variables }
    }
export const ApiTokensByOrganizationDocument = /*#__PURE__*/ gql`
    query ApiTokensByOrganization($input: ApiTokensByOrganizationInput!) {
  apiTokensByOrganization(input: $input) {
    ...ApiToken
  }
}
    ${ApiTokenFragmentDoc}`;

/**
 * __useApiTokensByOrganizationQuery__
 *
 * To run a query within a React component, call `useApiTokensByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokensByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokensByOrganizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiTokensByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<ApiTokensByOrganizationQuery, ApiTokensByOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiTokensByOrganizationQuery, ApiTokensByOrganizationQueryVariables>(ApiTokensByOrganizationDocument, options);
      }
export function useApiTokensByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiTokensByOrganizationQuery, ApiTokensByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiTokensByOrganizationQuery, ApiTokensByOrganizationQueryVariables>(ApiTokensByOrganizationDocument, options);
        }
export type ApiTokensByOrganizationQueryHookResult = ReturnType<typeof useApiTokensByOrganizationQuery>;
export type ApiTokensByOrganizationLazyQueryHookResult = ReturnType<typeof useApiTokensByOrganizationLazyQuery>;
export type ApiTokensByOrganizationQueryResult = Apollo.QueryResult<ApiTokensByOrganizationQuery, ApiTokensByOrganizationQueryVariables>;
export function refetchApiTokensByOrganizationQuery(variables: ApiTokensByOrganizationQueryVariables) {
      return { query: ApiTokensByOrganizationDocument, variables: variables }
    }
export const AuditEventSiteCreatedDocument = /*#__PURE__*/ gql`
    query AuditEventSiteCreated($input: AuditEventFindOneInput!) {
  auditEventSiteCreated(input: $input) {
    ...AuditEventNest
    user {
      ...UserNest
    }
  }
}
    ${AuditEventNestFragmentDoc}
${UserNestFragmentDoc}`;

/**
 * __useAuditEventSiteCreatedQuery__
 *
 * To run a query within a React component, call `useAuditEventSiteCreatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditEventSiteCreatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditEventSiteCreatedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuditEventSiteCreatedQuery(baseOptions: Apollo.QueryHookOptions<AuditEventSiteCreatedQuery, AuditEventSiteCreatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditEventSiteCreatedQuery, AuditEventSiteCreatedQueryVariables>(AuditEventSiteCreatedDocument, options);
      }
export function useAuditEventSiteCreatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditEventSiteCreatedQuery, AuditEventSiteCreatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditEventSiteCreatedQuery, AuditEventSiteCreatedQueryVariables>(AuditEventSiteCreatedDocument, options);
        }
export type AuditEventSiteCreatedQueryHookResult = ReturnType<typeof useAuditEventSiteCreatedQuery>;
export type AuditEventSiteCreatedLazyQueryHookResult = ReturnType<typeof useAuditEventSiteCreatedLazyQuery>;
export type AuditEventSiteCreatedQueryResult = Apollo.QueryResult<AuditEventSiteCreatedQuery, AuditEventSiteCreatedQueryVariables>;
export function refetchAuditEventSiteCreatedQuery(variables: AuditEventSiteCreatedQueryVariables) {
      return { query: AuditEventSiteCreatedDocument, variables: variables }
    }
export const AuditEventsDocument = /*#__PURE__*/ gql`
    query AuditEvents($input: AuditEventsInput!) {
  auditEvents(input: $input) {
    activitySchedule {
      ...ActivitySchedule
    }
    ...AuditEventNest
    component {
      ...ComponentNest
    }
    metric {
      ...MetricNest
    }
    process {
      ...ProcessNest
    }
    scheduledItem {
      ...ScheduledItem
    }
    site {
      ...SiteNest
    }
    system {
      ...SystemNest
    }
    user {
      ...UserNest
    }
  }
}
    ${ActivityScheduleFragmentDoc}
${AuditEventNestFragmentDoc}
${ComponentNestFragmentDoc}
${MetricNestFragmentDoc}
${ProcessNestFragmentDoc}
${ScheduledItemFragmentDoc}
${SiteNestFragmentDoc}
${SystemNestFragmentDoc}
${UserNestFragmentDoc}`;

/**
 * __useAuditEventsQuery__
 *
 * To run a query within a React component, call `useAuditEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuditEventsQuery(baseOptions: Apollo.QueryHookOptions<AuditEventsQuery, AuditEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditEventsQuery, AuditEventsQueryVariables>(AuditEventsDocument, options);
      }
export function useAuditEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditEventsQuery, AuditEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditEventsQuery, AuditEventsQueryVariables>(AuditEventsDocument, options);
        }
export type AuditEventsQueryHookResult = ReturnType<typeof useAuditEventsQuery>;
export type AuditEventsLazyQueryHookResult = ReturnType<typeof useAuditEventsLazyQuery>;
export type AuditEventsQueryResult = Apollo.QueryResult<AuditEventsQuery, AuditEventsQueryVariables>;
export function refetchAuditEventsQuery(variables: AuditEventsQueryVariables) {
      return { query: AuditEventsDocument, variables: variables }
    }
export const AuditEventsByItemTypeAndItemIdDocument = /*#__PURE__*/ gql`
    query AuditEventsByItemTypeAndItemId($input: AuditEventsByItemTypeAndItemId!) {
  auditEventsByItemTypeAndItemId(input: $input) {
    activitySchedule {
      ...ActivitySchedule
    }
    ...AuditEventNest
    component {
      ...ComponentNest
    }
    metric {
      ...MetricNest
    }
    process {
      ...ProcessNest
    }
    scheduledItem {
      ...ScheduledItem
    }
    site {
      ...SiteNest
    }
    system {
      ...SystemNest
    }
    user {
      ...UserNest
    }
  }
}
    ${ActivityScheduleFragmentDoc}
${AuditEventNestFragmentDoc}
${ComponentNestFragmentDoc}
${MetricNestFragmentDoc}
${ProcessNestFragmentDoc}
${ScheduledItemFragmentDoc}
${SiteNestFragmentDoc}
${SystemNestFragmentDoc}
${UserNestFragmentDoc}`;

/**
 * __useAuditEventsByItemTypeAndItemIdQuery__
 *
 * To run a query within a React component, call `useAuditEventsByItemTypeAndItemIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditEventsByItemTypeAndItemIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditEventsByItemTypeAndItemIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuditEventsByItemTypeAndItemIdQuery(baseOptions: Apollo.QueryHookOptions<AuditEventsByItemTypeAndItemIdQuery, AuditEventsByItemTypeAndItemIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditEventsByItemTypeAndItemIdQuery, AuditEventsByItemTypeAndItemIdQueryVariables>(AuditEventsByItemTypeAndItemIdDocument, options);
      }
export function useAuditEventsByItemTypeAndItemIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditEventsByItemTypeAndItemIdQuery, AuditEventsByItemTypeAndItemIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditEventsByItemTypeAndItemIdQuery, AuditEventsByItemTypeAndItemIdQueryVariables>(AuditEventsByItemTypeAndItemIdDocument, options);
        }
export type AuditEventsByItemTypeAndItemIdQueryHookResult = ReturnType<typeof useAuditEventsByItemTypeAndItemIdQuery>;
export type AuditEventsByItemTypeAndItemIdLazyQueryHookResult = ReturnType<typeof useAuditEventsByItemTypeAndItemIdLazyQuery>;
export type AuditEventsByItemTypeAndItemIdQueryResult = Apollo.QueryResult<AuditEventsByItemTypeAndItemIdQuery, AuditEventsByItemTypeAndItemIdQueryVariables>;
export function refetchAuditEventsByItemTypeAndItemIdQuery(variables: AuditEventsByItemTypeAndItemIdQueryVariables) {
      return { query: AuditEventsByItemTypeAndItemIdDocument, variables: variables }
    }
export const AuditEventsByMetricIdDocument = /*#__PURE__*/ gql`
    query AuditEventsByMetricId($input: AuditEventsByMetricIdInput!) {
  auditEventsByMetricId(input: $input) {
    count
    items {
      appliedAtWithTimeZone
      event
      id
      rolledBackAt
      system {
        ...SystemNest
      }
      timestamp
      type
      user {
        email
        firstName
        id
        lastName
      }
      userId
    }
  }
}
    ${SystemNestFragmentDoc}`;

/**
 * __useAuditEventsByMetricIdQuery__
 *
 * To run a query within a React component, call `useAuditEventsByMetricIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditEventsByMetricIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditEventsByMetricIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuditEventsByMetricIdQuery(baseOptions: Apollo.QueryHookOptions<AuditEventsByMetricIdQuery, AuditEventsByMetricIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditEventsByMetricIdQuery, AuditEventsByMetricIdQueryVariables>(AuditEventsByMetricIdDocument, options);
      }
export function useAuditEventsByMetricIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditEventsByMetricIdQuery, AuditEventsByMetricIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditEventsByMetricIdQuery, AuditEventsByMetricIdQueryVariables>(AuditEventsByMetricIdDocument, options);
        }
export type AuditEventsByMetricIdQueryHookResult = ReturnType<typeof useAuditEventsByMetricIdQuery>;
export type AuditEventsByMetricIdLazyQueryHookResult = ReturnType<typeof useAuditEventsByMetricIdLazyQuery>;
export type AuditEventsByMetricIdQueryResult = Apollo.QueryResult<AuditEventsByMetricIdQuery, AuditEventsByMetricIdQueryVariables>;
export function refetchAuditEventsByMetricIdQuery(variables: AuditEventsByMetricIdQueryVariables) {
      return { query: AuditEventsByMetricIdDocument, variables: variables }
    }
export const AuditEventsByScheduledItemIdDocument = /*#__PURE__*/ gql`
    query AuditEventsByScheduledItemId($input: AuditEventsByScheduledItemIdInput!) {
  auditEventsByScheduledItemId(input: $input) {
    event
    id
    rolledBackAt
    timestamp
    type
    user {
      email
      externalId
      externalOwner
      firstName
      id
      idpKey
      lastName
      pending
      primaryOrganizationId
      readonlySuperadmin
      subject
      superadmin
    }
    userId
  }
}
    `;

/**
 * __useAuditEventsByScheduledItemIdQuery__
 *
 * To run a query within a React component, call `useAuditEventsByScheduledItemIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditEventsByScheduledItemIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditEventsByScheduledItemIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuditEventsByScheduledItemIdQuery(baseOptions: Apollo.QueryHookOptions<AuditEventsByScheduledItemIdQuery, AuditEventsByScheduledItemIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditEventsByScheduledItemIdQuery, AuditEventsByScheduledItemIdQueryVariables>(AuditEventsByScheduledItemIdDocument, options);
      }
export function useAuditEventsByScheduledItemIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditEventsByScheduledItemIdQuery, AuditEventsByScheduledItemIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditEventsByScheduledItemIdQuery, AuditEventsByScheduledItemIdQueryVariables>(AuditEventsByScheduledItemIdDocument, options);
        }
export type AuditEventsByScheduledItemIdQueryHookResult = ReturnType<typeof useAuditEventsByScheduledItemIdQuery>;
export type AuditEventsByScheduledItemIdLazyQueryHookResult = ReturnType<typeof useAuditEventsByScheduledItemIdLazyQuery>;
export type AuditEventsByScheduledItemIdQueryResult = Apollo.QueryResult<AuditEventsByScheduledItemIdQuery, AuditEventsByScheduledItemIdQueryVariables>;
export function refetchAuditEventsByScheduledItemIdQuery(variables: AuditEventsByScheduledItemIdQueryVariables) {
      return { query: AuditEventsByScheduledItemIdDocument, variables: variables }
    }
export const BulkMetricEditorFilterOptionsDocument = /*#__PURE__*/ gql`
    query BulkMetricEditorFilterOptions($input: BulkMetricEditorMetricsFilterInput!) {
  bulkMetricEditorFilterOptions(input: $input) {
    calculationNames
    componentKeynames
    components {
      id
      name
    }
    copyPreviousValueEnabled
    dataPointCommentPolicies
    dataTypes
    expressions
    hasIntervals
    hideFromDataEntry
    interpolated
    isLockedByWaterly
    isReportComments
    keynames
    limits
    metricRangeTypes
    notificationEnabled
    organizations {
      id
      name
    }
    processes {
      id
      name
    }
    processKeynames
    reportAggregations
    required
    sites {
      id
      name
    }
    siteTypes
    systems {
      id
      name
    }
    systemTypes
    units
  }
}
    `;

/**
 * __useBulkMetricEditorFilterOptionsQuery__
 *
 * To run a query within a React component, call `useBulkMetricEditorFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkMetricEditorFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkMetricEditorFilterOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkMetricEditorFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<BulkMetricEditorFilterOptionsQuery, BulkMetricEditorFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkMetricEditorFilterOptionsQuery, BulkMetricEditorFilterOptionsQueryVariables>(BulkMetricEditorFilterOptionsDocument, options);
      }
export function useBulkMetricEditorFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkMetricEditorFilterOptionsQuery, BulkMetricEditorFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkMetricEditorFilterOptionsQuery, BulkMetricEditorFilterOptionsQueryVariables>(BulkMetricEditorFilterOptionsDocument, options);
        }
export type BulkMetricEditorFilterOptionsQueryHookResult = ReturnType<typeof useBulkMetricEditorFilterOptionsQuery>;
export type BulkMetricEditorFilterOptionsLazyQueryHookResult = ReturnType<typeof useBulkMetricEditorFilterOptionsLazyQuery>;
export type BulkMetricEditorFilterOptionsQueryResult = Apollo.QueryResult<BulkMetricEditorFilterOptionsQuery, BulkMetricEditorFilterOptionsQueryVariables>;
export function refetchBulkMetricEditorFilterOptionsQuery(variables: BulkMetricEditorFilterOptionsQueryVariables) {
      return { query: BulkMetricEditorFilterOptionsDocument, variables: variables }
    }
export const BulkMetricEditorMetricsDocument = /*#__PURE__*/ gql`
    query BulkMetricEditorMetrics($input: BulkMetricEditorMetricsInput!) {
  bulkMetricEditorMetrics(input: $input) {
    filteredCount
    items {
      ...BulkMetricEditorRow
    }
    totalCount
  }
}
    ${BulkMetricEditorRowFragmentDoc}`;

/**
 * __useBulkMetricEditorMetricsQuery__
 *
 * To run a query within a React component, call `useBulkMetricEditorMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkMetricEditorMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkMetricEditorMetricsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkMetricEditorMetricsQuery(baseOptions: Apollo.QueryHookOptions<BulkMetricEditorMetricsQuery, BulkMetricEditorMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkMetricEditorMetricsQuery, BulkMetricEditorMetricsQueryVariables>(BulkMetricEditorMetricsDocument, options);
      }
export function useBulkMetricEditorMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkMetricEditorMetricsQuery, BulkMetricEditorMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkMetricEditorMetricsQuery, BulkMetricEditorMetricsQueryVariables>(BulkMetricEditorMetricsDocument, options);
        }
export type BulkMetricEditorMetricsQueryHookResult = ReturnType<typeof useBulkMetricEditorMetricsQuery>;
export type BulkMetricEditorMetricsLazyQueryHookResult = ReturnType<typeof useBulkMetricEditorMetricsLazyQuery>;
export type BulkMetricEditorMetricsQueryResult = Apollo.QueryResult<BulkMetricEditorMetricsQuery, BulkMetricEditorMetricsQueryVariables>;
export function refetchBulkMetricEditorMetricsQuery(variables: BulkMetricEditorMetricsQueryVariables) {
      return { query: BulkMetricEditorMetricsDocument, variables: variables }
    }
export const CalcClusterDebugByClusterIdDocument = /*#__PURE__*/ gql`
    query CalcClusterDebugByClusterId($clusterId: String!) {
  calcClusterDebugByClusterId(clusterId: $clusterId) {
    ...CalcClusterDebug
  }
}
    ${CalcClusterDebugFragmentDoc}`;

/**
 * __useCalcClusterDebugByClusterIdQuery__
 *
 * To run a query within a React component, call `useCalcClusterDebugByClusterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalcClusterDebugByClusterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalcClusterDebugByClusterIdQuery({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useCalcClusterDebugByClusterIdQuery(baseOptions: Apollo.QueryHookOptions<CalcClusterDebugByClusterIdQuery, CalcClusterDebugByClusterIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalcClusterDebugByClusterIdQuery, CalcClusterDebugByClusterIdQueryVariables>(CalcClusterDebugByClusterIdDocument, options);
      }
export function useCalcClusterDebugByClusterIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalcClusterDebugByClusterIdQuery, CalcClusterDebugByClusterIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalcClusterDebugByClusterIdQuery, CalcClusterDebugByClusterIdQueryVariables>(CalcClusterDebugByClusterIdDocument, options);
        }
export type CalcClusterDebugByClusterIdQueryHookResult = ReturnType<typeof useCalcClusterDebugByClusterIdQuery>;
export type CalcClusterDebugByClusterIdLazyQueryHookResult = ReturnType<typeof useCalcClusterDebugByClusterIdLazyQuery>;
export type CalcClusterDebugByClusterIdQueryResult = Apollo.QueryResult<CalcClusterDebugByClusterIdQuery, CalcClusterDebugByClusterIdQueryVariables>;
export function refetchCalcClusterDebugByClusterIdQuery(variables: CalcClusterDebugByClusterIdQueryVariables) {
      return { query: CalcClusterDebugByClusterIdDocument, variables: variables }
    }
export const CalcClusterDebugLogsDocument = /*#__PURE__*/ gql`
    query CalcClusterDebugLogs($input: CalcClusterDebugLogsInput!) {
  calcClusterDebugLogs(input: $input) {
    ...CalcClusterDebugLog
  }
}
    ${CalcClusterDebugLogFragmentDoc}`;

/**
 * __useCalcClusterDebugLogsQuery__
 *
 * To run a query within a React component, call `useCalcClusterDebugLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalcClusterDebugLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalcClusterDebugLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalcClusterDebugLogsQuery(baseOptions: Apollo.QueryHookOptions<CalcClusterDebugLogsQuery, CalcClusterDebugLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalcClusterDebugLogsQuery, CalcClusterDebugLogsQueryVariables>(CalcClusterDebugLogsDocument, options);
      }
export function useCalcClusterDebugLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalcClusterDebugLogsQuery, CalcClusterDebugLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalcClusterDebugLogsQuery, CalcClusterDebugLogsQueryVariables>(CalcClusterDebugLogsDocument, options);
        }
export type CalcClusterDebugLogsQueryHookResult = ReturnType<typeof useCalcClusterDebugLogsQuery>;
export type CalcClusterDebugLogsLazyQueryHookResult = ReturnType<typeof useCalcClusterDebugLogsLazyQuery>;
export type CalcClusterDebugLogsQueryResult = Apollo.QueryResult<CalcClusterDebugLogsQuery, CalcClusterDebugLogsQueryVariables>;
export function refetchCalcClusterDebugLogsQuery(variables: CalcClusterDebugLogsQueryVariables) {
      return { query: CalcClusterDebugLogsDocument, variables: variables }
    }
export const CalcClusterDebugsDocument = /*#__PURE__*/ gql`
    query CalcClusterDebugs($input: CalcClusterDebugInputs!) {
  calcClusterDebugs(input: $input) {
    count
    items {
      ...CalcClusterDebug
      logStats {
        avgLogsPerTransaction
        lastLoggedAt
        logCount
        maxLogsPerTransaction
        transactionCount
      }
      metrics(input: $input) {
        displayName
        id
        site {
          id
          name
          systemId
        }
      }
      systems {
        ...SystemNest
      }
    }
  }
}
    ${CalcClusterDebugFragmentDoc}
${SystemNestFragmentDoc}`;

/**
 * __useCalcClusterDebugsQuery__
 *
 * To run a query within a React component, call `useCalcClusterDebugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalcClusterDebugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalcClusterDebugsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalcClusterDebugsQuery(baseOptions: Apollo.QueryHookOptions<CalcClusterDebugsQuery, CalcClusterDebugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalcClusterDebugsQuery, CalcClusterDebugsQueryVariables>(CalcClusterDebugsDocument, options);
      }
export function useCalcClusterDebugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalcClusterDebugsQuery, CalcClusterDebugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalcClusterDebugsQuery, CalcClusterDebugsQueryVariables>(CalcClusterDebugsDocument, options);
        }
export type CalcClusterDebugsQueryHookResult = ReturnType<typeof useCalcClusterDebugsQuery>;
export type CalcClusterDebugsLazyQueryHookResult = ReturnType<typeof useCalcClusterDebugsLazyQuery>;
export type CalcClusterDebugsQueryResult = Apollo.QueryResult<CalcClusterDebugsQuery, CalcClusterDebugsQueryVariables>;
export function refetchCalcClusterDebugsQuery(variables: CalcClusterDebugsQueryVariables) {
      return { query: CalcClusterDebugsDocument, variables: variables }
    }
export const ColumnGroupsDocument = /*#__PURE__*/ gql`
    query ColumnGroups($input: ColumnGroupsInput!) {
  columnGroups(input: $input) {
    ...ColumnGroup
  }
}
    ${ColumnGroupFragmentDoc}`;

/**
 * __useColumnGroupsQuery__
 *
 * To run a query within a React component, call `useColumnGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useColumnGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColumnGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useColumnGroupsQuery(baseOptions: Apollo.QueryHookOptions<ColumnGroupsQuery, ColumnGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ColumnGroupsQuery, ColumnGroupsQueryVariables>(ColumnGroupsDocument, options);
      }
export function useColumnGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ColumnGroupsQuery, ColumnGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ColumnGroupsQuery, ColumnGroupsQueryVariables>(ColumnGroupsDocument, options);
        }
export type ColumnGroupsQueryHookResult = ReturnType<typeof useColumnGroupsQuery>;
export type ColumnGroupsLazyQueryHookResult = ReturnType<typeof useColumnGroupsLazyQuery>;
export type ColumnGroupsQueryResult = Apollo.QueryResult<ColumnGroupsQuery, ColumnGroupsQueryVariables>;
export function refetchColumnGroupsQuery(variables: ColumnGroupsQueryVariables) {
      return { query: ColumnGroupsDocument, variables: variables }
    }
export const ColumnGroupsWithItemsDocument = /*#__PURE__*/ gql`
    query ColumnGroupsWithItems($input: ColumnGroupsWithItemsInput!) {
  columnGroupsWithItems(input: $input) {
    columnGroupItems {
      id
      metric {
        id
        name
      }
      metricId
      name
      type
    }
    id
    name
    reportDefinitionId
  }
}
    `;

/**
 * __useColumnGroupsWithItemsQuery__
 *
 * To run a query within a React component, call `useColumnGroupsWithItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useColumnGroupsWithItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColumnGroupsWithItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useColumnGroupsWithItemsQuery(baseOptions: Apollo.QueryHookOptions<ColumnGroupsWithItemsQuery, ColumnGroupsWithItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ColumnGroupsWithItemsQuery, ColumnGroupsWithItemsQueryVariables>(ColumnGroupsWithItemsDocument, options);
      }
export function useColumnGroupsWithItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ColumnGroupsWithItemsQuery, ColumnGroupsWithItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ColumnGroupsWithItemsQuery, ColumnGroupsWithItemsQueryVariables>(ColumnGroupsWithItemsDocument, options);
        }
export type ColumnGroupsWithItemsQueryHookResult = ReturnType<typeof useColumnGroupsWithItemsQuery>;
export type ColumnGroupsWithItemsLazyQueryHookResult = ReturnType<typeof useColumnGroupsWithItemsLazyQuery>;
export type ColumnGroupsWithItemsQueryResult = Apollo.QueryResult<ColumnGroupsWithItemsQuery, ColumnGroupsWithItemsQueryVariables>;
export function refetchColumnGroupsWithItemsQuery(variables: ColumnGroupsWithItemsQueryVariables) {
      return { query: ColumnGroupsWithItemsDocument, variables: variables }
    }
export const ConstantRecalculationEstimateDocument = /*#__PURE__*/ gql`
    query ConstantRecalculationEstimate($input: ConstantRecalculationInput!) {
  constantRecalculationEstimate(input: $input) {
    capped
    dayCount
    effectiveFromDate
    metrics {
      metricId
      metricName
      recalculationCount
      siteName
    }
    recalcFromDate
    toDate
    totalRecalculationCount
  }
}
    `;

/**
 * __useConstantRecalculationEstimateQuery__
 *
 * To run a query within a React component, call `useConstantRecalculationEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useConstantRecalculationEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConstantRecalculationEstimateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConstantRecalculationEstimateQuery(baseOptions: Apollo.QueryHookOptions<ConstantRecalculationEstimateQuery, ConstantRecalculationEstimateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConstantRecalculationEstimateQuery, ConstantRecalculationEstimateQueryVariables>(ConstantRecalculationEstimateDocument, options);
      }
export function useConstantRecalculationEstimateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConstantRecalculationEstimateQuery, ConstantRecalculationEstimateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConstantRecalculationEstimateQuery, ConstantRecalculationEstimateQueryVariables>(ConstantRecalculationEstimateDocument, options);
        }
export type ConstantRecalculationEstimateQueryHookResult = ReturnType<typeof useConstantRecalculationEstimateQuery>;
export type ConstantRecalculationEstimateLazyQueryHookResult = ReturnType<typeof useConstantRecalculationEstimateLazyQuery>;
export type ConstantRecalculationEstimateQueryResult = Apollo.QueryResult<ConstantRecalculationEstimateQuery, ConstantRecalculationEstimateQueryVariables>;
export function refetchConstantRecalculationEstimateQuery(variables: ConstantRecalculationEstimateQueryVariables) {
      return { query: ConstantRecalculationEstimateDocument, variables: variables }
    }
export const ConstantsDiscoveryDocument = /*#__PURE__*/ gql`
    query ConstantsDiscovery($organizationInput: ConstantsForOrganizationInput!, $systemInput: ConstantsForSystemInput!) {
  constantsForOrganization(input: $organizationInput) {
    constantDefinition {
      ...ConstantDefinition
    }
    constantValue {
      ...ConstantValue
    }
    source
  }
  constantsForSystem(input: $systemInput) {
    constantDefinition {
      ...ConstantDefinition
    }
    constantValue {
      ...ConstantValue
    }
    source
  }
}
    ${ConstantDefinitionFragmentDoc}
${ConstantValueFragmentDoc}`;

/**
 * __useConstantsDiscoveryQuery__
 *
 * To run a query within a React component, call `useConstantsDiscoveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConstantsDiscoveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConstantsDiscoveryQuery({
 *   variables: {
 *      organizationInput: // value for 'organizationInput'
 *      systemInput: // value for 'systemInput'
 *   },
 * });
 */
export function useConstantsDiscoveryQuery(baseOptions: Apollo.QueryHookOptions<ConstantsDiscoveryQuery, ConstantsDiscoveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConstantsDiscoveryQuery, ConstantsDiscoveryQueryVariables>(ConstantsDiscoveryDocument, options);
      }
export function useConstantsDiscoveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConstantsDiscoveryQuery, ConstantsDiscoveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConstantsDiscoveryQuery, ConstantsDiscoveryQueryVariables>(ConstantsDiscoveryDocument, options);
        }
export type ConstantsDiscoveryQueryHookResult = ReturnType<typeof useConstantsDiscoveryQuery>;
export type ConstantsDiscoveryLazyQueryHookResult = ReturnType<typeof useConstantsDiscoveryLazyQuery>;
export type ConstantsDiscoveryQueryResult = Apollo.QueryResult<ConstantsDiscoveryQuery, ConstantsDiscoveryQueryVariables>;
export function refetchConstantsDiscoveryQuery(variables: ConstantsDiscoveryQueryVariables) {
      return { query: ConstantsDiscoveryDocument, variables: variables }
    }
export const ConstantsForOrganizationDocument = /*#__PURE__*/ gql`
    query ConstantsForOrganization($input: ConstantsForOrganizationInput!) {
  constantsForOrganization(input: $input) {
    constantDefinition {
      ...ConstantDefinition
      usedByMetricCount
      values {
        ...ConstantValue
      }
    }
    constantValue {
      ...ConstantValue
    }
    source
  }
}
    ${ConstantDefinitionFragmentDoc}
${ConstantValueFragmentDoc}`;

/**
 * __useConstantsForOrganizationQuery__
 *
 * To run a query within a React component, call `useConstantsForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConstantsForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConstantsForOrganizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConstantsForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<ConstantsForOrganizationQuery, ConstantsForOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConstantsForOrganizationQuery, ConstantsForOrganizationQueryVariables>(ConstantsForOrganizationDocument, options);
      }
export function useConstantsForOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConstantsForOrganizationQuery, ConstantsForOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConstantsForOrganizationQuery, ConstantsForOrganizationQueryVariables>(ConstantsForOrganizationDocument, options);
        }
export type ConstantsForOrganizationQueryHookResult = ReturnType<typeof useConstantsForOrganizationQuery>;
export type ConstantsForOrganizationLazyQueryHookResult = ReturnType<typeof useConstantsForOrganizationLazyQuery>;
export type ConstantsForOrganizationQueryResult = Apollo.QueryResult<ConstantsForOrganizationQuery, ConstantsForOrganizationQueryVariables>;
export function refetchConstantsForOrganizationQuery(variables: ConstantsForOrganizationQueryVariables) {
      return { query: ConstantsForOrganizationDocument, variables: variables }
    }
export const ConstantsForSystemDocument = /*#__PURE__*/ gql`
    query ConstantsForSystem($input: ConstantsForSystemInput!) {
  constantsForSystem(input: $input) {
    constantDefinition {
      ...ConstantDefinition
      usedByMetricCount
      values {
        ...ConstantValue
      }
    }
    constantValue {
      ...ConstantValue
    }
    source
  }
}
    ${ConstantDefinitionFragmentDoc}
${ConstantValueFragmentDoc}`;

/**
 * __useConstantsForSystemQuery__
 *
 * To run a query within a React component, call `useConstantsForSystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useConstantsForSystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConstantsForSystemQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConstantsForSystemQuery(baseOptions: Apollo.QueryHookOptions<ConstantsForSystemQuery, ConstantsForSystemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConstantsForSystemQuery, ConstantsForSystemQueryVariables>(ConstantsForSystemDocument, options);
      }
export function useConstantsForSystemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConstantsForSystemQuery, ConstantsForSystemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConstantsForSystemQuery, ConstantsForSystemQueryVariables>(ConstantsForSystemDocument, options);
        }
export type ConstantsForSystemQueryHookResult = ReturnType<typeof useConstantsForSystemQuery>;
export type ConstantsForSystemLazyQueryHookResult = ReturnType<typeof useConstantsForSystemLazyQuery>;
export type ConstantsForSystemQueryResult = Apollo.QueryResult<ConstantsForSystemQuery, ConstantsForSystemQueryVariables>;
export function refetchConstantsForSystemQuery(variables: ConstantsForSystemQueryVariables) {
      return { query: ConstantsForSystemDocument, variables: variables }
    }
export const DataEntryCompletionsByReportDateDocument = /*#__PURE__*/ gql`
    query DataEntryCompletionsByReportDate($input: DataEntryCompletionsByReportDateInput!) {
  dataEntryCompletionsByReportDate(input: $input) {
    daily {
      ...DataEntryCompletion
    }
    intervals {
      ...DataEntryCompletion
    }
  }
}
    ${DataEntryCompletionFragmentDoc}`;

/**
 * __useDataEntryCompletionsByReportDateQuery__
 *
 * To run a query within a React component, call `useDataEntryCompletionsByReportDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataEntryCompletionsByReportDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataEntryCompletionsByReportDateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDataEntryCompletionsByReportDateQuery(baseOptions: Apollo.QueryHookOptions<DataEntryCompletionsByReportDateQuery, DataEntryCompletionsByReportDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataEntryCompletionsByReportDateQuery, DataEntryCompletionsByReportDateQueryVariables>(DataEntryCompletionsByReportDateDocument, options);
      }
export function useDataEntryCompletionsByReportDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataEntryCompletionsByReportDateQuery, DataEntryCompletionsByReportDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataEntryCompletionsByReportDateQuery, DataEntryCompletionsByReportDateQueryVariables>(DataEntryCompletionsByReportDateDocument, options);
        }
export type DataEntryCompletionsByReportDateQueryHookResult = ReturnType<typeof useDataEntryCompletionsByReportDateQuery>;
export type DataEntryCompletionsByReportDateLazyQueryHookResult = ReturnType<typeof useDataEntryCompletionsByReportDateLazyQuery>;
export type DataEntryCompletionsByReportDateQueryResult = Apollo.QueryResult<DataEntryCompletionsByReportDateQuery, DataEntryCompletionsByReportDateQueryVariables>;
export function refetchDataEntryCompletionsByReportDateQuery(variables: DataEntryCompletionsByReportDateQueryVariables) {
      return { query: DataEntryCompletionsByReportDateDocument, variables: variables }
    }
export const DataModelSitesForMirrorDocument = /*#__PURE__*/ gql`
    query DataModelSitesForMirror($input: SitesInput!) {
  sitesV2(input: $input) {
    metrics(includeDeleted: true, includeHidden: true) {
      deletedAt
      id
    }
    processes(includeDeleted: true) {
      deletedAt
      id
      name
      order
    }
    ...SiteNest
  }
}
    ${SiteNestFragmentDoc}`;

/**
 * __useDataModelSitesForMirrorQuery__
 *
 * To run a query within a React component, call `useDataModelSitesForMirrorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataModelSitesForMirrorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataModelSitesForMirrorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDataModelSitesForMirrorQuery(baseOptions: Apollo.QueryHookOptions<DataModelSitesForMirrorQuery, DataModelSitesForMirrorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataModelSitesForMirrorQuery, DataModelSitesForMirrorQueryVariables>(DataModelSitesForMirrorDocument, options);
      }
export function useDataModelSitesForMirrorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataModelSitesForMirrorQuery, DataModelSitesForMirrorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataModelSitesForMirrorQuery, DataModelSitesForMirrorQueryVariables>(DataModelSitesForMirrorDocument, options);
        }
export type DataModelSitesForMirrorQueryHookResult = ReturnType<typeof useDataModelSitesForMirrorQuery>;
export type DataModelSitesForMirrorLazyQueryHookResult = ReturnType<typeof useDataModelSitesForMirrorLazyQuery>;
export type DataModelSitesForMirrorQueryResult = Apollo.QueryResult<DataModelSitesForMirrorQuery, DataModelSitesForMirrorQueryVariables>;
export function refetchDataModelSitesForMirrorQuery(variables: DataModelSitesForMirrorQueryVariables) {
      return { query: DataModelSitesForMirrorDocument, variables: variables }
    }
export const EligibleManualReportEmailRecipientsDocument = /*#__PURE__*/ gql`
    query EligibleManualReportEmailRecipients($input: EligibleManualReportEmailRecipientsInput!) {
  eligibleManualReportEmailRecipients(input: $input) {
    displayName
    email
    primaryOrganizationName
    userId
  }
}
    `;

/**
 * __useEligibleManualReportEmailRecipientsQuery__
 *
 * To run a query within a React component, call `useEligibleManualReportEmailRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEligibleManualReportEmailRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEligibleManualReportEmailRecipientsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEligibleManualReportEmailRecipientsQuery(baseOptions: Apollo.QueryHookOptions<EligibleManualReportEmailRecipientsQuery, EligibleManualReportEmailRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EligibleManualReportEmailRecipientsQuery, EligibleManualReportEmailRecipientsQueryVariables>(EligibleManualReportEmailRecipientsDocument, options);
      }
export function useEligibleManualReportEmailRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EligibleManualReportEmailRecipientsQuery, EligibleManualReportEmailRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EligibleManualReportEmailRecipientsQuery, EligibleManualReportEmailRecipientsQueryVariables>(EligibleManualReportEmailRecipientsDocument, options);
        }
export type EligibleManualReportEmailRecipientsQueryHookResult = ReturnType<typeof useEligibleManualReportEmailRecipientsQuery>;
export type EligibleManualReportEmailRecipientsLazyQueryHookResult = ReturnType<typeof useEligibleManualReportEmailRecipientsLazyQuery>;
export type EligibleManualReportEmailRecipientsQueryResult = Apollo.QueryResult<EligibleManualReportEmailRecipientsQuery, EligibleManualReportEmailRecipientsQueryVariables>;
export function refetchEligibleManualReportEmailRecipientsQuery(variables: EligibleManualReportEmailRecipientsQueryVariables) {
      return { query: EligibleManualReportEmailRecipientsDocument, variables: variables }
    }
export const EnterpriseReportShareLinkDocument = /*#__PURE__*/ gql`
    query EnterpriseReportShareLink($id: UUID!) {
  enterpriseReportShareLink(id: $id) {
    disabledAt
    expiresAt
    redirectPath
    reportSnapshotId
    shareLinkId
    state
  }
}
    `;

/**
 * __useEnterpriseReportShareLinkQuery__
 *
 * To run a query within a React component, call `useEnterpriseReportShareLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseReportShareLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseReportShareLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnterpriseReportShareLinkQuery(baseOptions: Apollo.QueryHookOptions<EnterpriseReportShareLinkQuery, EnterpriseReportShareLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnterpriseReportShareLinkQuery, EnterpriseReportShareLinkQueryVariables>(EnterpriseReportShareLinkDocument, options);
      }
export function useEnterpriseReportShareLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnterpriseReportShareLinkQuery, EnterpriseReportShareLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnterpriseReportShareLinkQuery, EnterpriseReportShareLinkQueryVariables>(EnterpriseReportShareLinkDocument, options);
        }
export type EnterpriseReportShareLinkQueryHookResult = ReturnType<typeof useEnterpriseReportShareLinkQuery>;
export type EnterpriseReportShareLinkLazyQueryHookResult = ReturnType<typeof useEnterpriseReportShareLinkLazyQuery>;
export type EnterpriseReportShareLinkQueryResult = Apollo.QueryResult<EnterpriseReportShareLinkQuery, EnterpriseReportShareLinkQueryVariables>;
export function refetchEnterpriseReportShareLinkQuery(variables: EnterpriseReportShareLinkQueryVariables) {
      return { query: EnterpriseReportShareLinkDocument, variables: variables }
    }
export const EnterpriseReportsForAnalyticsAdminDocument = /*#__PURE__*/ gql`
    query EnterpriseReportsForAnalyticsAdmin($input: EnterpriseReportsInput!) {
  enterpriseReports(input: $input) {
    id
    inputConfig
    name
    organizationId
    reportSnapshots {
      configSchemaVersion
      id
      name
      reportDateTime
      status
      updatedAt
      url
    }
    siteId
    systemId
  }
}
    `;

/**
 * __useEnterpriseReportsForAnalyticsAdminQuery__
 *
 * To run a query within a React component, call `useEnterpriseReportsForAnalyticsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseReportsForAnalyticsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseReportsForAnalyticsAdminQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnterpriseReportsForAnalyticsAdminQuery(baseOptions: Apollo.QueryHookOptions<EnterpriseReportsForAnalyticsAdminQuery, EnterpriseReportsForAnalyticsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnterpriseReportsForAnalyticsAdminQuery, EnterpriseReportsForAnalyticsAdminQueryVariables>(EnterpriseReportsForAnalyticsAdminDocument, options);
      }
export function useEnterpriseReportsForAnalyticsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnterpriseReportsForAnalyticsAdminQuery, EnterpriseReportsForAnalyticsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnterpriseReportsForAnalyticsAdminQuery, EnterpriseReportsForAnalyticsAdminQueryVariables>(EnterpriseReportsForAnalyticsAdminDocument, options);
        }
export type EnterpriseReportsForAnalyticsAdminQueryHookResult = ReturnType<typeof useEnterpriseReportsForAnalyticsAdminQuery>;
export type EnterpriseReportsForAnalyticsAdminLazyQueryHookResult = ReturnType<typeof useEnterpriseReportsForAnalyticsAdminLazyQuery>;
export type EnterpriseReportsForAnalyticsAdminQueryResult = Apollo.QueryResult<EnterpriseReportsForAnalyticsAdminQuery, EnterpriseReportsForAnalyticsAdminQueryVariables>;
export function refetchEnterpriseReportsForAnalyticsAdminQuery(variables: EnterpriseReportsForAnalyticsAdminQueryVariables) {
      return { query: EnterpriseReportsForAnalyticsAdminDocument, variables: variables }
    }
export const EntryIntervalsByDateRangeDocument = /*#__PURE__*/ gql`
    query EntryIntervalsByDateRange($input: EntryIntervalDateRangeInput!) {
  entryIntervalsByDateRange(input: $input) {
    date
    id
  }
}
    `;

/**
 * __useEntryIntervalsByDateRangeQuery__
 *
 * To run a query within a React component, call `useEntryIntervalsByDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntryIntervalsByDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntryIntervalsByDateRangeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEntryIntervalsByDateRangeQuery(baseOptions: Apollo.QueryHookOptions<EntryIntervalsByDateRangeQuery, EntryIntervalsByDateRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntryIntervalsByDateRangeQuery, EntryIntervalsByDateRangeQueryVariables>(EntryIntervalsByDateRangeDocument, options);
      }
export function useEntryIntervalsByDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntryIntervalsByDateRangeQuery, EntryIntervalsByDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntryIntervalsByDateRangeQuery, EntryIntervalsByDateRangeQueryVariables>(EntryIntervalsByDateRangeDocument, options);
        }
export type EntryIntervalsByDateRangeQueryHookResult = ReturnType<typeof useEntryIntervalsByDateRangeQuery>;
export type EntryIntervalsByDateRangeLazyQueryHookResult = ReturnType<typeof useEntryIntervalsByDateRangeLazyQuery>;
export type EntryIntervalsByDateRangeQueryResult = Apollo.QueryResult<EntryIntervalsByDateRangeQuery, EntryIntervalsByDateRangeQueryVariables>;
export function refetchEntryIntervalsByDateRangeQuery(variables: EntryIntervalsByDateRangeQueryVariables) {
      return { query: EntryIntervalsByDateRangeDocument, variables: variables }
    }
export const EstimateSiteRecalculationDocument = /*#__PURE__*/ gql`
    query EstimateSiteRecalculation($input: SubmitSiteRecalculationInput!) {
  estimateSiteRecalculation(input: $input) {
    metrics {
      metricId
      metricName
      recalculationCount
    }
    totalRecalculationCount
  }
}
    `;

/**
 * __useEstimateSiteRecalculationQuery__
 *
 * To run a query within a React component, call `useEstimateSiteRecalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstimateSiteRecalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimateSiteRecalculationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEstimateSiteRecalculationQuery(baseOptions: Apollo.QueryHookOptions<EstimateSiteRecalculationQuery, EstimateSiteRecalculationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstimateSiteRecalculationQuery, EstimateSiteRecalculationQueryVariables>(EstimateSiteRecalculationDocument, options);
      }
export function useEstimateSiteRecalculationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstimateSiteRecalculationQuery, EstimateSiteRecalculationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstimateSiteRecalculationQuery, EstimateSiteRecalculationQueryVariables>(EstimateSiteRecalculationDocument, options);
        }
export type EstimateSiteRecalculationQueryHookResult = ReturnType<typeof useEstimateSiteRecalculationQuery>;
export type EstimateSiteRecalculationLazyQueryHookResult = ReturnType<typeof useEstimateSiteRecalculationLazyQuery>;
export type EstimateSiteRecalculationQueryResult = Apollo.QueryResult<EstimateSiteRecalculationQuery, EstimateSiteRecalculationQueryVariables>;
export function refetchEstimateSiteRecalculationQuery(variables: EstimateSiteRecalculationQueryVariables) {
      return { query: EstimateSiteRecalculationDocument, variables: variables }
    }
export const ExportBulkMetricEditorMetricsCsvDocument = /*#__PURE__*/ gql`
    query ExportBulkMetricEditorMetricsCsv($input: BulkMetricEditorMetricsCsvExportInput!) {
  exportBulkMetricEditorMetricsCsv(input: $input) {
    contentType
    csv
    downloadUrl
    filename
    message
    rowCount
    status
  }
}
    `;

/**
 * __useExportBulkMetricEditorMetricsCsvQuery__
 *
 * To run a query within a React component, call `useExportBulkMetricEditorMetricsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportBulkMetricEditorMetricsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportBulkMetricEditorMetricsCsvQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportBulkMetricEditorMetricsCsvQuery(baseOptions: Apollo.QueryHookOptions<ExportBulkMetricEditorMetricsCsvQuery, ExportBulkMetricEditorMetricsCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportBulkMetricEditorMetricsCsvQuery, ExportBulkMetricEditorMetricsCsvQueryVariables>(ExportBulkMetricEditorMetricsCsvDocument, options);
      }
export function useExportBulkMetricEditorMetricsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportBulkMetricEditorMetricsCsvQuery, ExportBulkMetricEditorMetricsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportBulkMetricEditorMetricsCsvQuery, ExportBulkMetricEditorMetricsCsvQueryVariables>(ExportBulkMetricEditorMetricsCsvDocument, options);
        }
export type ExportBulkMetricEditorMetricsCsvQueryHookResult = ReturnType<typeof useExportBulkMetricEditorMetricsCsvQuery>;
export type ExportBulkMetricEditorMetricsCsvLazyQueryHookResult = ReturnType<typeof useExportBulkMetricEditorMetricsCsvLazyQuery>;
export type ExportBulkMetricEditorMetricsCsvQueryResult = Apollo.QueryResult<ExportBulkMetricEditorMetricsCsvQuery, ExportBulkMetricEditorMetricsCsvQueryVariables>;
export function refetchExportBulkMetricEditorMetricsCsvQuery(variables: ExportBulkMetricEditorMetricsCsvQueryVariables) {
      return { query: ExportBulkMetricEditorMetricsCsvDocument, variables: variables }
    }
export const ExportLogBookEntriesCsvDocument = /*#__PURE__*/ gql`
    query ExportLogBookEntriesCsv($input: LogBookEntriesInput!) {
  exportLogBookEntriesCsv(input: $input)
}
    `;

/**
 * __useExportLogBookEntriesCsvQuery__
 *
 * To run a query within a React component, call `useExportLogBookEntriesCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportLogBookEntriesCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportLogBookEntriesCsvQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportLogBookEntriesCsvQuery(baseOptions: Apollo.QueryHookOptions<ExportLogBookEntriesCsvQuery, ExportLogBookEntriesCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportLogBookEntriesCsvQuery, ExportLogBookEntriesCsvQueryVariables>(ExportLogBookEntriesCsvDocument, options);
      }
export function useExportLogBookEntriesCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportLogBookEntriesCsvQuery, ExportLogBookEntriesCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportLogBookEntriesCsvQuery, ExportLogBookEntriesCsvQueryVariables>(ExportLogBookEntriesCsvDocument, options);
        }
export type ExportLogBookEntriesCsvQueryHookResult = ReturnType<typeof useExportLogBookEntriesCsvQuery>;
export type ExportLogBookEntriesCsvLazyQueryHookResult = ReturnType<typeof useExportLogBookEntriesCsvLazyQuery>;
export type ExportLogBookEntriesCsvQueryResult = Apollo.QueryResult<ExportLogBookEntriesCsvQuery, ExportLogBookEntriesCsvQueryVariables>;
export function refetchExportLogBookEntriesCsvQuery(variables: ExportLogBookEntriesCsvQueryVariables) {
      return { query: ExportLogBookEntriesCsvDocument, variables: variables }
    }
export const ExportUserManagerUsersCsvDocument = /*#__PURE__*/ gql`
    query ExportUserManagerUsersCsv($input: UserManagerUsersCsvExportInput) {
  exportUserManagerUsersCsv(input: $input)
}
    `;

/**
 * __useExportUserManagerUsersCsvQuery__
 *
 * To run a query within a React component, call `useExportUserManagerUsersCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportUserManagerUsersCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportUserManagerUsersCsvQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportUserManagerUsersCsvQuery(baseOptions?: Apollo.QueryHookOptions<ExportUserManagerUsersCsvQuery, ExportUserManagerUsersCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportUserManagerUsersCsvQuery, ExportUserManagerUsersCsvQueryVariables>(ExportUserManagerUsersCsvDocument, options);
      }
export function useExportUserManagerUsersCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportUserManagerUsersCsvQuery, ExportUserManagerUsersCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportUserManagerUsersCsvQuery, ExportUserManagerUsersCsvQueryVariables>(ExportUserManagerUsersCsvDocument, options);
        }
export type ExportUserManagerUsersCsvQueryHookResult = ReturnType<typeof useExportUserManagerUsersCsvQuery>;
export type ExportUserManagerUsersCsvLazyQueryHookResult = ReturnType<typeof useExportUserManagerUsersCsvLazyQuery>;
export type ExportUserManagerUsersCsvQueryResult = Apollo.QueryResult<ExportUserManagerUsersCsvQuery, ExportUserManagerUsersCsvQueryVariables>;
export function refetchExportUserManagerUsersCsvQuery(variables?: ExportUserManagerUsersCsvQueryVariables) {
      return { query: ExportUserManagerUsersCsvDocument, variables: variables }
    }
export const ExternalFacilitiesDocument = /*#__PURE__*/ gql`
    query ExternalFacilities($input: ExternalFacilitiesInput!) {
  externalFacilities(input: $input) {
    ...ExternalFacility
  }
}
    ${ExternalFacilityFragmentDoc}`;

/**
 * __useExternalFacilitiesQuery__
 *
 * To run a query within a React component, call `useExternalFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalFacilitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<ExternalFacilitiesQuery, ExternalFacilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalFacilitiesQuery, ExternalFacilitiesQueryVariables>(ExternalFacilitiesDocument, options);
      }
export function useExternalFacilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalFacilitiesQuery, ExternalFacilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalFacilitiesQuery, ExternalFacilitiesQueryVariables>(ExternalFacilitiesDocument, options);
        }
export type ExternalFacilitiesQueryHookResult = ReturnType<typeof useExternalFacilitiesQuery>;
export type ExternalFacilitiesLazyQueryHookResult = ReturnType<typeof useExternalFacilitiesLazyQuery>;
export type ExternalFacilitiesQueryResult = Apollo.QueryResult<ExternalFacilitiesQuery, ExternalFacilitiesQueryVariables>;
export function refetchExternalFacilitiesQuery(variables: ExternalFacilitiesQueryVariables) {
      return { query: ExternalFacilitiesDocument, variables: variables }
    }
export const ExternalSystemsDocument = /*#__PURE__*/ gql`
    query ExternalSystems($input: ExternalSystemsInput!) {
  externalSystems(input: $input) {
    ...ExternalSystem
  }
}
    ${ExternalSystemFragmentDoc}`;

/**
 * __useExternalSystemsQuery__
 *
 * To run a query within a React component, call `useExternalSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalSystemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalSystemsQuery(baseOptions: Apollo.QueryHookOptions<ExternalSystemsQuery, ExternalSystemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalSystemsQuery, ExternalSystemsQueryVariables>(ExternalSystemsDocument, options);
      }
export function useExternalSystemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalSystemsQuery, ExternalSystemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalSystemsQuery, ExternalSystemsQueryVariables>(ExternalSystemsDocument, options);
        }
export type ExternalSystemsQueryHookResult = ReturnType<typeof useExternalSystemsQuery>;
export type ExternalSystemsLazyQueryHookResult = ReturnType<typeof useExternalSystemsLazyQuery>;
export type ExternalSystemsQueryResult = Apollo.QueryResult<ExternalSystemsQuery, ExternalSystemsQueryVariables>;
export function refetchExternalSystemsQuery(variables: ExternalSystemsQueryVariables) {
      return { query: ExternalSystemsDocument, variables: variables }
    }
export const FindEdgeDeviceSubmissionsDocument = /*#__PURE__*/ gql`
    query FindEdgeDeviceSubmissions($input: EdgeDeviceSubmissionFindRecentForDeviceIdInput!) {
  findEdgeDeviceSubmissions(input: $input) {
    count
    items {
      ...EdgeDeviceSubmissionSummary
    }
  }
}
    ${EdgeDeviceSubmissionSummaryFragmentDoc}`;

/**
 * __useFindEdgeDeviceSubmissionsQuery__
 *
 * To run a query within a React component, call `useFindEdgeDeviceSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindEdgeDeviceSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindEdgeDeviceSubmissionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindEdgeDeviceSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<FindEdgeDeviceSubmissionsQuery, FindEdgeDeviceSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindEdgeDeviceSubmissionsQuery, FindEdgeDeviceSubmissionsQueryVariables>(FindEdgeDeviceSubmissionsDocument, options);
      }
export function useFindEdgeDeviceSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindEdgeDeviceSubmissionsQuery, FindEdgeDeviceSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindEdgeDeviceSubmissionsQuery, FindEdgeDeviceSubmissionsQueryVariables>(FindEdgeDeviceSubmissionsDocument, options);
        }
export type FindEdgeDeviceSubmissionsQueryHookResult = ReturnType<typeof useFindEdgeDeviceSubmissionsQuery>;
export type FindEdgeDeviceSubmissionsLazyQueryHookResult = ReturnType<typeof useFindEdgeDeviceSubmissionsLazyQuery>;
export type FindEdgeDeviceSubmissionsQueryResult = Apollo.QueryResult<FindEdgeDeviceSubmissionsQuery, FindEdgeDeviceSubmissionsQueryVariables>;
export function refetchFindEdgeDeviceSubmissionsQuery(variables: FindEdgeDeviceSubmissionsQueryVariables) {
      return { query: FindEdgeDeviceSubmissionsDocument, variables: variables }
    }
export const FindRecentEdgeDeviceSubmissionsDocument = /*#__PURE__*/ gql`
    query FindRecentEdgeDeviceSubmissions($input: EdgeDeviceSubmissionFindRecentForDeviceIdInput!) {
  findRecentEdgeDeviceSubmissions(input: $input) {
    ...EdgeDeviceSubmissionSummary
  }
}
    ${EdgeDeviceSubmissionSummaryFragmentDoc}`;

/**
 * __useFindRecentEdgeDeviceSubmissionsQuery__
 *
 * To run a query within a React component, call `useFindRecentEdgeDeviceSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRecentEdgeDeviceSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRecentEdgeDeviceSubmissionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindRecentEdgeDeviceSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<FindRecentEdgeDeviceSubmissionsQuery, FindRecentEdgeDeviceSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindRecentEdgeDeviceSubmissionsQuery, FindRecentEdgeDeviceSubmissionsQueryVariables>(FindRecentEdgeDeviceSubmissionsDocument, options);
      }
export function useFindRecentEdgeDeviceSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindRecentEdgeDeviceSubmissionsQuery, FindRecentEdgeDeviceSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindRecentEdgeDeviceSubmissionsQuery, FindRecentEdgeDeviceSubmissionsQueryVariables>(FindRecentEdgeDeviceSubmissionsDocument, options);
        }
export type FindRecentEdgeDeviceSubmissionsQueryHookResult = ReturnType<typeof useFindRecentEdgeDeviceSubmissionsQuery>;
export type FindRecentEdgeDeviceSubmissionsLazyQueryHookResult = ReturnType<typeof useFindRecentEdgeDeviceSubmissionsLazyQuery>;
export type FindRecentEdgeDeviceSubmissionsQueryResult = Apollo.QueryResult<FindRecentEdgeDeviceSubmissionsQuery, FindRecentEdgeDeviceSubmissionsQueryVariables>;
export function refetchFindRecentEdgeDeviceSubmissionsQuery(variables: FindRecentEdgeDeviceSubmissionsQueryVariables) {
      return { query: FindRecentEdgeDeviceSubmissionsDocument, variables: variables }
    }
export const FindUploadByIdDocument = /*#__PURE__*/ gql`
    query FindUploadById($id: String!) {
  findUploadById(id: $id) {
    ...Uploads
  }
}
    ${UploadsFragmentDoc}`;

/**
 * __useFindUploadByIdQuery__
 *
 * To run a query within a React component, call `useFindUploadByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUploadByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUploadByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindUploadByIdQuery(baseOptions: Apollo.QueryHookOptions<FindUploadByIdQuery, FindUploadByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUploadByIdQuery, FindUploadByIdQueryVariables>(FindUploadByIdDocument, options);
      }
export function useFindUploadByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUploadByIdQuery, FindUploadByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUploadByIdQuery, FindUploadByIdQueryVariables>(FindUploadByIdDocument, options);
        }
export type FindUploadByIdQueryHookResult = ReturnType<typeof useFindUploadByIdQuery>;
export type FindUploadByIdLazyQueryHookResult = ReturnType<typeof useFindUploadByIdLazyQuery>;
export type FindUploadByIdQueryResult = Apollo.QueryResult<FindUploadByIdQuery, FindUploadByIdQueryVariables>;
export function refetchFindUploadByIdQuery(variables: FindUploadByIdQueryVariables) {
      return { query: FindUploadByIdDocument, variables: variables }
    }
export const FlexSitesAssociatedWithMetricIdDocument = /*#__PURE__*/ gql`
    query FlexSitesAssociatedWithMetricId($input: FlexSitesAssociatedWithMetricId!) {
  flexSitesAssociatedWithMetricId(input: $input) {
    ...SiteNest
  }
}
    ${SiteNestFragmentDoc}`;

/**
 * __useFlexSitesAssociatedWithMetricIdQuery__
 *
 * To run a query within a React component, call `useFlexSitesAssociatedWithMetricIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlexSitesAssociatedWithMetricIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlexSitesAssociatedWithMetricIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFlexSitesAssociatedWithMetricIdQuery(baseOptions: Apollo.QueryHookOptions<FlexSitesAssociatedWithMetricIdQuery, FlexSitesAssociatedWithMetricIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlexSitesAssociatedWithMetricIdQuery, FlexSitesAssociatedWithMetricIdQueryVariables>(FlexSitesAssociatedWithMetricIdDocument, options);
      }
export function useFlexSitesAssociatedWithMetricIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlexSitesAssociatedWithMetricIdQuery, FlexSitesAssociatedWithMetricIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlexSitesAssociatedWithMetricIdQuery, FlexSitesAssociatedWithMetricIdQueryVariables>(FlexSitesAssociatedWithMetricIdDocument, options);
        }
export type FlexSitesAssociatedWithMetricIdQueryHookResult = ReturnType<typeof useFlexSitesAssociatedWithMetricIdQuery>;
export type FlexSitesAssociatedWithMetricIdLazyQueryHookResult = ReturnType<typeof useFlexSitesAssociatedWithMetricIdLazyQuery>;
export type FlexSitesAssociatedWithMetricIdQueryResult = Apollo.QueryResult<FlexSitesAssociatedWithMetricIdQuery, FlexSitesAssociatedWithMetricIdQueryVariables>;
export function refetchFlexSitesAssociatedWithMetricIdQuery(variables: FlexSitesAssociatedWithMetricIdQueryVariables) {
      return { query: FlexSitesAssociatedWithMetricIdDocument, variables: variables }
    }
export const GenerateUploadParametersDocument = /*#__PURE__*/ gql`
    query GenerateUploadParameters($fileName: String!, $mimeType: MimeType!, $organizationId: Int) {
  generateUploadParameters(
    fileName: $fileName
    mimeType: $mimeType
    organizationId: $organizationId
  ) {
    blobId
    downloadUrl
    fileName
    mimeType
    uploadHeadersJSON
    uploadToken
    uploadUrl
  }
}
    `;

/**
 * __useGenerateUploadParametersQuery__
 *
 * To run a query within a React component, call `useGenerateUploadParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateUploadParametersQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      mimeType: // value for 'mimeType'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGenerateUploadParametersQuery(baseOptions: Apollo.QueryHookOptions<GenerateUploadParametersQuery, GenerateUploadParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateUploadParametersQuery, GenerateUploadParametersQueryVariables>(GenerateUploadParametersDocument, options);
      }
export function useGenerateUploadParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateUploadParametersQuery, GenerateUploadParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateUploadParametersQuery, GenerateUploadParametersQueryVariables>(GenerateUploadParametersDocument, options);
        }
export type GenerateUploadParametersQueryHookResult = ReturnType<typeof useGenerateUploadParametersQuery>;
export type GenerateUploadParametersLazyQueryHookResult = ReturnType<typeof useGenerateUploadParametersLazyQuery>;
export type GenerateUploadParametersQueryResult = Apollo.QueryResult<GenerateUploadParametersQuery, GenerateUploadParametersQueryVariables>;
export function refetchGenerateUploadParametersQuery(variables: GenerateUploadParametersQueryVariables) {
      return { query: GenerateUploadParametersDocument, variables: variables }
    }
export const GetAdminStatsDocument = /*#__PURE__*/ gql`
    query GetAdminStats {
  adminStats {
    numberOfMetrics
    numberOfSites
    numberOfStates
    numberOfSystems
    numberOfUsers
  }
}
    `;

/**
 * __useGetAdminStatsQuery__
 *
 * To run a query within a React component, call `useGetAdminStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminStatsQuery, GetAdminStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminStatsQuery, GetAdminStatsQueryVariables>(GetAdminStatsDocument, options);
      }
export function useGetAdminStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminStatsQuery, GetAdminStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminStatsQuery, GetAdminStatsQueryVariables>(GetAdminStatsDocument, options);
        }
export type GetAdminStatsQueryHookResult = ReturnType<typeof useGetAdminStatsQuery>;
export type GetAdminStatsLazyQueryHookResult = ReturnType<typeof useGetAdminStatsLazyQuery>;
export type GetAdminStatsQueryResult = Apollo.QueryResult<GetAdminStatsQuery, GetAdminStatsQueryVariables>;
export function refetchGetAdminStatsQuery(variables?: GetAdminStatsQueryVariables) {
      return { query: GetAdminStatsDocument, variables: variables }
    }
export const GetAllEdgeDevicesDocument = /*#__PURE__*/ gql`
    query GetAllEdgeDevices {
  allEdgeDevices {
    ...EdgeDevice
  }
}
    ${EdgeDeviceFragmentDoc}`;

/**
 * __useGetAllEdgeDevicesQuery__
 *
 * To run a query within a React component, call `useGetAllEdgeDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEdgeDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEdgeDevicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEdgeDevicesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEdgeDevicesQuery, GetAllEdgeDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEdgeDevicesQuery, GetAllEdgeDevicesQueryVariables>(GetAllEdgeDevicesDocument, options);
      }
export function useGetAllEdgeDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEdgeDevicesQuery, GetAllEdgeDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEdgeDevicesQuery, GetAllEdgeDevicesQueryVariables>(GetAllEdgeDevicesDocument, options);
        }
export type GetAllEdgeDevicesQueryHookResult = ReturnType<typeof useGetAllEdgeDevicesQuery>;
export type GetAllEdgeDevicesLazyQueryHookResult = ReturnType<typeof useGetAllEdgeDevicesLazyQuery>;
export type GetAllEdgeDevicesQueryResult = Apollo.QueryResult<GetAllEdgeDevicesQuery, GetAllEdgeDevicesQueryVariables>;
export function refetchGetAllEdgeDevicesQuery(variables?: GetAllEdgeDevicesQueryVariables) {
      return { query: GetAllEdgeDevicesDocument, variables: variables }
    }
export const GetAllEdgeDevicesV2Document = /*#__PURE__*/ gql`
    query GetAllEdgeDevicesV2 {
  edgeDevicesV2 {
    ...EdgeDeviceV2
  }
}
    ${EdgeDeviceV2FragmentDoc}`;

/**
 * __useGetAllEdgeDevicesV2Query__
 *
 * To run a query within a React component, call `useGetAllEdgeDevicesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEdgeDevicesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEdgeDevicesV2Query({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEdgeDevicesV2Query(baseOptions?: Apollo.QueryHookOptions<GetAllEdgeDevicesV2Query, GetAllEdgeDevicesV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEdgeDevicesV2Query, GetAllEdgeDevicesV2QueryVariables>(GetAllEdgeDevicesV2Document, options);
      }
export function useGetAllEdgeDevicesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEdgeDevicesV2Query, GetAllEdgeDevicesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEdgeDevicesV2Query, GetAllEdgeDevicesV2QueryVariables>(GetAllEdgeDevicesV2Document, options);
        }
export type GetAllEdgeDevicesV2QueryHookResult = ReturnType<typeof useGetAllEdgeDevicesV2Query>;
export type GetAllEdgeDevicesV2LazyQueryHookResult = ReturnType<typeof useGetAllEdgeDevicesV2LazyQuery>;
export type GetAllEdgeDevicesV2QueryResult = Apollo.QueryResult<GetAllEdgeDevicesV2Query, GetAllEdgeDevicesV2QueryVariables>;
export function refetchGetAllEdgeDevicesV2Query(variables?: GetAllEdgeDevicesV2QueryVariables) {
      return { query: GetAllEdgeDevicesV2Document, variables: variables }
    }
export const GetAllSitesDocument = /*#__PURE__*/ gql`
    query GetAllSites($input: SitesInput) {
  allSites(input: $input) {
    displayNameBreadcrumbs {
      key
      value
    }
    ...SiteNest
  }
}
    ${SiteNestFragmentDoc}`;

/**
 * __useGetAllSitesQuery__
 *
 * To run a query within a React component, call `useGetAllSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSitesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllSitesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSitesQuery, GetAllSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSitesQuery, GetAllSitesQueryVariables>(GetAllSitesDocument, options);
      }
export function useGetAllSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSitesQuery, GetAllSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSitesQuery, GetAllSitesQueryVariables>(GetAllSitesDocument, options);
        }
export type GetAllSitesQueryHookResult = ReturnType<typeof useGetAllSitesQuery>;
export type GetAllSitesLazyQueryHookResult = ReturnType<typeof useGetAllSitesLazyQuery>;
export type GetAllSitesQueryResult = Apollo.QueryResult<GetAllSitesQuery, GetAllSitesQueryVariables>;
export function refetchGetAllSitesQuery(variables?: GetAllSitesQueryVariables) {
      return { query: GetAllSitesDocument, variables: variables }
    }
export const GetCalcTreeDocument = /*#__PURE__*/ gql`
    query GetCalcTree($input: GetCalcTreeInput!) {
  getCalcTree(input: $input) {
    dot
    id
  }
}
    `;

/**
 * __useGetCalcTreeQuery__
 *
 * To run a query within a React component, call `useGetCalcTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalcTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalcTreeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCalcTreeQuery(baseOptions: Apollo.QueryHookOptions<GetCalcTreeQuery, GetCalcTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalcTreeQuery, GetCalcTreeQueryVariables>(GetCalcTreeDocument, options);
      }
export function useGetCalcTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalcTreeQuery, GetCalcTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalcTreeQuery, GetCalcTreeQueryVariables>(GetCalcTreeDocument, options);
        }
export type GetCalcTreeQueryHookResult = ReturnType<typeof useGetCalcTreeQuery>;
export type GetCalcTreeLazyQueryHookResult = ReturnType<typeof useGetCalcTreeLazyQuery>;
export type GetCalcTreeQueryResult = Apollo.QueryResult<GetCalcTreeQuery, GetCalcTreeQueryVariables>;
export function refetchGetCalcTreeQuery(variables: GetCalcTreeQueryVariables) {
      return { query: GetCalcTreeDocument, variables: variables }
    }
export const GetCalcTreesWithCyclesDocument = /*#__PURE__*/ gql`
    query GetCalcTreesWithCycles {
  getCalcTreesWithCycles
}
    `;

/**
 * __useGetCalcTreesWithCyclesQuery__
 *
 * To run a query within a React component, call `useGetCalcTreesWithCyclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalcTreesWithCyclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalcTreesWithCyclesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCalcTreesWithCyclesQuery(baseOptions?: Apollo.QueryHookOptions<GetCalcTreesWithCyclesQuery, GetCalcTreesWithCyclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalcTreesWithCyclesQuery, GetCalcTreesWithCyclesQueryVariables>(GetCalcTreesWithCyclesDocument, options);
      }
export function useGetCalcTreesWithCyclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalcTreesWithCyclesQuery, GetCalcTreesWithCyclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalcTreesWithCyclesQuery, GetCalcTreesWithCyclesQueryVariables>(GetCalcTreesWithCyclesDocument, options);
        }
export type GetCalcTreesWithCyclesQueryHookResult = ReturnType<typeof useGetCalcTreesWithCyclesQuery>;
export type GetCalcTreesWithCyclesLazyQueryHookResult = ReturnType<typeof useGetCalcTreesWithCyclesLazyQuery>;
export type GetCalcTreesWithCyclesQueryResult = Apollo.QueryResult<GetCalcTreesWithCyclesQuery, GetCalcTreesWithCyclesQueryVariables>;
export function refetchGetCalcTreesWithCyclesQuery(variables?: GetCalcTreesWithCyclesQueryVariables) {
      return { query: GetCalcTreesWithCyclesDocument, variables: variables }
    }
export const GetEdgeDeviceSubmissionDataDocument = /*#__PURE__*/ gql`
    query GetEdgeDeviceSubmissionData($submissionId: Int!) {
  getEdgeDeviceSubmissionData(submissionId: $submissionId)
}
    `;

/**
 * __useGetEdgeDeviceSubmissionDataQuery__
 *
 * To run a query within a React component, call `useGetEdgeDeviceSubmissionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEdgeDeviceSubmissionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEdgeDeviceSubmissionDataQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useGetEdgeDeviceSubmissionDataQuery(baseOptions: Apollo.QueryHookOptions<GetEdgeDeviceSubmissionDataQuery, GetEdgeDeviceSubmissionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEdgeDeviceSubmissionDataQuery, GetEdgeDeviceSubmissionDataQueryVariables>(GetEdgeDeviceSubmissionDataDocument, options);
      }
export function useGetEdgeDeviceSubmissionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEdgeDeviceSubmissionDataQuery, GetEdgeDeviceSubmissionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEdgeDeviceSubmissionDataQuery, GetEdgeDeviceSubmissionDataQueryVariables>(GetEdgeDeviceSubmissionDataDocument, options);
        }
export type GetEdgeDeviceSubmissionDataQueryHookResult = ReturnType<typeof useGetEdgeDeviceSubmissionDataQuery>;
export type GetEdgeDeviceSubmissionDataLazyQueryHookResult = ReturnType<typeof useGetEdgeDeviceSubmissionDataLazyQuery>;
export type GetEdgeDeviceSubmissionDataQueryResult = Apollo.QueryResult<GetEdgeDeviceSubmissionDataQuery, GetEdgeDeviceSubmissionDataQueryVariables>;
export function refetchGetEdgeDeviceSubmissionDataQuery(variables: GetEdgeDeviceSubmissionDataQueryVariables) {
      return { query: GetEdgeDeviceSubmissionDataDocument, variables: variables }
    }
export const GetEdgeDeviceTokenDocument = /*#__PURE__*/ gql`
    query GetEdgeDeviceToken($edgeDeviceId: Int!) {
  edgeDeviceToken(edgeDeviceId: $edgeDeviceId)
}
    `;

/**
 * __useGetEdgeDeviceTokenQuery__
 *
 * To run a query within a React component, call `useGetEdgeDeviceTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEdgeDeviceTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEdgeDeviceTokenQuery({
 *   variables: {
 *      edgeDeviceId: // value for 'edgeDeviceId'
 *   },
 * });
 */
export function useGetEdgeDeviceTokenQuery(baseOptions: Apollo.QueryHookOptions<GetEdgeDeviceTokenQuery, GetEdgeDeviceTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEdgeDeviceTokenQuery, GetEdgeDeviceTokenQueryVariables>(GetEdgeDeviceTokenDocument, options);
      }
export function useGetEdgeDeviceTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEdgeDeviceTokenQuery, GetEdgeDeviceTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEdgeDeviceTokenQuery, GetEdgeDeviceTokenQueryVariables>(GetEdgeDeviceTokenDocument, options);
        }
export type GetEdgeDeviceTokenQueryHookResult = ReturnType<typeof useGetEdgeDeviceTokenQuery>;
export type GetEdgeDeviceTokenLazyQueryHookResult = ReturnType<typeof useGetEdgeDeviceTokenLazyQuery>;
export type GetEdgeDeviceTokenQueryResult = Apollo.QueryResult<GetEdgeDeviceTokenQuery, GetEdgeDeviceTokenQueryVariables>;
export function refetchGetEdgeDeviceTokenQuery(variables: GetEdgeDeviceTokenQueryVariables) {
      return { query: GetEdgeDeviceTokenDocument, variables: variables }
    }
export const GetEdgeDeviceV2Document = /*#__PURE__*/ gql`
    query GetEdgeDeviceV2($edgeDeviceId: Int!) {
  getEdgeDeviceV2(edgeDeviceId: $edgeDeviceId) {
    ...EdgeDeviceV2
  }
}
    ${EdgeDeviceV2FragmentDoc}`;

/**
 * __useGetEdgeDeviceV2Query__
 *
 * To run a query within a React component, call `useGetEdgeDeviceV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetEdgeDeviceV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEdgeDeviceV2Query({
 *   variables: {
 *      edgeDeviceId: // value for 'edgeDeviceId'
 *   },
 * });
 */
export function useGetEdgeDeviceV2Query(baseOptions: Apollo.QueryHookOptions<GetEdgeDeviceV2Query, GetEdgeDeviceV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEdgeDeviceV2Query, GetEdgeDeviceV2QueryVariables>(GetEdgeDeviceV2Document, options);
      }
export function useGetEdgeDeviceV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEdgeDeviceV2Query, GetEdgeDeviceV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEdgeDeviceV2Query, GetEdgeDeviceV2QueryVariables>(GetEdgeDeviceV2Document, options);
        }
export type GetEdgeDeviceV2QueryHookResult = ReturnType<typeof useGetEdgeDeviceV2Query>;
export type GetEdgeDeviceV2LazyQueryHookResult = ReturnType<typeof useGetEdgeDeviceV2LazyQuery>;
export type GetEdgeDeviceV2QueryResult = Apollo.QueryResult<GetEdgeDeviceV2Query, GetEdgeDeviceV2QueryVariables>;
export function refetchGetEdgeDeviceV2Query(variables: GetEdgeDeviceV2QueryVariables) {
      return { query: GetEdgeDeviceV2Document, variables: variables }
    }
export const GetEdgeDevicesByOrganizationIdDocument = /*#__PURE__*/ gql`
    query GetEdgeDevicesByOrganizationId($organizationId: Int!) {
  edgeDevicesByOrganizationId(organizationId: $organizationId) {
    deviceName
    id
  }
}
    `;

/**
 * __useGetEdgeDevicesByOrganizationIdQuery__
 *
 * To run a query within a React component, call `useGetEdgeDevicesByOrganizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEdgeDevicesByOrganizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEdgeDevicesByOrganizationIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetEdgeDevicesByOrganizationIdQuery(baseOptions: Apollo.QueryHookOptions<GetEdgeDevicesByOrganizationIdQuery, GetEdgeDevicesByOrganizationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEdgeDevicesByOrganizationIdQuery, GetEdgeDevicesByOrganizationIdQueryVariables>(GetEdgeDevicesByOrganizationIdDocument, options);
      }
export function useGetEdgeDevicesByOrganizationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEdgeDevicesByOrganizationIdQuery, GetEdgeDevicesByOrganizationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEdgeDevicesByOrganizationIdQuery, GetEdgeDevicesByOrganizationIdQueryVariables>(GetEdgeDevicesByOrganizationIdDocument, options);
        }
export type GetEdgeDevicesByOrganizationIdQueryHookResult = ReturnType<typeof useGetEdgeDevicesByOrganizationIdQuery>;
export type GetEdgeDevicesByOrganizationIdLazyQueryHookResult = ReturnType<typeof useGetEdgeDevicesByOrganizationIdLazyQuery>;
export type GetEdgeDevicesByOrganizationIdQueryResult = Apollo.QueryResult<GetEdgeDevicesByOrganizationIdQuery, GetEdgeDevicesByOrganizationIdQueryVariables>;
export function refetchGetEdgeDevicesByOrganizationIdQuery(variables: GetEdgeDevicesByOrganizationIdQueryVariables) {
      return { query: GetEdgeDevicesByOrganizationIdDocument, variables: variables }
    }
export const GetEntrySparklineDataDocument = /*#__PURE__*/ gql`
    query GetEntrySparklineData($input: EntrySparklineDataInput!) {
  entrySparklineData(input: $input) {
    dataPoints {
      appliedAt
      dataPoint {
        ...EntryTsDataPoint
      }
      id
      intervalId
      time
    }
    id
    metricId
    metricType
  }
}
    ${EntryTsDataPointFragmentDoc}`;

/**
 * __useGetEntrySparklineDataQuery__
 *
 * To run a query within a React component, call `useGetEntrySparklineDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntrySparklineDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntrySparklineDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEntrySparklineDataQuery(baseOptions: Apollo.QueryHookOptions<GetEntrySparklineDataQuery, GetEntrySparklineDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntrySparklineDataQuery, GetEntrySparklineDataQueryVariables>(GetEntrySparklineDataDocument, options);
      }
export function useGetEntrySparklineDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntrySparklineDataQuery, GetEntrySparklineDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntrySparklineDataQuery, GetEntrySparklineDataQueryVariables>(GetEntrySparklineDataDocument, options);
        }
export type GetEntrySparklineDataQueryHookResult = ReturnType<typeof useGetEntrySparklineDataQuery>;
export type GetEntrySparklineDataLazyQueryHookResult = ReturnType<typeof useGetEntrySparklineDataLazyQuery>;
export type GetEntrySparklineDataQueryResult = Apollo.QueryResult<GetEntrySparklineDataQuery, GetEntrySparklineDataQueryVariables>;
export function refetchGetEntrySparklineDataQuery(variables: GetEntrySparklineDataQueryVariables) {
      return { query: GetEntrySparklineDataDocument, variables: variables }
    }
export const GetFindUserByTokenDocument = /*#__PURE__*/ gql`
    query GetFindUserByToken($userToken: String!) {
  findUserByToken(userToken: $userToken) {
    displayName @client
    email
    externalId
    externalOwner
    firstName
    id
    idpKey
    lastName
    pending
    subject
    superadmin
  }
}
    `;

/**
 * __useGetFindUserByTokenQuery__
 *
 * To run a query within a React component, call `useGetFindUserByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFindUserByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFindUserByTokenQuery({
 *   variables: {
 *      userToken: // value for 'userToken'
 *   },
 * });
 */
export function useGetFindUserByTokenQuery(baseOptions: Apollo.QueryHookOptions<GetFindUserByTokenQuery, GetFindUserByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFindUserByTokenQuery, GetFindUserByTokenQueryVariables>(GetFindUserByTokenDocument, options);
      }
export function useGetFindUserByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFindUserByTokenQuery, GetFindUserByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFindUserByTokenQuery, GetFindUserByTokenQueryVariables>(GetFindUserByTokenDocument, options);
        }
export type GetFindUserByTokenQueryHookResult = ReturnType<typeof useGetFindUserByTokenQuery>;
export type GetFindUserByTokenLazyQueryHookResult = ReturnType<typeof useGetFindUserByTokenLazyQuery>;
export type GetFindUserByTokenQueryResult = Apollo.QueryResult<GetFindUserByTokenQuery, GetFindUserByTokenQueryVariables>;
export function refetchGetFindUserByTokenQuery(variables: GetFindUserByTokenQueryVariables) {
      return { query: GetFindUserByTokenDocument, variables: variables }
    }
export const GetMeDocument = /*#__PURE__*/ gql`
    query GetMe {
  me {
    permissions {
      ...UserOrganizationPermission
    }
    primaryOrganization {
      id
      name
    }
    primaryOrganizationDateFormat
    ...User
  }
}
    ${UserOrganizationPermissionFragmentDoc}
${UserFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export function refetchGetMeQuery(variables?: GetMeQueryVariables) {
      return { query: GetMeDocument, variables: variables }
    }
export const GetMetricDocument = /*#__PURE__*/ gql`
    query GetMetric($metricId: Int!, $withIntervals: Boolean = false) {
  metric(metricId: $metricId) {
    hasIntervals @client @include(if: $withIntervals)
    intervals @include(if: $withIntervals) {
      ...Interval
    }
    ...Metric
  }
}
    ${IntervalFragmentDoc}
${MetricFragmentDoc}`;

/**
 * __useGetMetricQuery__
 *
 * To run a query within a React component, call `useGetMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricQuery({
 *   variables: {
 *      metricId: // value for 'metricId'
 *      withIntervals: // value for 'withIntervals'
 *   },
 * });
 */
export function useGetMetricQuery(baseOptions: Apollo.QueryHookOptions<GetMetricQuery, GetMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricQuery, GetMetricQueryVariables>(GetMetricDocument, options);
      }
export function useGetMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricQuery, GetMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricQuery, GetMetricQueryVariables>(GetMetricDocument, options);
        }
export type GetMetricQueryHookResult = ReturnType<typeof useGetMetricQuery>;
export type GetMetricLazyQueryHookResult = ReturnType<typeof useGetMetricLazyQuery>;
export type GetMetricQueryResult = Apollo.QueryResult<GetMetricQuery, GetMetricQueryVariables>;
export function refetchGetMetricQuery(variables: GetMetricQueryVariables) {
      return { query: GetMetricDocument, variables: variables }
    }
export const GetMetricCalcClusterDocument = /*#__PURE__*/ gql`
    query GetMetricCalcCluster($metricId: Int!) {
  metricById(metricId: $metricId) {
    calcClusterId(includeCalcClusterId: true)
    id
  }
}
    `;

/**
 * __useGetMetricCalcClusterQuery__
 *
 * To run a query within a React component, call `useGetMetricCalcClusterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricCalcClusterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricCalcClusterQuery({
 *   variables: {
 *      metricId: // value for 'metricId'
 *   },
 * });
 */
export function useGetMetricCalcClusterQuery(baseOptions: Apollo.QueryHookOptions<GetMetricCalcClusterQuery, GetMetricCalcClusterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricCalcClusterQuery, GetMetricCalcClusterQueryVariables>(GetMetricCalcClusterDocument, options);
      }
export function useGetMetricCalcClusterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricCalcClusterQuery, GetMetricCalcClusterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricCalcClusterQuery, GetMetricCalcClusterQueryVariables>(GetMetricCalcClusterDocument, options);
        }
export type GetMetricCalcClusterQueryHookResult = ReturnType<typeof useGetMetricCalcClusterQuery>;
export type GetMetricCalcClusterLazyQueryHookResult = ReturnType<typeof useGetMetricCalcClusterLazyQuery>;
export type GetMetricCalcClusterQueryResult = Apollo.QueryResult<GetMetricCalcClusterQuery, GetMetricCalcClusterQueryVariables>;
export function refetchGetMetricCalcClusterQuery(variables: GetMetricCalcClusterQueryVariables) {
      return { query: GetMetricCalcClusterDocument, variables: variables }
    }
export const GetMetricChartDataDocument = /*#__PURE__*/ gql`
    query GetMetricChartData($endDate: DateType!, $metricIds: [Int!]!, $startDate: DateType!, $systemId: Int!) {
  metricChartData(
    endDate: $endDate
    metricIds: $metricIds
    startDate: $startDate
    systemId: $systemId
  ) {
    data {
      dataPoints {
        effectiveValue
        reportDate
        value
      }
      metricId
    }
    endDate
    startDate
  }
}
    `;

/**
 * __useGetMetricChartDataQuery__
 *
 * To run a query within a React component, call `useGetMetricChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricChartDataQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      metricIds: // value for 'metricIds'
 *      startDate: // value for 'startDate'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetMetricChartDataQuery(baseOptions: Apollo.QueryHookOptions<GetMetricChartDataQuery, GetMetricChartDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricChartDataQuery, GetMetricChartDataQueryVariables>(GetMetricChartDataDocument, options);
      }
export function useGetMetricChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricChartDataQuery, GetMetricChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricChartDataQuery, GetMetricChartDataQueryVariables>(GetMetricChartDataDocument, options);
        }
export type GetMetricChartDataQueryHookResult = ReturnType<typeof useGetMetricChartDataQuery>;
export type GetMetricChartDataLazyQueryHookResult = ReturnType<typeof useGetMetricChartDataLazyQuery>;
export type GetMetricChartDataQueryResult = Apollo.QueryResult<GetMetricChartDataQuery, GetMetricChartDataQueryVariables>;
export function refetchGetMetricChartDataQuery(variables: GetMetricChartDataQueryVariables) {
      return { query: GetMetricChartDataDocument, variables: variables }
    }
export const GetMetricWithContextAndSystemDocument = /*#__PURE__*/ gql`
    query GetMetricWithContextAndSystem($metricId: Int!) {
  metric(metricId: $metricId) {
    ...Metric
    ...MetricContext
    system {
      ...System
    }
  }
}
    ${MetricFragmentDoc}
${MetricContextFragmentDoc}
${SystemFragmentDoc}`;

/**
 * __useGetMetricWithContextAndSystemQuery__
 *
 * To run a query within a React component, call `useGetMetricWithContextAndSystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricWithContextAndSystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricWithContextAndSystemQuery({
 *   variables: {
 *      metricId: // value for 'metricId'
 *   },
 * });
 */
export function useGetMetricWithContextAndSystemQuery(baseOptions: Apollo.QueryHookOptions<GetMetricWithContextAndSystemQuery, GetMetricWithContextAndSystemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricWithContextAndSystemQuery, GetMetricWithContextAndSystemQueryVariables>(GetMetricWithContextAndSystemDocument, options);
      }
export function useGetMetricWithContextAndSystemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricWithContextAndSystemQuery, GetMetricWithContextAndSystemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricWithContextAndSystemQuery, GetMetricWithContextAndSystemQueryVariables>(GetMetricWithContextAndSystemDocument, options);
        }
export type GetMetricWithContextAndSystemQueryHookResult = ReturnType<typeof useGetMetricWithContextAndSystemQuery>;
export type GetMetricWithContextAndSystemLazyQueryHookResult = ReturnType<typeof useGetMetricWithContextAndSystemLazyQuery>;
export type GetMetricWithContextAndSystemQueryResult = Apollo.QueryResult<GetMetricWithContextAndSystemQuery, GetMetricWithContextAndSystemQueryVariables>;
export function refetchGetMetricWithContextAndSystemQuery(variables: GetMetricWithContextAndSystemQueryVariables) {
      return { query: GetMetricWithContextAndSystemDocument, variables: variables }
    }
export const GetMetricsDataPointsForDayDocument = /*#__PURE__*/ gql`
    query GetMetricsDataPointsForDay($metricIds: [Int!]!, $reportDate: Date!, $systemId: Int!) {
  getDataPointsForDay(
    metricIds: $metricIds
    reportDate: $reportDate
    systemId: $systemId
  ) {
    dataPoints {
      id
      intervalId
      value
      waterlyConnect
    }
    id
    metricId
  }
}
    `;

/**
 * __useGetMetricsDataPointsForDayQuery__
 *
 * To run a query within a React component, call `useGetMetricsDataPointsForDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricsDataPointsForDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricsDataPointsForDayQuery({
 *   variables: {
 *      metricIds: // value for 'metricIds'
 *      reportDate: // value for 'reportDate'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetMetricsDataPointsForDayQuery(baseOptions: Apollo.QueryHookOptions<GetMetricsDataPointsForDayQuery, GetMetricsDataPointsForDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricsDataPointsForDayQuery, GetMetricsDataPointsForDayQueryVariables>(GetMetricsDataPointsForDayDocument, options);
      }
export function useGetMetricsDataPointsForDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricsDataPointsForDayQuery, GetMetricsDataPointsForDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricsDataPointsForDayQuery, GetMetricsDataPointsForDayQueryVariables>(GetMetricsDataPointsForDayDocument, options);
        }
export type GetMetricsDataPointsForDayQueryHookResult = ReturnType<typeof useGetMetricsDataPointsForDayQuery>;
export type GetMetricsDataPointsForDayLazyQueryHookResult = ReturnType<typeof useGetMetricsDataPointsForDayLazyQuery>;
export type GetMetricsDataPointsForDayQueryResult = Apollo.QueryResult<GetMetricsDataPointsForDayQuery, GetMetricsDataPointsForDayQueryVariables>;
export function refetchGetMetricsDataPointsForDayQuery(variables: GetMetricsDataPointsForDayQueryVariables) {
      return { query: GetMetricsDataPointsForDayDocument, variables: variables }
    }
export const GetNextNewUnitIdDocument = /*#__PURE__*/ gql`
    query GetNextNewUnitId {
  getNextNewUnitId
}
    `;

/**
 * __useGetNextNewUnitIdQuery__
 *
 * To run a query within a React component, call `useGetNextNewUnitIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextNewUnitIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextNewUnitIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNextNewUnitIdQuery(baseOptions?: Apollo.QueryHookOptions<GetNextNewUnitIdQuery, GetNextNewUnitIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextNewUnitIdQuery, GetNextNewUnitIdQueryVariables>(GetNextNewUnitIdDocument, options);
      }
export function useGetNextNewUnitIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextNewUnitIdQuery, GetNextNewUnitIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextNewUnitIdQuery, GetNextNewUnitIdQueryVariables>(GetNextNewUnitIdDocument, options);
        }
export type GetNextNewUnitIdQueryHookResult = ReturnType<typeof useGetNextNewUnitIdQuery>;
export type GetNextNewUnitIdLazyQueryHookResult = ReturnType<typeof useGetNextNewUnitIdLazyQuery>;
export type GetNextNewUnitIdQueryResult = Apollo.QueryResult<GetNextNewUnitIdQuery, GetNextNewUnitIdQueryVariables>;
export function refetchGetNextNewUnitIdQuery(variables?: GetNextNewUnitIdQueryVariables) {
      return { query: GetNextNewUnitIdDocument, variables: variables }
    }
export const GetOrganizationsDocument = /*#__PURE__*/ gql`
    query GetOrganizations {
  organizations {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export function refetchGetOrganizationsQuery(variables?: GetOrganizationsQueryVariables) {
      return { query: GetOrganizationsDocument, variables: variables }
    }
export const GetPingDocument = /*#__PURE__*/ gql`
    query GetPing {
  ping
}
    `;

/**
 * __useGetPingQuery__
 *
 * To run a query within a React component, call `useGetPingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPingQuery(baseOptions?: Apollo.QueryHookOptions<GetPingQuery, GetPingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPingQuery, GetPingQueryVariables>(GetPingDocument, options);
      }
export function useGetPingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPingQuery, GetPingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPingQuery, GetPingQueryVariables>(GetPingDocument, options);
        }
export type GetPingQueryHookResult = ReturnType<typeof useGetPingQuery>;
export type GetPingLazyQueryHookResult = ReturnType<typeof useGetPingLazyQuery>;
export type GetPingQueryResult = Apollo.QueryResult<GetPingQuery, GetPingQueryVariables>;
export function refetchGetPingQuery(variables?: GetPingQueryVariables) {
      return { query: GetPingDocument, variables: variables }
    }
export const GetRelatedMetricsDocument = /*#__PURE__*/ gql`
    query GetRelatedMetrics($metricId: Int!) {
  metric(metricId: $metricId) {
    calculatedMetrics {
      ...Metric
      ...MetricContext
    }
    ...Metric
    sourceMetrics {
      ...Metric
      ...MetricContext
    }
    tagMapping {
      edgeDevice {
        deviceName
        id
      }
      ...TagMapping
    }
  }
}
    ${MetricFragmentDoc}
${MetricContextFragmentDoc}
${TagMappingFragmentDoc}`;

/**
 * __useGetRelatedMetricsQuery__
 *
 * To run a query within a React component, call `useGetRelatedMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedMetricsQuery({
 *   variables: {
 *      metricId: // value for 'metricId'
 *   },
 * });
 */
export function useGetRelatedMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetRelatedMetricsQuery, GetRelatedMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelatedMetricsQuery, GetRelatedMetricsQueryVariables>(GetRelatedMetricsDocument, options);
      }
export function useGetRelatedMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelatedMetricsQuery, GetRelatedMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelatedMetricsQuery, GetRelatedMetricsQueryVariables>(GetRelatedMetricsDocument, options);
        }
export type GetRelatedMetricsQueryHookResult = ReturnType<typeof useGetRelatedMetricsQuery>;
export type GetRelatedMetricsLazyQueryHookResult = ReturnType<typeof useGetRelatedMetricsLazyQuery>;
export type GetRelatedMetricsQueryResult = Apollo.QueryResult<GetRelatedMetricsQuery, GetRelatedMetricsQueryVariables>;
export function refetchGetRelatedMetricsQuery(variables: GetRelatedMetricsQueryVariables) {
      return { query: GetRelatedMetricsDocument, variables: variables }
    }
export const GetReportDefinitionDocument = /*#__PURE__*/ gql`
    query GetReportDefinition($input: ReportDefinitionInput!, $reportDefinitionId: Int!) {
  reportDefinition(input: $input) {
    ...ReportDefinition
    ...ReportDefinitionSite
  }
}
    ${ReportDefinitionFragmentDoc}
${ReportDefinitionSiteFragmentDoc}`;

/**
 * __useGetReportDefinitionQuery__
 *
 * To run a query within a React component, call `useGetReportDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportDefinitionQuery({
 *   variables: {
 *      input: // value for 'input'
 *      reportDefinitionId: // value for 'reportDefinitionId'
 *   },
 * });
 */
export function useGetReportDefinitionQuery(baseOptions: Apollo.QueryHookOptions<GetReportDefinitionQuery, GetReportDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportDefinitionQuery, GetReportDefinitionQueryVariables>(GetReportDefinitionDocument, options);
      }
export function useGetReportDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportDefinitionQuery, GetReportDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportDefinitionQuery, GetReportDefinitionQueryVariables>(GetReportDefinitionDocument, options);
        }
export type GetReportDefinitionQueryHookResult = ReturnType<typeof useGetReportDefinitionQuery>;
export type GetReportDefinitionLazyQueryHookResult = ReturnType<typeof useGetReportDefinitionLazyQuery>;
export type GetReportDefinitionQueryResult = Apollo.QueryResult<GetReportDefinitionQuery, GetReportDefinitionQueryVariables>;
export function refetchGetReportDefinitionQuery(variables: GetReportDefinitionQueryVariables) {
      return { query: GetReportDefinitionDocument, variables: variables }
    }
export const GetReportTemplatesDocument = /*#__PURE__*/ gql`
    query GetReportTemplates($input: ReportTemplatesWhere!) {
  reportTemplates(input: $input) {
    agencyName
    configSchemaId
    id
    legalStatement
    outputTypes
    stateOrProvince
    variant
  }
}
    `;

/**
 * __useGetReportTemplatesQuery__
 *
 * To run a query within a React component, call `useGetReportTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTemplatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReportTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>(GetReportTemplatesDocument, options);
      }
export function useGetReportTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>(GetReportTemplatesDocument, options);
        }
export type GetReportTemplatesQueryHookResult = ReturnType<typeof useGetReportTemplatesQuery>;
export type GetReportTemplatesLazyQueryHookResult = ReturnType<typeof useGetReportTemplatesLazyQuery>;
export type GetReportTemplatesQueryResult = Apollo.QueryResult<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>;
export function refetchGetReportTemplatesQuery(variables: GetReportTemplatesQueryVariables) {
      return { query: GetReportTemplatesDocument, variables: variables }
    }
export const GetSiteDataEntriesDocument = /*#__PURE__*/ gql`
    query GetSiteDataEntries($includeDeleted: Boolean, $includeHidden: Boolean, $intervalIds: [Int!], $reportDate: Date!, $siteId: Int!) {
  site(siteId: $siteId) {
    dataEntries(
      includeDeleted: $includeDeleted
      includeHidden: $includeHidden
      intervalIds: $intervalIds
      reportDate: $reportDate
    ) {
      current {
        ...MetricDataPointDetails
      }
      id
      metricId
    }
    id
  }
}
    ${MetricDataPointDetailsFragmentDoc}`;

/**
 * __useGetSiteDataEntriesQuery__
 *
 * To run a query within a React component, call `useGetSiteDataEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteDataEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteDataEntriesQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *      includeHidden: // value for 'includeHidden'
 *      intervalIds: // value for 'intervalIds'
 *      reportDate: // value for 'reportDate'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteDataEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetSiteDataEntriesQuery, GetSiteDataEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteDataEntriesQuery, GetSiteDataEntriesQueryVariables>(GetSiteDataEntriesDocument, options);
      }
export function useGetSiteDataEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteDataEntriesQuery, GetSiteDataEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteDataEntriesQuery, GetSiteDataEntriesQueryVariables>(GetSiteDataEntriesDocument, options);
        }
export type GetSiteDataEntriesQueryHookResult = ReturnType<typeof useGetSiteDataEntriesQuery>;
export type GetSiteDataEntriesLazyQueryHookResult = ReturnType<typeof useGetSiteDataEntriesLazyQuery>;
export type GetSiteDataEntriesQueryResult = Apollo.QueryResult<GetSiteDataEntriesQuery, GetSiteDataEntriesQueryVariables>;
export function refetchGetSiteDataEntriesQuery(variables: GetSiteDataEntriesQueryVariables) {
      return { query: GetSiteDataEntriesDocument, variables: variables }
    }
export const GetSiteDataEntriesDayDocument = /*#__PURE__*/ gql`
    query GetSiteDataEntriesDay($includeDeleted: Boolean, $includeHidden: Boolean, $intervalIds: [Int!]!, $reportDate: Date!, $siteId: Int!) {
  site(siteId: $siteId) {
    dataEntriesDay(
      includeDeleted: $includeDeleted
      includeHidden: $includeHidden
      intervalIds: $intervalIds
      reportDate: $reportDate
    ) {
      dataPoints {
        appliedAt
        dataPoint {
          ...TsDataPoint
        }
        id
        intervalId
        reportDate
        time
      }
      id
      metricId
      metricType
    }
    id
  }
}
    ${TsDataPointFragmentDoc}`;

/**
 * __useGetSiteDataEntriesDayQuery__
 *
 * To run a query within a React component, call `useGetSiteDataEntriesDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteDataEntriesDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteDataEntriesDayQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *      includeHidden: // value for 'includeHidden'
 *      intervalIds: // value for 'intervalIds'
 *      reportDate: // value for 'reportDate'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteDataEntriesDayQuery(baseOptions: Apollo.QueryHookOptions<GetSiteDataEntriesDayQuery, GetSiteDataEntriesDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteDataEntriesDayQuery, GetSiteDataEntriesDayQueryVariables>(GetSiteDataEntriesDayDocument, options);
      }
export function useGetSiteDataEntriesDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteDataEntriesDayQuery, GetSiteDataEntriesDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteDataEntriesDayQuery, GetSiteDataEntriesDayQueryVariables>(GetSiteDataEntriesDayDocument, options);
        }
export type GetSiteDataEntriesDayQueryHookResult = ReturnType<typeof useGetSiteDataEntriesDayQuery>;
export type GetSiteDataEntriesDayLazyQueryHookResult = ReturnType<typeof useGetSiteDataEntriesDayLazyQuery>;
export type GetSiteDataEntriesDayQueryResult = Apollo.QueryResult<GetSiteDataEntriesDayQuery, GetSiteDataEntriesDayQueryVariables>;
export function refetchGetSiteDataEntriesDayQuery(variables: GetSiteDataEntriesDayQueryVariables) {
      return { query: GetSiteDataEntriesDayDocument, variables: variables }
    }
export const GetSiteDataEntriesHistoryDocument = /*#__PURE__*/ gql`
    query GetSiteDataEntriesHistory($includeDeleted: Boolean, $includeHidden: Boolean, $intervalIds: [Int!], $reportDate: Date!, $siteId: Int!) {
  site(siteId: $siteId) {
    dataEntriesHistory(
      includeDeleted: $includeDeleted
      includeHidden: $includeHidden
      intervalIds: $intervalIds
      reportDate: $reportDate
    ) {
      history {
        ...MetricDataPointDetails
      }
      id
      metricId
    }
    id
  }
}
    ${MetricDataPointDetailsFragmentDoc}`;

/**
 * __useGetSiteDataEntriesHistoryQuery__
 *
 * To run a query within a React component, call `useGetSiteDataEntriesHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteDataEntriesHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteDataEntriesHistoryQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *      includeHidden: // value for 'includeHidden'
 *      intervalIds: // value for 'intervalIds'
 *      reportDate: // value for 'reportDate'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteDataEntriesHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetSiteDataEntriesHistoryQuery, GetSiteDataEntriesHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteDataEntriesHistoryQuery, GetSiteDataEntriesHistoryQueryVariables>(GetSiteDataEntriesHistoryDocument, options);
      }
export function useGetSiteDataEntriesHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteDataEntriesHistoryQuery, GetSiteDataEntriesHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteDataEntriesHistoryQuery, GetSiteDataEntriesHistoryQueryVariables>(GetSiteDataEntriesHistoryDocument, options);
        }
export type GetSiteDataEntriesHistoryQueryHookResult = ReturnType<typeof useGetSiteDataEntriesHistoryQuery>;
export type GetSiteDataEntriesHistoryLazyQueryHookResult = ReturnType<typeof useGetSiteDataEntriesHistoryLazyQuery>;
export type GetSiteDataEntriesHistoryQueryResult = Apollo.QueryResult<GetSiteDataEntriesHistoryQuery, GetSiteDataEntriesHistoryQueryVariables>;
export function refetchGetSiteDataEntriesHistoryQuery(variables: GetSiteDataEntriesHistoryQueryVariables) {
      return { query: GetSiteDataEntriesHistoryDocument, variables: variables }
    }
export const GetSiteMetricsV2Document = /*#__PURE__*/ gql`
    query GetSiteMetricsV2($includeDeleted: Boolean, $siteId: Int!) {
  siteV2(includeDeleted: $includeDeleted, siteId: $siteId) {
    id
    metrics {
      intervals {
        ...IntervalNest
      }
      metricKeyname {
        ...MetricKeyname
      }
      ...MetricNest
      unit {
        ...UnitNest
      }
    }
  }
}
    ${IntervalNestFragmentDoc}
${MetricKeynameFragmentDoc}
${MetricNestFragmentDoc}
${UnitNestFragmentDoc}`;

/**
 * __useGetSiteMetricsV2Query__
 *
 * To run a query within a React component, call `useGetSiteMetricsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteMetricsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteMetricsV2Query({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteMetricsV2Query(baseOptions: Apollo.QueryHookOptions<GetSiteMetricsV2Query, GetSiteMetricsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteMetricsV2Query, GetSiteMetricsV2QueryVariables>(GetSiteMetricsV2Document, options);
      }
export function useGetSiteMetricsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteMetricsV2Query, GetSiteMetricsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteMetricsV2Query, GetSiteMetricsV2QueryVariables>(GetSiteMetricsV2Document, options);
        }
export type GetSiteMetricsV2QueryHookResult = ReturnType<typeof useGetSiteMetricsV2Query>;
export type GetSiteMetricsV2LazyQueryHookResult = ReturnType<typeof useGetSiteMetricsV2LazyQuery>;
export type GetSiteMetricsV2QueryResult = Apollo.QueryResult<GetSiteMetricsV2Query, GetSiteMetricsV2QueryVariables>;
export function refetchGetSiteMetricsV2Query(variables: GetSiteMetricsV2QueryVariables) {
      return { query: GetSiteMetricsV2Document, variables: variables }
    }
export const GetSiteSourceMetricsDocument = /*#__PURE__*/ gql`
    query GetSiteSourceMetrics($includeDeleted: Boolean, $siteId: Int!) {
  siteV2(includeDeleted: $includeDeleted, siteId: $siteId) {
    id
    sourceMetrics {
      ...MetricWithCalculatedMetric
    }
  }
}
    ${MetricWithCalculatedMetricFragmentDoc}`;

/**
 * __useGetSiteSourceMetricsQuery__
 *
 * To run a query within a React component, call `useGetSiteSourceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteSourceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteSourceMetricsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteSourceMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetSiteSourceMetricsQuery, GetSiteSourceMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteSourceMetricsQuery, GetSiteSourceMetricsQueryVariables>(GetSiteSourceMetricsDocument, options);
      }
export function useGetSiteSourceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteSourceMetricsQuery, GetSiteSourceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteSourceMetricsQuery, GetSiteSourceMetricsQueryVariables>(GetSiteSourceMetricsDocument, options);
        }
export type GetSiteSourceMetricsQueryHookResult = ReturnType<typeof useGetSiteSourceMetricsQuery>;
export type GetSiteSourceMetricsLazyQueryHookResult = ReturnType<typeof useGetSiteSourceMetricsLazyQuery>;
export type GetSiteSourceMetricsQueryResult = Apollo.QueryResult<GetSiteSourceMetricsQuery, GetSiteSourceMetricsQueryVariables>;
export function refetchGetSiteSourceMetricsQuery(variables: GetSiteSourceMetricsQueryVariables) {
      return { query: GetSiteSourceMetricsDocument, variables: variables }
    }
export const GetSiteV2Document = /*#__PURE__*/ gql`
    query GetSiteV2($entryDate: Date, $siteId: Int!) {
  siteV2(
    entryDate: $entryDate
    includeDeleted: true
    includeHidden: true
    siteId: $siteId
  ) {
    addresses {
      ...Address
    }
    components {
      ...ComponentNest
    }
    dataModelSite {
      ...SiteNest
    }
    foldersWithMetricIdsAndOrder {
      ...FolderWithMetricIdsAndOrder
      metricIdsWithOrder {
        ...MetricOrderWithMetricId
      }
    }
    intervals {
      ...IntervalNest
      siteFullName
    }
    metrics {
      intervals {
        ...IntervalNest
        siteFullName
      }
      metricKeyname {
        ...MetricKeyname
      }
      ...MetricNest
      metricRanges {
        maxTag {
          ...Tag
        }
        ...MetricRange
        minTag {
          ...Tag
        }
      }
      unit {
        ...UnitNest
      }
    }
    processes {
      ...ProcessNest
    }
    siteFlexMetricsWithParentSite {
      ...SiteFlexMetricWithParentSite
    }
    ...SiteNest
  }
}
    ${AddressFragmentDoc}
${ComponentNestFragmentDoc}
${SiteNestFragmentDoc}
${FolderWithMetricIdsAndOrderFragmentDoc}
${MetricOrderWithMetricIdFragmentDoc}
${IntervalNestFragmentDoc}
${MetricKeynameFragmentDoc}
${MetricNestFragmentDoc}
${TagFragmentDoc}
${MetricRangeFragmentDoc}
${UnitNestFragmentDoc}
${ProcessNestFragmentDoc}
${SiteFlexMetricWithParentSiteFragmentDoc}`;

/**
 * __useGetSiteV2Query__
 *
 * To run a query within a React component, call `useGetSiteV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteV2Query({
 *   variables: {
 *      entryDate: // value for 'entryDate'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteV2Query(baseOptions: Apollo.QueryHookOptions<GetSiteV2Query, GetSiteV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteV2Query, GetSiteV2QueryVariables>(GetSiteV2Document, options);
      }
export function useGetSiteV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteV2Query, GetSiteV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteV2Query, GetSiteV2QueryVariables>(GetSiteV2Document, options);
        }
export type GetSiteV2QueryHookResult = ReturnType<typeof useGetSiteV2Query>;
export type GetSiteV2LazyQueryHookResult = ReturnType<typeof useGetSiteV2LazyQuery>;
export type GetSiteV2QueryResult = Apollo.QueryResult<GetSiteV2Query, GetSiteV2QueryVariables>;
export function refetchGetSiteV2Query(variables: GetSiteV2QueryVariables) {
      return { query: GetSiteV2Document, variables: variables }
    }
export const GetSitesDocument = /*#__PURE__*/ gql`
    query GetSites($input: SitesInput!) {
  sitesV2(input: $input) {
    ...SiteNest
  }
}
    ${SiteNestFragmentDoc}`;

/**
 * __useGetSitesQuery__
 *
 * To run a query within a React component, call `useGetSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSitesQuery(baseOptions: Apollo.QueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
      }
export function useGetSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
        }
export type GetSitesQueryHookResult = ReturnType<typeof useGetSitesQuery>;
export type GetSitesLazyQueryHookResult = ReturnType<typeof useGetSitesLazyQuery>;
export type GetSitesQueryResult = Apollo.QueryResult<GetSitesQuery, GetSitesQueryVariables>;
export function refetchGetSitesQuery(variables: GetSitesQueryVariables) {
      return { query: GetSitesDocument, variables: variables }
    }
export const GetSitesForSystemDocument = /*#__PURE__*/ gql`
    query GetSitesForSystem($systemId: Int!) {
  system(systemId: $systemId) {
    hideDataSites
    id
    sites {
      ...Site
    }
  }
}
    ${SiteFragmentDoc}`;

/**
 * __useGetSitesForSystemQuery__
 *
 * To run a query within a React component, call `useGetSitesForSystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitesForSystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitesForSystemQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetSitesForSystemQuery(baseOptions: Apollo.QueryHookOptions<GetSitesForSystemQuery, GetSitesForSystemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSitesForSystemQuery, GetSitesForSystemQueryVariables>(GetSitesForSystemDocument, options);
      }
export function useGetSitesForSystemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSitesForSystemQuery, GetSitesForSystemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSitesForSystemQuery, GetSitesForSystemQueryVariables>(GetSitesForSystemDocument, options);
        }
export type GetSitesForSystemQueryHookResult = ReturnType<typeof useGetSitesForSystemQuery>;
export type GetSitesForSystemLazyQueryHookResult = ReturnType<typeof useGetSitesForSystemLazyQuery>;
export type GetSitesForSystemQueryResult = Apollo.QueryResult<GetSitesForSystemQuery, GetSitesForSystemQueryVariables>;
export function refetchGetSitesForSystemQuery(variables: GetSitesForSystemQueryVariables) {
      return { query: GetSitesForSystemDocument, variables: variables }
    }
export const GetSsoConfigurationDocument = /*#__PURE__*/ gql`
    query GetSsoConfiguration($idpKey: String!) {
  getSSOConfigurationByIDP(idpKey: $idpKey) {
    ...SSOConfiguration
  }
}
    ${SsoConfigurationFragmentDoc}`;

/**
 * __useGetSsoConfigurationQuery__
 *
 * To run a query within a React component, call `useGetSsoConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSsoConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSsoConfigurationQuery({
 *   variables: {
 *      idpKey: // value for 'idpKey'
 *   },
 * });
 */
export function useGetSsoConfigurationQuery(baseOptions: Apollo.QueryHookOptions<GetSsoConfigurationQuery, GetSsoConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSsoConfigurationQuery, GetSsoConfigurationQueryVariables>(GetSsoConfigurationDocument, options);
      }
export function useGetSsoConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSsoConfigurationQuery, GetSsoConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSsoConfigurationQuery, GetSsoConfigurationQueryVariables>(GetSsoConfigurationDocument, options);
        }
export type GetSsoConfigurationQueryHookResult = ReturnType<typeof useGetSsoConfigurationQuery>;
export type GetSsoConfigurationLazyQueryHookResult = ReturnType<typeof useGetSsoConfigurationLazyQuery>;
export type GetSsoConfigurationQueryResult = Apollo.QueryResult<GetSsoConfigurationQuery, GetSsoConfigurationQueryVariables>;
export function refetchGetSsoConfigurationQuery(variables: GetSsoConfigurationQueryVariables) {
      return { query: GetSsoConfigurationDocument, variables: variables }
    }
export const GetSystemDocument = /*#__PURE__*/ gql`
    query GetSystem($systemId: Int!, $withHasSitesWithIntervals: Boolean = false, $withOperator: Boolean = false, $withUserDirectoryEnabled: Boolean = false) {
  system(systemId: $systemId) {
    hasSitesWithIntervals @include(if: $withHasSitesWithIntervals)
    operator @include(if: $withOperator) {
      ...User
    }
    organization {
      ...Organization
    }
    organizationId
    sites {
      id
    }
    ...System
    userDirectoryEnabled @include(if: $withUserDirectoryEnabled)
  }
}
    ${UserFragmentDoc}
${OrganizationFragmentDoc}
${SystemFragmentDoc}`;

/**
 * __useGetSystemQuery__
 *
 * To run a query within a React component, call `useGetSystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      withHasSitesWithIntervals: // value for 'withHasSitesWithIntervals'
 *      withOperator: // value for 'withOperator'
 *      withUserDirectoryEnabled: // value for 'withUserDirectoryEnabled'
 *   },
 * });
 */
export function useGetSystemQuery(baseOptions: Apollo.QueryHookOptions<GetSystemQuery, GetSystemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemQuery, GetSystemQueryVariables>(GetSystemDocument, options);
      }
export function useGetSystemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemQuery, GetSystemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemQuery, GetSystemQueryVariables>(GetSystemDocument, options);
        }
export type GetSystemQueryHookResult = ReturnType<typeof useGetSystemQuery>;
export type GetSystemLazyQueryHookResult = ReturnType<typeof useGetSystemLazyQuery>;
export type GetSystemQueryResult = Apollo.QueryResult<GetSystemQuery, GetSystemQueryVariables>;
export function refetchGetSystemQuery(variables: GetSystemQueryVariables) {
      return { query: GetSystemDocument, variables: variables }
    }
export const GetSystemComponentsDocument = /*#__PURE__*/ gql`
    query GetSystemComponents($systemId: Int!) {
  system(systemId: $systemId) {
    components {
      ...Component
      displayName @client
      process {
        id
        name
      }
      site {
        id
        name
      }
    }
    id
  }
}
    ${ComponentFragmentDoc}`;

/**
 * __useGetSystemComponentsQuery__
 *
 * To run a query within a React component, call `useGetSystemComponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemComponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemComponentsQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetSystemComponentsQuery(baseOptions: Apollo.QueryHookOptions<GetSystemComponentsQuery, GetSystemComponentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemComponentsQuery, GetSystemComponentsQueryVariables>(GetSystemComponentsDocument, options);
      }
export function useGetSystemComponentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemComponentsQuery, GetSystemComponentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemComponentsQuery, GetSystemComponentsQueryVariables>(GetSystemComponentsDocument, options);
        }
export type GetSystemComponentsQueryHookResult = ReturnType<typeof useGetSystemComponentsQuery>;
export type GetSystemComponentsLazyQueryHookResult = ReturnType<typeof useGetSystemComponentsLazyQuery>;
export type GetSystemComponentsQueryResult = Apollo.QueryResult<GetSystemComponentsQuery, GetSystemComponentsQueryVariables>;
export function refetchGetSystemComponentsQuery(variables: GetSystemComponentsQueryVariables) {
      return { query: GetSystemComponentsDocument, variables: variables }
    }
export const GetSystemMetricsForValidationDocument = /*#__PURE__*/ gql`
    query GetSystemMetricsForValidation($systemId: Int!) {
  system(systemId: $systemId) {
    id
    metrics {
      intervals {
        ...Interval
      }
      ...Metric
      ...MetricContext
      sourceMetrics {
        intervals {
          ...Interval
        }
        ...Metric
      }
    }
  }
}
    ${IntervalFragmentDoc}
${MetricFragmentDoc}
${MetricContextFragmentDoc}`;

/**
 * __useGetSystemMetricsForValidationQuery__
 *
 * To run a query within a React component, call `useGetSystemMetricsForValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemMetricsForValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemMetricsForValidationQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetSystemMetricsForValidationQuery(baseOptions: Apollo.QueryHookOptions<GetSystemMetricsForValidationQuery, GetSystemMetricsForValidationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemMetricsForValidationQuery, GetSystemMetricsForValidationQueryVariables>(GetSystemMetricsForValidationDocument, options);
      }
export function useGetSystemMetricsForValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemMetricsForValidationQuery, GetSystemMetricsForValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemMetricsForValidationQuery, GetSystemMetricsForValidationQueryVariables>(GetSystemMetricsForValidationDocument, options);
        }
export type GetSystemMetricsForValidationQueryHookResult = ReturnType<typeof useGetSystemMetricsForValidationQuery>;
export type GetSystemMetricsForValidationLazyQueryHookResult = ReturnType<typeof useGetSystemMetricsForValidationLazyQuery>;
export type GetSystemMetricsForValidationQueryResult = Apollo.QueryResult<GetSystemMetricsForValidationQuery, GetSystemMetricsForValidationQueryVariables>;
export function refetchGetSystemMetricsForValidationQuery(variables: GetSystemMetricsForValidationQueryVariables) {
      return { query: GetSystemMetricsForValidationDocument, variables: variables }
    }
export const GetSystemProcessesDocument = /*#__PURE__*/ gql`
    query GetSystemProcesses($systemId: Int!) {
  system(systemId: $systemId) {
    id
    processes {
      displayName @client
      id
      name
      site {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetSystemProcessesQuery__
 *
 * To run a query within a React component, call `useGetSystemProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemProcessesQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetSystemProcessesQuery(baseOptions: Apollo.QueryHookOptions<GetSystemProcessesQuery, GetSystemProcessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemProcessesQuery, GetSystemProcessesQueryVariables>(GetSystemProcessesDocument, options);
      }
export function useGetSystemProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemProcessesQuery, GetSystemProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemProcessesQuery, GetSystemProcessesQueryVariables>(GetSystemProcessesDocument, options);
        }
export type GetSystemProcessesQueryHookResult = ReturnType<typeof useGetSystemProcessesQuery>;
export type GetSystemProcessesLazyQueryHookResult = ReturnType<typeof useGetSystemProcessesLazyQuery>;
export type GetSystemProcessesQueryResult = Apollo.QueryResult<GetSystemProcessesQuery, GetSystemProcessesQueryVariables>;
export function refetchGetSystemProcessesQuery(variables: GetSystemProcessesQueryVariables) {
      return { query: GetSystemProcessesDocument, variables: variables }
    }
export const GetSystemSiteDetailsDocument = /*#__PURE__*/ gql`
    query GetSystemSiteDetails($endDateTime: Timestamp!, $includeMetricRanges: Boolean! = false, $startDateTime: Timestamp!, $systemId: Int!) {
  system(systemId: $systemId) {
    id
    sites {
      outOfIdealRangeMetrics(endDateTime: $endDateTime, startDateTime: $startDateTime) {
        metric {
          intervals {
            id
            time
          }
          ...Metric
          metricRanges @include(if: $includeMetricRanges) {
            ...MetricRange
          }
        }
        outOfIdealRange {
          appliedAt
          calculatedNondetectValue
          calculatedValue
          comment
          effectiveNumericValue
          intervalId
          isArchived
          isCalculatedResult
          isInterpolated
          isNondetect
          measuredAt
          metaData {
            intervalId
            reportDate
          }
          metricId
          numericValue
          reportDate
          storedAt
          type
          value
          valueType
        }
      }
      outOfRangeMetrics(endDateTime: $endDateTime, startDateTime: $startDateTime) {
        metric {
          intervals {
            id
            time
          }
          ...Metric
        }
        outOfRange {
          appliedAt
          calculatedNondetectValue
          calculatedValue
          comment
          effectiveNumericValue
          intervalId
          isArchived
          isCalculatedResult
          isInterpolated
          isNondetect
          measuredAt
          metaData {
            intervalId
            reportDate
          }
          metricId
          numericValue
          reportDate
          storedAt
          type
          value
          valueType
        }
      }
      processes {
        components {
          ...Component
        }
        ...Process
      }
      ...Site
    }
  }
}
    ${MetricFragmentDoc}
${MetricRangeFragmentDoc}
${ComponentFragmentDoc}
${ProcessFragmentDoc}
${SiteFragmentDoc}`;

/**
 * __useGetSystemSiteDetailsQuery__
 *
 * To run a query within a React component, call `useGetSystemSiteDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemSiteDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemSiteDetailsQuery({
 *   variables: {
 *      endDateTime: // value for 'endDateTime'
 *      includeMetricRanges: // value for 'includeMetricRanges'
 *      startDateTime: // value for 'startDateTime'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetSystemSiteDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSystemSiteDetailsQuery, GetSystemSiteDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemSiteDetailsQuery, GetSystemSiteDetailsQueryVariables>(GetSystemSiteDetailsDocument, options);
      }
export function useGetSystemSiteDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemSiteDetailsQuery, GetSystemSiteDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemSiteDetailsQuery, GetSystemSiteDetailsQueryVariables>(GetSystemSiteDetailsDocument, options);
        }
export type GetSystemSiteDetailsQueryHookResult = ReturnType<typeof useGetSystemSiteDetailsQuery>;
export type GetSystemSiteDetailsLazyQueryHookResult = ReturnType<typeof useGetSystemSiteDetailsLazyQuery>;
export type GetSystemSiteDetailsQueryResult = Apollo.QueryResult<GetSystemSiteDetailsQuery, GetSystemSiteDetailsQueryVariables>;
export function refetchGetSystemSiteDetailsQuery(variables: GetSystemSiteDetailsQueryVariables) {
      return { query: GetSystemSiteDetailsDocument, variables: variables }
    }
export const GetSystemSitesDocument = /*#__PURE__*/ gql`
    query GetSystemSites($systemId: Int!) {
  system(systemId: $systemId) {
    id
    sites {
      displayName @client
      flex
      id
      intervals {
        id
        time
      }
      name
      order
    }
  }
}
    `;

/**
 * __useGetSystemSitesQuery__
 *
 * To run a query within a React component, call `useGetSystemSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemSitesQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetSystemSitesQuery(baseOptions: Apollo.QueryHookOptions<GetSystemSitesQuery, GetSystemSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemSitesQuery, GetSystemSitesQueryVariables>(GetSystemSitesDocument, options);
      }
export function useGetSystemSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemSitesQuery, GetSystemSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemSitesQuery, GetSystemSitesQueryVariables>(GetSystemSitesDocument, options);
        }
export type GetSystemSitesQueryHookResult = ReturnType<typeof useGetSystemSitesQuery>;
export type GetSystemSitesLazyQueryHookResult = ReturnType<typeof useGetSystemSitesLazyQuery>;
export type GetSystemSitesQueryResult = Apollo.QueryResult<GetSystemSitesQuery, GetSystemSitesQueryVariables>;
export function refetchGetSystemSitesQuery(variables: GetSystemSitesQueryVariables) {
      return { query: GetSystemSitesDocument, variables: variables }
    }
export const GetSystemUsersDocument = /*#__PURE__*/ gql`
    query GetSystemUsers($systemId: Int!) {
  system(systemId: $systemId) {
    id
    users {
      roleForSystem(systemId: $systemId)
      ...User
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetSystemUsersQuery__
 *
 * To run a query within a React component, call `useGetSystemUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemUsersQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetSystemUsersQuery(baseOptions: Apollo.QueryHookOptions<GetSystemUsersQuery, GetSystemUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemUsersQuery, GetSystemUsersQueryVariables>(GetSystemUsersDocument, options);
      }
export function useGetSystemUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemUsersQuery, GetSystemUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemUsersQuery, GetSystemUsersQueryVariables>(GetSystemUsersDocument, options);
        }
export type GetSystemUsersQueryHookResult = ReturnType<typeof useGetSystemUsersQuery>;
export type GetSystemUsersLazyQueryHookResult = ReturnType<typeof useGetSystemUsersLazyQuery>;
export type GetSystemUsersQueryResult = Apollo.QueryResult<GetSystemUsersQuery, GetSystemUsersQueryVariables>;
export function refetchGetSystemUsersQuery(variables: GetSystemUsersQueryVariables) {
      return { query: GetSystemUsersDocument, variables: variables }
    }
export const GetSystemsDocument = /*#__PURE__*/ gql`
    query GetSystems($input: SystemsInput) {
  systems(input: $input) {
    ...System
  }
}
    ${SystemFragmentDoc}`;

/**
 * __useGetSystemsQuery__
 *
 * To run a query within a React component, call `useGetSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSystemsQuery(baseOptions?: Apollo.QueryHookOptions<GetSystemsQuery, GetSystemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemsQuery, GetSystemsQueryVariables>(GetSystemsDocument, options);
      }
export function useGetSystemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemsQuery, GetSystemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemsQuery, GetSystemsQueryVariables>(GetSystemsDocument, options);
        }
export type GetSystemsQueryHookResult = ReturnType<typeof useGetSystemsQuery>;
export type GetSystemsLazyQueryHookResult = ReturnType<typeof useGetSystemsLazyQuery>;
export type GetSystemsQueryResult = Apollo.QueryResult<GetSystemsQuery, GetSystemsQueryVariables>;
export function refetchGetSystemsQuery(variables?: GetSystemsQueryVariables) {
      return { query: GetSystemsDocument, variables: variables }
    }
export const GetSystemsWithOperatorDocument = /*#__PURE__*/ gql`
    query GetSystemsWithOperator {
  systemsV2 {
    addresses {
      id
      region
    }
    displayName @client
    id
    isFavorite
    isTemplate
    myRole
    name
    organizationId
    regulatoryId
    type
  }
}
    `;

/**
 * __useGetSystemsWithOperatorQuery__
 *
 * To run a query within a React component, call `useGetSystemsWithOperatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemsWithOperatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemsWithOperatorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSystemsWithOperatorQuery(baseOptions?: Apollo.QueryHookOptions<GetSystemsWithOperatorQuery, GetSystemsWithOperatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemsWithOperatorQuery, GetSystemsWithOperatorQueryVariables>(GetSystemsWithOperatorDocument, options);
      }
export function useGetSystemsWithOperatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemsWithOperatorQuery, GetSystemsWithOperatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemsWithOperatorQuery, GetSystemsWithOperatorQueryVariables>(GetSystemsWithOperatorDocument, options);
        }
export type GetSystemsWithOperatorQueryHookResult = ReturnType<typeof useGetSystemsWithOperatorQuery>;
export type GetSystemsWithOperatorLazyQueryHookResult = ReturnType<typeof useGetSystemsWithOperatorLazyQuery>;
export type GetSystemsWithOperatorQueryResult = Apollo.QueryResult<GetSystemsWithOperatorQuery, GetSystemsWithOperatorQueryVariables>;
export function refetchGetSystemsWithOperatorQuery(variables?: GetSystemsWithOperatorQueryVariables) {
      return { query: GetSystemsWithOperatorDocument, variables: variables }
    }
export const GetTrendsDocument = /*#__PURE__*/ gql`
    query GetTrends($input: TrendsQueryInput!, $systemId: Int!) {
  trends(input: $input) {
    owner {
      ...UserNest
    }
    system {
      ...SystemNest
    }
    ...Trend
  }
}
    ${UserNestFragmentDoc}
${SystemNestFragmentDoc}
${TrendFragmentDoc}`;

/**
 * __useGetTrendsQuery__
 *
 * To run a query within a React component, call `useGetTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetTrendsQuery(baseOptions: Apollo.QueryHookOptions<GetTrendsQuery, GetTrendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrendsQuery, GetTrendsQueryVariables>(GetTrendsDocument, options);
      }
export function useGetTrendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendsQuery, GetTrendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrendsQuery, GetTrendsQueryVariables>(GetTrendsDocument, options);
        }
export type GetTrendsQueryHookResult = ReturnType<typeof useGetTrendsQuery>;
export type GetTrendsLazyQueryHookResult = ReturnType<typeof useGetTrendsLazyQuery>;
export type GetTrendsQueryResult = Apollo.QueryResult<GetTrendsQuery, GetTrendsQueryVariables>;
export function refetchGetTrendsQuery(variables: GetTrendsQueryVariables) {
      return { query: GetTrendsDocument, variables: variables }
    }
export const GetUnitsDocument = /*#__PURE__*/ gql`
    query GetUnits {
  units {
    id
    isInterpolatable
    name
  }
}
    `;

/**
 * __useGetUnitsQuery__
 *
 * To run a query within a React component, call `useGetUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitsQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitsQuery, GetUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsQuery, GetUnitsQueryVariables>(GetUnitsDocument, options);
      }
export function useGetUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsQuery, GetUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsQuery, GetUnitsQueryVariables>(GetUnitsDocument, options);
        }
export type GetUnitsQueryHookResult = ReturnType<typeof useGetUnitsQuery>;
export type GetUnitsLazyQueryHookResult = ReturnType<typeof useGetUnitsLazyQuery>;
export type GetUnitsQueryResult = Apollo.QueryResult<GetUnitsQuery, GetUnitsQueryVariables>;
export function refetchGetUnitsQuery(variables?: GetUnitsQueryVariables) {
      return { query: GetUnitsDocument, variables: variables }
    }
export const GetUserDocument = /*#__PURE__*/ gql`
    query GetUser($userId: Int!) {
  user(userId: $userId) {
    ...UserNest
  }
}
    ${UserNestFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export function refetchGetUserQuery(variables: GetUserQueryVariables) {
      return { query: GetUserDocument, variables: variables }
    }
export const GetUserFullInfoDocument = /*#__PURE__*/ gql`
    query GetUserFullInfo($userId: Int!) {
  user(userId: $userId) {
    licenses {
      ...License
    }
    permissions {
      ...UserOrganizationPermissionNest
    }
    ssoConfig {
      id
      idpKey
      isNameEditable
    }
    ...UserNest
  }
}
    ${LicenseFragmentDoc}
${UserOrganizationPermissionNestFragmentDoc}
${UserNestFragmentDoc}`;

/**
 * __useGetUserFullInfoQuery__
 *
 * To run a query within a React component, call `useGetUserFullInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFullInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFullInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserFullInfoQuery(baseOptions: Apollo.QueryHookOptions<GetUserFullInfoQuery, GetUserFullInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFullInfoQuery, GetUserFullInfoQueryVariables>(GetUserFullInfoDocument, options);
      }
export function useGetUserFullInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFullInfoQuery, GetUserFullInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFullInfoQuery, GetUserFullInfoQueryVariables>(GetUserFullInfoDocument, options);
        }
export type GetUserFullInfoQueryHookResult = ReturnType<typeof useGetUserFullInfoQuery>;
export type GetUserFullInfoLazyQueryHookResult = ReturnType<typeof useGetUserFullInfoLazyQuery>;
export type GetUserFullInfoQueryResult = Apollo.QueryResult<GetUserFullInfoQuery, GetUserFullInfoQueryVariables>;
export function refetchGetUserFullInfoQuery(variables: GetUserFullInfoQueryVariables) {
      return { query: GetUserFullInfoDocument, variables: variables }
    }
export const GetUserLicensesDocument = /*#__PURE__*/ gql`
    query GetUserLicenses($userId: Int!) {
  licenses(userId: $userId) {
    ...License
  }
}
    ${LicenseFragmentDoc}`;

/**
 * __useGetUserLicensesQuery__
 *
 * To run a query within a React component, call `useGetUserLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLicensesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserLicensesQuery(baseOptions: Apollo.QueryHookOptions<GetUserLicensesQuery, GetUserLicensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserLicensesQuery, GetUserLicensesQueryVariables>(GetUserLicensesDocument, options);
      }
export function useGetUserLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserLicensesQuery, GetUserLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserLicensesQuery, GetUserLicensesQueryVariables>(GetUserLicensesDocument, options);
        }
export type GetUserLicensesQueryHookResult = ReturnType<typeof useGetUserLicensesQuery>;
export type GetUserLicensesLazyQueryHookResult = ReturnType<typeof useGetUserLicensesLazyQuery>;
export type GetUserLicensesQueryResult = Apollo.QueryResult<GetUserLicensesQuery, GetUserLicensesQueryVariables>;
export function refetchGetUserLicensesQuery(variables: GetUserLicensesQueryVariables) {
      return { query: GetUserLicensesDocument, variables: variables }
    }
export const GetUserPhoneNumbersDocument = /*#__PURE__*/ gql`
    query GetUserPhoneNumbers($userId: Int!) {
  phoneNumbers(userId: $userId) {
    ...PhoneNumber
  }
}
    ${PhoneNumberFragmentDoc}`;

/**
 * __useGetUserPhoneNumbersQuery__
 *
 * To run a query within a React component, call `useGetUserPhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPhoneNumbersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserPhoneNumbersQuery(baseOptions: Apollo.QueryHookOptions<GetUserPhoneNumbersQuery, GetUserPhoneNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPhoneNumbersQuery, GetUserPhoneNumbersQueryVariables>(GetUserPhoneNumbersDocument, options);
      }
export function useGetUserPhoneNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPhoneNumbersQuery, GetUserPhoneNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPhoneNumbersQuery, GetUserPhoneNumbersQueryVariables>(GetUserPhoneNumbersDocument, options);
        }
export type GetUserPhoneNumbersQueryHookResult = ReturnType<typeof useGetUserPhoneNumbersQuery>;
export type GetUserPhoneNumbersLazyQueryHookResult = ReturnType<typeof useGetUserPhoneNumbersLazyQuery>;
export type GetUserPhoneNumbersQueryResult = Apollo.QueryResult<GetUserPhoneNumbersQuery, GetUserPhoneNumbersQueryVariables>;
export function refetchGetUserPhoneNumbersQuery(variables: GetUserPhoneNumbersQueryVariables) {
      return { query: GetUserPhoneNumbersDocument, variables: variables }
    }
export const GetWaterlyConnectErrorStatsDocument = /*#__PURE__*/ gql`
    query GetWaterlyConnectErrorStats($edgeDeviceId: Int, $forMonthStartingUtc: String!) {
  waterlyConnectErrorStats(
    edgeDeviceId: $edgeDeviceId
    forMonthStartingUTC: $forMonthStartingUtc
  ) {
    errorCountByDay
    id
  }
}
    `;

/**
 * __useGetWaterlyConnectErrorStatsQuery__
 *
 * To run a query within a React component, call `useGetWaterlyConnectErrorStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaterlyConnectErrorStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaterlyConnectErrorStatsQuery({
 *   variables: {
 *      edgeDeviceId: // value for 'edgeDeviceId'
 *      forMonthStartingUtc: // value for 'forMonthStartingUtc'
 *   },
 * });
 */
export function useGetWaterlyConnectErrorStatsQuery(baseOptions: Apollo.QueryHookOptions<GetWaterlyConnectErrorStatsQuery, GetWaterlyConnectErrorStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWaterlyConnectErrorStatsQuery, GetWaterlyConnectErrorStatsQueryVariables>(GetWaterlyConnectErrorStatsDocument, options);
      }
export function useGetWaterlyConnectErrorStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWaterlyConnectErrorStatsQuery, GetWaterlyConnectErrorStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWaterlyConnectErrorStatsQuery, GetWaterlyConnectErrorStatsQueryVariables>(GetWaterlyConnectErrorStatsDocument, options);
        }
export type GetWaterlyConnectErrorStatsQueryHookResult = ReturnType<typeof useGetWaterlyConnectErrorStatsQuery>;
export type GetWaterlyConnectErrorStatsLazyQueryHookResult = ReturnType<typeof useGetWaterlyConnectErrorStatsLazyQuery>;
export type GetWaterlyConnectErrorStatsQueryResult = Apollo.QueryResult<GetWaterlyConnectErrorStatsQuery, GetWaterlyConnectErrorStatsQueryVariables>;
export function refetchGetWaterlyConnectErrorStatsQuery(variables: GetWaterlyConnectErrorStatsQueryVariables) {
      return { query: GetWaterlyConnectErrorStatsDocument, variables: variables }
    }
export const GetWaterlyConnectStatsDocument = /*#__PURE__*/ gql`
    query GetWaterlyConnectStats {
  waterlyConnectStats {
    activeQueueJobCount
    countLast24HourSubmissions
    countLast24HourSubmissionsSuccessful
    id
    queueJobCountsByEdgeDevice {
      activeCount
      edgeDeviceId
      edgeDeviceName
      waitingCount
    }
    waitingQueueJobCount
  }
}
    `;

/**
 * __useGetWaterlyConnectStatsQuery__
 *
 * To run a query within a React component, call `useGetWaterlyConnectStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaterlyConnectStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaterlyConnectStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWaterlyConnectStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetWaterlyConnectStatsQuery, GetWaterlyConnectStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWaterlyConnectStatsQuery, GetWaterlyConnectStatsQueryVariables>(GetWaterlyConnectStatsDocument, options);
      }
export function useGetWaterlyConnectStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWaterlyConnectStatsQuery, GetWaterlyConnectStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWaterlyConnectStatsQuery, GetWaterlyConnectStatsQueryVariables>(GetWaterlyConnectStatsDocument, options);
        }
export type GetWaterlyConnectStatsQueryHookResult = ReturnType<typeof useGetWaterlyConnectStatsQuery>;
export type GetWaterlyConnectStatsLazyQueryHookResult = ReturnType<typeof useGetWaterlyConnectStatsLazyQuery>;
export type GetWaterlyConnectStatsQueryResult = Apollo.QueryResult<GetWaterlyConnectStatsQuery, GetWaterlyConnectStatsQueryVariables>;
export function refetchGetWaterlyConnectStatsQuery(variables?: GetWaterlyConnectStatsQueryVariables) {
      return { query: GetWaterlyConnectStatsDocument, variables: variables }
    }
export const GetWaterlyConnectSubmissionHistoryDocument = /*#__PURE__*/ gql`
    query GetWaterlyConnectSubmissionHistory($options: EdgeDeviceSubmissionSearchOptions!) {
  waterlyConnectSubmissionHistory(options: $options) {
    edgeDevice {
      ...EdgeDevice
    }
    ...EdgeDeviceSubmission
  }
}
    ${EdgeDeviceFragmentDoc}
${EdgeDeviceSubmissionFragmentDoc}`;

/**
 * __useGetWaterlyConnectSubmissionHistoryQuery__
 *
 * To run a query within a React component, call `useGetWaterlyConnectSubmissionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaterlyConnectSubmissionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaterlyConnectSubmissionHistoryQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetWaterlyConnectSubmissionHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetWaterlyConnectSubmissionHistoryQuery, GetWaterlyConnectSubmissionHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWaterlyConnectSubmissionHistoryQuery, GetWaterlyConnectSubmissionHistoryQueryVariables>(GetWaterlyConnectSubmissionHistoryDocument, options);
      }
export function useGetWaterlyConnectSubmissionHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWaterlyConnectSubmissionHistoryQuery, GetWaterlyConnectSubmissionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWaterlyConnectSubmissionHistoryQuery, GetWaterlyConnectSubmissionHistoryQueryVariables>(GetWaterlyConnectSubmissionHistoryDocument, options);
        }
export type GetWaterlyConnectSubmissionHistoryQueryHookResult = ReturnType<typeof useGetWaterlyConnectSubmissionHistoryQuery>;
export type GetWaterlyConnectSubmissionHistoryLazyQueryHookResult = ReturnType<typeof useGetWaterlyConnectSubmissionHistoryLazyQuery>;
export type GetWaterlyConnectSubmissionHistoryQueryResult = Apollo.QueryResult<GetWaterlyConnectSubmissionHistoryQuery, GetWaterlyConnectSubmissionHistoryQueryVariables>;
export function refetchGetWaterlyConnectSubmissionHistoryQuery(variables: GetWaterlyConnectSubmissionHistoryQueryVariables) {
      return { query: GetWaterlyConnectSubmissionHistoryDocument, variables: variables }
    }
export const HasLinkedServiceReportEnterpriseReportDocument = /*#__PURE__*/ gql`
    query HasLinkedServiceReportEnterpriseReport($siteId: Int!) {
  hasLinkedServiceReportEnterpriseReport(siteId: $siteId)
}
    `;

/**
 * __useHasLinkedServiceReportEnterpriseReportQuery__
 *
 * To run a query within a React component, call `useHasLinkedServiceReportEnterpriseReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasLinkedServiceReportEnterpriseReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasLinkedServiceReportEnterpriseReportQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useHasLinkedServiceReportEnterpriseReportQuery(baseOptions: Apollo.QueryHookOptions<HasLinkedServiceReportEnterpriseReportQuery, HasLinkedServiceReportEnterpriseReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasLinkedServiceReportEnterpriseReportQuery, HasLinkedServiceReportEnterpriseReportQueryVariables>(HasLinkedServiceReportEnterpriseReportDocument, options);
      }
export function useHasLinkedServiceReportEnterpriseReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasLinkedServiceReportEnterpriseReportQuery, HasLinkedServiceReportEnterpriseReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasLinkedServiceReportEnterpriseReportQuery, HasLinkedServiceReportEnterpriseReportQueryVariables>(HasLinkedServiceReportEnterpriseReportDocument, options);
        }
export type HasLinkedServiceReportEnterpriseReportQueryHookResult = ReturnType<typeof useHasLinkedServiceReportEnterpriseReportQuery>;
export type HasLinkedServiceReportEnterpriseReportLazyQueryHookResult = ReturnType<typeof useHasLinkedServiceReportEnterpriseReportLazyQuery>;
export type HasLinkedServiceReportEnterpriseReportQueryResult = Apollo.QueryResult<HasLinkedServiceReportEnterpriseReportQuery, HasLinkedServiceReportEnterpriseReportQueryVariables>;
export function refetchHasLinkedServiceReportEnterpriseReportQuery(variables: HasLinkedServiceReportEnterpriseReportQueryVariables) {
      return { query: HasLinkedServiceReportEnterpriseReportDocument, variables: variables }
    }
export const LabImportBatchDocument = /*#__PURE__*/ gql`
    query LabImportBatch($id: UUID!) {
  labImportBatch(id: $id) {
    ...LabImportBatch
  }
}
    ${LabImportBatchFragmentDoc}`;

/**
 * __useLabImportBatchQuery__
 *
 * To run a query within a React component, call `useLabImportBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabImportBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabImportBatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLabImportBatchQuery(baseOptions: Apollo.QueryHookOptions<LabImportBatchQuery, LabImportBatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabImportBatchQuery, LabImportBatchQueryVariables>(LabImportBatchDocument, options);
      }
export function useLabImportBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabImportBatchQuery, LabImportBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabImportBatchQuery, LabImportBatchQueryVariables>(LabImportBatchDocument, options);
        }
export type LabImportBatchQueryHookResult = ReturnType<typeof useLabImportBatchQuery>;
export type LabImportBatchLazyQueryHookResult = ReturnType<typeof useLabImportBatchLazyQuery>;
export type LabImportBatchQueryResult = Apollo.QueryResult<LabImportBatchQuery, LabImportBatchQueryVariables>;
export function refetchLabImportBatchQuery(variables: LabImportBatchQueryVariables) {
      return { query: LabImportBatchDocument, variables: variables }
    }
export const LabImportBatchResumeDocument = /*#__PURE__*/ gql`
    query LabImportBatchResume($id: UUID!) {
  labImportBatchResume(id: $id) {
    batch {
      ...LabImportBatch
    }
    pendingProfile {
      ...LabImportPendingProfile
    }
  }
}
    ${LabImportBatchFragmentDoc}
${LabImportPendingProfileFragmentDoc}`;

/**
 * __useLabImportBatchResumeQuery__
 *
 * To run a query within a React component, call `useLabImportBatchResumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabImportBatchResumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabImportBatchResumeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLabImportBatchResumeQuery(baseOptions: Apollo.QueryHookOptions<LabImportBatchResumeQuery, LabImportBatchResumeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabImportBatchResumeQuery, LabImportBatchResumeQueryVariables>(LabImportBatchResumeDocument, options);
      }
export function useLabImportBatchResumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabImportBatchResumeQuery, LabImportBatchResumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabImportBatchResumeQuery, LabImportBatchResumeQueryVariables>(LabImportBatchResumeDocument, options);
        }
export type LabImportBatchResumeQueryHookResult = ReturnType<typeof useLabImportBatchResumeQuery>;
export type LabImportBatchResumeLazyQueryHookResult = ReturnType<typeof useLabImportBatchResumeLazyQuery>;
export type LabImportBatchResumeQueryResult = Apollo.QueryResult<LabImportBatchResumeQuery, LabImportBatchResumeQueryVariables>;
export function refetchLabImportBatchResumeQuery(variables: LabImportBatchResumeQueryVariables) {
      return { query: LabImportBatchResumeDocument, variables: variables }
    }
export const LabImportBatchesDocument = /*#__PURE__*/ gql`
    query LabImportBatches($input: LabImportBatchesInput!) {
  labImportBatches(input: $input) {
    count
    items {
      committedAt
      committedRowCount
      createdAt
      fileLength
      fileName
      id
      invalidRowCount
      profileName
      reconciliationRequiredRowCount
      skippedRowCount
      status
      totalRowCount
      validRowCount
    }
  }
}
    `;

/**
 * __useLabImportBatchesQuery__
 *
 * To run a query within a React component, call `useLabImportBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabImportBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabImportBatchesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLabImportBatchesQuery(baseOptions: Apollo.QueryHookOptions<LabImportBatchesQuery, LabImportBatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabImportBatchesQuery, LabImportBatchesQueryVariables>(LabImportBatchesDocument, options);
      }
export function useLabImportBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabImportBatchesQuery, LabImportBatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabImportBatchesQuery, LabImportBatchesQueryVariables>(LabImportBatchesDocument, options);
        }
export type LabImportBatchesQueryHookResult = ReturnType<typeof useLabImportBatchesQuery>;
export type LabImportBatchesLazyQueryHookResult = ReturnType<typeof useLabImportBatchesLazyQuery>;
export type LabImportBatchesQueryResult = Apollo.QueryResult<LabImportBatchesQuery, LabImportBatchesQueryVariables>;
export function refetchLabImportBatchesQuery(variables: LabImportBatchesQueryVariables) {
      return { query: LabImportBatchesDocument, variables: variables }
    }
export const LabImportBootstrapDocument = /*#__PURE__*/ gql`
    query LabImportBootstrap($systemId: Int!) {
  labImportProfiles(systemId: $systemId) {
    ...LabImportProfile
  }
  labImportTargets(systemId: $systemId) {
    metricId
    metricName
    metricUnitLabel
    siteId
    siteName
  }
}
    ${LabImportProfileFragmentDoc}`;

/**
 * __useLabImportBootstrapQuery__
 *
 * To run a query within a React component, call `useLabImportBootstrapQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabImportBootstrapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabImportBootstrapQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useLabImportBootstrapQuery(baseOptions: Apollo.QueryHookOptions<LabImportBootstrapQuery, LabImportBootstrapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabImportBootstrapQuery, LabImportBootstrapQueryVariables>(LabImportBootstrapDocument, options);
      }
export function useLabImportBootstrapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabImportBootstrapQuery, LabImportBootstrapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabImportBootstrapQuery, LabImportBootstrapQueryVariables>(LabImportBootstrapDocument, options);
        }
export type LabImportBootstrapQueryHookResult = ReturnType<typeof useLabImportBootstrapQuery>;
export type LabImportBootstrapLazyQueryHookResult = ReturnType<typeof useLabImportBootstrapLazyQuery>;
export type LabImportBootstrapQueryResult = Apollo.QueryResult<LabImportBootstrapQuery, LabImportBootstrapQueryVariables>;
export function refetchLabImportBootstrapQuery(variables: LabImportBootstrapQueryVariables) {
      return { query: LabImportBootstrapDocument, variables: variables }
    }
export const LabImportFileDownloadDocument = /*#__PURE__*/ gql`
    query LabImportFileDownload($batchId: UUID!) {
  labImportFileDownload(batchId: $batchId) {
    downloadUrl
    fileName
    mimeType
  }
}
    `;

/**
 * __useLabImportFileDownloadQuery__
 *
 * To run a query within a React component, call `useLabImportFileDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabImportFileDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabImportFileDownloadQuery({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useLabImportFileDownloadQuery(baseOptions: Apollo.QueryHookOptions<LabImportFileDownloadQuery, LabImportFileDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabImportFileDownloadQuery, LabImportFileDownloadQueryVariables>(LabImportFileDownloadDocument, options);
      }
export function useLabImportFileDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabImportFileDownloadQuery, LabImportFileDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabImportFileDownloadQuery, LabImportFileDownloadQueryVariables>(LabImportFileDownloadDocument, options);
        }
export type LabImportFileDownloadQueryHookResult = ReturnType<typeof useLabImportFileDownloadQuery>;
export type LabImportFileDownloadLazyQueryHookResult = ReturnType<typeof useLabImportFileDownloadLazyQuery>;
export type LabImportFileDownloadQueryResult = Apollo.QueryResult<LabImportFileDownloadQuery, LabImportFileDownloadQueryVariables>;
export function refetchLabImportFileDownloadQuery(variables: LabImportFileDownloadQueryVariables) {
      return { query: LabImportFileDownloadDocument, variables: variables }
    }
export const LabImportRowsDocument = /*#__PURE__*/ gql`
    query LabImportRows($input: LabImportRowsInput!) {
  labImportRows(input: $input) {
    count
    items {
      ...LabImportRow
    }
  }
}
    ${LabImportRowFragmentDoc}`;

/**
 * __useLabImportRowsQuery__
 *
 * To run a query within a React component, call `useLabImportRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabImportRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabImportRowsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLabImportRowsQuery(baseOptions: Apollo.QueryHookOptions<LabImportRowsQuery, LabImportRowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabImportRowsQuery, LabImportRowsQueryVariables>(LabImportRowsDocument, options);
      }
export function useLabImportRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabImportRowsQuery, LabImportRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabImportRowsQuery, LabImportRowsQueryVariables>(LabImportRowsDocument, options);
        }
export type LabImportRowsQueryHookResult = ReturnType<typeof useLabImportRowsQuery>;
export type LabImportRowsLazyQueryHookResult = ReturnType<typeof useLabImportRowsLazyQuery>;
export type LabImportRowsQueryResult = Apollo.QueryResult<LabImportRowsQuery, LabImportRowsQueryVariables>;
export function refetchLabImportRowsQuery(variables: LabImportRowsQueryVariables) {
      return { query: LabImportRowsDocument, variables: variables }
    }
export const LabImportSourceGroupsDocument = /*#__PURE__*/ gql`
    query LabImportSourceGroups($input: LabImportSourceGroupsInput!) {
  labImportSourceGroups(input: $input) {
    analyte
    project
    rowCount
    sampleSite
    unit
  }
}
    `;

/**
 * __useLabImportSourceGroupsQuery__
 *
 * To run a query within a React component, call `useLabImportSourceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabImportSourceGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabImportSourceGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLabImportSourceGroupsQuery(baseOptions: Apollo.QueryHookOptions<LabImportSourceGroupsQuery, LabImportSourceGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabImportSourceGroupsQuery, LabImportSourceGroupsQueryVariables>(LabImportSourceGroupsDocument, options);
      }
export function useLabImportSourceGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabImportSourceGroupsQuery, LabImportSourceGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabImportSourceGroupsQuery, LabImportSourceGroupsQueryVariables>(LabImportSourceGroupsDocument, options);
        }
export type LabImportSourceGroupsQueryHookResult = ReturnType<typeof useLabImportSourceGroupsQuery>;
export type LabImportSourceGroupsLazyQueryHookResult = ReturnType<typeof useLabImportSourceGroupsLazyQuery>;
export type LabImportSourceGroupsQueryResult = Apollo.QueryResult<LabImportSourceGroupsQuery, LabImportSourceGroupsQueryVariables>;
export function refetchLabImportSourceGroupsQuery(variables: LabImportSourceGroupsQueryVariables) {
      return { query: LabImportSourceGroupsDocument, variables: variables }
    }
export const LatestServiceReportSnapshotBySiteAndReportDateDocument = /*#__PURE__*/ gql`
    query LatestServiceReportSnapshotBySiteAndReportDate($input: LatestServiceReportSnapshotBySiteAndReportDateInput!) {
  latestServiceReportSnapshotBySiteAndReportDate(input: $input) {
    enterpriseReportId
    id
    name
    reportDateTime
    status
    updatedAt
  }
}
    `;

/**
 * __useLatestServiceReportSnapshotBySiteAndReportDateQuery__
 *
 * To run a query within a React component, call `useLatestServiceReportSnapshotBySiteAndReportDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestServiceReportSnapshotBySiteAndReportDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestServiceReportSnapshotBySiteAndReportDateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLatestServiceReportSnapshotBySiteAndReportDateQuery(baseOptions: Apollo.QueryHookOptions<LatestServiceReportSnapshotBySiteAndReportDateQuery, LatestServiceReportSnapshotBySiteAndReportDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestServiceReportSnapshotBySiteAndReportDateQuery, LatestServiceReportSnapshotBySiteAndReportDateQueryVariables>(LatestServiceReportSnapshotBySiteAndReportDateDocument, options);
      }
export function useLatestServiceReportSnapshotBySiteAndReportDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestServiceReportSnapshotBySiteAndReportDateQuery, LatestServiceReportSnapshotBySiteAndReportDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestServiceReportSnapshotBySiteAndReportDateQuery, LatestServiceReportSnapshotBySiteAndReportDateQueryVariables>(LatestServiceReportSnapshotBySiteAndReportDateDocument, options);
        }
export type LatestServiceReportSnapshotBySiteAndReportDateQueryHookResult = ReturnType<typeof useLatestServiceReportSnapshotBySiteAndReportDateQuery>;
export type LatestServiceReportSnapshotBySiteAndReportDateLazyQueryHookResult = ReturnType<typeof useLatestServiceReportSnapshotBySiteAndReportDateLazyQuery>;
export type LatestServiceReportSnapshotBySiteAndReportDateQueryResult = Apollo.QueryResult<LatestServiceReportSnapshotBySiteAndReportDateQuery, LatestServiceReportSnapshotBySiteAndReportDateQueryVariables>;
export function refetchLatestServiceReportSnapshotBySiteAndReportDateQuery(variables: LatestServiceReportSnapshotBySiteAndReportDateQueryVariables) {
      return { query: LatestServiceReportSnapshotBySiteAndReportDateDocument, variables: variables }
    }
export const LogBookEntriesDocument = /*#__PURE__*/ gql`
    query LogBookEntries($input: LogBookEntriesInput!) {
  logBookEntries(input: $input) {
    ...LogBookEntryListItem
  }
}
    ${LogBookEntryListItemFragmentDoc}`;

/**
 * __useLogBookEntriesQuery__
 *
 * To run a query within a React component, call `useLogBookEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogBookEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogBookEntriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogBookEntriesQuery(baseOptions: Apollo.QueryHookOptions<LogBookEntriesQuery, LogBookEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogBookEntriesQuery, LogBookEntriesQueryVariables>(LogBookEntriesDocument, options);
      }
export function useLogBookEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogBookEntriesQuery, LogBookEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogBookEntriesQuery, LogBookEntriesQueryVariables>(LogBookEntriesDocument, options);
        }
export type LogBookEntriesQueryHookResult = ReturnType<typeof useLogBookEntriesQuery>;
export type LogBookEntriesLazyQueryHookResult = ReturnType<typeof useLogBookEntriesLazyQuery>;
export type LogBookEntriesQueryResult = Apollo.QueryResult<LogBookEntriesQuery, LogBookEntriesQueryVariables>;
export function refetchLogBookEntriesQuery(variables: LogBookEntriesQueryVariables) {
      return { query: LogBookEntriesDocument, variables: variables }
    }
export const LogBookEntriesWithCountDocument = /*#__PURE__*/ gql`
    query LogBookEntriesWithCount($input: LogBookEntriesInput!) {
  logBookEntriesWithCount(input: $input) {
    count
    items {
      attachments {
        components {
          ...ComponentNest
        }
        metrics {
          ...MetricNest
        }
        processes {
          ...ProcessNest
        }
        sites {
          ...SiteNest
        }
        systems {
          ...SystemNest
        }
        tags {
          ...Tag
        }
        uploads {
          ...Uploads
        }
      }
      ...LogBookEntry
      user {
        ...UserNest
      }
    }
  }
}
    ${ComponentNestFragmentDoc}
${MetricNestFragmentDoc}
${ProcessNestFragmentDoc}
${SiteNestFragmentDoc}
${SystemNestFragmentDoc}
${TagFragmentDoc}
${UploadsFragmentDoc}
${LogBookEntryFragmentDoc}
${UserNestFragmentDoc}`;

/**
 * __useLogBookEntriesWithCountQuery__
 *
 * To run a query within a React component, call `useLogBookEntriesWithCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogBookEntriesWithCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogBookEntriesWithCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogBookEntriesWithCountQuery(baseOptions: Apollo.QueryHookOptions<LogBookEntriesWithCountQuery, LogBookEntriesWithCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogBookEntriesWithCountQuery, LogBookEntriesWithCountQueryVariables>(LogBookEntriesWithCountDocument, options);
      }
export function useLogBookEntriesWithCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogBookEntriesWithCountQuery, LogBookEntriesWithCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogBookEntriesWithCountQuery, LogBookEntriesWithCountQueryVariables>(LogBookEntriesWithCountDocument, options);
        }
export type LogBookEntriesWithCountQueryHookResult = ReturnType<typeof useLogBookEntriesWithCountQuery>;
export type LogBookEntriesWithCountLazyQueryHookResult = ReturnType<typeof useLogBookEntriesWithCountLazyQuery>;
export type LogBookEntriesWithCountQueryResult = Apollo.QueryResult<LogBookEntriesWithCountQuery, LogBookEntriesWithCountQueryVariables>;
export function refetchLogBookEntriesWithCountQuery(variables: LogBookEntriesWithCountQueryVariables) {
      return { query: LogBookEntriesWithCountDocument, variables: variables }
    }
export const LogBookEntryByIdDocument = /*#__PURE__*/ gql`
    query LogBookEntryById($logBookEntryId: UUID!, $withDeleted: Boolean) {
  logBookEntryById(id: $logBookEntryId, withDeleted: $withDeleted) {
    ...LogBookEntry
    user {
      ...UserNest
    }
  }
}
    ${LogBookEntryFragmentDoc}
${UserNestFragmentDoc}`;

/**
 * __useLogBookEntryByIdQuery__
 *
 * To run a query within a React component, call `useLogBookEntryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogBookEntryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogBookEntryByIdQuery({
 *   variables: {
 *      logBookEntryId: // value for 'logBookEntryId'
 *      withDeleted: // value for 'withDeleted'
 *   },
 * });
 */
export function useLogBookEntryByIdQuery(baseOptions: Apollo.QueryHookOptions<LogBookEntryByIdQuery, LogBookEntryByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogBookEntryByIdQuery, LogBookEntryByIdQueryVariables>(LogBookEntryByIdDocument, options);
      }
export function useLogBookEntryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogBookEntryByIdQuery, LogBookEntryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogBookEntryByIdQuery, LogBookEntryByIdQueryVariables>(LogBookEntryByIdDocument, options);
        }
export type LogBookEntryByIdQueryHookResult = ReturnType<typeof useLogBookEntryByIdQuery>;
export type LogBookEntryByIdLazyQueryHookResult = ReturnType<typeof useLogBookEntryByIdLazyQuery>;
export type LogBookEntryByIdQueryResult = Apollo.QueryResult<LogBookEntryByIdQuery, LogBookEntryByIdQueryVariables>;
export function refetchLogBookEntryByIdQuery(variables: LogBookEntryByIdQueryVariables) {
      return { query: LogBookEntryByIdDocument, variables: variables }
    }
export const LogBookEntryDashboardViewByUserIdDocument = /*#__PURE__*/ gql`
    query LogBookEntryDashboardViewByUserId($input: LogBookEntryDashboardViewByUserIdInput!) {
  logBookEntryDashboardViewByUserId(input: $input) {
    ...LogBookEntryDashboardView
  }
}
    ${LogBookEntryDashboardViewFragmentDoc}`;

/**
 * __useLogBookEntryDashboardViewByUserIdQuery__
 *
 * To run a query within a React component, call `useLogBookEntryDashboardViewByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogBookEntryDashboardViewByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogBookEntryDashboardViewByUserIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogBookEntryDashboardViewByUserIdQuery(baseOptions: Apollo.QueryHookOptions<LogBookEntryDashboardViewByUserIdQuery, LogBookEntryDashboardViewByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogBookEntryDashboardViewByUserIdQuery, LogBookEntryDashboardViewByUserIdQueryVariables>(LogBookEntryDashboardViewByUserIdDocument, options);
      }
export function useLogBookEntryDashboardViewByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogBookEntryDashboardViewByUserIdQuery, LogBookEntryDashboardViewByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogBookEntryDashboardViewByUserIdQuery, LogBookEntryDashboardViewByUserIdQueryVariables>(LogBookEntryDashboardViewByUserIdDocument, options);
        }
export type LogBookEntryDashboardViewByUserIdQueryHookResult = ReturnType<typeof useLogBookEntryDashboardViewByUserIdQuery>;
export type LogBookEntryDashboardViewByUserIdLazyQueryHookResult = ReturnType<typeof useLogBookEntryDashboardViewByUserIdLazyQuery>;
export type LogBookEntryDashboardViewByUserIdQueryResult = Apollo.QueryResult<LogBookEntryDashboardViewByUserIdQuery, LogBookEntryDashboardViewByUserIdQueryVariables>;
export function refetchLogBookEntryDashboardViewByUserIdQuery(variables: LogBookEntryDashboardViewByUserIdQueryVariables) {
      return { query: LogBookEntryDashboardViewByUserIdDocument, variables: variables }
    }
export const ManualReportEmailSharingScopeDocument = /*#__PURE__*/ gql`
    query ManualReportEmailSharingScope($reportSnapshotId: UUID!) {
  manualReportEmailSharingScope(reportSnapshotId: $reportSnapshotId) {
    organizationId
    organizationName
    scope
    siteId
    systemId
  }
}
    `;

/**
 * __useManualReportEmailSharingScopeQuery__
 *
 * To run a query within a React component, call `useManualReportEmailSharingScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useManualReportEmailSharingScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManualReportEmailSharingScopeQuery({
 *   variables: {
 *      reportSnapshotId: // value for 'reportSnapshotId'
 *   },
 * });
 */
export function useManualReportEmailSharingScopeQuery(baseOptions: Apollo.QueryHookOptions<ManualReportEmailSharingScopeQuery, ManualReportEmailSharingScopeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManualReportEmailSharingScopeQuery, ManualReportEmailSharingScopeQueryVariables>(ManualReportEmailSharingScopeDocument, options);
      }
export function useManualReportEmailSharingScopeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManualReportEmailSharingScopeQuery, ManualReportEmailSharingScopeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManualReportEmailSharingScopeQuery, ManualReportEmailSharingScopeQueryVariables>(ManualReportEmailSharingScopeDocument, options);
        }
export type ManualReportEmailSharingScopeQueryHookResult = ReturnType<typeof useManualReportEmailSharingScopeQuery>;
export type ManualReportEmailSharingScopeLazyQueryHookResult = ReturnType<typeof useManualReportEmailSharingScopeLazyQuery>;
export type ManualReportEmailSharingScopeQueryResult = Apollo.QueryResult<ManualReportEmailSharingScopeQuery, ManualReportEmailSharingScopeQueryVariables>;
export function refetchManualReportEmailSharingScopeQuery(variables: ManualReportEmailSharingScopeQueryVariables) {
      return { query: ManualReportEmailSharingScopeDocument, variables: variables }
    }
export const MetricKeynameWithCountDocument = /*#__PURE__*/ gql`
    query MetricKeynameWithCount($input: MetricKeynameInput!) {
  metricKeynamesWithCount(input: $input) {
    count
    items {
      compliance
      createdAt
      deletedAt
      description
      id
      name
      systemTypes
      tags {
        ...Tag
      }
      units {
        ...UnitNest
      }
      updatedAt
    }
  }
}
    ${TagFragmentDoc}
${UnitNestFragmentDoc}`;

/**
 * __useMetricKeynameWithCountQuery__
 *
 * To run a query within a React component, call `useMetricKeynameWithCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricKeynameWithCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricKeynameWithCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMetricKeynameWithCountQuery(baseOptions: Apollo.QueryHookOptions<MetricKeynameWithCountQuery, MetricKeynameWithCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricKeynameWithCountQuery, MetricKeynameWithCountQueryVariables>(MetricKeynameWithCountDocument, options);
      }
export function useMetricKeynameWithCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricKeynameWithCountQuery, MetricKeynameWithCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricKeynameWithCountQuery, MetricKeynameWithCountQueryVariables>(MetricKeynameWithCountDocument, options);
        }
export type MetricKeynameWithCountQueryHookResult = ReturnType<typeof useMetricKeynameWithCountQuery>;
export type MetricKeynameWithCountLazyQueryHookResult = ReturnType<typeof useMetricKeynameWithCountLazyQuery>;
export type MetricKeynameWithCountQueryResult = Apollo.QueryResult<MetricKeynameWithCountQuery, MetricKeynameWithCountQueryVariables>;
export function refetchMetricKeynameWithCountQuery(variables: MetricKeynameWithCountQueryVariables) {
      return { query: MetricKeynameWithCountDocument, variables: variables }
    }
export const MetricKeynamesWithCountAndMetricCountDocument = /*#__PURE__*/ gql`
    query MetricKeynamesWithCountAndMetricCount($input: MetricKeynameInput!) {
  metricKeynamesWithCount(input: $input) {
    count
    items {
      compliance
      createdAt
      deletedAt
      description
      id
      metricsCount
      name
      systemTypes
      tags {
        ...Tag
      }
      units {
        ...UnitNest
      }
      updatedAt
    }
  }
}
    ${TagFragmentDoc}
${UnitNestFragmentDoc}`;

/**
 * __useMetricKeynamesWithCountAndMetricCountQuery__
 *
 * To run a query within a React component, call `useMetricKeynamesWithCountAndMetricCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricKeynamesWithCountAndMetricCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricKeynamesWithCountAndMetricCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMetricKeynamesWithCountAndMetricCountQuery(baseOptions: Apollo.QueryHookOptions<MetricKeynamesWithCountAndMetricCountQuery, MetricKeynamesWithCountAndMetricCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricKeynamesWithCountAndMetricCountQuery, MetricKeynamesWithCountAndMetricCountQueryVariables>(MetricKeynamesWithCountAndMetricCountDocument, options);
      }
export function useMetricKeynamesWithCountAndMetricCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricKeynamesWithCountAndMetricCountQuery, MetricKeynamesWithCountAndMetricCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricKeynamesWithCountAndMetricCountQuery, MetricKeynamesWithCountAndMetricCountQueryVariables>(MetricKeynamesWithCountAndMetricCountDocument, options);
        }
export type MetricKeynamesWithCountAndMetricCountQueryHookResult = ReturnType<typeof useMetricKeynamesWithCountAndMetricCountQuery>;
export type MetricKeynamesWithCountAndMetricCountLazyQueryHookResult = ReturnType<typeof useMetricKeynamesWithCountAndMetricCountLazyQuery>;
export type MetricKeynamesWithCountAndMetricCountQueryResult = Apollo.QueryResult<MetricKeynamesWithCountAndMetricCountQuery, MetricKeynamesWithCountAndMetricCountQueryVariables>;
export function refetchMetricKeynamesWithCountAndMetricCountQuery(variables: MetricKeynamesWithCountAndMetricCountQueryVariables) {
      return { query: MetricKeynamesWithCountAndMetricCountDocument, variables: variables }
    }
export const MetricRangesForCloneDocument = /*#__PURE__*/ gql`
    query MetricRangesForClone($metricId: Int!) {
  metricById(metricId: $metricId) {
    id
    metricRanges {
      ...MetricRange
    }
    metricRangeType
  }
}
    ${MetricRangeFragmentDoc}`;

/**
 * __useMetricRangesForCloneQuery__
 *
 * To run a query within a React component, call `useMetricRangesForCloneQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricRangesForCloneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricRangesForCloneQuery({
 *   variables: {
 *      metricId: // value for 'metricId'
 *   },
 * });
 */
export function useMetricRangesForCloneQuery(baseOptions: Apollo.QueryHookOptions<MetricRangesForCloneQuery, MetricRangesForCloneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricRangesForCloneQuery, MetricRangesForCloneQueryVariables>(MetricRangesForCloneDocument, options);
      }
export function useMetricRangesForCloneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricRangesForCloneQuery, MetricRangesForCloneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricRangesForCloneQuery, MetricRangesForCloneQueryVariables>(MetricRangesForCloneDocument, options);
        }
export type MetricRangesForCloneQueryHookResult = ReturnType<typeof useMetricRangesForCloneQuery>;
export type MetricRangesForCloneLazyQueryHookResult = ReturnType<typeof useMetricRangesForCloneLazyQuery>;
export type MetricRangesForCloneQueryResult = Apollo.QueryResult<MetricRangesForCloneQuery, MetricRangesForCloneQueryVariables>;
export function refetchMetricRangesForCloneQuery(variables: MetricRangesForCloneQueryVariables) {
      return { query: MetricRangesForCloneDocument, variables: variables }
    }
export const MetricsBySiteProcessComponentDocument = /*#__PURE__*/ gql`
    query MetricsBySiteProcessComponent($input: MetricsInput!) {
  metricsBySiteProcessComponent(input: $input) {
    displayNameBreadcrumbs {
      key
      value
    }
    id
    name
  }
}
    `;

/**
 * __useMetricsBySiteProcessComponentQuery__
 *
 * To run a query within a React component, call `useMetricsBySiteProcessComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricsBySiteProcessComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricsBySiteProcessComponentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMetricsBySiteProcessComponentQuery(baseOptions: Apollo.QueryHookOptions<MetricsBySiteProcessComponentQuery, MetricsBySiteProcessComponentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricsBySiteProcessComponentQuery, MetricsBySiteProcessComponentQueryVariables>(MetricsBySiteProcessComponentDocument, options);
      }
export function useMetricsBySiteProcessComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricsBySiteProcessComponentQuery, MetricsBySiteProcessComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricsBySiteProcessComponentQuery, MetricsBySiteProcessComponentQueryVariables>(MetricsBySiteProcessComponentDocument, options);
        }
export type MetricsBySiteProcessComponentQueryHookResult = ReturnType<typeof useMetricsBySiteProcessComponentQuery>;
export type MetricsBySiteProcessComponentLazyQueryHookResult = ReturnType<typeof useMetricsBySiteProcessComponentLazyQuery>;
export type MetricsBySiteProcessComponentQueryResult = Apollo.QueryResult<MetricsBySiteProcessComponentQuery, MetricsBySiteProcessComponentQueryVariables>;
export function refetchMetricsBySiteProcessComponentQuery(variables: MetricsBySiteProcessComponentQueryVariables) {
      return { query: MetricsBySiteProcessComponentDocument, variables: variables }
    }
export const MetricsBySystemIdsDocument = /*#__PURE__*/ gql`
    query MetricsBySystemIds($input: MetricsBySystemIdsInput!) {
  metricsBySystemIds(input: $input) {
    belowRlValue
    calculated
    calculationName
    canBeAveraged
    canBeCounted
    canBeMaximized
    canBeMinimized
    canBeTotaled
    component {
      ...ComponentNest
    }
    componentId
    copyPreviousValueEnabled
    createdAt
    dataPointCommentPolicy
    dataType
    debug
    deletedAt
    detectionLimit
    displayName
    expression
    hideFromDataEntry
    id
    internalKeyname
    interpolated
    intervals {
      ...IntervalNest
    }
    isDecreasing
    isIncreasing
    isLockedByWaterly
    isReportComments
    isWaterlyConnected
    maxValue
    minValue
    name
    notificationEnabled
    order
    precision
    process {
      ...ProcessNest
    }
    processId
    rangeMax
    rangeMin
    reportingLimit
    required
    site {
      ...SiteNest
    }
    treatBelowRlAsPercent
    unit {
      ...UnitNest
    }
    unitId
    updatedAt
    updatesPriorDay
  }
}
    ${ComponentNestFragmentDoc}
${IntervalNestFragmentDoc}
${ProcessNestFragmentDoc}
${SiteNestFragmentDoc}
${UnitNestFragmentDoc}`;

/**
 * __useMetricsBySystemIdsQuery__
 *
 * To run a query within a React component, call `useMetricsBySystemIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricsBySystemIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricsBySystemIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMetricsBySystemIdsQuery(baseOptions: Apollo.QueryHookOptions<MetricsBySystemIdsQuery, MetricsBySystemIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricsBySystemIdsQuery, MetricsBySystemIdsQueryVariables>(MetricsBySystemIdsDocument, options);
      }
export function useMetricsBySystemIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricsBySystemIdsQuery, MetricsBySystemIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricsBySystemIdsQuery, MetricsBySystemIdsQueryVariables>(MetricsBySystemIdsDocument, options);
        }
export type MetricsBySystemIdsQueryHookResult = ReturnType<typeof useMetricsBySystemIdsQuery>;
export type MetricsBySystemIdsLazyQueryHookResult = ReturnType<typeof useMetricsBySystemIdsLazyQuery>;
export type MetricsBySystemIdsQueryResult = Apollo.QueryResult<MetricsBySystemIdsQuery, MetricsBySystemIdsQueryVariables>;
export function refetchMetricsBySystemIdsQuery(variables: MetricsBySystemIdsQueryVariables) {
      return { query: MetricsBySystemIdsDocument, variables: variables }
    }
export const MetricsForSelectDocument = /*#__PURE__*/ gql`
    query MetricsForSelect($input: MetricsBySystemIdsInput!) {
  metricsBySystemIds(input: $input) {
    canBeAveraged
    canBeMaximized
    canBeMinimized
    canBeTotaled
    component {
      id
      name
      order
    }
    dataType
    displayName
    id
    internalKeyname
    intervals {
      id
    }
    name
    order
    precision
    process {
      id
      name
      order
    }
    site {
      id
      name
      order
      systemId
    }
    unit {
      id
      name
    }
  }
}
    `;

/**
 * __useMetricsForSelectQuery__
 *
 * To run a query within a React component, call `useMetricsForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricsForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricsForSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMetricsForSelectQuery(baseOptions: Apollo.QueryHookOptions<MetricsForSelectQuery, MetricsForSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricsForSelectQuery, MetricsForSelectQueryVariables>(MetricsForSelectDocument, options);
      }
export function useMetricsForSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricsForSelectQuery, MetricsForSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricsForSelectQuery, MetricsForSelectQueryVariables>(MetricsForSelectDocument, options);
        }
export type MetricsForSelectQueryHookResult = ReturnType<typeof useMetricsForSelectQuery>;
export type MetricsForSelectLazyQueryHookResult = ReturnType<typeof useMetricsForSelectLazyQuery>;
export type MetricsForSelectQueryResult = Apollo.QueryResult<MetricsForSelectQuery, MetricsForSelectQueryVariables>;
export function refetchMetricsForSelectQuery(variables: MetricsForSelectQueryVariables) {
      return { query: MetricsForSelectDocument, variables: variables }
    }
export const MetricsWithDownstreamCalcCountsDocument = /*#__PURE__*/ gql`
    query MetricsWithDownstreamCalcCounts($input: MetricsWithDownstreamCalcCountsInput!) {
  metricsWithDownstreamCalcCounts(input: $input) {
    downstreamCalcCount
    id
    name
  }
}
    `;

/**
 * __useMetricsWithDownstreamCalcCountsQuery__
 *
 * To run a query within a React component, call `useMetricsWithDownstreamCalcCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricsWithDownstreamCalcCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricsWithDownstreamCalcCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMetricsWithDownstreamCalcCountsQuery(baseOptions: Apollo.QueryHookOptions<MetricsWithDownstreamCalcCountsQuery, MetricsWithDownstreamCalcCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricsWithDownstreamCalcCountsQuery, MetricsWithDownstreamCalcCountsQueryVariables>(MetricsWithDownstreamCalcCountsDocument, options);
      }
export function useMetricsWithDownstreamCalcCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricsWithDownstreamCalcCountsQuery, MetricsWithDownstreamCalcCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricsWithDownstreamCalcCountsQuery, MetricsWithDownstreamCalcCountsQueryVariables>(MetricsWithDownstreamCalcCountsDocument, options);
        }
export type MetricsWithDownstreamCalcCountsQueryHookResult = ReturnType<typeof useMetricsWithDownstreamCalcCountsQuery>;
export type MetricsWithDownstreamCalcCountsLazyQueryHookResult = ReturnType<typeof useMetricsWithDownstreamCalcCountsLazyQuery>;
export type MetricsWithDownstreamCalcCountsQueryResult = Apollo.QueryResult<MetricsWithDownstreamCalcCountsQuery, MetricsWithDownstreamCalcCountsQueryVariables>;
export function refetchMetricsWithDownstreamCalcCountsQuery(variables: MetricsWithDownstreamCalcCountsQueryVariables) {
      return { query: MetricsWithDownstreamCalcCountsDocument, variables: variables }
    }
export const NotificationsDocument = /*#__PURE__*/ gql`
    query Notifications($input: NotificationsInput!) {
  notifications(input: $input) {
    count
    items {
      ...Notification
    }
  }
}
    ${NotificationFragmentDoc}`;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export function refetchNotificationsQuery(variables: NotificationsQueryVariables) {
      return { query: NotificationsDocument, variables: variables }
    }
export const OrganizationDocument = /*#__PURE__*/ gql`
    query Organization($organizationId: Int!) {
  organization(organizationId: $organizationId) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export function refetchOrganizationQuery(variables: OrganizationQueryVariables) {
      return { query: OrganizationDocument, variables: variables }
    }
export const OrganizationIntegrationsDocument = /*#__PURE__*/ gql`
    query OrganizationIntegrations {
  organizationIntegrations {
    createdAt
    credentialsSecretReference
    id
    integrationType
    organizationId
    tokenExpiresAt
    tokenId
    updatedAt
  }
}
    `;

/**
 * __useOrganizationIntegrationsQuery__
 *
 * To run a query within a React component, call `useOrganizationIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationIntegrationsQuery, OrganizationIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationIntegrationsQuery, OrganizationIntegrationsQueryVariables>(OrganizationIntegrationsDocument, options);
      }
export function useOrganizationIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationIntegrationsQuery, OrganizationIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationIntegrationsQuery, OrganizationIntegrationsQueryVariables>(OrganizationIntegrationsDocument, options);
        }
export type OrganizationIntegrationsQueryHookResult = ReturnType<typeof useOrganizationIntegrationsQuery>;
export type OrganizationIntegrationsLazyQueryHookResult = ReturnType<typeof useOrganizationIntegrationsLazyQuery>;
export type OrganizationIntegrationsQueryResult = Apollo.QueryResult<OrganizationIntegrationsQuery, OrganizationIntegrationsQueryVariables>;
export function refetchOrganizationIntegrationsQuery(variables?: OrganizationIntegrationsQueryVariables) {
      return { query: OrganizationIntegrationsDocument, variables: variables }
    }
export const OrganizationWithSystemGroupsAndSystemsDocument = /*#__PURE__*/ gql`
    query OrganizationWithSystemGroupsAndSystems($organizationId: Int!) {
  organization(organizationId: $organizationId) {
    addresses {
      ...Address
    }
    ...Organization
    systemGroups {
      ...SystemGroup
      systems {
        ...System
      }
    }
  }
}
    ${AddressFragmentDoc}
${OrganizationFragmentDoc}
${SystemGroupFragmentDoc}
${SystemFragmentDoc}`;

/**
 * __useOrganizationWithSystemGroupsAndSystemsQuery__
 *
 * To run a query within a React component, call `useOrganizationWithSystemGroupsAndSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationWithSystemGroupsAndSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationWithSystemGroupsAndSystemsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationWithSystemGroupsAndSystemsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationWithSystemGroupsAndSystemsQuery, OrganizationWithSystemGroupsAndSystemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationWithSystemGroupsAndSystemsQuery, OrganizationWithSystemGroupsAndSystemsQueryVariables>(OrganizationWithSystemGroupsAndSystemsDocument, options);
      }
export function useOrganizationWithSystemGroupsAndSystemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationWithSystemGroupsAndSystemsQuery, OrganizationWithSystemGroupsAndSystemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationWithSystemGroupsAndSystemsQuery, OrganizationWithSystemGroupsAndSystemsQueryVariables>(OrganizationWithSystemGroupsAndSystemsDocument, options);
        }
export type OrganizationWithSystemGroupsAndSystemsQueryHookResult = ReturnType<typeof useOrganizationWithSystemGroupsAndSystemsQuery>;
export type OrganizationWithSystemGroupsAndSystemsLazyQueryHookResult = ReturnType<typeof useOrganizationWithSystemGroupsAndSystemsLazyQuery>;
export type OrganizationWithSystemGroupsAndSystemsQueryResult = Apollo.QueryResult<OrganizationWithSystemGroupsAndSystemsQuery, OrganizationWithSystemGroupsAndSystemsQueryVariables>;
export function refetchOrganizationWithSystemGroupsAndSystemsQuery(variables: OrganizationWithSystemGroupsAndSystemsQueryVariables) {
      return { query: OrganizationWithSystemGroupsAndSystemsDocument, variables: variables }
    }
export const OrganizationsWithSystemGroupsAndSystemsDocument = /*#__PURE__*/ gql`
    query OrganizationsWithSystemGroupsAndSystems {
  organizationsWithSystemGroupsAndSystems {
    ...Organization
    systemGroups {
      ...SystemGroup
      systems {
        ...System
      }
    }
  }
}
    ${OrganizationFragmentDoc}
${SystemGroupFragmentDoc}
${SystemFragmentDoc}`;

/**
 * __useOrganizationsWithSystemGroupsAndSystemsQuery__
 *
 * To run a query within a React component, call `useOrganizationsWithSystemGroupsAndSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsWithSystemGroupsAndSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsWithSystemGroupsAndSystemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationsWithSystemGroupsAndSystemsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationsWithSystemGroupsAndSystemsQuery, OrganizationsWithSystemGroupsAndSystemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsWithSystemGroupsAndSystemsQuery, OrganizationsWithSystemGroupsAndSystemsQueryVariables>(OrganizationsWithSystemGroupsAndSystemsDocument, options);
      }
export function useOrganizationsWithSystemGroupsAndSystemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsWithSystemGroupsAndSystemsQuery, OrganizationsWithSystemGroupsAndSystemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsWithSystemGroupsAndSystemsQuery, OrganizationsWithSystemGroupsAndSystemsQueryVariables>(OrganizationsWithSystemGroupsAndSystemsDocument, options);
        }
export type OrganizationsWithSystemGroupsAndSystemsQueryHookResult = ReturnType<typeof useOrganizationsWithSystemGroupsAndSystemsQuery>;
export type OrganizationsWithSystemGroupsAndSystemsLazyQueryHookResult = ReturnType<typeof useOrganizationsWithSystemGroupsAndSystemsLazyQuery>;
export type OrganizationsWithSystemGroupsAndSystemsQueryResult = Apollo.QueryResult<OrganizationsWithSystemGroupsAndSystemsQuery, OrganizationsWithSystemGroupsAndSystemsQueryVariables>;
export function refetchOrganizationsWithSystemGroupsAndSystemsQuery(variables?: OrganizationsWithSystemGroupsAndSystemsQueryVariables) {
      return { query: OrganizationsWithSystemGroupsAndSystemsDocument, variables: variables }
    }
export const PermitByIdDocument = /*#__PURE__*/ gql`
    query PermitById($permitId: UUID!) {
  permitById(permitId: $permitId) {
    ...Permit
  }
}
    ${PermitFragmentDoc}`;

/**
 * __usePermitByIdQuery__
 *
 * To run a query within a React component, call `usePermitByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermitByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermitByIdQuery({
 *   variables: {
 *      permitId: // value for 'permitId'
 *   },
 * });
 */
export function usePermitByIdQuery(baseOptions: Apollo.QueryHookOptions<PermitByIdQuery, PermitByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermitByIdQuery, PermitByIdQueryVariables>(PermitByIdDocument, options);
      }
export function usePermitByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermitByIdQuery, PermitByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermitByIdQuery, PermitByIdQueryVariables>(PermitByIdDocument, options);
        }
export type PermitByIdQueryHookResult = ReturnType<typeof usePermitByIdQuery>;
export type PermitByIdLazyQueryHookResult = ReturnType<typeof usePermitByIdLazyQuery>;
export type PermitByIdQueryResult = Apollo.QueryResult<PermitByIdQuery, PermitByIdQueryVariables>;
export function refetchPermitByIdQuery(variables: PermitByIdQueryVariables) {
      return { query: PermitByIdDocument, variables: variables }
    }
export const PermitsDocument = /*#__PURE__*/ gql`
    query Permits($input: PermitsInput!) {
  permits(input: $input) {
    ...Permit
  }
}
    ${PermitFragmentDoc}`;

/**
 * __usePermitsQuery__
 *
 * To run a query within a React component, call `usePermitsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermitsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePermitsQuery(baseOptions: Apollo.QueryHookOptions<PermitsQuery, PermitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermitsQuery, PermitsQueryVariables>(PermitsDocument, options);
      }
export function usePermitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermitsQuery, PermitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermitsQuery, PermitsQueryVariables>(PermitsDocument, options);
        }
export type PermitsQueryHookResult = ReturnType<typeof usePermitsQuery>;
export type PermitsLazyQueryHookResult = ReturnType<typeof usePermitsLazyQuery>;
export type PermitsQueryResult = Apollo.QueryResult<PermitsQuery, PermitsQueryVariables>;
export function refetchPermitsQuery(variables: PermitsQueryVariables) {
      return { query: PermitsDocument, variables: variables }
    }
export const PhrasesDocument = /*#__PURE__*/ gql`
    query Phrases($input: PhrasesInput!) {
  phrases(input: $input) {
    ...Phrase
  }
}
    ${PhraseFragmentDoc}`;

/**
 * __usePhrasesQuery__
 *
 * To run a query within a React component, call `usePhrasesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhrasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhrasesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePhrasesQuery(baseOptions: Apollo.QueryHookOptions<PhrasesQuery, PhrasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhrasesQuery, PhrasesQueryVariables>(PhrasesDocument, options);
      }
export function usePhrasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhrasesQuery, PhrasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhrasesQuery, PhrasesQueryVariables>(PhrasesDocument, options);
        }
export type PhrasesQueryHookResult = ReturnType<typeof usePhrasesQuery>;
export type PhrasesLazyQueryHookResult = ReturnType<typeof usePhrasesLazyQuery>;
export type PhrasesQueryResult = Apollo.QueryResult<PhrasesQuery, PhrasesQueryVariables>;
export function refetchPhrasesQuery(variables: PhrasesQueryVariables) {
      return { query: PhrasesDocument, variables: variables }
    }
export const ProcessComponentsDocument = /*#__PURE__*/ gql`
    query ProcessComponents($processId: Int!) {
  process(processId: $processId) {
    components {
      ...Component
    }
    id
  }
}
    ${ComponentFragmentDoc}`;

/**
 * __useProcessComponentsQuery__
 *
 * To run a query within a React component, call `useProcessComponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessComponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessComponentsQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useProcessComponentsQuery(baseOptions: Apollo.QueryHookOptions<ProcessComponentsQuery, ProcessComponentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessComponentsQuery, ProcessComponentsQueryVariables>(ProcessComponentsDocument, options);
      }
export function useProcessComponentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessComponentsQuery, ProcessComponentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessComponentsQuery, ProcessComponentsQueryVariables>(ProcessComponentsDocument, options);
        }
export type ProcessComponentsQueryHookResult = ReturnType<typeof useProcessComponentsQuery>;
export type ProcessComponentsLazyQueryHookResult = ReturnType<typeof useProcessComponentsLazyQuery>;
export type ProcessComponentsQueryResult = Apollo.QueryResult<ProcessComponentsQuery, ProcessComponentsQueryVariables>;
export function refetchProcessComponentsQuery(variables: ProcessComponentsQueryVariables) {
      return { query: ProcessComponentsDocument, variables: variables }
    }
export const ProcessesAndComponentsBySiteIdDocument = /*#__PURE__*/ gql`
    query ProcessesAndComponentsBySiteId($siteId: Int!) {
  siteV2(siteId: $siteId) {
    components {
      ...ComponentNest
    }
    id
    processes {
      ...ProcessNest
    }
  }
}
    ${ComponentNestFragmentDoc}
${ProcessNestFragmentDoc}`;

/**
 * __useProcessesAndComponentsBySiteIdQuery__
 *
 * To run a query within a React component, call `useProcessesAndComponentsBySiteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessesAndComponentsBySiteIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessesAndComponentsBySiteIdQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useProcessesAndComponentsBySiteIdQuery(baseOptions: Apollo.QueryHookOptions<ProcessesAndComponentsBySiteIdQuery, ProcessesAndComponentsBySiteIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessesAndComponentsBySiteIdQuery, ProcessesAndComponentsBySiteIdQueryVariables>(ProcessesAndComponentsBySiteIdDocument, options);
      }
export function useProcessesAndComponentsBySiteIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessesAndComponentsBySiteIdQuery, ProcessesAndComponentsBySiteIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessesAndComponentsBySiteIdQuery, ProcessesAndComponentsBySiteIdQueryVariables>(ProcessesAndComponentsBySiteIdDocument, options);
        }
export type ProcessesAndComponentsBySiteIdQueryHookResult = ReturnType<typeof useProcessesAndComponentsBySiteIdQuery>;
export type ProcessesAndComponentsBySiteIdLazyQueryHookResult = ReturnType<typeof useProcessesAndComponentsBySiteIdLazyQuery>;
export type ProcessesAndComponentsBySiteIdQueryResult = Apollo.QueryResult<ProcessesAndComponentsBySiteIdQuery, ProcessesAndComponentsBySiteIdQueryVariables>;
export function refetchProcessesAndComponentsBySiteIdQuery(variables: ProcessesAndComponentsBySiteIdQueryVariables) {
      return { query: ProcessesAndComponentsBySiteIdDocument, variables: variables }
    }
export const RecentEntryIntervalsBySiteIdDocument = /*#__PURE__*/ gql`
    query RecentEntryIntervalsBySiteId($beforeDate: Date, $includeServiceReportSnapshot: Boolean! = false, $limit: Int, $siteId: Int!, $skip: Int) {
  recentEntryIntervalsBySiteId(
    beforeDate: $beforeDate
    limit: $limit
    siteId: $siteId
    skip: $skip
  ) {
    count
    items {
      createdByUser {
        displayName
        email
        fullNameOrEmail
        id
      }
      ...IntervalNest
      recentEntryCompletion {
        ...DataEntryCompletion
        latestServiceReportSnapshot @include(if: $includeServiceReportSnapshot) {
          id
          status
        }
        user {
          displayName
          email
          fullNameOrEmail
          id
        }
      }
    }
  }
}
    ${IntervalNestFragmentDoc}
${DataEntryCompletionFragmentDoc}`;

/**
 * __useRecentEntryIntervalsBySiteIdQuery__
 *
 * To run a query within a React component, call `useRecentEntryIntervalsBySiteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentEntryIntervalsBySiteIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentEntryIntervalsBySiteIdQuery({
 *   variables: {
 *      beforeDate: // value for 'beforeDate'
 *      includeServiceReportSnapshot: // value for 'includeServiceReportSnapshot'
 *      limit: // value for 'limit'
 *      siteId: // value for 'siteId'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useRecentEntryIntervalsBySiteIdQuery(baseOptions: Apollo.QueryHookOptions<RecentEntryIntervalsBySiteIdQuery, RecentEntryIntervalsBySiteIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentEntryIntervalsBySiteIdQuery, RecentEntryIntervalsBySiteIdQueryVariables>(RecentEntryIntervalsBySiteIdDocument, options);
      }
export function useRecentEntryIntervalsBySiteIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentEntryIntervalsBySiteIdQuery, RecentEntryIntervalsBySiteIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentEntryIntervalsBySiteIdQuery, RecentEntryIntervalsBySiteIdQueryVariables>(RecentEntryIntervalsBySiteIdDocument, options);
        }
export type RecentEntryIntervalsBySiteIdQueryHookResult = ReturnType<typeof useRecentEntryIntervalsBySiteIdQuery>;
export type RecentEntryIntervalsBySiteIdLazyQueryHookResult = ReturnType<typeof useRecentEntryIntervalsBySiteIdLazyQuery>;
export type RecentEntryIntervalsBySiteIdQueryResult = Apollo.QueryResult<RecentEntryIntervalsBySiteIdQuery, RecentEntryIntervalsBySiteIdQueryVariables>;
export function refetchRecentEntryIntervalsBySiteIdQuery(variables: RecentEntryIntervalsBySiteIdQueryVariables) {
      return { query: RecentEntryIntervalsBySiteIdDocument, variables: variables }
    }
export const RegulatoryReportDefinitionsForGroupingDocument = /*#__PURE__*/ gql`
    query RegulatoryReportDefinitionsForGrouping($input: ReportDefinitionsForDiscoveryInput!) {
  regulatoryReportDefinitionsForGrouping(input: $input) {
    id
    name
    order
    outputTypes
    reportGroup {
      id
      name
      order
      systemId
    }
    reportGroupId
    reportType
    site {
      id
      name
    }
    siteId
    system {
      id
      name
      organizationId
      timeZone
    }
    systemId
  }
}
    `;

/**
 * __useRegulatoryReportDefinitionsForGroupingQuery__
 *
 * To run a query within a React component, call `useRegulatoryReportDefinitionsForGroupingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulatoryReportDefinitionsForGroupingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulatoryReportDefinitionsForGroupingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegulatoryReportDefinitionsForGroupingQuery(baseOptions: Apollo.QueryHookOptions<RegulatoryReportDefinitionsForGroupingQuery, RegulatoryReportDefinitionsForGroupingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulatoryReportDefinitionsForGroupingQuery, RegulatoryReportDefinitionsForGroupingQueryVariables>(RegulatoryReportDefinitionsForGroupingDocument, options);
      }
export function useRegulatoryReportDefinitionsForGroupingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulatoryReportDefinitionsForGroupingQuery, RegulatoryReportDefinitionsForGroupingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulatoryReportDefinitionsForGroupingQuery, RegulatoryReportDefinitionsForGroupingQueryVariables>(RegulatoryReportDefinitionsForGroupingDocument, options);
        }
export type RegulatoryReportDefinitionsForGroupingQueryHookResult = ReturnType<typeof useRegulatoryReportDefinitionsForGroupingQuery>;
export type RegulatoryReportDefinitionsForGroupingLazyQueryHookResult = ReturnType<typeof useRegulatoryReportDefinitionsForGroupingLazyQuery>;
export type RegulatoryReportDefinitionsForGroupingQueryResult = Apollo.QueryResult<RegulatoryReportDefinitionsForGroupingQuery, RegulatoryReportDefinitionsForGroupingQueryVariables>;
export function refetchRegulatoryReportDefinitionsForGroupingQuery(variables: RegulatoryReportDefinitionsForGroupingQueryVariables) {
      return { query: RegulatoryReportDefinitionsForGroupingDocument, variables: variables }
    }
export const ReportDataDocument = /*#__PURE__*/ gql`
    query ReportData($reportDefinitionId: Int!) {
  reportData(reportDefinitionId: $reportDefinitionId) {
    reportNodes {
      columnGroup {
        ...ColumnGroup
      }
      columnGroupId
      columnGroupItem {
        ...ColumnGroupItem
        sourceMetrics {
          id
          name
        }
      }
      columnGroupItemId
      createdAt
      deletedAt
      id
      metric {
        intervals {
          displayName
          id
          time
        }
        ...MetricNest
        metricRanges {
          maxTag {
            ...Tag
          }
          ...MetricRange
          minTag {
            ...Tag
          }
        }
      }
      metricId
      order
      parentId
      reportDefinitionId
      type
      updatedAt
    }
  }
}
    ${ColumnGroupFragmentDoc}
${ColumnGroupItemFragmentDoc}
${MetricNestFragmentDoc}
${TagFragmentDoc}
${MetricRangeFragmentDoc}`;

/**
 * __useReportDataQuery__
 *
 * To run a query within a React component, call `useReportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDataQuery({
 *   variables: {
 *      reportDefinitionId: // value for 'reportDefinitionId'
 *   },
 * });
 */
export function useReportDataQuery(baseOptions: Apollo.QueryHookOptions<ReportDataQuery, ReportDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDataQuery, ReportDataQueryVariables>(ReportDataDocument, options);
      }
export function useReportDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDataQuery, ReportDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDataQuery, ReportDataQueryVariables>(ReportDataDocument, options);
        }
export type ReportDataQueryHookResult = ReturnType<typeof useReportDataQuery>;
export type ReportDataLazyQueryHookResult = ReturnType<typeof useReportDataLazyQuery>;
export type ReportDataQueryResult = Apollo.QueryResult<ReportDataQuery, ReportDataQueryVariables>;
export function refetchReportDataQuery(variables: ReportDataQueryVariables) {
      return { query: ReportDataDocument, variables: variables }
    }
export const ReportDataForSiteDocument = /*#__PURE__*/ gql`
    query ReportDataForSite($reportDefinitionId: Int!) {
  reportDataForSite(reportDefinitionId: $reportDefinitionId) {
    metricsWithReportData {
      enabledForReport
      enabledIntervalId
      metricId
    }
    processesWithReportData {
      enabledForReport
      processId
    }
  }
}
    `;

/**
 * __useReportDataForSiteQuery__
 *
 * To run a query within a React component, call `useReportDataForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDataForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDataForSiteQuery({
 *   variables: {
 *      reportDefinitionId: // value for 'reportDefinitionId'
 *   },
 * });
 */
export function useReportDataForSiteQuery(baseOptions: Apollo.QueryHookOptions<ReportDataForSiteQuery, ReportDataForSiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDataForSiteQuery, ReportDataForSiteQueryVariables>(ReportDataForSiteDocument, options);
      }
export function useReportDataForSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDataForSiteQuery, ReportDataForSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDataForSiteQuery, ReportDataForSiteQueryVariables>(ReportDataForSiteDocument, options);
        }
export type ReportDataForSiteQueryHookResult = ReturnType<typeof useReportDataForSiteQuery>;
export type ReportDataForSiteLazyQueryHookResult = ReturnType<typeof useReportDataForSiteLazyQuery>;
export type ReportDataForSiteQueryResult = Apollo.QueryResult<ReportDataForSiteQuery, ReportDataForSiteQueryVariables>;
export function refetchReportDataForSiteQuery(variables: ReportDataForSiteQueryVariables) {
      return { query: ReportDataForSiteDocument, variables: variables }
    }
export const ReportDefinitionDiscoveryFilterCountsDocument = /*#__PURE__*/ gql`
    query ReportDefinitionDiscoveryFilterCounts($input: ReportDefinitionsForDiscoveryInput!) {
  reportDefinitionDiscoveryFilterCounts(input: $input) {
    frequencies {
      annual
      daily
      monthly
      other
      quarterly
    }
    scopes {
      component
      organization
      process
      site
      system
    }
  }
}
    `;

/**
 * __useReportDefinitionDiscoveryFilterCountsQuery__
 *
 * To run a query within a React component, call `useReportDefinitionDiscoveryFilterCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDefinitionDiscoveryFilterCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDefinitionDiscoveryFilterCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportDefinitionDiscoveryFilterCountsQuery(baseOptions: Apollo.QueryHookOptions<ReportDefinitionDiscoveryFilterCountsQuery, ReportDefinitionDiscoveryFilterCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDefinitionDiscoveryFilterCountsQuery, ReportDefinitionDiscoveryFilterCountsQueryVariables>(ReportDefinitionDiscoveryFilterCountsDocument, options);
      }
export function useReportDefinitionDiscoveryFilterCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDefinitionDiscoveryFilterCountsQuery, ReportDefinitionDiscoveryFilterCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDefinitionDiscoveryFilterCountsQuery, ReportDefinitionDiscoveryFilterCountsQueryVariables>(ReportDefinitionDiscoveryFilterCountsDocument, options);
        }
export type ReportDefinitionDiscoveryFilterCountsQueryHookResult = ReturnType<typeof useReportDefinitionDiscoveryFilterCountsQuery>;
export type ReportDefinitionDiscoveryFilterCountsLazyQueryHookResult = ReturnType<typeof useReportDefinitionDiscoveryFilterCountsLazyQuery>;
export type ReportDefinitionDiscoveryFilterCountsQueryResult = Apollo.QueryResult<ReportDefinitionDiscoveryFilterCountsQuery, ReportDefinitionDiscoveryFilterCountsQueryVariables>;
export function refetchReportDefinitionDiscoveryFilterCountsQuery(variables: ReportDefinitionDiscoveryFilterCountsQueryVariables) {
      return { query: ReportDefinitionDiscoveryFilterCountsDocument, variables: variables }
    }
export const ReportDefinitionHistorySnapshotsDocument = /*#__PURE__*/ gql`
    query ReportDefinitionHistorySnapshots($input: ReportSnapshotInput!) {
  reportSnapshotsWithCount(input: $input) {
    count
    items {
      ...ReportSnapshot
    }
  }
}
    ${ReportSnapshotFragmentDoc}`;

/**
 * __useReportDefinitionHistorySnapshotsQuery__
 *
 * To run a query within a React component, call `useReportDefinitionHistorySnapshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDefinitionHistorySnapshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDefinitionHistorySnapshotsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportDefinitionHistorySnapshotsQuery(baseOptions: Apollo.QueryHookOptions<ReportDefinitionHistorySnapshotsQuery, ReportDefinitionHistorySnapshotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDefinitionHistorySnapshotsQuery, ReportDefinitionHistorySnapshotsQueryVariables>(ReportDefinitionHistorySnapshotsDocument, options);
      }
export function useReportDefinitionHistorySnapshotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDefinitionHistorySnapshotsQuery, ReportDefinitionHistorySnapshotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDefinitionHistorySnapshotsQuery, ReportDefinitionHistorySnapshotsQueryVariables>(ReportDefinitionHistorySnapshotsDocument, options);
        }
export type ReportDefinitionHistorySnapshotsQueryHookResult = ReturnType<typeof useReportDefinitionHistorySnapshotsQuery>;
export type ReportDefinitionHistorySnapshotsLazyQueryHookResult = ReturnType<typeof useReportDefinitionHistorySnapshotsLazyQuery>;
export type ReportDefinitionHistorySnapshotsQueryResult = Apollo.QueryResult<ReportDefinitionHistorySnapshotsQuery, ReportDefinitionHistorySnapshotsQueryVariables>;
export function refetchReportDefinitionHistorySnapshotsQuery(variables: ReportDefinitionHistorySnapshotsQueryVariables) {
      return { query: ReportDefinitionHistorySnapshotsDocument, variables: variables }
    }
export const ReportDefinitionsForDiscoveryDocument = /*#__PURE__*/ gql`
    query ReportDefinitionsForDiscovery($input: ReportDefinitionsForDiscoveryInput!) {
  reportDefinitionsForDiscovery(input: $input) {
    count
    items {
      createdAt
      enterpriseReportId
      id
      isFlex
      latestSnapshotReportDateTime
      latestSnapshotStatus
      latestSnapshotUpdatedAt
      name
      order
      outputTypes
      recentSnapshots {
        enterpriseReportId
        id
        name
        reportDateTime
        status
        updatedAt
      }
      reportDefinitionId
      reportGroup {
        id
        name
        order
        systemId
      }
      reportGroupId
      reportSnapshotId
      reportType
      site {
        id
        name
      }
      siteId
      snapshotCount
      sourceType
      system {
        createdAt
        id
        name
        organizationId
        timeZone
      }
      systemId
    }
  }
}
    `;

/**
 * __useReportDefinitionsForDiscoveryQuery__
 *
 * To run a query within a React component, call `useReportDefinitionsForDiscoveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDefinitionsForDiscoveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDefinitionsForDiscoveryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportDefinitionsForDiscoveryQuery(baseOptions: Apollo.QueryHookOptions<ReportDefinitionsForDiscoveryQuery, ReportDefinitionsForDiscoveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDefinitionsForDiscoveryQuery, ReportDefinitionsForDiscoveryQueryVariables>(ReportDefinitionsForDiscoveryDocument, options);
      }
export function useReportDefinitionsForDiscoveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDefinitionsForDiscoveryQuery, ReportDefinitionsForDiscoveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDefinitionsForDiscoveryQuery, ReportDefinitionsForDiscoveryQueryVariables>(ReportDefinitionsForDiscoveryDocument, options);
        }
export type ReportDefinitionsForDiscoveryQueryHookResult = ReturnType<typeof useReportDefinitionsForDiscoveryQuery>;
export type ReportDefinitionsForDiscoveryLazyQueryHookResult = ReturnType<typeof useReportDefinitionsForDiscoveryLazyQuery>;
export type ReportDefinitionsForDiscoveryQueryResult = Apollo.QueryResult<ReportDefinitionsForDiscoveryQuery, ReportDefinitionsForDiscoveryQueryVariables>;
export function refetchReportDefinitionsForDiscoveryQuery(variables: ReportDefinitionsForDiscoveryQueryVariables) {
      return { query: ReportDefinitionsForDiscoveryDocument, variables: variables }
    }
export const ReportDistributionListsDocument = /*#__PURE__*/ gql`
    query ReportDistributionLists($input: ReportDistributionListsInput!) {
  reportDistributionLists(input: $input) {
    ...ReportDistributionList
  }
}
    ${ReportDistributionListFragmentDoc}`;

/**
 * __useReportDistributionListsQuery__
 *
 * To run a query within a React component, call `useReportDistributionListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDistributionListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDistributionListsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportDistributionListsQuery(baseOptions: Apollo.QueryHookOptions<ReportDistributionListsQuery, ReportDistributionListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDistributionListsQuery, ReportDistributionListsQueryVariables>(ReportDistributionListsDocument, options);
      }
export function useReportDistributionListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDistributionListsQuery, ReportDistributionListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDistributionListsQuery, ReportDistributionListsQueryVariables>(ReportDistributionListsDocument, options);
        }
export type ReportDistributionListsQueryHookResult = ReturnType<typeof useReportDistributionListsQuery>;
export type ReportDistributionListsLazyQueryHookResult = ReturnType<typeof useReportDistributionListsLazyQuery>;
export type ReportDistributionListsQueryResult = Apollo.QueryResult<ReportDistributionListsQuery, ReportDistributionListsQueryVariables>;
export function refetchReportDistributionListsQuery(variables: ReportDistributionListsQueryVariables) {
      return { query: ReportDistributionListsDocument, variables: variables }
    }
export const ReportSnapshotByIdDocument = /*#__PURE__*/ gql`
    query ReportSnapshotById($id: UUID!) {
  reportSnapshotById(id: $id) {
    ...ReportSnapshot
  }
}
    ${ReportSnapshotFragmentDoc}`;

/**
 * __useReportSnapshotByIdQuery__
 *
 * To run a query within a React component, call `useReportSnapshotByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportSnapshotByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSnapshotByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportSnapshotByIdQuery(baseOptions: Apollo.QueryHookOptions<ReportSnapshotByIdQuery, ReportSnapshotByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportSnapshotByIdQuery, ReportSnapshotByIdQueryVariables>(ReportSnapshotByIdDocument, options);
      }
export function useReportSnapshotByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportSnapshotByIdQuery, ReportSnapshotByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportSnapshotByIdQuery, ReportSnapshotByIdQueryVariables>(ReportSnapshotByIdDocument, options);
        }
export type ReportSnapshotByIdQueryHookResult = ReturnType<typeof useReportSnapshotByIdQuery>;
export type ReportSnapshotByIdLazyQueryHookResult = ReturnType<typeof useReportSnapshotByIdLazyQuery>;
export type ReportSnapshotByIdQueryResult = Apollo.QueryResult<ReportSnapshotByIdQuery, ReportSnapshotByIdQueryVariables>;
export function refetchReportSnapshotByIdQuery(variables: ReportSnapshotByIdQueryVariables) {
      return { query: ReportSnapshotByIdDocument, variables: variables }
    }
export const RetentionRisksDocument = /*#__PURE__*/ gql`
    query RetentionRisks($input: RetentionRisksInput!) {
  retentionRisks(input: $input) {
    organizationId
    organizationRetentionRisks {
      organization {
        id
        name
      }
      ...RetentionRiskNest
    }
    score
    systemRetentionRisks {
      organization {
        id
        name
      }
      ...RetentionRiskNest
    }
  }
}
    ${RetentionRiskNestFragmentDoc}`;

/**
 * __useRetentionRisksQuery__
 *
 * To run a query within a React component, call `useRetentionRisksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetentionRisksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetentionRisksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetentionRisksQuery(baseOptions: Apollo.QueryHookOptions<RetentionRisksQuery, RetentionRisksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetentionRisksQuery, RetentionRisksQueryVariables>(RetentionRisksDocument, options);
      }
export function useRetentionRisksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetentionRisksQuery, RetentionRisksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetentionRisksQuery, RetentionRisksQueryVariables>(RetentionRisksDocument, options);
        }
export type RetentionRisksQueryHookResult = ReturnType<typeof useRetentionRisksQuery>;
export type RetentionRisksLazyQueryHookResult = ReturnType<typeof useRetentionRisksLazyQuery>;
export type RetentionRisksQueryResult = Apollo.QueryResult<RetentionRisksQuery, RetentionRisksQueryVariables>;
export function refetchRetentionRisksQuery(variables: RetentionRisksQueryVariables) {
      return { query: RetentionRisksDocument, variables: variables }
    }
export const RoundsAssetsMappingsByEntitiesDocument = /*#__PURE__*/ gql`
    query RoundsAssetsMappingsByEntities($input: RoundsAssetsMappingsByEntitiesInput!) {
  roundsAssetsMappingsByEntities(input: $input) {
    assetsEntityId
    assetsEntityType
    assetsInstanceId
    id
    roundsEntityId
    roundsEntityType
    systemId
  }
}
    `;

/**
 * __useRoundsAssetsMappingsByEntitiesQuery__
 *
 * To run a query within a React component, call `useRoundsAssetsMappingsByEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoundsAssetsMappingsByEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoundsAssetsMappingsByEntitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRoundsAssetsMappingsByEntitiesQuery(baseOptions: Apollo.QueryHookOptions<RoundsAssetsMappingsByEntitiesQuery, RoundsAssetsMappingsByEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoundsAssetsMappingsByEntitiesQuery, RoundsAssetsMappingsByEntitiesQueryVariables>(RoundsAssetsMappingsByEntitiesDocument, options);
      }
export function useRoundsAssetsMappingsByEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoundsAssetsMappingsByEntitiesQuery, RoundsAssetsMappingsByEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoundsAssetsMappingsByEntitiesQuery, RoundsAssetsMappingsByEntitiesQueryVariables>(RoundsAssetsMappingsByEntitiesDocument, options);
        }
export type RoundsAssetsMappingsByEntitiesQueryHookResult = ReturnType<typeof useRoundsAssetsMappingsByEntitiesQuery>;
export type RoundsAssetsMappingsByEntitiesLazyQueryHookResult = ReturnType<typeof useRoundsAssetsMappingsByEntitiesLazyQuery>;
export type RoundsAssetsMappingsByEntitiesQueryResult = Apollo.QueryResult<RoundsAssetsMappingsByEntitiesQuery, RoundsAssetsMappingsByEntitiesQueryVariables>;
export function refetchRoundsAssetsMappingsByEntitiesQuery(variables: RoundsAssetsMappingsByEntitiesQueryVariables) {
      return { query: RoundsAssetsMappingsByEntitiesDocument, variables: variables }
    }
export const RoundsShiftNoteFormContextDocument = /*#__PURE__*/ gql`
    query RoundsShiftNoteFormContext($input: RoundsShiftNoteFormContextInput!) {
  roundsShiftNoteFormContext(input: $input) {
    asset {
      id
      name
    }
    assetChoices {
      componentId
      name
    }
    assigneeRoles {
      isUnassignedBucket
      roleId
      roleName
      users {
        label
        userId
      }
    }
    defaultDate
    defaultTime
    facility {
      id
      name
    }
    notifyAssignedByDefault
    sourceType
    system {
      id
      name
    }
    systemChoices {
      assets {
        componentId
        name
      }
      name
      processId
    }
  }
}
    `;

/**
 * __useRoundsShiftNoteFormContextQuery__
 *
 * To run a query within a React component, call `useRoundsShiftNoteFormContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoundsShiftNoteFormContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoundsShiftNoteFormContextQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRoundsShiftNoteFormContextQuery(baseOptions: Apollo.QueryHookOptions<RoundsShiftNoteFormContextQuery, RoundsShiftNoteFormContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoundsShiftNoteFormContextQuery, RoundsShiftNoteFormContextQueryVariables>(RoundsShiftNoteFormContextDocument, options);
      }
export function useRoundsShiftNoteFormContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoundsShiftNoteFormContextQuery, RoundsShiftNoteFormContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoundsShiftNoteFormContextQuery, RoundsShiftNoteFormContextQueryVariables>(RoundsShiftNoteFormContextDocument, options);
        }
export type RoundsShiftNoteFormContextQueryHookResult = ReturnType<typeof useRoundsShiftNoteFormContextQuery>;
export type RoundsShiftNoteFormContextLazyQueryHookResult = ReturnType<typeof useRoundsShiftNoteFormContextLazyQuery>;
export type RoundsShiftNoteFormContextQueryResult = Apollo.QueryResult<RoundsShiftNoteFormContextQuery, RoundsShiftNoteFormContextQueryVariables>;
export function refetchRoundsShiftNoteFormContextQuery(variables: RoundsShiftNoteFormContextQueryVariables) {
      return { query: RoundsShiftNoteFormContextDocument, variables: variables }
    }
export const RuntimeLoggersDocument = /*#__PURE__*/ gql`
    query RuntimeLoggers {
  runtimeLoggers {
    available
    complete
    loggers {
      defaults {
        instanceId
        lastSeenAt
        level
        role
      }
      name
      override {
        expiresAt
        level
        updatedAt
      }
      overrideStatus
      recent
    }
    observedAt
  }
}
    `;

/**
 * __useRuntimeLoggersQuery__
 *
 * To run a query within a React component, call `useRuntimeLoggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuntimeLoggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuntimeLoggersQuery({
 *   variables: {
 *   },
 * });
 */
export function useRuntimeLoggersQuery(baseOptions?: Apollo.QueryHookOptions<RuntimeLoggersQuery, RuntimeLoggersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuntimeLoggersQuery, RuntimeLoggersQueryVariables>(RuntimeLoggersDocument, options);
      }
export function useRuntimeLoggersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuntimeLoggersQuery, RuntimeLoggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuntimeLoggersQuery, RuntimeLoggersQueryVariables>(RuntimeLoggersDocument, options);
        }
export type RuntimeLoggersQueryHookResult = ReturnType<typeof useRuntimeLoggersQuery>;
export type RuntimeLoggersLazyQueryHookResult = ReturnType<typeof useRuntimeLoggersLazyQuery>;
export type RuntimeLoggersQueryResult = Apollo.QueryResult<RuntimeLoggersQuery, RuntimeLoggersQueryVariables>;
export function refetchRuntimeLoggersQuery(variables?: RuntimeLoggersQueryVariables) {
      return { query: RuntimeLoggersDocument, variables: variables }
    }
export const SampleCollectionByIdDocument = /*#__PURE__*/ gql`
    query SampleCollectionById($id: String!) {
  sampleCollectionById(id: $id) {
    currentCustody {
      relinquishedByUser {
        ...UserNest
      }
      relinquishedToUser {
        ...UserNest
      }
      ...SampleCollectionCustody
    }
    ...SampleCollection
    sampleCollectionResults {
      analyte {
        ...Analyte
      }
      ...SampleCollectionResult
    }
    sampleSite {
      ...SampleSite
    }
  }
}
    ${UserNestFragmentDoc}
${SampleCollectionCustodyFragmentDoc}
${SampleCollectionFragmentDoc}
${AnalyteFragmentDoc}
${SampleCollectionResultFragmentDoc}
${SampleSiteFragmentDoc}`;

/**
 * __useSampleCollectionByIdQuery__
 *
 * To run a query within a React component, call `useSampleCollectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSampleCollectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSampleCollectionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSampleCollectionByIdQuery(baseOptions: Apollo.QueryHookOptions<SampleCollectionByIdQuery, SampleCollectionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SampleCollectionByIdQuery, SampleCollectionByIdQueryVariables>(SampleCollectionByIdDocument, options);
      }
export function useSampleCollectionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SampleCollectionByIdQuery, SampleCollectionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SampleCollectionByIdQuery, SampleCollectionByIdQueryVariables>(SampleCollectionByIdDocument, options);
        }
export type SampleCollectionByIdQueryHookResult = ReturnType<typeof useSampleCollectionByIdQuery>;
export type SampleCollectionByIdLazyQueryHookResult = ReturnType<typeof useSampleCollectionByIdLazyQuery>;
export type SampleCollectionByIdQueryResult = Apollo.QueryResult<SampleCollectionByIdQuery, SampleCollectionByIdQueryVariables>;
export function refetchSampleCollectionByIdQuery(variables: SampleCollectionByIdQueryVariables) {
      return { query: SampleCollectionByIdDocument, variables: variables }
    }
export const SampleCollectionCustodiesDocument = /*#__PURE__*/ gql`
    query SampleCollectionCustodies($input: SampleCollectionCustodiesInput!) {
  sampleCollectionCustodies(input: $input) {
    count
    items {
      ...SampleCollectionCustody
    }
  }
}
    ${SampleCollectionCustodyFragmentDoc}`;

/**
 * __useSampleCollectionCustodiesQuery__
 *
 * To run a query within a React component, call `useSampleCollectionCustodiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSampleCollectionCustodiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSampleCollectionCustodiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSampleCollectionCustodiesQuery(baseOptions: Apollo.QueryHookOptions<SampleCollectionCustodiesQuery, SampleCollectionCustodiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SampleCollectionCustodiesQuery, SampleCollectionCustodiesQueryVariables>(SampleCollectionCustodiesDocument, options);
      }
export function useSampleCollectionCustodiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SampleCollectionCustodiesQuery, SampleCollectionCustodiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SampleCollectionCustodiesQuery, SampleCollectionCustodiesQueryVariables>(SampleCollectionCustodiesDocument, options);
        }
export type SampleCollectionCustodiesQueryHookResult = ReturnType<typeof useSampleCollectionCustodiesQuery>;
export type SampleCollectionCustodiesLazyQueryHookResult = ReturnType<typeof useSampleCollectionCustodiesLazyQuery>;
export type SampleCollectionCustodiesQueryResult = Apollo.QueryResult<SampleCollectionCustodiesQuery, SampleCollectionCustodiesQueryVariables>;
export function refetchSampleCollectionCustodiesQuery(variables: SampleCollectionCustodiesQueryVariables) {
      return { query: SampleCollectionCustodiesDocument, variables: variables }
    }
export const SampleCollectionsDocument = /*#__PURE__*/ gql`
    query SampleCollections($input: SampleCollectionsInput!) {
  sampleCollections(input: $input) {
    count
    items {
      currentCustody {
        relinquishedByUser {
          ...UserNest
        }
        relinquishedToUser {
          ...UserNest
        }
        ...SampleCollectionCustody
      }
      ...SampleCollection
    }
  }
}
    ${UserNestFragmentDoc}
${SampleCollectionCustodyFragmentDoc}
${SampleCollectionFragmentDoc}`;

/**
 * __useSampleCollectionsQuery__
 *
 * To run a query within a React component, call `useSampleCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSampleCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSampleCollectionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSampleCollectionsQuery(baseOptions: Apollo.QueryHookOptions<SampleCollectionsQuery, SampleCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SampleCollectionsQuery, SampleCollectionsQueryVariables>(SampleCollectionsDocument, options);
      }
export function useSampleCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SampleCollectionsQuery, SampleCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SampleCollectionsQuery, SampleCollectionsQueryVariables>(SampleCollectionsDocument, options);
        }
export type SampleCollectionsQueryHookResult = ReturnType<typeof useSampleCollectionsQuery>;
export type SampleCollectionsLazyQueryHookResult = ReturnType<typeof useSampleCollectionsLazyQuery>;
export type SampleCollectionsQueryResult = Apollo.QueryResult<SampleCollectionsQuery, SampleCollectionsQueryVariables>;
export function refetchSampleCollectionsQuery(variables: SampleCollectionsQueryVariables) {
      return { query: SampleCollectionsDocument, variables: variables }
    }
export const SampleScheduleByIdDocument = /*#__PURE__*/ gql`
    query SampleScheduleById($id: String!) {
  sampleScheduleById(id: $id) {
    ...SampleSchedule
  }
}
    ${SampleScheduleFragmentDoc}`;

/**
 * __useSampleScheduleByIdQuery__
 *
 * To run a query within a React component, call `useSampleScheduleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSampleScheduleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSampleScheduleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSampleScheduleByIdQuery(baseOptions: Apollo.QueryHookOptions<SampleScheduleByIdQuery, SampleScheduleByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SampleScheduleByIdQuery, SampleScheduleByIdQueryVariables>(SampleScheduleByIdDocument, options);
      }
export function useSampleScheduleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SampleScheduleByIdQuery, SampleScheduleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SampleScheduleByIdQuery, SampleScheduleByIdQueryVariables>(SampleScheduleByIdDocument, options);
        }
export type SampleScheduleByIdQueryHookResult = ReturnType<typeof useSampleScheduleByIdQuery>;
export type SampleScheduleByIdLazyQueryHookResult = ReturnType<typeof useSampleScheduleByIdLazyQuery>;
export type SampleScheduleByIdQueryResult = Apollo.QueryResult<SampleScheduleByIdQuery, SampleScheduleByIdQueryVariables>;
export function refetchSampleScheduleByIdQuery(variables: SampleScheduleByIdQueryVariables) {
      return { query: SampleScheduleByIdDocument, variables: variables }
    }
export const SampleSchedulesDocument = /*#__PURE__*/ gql`
    query SampleSchedules($input: SampleSchedulesInput!) {
  sampleSchedules(input: $input) {
    count
    items {
      analytes {
        ...Analyte
      }
      defaultAssignee {
        ...UserNest
      }
      ...SampleSchedule
      sampleSite {
        ...SampleSite
      }
      system {
        id
        isFavorite
        name
        organizationId
        parentSystemGroupId
        timeZone
        type
      }
    }
  }
}
    ${AnalyteFragmentDoc}
${UserNestFragmentDoc}
${SampleScheduleFragmentDoc}
${SampleSiteFragmentDoc}`;

/**
 * __useSampleSchedulesQuery__
 *
 * To run a query within a React component, call `useSampleSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSampleSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSampleSchedulesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSampleSchedulesQuery(baseOptions: Apollo.QueryHookOptions<SampleSchedulesQuery, SampleSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SampleSchedulesQuery, SampleSchedulesQueryVariables>(SampleSchedulesDocument, options);
      }
export function useSampleSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SampleSchedulesQuery, SampleSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SampleSchedulesQuery, SampleSchedulesQueryVariables>(SampleSchedulesDocument, options);
        }
export type SampleSchedulesQueryHookResult = ReturnType<typeof useSampleSchedulesQuery>;
export type SampleSchedulesLazyQueryHookResult = ReturnType<typeof useSampleSchedulesLazyQuery>;
export type SampleSchedulesQueryResult = Apollo.QueryResult<SampleSchedulesQuery, SampleSchedulesQueryVariables>;
export function refetchSampleSchedulesQuery(variables: SampleSchedulesQueryVariables) {
      return { query: SampleSchedulesDocument, variables: variables }
    }
export const SampleSiteByIdDocument = /*#__PURE__*/ gql`
    query SampleSiteById($id: String!) {
  sampleSiteById(id: $id) {
    ...SampleSite
  }
}
    ${SampleSiteFragmentDoc}`;

/**
 * __useSampleSiteByIdQuery__
 *
 * To run a query within a React component, call `useSampleSiteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSampleSiteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSampleSiteByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSampleSiteByIdQuery(baseOptions: Apollo.QueryHookOptions<SampleSiteByIdQuery, SampleSiteByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SampleSiteByIdQuery, SampleSiteByIdQueryVariables>(SampleSiteByIdDocument, options);
      }
export function useSampleSiteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SampleSiteByIdQuery, SampleSiteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SampleSiteByIdQuery, SampleSiteByIdQueryVariables>(SampleSiteByIdDocument, options);
        }
export type SampleSiteByIdQueryHookResult = ReturnType<typeof useSampleSiteByIdQuery>;
export type SampleSiteByIdLazyQueryHookResult = ReturnType<typeof useSampleSiteByIdLazyQuery>;
export type SampleSiteByIdQueryResult = Apollo.QueryResult<SampleSiteByIdQuery, SampleSiteByIdQueryVariables>;
export function refetchSampleSiteByIdQuery(variables: SampleSiteByIdQueryVariables) {
      return { query: SampleSiteByIdDocument, variables: variables }
    }
export const SampleSitesDocument = /*#__PURE__*/ gql`
    query SampleSites($input: SampleSitesInput!) {
  sampleSites(input: $input) {
    ...SampleSite
  }
}
    ${SampleSiteFragmentDoc}`;

/**
 * __useSampleSitesQuery__
 *
 * To run a query within a React component, call `useSampleSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSampleSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSampleSitesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSampleSitesQuery(baseOptions: Apollo.QueryHookOptions<SampleSitesQuery, SampleSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SampleSitesQuery, SampleSitesQueryVariables>(SampleSitesDocument, options);
      }
export function useSampleSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SampleSitesQuery, SampleSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SampleSitesQuery, SampleSitesQueryVariables>(SampleSitesDocument, options);
        }
export type SampleSitesQueryHookResult = ReturnType<typeof useSampleSitesQuery>;
export type SampleSitesLazyQueryHookResult = ReturnType<typeof useSampleSitesLazyQuery>;
export type SampleSitesQueryResult = Apollo.QueryResult<SampleSitesQuery, SampleSitesQueryVariables>;
export function refetchSampleSitesQuery(variables: SampleSitesQueryVariables) {
      return { query: SampleSitesDocument, variables: variables }
    }
export const ScheduledItemByIdDocument = /*#__PURE__*/ gql`
    query ScheduledItemById($id: String!) {
  getScheduledItemById(id: $id) {
    assignee {
      ...UserNest
    }
    comments {
      ...ScheduledItemComment
      user {
        ...UserNest
      }
    }
    ...ScheduledItem
  }
}
    ${UserNestFragmentDoc}
${ScheduledItemCommentFragmentDoc}
${ScheduledItemFragmentDoc}`;

/**
 * __useScheduledItemByIdQuery__
 *
 * To run a query within a React component, call `useScheduledItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledItemByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScheduledItemByIdQuery(baseOptions: Apollo.QueryHookOptions<ScheduledItemByIdQuery, ScheduledItemByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledItemByIdQuery, ScheduledItemByIdQueryVariables>(ScheduledItemByIdDocument, options);
      }
export function useScheduledItemByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledItemByIdQuery, ScheduledItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledItemByIdQuery, ScheduledItemByIdQueryVariables>(ScheduledItemByIdDocument, options);
        }
export type ScheduledItemByIdQueryHookResult = ReturnType<typeof useScheduledItemByIdQuery>;
export type ScheduledItemByIdLazyQueryHookResult = ReturnType<typeof useScheduledItemByIdLazyQuery>;
export type ScheduledItemByIdQueryResult = Apollo.QueryResult<ScheduledItemByIdQuery, ScheduledItemByIdQueryVariables>;
export function refetchScheduledItemByIdQuery(variables: ScheduledItemByIdQueryVariables) {
      return { query: ScheduledItemByIdDocument, variables: variables }
    }
export const ScheduledItemCountDocument = /*#__PURE__*/ gql`
    query ScheduledItemCount($input: ScheduledItemsInput!) {
  scheduledItemCount(input: $input) {
    count
  }
}
    `;

/**
 * __useScheduledItemCountQuery__
 *
 * To run a query within a React component, call `useScheduledItemCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledItemCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledItemCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduledItemCountQuery(baseOptions: Apollo.QueryHookOptions<ScheduledItemCountQuery, ScheduledItemCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledItemCountQuery, ScheduledItemCountQueryVariables>(ScheduledItemCountDocument, options);
      }
export function useScheduledItemCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledItemCountQuery, ScheduledItemCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledItemCountQuery, ScheduledItemCountQueryVariables>(ScheduledItemCountDocument, options);
        }
export type ScheduledItemCountQueryHookResult = ReturnType<typeof useScheduledItemCountQuery>;
export type ScheduledItemCountLazyQueryHookResult = ReturnType<typeof useScheduledItemCountLazyQuery>;
export type ScheduledItemCountQueryResult = Apollo.QueryResult<ScheduledItemCountQuery, ScheduledItemCountQueryVariables>;
export function refetchScheduledItemCountQuery(variables: ScheduledItemCountQueryVariables) {
      return { query: ScheduledItemCountDocument, variables: variables }
    }
export const ScheduledItemsDocument = /*#__PURE__*/ gql`
    query ScheduledItems($input: ScheduledItemsInput!) {
  getScheduledItems(input: $input) {
    count
    items {
      assignee {
        firstName
        id
        lastName
      }
      ...ScheduledItem
      system {
        id
        name
        timeZone
      }
    }
  }
}
    ${ScheduledItemFragmentDoc}`;

/**
 * __useScheduledItemsQuery__
 *
 * To run a query within a React component, call `useScheduledItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduledItemsQuery(baseOptions: Apollo.QueryHookOptions<ScheduledItemsQuery, ScheduledItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledItemsQuery, ScheduledItemsQueryVariables>(ScheduledItemsDocument, options);
      }
export function useScheduledItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledItemsQuery, ScheduledItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledItemsQuery, ScheduledItemsQueryVariables>(ScheduledItemsDocument, options);
        }
export type ScheduledItemsQueryHookResult = ReturnType<typeof useScheduledItemsQuery>;
export type ScheduledItemsLazyQueryHookResult = ReturnType<typeof useScheduledItemsLazyQuery>;
export type ScheduledItemsQueryResult = Apollo.QueryResult<ScheduledItemsQuery, ScheduledItemsQueryVariables>;
export function refetchScheduledItemsQuery(variables: ScheduledItemsQueryVariables) {
      return { query: ScheduledItemsDocument, variables: variables }
    }
export const SiteDataEntryCompletionByDateDocument = /*#__PURE__*/ gql`
    query SiteDataEntryCompletionByDate($input: SiteDataEntryCompletionByDateInput!) {
  siteDataEntryCompletionByDate(input: $input) {
    dailyCompletion {
      dataEntryCompletion {
        ...DataEntryCompletion
        user {
          ...UserNest
        }
      }
      hasRequiredMetrics
      interval {
        ...IntervalNest
      }
    }
    intervalCompletions {
      dataEntryCompletion {
        ...DataEntryCompletion
        user {
          ...UserNest
        }
      }
      hasRequiredMetrics
      interval {
        ...IntervalNest
      }
    }
    site {
      intervals {
        ...IntervalNest
      }
      ...SiteNest
    }
  }
}
    ${DataEntryCompletionFragmentDoc}
${UserNestFragmentDoc}
${IntervalNestFragmentDoc}
${SiteNestFragmentDoc}`;

/**
 * __useSiteDataEntryCompletionByDateQuery__
 *
 * To run a query within a React component, call `useSiteDataEntryCompletionByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteDataEntryCompletionByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteDataEntryCompletionByDateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSiteDataEntryCompletionByDateQuery(baseOptions: Apollo.QueryHookOptions<SiteDataEntryCompletionByDateQuery, SiteDataEntryCompletionByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteDataEntryCompletionByDateQuery, SiteDataEntryCompletionByDateQueryVariables>(SiteDataEntryCompletionByDateDocument, options);
      }
export function useSiteDataEntryCompletionByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteDataEntryCompletionByDateQuery, SiteDataEntryCompletionByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteDataEntryCompletionByDateQuery, SiteDataEntryCompletionByDateQueryVariables>(SiteDataEntryCompletionByDateDocument, options);
        }
export type SiteDataEntryCompletionByDateQueryHookResult = ReturnType<typeof useSiteDataEntryCompletionByDateQuery>;
export type SiteDataEntryCompletionByDateLazyQueryHookResult = ReturnType<typeof useSiteDataEntryCompletionByDateLazyQuery>;
export type SiteDataEntryCompletionByDateQueryResult = Apollo.QueryResult<SiteDataEntryCompletionByDateQuery, SiteDataEntryCompletionByDateQueryVariables>;
export function refetchSiteDataEntryCompletionByDateQuery(variables: SiteDataEntryCompletionByDateQueryVariables) {
      return { query: SiteDataEntryCompletionByDateDocument, variables: variables }
    }
export const SiteFlexMetricsDocument = /*#__PURE__*/ gql`
    query SiteFlexMetrics($input: SiteFlexMetricsInput!) {
  siteFlexMetrics(input: $input) {
    metric {
      deletedAt
      displayNameBreadcrumbs {
        key
        value
      }
      id
      internalKeyname
      name
      unit {
        id
        name
      }
    }
    ...SiteFlexMetric
  }
}
    ${SiteFlexMetricFragmentDoc}`;

/**
 * __useSiteFlexMetricsQuery__
 *
 * To run a query within a React component, call `useSiteFlexMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteFlexMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteFlexMetricsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSiteFlexMetricsQuery(baseOptions: Apollo.QueryHookOptions<SiteFlexMetricsQuery, SiteFlexMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteFlexMetricsQuery, SiteFlexMetricsQueryVariables>(SiteFlexMetricsDocument, options);
      }
export function useSiteFlexMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteFlexMetricsQuery, SiteFlexMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteFlexMetricsQuery, SiteFlexMetricsQueryVariables>(SiteFlexMetricsDocument, options);
        }
export type SiteFlexMetricsQueryHookResult = ReturnType<typeof useSiteFlexMetricsQuery>;
export type SiteFlexMetricsLazyQueryHookResult = ReturnType<typeof useSiteFlexMetricsLazyQuery>;
export type SiteFlexMetricsQueryResult = Apollo.QueryResult<SiteFlexMetricsQuery, SiteFlexMetricsQueryVariables>;
export function refetchSiteFlexMetricsQuery(variables: SiteFlexMetricsQueryVariables) {
      return { query: SiteFlexMetricsDocument, variables: variables }
    }
export const SiteProcessesDocument = /*#__PURE__*/ gql`
    query SiteProcesses($siteId: Int!) {
  site(siteId: $siteId) {
    id
    processes {
      ...Process
    }
  }
}
    ${ProcessFragmentDoc}`;

/**
 * __useSiteProcessesQuery__
 *
 * To run a query within a React component, call `useSiteProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteProcessesQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteProcessesQuery(baseOptions: Apollo.QueryHookOptions<SiteProcessesQuery, SiteProcessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteProcessesQuery, SiteProcessesQueryVariables>(SiteProcessesDocument, options);
      }
export function useSiteProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteProcessesQuery, SiteProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteProcessesQuery, SiteProcessesQueryVariables>(SiteProcessesDocument, options);
        }
export type SiteProcessesQueryHookResult = ReturnType<typeof useSiteProcessesQuery>;
export type SiteProcessesLazyQueryHookResult = ReturnType<typeof useSiteProcessesLazyQuery>;
export type SiteProcessesQueryResult = Apollo.QueryResult<SiteProcessesQuery, SiteProcessesQueryVariables>;
export function refetchSiteProcessesQuery(variables: SiteProcessesQueryVariables) {
      return { query: SiteProcessesDocument, variables: variables }
    }
export const SitesV2Document = /*#__PURE__*/ gql`
    query SitesV2($input: SitesInput!) {
  sitesV2(input: $input) {
    ...SiteNest
  }
}
    ${SiteNestFragmentDoc}`;

/**
 * __useSitesV2Query__
 *
 * To run a query within a React component, call `useSitesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useSitesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesV2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSitesV2Query(baseOptions: Apollo.QueryHookOptions<SitesV2Query, SitesV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesV2Query, SitesV2QueryVariables>(SitesV2Document, options);
      }
export function useSitesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesV2Query, SitesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesV2Query, SitesV2QueryVariables>(SitesV2Document, options);
        }
export type SitesV2QueryHookResult = ReturnType<typeof useSitesV2Query>;
export type SitesV2LazyQueryHookResult = ReturnType<typeof useSitesV2LazyQuery>;
export type SitesV2QueryResult = Apollo.QueryResult<SitesV2Query, SitesV2QueryVariables>;
export function refetchSitesV2Query(variables: SitesV2QueryVariables) {
      return { query: SitesV2Document, variables: variables }
    }
export const SourceMetricsBySystemIdDocument = /*#__PURE__*/ gql`
    query SourceMetricsBySystemId($systemId: Int!) {
  sourceMetricsBySystemId(systemId: $systemId) {
    id
    ...MetricWithCalculatedMetric
  }
}
    ${MetricWithCalculatedMetricFragmentDoc}`;

/**
 * __useSourceMetricsBySystemIdQuery__
 *
 * To run a query within a React component, call `useSourceMetricsBySystemIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceMetricsBySystemIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceMetricsBySystemIdQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useSourceMetricsBySystemIdQuery(baseOptions: Apollo.QueryHookOptions<SourceMetricsBySystemIdQuery, SourceMetricsBySystemIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceMetricsBySystemIdQuery, SourceMetricsBySystemIdQueryVariables>(SourceMetricsBySystemIdDocument, options);
      }
export function useSourceMetricsBySystemIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceMetricsBySystemIdQuery, SourceMetricsBySystemIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceMetricsBySystemIdQuery, SourceMetricsBySystemIdQueryVariables>(SourceMetricsBySystemIdDocument, options);
        }
export type SourceMetricsBySystemIdQueryHookResult = ReturnType<typeof useSourceMetricsBySystemIdQuery>;
export type SourceMetricsBySystemIdLazyQueryHookResult = ReturnType<typeof useSourceMetricsBySystemIdLazyQuery>;
export type SourceMetricsBySystemIdQueryResult = Apollo.QueryResult<SourceMetricsBySystemIdQuery, SourceMetricsBySystemIdQueryVariables>;
export function refetchSourceMetricsBySystemIdQuery(variables: SourceMetricsBySystemIdQueryVariables) {
      return { query: SourceMetricsBySystemIdDocument, variables: variables }
    }
export const SsoOrgUsersForSystemDocument = /*#__PURE__*/ gql`
    query SsoOrgUsersForSystem($searchInput: String!, $systemId: Int!) {
  ssoOrgUsersForSystem(searchInput: $searchInput, systemId: $systemId) {
    firstName
    id
    lastName
  }
}
    `;

/**
 * __useSsoOrgUsersForSystemQuery__
 *
 * To run a query within a React component, call `useSsoOrgUsersForSystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoOrgUsersForSystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoOrgUsersForSystemQuery({
 *   variables: {
 *      searchInput: // value for 'searchInput'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useSsoOrgUsersForSystemQuery(baseOptions: Apollo.QueryHookOptions<SsoOrgUsersForSystemQuery, SsoOrgUsersForSystemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsoOrgUsersForSystemQuery, SsoOrgUsersForSystemQueryVariables>(SsoOrgUsersForSystemDocument, options);
      }
export function useSsoOrgUsersForSystemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsoOrgUsersForSystemQuery, SsoOrgUsersForSystemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsoOrgUsersForSystemQuery, SsoOrgUsersForSystemQueryVariables>(SsoOrgUsersForSystemDocument, options);
        }
export type SsoOrgUsersForSystemQueryHookResult = ReturnType<typeof useSsoOrgUsersForSystemQuery>;
export type SsoOrgUsersForSystemLazyQueryHookResult = ReturnType<typeof useSsoOrgUsersForSystemLazyQuery>;
export type SsoOrgUsersForSystemQueryResult = Apollo.QueryResult<SsoOrgUsersForSystemQuery, SsoOrgUsersForSystemQueryVariables>;
export function refetchSsoOrgUsersForSystemQuery(variables: SsoOrgUsersForSystemQueryVariables) {
      return { query: SsoOrgUsersForSystemDocument, variables: variables }
    }
export const SsoUsersForOrganizationDocument = /*#__PURE__*/ gql`
    query SsoUsersForOrganization($input: SSOUsersForOrganizationInput!) {
  ssoUsersForOrganization(input: $input) {
    firstName
    id
    lastName
  }
}
    `;

/**
 * __useSsoUsersForOrganizationQuery__
 *
 * To run a query within a React component, call `useSsoUsersForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoUsersForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoUsersForOrganizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSsoUsersForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<SsoUsersForOrganizationQuery, SsoUsersForOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsoUsersForOrganizationQuery, SsoUsersForOrganizationQueryVariables>(SsoUsersForOrganizationDocument, options);
      }
export function useSsoUsersForOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsoUsersForOrganizationQuery, SsoUsersForOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsoUsersForOrganizationQuery, SsoUsersForOrganizationQueryVariables>(SsoUsersForOrganizationDocument, options);
        }
export type SsoUsersForOrganizationQueryHookResult = ReturnType<typeof useSsoUsersForOrganizationQuery>;
export type SsoUsersForOrganizationLazyQueryHookResult = ReturnType<typeof useSsoUsersForOrganizationLazyQuery>;
export type SsoUsersForOrganizationQueryResult = Apollo.QueryResult<SsoUsersForOrganizationQuery, SsoUsersForOrganizationQueryVariables>;
export function refetchSsoUsersForOrganizationQuery(variables: SsoUsersForOrganizationQueryVariables) {
      return { query: SsoUsersForOrganizationDocument, variables: variables }
    }
export const SystemDocument = /*#__PURE__*/ gql`
    query System($id: Int!) {
  systemV2(id: $id) {
    addresses {
      ...Address
    }
    operator {
      ...UserNest
    }
    organization {
      isExternalSystemSearchEnabled
      ...OrganizationNest
    }
    permits {
      ...Permit
    }
    ...SystemNest
    userDirectoryEnabled
    users {
      roleForSystem(systemId: $id)
      ...UserNest
    }
  }
}
    ${AddressFragmentDoc}
${UserNestFragmentDoc}
${OrganizationNestFragmentDoc}
${PermitFragmentDoc}
${SystemNestFragmentDoc}`;

/**
 * __useSystemQuery__
 *
 * To run a query within a React component, call `useSystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemQuery(baseOptions: Apollo.QueryHookOptions<SystemQuery, SystemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemQuery, SystemQueryVariables>(SystemDocument, options);
      }
export function useSystemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemQuery, SystemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemQuery, SystemQueryVariables>(SystemDocument, options);
        }
export type SystemQueryHookResult = ReturnType<typeof useSystemQuery>;
export type SystemLazyQueryHookResult = ReturnType<typeof useSystemLazyQuery>;
export type SystemQueryResult = Apollo.QueryResult<SystemQuery, SystemQueryVariables>;
export function refetchSystemQuery(variables: SystemQueryVariables) {
      return { query: SystemDocument, variables: variables }
    }
export const SystemGroupDocument = /*#__PURE__*/ gql`
    query SystemGroup($input: SystemGroupInput!, $systemGroupId: Int!) {
  systemGroup(input: $input) {
    ...SystemGroupWithUsers
  }
}
    ${SystemGroupWithUsersFragmentDoc}`;

/**
 * __useSystemGroupQuery__
 *
 * To run a query within a React component, call `useSystemGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemGroupQuery({
 *   variables: {
 *      input: // value for 'input'
 *      systemGroupId: // value for 'systemGroupId'
 *   },
 * });
 */
export function useSystemGroupQuery(baseOptions: Apollo.QueryHookOptions<SystemGroupQuery, SystemGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemGroupQuery, SystemGroupQueryVariables>(SystemGroupDocument, options);
      }
export function useSystemGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemGroupQuery, SystemGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemGroupQuery, SystemGroupQueryVariables>(SystemGroupDocument, options);
        }
export type SystemGroupQueryHookResult = ReturnType<typeof useSystemGroupQuery>;
export type SystemGroupLazyQueryHookResult = ReturnType<typeof useSystemGroupLazyQuery>;
export type SystemGroupQueryResult = Apollo.QueryResult<SystemGroupQuery, SystemGroupQueryVariables>;
export function refetchSystemGroupQuery(variables: SystemGroupQueryVariables) {
      return { query: SystemGroupDocument, variables: variables }
    }
export const SystemGroupDirectUsersDocument = /*#__PURE__*/ gql`
    query SystemGroupDirectUsers($input: SystemGroupInput!, $systemGroupId: Int!) {
  systemGroup(input: $input) {
    id
    users {
      ...SystemGroupUser
    }
  }
}
    ${SystemGroupUserFragmentDoc}`;

/**
 * __useSystemGroupDirectUsersQuery__
 *
 * To run a query within a React component, call `useSystemGroupDirectUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemGroupDirectUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemGroupDirectUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      systemGroupId: // value for 'systemGroupId'
 *   },
 * });
 */
export function useSystemGroupDirectUsersQuery(baseOptions: Apollo.QueryHookOptions<SystemGroupDirectUsersQuery, SystemGroupDirectUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemGroupDirectUsersQuery, SystemGroupDirectUsersQueryVariables>(SystemGroupDirectUsersDocument, options);
      }
export function useSystemGroupDirectUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemGroupDirectUsersQuery, SystemGroupDirectUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemGroupDirectUsersQuery, SystemGroupDirectUsersQueryVariables>(SystemGroupDirectUsersDocument, options);
        }
export type SystemGroupDirectUsersQueryHookResult = ReturnType<typeof useSystemGroupDirectUsersQuery>;
export type SystemGroupDirectUsersLazyQueryHookResult = ReturnType<typeof useSystemGroupDirectUsersLazyQuery>;
export type SystemGroupDirectUsersQueryResult = Apollo.QueryResult<SystemGroupDirectUsersQuery, SystemGroupDirectUsersQueryVariables>;
export function refetchSystemGroupDirectUsersQuery(variables: SystemGroupDirectUsersQueryVariables) {
      return { query: SystemGroupDirectUsersDocument, variables: variables }
    }
export const SystemGroupWithSystemGroupsAndSystemsDocument = /*#__PURE__*/ gql`
    query SystemGroupWithSystemGroupsAndSystems($input: SystemGroupInput!) {
  systemGroup(input: $input) {
    ...SystemGroup
    systemGroups {
      ...SystemGroup
    }
    systems {
      ...System
    }
  }
}
    ${SystemGroupFragmentDoc}
${SystemFragmentDoc}`;

/**
 * __useSystemGroupWithSystemGroupsAndSystemsQuery__
 *
 * To run a query within a React component, call `useSystemGroupWithSystemGroupsAndSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemGroupWithSystemGroupsAndSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemGroupWithSystemGroupsAndSystemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemGroupWithSystemGroupsAndSystemsQuery(baseOptions: Apollo.QueryHookOptions<SystemGroupWithSystemGroupsAndSystemsQuery, SystemGroupWithSystemGroupsAndSystemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemGroupWithSystemGroupsAndSystemsQuery, SystemGroupWithSystemGroupsAndSystemsQueryVariables>(SystemGroupWithSystemGroupsAndSystemsDocument, options);
      }
export function useSystemGroupWithSystemGroupsAndSystemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemGroupWithSystemGroupsAndSystemsQuery, SystemGroupWithSystemGroupsAndSystemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemGroupWithSystemGroupsAndSystemsQuery, SystemGroupWithSystemGroupsAndSystemsQueryVariables>(SystemGroupWithSystemGroupsAndSystemsDocument, options);
        }
export type SystemGroupWithSystemGroupsAndSystemsQueryHookResult = ReturnType<typeof useSystemGroupWithSystemGroupsAndSystemsQuery>;
export type SystemGroupWithSystemGroupsAndSystemsLazyQueryHookResult = ReturnType<typeof useSystemGroupWithSystemGroupsAndSystemsLazyQuery>;
export type SystemGroupWithSystemGroupsAndSystemsQueryResult = Apollo.QueryResult<SystemGroupWithSystemGroupsAndSystemsQuery, SystemGroupWithSystemGroupsAndSystemsQueryVariables>;
export function refetchSystemGroupWithSystemGroupsAndSystemsQuery(variables: SystemGroupWithSystemGroupsAndSystemsQueryVariables) {
      return { query: SystemGroupWithSystemGroupsAndSystemsDocument, variables: variables }
    }
export const SystemGroupsDocument = /*#__PURE__*/ gql`
    query SystemGroups($input: SystemGroupsInput!) {
  systemGroups(input: $input) {
    ...SystemGroup
  }
}
    ${SystemGroupFragmentDoc}`;

/**
 * __useSystemGroupsQuery__
 *
 * To run a query within a React component, call `useSystemGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemGroupsQuery(baseOptions: Apollo.QueryHookOptions<SystemGroupsQuery, SystemGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemGroupsQuery, SystemGroupsQueryVariables>(SystemGroupsDocument, options);
      }
export function useSystemGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemGroupsQuery, SystemGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemGroupsQuery, SystemGroupsQueryVariables>(SystemGroupsDocument, options);
        }
export type SystemGroupsQueryHookResult = ReturnType<typeof useSystemGroupsQuery>;
export type SystemGroupsLazyQueryHookResult = ReturnType<typeof useSystemGroupsLazyQuery>;
export type SystemGroupsQueryResult = Apollo.QueryResult<SystemGroupsQuery, SystemGroupsQueryVariables>;
export function refetchSystemGroupsQuery(variables: SystemGroupsQueryVariables) {
      return { query: SystemGroupsDocument, variables: variables }
    }
export const SystemSettingsDocument = /*#__PURE__*/ gql`
    query SystemSettings($id: Int!) {
  systemV2(id: $id) {
    addresses {
      ...Address
    }
    operator {
      ...UserNest
    }
    organization {
      isExternalSystemSearchEnabled
      ...OrganizationNest
    }
    permits {
      ...Permit
    }
    ...SystemNest
    userDirectoryEnabled
    users {
      roleForSystem(systemId: $id)
      ...UserNest
    }
  }
}
    ${AddressFragmentDoc}
${UserNestFragmentDoc}
${OrganizationNestFragmentDoc}
${PermitFragmentDoc}
${SystemNestFragmentDoc}`;

/**
 * __useSystemSettingsQuery__
 *
 * To run a query within a React component, call `useSystemSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemSettingsQuery(baseOptions: Apollo.QueryHookOptions<SystemSettingsQuery, SystemSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemSettingsQuery, SystemSettingsQueryVariables>(SystemSettingsDocument, options);
      }
export function useSystemSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemSettingsQuery, SystemSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemSettingsQuery, SystemSettingsQueryVariables>(SystemSettingsDocument, options);
        }
export type SystemSettingsQueryHookResult = ReturnType<typeof useSystemSettingsQuery>;
export type SystemSettingsLazyQueryHookResult = ReturnType<typeof useSystemSettingsLazyQuery>;
export type SystemSettingsQueryResult = Apollo.QueryResult<SystemSettingsQuery, SystemSettingsQueryVariables>;
export function refetchSystemSettingsQuery(variables: SystemSettingsQueryVariables) {
      return { query: SystemSettingsDocument, variables: variables }
    }
export const SystemWithDeepSitesDocument = /*#__PURE__*/ gql`
    query SystemWithDeepSites($id: Int!, $withDeleted: Boolean!) {
  systemWithDeepSites(id: $id, withDeleted: $withDeleted) {
    id
    isTemplate
    name
    organizationId
    sites {
      deletedAt
      flex
      id
      isEntry
      name
      order
      processes {
        components {
          deletedAt
          id
          name
          order
        }
        deletedAt
        id
        metrics {
          calculated
          calculatedMetrics {
            sourceMetricId
          }
          componentId
          deletedAt
          hideFromDataEntry
          id
          name
          order
          processId
          required
          sourceMetrics {
            calculatedMetricId
          }
        }
        name
        order
      }
    }
    type
  }
}
    `;

/**
 * __useSystemWithDeepSitesQuery__
 *
 * To run a query within a React component, call `useSystemWithDeepSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemWithDeepSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemWithDeepSitesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withDeleted: // value for 'withDeleted'
 *   },
 * });
 */
export function useSystemWithDeepSitesQuery(baseOptions: Apollo.QueryHookOptions<SystemWithDeepSitesQuery, SystemWithDeepSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemWithDeepSitesQuery, SystemWithDeepSitesQueryVariables>(SystemWithDeepSitesDocument, options);
      }
export function useSystemWithDeepSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemWithDeepSitesQuery, SystemWithDeepSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemWithDeepSitesQuery, SystemWithDeepSitesQueryVariables>(SystemWithDeepSitesDocument, options);
        }
export type SystemWithDeepSitesQueryHookResult = ReturnType<typeof useSystemWithDeepSitesQuery>;
export type SystemWithDeepSitesLazyQueryHookResult = ReturnType<typeof useSystemWithDeepSitesLazyQuery>;
export type SystemWithDeepSitesQueryResult = Apollo.QueryResult<SystemWithDeepSitesQuery, SystemWithDeepSitesQueryVariables>;
export function refetchSystemWithDeepSitesQuery(variables: SystemWithDeepSitesQueryVariables) {
      return { query: SystemWithDeepSitesDocument, variables: variables }
    }
export const TagMappingsDocument = /*#__PURE__*/ gql`
    query TagMappings($input: TagMappingsInput!) {
  tagMappings(input: $input) {
    data {
      edgeDevice {
        deviceName
        id
      }
      id
      metric {
        component {
          id
          name
        }
        id
        name
        process {
          id
          name
        }
      }
      site {
        id
        name
      }
      system {
        id
        name
      }
      tagName
    }
    id
    total
  }
}
    `;

/**
 * __useTagMappingsQuery__
 *
 * To run a query within a React component, call `useTagMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagMappingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTagMappingsQuery(baseOptions: Apollo.QueryHookOptions<TagMappingsQuery, TagMappingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagMappingsQuery, TagMappingsQueryVariables>(TagMappingsDocument, options);
      }
export function useTagMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagMappingsQuery, TagMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagMappingsQuery, TagMappingsQueryVariables>(TagMappingsDocument, options);
        }
export type TagMappingsQueryHookResult = ReturnType<typeof useTagMappingsQuery>;
export type TagMappingsLazyQueryHookResult = ReturnType<typeof useTagMappingsLazyQuery>;
export type TagMappingsQueryResult = Apollo.QueryResult<TagMappingsQuery, TagMappingsQueryVariables>;
export function refetchTagMappingsQuery(variables: TagMappingsQueryVariables) {
      return { query: TagMappingsDocument, variables: variables }
    }
export const TagsDocument = /*#__PURE__*/ gql`
    query Tags($input: TagsInput!) {
  tags(input: $input) {
    count
    items {
      keynameTagCount
      logBookEntryTagCount
      organization {
        id
        name
      }
      reportTagCount
      ...Tag
    }
  }
}
    ${TagFragmentDoc}`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTagsQuery(baseOptions: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export function refetchTagsQuery(variables: TagsQueryVariables) {
      return { query: TagsDocument, variables: variables }
    }
export const TemplateSystemsDocument = /*#__PURE__*/ gql`
    query TemplateSystems($organizationId: Int!) {
  templateSystems(organizationId: $organizationId) {
    ...SystemNest
  }
}
    ${SystemNestFragmentDoc}`;

/**
 * __useTemplateSystemsQuery__
 *
 * To run a query within a React component, call `useTemplateSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateSystemsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useTemplateSystemsQuery(baseOptions: Apollo.QueryHookOptions<TemplateSystemsQuery, TemplateSystemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateSystemsQuery, TemplateSystemsQueryVariables>(TemplateSystemsDocument, options);
      }
export function useTemplateSystemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateSystemsQuery, TemplateSystemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateSystemsQuery, TemplateSystemsQueryVariables>(TemplateSystemsDocument, options);
        }
export type TemplateSystemsQueryHookResult = ReturnType<typeof useTemplateSystemsQuery>;
export type TemplateSystemsLazyQueryHookResult = ReturnType<typeof useTemplateSystemsLazyQuery>;
export type TemplateSystemsQueryResult = Apollo.QueryResult<TemplateSystemsQuery, TemplateSystemsQueryVariables>;
export function refetchTemplateSystemsQuery(variables: TemplateSystemsQueryVariables) {
      return { query: TemplateSystemsDocument, variables: variables }
    }
export const TransactionInfoWithCalcClusterDebugLogsDocument = /*#__PURE__*/ gql`
    query TransactionInfoWithCalcClusterDebugLogs($input: CalcClusterDebugLogsInput!) {
  transactionInfoWithCalcClusterDebugLogs(input: $input) {
    id
    logs {
      ...CalcClusterDebugLog
      site {
        ...SiteNest
      }
    }
    originTimestamp
    transactionId
  }
}
    ${CalcClusterDebugLogFragmentDoc}
${SiteNestFragmentDoc}`;

/**
 * __useTransactionInfoWithCalcClusterDebugLogsQuery__
 *
 * To run a query within a React component, call `useTransactionInfoWithCalcClusterDebugLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionInfoWithCalcClusterDebugLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionInfoWithCalcClusterDebugLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransactionInfoWithCalcClusterDebugLogsQuery(baseOptions: Apollo.QueryHookOptions<TransactionInfoWithCalcClusterDebugLogsQuery, TransactionInfoWithCalcClusterDebugLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionInfoWithCalcClusterDebugLogsQuery, TransactionInfoWithCalcClusterDebugLogsQueryVariables>(TransactionInfoWithCalcClusterDebugLogsDocument, options);
      }
export function useTransactionInfoWithCalcClusterDebugLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionInfoWithCalcClusterDebugLogsQuery, TransactionInfoWithCalcClusterDebugLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionInfoWithCalcClusterDebugLogsQuery, TransactionInfoWithCalcClusterDebugLogsQueryVariables>(TransactionInfoWithCalcClusterDebugLogsDocument, options);
        }
export type TransactionInfoWithCalcClusterDebugLogsQueryHookResult = ReturnType<typeof useTransactionInfoWithCalcClusterDebugLogsQuery>;
export type TransactionInfoWithCalcClusterDebugLogsLazyQueryHookResult = ReturnType<typeof useTransactionInfoWithCalcClusterDebugLogsLazyQuery>;
export type TransactionInfoWithCalcClusterDebugLogsQueryResult = Apollo.QueryResult<TransactionInfoWithCalcClusterDebugLogsQuery, TransactionInfoWithCalcClusterDebugLogsQueryVariables>;
export function refetchTransactionInfoWithCalcClusterDebugLogsQuery(variables: TransactionInfoWithCalcClusterDebugLogsQueryVariables) {
      return { query: TransactionInfoWithCalcClusterDebugLogsDocument, variables: variables }
    }
export const UnitNestsDocument = /*#__PURE__*/ gql`
    query UnitNests($input: UnitsInput!) {
  unitNests(input: $input) {
    ...UnitNest
  }
}
    ${UnitNestFragmentDoc}`;

/**
 * __useUnitNestsQuery__
 *
 * To run a query within a React component, call `useUnitNestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitNestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitNestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnitNestsQuery(baseOptions: Apollo.QueryHookOptions<UnitNestsQuery, UnitNestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnitNestsQuery, UnitNestsQueryVariables>(UnitNestsDocument, options);
      }
export function useUnitNestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnitNestsQuery, UnitNestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnitNestsQuery, UnitNestsQueryVariables>(UnitNestsDocument, options);
        }
export type UnitNestsQueryHookResult = ReturnType<typeof useUnitNestsQuery>;
export type UnitNestsLazyQueryHookResult = ReturnType<typeof useUnitNestsLazyQuery>;
export type UnitNestsQueryResult = Apollo.QueryResult<UnitNestsQuery, UnitNestsQueryVariables>;
export function refetchUnitNestsQuery(variables: UnitNestsQueryVariables) {
      return { query: UnitNestsDocument, variables: variables }
    }
export const UserManagerUserDocument = /*#__PURE__*/ gql`
    query UserManagerUser($input: UserManagerUserDetailsInput!) {
  userManagerUser(input: $input) {
    ...UserManagerUserFields
  }
}
    ${UserManagerUserFieldsFragmentDoc}`;

/**
 * __useUserManagerUserQuery__
 *
 * To run a query within a React component, call `useUserManagerUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserManagerUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserManagerUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserManagerUserQuery(baseOptions: Apollo.QueryHookOptions<UserManagerUserQuery, UserManagerUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserManagerUserQuery, UserManagerUserQueryVariables>(UserManagerUserDocument, options);
      }
export function useUserManagerUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserManagerUserQuery, UserManagerUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserManagerUserQuery, UserManagerUserQueryVariables>(UserManagerUserDocument, options);
        }
export type UserManagerUserQueryHookResult = ReturnType<typeof useUserManagerUserQuery>;
export type UserManagerUserLazyQueryHookResult = ReturnType<typeof useUserManagerUserLazyQuery>;
export type UserManagerUserQueryResult = Apollo.QueryResult<UserManagerUserQuery, UserManagerUserQueryVariables>;
export function refetchUserManagerUserQuery(variables: UserManagerUserQueryVariables) {
      return { query: UserManagerUserDocument, variables: variables }
    }
export const UserManagerUsersDocument = /*#__PURE__*/ gql`
    query UserManagerUsers($input: UserManagerUsersInput) {
  userManagerUsers(input: $input) {
    count
    items {
      ...UserManagerUserFields
    }
  }
}
    ${UserManagerUserFieldsFragmentDoc}`;

/**
 * __useUserManagerUsersQuery__
 *
 * To run a query within a React component, call `useUserManagerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserManagerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserManagerUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserManagerUsersQuery(baseOptions?: Apollo.QueryHookOptions<UserManagerUsersQuery, UserManagerUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserManagerUsersQuery, UserManagerUsersQueryVariables>(UserManagerUsersDocument, options);
      }
export function useUserManagerUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserManagerUsersQuery, UserManagerUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserManagerUsersQuery, UserManagerUsersQueryVariables>(UserManagerUsersDocument, options);
        }
export type UserManagerUsersQueryHookResult = ReturnType<typeof useUserManagerUsersQuery>;
export type UserManagerUsersLazyQueryHookResult = ReturnType<typeof useUserManagerUsersLazyQuery>;
export type UserManagerUsersQueryResult = Apollo.QueryResult<UserManagerUsersQuery, UserManagerUsersQueryVariables>;
export function refetchUserManagerUsersQuery(variables?: UserManagerUsersQueryVariables) {
      return { query: UserManagerUsersDocument, variables: variables }
    }
export const UsersDocument = /*#__PURE__*/ gql`
    query Users($input: UsersInput!) {
  users(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUsersQuery(baseOptions: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export function refetchUsersQuery(variables: UsersQueryVariables) {
      return { query: UsersDocument, variables: variables }
    }
export const WeatherDataStationsDocument = /*#__PURE__*/ gql`
    query WeatherDataStations($includeArchived: Boolean = false) {
  weatherDataStations(includeArchived: $includeArchived) {
    ...WeatherDataStationFields
  }
}
    ${WeatherDataStationFieldsFragmentDoc}`;

/**
 * __useWeatherDataStationsQuery__
 *
 * To run a query within a React component, call `useWeatherDataStationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeatherDataStationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherDataStationsQuery({
 *   variables: {
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useWeatherDataStationsQuery(baseOptions?: Apollo.QueryHookOptions<WeatherDataStationsQuery, WeatherDataStationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeatherDataStationsQuery, WeatherDataStationsQueryVariables>(WeatherDataStationsDocument, options);
      }
export function useWeatherDataStationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeatherDataStationsQuery, WeatherDataStationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeatherDataStationsQuery, WeatherDataStationsQueryVariables>(WeatherDataStationsDocument, options);
        }
export type WeatherDataStationsQueryHookResult = ReturnType<typeof useWeatherDataStationsQuery>;
export type WeatherDataStationsLazyQueryHookResult = ReturnType<typeof useWeatherDataStationsLazyQuery>;
export type WeatherDataStationsQueryResult = Apollo.QueryResult<WeatherDataStationsQuery, WeatherDataStationsQueryVariables>;
export function refetchWeatherDataStationsQuery(variables?: WeatherDataStationsQueryVariables) {
      return { query: WeatherDataStationsDocument, variables: variables }
    }
export const OnAuditEventPublishedDocument = /*#__PURE__*/ gql`
    subscription OnAuditEventPublished($accessToken: String!, $input: AuditEventSubscriptionInput!) {
  onAuditEventPublished(accessToken: $accessToken, input: $input) {
    ...AuditEvent
    system {
      ...SystemNest
    }
    user {
      ...UserNest
    }
  }
}
    ${AuditEventFragmentDoc}
${SystemNestFragmentDoc}
${UserNestFragmentDoc}`;

/**
 * __useOnAuditEventPublishedSubscription__
 *
 * To run a query within a React component, call `useOnAuditEventPublishedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAuditEventPublishedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAuditEventPublishedSubscription({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnAuditEventPublishedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnAuditEventPublishedSubscription, OnAuditEventPublishedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnAuditEventPublishedSubscription, OnAuditEventPublishedSubscriptionVariables>(OnAuditEventPublishedDocument, options);
      }
export type OnAuditEventPublishedSubscriptionHookResult = ReturnType<typeof useOnAuditEventPublishedSubscription>;
export type OnAuditEventPublishedSubscriptionResult = Apollo.SubscriptionResult<OnAuditEventPublishedSubscription>;
export const OnCalcQueueJobsPublishedDocument = /*#__PURE__*/ gql`
    subscription OnCalcQueueJobsPublished {
  onCalcQueueJobsPublished {
    job {
      groupId
      id
      name
    }
  }
}
    `;

/**
 * __useOnCalcQueueJobsPublishedSubscription__
 *
 * To run a query within a React component, call `useOnCalcQueueJobsPublishedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCalcQueueJobsPublishedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCalcQueueJobsPublishedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnCalcQueueJobsPublishedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCalcQueueJobsPublishedSubscription, OnCalcQueueJobsPublishedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCalcQueueJobsPublishedSubscription, OnCalcQueueJobsPublishedSubscriptionVariables>(OnCalcQueueJobsPublishedDocument, options);
      }
export type OnCalcQueueJobsPublishedSubscriptionHookResult = ReturnType<typeof useOnCalcQueueJobsPublishedSubscription>;
export type OnCalcQueueJobsPublishedSubscriptionResult = Apollo.SubscriptionResult<OnCalcQueueJobsPublishedSubscription>;
export const OnCalcQueueStatsPublishedDocument = /*#__PURE__*/ gql`
    subscription OnCalcQueueStatsPublished($accessToken: String!) {
  onCalcQueueStatsPublished(accessToken: $accessToken) {
    ...QueueStats
  }
}
    ${QueueStatsFragmentDoc}`;

/**
 * __useOnCalcQueueStatsPublishedSubscription__
 *
 * To run a query within a React component, call `useOnCalcQueueStatsPublishedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCalcQueueStatsPublishedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCalcQueueStatsPublishedSubscription({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useOnCalcQueueStatsPublishedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnCalcQueueStatsPublishedSubscription, OnCalcQueueStatsPublishedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCalcQueueStatsPublishedSubscription, OnCalcQueueStatsPublishedSubscriptionVariables>(OnCalcQueueStatsPublishedDocument, options);
      }
export type OnCalcQueueStatsPublishedSubscriptionHookResult = ReturnType<typeof useOnCalcQueueStatsPublishedSubscription>;
export type OnCalcQueueStatsPublishedSubscriptionResult = Apollo.SubscriptionResult<OnCalcQueueStatsPublishedSubscription>;
export const OnDataEntryCompletionPublishedDocument = /*#__PURE__*/ gql`
    subscription OnDataEntryCompletionPublished($accessToken: String!, $siteId: Float!) {
  onDataEntryCompletionPublished(accessToken: $accessToken, siteId: $siteId) {
    ...DataEntryCompletion
  }
}
    ${DataEntryCompletionFragmentDoc}`;

/**
 * __useOnDataEntryCompletionPublishedSubscription__
 *
 * To run a query within a React component, call `useOnDataEntryCompletionPublishedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDataEntryCompletionPublishedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDataEntryCompletionPublishedSubscription({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useOnDataEntryCompletionPublishedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnDataEntryCompletionPublishedSubscription, OnDataEntryCompletionPublishedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDataEntryCompletionPublishedSubscription, OnDataEntryCompletionPublishedSubscriptionVariables>(OnDataEntryCompletionPublishedDocument, options);
      }
export type OnDataEntryCompletionPublishedSubscriptionHookResult = ReturnType<typeof useOnDataEntryCompletionPublishedSubscription>;
export type OnDataEntryCompletionPublishedSubscriptionResult = Apollo.SubscriptionResult<OnDataEntryCompletionPublishedSubscription>;
export const OnLogBookEntryPublishedDocument = /*#__PURE__*/ gql`
    subscription OnLogBookEntryPublished($accessToken: String!, $siteId: Float!) {
  onLogBookEntryPublished(accessToken: $accessToken, siteId: $siteId) {
    ...LogBookEntryListItem
  }
}
    ${LogBookEntryListItemFragmentDoc}`;

/**
 * __useOnLogBookEntryPublishedSubscription__
 *
 * To run a query within a React component, call `useOnLogBookEntryPublishedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnLogBookEntryPublishedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnLogBookEntryPublishedSubscription({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useOnLogBookEntryPublishedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnLogBookEntryPublishedSubscription, OnLogBookEntryPublishedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnLogBookEntryPublishedSubscription, OnLogBookEntryPublishedSubscriptionVariables>(OnLogBookEntryPublishedDocument, options);
      }
export type OnLogBookEntryPublishedSubscriptionHookResult = ReturnType<typeof useOnLogBookEntryPublishedSubscription>;
export type OnLogBookEntryPublishedSubscriptionResult = Apollo.SubscriptionResult<OnLogBookEntryPublishedSubscription>;
export const OnNotificationPublishedDocument = /*#__PURE__*/ gql`
    subscription OnNotificationPublished {
  onNotificationPublished {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;

/**
 * __useOnNotificationPublishedSubscription__
 *
 * To run a query within a React component, call `useOnNotificationPublishedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNotificationPublishedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNotificationPublishedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnNotificationPublishedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnNotificationPublishedSubscription, OnNotificationPublishedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnNotificationPublishedSubscription, OnNotificationPublishedSubscriptionVariables>(OnNotificationPublishedDocument, options);
      }
export type OnNotificationPublishedSubscriptionHookResult = ReturnType<typeof useOnNotificationPublishedSubscription>;
export type OnNotificationPublishedSubscriptionResult = Apollo.SubscriptionResult<OnNotificationPublishedSubscription>;
export const OnScheduledItemPublishedDocument = /*#__PURE__*/ gql`
    subscription OnScheduledItemPublished($accessToken: String!) {
  onScheduledItemPublished(accessToken: $accessToken) {
    ...ScheduledItem
  }
}
    ${ScheduledItemFragmentDoc}`;

/**
 * __useOnScheduledItemPublishedSubscription__
 *
 * To run a query within a React component, call `useOnScheduledItemPublishedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnScheduledItemPublishedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnScheduledItemPublishedSubscription({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useOnScheduledItemPublishedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnScheduledItemPublishedSubscription, OnScheduledItemPublishedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnScheduledItemPublishedSubscription, OnScheduledItemPublishedSubscriptionVariables>(OnScheduledItemPublishedDocument, options);
      }
export type OnScheduledItemPublishedSubscriptionHookResult = ReturnType<typeof useOnScheduledItemPublishedSubscription>;
export type OnScheduledItemPublishedSubscriptionResult = Apollo.SubscriptionResult<OnScheduledItemPublishedSubscription>;
export const OnSiteDataEntryChangedDocument = /*#__PURE__*/ gql`
    subscription OnSiteDataEntryChanged($accessToken: String!, $intervalIds: [Int!], $reportDate: DateType!, $siteId: Int!, $subscriptionClientId: String!) {
  onSiteDataEntryChanged(
    accessToken: $accessToken
    intervalIds: $intervalIds
    reportDate: $reportDate
    siteId: $siteId
    subscriptionClientId: $subscriptionClientId
  ) {
    dataPoint {
      ...MetricDataPointDetails
    }
    entryIntervalDate
    entryIntervalTime
  }
}
    ${MetricDataPointDetailsFragmentDoc}`;

/**
 * __useOnSiteDataEntryChangedSubscription__
 *
 * To run a query within a React component, call `useOnSiteDataEntryChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSiteDataEntryChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSiteDataEntryChangedSubscription({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      intervalIds: // value for 'intervalIds'
 *      reportDate: // value for 'reportDate'
 *      siteId: // value for 'siteId'
 *      subscriptionClientId: // value for 'subscriptionClientId'
 *   },
 * });
 */
export function useOnSiteDataEntryChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnSiteDataEntryChangedSubscription, OnSiteDataEntryChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnSiteDataEntryChangedSubscription, OnSiteDataEntryChangedSubscriptionVariables>(OnSiteDataEntryChangedDocument, options);
      }
export type OnSiteDataEntryChangedSubscriptionHookResult = ReturnType<typeof useOnSiteDataEntryChangedSubscription>;
export type OnSiteDataEntryChangedSubscriptionResult = Apollo.SubscriptionResult<OnSiteDataEntryChangedSubscription>;
export const namedOperations = {
  Query: {
    ActiveMetricStats: 'ActiveMetricStats',
    ActiveUserStats: 'ActiveUserStats',
    ActivityScheduleById: 'ActivityScheduleById',
    ActivitySchedules: 'ActivitySchedules',
    AdjacentEntryInterval: 'AdjacentEntryInterval',
    AnalyteGroupById: 'AnalyteGroupById',
    AnalyteGroups: 'AnalyteGroups',
    Analytes: 'Analytes',
    ApiTokens: 'ApiTokens',
    ApiTokensByOrganization: 'ApiTokensByOrganization',
    AuditEventSiteCreated: 'AuditEventSiteCreated',
    AuditEvents: 'AuditEvents',
    AuditEventsByItemTypeAndItemId: 'AuditEventsByItemTypeAndItemId',
    AuditEventsByMetricId: 'AuditEventsByMetricId',
    AuditEventsByScheduledItemId: 'AuditEventsByScheduledItemId',
    BulkMetricEditorFilterOptions: 'BulkMetricEditorFilterOptions',
    BulkMetricEditorMetrics: 'BulkMetricEditorMetrics',
    CalcClusterDebugByClusterId: 'CalcClusterDebugByClusterId',
    CalcClusterDebugLogs: 'CalcClusterDebugLogs',
    CalcClusterDebugs: 'CalcClusterDebugs',
    ColumnGroups: 'ColumnGroups',
    ColumnGroupsWithItems: 'ColumnGroupsWithItems',
    ConstantRecalculationEstimate: 'ConstantRecalculationEstimate',
    ConstantsDiscovery: 'ConstantsDiscovery',
    ConstantsForOrganization: 'ConstantsForOrganization',
    ConstantsForSystem: 'ConstantsForSystem',
    DataEntryCompletionsByReportDate: 'DataEntryCompletionsByReportDate',
    DataModelSitesForMirror: 'DataModelSitesForMirror',
    EligibleManualReportEmailRecipients: 'EligibleManualReportEmailRecipients',
    EnterpriseReportShareLink: 'EnterpriseReportShareLink',
    EnterpriseReportsForAnalyticsAdmin: 'EnterpriseReportsForAnalyticsAdmin',
    EntryIntervalsByDateRange: 'EntryIntervalsByDateRange',
    EstimateSiteRecalculation: 'EstimateSiteRecalculation',
    ExportBulkMetricEditorMetricsCsv: 'ExportBulkMetricEditorMetricsCsv',
    ExportLogBookEntriesCsv: 'ExportLogBookEntriesCsv',
    ExportUserManagerUsersCsv: 'ExportUserManagerUsersCsv',
    ExternalFacilities: 'ExternalFacilities',
    ExternalSystems: 'ExternalSystems',
    FindEdgeDeviceSubmissions: 'FindEdgeDeviceSubmissions',
    FindRecentEdgeDeviceSubmissions: 'FindRecentEdgeDeviceSubmissions',
    FindUploadById: 'FindUploadById',
    FlexSitesAssociatedWithMetricId: 'FlexSitesAssociatedWithMetricId',
    GenerateUploadParameters: 'GenerateUploadParameters',
    GetAdminStats: 'GetAdminStats',
    GetAllEdgeDevices: 'GetAllEdgeDevices',
    GetAllEdgeDevicesV2: 'GetAllEdgeDevicesV2',
    GetAllSites: 'GetAllSites',
    GetCalcTree: 'GetCalcTree',
    GetCalcTreesWithCycles: 'GetCalcTreesWithCycles',
    GetEdgeDeviceSubmissionData: 'GetEdgeDeviceSubmissionData',
    GetEdgeDeviceToken: 'GetEdgeDeviceToken',
    GetEdgeDeviceV2: 'GetEdgeDeviceV2',
    GetEdgeDevicesByOrganizationId: 'GetEdgeDevicesByOrganizationId',
    GetEntrySparklineData: 'GetEntrySparklineData',
    GetFindUserByToken: 'GetFindUserByToken',
    GetMe: 'GetMe',
    GetMetric: 'GetMetric',
    GetMetricCalcCluster: 'GetMetricCalcCluster',
    GetMetricChartData: 'GetMetricChartData',
    GetMetricWithContextAndSystem: 'GetMetricWithContextAndSystem',
    GetMetricsDataPointsForDay: 'GetMetricsDataPointsForDay',
    GetNextNewUnitId: 'GetNextNewUnitId',
    GetOrganizations: 'GetOrganizations',
    GetPing: 'GetPing',
    GetRelatedMetrics: 'GetRelatedMetrics',
    GetReportDefinition: 'GetReportDefinition',
    GetReportTemplates: 'GetReportTemplates',
    GetSiteDataEntries: 'GetSiteDataEntries',
    GetSiteDataEntriesDay: 'GetSiteDataEntriesDay',
    GetSiteDataEntriesHistory: 'GetSiteDataEntriesHistory',
    GetSiteMetricsV2: 'GetSiteMetricsV2',
    GetSiteSourceMetrics: 'GetSiteSourceMetrics',
    GetSiteV2: 'GetSiteV2',
    GetSites: 'GetSites',
    GetSitesForSystem: 'GetSitesForSystem',
    GetSsoConfiguration: 'GetSsoConfiguration',
    GetSystem: 'GetSystem',
    GetSystemComponents: 'GetSystemComponents',
    GetSystemMetricsForValidation: 'GetSystemMetricsForValidation',
    GetSystemProcesses: 'GetSystemProcesses',
    GetSystemSiteDetails: 'GetSystemSiteDetails',
    GetSystemSites: 'GetSystemSites',
    GetSystemUsers: 'GetSystemUsers',
    GetSystems: 'GetSystems',
    GetSystemsWithOperator: 'GetSystemsWithOperator',
    GetTrends: 'GetTrends',
    GetUnits: 'GetUnits',
    GetUser: 'GetUser',
    GetUserFullInfo: 'GetUserFullInfo',
    GetUserLicenses: 'GetUserLicenses',
    GetUserPhoneNumbers: 'GetUserPhoneNumbers',
    GetWaterlyConnectErrorStats: 'GetWaterlyConnectErrorStats',
    GetWaterlyConnectStats: 'GetWaterlyConnectStats',
    GetWaterlyConnectSubmissionHistory: 'GetWaterlyConnectSubmissionHistory',
    HasLinkedServiceReportEnterpriseReport: 'HasLinkedServiceReportEnterpriseReport',
    LabImportBatch: 'LabImportBatch',
    LabImportBatchResume: 'LabImportBatchResume',
    LabImportBatches: 'LabImportBatches',
    LabImportBootstrap: 'LabImportBootstrap',
    LabImportFileDownload: 'LabImportFileDownload',
    LabImportRows: 'LabImportRows',
    LabImportSourceGroups: 'LabImportSourceGroups',
    LatestServiceReportSnapshotBySiteAndReportDate: 'LatestServiceReportSnapshotBySiteAndReportDate',
    LogBookEntries: 'LogBookEntries',
    LogBookEntriesWithCount: 'LogBookEntriesWithCount',
    LogBookEntryById: 'LogBookEntryById',
    LogBookEntryDashboardViewByUserId: 'LogBookEntryDashboardViewByUserId',
    ManualReportEmailSharingScope: 'ManualReportEmailSharingScope',
    MetricKeynameWithCount: 'MetricKeynameWithCount',
    MetricKeynamesWithCountAndMetricCount: 'MetricKeynamesWithCountAndMetricCount',
    MetricRangesForClone: 'MetricRangesForClone',
    MetricsBySiteProcessComponent: 'MetricsBySiteProcessComponent',
    MetricsBySystemIds: 'MetricsBySystemIds',
    MetricsForSelect: 'MetricsForSelect',
    MetricsWithDownstreamCalcCounts: 'MetricsWithDownstreamCalcCounts',
    Notifications: 'Notifications',
    Organization: 'Organization',
    OrganizationIntegrations: 'OrganizationIntegrations',
    OrganizationWithSystemGroupsAndSystems: 'OrganizationWithSystemGroupsAndSystems',
    OrganizationsWithSystemGroupsAndSystems: 'OrganizationsWithSystemGroupsAndSystems',
    PermitById: 'PermitById',
    Permits: 'Permits',
    Phrases: 'Phrases',
    ProcessComponents: 'ProcessComponents',
    ProcessesAndComponentsBySiteId: 'ProcessesAndComponentsBySiteId',
    RecentEntryIntervalsBySiteId: 'RecentEntryIntervalsBySiteId',
    RegulatoryReportDefinitionsForGrouping: 'RegulatoryReportDefinitionsForGrouping',
    ReportData: 'ReportData',
    ReportDataForSite: 'ReportDataForSite',
    ReportDefinitionDiscoveryFilterCounts: 'ReportDefinitionDiscoveryFilterCounts',
    ReportDefinitionHistorySnapshots: 'ReportDefinitionHistorySnapshots',
    ReportDefinitionsForDiscovery: 'ReportDefinitionsForDiscovery',
    ReportDistributionLists: 'ReportDistributionLists',
    ReportSnapshotById: 'ReportSnapshotById',
    RetentionRisks: 'RetentionRisks',
    RoundsAssetsMappingsByEntities: 'RoundsAssetsMappingsByEntities',
    RoundsShiftNoteFormContext: 'RoundsShiftNoteFormContext',
    RuntimeLoggers: 'RuntimeLoggers',
    SampleCollectionById: 'SampleCollectionById',
    SampleCollectionCustodies: 'SampleCollectionCustodies',
    SampleCollections: 'SampleCollections',
    SampleScheduleById: 'SampleScheduleById',
    SampleSchedules: 'SampleSchedules',
    SampleSiteById: 'SampleSiteById',
    SampleSites: 'SampleSites',
    ScheduledItemById: 'ScheduledItemById',
    ScheduledItemCount: 'ScheduledItemCount',
    ScheduledItems: 'ScheduledItems',
    SiteDataEntryCompletionByDate: 'SiteDataEntryCompletionByDate',
    SiteFlexMetrics: 'SiteFlexMetrics',
    SiteProcesses: 'SiteProcesses',
    SitesV2: 'SitesV2',
    SourceMetricsBySystemId: 'SourceMetricsBySystemId',
    SsoOrgUsersForSystem: 'SsoOrgUsersForSystem',
    SsoUsersForOrganization: 'SsoUsersForOrganization',
    System: 'System',
    SystemGroup: 'SystemGroup',
    SystemGroupDirectUsers: 'SystemGroupDirectUsers',
    SystemGroupWithSystemGroupsAndSystems: 'SystemGroupWithSystemGroupsAndSystems',
    SystemGroups: 'SystemGroups',
    SystemSettings: 'SystemSettings',
    SystemWithDeepSites: 'SystemWithDeepSites',
    TagMappings: 'TagMappings',
    Tags: 'Tags',
    TemplateSystems: 'TemplateSystems',
    TransactionInfoWithCalcClusterDebugLogs: 'TransactionInfoWithCalcClusterDebugLogs',
    UnitNests: 'UnitNests',
    UserManagerUser: 'UserManagerUser',
    UserManagerUsers: 'UserManagerUsers',
    Users: 'Users',
    WeatherDataStations: 'WeatherDataStations'
  },
  Mutation: {
    UpdatePermit: 'UpdatePermit',
    AddActivitySchedule: 'AddActivitySchedule',
    AddEdgeDevice: 'AddEdgeDevice',
    AddLicense: 'AddLicense',
    AddNewReportDefinition: 'AddNewReportDefinition',
    AddPhoneNumber: 'AddPhoneNumber',
    AddScheduledItemUpload: 'AddScheduledItemUpload',
    AddSite: 'AddSite',
    AddSiteFlexMetricsToFolder: 'AddSiteFlexMetricsToFolder',
    AddSsoUserToSystem: 'AddSsoUserToSystem',
    AddSSOUserToSystemGroup: 'AddSSOUserToSystemGroup',
    AddSystemFavorite: 'AddSystemFavorite',
    AddSystemGroup: 'AddSystemGroup',
    AddTagMapping: 'AddTagMapping',
    AddTrend: 'AddTrend',
    AddUpload: 'AddUpload',
    AddUserToSystem: 'AddUserToSystem',
    AddUserToSystemGroup: 'AddUserToSystemGroup',
    ArchiveConstantDefinition: 'ArchiveConstantDefinition',
    ArchiveConstantValue: 'ArchiveConstantValue',
    ArchiveSampleSchedule: 'ArchiveSampleSchedule',
    ArchiveScheduledItemComment: 'ArchiveScheduledItemComment',
    ArchiveScheduledItemUpload: 'ArchiveScheduledItemUpload',
    ArchiveScheduledItems: 'ArchiveScheduledItems',
    ArchiveUpload: 'ArchiveUpload',
    ArchiveWeatherDataStation: 'ArchiveWeatherDataStation',
    CancelActivitySchedule: 'CancelActivitySchedule',
    CancelSampleSchedule: 'CancelSampleSchedule',
    ClearRuntimeLoggerOverride: 'ClearRuntimeLoggerOverride',
    ClearSsoCache: 'ClearSsoCache',
    CloneComponents: 'CloneComponents',
    CloneMetrics: 'CloneMetrics',
    CloneProcesses: 'CloneProcesses',
    CloneSites: 'CloneSites',
    CloneSystem: 'CloneSystem',
    CloneSystemWithSelectedDescendants: 'CloneSystemWithSelectedDescendants',
    CloneToTarget: 'CloneToTarget',
    CommitDirtyDataPoints: 'CommitDirtyDataPoints',
    CommitLabImportBatch: 'CommitLabImportBatch',
    ConvertToFlexReport: 'ConvertToFlexReport',
    CreateAddress: 'CreateAddress',
    CreateAnalyteGroup: 'CreateAnalyteGroup',
    CreateApiToken: 'CreateApiToken',
    CreateCalcClusterDebugByClusterId: 'CreateCalcClusterDebugByClusterId',
    CreateColumnGroup: 'CreateColumnGroup',
    CreateColumnGroupItems: 'CreateColumnGroupItems',
    CreateColumnGroupsAndItems: 'CreateColumnGroupsAndItems',
    CreateComponent: 'CreateComponent',
    CreateConstantDefinition: 'CreateConstantDefinition',
    CreateEnterpriseReportShareLink: 'CreateEnterpriseReportShareLink',
    CreateEntryIntervals: 'CreateEntryIntervals',
    CreateFlexFormFromSystem: 'CreateFlexFormFromSystem',
    CreateFolder: 'CreateFolder',
    CreateInterval: 'CreateInterval',
    CreateIntervals: 'CreateIntervals',
    CreateLabImportBatch: 'CreateLabImportBatch',
    CreateLogBookEntry: 'CreateLogBookEntry',
    CreateLogBookEntryDashboardView: 'CreateLogBookEntryDashboardView',
    CreateMetric: 'CreateMetric',
    CreateMetricKeyname: 'CreateMetricKeyname',
    CreateNotification: 'CreateNotification',
    CreateOrganizationIntegration: 'CreateOrganizationIntegration',
    CreatePermit: 'CreatePermit',
    CreateProcess: 'CreateProcess',
    CreateReportDistributionList: 'CreateReportDistributionList',
    CreateRoundsShiftNote: 'CreateRoundsShiftNote',
    CreateSampleCollection: 'CreateSampleCollection',
    CreateSampleCollectionCustody: 'CreateSampleCollectionCustody',
    CreateSampleSchedule: 'CreateSampleSchedule',
    CreateSampleSite: 'CreateSampleSite',
    CreateScheduledItemComment: 'CreateScheduledItemComment',
    CreateSystem: 'CreateSystem',
    CreateTag: 'CreateTag',
    CreateUnit: 'CreateUnit',
    CreateUserPhrase: 'CreateUserPhrase',
    CreateWeatherDataStation: 'CreateWeatherDataStation',
    DeleteActivitySchedule: 'DeleteActivitySchedule',
    DeleteColumnGroupItem: 'DeleteColumnGroupItem',
    DeleteComponent: 'DeleteComponent',
    DeleteFolder: 'DeleteFolder',
    DeleteInterval: 'DeleteInterval',
    DeleteLicense: 'DeleteLicense',
    DeleteLogBookEntry: 'DeleteLogBookEntry',
    DeleteLogBookEntryDashboardView: 'DeleteLogBookEntryDashboardView',
    DeleteMetric: 'DeleteMetric',
    DeleteMetricKeyname: 'DeleteMetricKeyname',
    DeleteMetricRange: 'DeleteMetricRange',
    DeleteNotification: 'DeleteNotification',
    DeleteOrganizationIntegration: 'DeleteOrganizationIntegration',
    DeletePermit: 'DeletePermit',
    DeletePhoneNumber: 'DeletePhoneNumber',
    DeletePhrase: 'DeletePhrase',
    DeleteProcess: 'DeleteProcess',
    DeleteReportNodes: 'DeleteReportNodes',
    DeleteSite: 'DeleteSite',
    DeleteSiteFlexMetric: 'DeleteSiteFlexMetric',
    DeleteSystem: 'DeleteSystem',
    DeleteSystemFavorite: 'DeleteSystemFavorite',
    DeleteSystemGroup: 'DeleteSystemGroup',
    DeleteTag: 'DeleteTag',
    DeleteTagMapping: 'DeleteTagMapping',
    DeleteTrend: 'DeleteTrend',
    DeleteUnit: 'DeleteUnit',
    DeleteUserFromSystem: 'DeleteUserFromSystem',
    InitSsoUser: 'InitSsoUser',
    MigrateSiteDataToTimeSeries: 'MigrateSiteDataToTimeSeries',
    RecalculateMetric: 'RecalculateMetric',
    RemoveUserFromSystemGroup: 'RemoveUserFromSystemGroup',
    ReplayWaterlyConnectSubmission: 'ReplayWaterlyConnectSubmission',
    ArchiveReportingReportGroup: 'ArchiveReportingReportGroup',
    CreateReportingReportGroup: 'CreateReportingReportGroup',
    DeleteReportDefinition: 'DeleteReportDefinition',
    UpdateMetricForReport: 'UpdateMetricForReport',
    UpdateProcessForReport: 'UpdateProcessForReport',
    UpdateReportDefinition: 'UpdateReportDefinition',
    UpdateReportingReportDefinitionGroups: 'UpdateReportingReportDefinitionGroups',
    UpdateReportingReportGroup: 'UpdateReportingReportGroup',
    RequestEnterpriseReportShareLinkAccess: 'RequestEnterpriseReportShareLinkAccess',
    RestoreComponent: 'RestoreComponent',
    RestoreConstantDefinition: 'RestoreConstantDefinition',
    RestoreConstantValue: 'RestoreConstantValue',
    RestoreFolder: 'RestoreFolder',
    RestoreMetric: 'RestoreMetric',
    RestoreProcess: 'RestoreProcess',
    RestoreSite: 'RestoreSite',
    RestoreSiteFlexMetric: 'RestoreSiteFlexMetric',
    RestoreWeatherDataStation: 'RestoreWeatherDataStation',
    RevokeApiToken: 'RevokeApiToken',
    SendEmailVerification: 'SendEmailVerification',
    SendManualReportEmail: 'SendManualReportEmail',
    SetRuntimeLoggerOverride: 'SetRuntimeLoggerOverride',
    SnoozeAllOrgRetentionRisks: 'SnoozeAllOrgRetentionRisks',
    SnoozeRetentionRisk: 'SnoozeRetentionRisk',
    StartMirroring: 'StartMirroring',
    StopMirroring: 'StopMirroring',
    SubmitConstantRecalculation: 'SubmitConstantRecalculation',
    SubmitSiteRecalculation: 'SubmitSiteRecalculation',
    TransferComponent: 'TransferComponent',
    TransferMetric: 'TransferMetric',
    TransferMetricToFolder: 'TransferMetricToFolder',
    TransferSystem: 'TransferSystem',
    TriggerAnalyticsReportSnapshot: 'TriggerAnalyticsReportSnapshot',
    TriggerMetricRangeEmails: 'TriggerMetricRangeEmails',
    UpdateActivitySchedule: 'UpdateActivitySchedule',
    UpdateAddress: 'UpdateAddress',
    UpdateAnalyteGroup: 'UpdateAnalyteGroup',
    UpdateCalcClusterDebug: 'UpdateCalcClusterDebug',
    UpdateColumnGroup: 'UpdateColumnGroup',
    UpdateColumnGroupItem: 'UpdateColumnGroupItem',
    UpdateComponents: 'UpdateComponents',
    UpdateConstantDefinition: 'UpdateConstantDefinition',
    UpdateDataEntryMetrics: 'UpdateDataEntryMetrics',
    UpdateEdgeDevice: 'UpdateEdgeDevice',
    UpdateEnterpriseReportShareLink: 'UpdateEnterpriseReportShareLink',
    UpdateFolder: 'UpdateFolder',
    UpdateFolders: 'UpdateFolders',
    UpdateLicense: 'UpdateLicense',
    UpdateLogBookEntry: 'UpdateLogBookEntry',
    UpdateLogBookEntryDashboardView: 'UpdateLogBookEntryDashboardView',
    UpdateMetric: 'UpdateMetric',
    UpdateMetricKeyname: 'UpdateMetricKeyname',
    UpdateMetrics: 'UpdateMetrics',
    UpdateNotification: 'UpdateNotification',
    UpdateOrganization: 'UpdateOrganization',
    UpdateOrganizationIntegration: 'UpdateOrganizationIntegration',
    UpdatePhoneNumber: 'UpdatePhoneNumber',
    UpdatePhrase: 'UpdatePhrase',
    UpdateProcesses: 'UpdateProcesses',
    UpdateReportDistributionList: 'UpdateReportDistributionList',
    UpdateReportNodes: 'UpdateReportNodes',
    UpdateSampleCollection: 'UpdateSampleCollection',
    UpdateSampleSchedule: 'UpdateSampleSchedule',
    UpdateSampleSite: 'UpdateSampleSite',
    UpdateScheduledItem: 'UpdateScheduledItem',
    UpdateScheduledItemComment: 'UpdateScheduledItemComment',
    UpdateSite: 'UpdateSite',
    UpdateSiteFlexMetric: 'UpdateSiteFlexMetric',
    UpdateSiteFlexMetrics: 'UpdateSiteFlexMetrics',
    UpdateSiteStructure: 'UpdateSiteStructure',
    UpdateSites: 'UpdateSites',
    UpdateSystem: 'UpdateSystem',
    UpdateSystemGroup: 'UpdateSystemGroup',
    UpdateTag: 'UpdateTag',
    UpdateTrend: 'UpdateTrend',
    UpdateUnit: 'UpdateUnit',
    UpdateUpload: 'UpdateUpload',
    UpdateUser: 'UpdateUser',
    UpdateUserByToken: 'UpdateUserByToken',
    UpdateUserRoleForSystem: 'UpdateUserRoleForSystem',
    UpdateUserRoleForSystemGroup: 'UpdateUserRoleForSystemGroup',
    UpdateWeatherDataStation: 'UpdateWeatherDataStation',
    UpdatedRetentionRiskForOrgs: 'UpdatedRetentionRiskForOrgs',
    UpsertConstantValue: 'UpsertConstantValue',
    UpsertDataEntryCompletion: 'UpsertDataEntryCompletion',
    UpsertMetricRanges: 'UpsertMetricRanges',
    ValidateLabImportBatch: 'ValidateLabImportBatch',
    ValidateLabImportProfile: 'ValidateLabImportProfile'
  },
  Subscription: {
    OnAuditEventPublished: 'OnAuditEventPublished',
    OnCalcQueueJobsPublished: 'OnCalcQueueJobsPublished',
    OnCalcQueueStatsPublished: 'OnCalcQueueStatsPublished',
    OnDataEntryCompletionPublished: 'OnDataEntryCompletionPublished',
    OnLogBookEntryPublished: 'OnLogBookEntryPublished',
    OnNotificationPublished: 'OnNotificationPublished',
    OnScheduledItemPublished: 'OnScheduledItemPublished',
    OnSiteDataEntryChanged: 'OnSiteDataEntryChanged'
  },
  Fragment: {
    CalcClusterDebugLog: 'CalcClusterDebugLog',
    DataEntryCompletion: 'DataEntryCompletion',
    FolderWithMetricIdsAndOrder: 'FolderWithMetricIdsAndOrder',
    SiteFlexMetricWithParentSite: 'SiteFlexMetricWithParentSite',
    ActivitySchedule: 'ActivitySchedule',
    Address: 'Address',
    Analyte: 'Analyte',
    AnalyteGroup: 'AnalyteGroup',
    ApiToken: 'ApiToken',
    AuditEvent: 'AuditEvent',
    AuditEventNest: 'AuditEventNest',
    BaseFolder: 'BaseFolder',
    BulkMetricEditorRow: 'BulkMetricEditorRow',
    CalcClusterDebug: 'CalcClusterDebug',
    ColumnGroup: 'ColumnGroup',
    ColumnGroupItem: 'ColumnGroupItem',
    Component: 'Component',
    ComponentNest: 'ComponentNest',
    ConstantDefinition: 'ConstantDefinition',
    ConstantValue: 'ConstantValue',
    EdgeDevice: 'EdgeDevice',
    EdgeDeviceSubmission: 'EdgeDeviceSubmission',
    EdgeDeviceSubmissionSummary: 'EdgeDeviceSubmissionSummary',
    EdgeDeviceV2: 'EdgeDeviceV2',
    EntryTsDataPoint: 'EntryTsDataPoint',
    ExternalFacility: 'ExternalFacility',
    ExternalSystem: 'ExternalSystem',
    Interval: 'Interval',
    IntervalNest: 'IntervalNest',
    LabImportBatch: 'LabImportBatch',
    LabImportPendingProfile: 'LabImportPendingProfile',
    LabImportProfile: 'LabImportProfile',
    LabImportProfileDefinition: 'LabImportProfileDefinition',
    LabImportRow: 'LabImportRow',
    License: 'License',
    LogBookEntry: 'LogBookEntry',
    LogBookEntryDashboardView: 'LogBookEntryDashboardView',
    LogBookEntryListItem: 'LogBookEntryListItem',
    Metric: 'Metric',
    MetricContext: 'MetricContext',
    MetricDataPointDetails: 'MetricDataPointDetails',
    MetricOrderWithMetricId: 'MetricOrderWithMetricId',
    MetricKeyname: 'MetricKeyname',
    MetricNest: 'MetricNest',
    MetricRange: 'MetricRange',
    MetricWithCalculatedMetric: 'MetricWithCalculatedMetric',
    Notification: 'Notification',
    Organization: 'Organization',
    OrganizationNest: 'OrganizationNest',
    Permit: 'Permit',
    PhoneNumber: 'PhoneNumber',
    Phrase: 'Phrase',
    Process: 'Process',
    ProcessNest: 'ProcessNest',
    QueueStats: 'QueueStats',
    ReportDefinition: 'ReportDefinition',
    ReportDefinitionNest: 'ReportDefinitionNest',
    ReportDefinitionSite: 'ReportDefinitionSite',
    ReportDistributionList: 'ReportDistributionList',
    ReportMetric: 'ReportMetric',
    ReportNest: 'ReportNest',
    ReportNode: 'ReportNode',
    ReportSnapshot: 'ReportSnapshot',
    RetentionRiskNest: 'RetentionRiskNest',
    SampleCollection: 'SampleCollection',
    SampleCollectionCustody: 'SampleCollectionCustody',
    SampleCollectionResult: 'SampleCollectionResult',
    SampleSchedule: 'SampleSchedule',
    SampleSite: 'SampleSite',
    ScheduledItem: 'ScheduledItem',
    ScheduledItemComment: 'ScheduledItemComment',
    ScheduledItemsUploads: 'ScheduledItemsUploads',
    SiteFlexMetric: 'SiteFlexMetric',
    SiteNest: 'SiteNest',
    SSOConfiguration: 'SSOConfiguration',
    SuccessResponse: 'SuccessResponse',
    System: 'System',
    SystemGroup: 'SystemGroup',
    SystemGroupUser: 'SystemGroupUser',
    SystemGroupWithUsers: 'SystemGroupWithUsers',
    SystemNest: 'SystemNest',
    Tag: 'Tag',
    TagMapping: 'TagMapping',
    Trend: 'Trend',
    TsDataPoint: 'TsDataPoint',
    Unit: 'Unit',
    UnitNest: 'UnitNest',
    Uploads: 'Uploads',
    User: 'User',
    UserManagerUserFields: 'UserManagerUserFields',
    UserNest: 'UserNest',
    UserOrganizationPermission: 'UserOrganizationPermission',
    UserOrganizationPermissionNest: 'UserOrganizationPermissionNest',
    UserSystemGroupPermission: 'UserSystemGroupPermission',
    UserSystemGroupPermissionNest: 'UserSystemGroupPermissionNest',
    UserSystemPermission: 'UserSystemPermission',
    UserSystemPermissionNest: 'UserSystemPermissionNest',
    WeatherDataStationFields: 'WeatherDataStationFields',
    Site: 'Site'
  }
}